// ── app-core.js ──
/** Syrus Sales OS – Core Module (utilities, modal, notifications, ops widget) */
const SyrusApp = {
    // ── WhatsApp Notifications ──────────────────────────────────────────────
    _notifPollTimer: null,
    _notifLastCheck: null,
    _notifPrevTotal: 0,
    _notifShown: new Set(),  // track shown notification wa_ids to avoid duplicates

    initNotifications() {
        // Start polling every 5 seconds
        this._notifLastCheck = new Date().toISOString();
        this._pollUnread();
        this._notifPollTimer = setInterval(() => this._pollUnread(), 5000);
    },

    async _pollUnread() {
        try {
            const data = await this.api('/whatsapp/api/unread');
            const total = data.total_unread || 0;

            // Il badge della campanella è del centro notifiche (app-notifications.js);
            // qui restano toast/suono/blink per i WhatsApp non letti.

            // Check for NEW unread messages (total increased)
            if (total > this._notifPrevTotal && this._notifPrevTotal >= 0) {
                // Find the newest conversation that we haven't notified about
                for (const conv of data.conversations) {
                    const key = conv.wa_id + '_' + conv.last_message_at;
                    if (!this._notifShown.has(key)) {
                        this._notifShown.add(key);
                        this._showWaNotification(conv);
                        this._playNotifSound();
                        break;  // one notification at a time
                    }
                }
            }

            this._notifPrevTotal = total;

            // Update WA sidebar icon blink + counter numerico
            this._updateWaSidebarBlink(total > 0);
            const waBadge = document.getElementById('wa-sidebar-count');
            if (waBadge) {
                if (total > 0) {
                    waBadge.textContent = total > 99 ? '99+' : total;
                    waBadge.style.display = 'inline-block';
                } else {
                    waBadge.style.display = 'none';
                }
            }

        } catch(e) {
            // silent fail on poll
        }
    },

    _updateNotifBadge(count) {
        // Campanella in topbar + voce Notifiche in sidebar
        for (const [id, display] of [['notif-count', 'block'], ['notif-sidebar-count', 'inline-block']]) {
            const badge = document.getElementById(id);
            if (!badge) continue;
            if (count > 0) {
                badge.textContent = count > 99 ? '99+' : count;
                badge.style.display = display;
            } else {
                badge.style.display = 'none';
            }
        }
    },

    _updateWaSidebarBlink(hasUnread) {
        // Add/remove blink class on WhatsApp sidebar link
        const waLinks = document.querySelectorAll('a[href="/whatsapp/"],.mobile-nav-item[href="/whatsapp/"]');
        waLinks.forEach(link => {
            if (hasUnread) {
                link.classList.add('wa-has-unread');
            } else {
                link.classList.remove('wa-has-unread');
            }
        });
    },

    _showWaNotification(conv) {
        // Create slide-in notification card on the left
        let container = document.getElementById('wa-notif-container');
        if (!container) {
            container = document.createElement('div');
            container.id = 'wa-notif-container';
            container.style.cssText = 'position:fixed;top:80px;left:260px;z-index:1100;display:flex;flex-direction:column;gap:8px;max-width:360px;';
            document.body.appendChild(container);
        }

        const card = document.createElement('div');
        card.className = 'wa-notification-card';
        card.style.cssText = `
            background:#fff;border:1px solid #25D366;border-left:4px solid #25D366;
            border-radius:12px;padding:14px 16px;box-shadow:0 8px 24px rgba(0,0,0,0.15);
            cursor:pointer;display:flex;align-items:flex-start;gap:12px;
            animation:waNotifSlideIn 0.3s ease-out;min-width:300px;
        `;

        card.innerHTML = `
            <div style="width:40px;height:40px;min-width:40px;background:#25D366;border-radius:50%;display:flex;align-items:center;justify-content:center">
                <i class="fa-brands fa-whatsapp text-white"></i>
            </div>
            <div style="flex:1;overflow:hidden">
                <div style="font-weight:700;font-size:14px;color:#1e293b;margin-bottom:2px">${this._escapeHtml(conv.contact_name || '')}</div>
                <div style="font-size:13px;color:#475569;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${this._escapeHtml(conv.preview || 'Nuovo messaggio')}</div>
                <div style="font-size:11px;color:#94a3b8;margin-top:4px">${this.formatDate(conv.last_message_at)}</div>
            </div>
            <button onclick="event.stopPropagation();this.closest('.wa-notification-card').remove()" style="background:none;border:none;color:#94a3b8;font-size:18px;padding:0;line-height:1;cursor:pointer">&times;</button>
        `;

        card.addEventListener('click', () => {
            card.remove();
            SyrusApp._goToWaChat(conv.phone_number_id, conv.wa_id);
        });

        container.appendChild(card);

        // Auto-dismiss after 8 seconds
        setTimeout(() => {
            if (card.parentNode) {
                card.style.animation = 'waNotifSlideOut 0.3s ease-in forwards';
                setTimeout(() => card.remove(), 300);
            }
        }, 8000);

        // Also request browser notification permission
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }
        // Send browser notification too
        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification(`WhatsApp: ${this._escapeHtml(conv.contact_name || '')}`, {
                body: this._escapeHtml(conv.preview || 'Nuovo messaggio'),
                icon: 'https://syrusindustry.com/wp-content/themes/syrus-child/assets/images/logo-syrus-industry.png',
                tag: 'wa-' + conv.wa_id,
            });
        }
    },

    _audioCtx: null,
    _audioUnlocked: false,

    _unlockAudio() {
        if (this._audioUnlocked) return;
        try {
            this._audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            this._audioUnlocked = true;
            document.removeEventListener('click', SyrusApp._unlockAudioHandler);
            document.removeEventListener('keydown', SyrusApp._unlockAudioHandler);
            document.removeEventListener('touchstart', SyrusApp._unlockAudioHandler);
        } catch(e) {}
    },

    _playNotifSound() {
        // Web Audio API (only works after user has clicked/typed)
        if (this._audioUnlocked && this._audioCtx) {
            try {
                const ctx = this._audioCtx;
                if (ctx.state === 'suspended') ctx.resume();
                const playTone = (freq, start, duration) => {
                    const osc = ctx.createOscillator();
                    const gain = ctx.createGain();
                    osc.connect(gain);
                    gain.connect(ctx.destination);
                    osc.frequency.value = freq;
                    osc.type = 'sine';
                    gain.gain.setValueAtTime(0.5, ctx.currentTime + start);
                    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + start + duration);
                    osc.start(ctx.currentTime + start);
                    osc.stop(ctx.currentTime + start + duration);
                };
                playTone(784, 0, 0.12);
                playTone(988, 0.14, 0.12);
                playTone(1175, 0.28, 0.2);
                return;
            } catch(e) {}
        }

        // Fallback: HTML Audio element
        try {
            if (!this._notifAudio) {
                this._notifAudio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdX2LkZeWk42Gf3d0eICMmqGhnpeLgHZrcHqGkpqcmpWOh4B5dHiBi5OYl5SSjIZ/eXh7gYiOkpOSkY2Ign58fH+EiYyOjo2LiIWCgH9/gYSHiYqKiomHhoSCgYCAgoSFh4iIiIeGhYSCgYGBgoOEhYaGhoaFhISDgoGBgYKDhIWFhYWEhIOCgoGBgoKDhIWFhYSEg4OCgoKCgoODhISEhISEg4OCgoKCgoODhISEhIODg4OCgoKCgoODg4ODg4ODg4OCgoKCgoKDg4ODg4ODg4OCgoKCgoKCg4ODg4ODg4OCgoKCgoKCgoODg4ODg4OCgoKC');
            }
            this._notifAudio.currentTime = 0;
            this._notifAudio.volume = 0.7;
            this._notifAudio.play().catch(() => {});
        } catch(e) {}
    },

    // ── Utilities ───────────────────────────────────────────────────────────
    _csrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.content || '';
    },

    /** Refresh CSRF token from a 400 response body (if csrf_error). Returns true if refreshed. */
    _refreshCsrfFromError(body) {
        if (body && body.csrf_error && body.csrf_token) {
            const meta = document.querySelector('meta[name="csrf-token"]');
            if (meta) { meta.content = body.csrf_token; return true; }
        }
        return false;
    },

    /**
     * fetch() wrapper with automatic CSRF retry.
     * Use for FormData uploads and other non-JSON calls that bypass api().
     * Injects X-CSRFToken header automatically. On CSRF 400, retries once with a fresh token.
     */
    async fetchWithCsrf(url, options = {}) {
        if (!options.headers) options.headers = {};
        options.headers['X-CSRFToken'] = this._csrfToken();
        let resp = await fetch(url, options);
        if (resp.status === 400) {
            const body = await resp.clone().json().catch(() => null);
            if (this._refreshCsrfFromError(body)) {
                options.headers['X-CSRFToken'] = this._csrfToken();
                resp = await fetch(url, options);
            }
        }
        return resp;
    },

    async api(url, options = {}) {
        const csrfHeaders = { 'Content-Type': 'application/json', 'X-CSRFToken': this._csrfToken() };
        const mergedHeaders = { ...csrfHeaders, ...(options.headers || {}) };
        const resp = await fetch(url, { ...options, headers: mergedHeaders });
        if (!resp.ok) {
            const err = await resp.json().catch(() => ({ error: resp.statusText }));
            // Auto-retry once on CSRF token error: refresh token and replay request
            if (resp.status === 400 && err.csrf_error && !options._csrfRetried) {
                const meta = document.querySelector('meta[name="csrf-token"]');
                if (meta && err.csrf_token) {
                    meta.content = err.csrf_token;
                    return this.api(url, { ...options, _csrfRetried: true });
                }
            }
            throw new Error(err.error || resp.statusText);
        }
        return resp.json();
    },

    debounce(fn, ms) {
        let timer;
        return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), ms); };
    },

    toast(msg, type = 'success') {
        const container = document.getElementById('toast-container');
        const toast = document.createElement('div');
        toast.className = `toast show align-items-center text-bg-${type} border-0`;
        toast.innerHTML = `<div class="d-flex"><div class="toast-body">${this._escapeHtml(msg || '')}</div><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button></div>`;
        container.appendChild(toast);
        setTimeout(() => toast.remove(), 4000);
    },

    // ── SLA Violation Banner ─────────────────────────────────────────────
    _slaBannerTimer: null,

    initSlaBanner() {
        this._pollSlaBanner();
        this._slaBannerTimer = setInterval(() => this._pollSlaBanner(), 60000);
    },

    async _pollSlaBanner() {
        const banner = document.getElementById('sla-violation-banner');
        if (!banner) return;
        try {
            const data = await this.api('/leads/api/sla/banner');
            if (data.count > 0) {
                document.getElementById('sla-banner-text').textContent =
                    `Hai ${data.count} lead in violazione SLA — la più urgente: ${data.crm_id} ${data.company_name || ''}`;
                const link = document.getElementById('sla-banner-link');
                link.href = `/leads/${data.lead_id}`;
                link.onclick = (e) => { e.preventDefault(); this.spaNavigate(`/leads/${data.lead_id}`); };
                banner.style.display = 'block';
            } else {
                banner.style.display = 'none';
            }
        } catch (e) {
            banner.style.display = 'none';
        }
    },

    statusBadge(status) {
        return `<span class="badge badge-status-${status}">${this._statusLabels[status] || status}</span>`;
    },

    priorityBadge(p) {
        if (!p) return '<span class="text-muted">–</span>';
        const icons = { hot:'fa-fire', warm:'fa-sun', cold:'fa-snowflake' };
        const icon = icons[p] ? `<i class="fa-solid ${icons[p]}"></i>` : '';
        return `<span class="badge badge-priority-${p}">${icon} ${p.toUpperCase()}</span>`;
    },

    // Il backend salva in UTC senza suffisso Z: forza interpretazione UTC
    // così il browser converte automaticamente al fuso orario locale.
    // Usare SEMPRE questo al posto di new Date(iso) sui timestamp del backend.
    parseDate(iso) {
        let s = String(iso);
        if (s.includes('T') && !s.endsWith('Z') && !s.includes('+') && !s.includes('-', 19)) {
            s += 'Z';
        }
        return new Date(s);
    },

    formatDate(iso) {
        if (!iso) return '-';
        return this.parseDate(iso).toLocaleDateString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
    },

    formatCurrency(n) {
        return new Intl.NumberFormat('it-IT', { style:'currency', currency:'EUR' }).format(n || 0);
    },

    _statusLabels: {
        new: 'Nuovo', contacted: 'Contattato', qualified: 'Qualificato',
        proposal_sent: 'Preventivo Inviato', negotiation: 'In Trattativa',
        won: 'Vinto', lost: 'Perso', dormant: 'Dormiente', spam: 'Spam',
    },

    // ── Sidebar Toggle ──────────────────────────────────────────────────────
    initSidebar() {
        const toggle = document.getElementById('sidebar-toggle');
        if (toggle) {
            toggle.addEventListener('click', () => {
                document.getElementById('sidebar').classList.toggle('show');
            });
        }
    },

    // ── Escape Helpers ──────────────────────────────────────────────────────
    _escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    },

    _escapeAttr(val) {
        return String(val || '').replace(/&/g,'&amp;').replace(/'/g,'&#39;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    },

    /** Stellina a quattro punte stile Gemini: marca le azioni generate dall'AI.
     *  Gemella JS del partial `partials/_ai_sparkle.svg` (stessa forma, stesso
     *  gradiente) per le liste renderizzate lato client. Il gradiente porta un
     *  id univoco: più stelline nella stessa pagina non si rubano il fill. */
    _aiSparkleSvg(size) {
        const px = size || 14;
        const gid = 'aiSparkleGrad' + (this._aiSparkleSeq = (this._aiSparkleSeq || 0) + 1);
        return `<svg viewBox="0 0 24 24" width="${px}" height="${px}" aria-hidden="true" focusable="false">
            <defs><linearGradient id="${gid}" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stop-color="#4285F4"/><stop offset="45%" stop-color="#9B72CB"/><stop offset="100%" stop-color="#D96570"/>
            </linearGradient></defs>
            <path fill="url(#${gid})" d="M12 1.5c.28 0 .52.19.6.46l1.24 4.24a5.6 5.6 0 0 0 3.96 3.96l4.24 1.24c.27.08.46.32.46.6s-.19.52-.46.6l-4.24 1.24a5.6 5.6 0 0 0-3.96 3.96l-1.24 4.24a.63.63 0 0 1-1.2 0l-1.24-4.24a5.6 5.6 0 0 0-3.96-3.96L1.96 12.6a.63.63 0 0 1 0-1.2l4.24-1.24a5.6 5.6 0 0 0 3.96-3.96l1.24-4.24c.08-.27.32-.46.6-.46Z"/>
        </svg>`;
    },

    // ── Unified Operations Center Widget ─────────────────────────────────────
    // All async operations (uploads, transcriptions, document generation, etc.)
    // are tracked in this single widget.
    _operations: [],
    _opsPollingInterval: null,
    _uploadCounter: 0,

    toggleOpsWidget() {
        const body = document.getElementById('ops-widget-body');
        const chevron = document.getElementById('ops-chevron');
        if (body.style.display === 'none') {
            body.style.display = 'block';
            chevron.className = 'fa-solid fa-chevron-down';
        } else {
            body.style.display = 'none';
            chevron.className = 'fa-solid fa-chevron-up';
        }
    },

    trackOperation(id, type, label, pollUrl, navigateTo) {
        const op = { id, type, label, pollUrl, navigateTo, status: 'running', startedAt: Date.now() };
        this._operations.push(op);
        this._showOpsWidget();
        this._renderOps();
        this._startOpsPolling();
    },

    /** Add an upload operation with progress tracking (no polling, manual updates). */
    trackUpload(id, label) {
        const op = { id, type: 'upload', label, status: 'uploading', progress: 0, detail: '', startedAt: Date.now() };
        this._operations.push(op);
        this._showOpsWidget();
        this._renderOps();
        return op;
    },

    /** Update progress of an upload operation. */
    updateOpProgress(id, progress, detail) {
        const op = this._operations.find(o => o.id === id);
        if (op) {
            op.progress = progress;
            if (detail) op.detail = detail;
            this._renderOps();
        }
    },

    /** Mark an operation as completed or failed. */
    completeOp(id, success, detail) {
        const op = this._operations.find(o => o.id === id);
        if (op) {
            op.status = success ? 'completed' : 'failed';
            if (detail) op.detail = detail;
            this._renderOps();
            // Auto-remove after 15s
            setTimeout(() => {
                this._operations = this._operations.filter(o => o.id !== id);
                this._renderOps();
                if (this._operations.length === 0) {
                    const w = document.getElementById('ops-widget');
                    if (w) w.style.display = 'none';
                }
            }, 15000);
        }
    },

    _showOpsWidget() {
        const w = document.getElementById('ops-widget');
        if (w) w.style.display = 'block';
        const body = document.getElementById('ops-widget-body');
        if (body) body.style.display = 'block';
    },

    _renderOps() {
        const list = document.getElementById('ops-list');
        const empty = document.getElementById('ops-empty');
        const badge = document.getElementById('ops-badge');
        if (!list) return;

        const active = this._operations.filter(o => o.status === 'running' || o.status === 'uploading');
        if (badge) {
            badge.textContent = active.length;
            badge.style.display = active.length > 0 ? 'inline' : 'none';
        }
        if (this._operations.length === 0) {
            list.innerHTML = '';
            if (empty) empty.style.display = 'block';
            return;
        }
        if (empty) empty.style.display = 'none';

        const typeIcons = {
            upload: 'fa-cloud-arrow-up text-primary',
            transcription: 'fa-microphone-lines text-info',
            document: 'fa-file-lines text-primary',
            scoring: 'fa-brain text-warning',
            presentation: 'fa-presentation-screen text-success',
            summary: 'fa-clipboard-list text-info',
        };
        list.innerHTML = this._operations.map(op => {
            const icon = typeIcons[op.type] || 'fa-gears text-secondary';
            const isRunning = op.status === 'running' || op.status === 'uploading';
            const isFailed = op.status === 'failed';
            const statusBadge = isRunning
                ? '<span class="spinner-border spinner-border-sm text-primary"></span>'
                : isFailed
                    ? '<i class="fa-solid fa-circle-xmark text-danger"></i>'
                    : '<i class="fa-solid fa-circle-check text-success"></i>';
            const clickAttr = (!isRunning && op.navigateTo)
                ? `onclick="SyrusApp.spaNavigate('${op.navigateTo}')" style="cursor:pointer"`
                : '';

            // Progress bar for uploads
            const progressBar = op.status === 'uploading'
                ? `<div class="progress mt-1" style="height:4px"><div class="progress-bar progress-bar-animated" style="width:${op.progress || 0}%"></div></div>`
                : '';
            const detailText = op.detail ? `<br><small class="text-muted" style="font-size:10px">${this._escapeHtml(op.detail)}</small>` : '';
            const statusText = op.status === 'uploading' ? `${op.progress || 0}%` : isRunning ? 'In corso...' : isFailed ? 'Fallito' : 'Completato';

            // Multi-line progress display for document/scoring pipelines
            let linesHtml = '';
            if (op.progressLines && op.progressLines.length > 0) {
                linesHtml = '<div class="mt-1" style="font-size:11px;line-height:1.5">' +
                    op.progressLines.map(l => {
                        const lineIcon = l.status === 'running'
                            ? '<span class="spinner-border spinner-border-sm" style="width:10px;height:10px;border-width:1.5px"></span> '
                            : '';
                        const cls = l.status === 'error' ? 'text-danger' : l.status === 'running' ? 'text-primary' : 'text-muted';
                        return `<div class="${cls}">${lineIcon}${this._escapeHtml(l.message)}</div>`;
                    }).join('') +
                    '</div>';
            }

            return `<div class="list-group-item d-flex align-items-start gap-2 py-2" ${clickAttr}>
                <i class="fa-solid ${icon} mt-1"></i>
                <div class="flex-grow-1">
                    <div class="small fw-medium">${this._escapeHtml(op.label)}</div>
                    <small class="text-muted">${statusText}</small>${detailText}
                    ${linesHtml}
                    ${progressBar}
                </div>
                ${statusBadge}
            </div>`;
        }).join('');
    },

    _startOpsPolling() {
        if (this._opsPollingInterval) return;
        this._opsPollingInterval = setInterval(() => this._pollOps(), 3000);
    },

    async _pollOps() {
        const running = this._operations.filter(o => o.status === 'running');
        if (running.length === 0) {
            clearInterval(this._opsPollingInterval);
            this._opsPollingInterval = null;
            // Check if there are also no uploading ops before hiding
            setTimeout(() => {
                const anyActive = this._operations.some(o => o.status === 'running' || o.status === 'uploading');
                if (!anyActive) {
                    this._operations = this._operations.filter(o => o.status === 'running' || o.status === 'uploading');
                    this._renderOps();
                    if (this._operations.length === 0) {
                        const w = document.getElementById('ops-widget');
                        if (w) w.style.display = 'none';
                    }
                }
            }, 10000);
            return;
        }
        for (const op of running) {
            try {
                const data = await this.api(op.pollUrl);
                if (data.status === 'completed') {
                    op.status = 'completed';
                    this.toast(`${op.label}: completato`, 'success');
                } else if (data.status === 'failed') {
                    op.status = 'failed';
                    this.toast(`${op.label}: fallito`, 'danger');
                }
            } catch (e) { /* keep polling */ }
        }
        this._renderOps();
    },

    CHUNK_SIZE: 5 * 1024 * 1024, // 5MB per chunk

    // ── Modal Utility ───────────────────────────────────────────────────────
    _showModal(title, bodyHtml, dialogClass) {
        let modal = document.getElementById('syrus-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'syrus-modal';
            modal.className = 'modal fade';
            modal.innerHTML = `<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h5 class="modal-title"></h5><button type="button" class="btn-close" data-bs-dismiss="modal"></button></div><div class="modal-body"></div></div></div>`;
            document.body.appendChild(modal);
            // Clean up backdrop + body state on every hide
            modal.addEventListener('hidden.bs.modal', () => {
                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('padding-right');
            });
        }
        const dlg = modal.querySelector('.modal-dialog');
        dlg.className = 'modal-dialog ' + (dialogClass || 'modal-lg');
        modal.querySelector('.modal-title').innerHTML = title;
        modal.querySelector('.modal-body').innerHTML = bodyHtml;

        // If modal is already visible, just update content (no new show/backdrop)
        const instance = bootstrap.Modal.getInstance(modal);
        if (instance && modal.classList.contains('show')) {
            return; // content already updated above
        }
        // Create instance only once, then show
        (instance || new bootstrap.Modal(modal)).show();
    },

    _closeAllModals() {
        // Close all open modals and clean up backdrops
        document.querySelectorAll('.modal.show').forEach(modalEl => {
            const instance = bootstrap.Modal.getInstance(modalEl);
            if (instance) instance.hide();
        });
        // Force-remove any lingering backdrops after a short delay
        setTimeout(() => {
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
        }, 300);
    },

    // ── Notifications ───────────────────────────────────────────────────────
    showNotifications() { this.toast('Notifiche in arrivo...', 'info'); },
    showProfile() { location.href = '/settings'; },

    /**
     * Popover al passaggio del mouse su ogni stellina AI, per dire cosa fa quel
     * pulsante prima di premerlo: le azioni AI costano e alcune sovrascrivono
     * quello che c'e' gia', quindi non devono essere una sorpresa.
     *
     * L'aggancio e' delegato sul documento invece che un ciclo all'avvio: meta'
     * delle stelline nascono da JS (registrazioni, telefonate, liste ricaricate
     * in polling) e un ciclo one-shot le mancherebbe. Il popover si costruisce
     * al primo passaggio e da li' in poi lo gestisce Bootstrap.
     */
    initAiSparklePopovers() {
        if (this._aiSparklePopoverReady) return;
        this._aiSparklePopoverReady = true;
        document.addEventListener('mouseover', (e) => {
            if (!window.bootstrap || !bootstrap.Popover) return;
            const btn = e.target.closest ? e.target.closest('.btn-ai-sparkle[data-ai-hint]') : null;
            if (!btn || btn._aiPopover) return;
            btn._aiPopover = new bootstrap.Popover(btn, {
                title: btn.dataset.aiHintTitle || 'Azione AI',
                content: btn.dataset.aiHint,
                trigger: 'hover focus',
                placement: 'bottom',
                container: 'body',
                customClass: 'ai-sparkle-popover',
            });
            btn._aiPopover.show();
        });
    },
};

document.addEventListener('DOMContentLoaded', () => SyrusApp.initAiSparklePopovers());


// ── app-leads.js ──
/** Syrus Sales OS – Leads Module */
Object.assign(SyrusApp, {

    // ── Dashboard ───────────────────────────────────────────────────────────
    async loadDashboard() {
        try {
            const data = await this.api('/api/dashboard/data');
            document.getElementById('kpi-leads').textContent = data.kpis.leads_month;
            document.getElementById('kpi-won').textContent = data.kpis.won_month;
            document.getElementById('kpi-pipeline').textContent = this.formatCurrency(data.kpis.pipeline_value);
            document.getElementById('kpi-rate').textContent = data.kpis.conversion_rate + '%';

            // Dynamic trends
            const trends = data.kpis.trends || {};
            const renderTrend = (elId, val, suffix) => {
                const el = document.getElementById(elId);
                if (!el) return;
                if (val === null || val === undefined) {
                    el.innerHTML = '<span class="text-muted">N/D</span>';
                } else {
                    const up = val >= 0;
                    el.className = 'stat-trend ' + (up ? 'trend-up' : 'trend-down');
                    el.innerHTML = `<i class="fa-solid fa-arrow-${up ? 'up' : 'down'}"></i> ${up ? '+' : ''}${val}% ${suffix}`;
                }
            };
            renderTrend('kpi-trend-leads', trends.leads, 'vs mese scorso');
            renderTrend('kpi-trend-won', trends.won, 'vs mese scorso');
            renderTrend('kpi-trend-pipeline', trends.pipeline, 'vs mese scorso');
            renderTrend('kpi-trend-conversion', trends.conversion, 'vs mese scorso');

            // Status chart
            const statusCtx = document.getElementById('chart-status');
            if (statusCtx) {
                const existingChart = Chart.getChart(statusCtx);
                if (existingChart) existingChart.destroy();
                new Chart(statusCtx, {
                    type: 'doughnut',
                    data: {
                        labels: Object.keys(data.status_distribution),
                        datasets: [{ data: Object.values(data.status_distribution), backgroundColor: ['#F59E0B','#3B82F6','#8B5CF6','#06B6D4','#F97316','#10B981','#EF4444','#94A3B8'] }]
                    },
                    options: { responsive: true, plugins: { legend: { position: 'bottom' } } }
                });
            }

            // Urgent leads
            const urgentList = document.getElementById('urgent-list');
            document.getElementById('urgent-count').textContent = data.urgent_leads.length;
            if (data.urgent_leads.length === 0) {
                urgentList.innerHTML = '<div class="list-group-item text-center text-success py-3"><i class="fa-solid fa-circle-check"></i> Nessun lead urgente</div>';
            } else {
                urgentList.innerHTML = data.urgent_leads.map(l => `
                    <a href="/leads/${l.id}" class="list-group-item list-group-item-action d-flex justify-content-between">
                        <div><strong>${this._escapeHtml(l.crm_id || '')}</strong> – ${this._escapeHtml(l.company_name || l.contact_name || '')}</div>
                        <small class="text-danger">${this.formatDate(l.first_contact_deadline)}</small>
                    </a>`).join('');
            }

            // Tasks today
            const tasksList = document.getElementById('tasks-list');
            if (data.tasks_today.length === 0) {
                tasksList.innerHTML = '<div class="list-group-item text-center text-muted py-3">Nessuna attività per oggi</div>';
            } else {
                tasksList.innerHTML = data.tasks_today.map(t => `
                    <a href="/leads/${t.id}" class="list-group-item list-group-item-action">
                        <div class="d-flex justify-content-between"><strong>${t.crm_id}</strong> <small>${this._escapeHtml(t.company_name || '')}</small></div>
                        <small class="text-muted">${this._escapeHtml(t.next_action || '')}</small>
                    </a>`).join('');
            }

            // Alerts
            const alertsList = document.getElementById('alerts-list');
            if (data.alerts.length === 0) {
                alertsList.innerHTML = '<div class="list-group-item text-center text-success py-3"><i class="fa-solid fa-circle-check"></i> Nessun alert</div>';
            } else {
                alertsList.innerHTML = data.alerts.map(a => `
                    <div class="list-group-item d-flex justify-content-between">
                        <div><span class="badge bg-${a.severity === 'escalated' ? 'danger' : (a.severity === 'critical' ? 'warning' : 'secondary')}">${this._escapeHtml(a.severity)}</span> ${this._escapeHtml(a.alert_type)}</div>
                        <small class="text-muted">${this.formatDate(a.created_at)}</small>
                    </div>`).join('');
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // ── Leads ───────────────────────────────────────────────────────────────
    _leadsPage: 1,

    _leadView: 'table',

    setLeadView(view) {
        this._leadView = view;
        document.getElementById('leads-view-table')?.classList.toggle('d-none', view !== 'table');
        document.getElementById('leads-view-kanban')?.classList.toggle('d-none', view !== 'kanban');
        document.getElementById('btn-view-table')?.classList.toggle('active', view === 'table');
        document.getElementById('btn-view-kanban')?.classList.toggle('active', view === 'kanban');
        if (view === 'kanban') this.loadKanban();
        else this.loadLeads();
    },

    // Viste rapide sopra la tabella: 'active' (default) nasconde perse e
    // dormienti. Lo status esplicito del dropdown ha la precedenza sulla vista.
    _leadQuickViewStatuses: {
        active: 'new,contacted,qualified,proposal_sent,negotiation',
        all: '',
        won: 'won',
        lost: 'lost',
        dormant: 'dormant',
    },

    setLeadQuickView(view) {
        this._leadsQuickView = view;
        // Vista scelta a mano: da qui in poi la ricerca la rispetta invece di
        // allargarsi a tutte le lead (vedi _getLeadFilters).
        this._leadsQuickViewExplicit = true;
        document.querySelectorAll('#leads-view-chips .lead-view-chip').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.view === view);
        });
        this.loadLeads(1);
    },

    _getLeadFilters() {
        const explicitStatus = document.getElementById('leads-status')?.value || '';
        const view = this._leadsQuickView || 'active';
        const search = (document.getElementById('leads-search')?.value || '').trim();
        // Una ricerca testuale guarda TUTTE le lead: con la vista di default
        // ("Attive") una lead persa/vinta/dormiente non sarebbe mai trovata e
        // sembrerebbe inesistente. Se invece l'utente ha scelto a mano una vista
        // o uno stato, quella scelta ha la precedenza e la ricerca resta dentro.
        this._leadsSearchWidened = !!search && !explicitStatus
            && view === 'active' && !this._leadsQuickViewExplicit;
        return {
            search,
            status: explicitStatus
                || (this._leadsSearchWidened ? '' : (this._leadQuickViewStatuses[view] || '')),
            priority: document.getElementById('leads-priority')?.value || '',
            assigned_to: document.getElementById('leads-assigned')?.value || '',
            source: document.getElementById('leads-source')?.value || '',
            sort_by: document.getElementById('leads-sort')?.value || 'created_at',
        };
    },

    clearLeadFilters() {
        ['leads-status','leads-priority','leads-assigned','leads-source','leads-search'].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = '';
        });
        this._syncPriorityButtons('');
        this.loadLeads();
    },

    togglePriorityFilter(priority) {
        const sel = document.getElementById('leads-priority');
        if (!sel) return;
        // Toggle: se già attivo, disattiva
        sel.value = sel.value === priority ? '' : priority;
        this._syncPriorityButtons(sel.value);
        this.loadLeads();
    },

    _syncPriorityButtons(active) {
        document.querySelectorAll('#priority-quick-filters button').forEach(btn => {
            const p = btn.textContent.trim().toLowerCase();
            btn.style.borderColor = p === active ? 'currentColor' : 'transparent';
            btn.style.opacity = active && p !== active ? '0.5' : '1';
        });
    },

    initLeadsPage() {
        // Binding filtri: search, status, priority, ecc. Chiamata sia da
        // DOMContentLoaded (primo caricamento) che da SPA navigation.
        const search = document.getElementById('leads-search');
        if (search && !search._bound) {
            search._bound = true;
            search.addEventListener('keyup', this.debounce(() => {
                // Una nuova digitazione riparte dalla ricerca larga: il vincolo
                // "resta nelle attive" vale solo finché non si ritocca il campo.
                this._leadsQuickViewExplicit = false;
                this.loadLeads();
            }, 300));
        }
        ['leads-status','leads-priority','leads-assigned','leads-source','leads-sort'].forEach(id => {
            const el = document.getElementById(id);
            if (el && !el._bound) {
                el._bound = true;
                el.addEventListener('change', () => {
                    if (id === 'leads-priority') this._syncPriorityButtons(el.value);
                    this.loadLeads();
                });
            }
        });
        this._loadSalespersonsFilter();
        // Riallinea le chip della vista rapida allo stato corrente (il template
        // ri-renderizzato dalla SPA marca sempre "Attive" come attiva).
        if (!this._leadsQuickView) this._leadsQuickView = 'active';
        document.querySelectorAll('#leads-view-chips .lead-view-chip').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.view === this._leadsQuickView);
        });
        this.loadLeads();
    },

    async _loadSalespersonsFilter() {
        try {
            const users = await this.api('/leads/api/salespersons');
            const sel = document.getElementById('leads-assigned');
            if (!sel) return;
            users.forEach(u => {
                const opt = document.createElement('option');
                opt.value = u.id;
                opt.textContent = u.display_name || u.email;
                sel.appendChild(opt);
            });
        } catch (e) { /* silent */ }
    },

    _lastContactBadge(isoDate, details) {
        if (!isoDate) return '<span class="last-contact-grey"><i class="fa-solid fa-minus"></i> Mai</span>';
        const d = this.parseDate(isoDate);
        const days = Math.floor((Date.now() - d.getTime()) / 86400000);
        let cls = 'last-contact-green', label = 'Oggi';
        if (days >= 7) { cls = 'last-contact-red'; label = `${days}g fa`; }
        else if (days >= 3) { cls = 'last-contact-yellow'; label = `${days}g fa`; }
        else if (days >= 1) { label = `${days}g fa`; }
        const badge = `<span class="${cls}"><i class="fa-solid fa-circle fa-xs me-1"></i>${label}</span>`;
        const content = this._lastContactPopContent(details);
        if (!content) return badge;
        const chip = this._contactChip(details);
        // Caso chiamata: niente testo, contano direzione (freccia in entrata /
        // in uscita) e giorno+ora della telefonata.
        let snippet;
        const dir = details.direction === 'inbound' ? 'in' : details.direction === 'outbound' ? 'out' : '';
        const logo = '<img class="lead-call-logo" src="/static/img/logo-mark.png" alt="Syrus">';
        const arrow = '<i class="fa-solid fa-arrow-right-long"></i>';
        if (details.channel === 'phone') {
            // Direzione come flusso "chi chiama → chi riceve": in entrata
            // telefono → logo Syrus, in uscita logo Syrus → telefono.
            // logo-mark.png = triangolo Syrus Industry ritagliato senza scritta.
            const phone = '<i class="fa-solid fa-phone"></i>';
            const callIco = dir
                ? `<span class="lead-call-flow lead-call-flow-${dir}"
                    title="${dir === 'in' ? 'Chiamata in entrata (il cliente ci ha chiamato)' : 'Chiamata in uscita (abbiamo chiamato noi)'}">
                    ${dir === 'in' ? phone + arrow + logo : logo + arrow + phone}</span>`
                : `<span class="lead-call-flow" title="Chiamata">${phone}</span>`;
            snippet = `<div class="lead-contact-snippet">${callIco}<span>${this._relativeDayTime(details.at)}</span></div>`;
        } else if (details.channel === 'whatsapp') {
            // Stesso flusso per WhatsApp (logo WA ↔ logo Syrus) + anteprima
            // del messaggio su una seconda riga.
            const wa = '<i class="fa-brands fa-whatsapp lead-wa-ico"></i>';
            const waIco = dir
                ? `<span class="lead-call-flow lead-call-flow-${dir}"
                    title="${dir === 'in' ? 'Messaggio ricevuto dal cliente' : 'Messaggio inviato da noi'}">
                    ${dir === 'in' ? wa + arrow + logo : logo + arrow + wa}</span>`
                : `<span class="lead-call-flow" title="WhatsApp">${wa}</span>`;
            const prev = details.preview
                ? `<div class="lead-contact-snippet"><span>${this._escapeHtml(details.preview)}</span></div>` : '';
            snippet = `<div class="lead-contact-snippet">${waIco}<span>${this._relativeDayTime(details.at)}</span></div>${prev}`;
        } else if (details.channel === 'email') {
            // Stesso flusso per le email (busta ↔ logo Syrus) + oggetto su
            // una seconda riga.
            const mail = '<i class="fa-solid fa-envelope lead-mail-ico"></i>';
            const mailIco = dir
                ? `<span class="lead-call-flow lead-call-flow-${dir}"
                    title="${dir === 'in' ? 'Email ricevuta dal cliente' : 'Email inviata da noi'}">
                    ${dir === 'in' ? mail + arrow + logo : logo + arrow + mail}</span>`
                : `<span class="lead-call-flow" title="Email">${mail}</span>`;
            const prev = details.preview
                ? `<div class="lead-contact-snippet"><span>${this._escapeHtml(details.preview)}</span></div>` : '';
            snippet = `<div class="lead-contact-snippet">${mailIco}<span>${this._relativeDayTime(details.at)}</span></div>${prev}`;
        } else {
            snippet = `<div class="lead-contact-snippet"><i class="${chip.icon}" style="color:${chip.color}"></i>
                <span>${this._escapeHtml(details.preview || this._contactLabel(details))}</span></div>`;
        }
        // Anteprima visibile subito sotto il badge; il click apre comunque il
        // popover completo (pin, stesso meccanismo delle icone canale).
        return `<span class="lead-contact-pop" data-pop-content="${this._escapeAttr(content)}"
            data-pop-placement="left">${badge}${snippet}</span>`;
    },

    // "oggi alle hh:mm" / "ieri alle hh:mm" / "gg/mm alle hh:mm" (giorni di
    // calendario nel fuso locale, non finestre di 24h).
    _relativeDayTime(iso) {
        if (!iso) return '';
        const d = this.parseDate(iso);
        const startOfDay = x => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
        const diffDays = Math.round((startOfDay(new Date()) - startOfDay(d)) / 86400000);
        const dayLabel = diffDays === 0 ? 'oggi' : diffDays === 1 ? 'ieri'
            : d.toLocaleDateString('it-IT', {day: '2-digit', month: '2-digit'});
        return `${dayLabel} alle ` + d.toLocaleTimeString('it-IT', {hour: '2-digit', minute: '2-digit'});
    },

    _contactChip(c) {
        const chips = {
            email:      {icon: 'fa-solid fa-envelope',    color: '#2E75B6', bg: '#EBF3FB'},
            whatsapp:   {icon: 'fa-brands fa-whatsapp',   color: '#15803D', bg: '#DCFCE7'},
            sms:        {icon: 'fa-solid fa-comment-sms', color: '#7C3AED', bg: '#F3E8FF'},
            phone:      {icon: 'fa-solid fa-phone',       color: '#B45309', bg: '#FEF3C7'},
            meeting:    {icon: 'fa-solid fa-users',       color: '#0F766E', bg: '#CCFBF1'},
            video_call: {icon: 'fa-solid fa-video',       color: '#0F766E', bg: '#CCFBF1'},
        };
        return chips[c.channel] || {icon: 'fa-solid fa-pen-to-square', color: '#475569', bg: '#F1F5F9'};
    },

    _contactLabel(c) {
        const kindLabels = {
            email:      {outbound: 'Email inviata',     inbound: 'Email ricevuta'},
            whatsapp:   {outbound: 'WhatsApp inviato',  inbound: 'WhatsApp ricevuto'},
            sms:        {outbound: 'SMS inviato',       inbound: 'SMS ricevuto'},
        };
        const channelLabels = {phone: 'Chiamata', email: 'Email', whatsapp: 'WhatsApp', sms: 'SMS',
                               meeting: 'Meeting', video_call: 'Videochiamata'};
        if (c.kind === 'activity') {
            const base = channelLabels[c.channel] || 'Attività';
            const dir = c.direction === 'inbound' ? ' in entrata' : c.direction === 'outbound' ? ' in uscita' : '';
            return base + (c.channel === 'phone' ? dir : '');
        }
        return kindLabels[c.kind]?.[c.direction || 'outbound'] || channelLabels[c.kind] || 'Contatto';
    },

    // Contenuto del popover anteprima ultimo contatto (l.last_contact dal
    // backend: kind/channel/direction/preview/by/outcome/at).
    _lastContactPopContent(c) {
        if (!c) return null;
        const chip = this._contactChip(c);
        const label = this._contactLabel(c);
        const when = c.at ? this.parseDate(c.at).toLocaleString('it-IT',
            {day: '2-digit', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit'}) : '';
        const outcomes = {reached: 'Raggiunto', not_reached: 'Non raggiunto', voicemail: 'Segreteria',
                          replied: 'Risposto', meeting_scheduled: 'Meeting fissato', refused: 'Rifiutato'};
        const meta = [when, c.by, outcomes[c.outcome]].filter(Boolean).map(x => this._escapeHtml(x)).join(' · ');
        // Email: oggetto in grassetto + estratto del body (ripulito server-side)
        let preview = '';
        if (c.preview || c.body_preview) {
            const inner = c.body_preview
                ? `${c.preview ? `<div class="fw-semibold mb-1">${this._escapeHtml(c.preview)}</div>` : ''}${this._escapeHtml(c.body_preview)}`
                : this._escapeHtml(c.preview);
            preview = `<div class="sy-pop-preview">${inner}</div>`;
        }
        return `<div class="d-flex align-items-center gap-2">
            <span class="sy-pop-chip" style="background:${chip.bg};color:${chip.color}"><i class="${chip.icon}"></i></span>
            <div><div class="fw-semibold">${this._escapeHtml(label)}</div>
            <div class="text-muted" style="font-size:.75rem">${meta}</div></div>
        </div>${preview}`;
    },

    showImportEmlModal() {
        this._showModal('<i class="fa-solid fa-envelope-open-text me-2"></i>Importa Lead da .eml', `
            <p class="text-muted small">
                Seleziona uno o più file <code>.eml</code> esportati dalla tua casella email.
                L'AI estrarrà automaticamente i dati del cliente (azienda, contatto, descrizione progetto)
                e gli allegati verranno salvati nella scheda della lead.
            </p>
            <div class="mb-3">
                <label class="form-label fw-medium">File .eml</label>
                <input type="file" id="eml-file-input" class="form-control" accept=".eml" multiple>
                <small class="text-muted">Puoi selezionare più file insieme.</small>
            </div>
            <div id="eml-import-progress" class="d-none mb-3">
                <div class="d-flex align-items-center gap-2 text-muted small">
                    <i class="fa-solid fa-spinner fa-spin"></i>
                    <span>Analisi in corso con AI... può richiedere fino a 2 minuti per file.</span>
                </div>
            </div>
            <div id="eml-import-result"></div>
            <div class="d-flex gap-2 justify-content-end mt-3">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
                <button class="btn btn-primary" id="eml-import-btn" onclick="SyrusApp.importEmlFiles()">
                    <i class="fa-solid fa-upload me-1"></i>Importa
                </button>
            </div>
        `);
    },

    async importEmlFiles() {
        const input = document.getElementById('eml-file-input');
        const files = input?.files;
        if (!files || files.length === 0) {
            this.toast('Seleziona almeno un file .eml', 'warning');
            return;
        }

        const btn = document.getElementById('eml-import-btn');
        const progress = document.getElementById('eml-import-progress');
        const result = document.getElementById('eml-import-result');
        if (btn) btn.disabled = true;
        if (progress) progress.classList.remove('d-none');
        if (result) result.innerHTML = '';

        const formData = new FormData();
        for (const f of files) formData.append('files', f);

        try {
            const r = await SyrusApp.fetchWithCsrf('/leads/api/import-eml', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const data = await r.json();
            if (!r.ok) throw new Error(data.error || 'Errore import');

            const rows = (data.results || []).map(item => {
                if (item.ok) {
                    const ai = item.ai_used ? `<span class="badge bg-info ms-1">AI: ${this._escapeHtml(item.ai_engine || '')}</span>` : '<span class="badge bg-warning text-dark ms-1">no AI</span>';
                    const att = item.attachments_saved > 0 ? `<span class="text-muted small ms-2"><i class="fa-solid fa-paperclip"></i> ${item.attachments_saved} allegati</span>` : '';
                    return `<li class="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                            <i class="fa-solid fa-check-circle text-success me-2"></i>
                            <strong>${this._escapeHtml(item.filename)}</strong> →
                            <a href="/leads/${item.lead_id}" onclick="event.preventDefault();bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();SyrusApp.spaNavigate('/leads/${item.lead_id}')">${this._escapeHtml(item.crm_id || '')} ${this._escapeHtml(item.lead_name || '')}</a>
                            ${ai}${att}
                        </div>
                    </li>`;
                }
                return `<li class="list-group-item">
                    <i class="fa-solid fa-circle-xmark text-danger me-2"></i>
                    <strong>${this._escapeHtml(item.filename)}</strong>:
                    <span class="text-danger small">${this._escapeHtml(item.error || 'errore')}</span>
                </li>`;
            }).join('');

            if (result) {
                result.innerHTML = `<div class="alert alert-${data.imported > 0 ? 'success' : 'warning'} mb-2">
                    Importate <strong>${data.imported}</strong> lead su ${data.total}.
                </div>
                <ul class="list-group">${rows}</ul>`;
            }
            if (data.imported > 0) this.loadLeads();
        } catch (e) {
            if (result) result.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`;
        } finally {
            if (btn) btn.disabled = false;
            if (progress) progress.classList.add('d-none');
        }
    },

    // Logo Google Ads inline (SVG ufficiale da icon-icons.com/icon/171064,
    // ripulito: viewBox aggiunto, clip-path e id rimossi perché il badge è
    // ripetuto su più righe). Inline e non <img> esterno per via della CSP.
    // Mostrato nella colonna senza intestazione quando la lead ha un gclid.
    _googleAdsBadge(gclid) {
        return `<span data-bs-toggle="tooltip" data-bs-placement="right"
            data-bs-title="Conversione Google Ads&#10;gclid: ${this._escapeAttr(gclid || '')}" style="cursor:help">
            <svg width="16" height="16" viewBox="0 0 64 64" role="img" aria-label="Google Ads" style="vertical-align:-3px">
                <g transform="matrix(.257748 0 0 .257745 -.361416 2.515516)">
                    <path d="M85.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54l51.6 89.8c14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21l-45.4-78.8c-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9L88.8 62.2c-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6" fill="#3c8bd9"/>
                    <path d="M85.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5l32.9 56.9c1 1.7 1.8 3.4 2.8 5l-18.1 31.1-25.3 43.6c-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5l14.3-24.9L85.2 29.7c.2-.4.5-.7.7-1.1" fill="#fabc04"/>
                    <path d="M11.8 158l5.7-5.1c24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9C20 225.4 4.5 210.6 1.8 191c-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2" fill="#34a852"/>
                </g>
            </svg></span>`;
    },

    // Icona canale di origine della lead (colonna senza intestazione, sotto
    // l'eventuale badge Google Ads). Click = apre il popover, che resta fisso
    // finché non si riclicca l'icona o si clicca fuori.
    _channelIcon(l) {
        const map = {
            whatsapp:        {icon: 'fa-brands fa-whatsapp',      color: '#15803D', bg: '#DCFCE7', label: 'WhatsApp'},
            website:         {icon: 'fa-solid fa-file-lines',     color: '#2E75B6', bg: '#EBF3FB', label: 'Form sito'},
            web_form:        {icon: 'fa-solid fa-file-lines',     color: '#2E75B6', bg: '#EBF3FB', label: 'Form sito'},
            api:             {icon: 'fa-solid fa-file-lines',     color: '#2E75B6', bg: '#EBF3FB', label: 'Form sito (API)'},
            phone_inbound:   {icon: 'fa-solid fa-phone',          color: '#B45309', bg: '#FEF3C7', label: 'Centralino'},
            manual:          {icon: 'fa-solid fa-user-pen',       color: '#475569', bg: '#F1F5F9', label: 'Inserimento manuale'},
            referral:        {icon: 'fa-solid fa-handshake',      color: '#475569', bg: '#F1F5F9', label: 'Referral'},
            email_import:    {icon: 'fa-solid fa-envelope',       color: '#475569', bg: '#F1F5F9', label: 'Import email'},
            audio_recording: {icon: 'fa-solid fa-microphone',     color: '#475569', bg: '#F1F5F9', label: 'Registrazione audio'},
        };
        const m = map[l.source] || {icon: 'fa-solid fa-circle-question', color: '#94A3B8', bg: '#F1F5F9', label: l.source || 'Sconosciuta'};
        const site = (l.site || '').trim();
        const siteUrl = site ? (site.startsWith('http') ? site : 'https://' + site) : '';
        const siteRow = site ? `<div class="sy-pop-site"><i class="fa-solid fa-globe me-1"></i>
            <a href="${this._escapeAttr(siteUrl)}" target="_blank" rel="noopener">${this._escapeHtml(site)}</a></div>` : '';
        const content = `<div class="d-flex align-items-center gap-2">
            <span class="sy-pop-chip" style="background:${m.bg};color:${m.color}"><i class="${m.icon}"></i></span>
            <div><div class="fw-semibold">${this._escapeHtml(m.label)}</div>
            <div class="text-muted" style="font-size:.75rem">Canale di origine</div></div>
        </div>${siteRow}`;
        return `<span class="lead-origin-ico" data-pop-content="${this._escapeAttr(content)}" aria-label="${this._escapeAttr(m.label)}">
            <i class="${m.icon}" style="color:${m.color};font-size:.95rem"></i></span>`;
    },

    // Popover custom delle icone canale: trigger manuale per gestire il pin al
    // click. Il contenuto è generato internamente (dati già escapati), quindi
    // sanitize:false è sicuro e permette gli stili inline della chip.
    _resetOriginPopovers() {
        this._pinnedOriginPopover = null;
        document.querySelectorAll('.popover.sy-origin-popover').forEach(t => t.remove());
    },
    _initOriginPopovers(tbody) {
        if (!this._originPopoverDocHandler) {
            this._originPopoverDocHandler = (e) => {
                const p = this._pinnedOriginPopover;
                if (!p) return;
                if (p._element?.contains(e.target) || p.tip?.contains(e.target)) return;
                this._pinnedOriginPopover = null;
                p.hide();
            };
            document.addEventListener('click', this._originPopoverDocHandler);
        }
        tbody.querySelectorAll('[data-pop-content]').forEach(el => {
            const pop = bootstrap.Popover.getOrCreateInstance(el, {
                html: true, sanitize: false, trigger: 'manual',
                placement: el.dataset.popPlacement || 'right', container: 'body',
                customClass: 'sy-origin-popover',
                content: el.dataset.popContent || '',
            });
            el.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this._pinnedOriginPopover === pop) {
                    this._pinnedOriginPopover = null;
                    pop.hide();
                } else {
                    if (this._pinnedOriginPopover) this._pinnedOriginPopover.hide();
                    this._pinnedOriginPopover = pop;
                    pop.show();
                }
            });
        });
    },

    // Colonna Score: anello di progresso col punteggio su 100, generato dall'AI.
    // Il tooltip porta la motivazione e la data, così il numero non arriva nudo.
    _scoreCell(l) {
        const score = l.lead_score != null ? Math.max(0, Math.min(100, Number(l.lead_score) || 0)) : null;
        if (score === null) return '<span class="text-muted">-</span>';
        const ringColor = score >= 70 ? '#10B981' : score >= 40 ? '#F59E0B' : '#EF4444';
        const parts = [];
        if (l.score_reason) parts.push(l.score_reason);
        if (l.score_updated_at) parts.push(`Aggiornato il ${this._fmtDateIt(l.score_updated_at)}`);
        const title = parts.length ? this._escapeAttr(parts.join(' — ')) : 'Punteggio non ancora generato dall\'AI';
        return `<div class="lead-score-wrap" title="${title}">
                <div class="lead-score-ring" style="--score:${score};--ring-color:${ringColor}"><span>${score}</span></div>
                <span class="lead-score-su">su 100</span></div>`;
    },

    // ── Colonna Documenti ────────────────────────────────────────────────
    // I tre passi della trattativa in catena: l'icona è spenta finché il passo
    // non parte, ambra mentre è in lavorazione, verde quando il documento c'è.
    // Al passaggio del mouse il popover dice a che punto è ciascuno.
    _DOC_STEPS: [
        {key: 'analysis', icon: 'fa-clipboard-check',      label: 'Analisi'},
        {key: 'offer',    icon: 'fa-file-invoice-dollar',  label: 'Offerta'},
        {key: 'contract', icon: 'fa-file-contract',        label: 'Contratto'},
    ],

    // Le parole sono quelle dei badge nei tab del dettaglio lead: stesso stato,
    // stesso nome. Analisi e offerta stanno sul workflow con approvazione, il
    // contratto sulla pipeline documenti storica: vocabolari diversi.
    _DOC_STATUS_LABEL: {
        analysis: {
            draft: 'Bozza', extracting: 'Estrazione in corso',
            extracted: 'Da inviare in approvazione', in_review: 'In approvazione',
            changes_requested: 'Da rivedere', approved: 'Approvata',
            generated: 'Documento generato',
        },
        offer: {
            draft: 'Bozza', extracting: 'Stesura in corso', extracted: 'Pronta',
            generated: 'Documento generato',
        },
        contract: {
            generating: 'Generazione in corso', draft: 'Bozza', review: 'In revisione',
            approved: 'Approvato', sent: 'Inviato', accepted: 'Accettato',
            rejected: 'Rifiutato',
        },
    },
    _DOC_NOT_STARTED: {
        analysis: 'Non ancora avviata',
        offer: 'Non ancora redatta',
        contract: 'Non ancora generato',
    },

    _docStepDetail(stepKey, d) {
        if (!d || !d.state || d.state === 'none') return this._DOC_NOT_STARTED[stepKey];
        const label = (this._DOC_STATUS_LABEL[stepKey] || {})[d.status] || d.status || '—';
        const parts = [];
        // Di offerte ne convivono più varianti: dire quante sono e come sta
        // l'ultima vale più che ripetere lo stato di una sola
        if (d.count > 1) {
            const names = (d.variants || []).filter(Boolean).join(', ');
            parts.push(`${d.count} varianti${names ? ` (${names})` : ''}`);
            parts.push(`ultima: ${label.toLowerCase()}`);
        } else {
            parts.push(label);
        }
        if (d.at) parts.push(this._fmtDateIt(d.at));
        return parts.join(' · ');
    },

    _docsCell(docs) {
        docs = docs || {};
        const steps = this._DOC_STEPS.map(s => ({s, d: docs[s.key] || {}}));
        const chain = steps.map(({s, d}, i) => {
            const state = d.state || 'none';
            // Il connettore si accende quando il passo precedente è chiuso:
            // la catena si legge come un avanzamento, non come tre spie
            const prev = i ? (steps[i - 1].d.state || 'none') : null;
            const sep = i ? `<span class="doc-sep${prev === 'done' ? ' is-done' : ''}"></span>` : '';
            return `${sep}<i class="fa-solid ${s.icon} doc-step is-${state}"></i>`;
        }).join('');
        const pop = '<div class="sy-doc-pop">' + steps.map(({s, d}) => `
            <div class="sy-doc-row">
                <i class="fa-solid ${s.icon} doc-step is-${d.state || 'none'}"></i>
                <span><b>${s.label}</b><br><small>${this._escapeHtml(this._docStepDetail(s.key, d))}</small></span>
            </div>`).join('') + '</div>';
        // tabindex: il popover si apre anche da tastiera, non solo col mouse
        return `<div class="doc-pipeline" data-doc-pop="${this._escapeAttr(pop)}" tabindex="0"
                     aria-label="Stato documenti: Analisi, Offerta, Contratto">${chain}</div>`;
    },

    // Popover dei documenti: al passaggio del mouse, niente pin al click —
    // la cella resta cliccabile per aprire la lead.
    _resetDocPopovers() {
        document.querySelectorAll('.popover.sy-doc-popover').forEach(t => t.remove());
    },
    _initDocPopovers(tbody) {
        tbody.querySelectorAll('[data-doc-pop]').forEach(el => {
            bootstrap.Popover.getOrCreateInstance(el, {
                html: true, sanitize: false, trigger: 'hover focus',
                placement: 'top', container: 'body',
                customClass: 'sy-doc-popover',
                content: el.dataset.docPop || '',
            });
        });
    },

    // Colonna Budget: invariata, resta il campo compilato a mano o dedotto.
    _budgetCell(l) {
        return l.budget_range
            ? `<small class="fw-medium text-success">${this._escapeHtml(l.budget_range)}</small>`
            : '<span class="text-muted">-</span>';
    },

    // Solo giorno: nel tooltip dello score l'orario è rumore.
    // parseDate normalizza l'UTC del backend (vedi app-core.js).
    _fmtDateIt(iso) {
        if (!iso) return '';
        const d = this.parseDate(iso);
        if (isNaN(d)) return '';
        return d.toLocaleDateString('it-IT', {day: '2-digit', month: '2-digit', year: 'numeric'});
    },

    // Classe riga per gli stati evidenziati nella lista (vinta/persa/dormiente),
    // in coppia con la legenda a chip sopra la tabella.
    _leadRowClass(status) {
        const cls = {new: 'lead-row-new', won: 'lead-row-won', lost: 'lead-row-lost', dormant: 'lead-row-dormant'}[status];
        return cls ? ` class="${cls}"` : '';
    },

    async loadLeads(page = 1) {
        if (this._leadView === 'kanban') { this.loadKanban(); return; }
        this._leadsPage = page;
        const f = this._getLeadFilters();
        const params = new URLSearchParams({page, search: f.search, status: f.status, priority: f.priority, assigned_to: f.assigned_to, source: f.source, sort_by: f.sort_by});

        try {
            const data = await this.api(`/leads/api/list?${params}`);
            // Admin: elenco commerciali per il cambio rapido dell'assegnatario
            if (window.SYRUS && window.SYRUS.isAdmin && !this._assigneeOptions) {
                try { this._assigneeOptions = await this.api('/leads/api/salespersons'); }
                catch (e) { this._assigneeOptions = []; }
            }
            const tbody = document.getElementById('leads-table');
            this._resetOriginPopovers();
            this._resetDocPopovers();

            if (data.items.length === 0) {
                tbody.innerHTML = '<tr><td colspan="13" class="text-center text-muted py-4">Nessun lead trovato</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(l => `
                    <tr data-lead-id="${l.id}"${this._leadRowClass(l.status)}>
                        <td class="text-center"><input type="checkbox" class="form-check-input lead-select" value="${l.id}" onchange="SyrusApp.onLeadCheckbox(this)"></td>
                        <td class="text-center pe-0">${l.status === 'new' ? '<div class="lead-beam" aria-hidden="true"></div>' : ''}<div class="d-flex flex-column align-items-center gap-1">${l.gclid ? this._googleAdsBadge(l.gclid) : ''}${this._channelIcon(l)}</div></td>
                        <td>
                            <a href="/leads/${l.id}" class="text-decoration-none">
                                <div class="fw-medium">${this._escapeHtml(l.company_name || '-')}</div>
                                <small class="text-muted">${this._escapeHtml(l.crm_id || '')} ${l.project_type ? '· ' + this._escapeHtml(l.project_type || '') : ''}</small>
                            </a>
                        </td>
                        <td>${this._escapeHtml(l.contact_name || '-')}</td>
                        <td>${this.statusBadge(l.status)}</td>
                        <td>${this.priorityBadge(l.priority)}</td>
                        <td><small>${this._lastContactBadge(l.last_contact_at, l.last_contact)}</small></td>
                        <td class="text-center">${this._scoreCell(l)}</td>
                        <td class="text-center">${this._budgetCell(l)}</td>
                        <td>${this._docsCell(l.documents)}</td>
                        <td><small class="text-muted">${l.created_at ? this.parseDate(l.created_at).toLocaleDateString('it-IT', {day:'2-digit',month:'short',year:'2-digit'}) : '-'}</small></td>
                        ${this._assigneeCell(l)}
                        <td class="text-end">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" onclick="event.stopPropagation()">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="/leads/${l.id}"><i class="fa-solid fa-eye me-2"></i>Dettaglio</a></li>
                                    ${l.contact_phone ? `<li><a class="dropdown-item" href="#" onclick="SyrusApp.wpQuickCall('${this._escapeAttr(l.contact_phone)}');return false"><i class="fa-solid fa-phone me-2"></i>Chiama</a></li>` : ''}
                                    ${l.contact_email ? `<li><a class="dropdown-item" href="#" onclick="SyrusApp.showSendEmailModal('${this._escapeAttr(l.id)}','${this._escapeAttr(l.contact_email)}');return false"><i class="fa-solid fa-envelope me-2"></i>Email</a></li>` : ''}
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.showStatusModal('${l.id}','${l.status}');return false"><i class="fa-solid fa-arrows-rotate me-2"></i>Cambia Status</a></li>
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.showLogContactModal('${l.id}');return false"><i class="fa-solid fa-pen-to-square me-2"></i>Registra Attivit&agrave;</a></li>
                                    ${window.SYRUS_CAN_DELETE_LEAD ? `<li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item text-danger" href="#" onclick="SyrusApp.showDeleteLeadModal('${l.id}','${this._escapeAttr(l.crm_id || '')}','${this._escapeAttr(l.company_name || l.contact_name || l.crm_id || '')}');return false"><i class="fa-solid fa-trash me-2"></i>Elimina</a></li>` : ''}
                                </ul>
                            </div>
                        </td>
                    </tr>`).join('');
                // Tooltip e popover Bootstrap (badge Google Ads, icona canale)
                // non si auto-inizializzano sull'HTML iniettato: vanno istanziati qui.
                if (typeof bootstrap !== 'undefined') {
                    tbody.querySelectorAll('[data-bs-toggle="tooltip"]')
                        .forEach(el => bootstrap.Tooltip.getOrCreateInstance(el));
                    this._initOriginPopovers(tbody);
                    this._initDocPopovers(tbody);
                }
                // Riga interamente cliccabile → dettaglio lead. Gli elementi
                // interattivi (dropdown ⋮, link, popover canale) restano autonomi.
                if (!tbody.dataset.rowNav) {
                    tbody.dataset.rowNav = '1';
                    tbody.addEventListener('click', (e) => {
                        if (e.target.closest('a, button, input, .dropdown, .dropdown-menu, [data-bs-toggle], [data-pop-content]')) return;
                        const row = e.target.closest('tr[data-lead-id]');
                        if (row) window.location.href = `/leads/${row.dataset.leadId}`;
                    });
                }
            }

            // Il tbody viene riscritto a ogni render: le checkbox vanno ri-spuntate
            // dalla selezione, che sopravvive a cambio pagina e filtri.
            this.restoreLeadSelection();

            document.getElementById('leads-info').textContent = `${data.total} lead totali – Pagina ${data.page} di ${data.pages}`;
            this._renderSearchScopeHint();
            const pag = document.getElementById('leads-pagination');
            pag.innerHTML = '';
            for (let i = 1; i <= data.pages; i++) {
                pag.innerHTML += `<li class="page-item ${i === data.page ? 'active' : ''}"><a class="page-link" href="#" onclick="SyrusApp.loadLeads(${i})">${i}</a></li>`;
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // Avviso sotto le viste rapide quando la ricerca ha scavalcato la vista
    // corrente: senza, l'utente vede "Attive" evidenziata ma anche lead perse.
    _renderSearchScopeHint() {
        const box = document.getElementById('leads-search-scope');
        const widened = !!this._leadsSearchWidened;
        document.querySelectorAll('#leads-view-chips .lead-view-chip').forEach(btn => {
            btn.classList.toggle('active', !widened && btn.dataset.view === (this._leadsQuickView || 'active'));
        });
        if (!box) return;
        box.classList.toggle('d-none', !widened);
        if (widened) {
            box.innerHTML = '<i class="fa-solid fa-magnifying-glass me-1"></i>'
                + 'Ricerca estesa a tutte le lead, comprese perse, vinte e dormienti. '
                + '<a href="#" onclick="SyrusApp.setLeadQuickView(\'active\');return false">Torna alle sole attive</a>';
        }
    },

    // ── Soft-delete lead (doppia conferma) ───────────────────────────────
    // Apre il modale condiviso (#deleteLeadModal, partial _delete_lead_modal.html):
    // il pulsante di conferma si abilita solo riscrivendo il CRM ID esatto.
    showDeleteLeadModal(leadId, crmId, leadName) {
        const modalEl = document.getElementById('deleteLeadModal');
        if (!modalEl) return;
        const form = document.getElementById('delete-lead-form');
        const input = document.getElementById('delete-confirm-input');
        const btn = document.getElementById('delete-confirm-btn');
        const target = (crmId || 'ELIMINA').trim();
        form.action = `/leads/delete/${leadId}`;
        document.getElementById('delete-lead-name').textContent = leadName || crmId || 'questa lead';
        document.getElementById('delete-lead-crm').textContent = target;
        input.value = '';
        input.placeholder = target;
        btn.disabled = true;
        input.oninput = () => { btn.disabled = input.value.trim() !== target; };
        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    },

    // ── Kanban View ──────────────────────────────────────────────────────

    async loadKanban() {
        const board = document.getElementById('kanban-board');
        if (!board) return;
        const search = document.getElementById('leads-search')?.value || '';

        try {
            const cols = await this.api(`/leads/api/kanban?search=${encodeURIComponent(search)}`);
            const statusLabels = {
                new:'Nuovo', contacted:'Contattato', qualified:'Qualificato',
                proposal_sent:'Preventivo', negotiation:'Trattativa',
                won:'Vinto', lost:'Perso', dormant:'Dormiente', spam:'Spam'
            };
            const statusColors = {
                new:'#F59E0B', contacted:'#3B82F6', qualified:'#8B5CF6',
                proposal_sent:'#06B6D4', negotiation:'#F97316',
                won:'#10B981', lost:'#EF4444', dormant:'#94A3B8', spam:'#374151'
            };

            board.innerHTML = Object.entries(cols).map(([status, leads]) => `
                <div class="kanban-col" data-status="${status}">
                    <div class="kanban-col-header" style="background:${statusColors[status] || '#64748B'};color:#fff">
                        <span>${statusLabels[status] || status}</span>
                        <span class="badge bg-white text-dark">${leads.length}</span>
                    </div>
                    <div class="kanban-col-body" data-status="${status}"
                         ondragover="event.preventDefault();this.classList.add('drag-over')"
                         ondragleave="this.classList.remove('drag-over')"
                         ondrop="SyrusApp.kanbanDrop(event,'${status}')">
                        ${leads.map(l => `
                            <div class="kanban-card" draggable="true" data-id="${l.id}"
                                 ondragstart="event.dataTransfer.setData('text/plain','${l.id}');this.classList.add('dragging')"
                                 ondragend="this.classList.remove('dragging')"
                                 onclick="SyrusApp.spaNavigate('/leads/${l.id}')">
                                <div class="d-flex justify-content-between align-items-start mb-1">
                                    <strong>${this._escapeHtml(l.company_name || '-')}</strong>
                                    ${this.priorityBadge(l.priority)}
                                </div>
                                <div class="small text-muted mb-2">${this._escapeHtml(l.contact_name || '')}</div>
                                ${l.project_type ? `<div class="small mb-2" style="color:var(--color-text-brand)"><i class="fa-solid fa-briefcase me-1" style="font-size:10px"></i>${this._escapeHtml(l.project_type)}</div>` : ''}
                                ${l.lead_score ? `<div class="d-inline-flex align-items-center gap-1 mb-2"><div style="width:40px;height:4px;background:var(--color-bg-emphasis);border-radius:2px;overflow:hidden"><div style="width:${l.lead_score}%;height:100%;background:${l.lead_score > 70 ? 'var(--color-success)' : l.lead_score > 40 ? 'var(--color-warning)' : 'var(--color-text-muted)'};border-radius:2px"></div></div><small style="font-size:10px;color:var(--color-text-muted)">${l.lead_score}</small></div>` : ''}
                                <div class="d-flex justify-content-between align-items-center" style="border-top:1px solid var(--color-border-default);padding-top:6px;margin-top:2px">
                                    <small>${this._lastContactBadge(l.last_contact_at)}</small>
                                    <small class="text-muted" style="font-size:11px">${l.assigned_name ? this._escapeHtml(l.assigned_name.split(' ')[0]) : ''}</small>
                                </div>
                            </div>
                        `).join('')}
                        ${leads.length === 0 ? '<div class="text-center text-muted small py-4"><i class="fa-solid fa-inbox d-block mb-1" style="opacity:.3"></i>Vuoto</div>' : ''}
                    </div>
                </div>
            `).join('');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async kanbanDrop(event, newStatus) {
        event.preventDefault();
        event.currentTarget.classList.remove('drag-over');
        const leadId = event.dataTransfer.getData('text/plain');
        if (!leadId) return;

        try {
            await this.api(`/leads/api/${leadId}/status`, {
                method: 'PUT',
                body: JSON.stringify({ status: newStatus, notes: 'Spostato via Kanban' }),
            });
            this.loadKanban();
        } catch (e) {
            this.toast(e.message, 'danger');
            this.loadKanban();
        }
    },

    async saveLead(event, leadId) {
        event.preventDefault();
        const form = event.target;
        const fd = new FormData(form);
        const data = Object.fromEntries(fd.entries());

        try {
            if (leadId) {
                await this.api(`/leads/api/${leadId}/update`, { method: 'PUT', body: JSON.stringify(data) });
                this.toast('Lead aggiornato');
            } else {
                const result = await this.api('/leads/api/create', { method: 'POST', body: JSON.stringify(data) });
                this.toast('Lead creato');
                location.href = `/leads/${result.id}`;
                return;
            }
            location.href = `/leads/${leadId}`;
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    toggleAiPanel(leadId) {
        const body = document.getElementById('ai-intelligence-body');
        const icon = document.getElementById('ai-panel-toggle-icon');
        if (!body) return;
        const key = `ai-panel-closed-${leadId}`;
        const isHidden = body.style.display === 'none';
        if (isHidden) {
            body.style.display = '';
            if (icon) icon.className = 'fa-solid fa-chevron-up';
            localStorage.removeItem(key);
        } else {
            body.style.display = 'none';
            if (icon) icon.className = 'fa-solid fa-chevron-down';
            localStorage.setItem(key, '1');
        }
    },

    _restoreAiPanelState(leadId) {
        const key = `ai-panel-closed-${leadId}`;
        if (localStorage.getItem(key) === '1') {
            const body = document.getElementById('ai-intelligence-body');
            const icon = document.getElementById('ai-panel-toggle-icon');
            if (body) body.style.display = 'none';
            if (icon) icon.className = 'fa-solid fa-chevron-down';
        }
    },

    async toggleFunnelActive(leadId, isActive) {
        try {
            await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT',
                body: JSON.stringify({ funnel_active: isActive }),
            });
            this.toast(isActive ? 'Funnel attivato' : 'Funnel disattivato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async updateLeadPriority(leadId, priority, btn) {
        try {
            await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT',
                body: JSON.stringify({ priority }),
            });
            const parent = btn.parentElement;
            parent.querySelectorAll('button').forEach(b => {
                const p = b.textContent.trim().toLowerCase();
                const color = p === 'cold' ? 'info' : p === 'warm' ? 'warning' : 'danger';
                b.className = `btn btn-${b === btn ? '' : 'outline-'}${color} btn-sm flex-fill`;
            });
            const headerBadge = document.querySelector('.badge-priority-cold, .badge-priority-warm, .badge-priority-hot');
            if (headerBadge) {
                headerBadge.className = `badge badge-priority-${priority}`;
                headerBadge.innerHTML = `<i class="fa-solid fa-${priority === 'cold' ? 'snowflake' : priority === 'warm' ? 'sun' : 'fire'} me-1"></i>${priority.toUpperCase()}`;
            }
            this.toast('Priorità aggiornata');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // Blocco appunti della lead (tab Note, primo tab della card Materiali).
    // Salva da sé mentre si scrive: nessun pulsante, lo stato lo dice la riga
    // sopra la casella.
    onLeadNotesInput(textarea) {
        this._setLeadNotesStatus('Modifiche non salvate…', 'text-muted');
        clearTimeout(this._leadNotesTimer);
        this._leadNotesTimer = setTimeout(() => this.saveLeadNotes(textarea), 1200);
    },

    // Uscita dalla pagina (navigazione SPA o chiusura tab) con il debounce ancora
    // pendente: si perderebbe l'ultimo appunto. keepalive tiene viva la richiesta.
    _flushLeadNotes() {
        const box = document.getElementById('lead-notes-box');
        if (!box || box.value === this._leadNotesSaved) return;
        clearTimeout(this._leadNotesTimer);
        const saved = box.value;
        this._leadNotesSaved = saved;
        try {
            fetch(`/leads/api/${box.dataset.lead}/update`, {
                method: 'PUT',
                keepalive: true,
                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': this._csrfToken() },
                body: JSON.stringify({ notes: saved }),
            });
        } catch (e) { /* uscita in corso: non c'è più UI a cui dirlo */ }
    },

    _setLeadNotesStatus(text, cls) {
        const el = document.getElementById('lead-notes-status');
        if (!el) return;
        el.className = `small ${cls || 'text-muted'}`;
        el.textContent = text;
    },

    async saveLeadNotes(textarea) {
        clearTimeout(this._leadNotesTimer);
        const leadId = textarea.dataset.lead;
        const notes = textarea.value;
        // Niente PUT a vuoto: il blur scatta anche solo cambiando tab.
        if (notes === this._leadNotesSaved) return;
        this._setLeadNotesStatus('Salvataggio…', 'text-muted');
        try {
            await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT',
                body: JSON.stringify({ notes }),
            });
            this._leadNotesSaved = notes;
            const ora = new Date().toLocaleTimeString('it-IT', {hour: '2-digit', minute: '2-digit'});
            this._setLeadNotesStatus(`Salvato alle ${ora}`, 'text-success');
        } catch (e) {
            this._setLeadNotesStatus('Non salvato: ' + e.message, 'text-danger');
            this.toast('Errore salvataggio note: ' + e.message, 'danger');
        }
    },

    inlineEdit(el) {
        if (el.querySelector('input') || el.querySelector('textarea')) return; // already editing
        const field = el.dataset.field;
        const leadId = el.dataset.lead;
        const isMultiline = el.dataset.multiline === '1';
        // Ignora placeholder e trattini
        let currentText = el.textContent.trim();
        if (currentText.startsWith('Clicca per')) currentText = '';
        currentText = currentText.replace(/^-$/, '');

        let input;
        if (isMultiline) {
            input = document.createElement('textarea');
            input.className = 'form-control form-control-sm';
            input.rows = 4;
            input.style.cssText = 'width:100%';
        } else {
            input = document.createElement('input');
            input.type = 'text';
            input.className = 'form-control form-control-sm';
            input.style.cssText = 'width:100%;display:inline';
        }
        input.value = currentText;

        el.textContent = '';
        el.appendChild(input);
        input.focus();
        if (!isMultiline) input.select();

        const save = async () => {
            const val = input.value.trim();
            try {
                const updated = await this.api(`/leads/api/${leadId}/update`, {
                    method: 'PUT',
                    body: JSON.stringify({ [field]: val }),
                });
                const finalVal = (updated && updated[field] !== undefined) ? updated[field] : val;
                el.innerHTML = `${this._escapeHtml(finalVal || '-')} <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>`;
                if (field === 'budget_range' && finalVal) {
                    el.dataset.manualOverride = '1';
                }
            } catch (e) {
                el.innerHTML = `${this._escapeHtml(currentText || '-')} <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>`;
                this.toast(e.message, 'danger');
            }
        };

        input.addEventListener('blur', save);
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !isMultiline) { e.preventDefault(); input.blur(); }
            if (e.key === 'Escape') {
                el.innerHTML = `${this._escapeHtml(currentText || '-')} <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>`;
            }
        });
    },

    async loadLeadDetail(leadId) {
        // Guard: bail out se non siamo sulla lead detail page (gli elementi
        // DOM specifici non esistono). Evita "Cannot set ... innerHTML" quando
        // viene chiamata da polling/refresh in background da altre pagine.
        if (!document.getElementById('rubrica-sidebar')) return;
        try {
            const data = await this.api(`/leads/api/${leadId}`);

            // Rubrica sidebar card (ex tab Contatti, rimossa 2026-07-24)
            this._currentLeadId = data.id || data.lead?.id;
            this._autoTabDone = false;  // riabilita il salto alla tab più recente
            this._cachedContacts = data.contacts;
            this._renderRubricaSidebar(data.contacts);

            // Load document pipeline for the Documents tab + sidebar
            const _lid = data.id || data.lead?.id;

            // Track current lead ID for polling/refresh
            this._currentLeadId = _lid;

            // Unified Timeline (dedicated endpoint)
            this._loadTimeline(_lid);
            this.loadDocumentPipeline(_lid);
            this.loadDocumentSidebar(_lid);
            this.checkDocPrerequisite(_lid);

            // Load lead files
            this.loadLeadFiles(_lid);

            // Tab Note: memorizza il testo già a DB per non ri-salvarlo a vuoto
            this._leadNotesSaved = document.getElementById('lead-notes-box')?.value ?? null;
            if (!this._leadNotesUnloadBound) {
                this._leadNotesUnloadBound = true;
                window.addEventListener('pagehide', () => this._flushLeadNotes());
            }

            // Load new tabs (Comunicazioni, WhatsApp, Telefonate, Trascrizioni)
            this.loadLeadComms(_lid);
            this.loadLeadWhatsapp(_lid);
            this.loadLeadCallsAndTranscriptions(_lid);
            this.loadLeadTranscriptions(_lid);

            // Load AI Intelligence panel (sidebar)
            this.loadAiIntelligence(_lid);

            // Tab Analisi: badge stato + deep-link ?tab=analisi dalle email
            this.loadAnalysis(_lid, { badgeOnly: true });
            if (new URLSearchParams(window.location.search).get('tab') === 'analisi') {
                const btn = document.getElementById('analysis-tab-btn');
                if (btn) { new bootstrap.Tab(btn).show(); this.loadAnalysis(_lid); }
            }

            // Populate assignee dropdown (admin only)
            this._initAssignedToDropdown();

            // Aggiorna campi inline con valori e badge AI
            this._updateInlineFields(data);

            // Proposta economica
            this._renderProposal(data, _lid);

            // Duplicate detection alert
            this._checkDuplicates(_lid);

            // Quick Fix button visibility
            this._checkQuickFix(_lid);
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    _updateInlineFields(data) {
        const aiFilled = data.ai_filled_fields || [];
        const aiBadge = ' <span class="badge bg-info text-white ms-1" style="font-size:9px;vertical-align:middle" title="Compilato da AI Lead Intelligence">AI</span>';
        const pencil = ' <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>';
        const fields = ['project_type', 'tech_stack', 'timeline', 'description', 'company_name',
                        'company_address', 'company_piva', 'company_codice_fiscale', 'company_pec', 'company_sdi'];
        for (const field of fields) {
            const el = document.querySelector(`[data-field="${field}"][data-lead]`);
            if (!el || el.querySelector('input') || el.querySelector('textarea')) continue;
            const val = data[field];
            const isAi = aiFilled.includes(field);
            if (val) {
                el.innerHTML = `${this._escapeHtml(val)}${isAi ? aiBadge : ''}${pencil}`;
            } else {
                const placeholder = field === 'description'
                    ? '<span class="text-muted fst-italic">Clicca per aggiungere descrizione...</span>'
                    : '-';
                el.innerHTML = `${placeholder}${pencil}`;
            }
        }
    },

    _renderProposal(data, leadId) {
        const voci = data.proposal_voci || [];
        const canoni = data.proposal_canoni || [];
        this._currentProposalLeadId = leadId;
        this._currentProposalVoci = voci;
        this._currentProposalCanoni = canoni;

        // Voci table
        const vTbody = document.getElementById('proposal-voci-table');
        if (vTbody) {
            if (!voci.length) {
                vTbody.innerHTML = '<tr><td colspan="3" class="text-center text-muted small py-3">Nessuna voce — l\'AI le suggerira\' durante il Lead Scoring</td></tr>';
            } else {
                vTbody.innerHTML = voci.map((v, i) => `<tr>
                    <td class="small" contenteditable="true" data-idx="${i}" data-field="descrizione" data-type="voci"
                        onblur="SyrusApp._onProposalCellEdit(this)">${this._escapeHtml(v.descrizione || '')}</td>
                    <td class="text-end small fw-medium" contenteditable="true" data-idx="${i}" data-field="prezzo" data-type="voci"
                        onblur="SyrusApp._onProposalCellEdit(this)">${this._escapeHtml(v.prezzo || '')}</td>
                    <td class="text-center"><button class="btn btn-sm btn-link text-danger p-0" onclick="SyrusApp.removeProposalRow('${leadId}','voci',${i})"><i class="fa-solid fa-xmark"></i></button></td>
                </tr>`).join('');
            }
        }
        // Totale
        const totalEl = document.getElementById('proposal-voci-total');
        if (totalEl) {
            let sum = 0;
            for (const v of voci) {
                const n = parseFloat((v.prezzo || '').replace(/[^\d,.]/g, '').replace('.', '').replace(',', '.'));
                if (!isNaN(n)) sum += n;
            }
            totalEl.textContent = sum > 0 ? this.formatCurrency(sum) : '-';
        }

        // Canoni table
        const cTbody = document.getElementById('proposal-canoni-table');
        if (cTbody) {
            if (!canoni.length) {
                cTbody.innerHTML = '<tr><td colspan="3" class="text-center text-muted small py-3">Nessun canone ricorrente</td></tr>';
            } else {
                cTbody.innerHTML = canoni.map((c, i) => `<tr>
                    <td class="small" contenteditable="true" data-idx="${i}" data-field="servizio" data-type="canoni"
                        onblur="SyrusApp._onProposalCellEdit(this)">${this._escapeHtml(c.servizio || '')}</td>
                    <td class="text-end small fw-medium" contenteditable="true" data-idx="${i}" data-field="costo_mensile" data-type="canoni"
                        onblur="SyrusApp._onProposalCellEdit(this)">${this._escapeHtml(c.costo_mensile || '')}</td>
                    <td class="text-center"><button class="btn btn-sm btn-link text-danger p-0" onclick="SyrusApp.removeProposalRow('${leadId}','canoni',${i})"><i class="fa-solid fa-xmark"></i></button></td>
                </tr>`).join('');
            }
        }
    },

    async _onProposalCellEdit(el) {
        const idx = parseInt(el.dataset.idx);
        const field = el.dataset.field;
        const type = el.dataset.type;
        const value = el.textContent.trim();
        const leadId = this._currentProposalLeadId;
        const arr = type === 'voci' ? [...this._currentProposalVoci] : [...this._currentProposalCanoni];
        if (arr[idx]) {
            arr[idx] = {...arr[idx], [field]: value};
        }
        const key = type === 'voci' ? 'proposal_voci' : 'proposal_canoni';
        try {
            const data = await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT', body: JSON.stringify({[key]: arr})
            });
            if (type === 'voci') this._currentProposalVoci = data.proposal_voci || [];
            else this._currentProposalCanoni = data.proposal_canoni || [];
            // Aggiorna totale
            this._renderProposal(data, leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    addProposalRow(leadId, type) {
        const isVoci = type === 'voci';
        let html = `<div class="mb-3 position-relative">
            <label class="form-label fw-bold">${isVoci ? 'Descrizione' : 'Servizio'}</label>
            <input type="text" class="form-control" id="proposal-new-name" placeholder="Inizia a scrivere per cercare nel listino..." autocomplete="off">
            <div id="proposal-suggest" class="list-group position-absolute w-100 shadow-sm" style="z-index:1050;max-height:200px;overflow-y:auto;display:none"></div>
        </div>
        <div class="mb-3">
            <label class="form-label fw-bold">${isVoci ? 'Prezzo' : 'Costo Mensile'}</label>
            <input type="text" class="form-control" id="proposal-new-price" placeholder="${isVoci ? 'Es: 3.500€' : 'Es: 250€/mese'}">
        </div>`;
        html += `<div class="text-end mt-3">
            <button class="btn btn-primary" onclick="SyrusApp._saveNewProposalRow('${leadId}','${type}')">Aggiungi</button>
        </div>`;
        this._showModal('Aggiungi al preventivo', html);

        // Autocomplete
        const input = document.getElementById('proposal-new-name');
        const suggest = document.getElementById('proposal-suggest');
        let debounce;
        input.addEventListener('input', () => {
            clearTimeout(debounce);
            debounce = setTimeout(async () => {
                const q = input.value.trim();
                if (q.length < 2) { suggest.style.display = 'none'; return; }
                try {
                    const items = await this.api(`/pricelist/api/search?q=${encodeURIComponent(q)}`);
                    if (!items.length) { suggest.style.display = 'none'; return; }
                    const filterType = isVoci ? 'one_time' : 'recurring';
                    const filtered = items.filter(i => !filterType || i.billing_type === filterType || items.length <= 3);
                    suggest.innerHTML = filtered.map(i => {
                        const badge = i.billing_type === 'recurring' ? '<span class="badge bg-info ms-1">ricorrente</span>' : '';
                        const priceStr = i.billing_type === 'recurring' ? `€${i.price}/mese` : `€${i.price}`;
                        return `<button type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2"
                            onclick="SyrusApp._selectPriceListItem('${isVoci ? 'voci' : 'canoni'}', ${JSON.stringify(i).replace(/"/g, '&quot;')})">
                            <span>${this._escapeHtml(i.name)}${badge}</span>
                            <span class="fw-bold text-success">${priceStr}</span>
                        </button>`;
                    }).join('');
                    suggest.style.display = 'block';
                } catch (e) { suggest.style.display = 'none'; }
            }, 300);
        });
        input.focus();
    },

    _selectPriceListItem(type, item) {
        const nameInput = document.getElementById('proposal-new-name');
        const priceInput = document.getElementById('proposal-new-price');
        const suggest = document.getElementById('proposal-suggest');
        nameInput.value = item.name;
        priceInput.value = item.billing_type === 'recurring'
            ? `${item.price}€/mese`
            : `${item.price}€`;
        suggest.style.display = 'none';
    },

    async _saveNewProposalRow(leadId, type) {
        const name = document.getElementById('proposal-new-name').value.trim();
        const price = document.getElementById('proposal-new-price').value.trim();
        if (!name) { this.toast('Nome obbligatorio', 'danger'); return; }
        const isVoci = type === 'voci';
        const newItem = isVoci
            ? {descrizione: name, prezzo: price || '0€'}
            : {servizio: name, costo_mensile: price || '0€/mese'};
        const arr = isVoci
            ? [...(this._currentProposalVoci || []), newItem]
            : [...(this._currentProposalCanoni || []), newItem];
        const key = isVoci ? 'proposal_voci' : 'proposal_canoni';
        try {
            const data = await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT', body: JSON.stringify({[key]: arr})
            });
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._renderProposal(data, leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async removeProposalRow(leadId, type, idx) {
        const arr = type === 'voci' ? [...(this._currentProposalVoci || [])] : [...(this._currentProposalCanoni || [])];
        arr.splice(idx, 1);
        const key = type === 'voci' ? 'proposal_voci' : 'proposal_canoni';
        try {
            const data = await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT', body: JSON.stringify({[key]: arr})
            });
            this._renderProposal(data, leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async savePaymentTerms(el) {
        const leadId = el.dataset.lead;
        const value = el.value.trim();
        try {
            await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT',
                body: JSON.stringify({payment_terms_notes: value}),
            });
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // Cella "Assegnato" della lista: per gli admin il nome apre un menu
    // per cambiare l'assegnatario al volo, senza entrare nella lead.
    _assigneeCell(l) {
        const name = this._escapeHtml(l.assigned_name || '-');
        const opts = this._assigneeOptions;
        if (!(window.SYRUS && window.SYRUS.isAdmin) || !opts || !opts.length) {
            return `<td><small>${name}</small></td>`;
        }
        const lead = this._escapeAttr(l.id);
        const item = (id, label) => `<li><a class="dropdown-item small${(l.assigned_to || '') === id ? ' active' : ''}" href="#" data-user="${this._escapeAttr(id)}" onclick="SyrusApp.quickAssignLead(this,'${lead}');return false">${this._escapeHtml(label)}</a></li>`;
        return `<td><div class="dropdown lead-assignee">
                <button type="button" class="lead-assignee-btn" data-bs-toggle="dropdown" onclick="event.stopPropagation()" title="Cambia assegnatario">
                    <small class="lead-assignee-name">${name}</small><i class="fa-solid fa-chevron-down"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                    <li><h6 class="dropdown-header">Assegna a</h6></li>
                    ${opts.map(u => item(u.id, u.display_name || u.email)).join('')}
                    <li><hr class="dropdown-divider"></li>
                    ${item('', 'Non assegnato')}
                </ul></div></td>`;
    },

    async quickAssignLead(el, leadId) {
        const userId = el.dataset.user || '';
        const wrap = el.closest('.lead-assignee');
        try {
            const lead = await this.api(`/leads/api/${leadId}/update`, {
                method: 'PUT',
                body: JSON.stringify({ assigned_to: userId || null }),
            });
            if (wrap) {
                wrap.querySelector('.lead-assignee-name').textContent = lead.assigned_name || '-';
                wrap.querySelectorAll('.dropdown-item').forEach(a =>
                    a.classList.toggle('active', (a.dataset.user || '') === userId));
            }
            this.toast(lead.assigned_name ? `Assegnata a ${lead.assigned_name}` : 'Lead non assegnata', 'success');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async _initAssignedToDropdown() {
        const sel = document.getElementById('lead-assigned-to');
        if (!sel) return; // not admin or not on detail page
        try {
            const users = await this.api('/leads/api/salespersons');
            const current = sel.dataset.current;
            users.forEach(u => {
                const opt = document.createElement('option');
                opt.value = u.id;
                opt.textContent = u.display_name || u.email;
                if (u.id === current) opt.selected = true;
                sel.appendChild(opt);
            });
            sel.addEventListener('change', async () => {
                try {
                    await this.api(`/leads/api/${sel.dataset.lead}/update`, {
                        method: 'PUT',
                        body: JSON.stringify({ assigned_to: sel.value || null }),
                    });
                    this.toast('Assegnatario aggiornato', 'success');
                } catch (e) {
                    this.toast(e.message, 'danger');
                }
            });
        } catch (e) {
            console.error('Failed to load salespersons', e);
        }
    },

    _renderCallItem(cl) {
        const dirIcon = cl.direction === 'inbound'
            ? '<i class="fa-solid fa-phone-arrow-down-left text-success me-1"></i>In entrata'
            : '<i class="fa-solid fa-phone-arrow-up-right text-primary me-1"></i>In uscita';
        const duration = cl.duration_minutes ? `<span class="badge bg-light text-dark"><i class="fa-solid fa-clock me-1"></i>${cl.duration_minutes} min</span>` : '';

        // Audio player or simulated button
        let audioHtml = '';
        if (cl.audio_url) {
            audioHtml = `<div class="mt-2"><audio controls preload="none" class="w-100" style="height:36px"><source src="${cl.audio_url}" type="audio/wav"></audio></div>`;
        } else if (cl.transcript_id) {
            const durationStr = cl.transcript_duration ? `${Math.floor(cl.transcript_duration / 60)}:${String(cl.transcript_duration % 60).padStart(2, '0')}` : '';
            audioHtml = `<div class="mt-2 d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-outline-primary" onclick="this.nextElementSibling.classList.toggle('d-none');this.innerHTML=this.innerHTML.includes('Ascolta')?'<i class=\\'fa-solid fa-eye-slash me-1\\'></i>Nascondi':'<i class=\\'fa-solid fa-headphones me-1\\'></i>Ascolta registrazione'">
                    <i class="fa-solid fa-headphones me-1"></i>Ascolta registrazione
                </button>
                <span class="text-muted small">${durationStr} · ${cl.transcript_speakers || '?'} speaker · conf. ${cl.transcript_confidence ? Math.round(cl.transcript_confidence * 100) + '%' : '?'}</span>
            </div>`;
        }

        // Transcript
        let transcriptHtml = '';
        if (cl.transcript_text) {
            const callId = cl.id.replace(/-/g, '');
            const summaryBtnHtml = cl.transcript_id ? `
                    <button class="btn btn-sm ${cl.call_summary ? 'btn-success' : 'btn-outline-info'}" onclick="SyrusApp.dgSummarize('${cl.transcript_id}')">
                        <i class="fa-solid fa-robot me-1"></i>${cl.call_summary ? 'Vedi Riepilogo AI' : 'Genera Riepilogo AI'}
                    </button>` : '';
            const summaryContentHtml = cl.call_summary ? `
                    <div id="sum-${callId}" class="d-none mt-2">${this._renderCallSummary(cl.call_summary)}</div>` : '';
            transcriptHtml = `
                <div class="mt-2">
                    <button class="btn btn-sm btn-outline-secondary" onclick="document.getElementById('tr-${callId}').classList.toggle('d-none');this.innerHTML=this.innerHTML.includes('Trascrizione')?'<i class=\\'fa-solid fa-eye-slash me-1\\'></i>Nascondi trascrizione':'<i class=\\'fa-solid fa-file-lines me-1\\'></i>Mostra trascrizione'">
                        <i class="fa-solid fa-file-lines me-1"></i>Mostra trascrizione
                    </button>${summaryBtnHtml}
                    <div id="tr-${callId}" class="d-none mt-2 p-3 rounded-3" style="background:var(--color-bg-subtle);max-height:400px;overflow-y:auto;font-size:13px;line-height:1.7;white-space:pre-wrap;font-family:inherit">${this._escapeHtml(cl.transcript_text)}</div>${summaryContentHtml}
                </div>`;
        }

        return `
            <div class="list-group-item">
                <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                            <span class="badge badge-channel-phone">telefono</span>
                            <span>${dirIcon}</span>
                            ${duration}
                            <span class="badge bg-light text-dark">${this._escapeHtml(cl.outcome || '-')}</span>
                        </div>
                        ${cl.notes ? `<div class="small text-secondary mt-1">${this._escapeHtml(cl.notes)}</div>` : ''}
                        ${audioHtml}
                        ${transcriptHtml}
                    </div>
                    <small class="text-muted text-nowrap ms-3">${this.formatDate(cl.contact_date)}</small>
                </div>
            </div>`;
    },

    // Recupero chiamate dal centralino (API by-phone) per la lead corrente
    async syncLeadCalls(leadId) {
        const btn = document.getElementById('pbx-sync-btn');
        if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>Recupero...'; }
        const restore = '<i class="fa-solid fa-phone-volume me-1"></i>Recupera chiamate';
        try {
            const r = await this.api(`/leads/api/${leadId}/pbx-sync`, { method: 'POST' });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            const parts = [];
            if (r.imported) parts.push(`${r.imported} nuove`);
            if (r.updated) parts.push(`${r.updated} aggiornate`);
            this.toast(parts.length ? `Chiamate: ${parts.join(', ')}` : 'Nessuna chiamata nuova dal centralino', parts.length ? 'success' : 'info');
            if (parts.length) {
                this._loadTimeline(leadId);
                if (this.loadLeadCallsAndTranscriptions) this.loadLeadCallsAndTranscriptions(leadId);
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        } finally {
            if (btn) { btn.disabled = false; btn.innerHTML = restore; }
        }
    },

    async _loadTimeline(leadId) {
        const container = document.getElementById('lead-timeline');
        if (!container) return;
        try {
            const data = await this.api(`/leads/api/${leadId}/timeline`);
            const events = data.events || [];
            if (!events.length) {
                container.innerHTML = '<div class="text-center py-5 text-muted"><i class="fa-solid fa-inbox fa-2x mb-2 d-block"></i>Nessuna comunicazione registrata</div>';
                return;
            }
            container.innerHTML = events.map(ev => this._renderTimelineEvent(ev)).join('');
            if (this._initVoicePlayers) this._initVoicePlayers(container);

            // All'apertura della lead salta alla tab del canale con la
            // comunicazione più recente (solo una volta per page load)
            if (!this._autoTabDone) {
                this._autoTabDone = true;
                const tabByType = { email: '#comms-pane', sms: '#comms-pane', whatsapp: '#whatsapp-pane', phone: '#calls-pane', call: '#calls-pane' };
                const latest = events.find(ev => tabByType[ev.type]);
                if (latest && window.bootstrap) {
                    const btn = document.querySelector(`#leadTabs [data-bs-target="${tabByType[latest.type]}"]`);
                    if (btn) new bootstrap.Tab(btn).show();
                }
            }
        } catch (e) {
            container.innerHTML = `<div class="p-3 text-danger">Errore caricamento timeline: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    // ── Lead Files ────────────────────────────────────────────────────────────

    // L'icona la decide l'estensione, non il mime: i formati Office hanno mime
    // quasi identici (un .docx e un .xlsx cominciano entrambi per
    // "application/vnd.openxmlformats") e un Word finiva con l'icona di Excel.
    _FILE_ICONS: [
        [['pdf'], 'fa-file-pdf text-danger'],
        [['doc', 'docx', 'odt', 'rtf'], 'fa-file-word text-primary'],
        [['xls', 'xlsx', 'ods', 'csv'], 'fa-file-excel text-success'],
        [['ppt', 'pptx', 'odp'], 'fa-file-powerpoint text-warning'],
        [['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'heic'], 'fa-file-image text-info'],
        [['zip', 'rar', '7z', 'tar', 'gz'], 'fa-file-zipper text-secondary'],
        [['mp3', 'wav', 'm4a', 'ogg', 'aac'], 'fa-file-audio text-info'],
        [['mp4', 'mov', 'avi', 'mkv', 'webm'], 'fa-file-video text-info'],
        [['json', 'xml', 'yml', 'yaml', 'html', 'js', 'py', 'sql'], 'fa-file-code text-secondary'],
        [['txt', 'md', 'log'], 'fa-file-lines text-secondary'],
        [['eml', 'msg'], 'fa-envelope text-warning'],
    ],

    _fileIcon(f) {
        if (f.is_eml) return 'fa-envelope text-warning';
        const ext = (f.filename || '').split('.').pop().toLowerCase();
        for (const [exts, icon] of this._FILE_ICONS) {
            if (exts.includes(ext)) return icon;
        }
        // Senza estensione riconoscibile resta il mime, meglio di niente
        const mime = f.mime_type || '';
        if (mime.startsWith('image/')) return 'fa-file-image text-info';
        if (mime.startsWith('audio/')) return 'fa-file-audio text-info';
        if (mime.startsWith('video/')) return 'fa-file-video text-info';
        if (mime.startsWith('text/')) return 'fa-file-lines text-secondary';
        if (mime === 'application/pdf') return 'fa-file-pdf text-danger';
        return 'fa-file text-muted';
    },

    async loadLeadFiles(leadId) {
        if (!leadId) return;
        this._currentLeadIdForFiles = leadId;
        try {
            const files = await this.api(`/leads/api/${leadId}/files`);
            const container = document.getElementById('lead-files-list');
            const countEl = document.getElementById('files-count');
            if (countEl) countEl.textContent = files.length;
            if (!container) return;

            if (!files.length) {
                container.innerHTML = '<div class="text-center py-4 text-muted"><i class="fa-solid fa-folder-open fa-2x mb-2 d-block"></i>Nessun file caricato</div>';
            } else {
                container.innerHTML = '<div class="list-group list-group-flush">' + files.map(f => {
                    const icon = this._fileIcon(f);
                    const size = f.file_size > 1048576
                        ? `${(f.file_size/1048576).toFixed(1)} MB`
                        : `${Math.round(f.file_size/1024)} KB`;
                    const rowClass = f.is_eml ? 'list-group-item-warning' : '';
                    const cursorAttr = f.is_eml ? `style="cursor:pointer" onclick="SyrusApp.showEmlPreview('${leadId}','${f.id}')"` : '';
                    const aiBadge = f.is_eml
                        ? '<span class="badge bg-warning text-dark ms-2" title="I file .eml non vengono utilizzati per AI Lead Intelligence o generazione documenti — le info sono già state estratte all\'import"><i class="fa-solid fa-circle-info me-1"></i>non usato per AI</span>'
                        : '';
                    const isPdf = (f.mime_type || '') === 'application/pdf';
                    const isImage = (f.mime_type || '').startsWith('image/');
                    const canPreview = isPdf || isImage;
                    let previewBtn = '';
                    if (f.is_eml) {
                        previewBtn = `<button class="btn btn-sm btn-outline-warning" onclick="event.stopPropagation();SyrusApp.showEmlPreview('${leadId}','${f.id}')" title="Anteprima email"><i class="fa-solid fa-eye"></i></button>`;
                    } else if (canPreview) {
                        previewBtn = `<button class="btn btn-sm btn-outline-secondary" onclick="event.stopPropagation();SyrusApp.showFilePreview('${leadId}','${f.id}','${this._escapeHtml(f.filename)}','${isPdf?'pdf':'image'}')" title="Anteprima"><i class="fa-solid fa-eye"></i></button>`;
                    }
                    return `<div class="list-group-item d-flex align-items-center ${rowClass}" ${cursorAttr}>
                        <i class="fa-solid ${icon} fa-lg me-3"></i>
                        <div class="flex-grow-1">
                            <div class="fw-medium">${this._escapeHtml(f.filename)}${aiBadge}</div>
                            <small class="text-muted">${size} &middot; ${this.formatDate(f.created_at)}${f.uploaded_by ? ` &middot; ${this._escapeHtml(f.uploaded_by)}` : ''}</small>
                        </div>
                        <div class="d-flex gap-1" onclick="event.stopPropagation()">
                            ${previewBtn}
                            <a href="/leads/api/${leadId}/files/${f.id}/download" download="${this._escapeHtml(f.filename)}" class="btn btn-sm btn-outline-primary" title="Scarica"><i class="fa-solid fa-download"></i></a>
                            <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteLeadFile('${leadId}','${f.id}')" title="Elimina"><i class="fa-solid fa-trash"></i></button>
                        </div>
                    </div>`;
                }).join('') + '</div>';
            }

            // Setup drag & drop
            this._setupFileDropzone(leadId);
        } catch (e) { /* silent */ }
    },

    _setupFileDropzone(leadId) {
        const zone = document.getElementById('file-dropzone');
        const input = document.getElementById('file-upload-input');
        if (!zone || !input) return;

        zone.onclick = () => input.click();
        input.onchange = () => { if (input.files.length) this._uploadLeadFiles(leadId, input.files); };

        zone.ondragover = (e) => { e.preventDefault(); zone.classList.add('bg-light'); };
        zone.ondragleave = () => zone.classList.remove('bg-light');
        zone.ondrop = (e) => {
            e.preventDefault();
            zone.classList.remove('bg-light');
            if (e.dataTransfer.files.length) this._uploadLeadFiles(leadId, e.dataTransfer.files);
        };
    },

    async _uploadLeadFiles(leadId, fileList) {
        const progress = document.getElementById('file-upload-progress');
        if (progress) progress.classList.remove('d-none');

        const fd = new FormData();
        for (const f of fileList) fd.append('files', f);

        try {
            const resp = await SyrusApp.fetchWithCsrf(`/leads/api/${leadId}/files/upload`, {
                method: 'POST',
                body: fd,
            });
            const data = await resp.json();
            if (!resp.ok) throw new Error(data.error || 'Upload fallito');
            this.toast(`${data.files.length} file caricati`);
            this.loadLeadFiles(leadId);
        } catch (e) {
            this.toast(e.message, 'danger');
        } finally {
            if (progress) progress.classList.add('d-none');
            const input = document.getElementById('file-upload-input');
            if (input) input.value = '';
        }
    },

    showFilePreview(leadId, fileId, filename, type) {
        // Rimuovi modale precedente se esiste
        const old = document.getElementById('file-preview-modal');
        if (old) old.remove();

        const url = `/leads/api/${leadId}/files/${fileId}/preview`;
        const spinner = `<div id="file-preview-spinner" class="text-center py-5"><span class="spinner-border text-primary"></span><p class="text-muted mt-2">Recupero file da Google Drive...</p></div>`;
        let content;
        if (type === 'pdf') {
            content = `<iframe src="${url}" style="width:100%;height:80vh;border:none;display:none" onload="this.style.display='block';document.getElementById('file-preview-spinner')?.remove()"></iframe>`;
        } else {
            content = `<img src="${url}" style="max-width:100%;max-height:80vh;display:none" class="d-block mx-auto" onload="this.style.display='block';document.getElementById('file-preview-spinner')?.remove()">`;
        }

        const modal = document.createElement('div');
        modal.id = 'file-preview-modal';
        modal.className = 'modal fade';
        modal.setAttribute('tabindex', '-1');
        modal.innerHTML = `<div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header py-2">
                    <h6 class="modal-title">${this._escapeHtml(filename)}</h6>
                    <div class="d-flex gap-2 align-items-center">
                        <a href="/leads/api/${leadId}/files/${fileId}/download" download class="btn btn-sm btn-outline-primary" title="Scarica"><i class="fa-solid fa-download"></i></a>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                </div>
                <div class="modal-body p-0">${spinner}${content}</div>
            </div>
        </div>`;
        document.body.appendChild(modal);
        const bsModal = new bootstrap.Modal(modal);
        modal.addEventListener('hidden.bs.modal', () => modal.remove());
        bsModal.show();
    },

    async deleteLeadFile(leadId, fileId) {
        if (!confirm('Eliminare questo file?')) return;
        try {
            await this.api(`/leads/api/${leadId}/files/${fileId}`, {method:'DELETE'});
            this.toast('File eliminato');
            this.loadLeadFiles(leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async showLeadContext(leadId, mode = 'intelligence') {
        const escape = (s) => this._escapeHtml(s || '');
        try {
            this.toast('Costruzione contesto AI...', 'info');
            const data = await this.api(`/leads/api/${leadId}/context-preview?mode=${mode}`);

            // Coverage badge color
            const cov = data.completeness?.coverage ?? 0;
            const covColor = cov >= 75 ? 'success' : cov >= 50 ? 'warning' : 'danger';

            const meta = data.metadata || {};
            const stats = data.completeness?.stats || {};

            // Header con KPI
            const headerHtml = `
                <div class="row g-2 mb-3">
                    <div class="col-md-3">
                        <div class="border rounded p-2 text-center bg-light">
                            <div class="fs-4 fw-bold text-${covColor}">${cov}<small class="fs-6 text-muted">/100</small></div>
                            <small class="text-muted">Completezza contesto</small>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="row g-2 h-100">
                            <div class="col"><div class="border rounded p-2 text-center"><div class="fw-bold">${(meta.total_chars || 0).toLocaleString('it-IT')}</div><small class="text-muted">char</small></div></div>
                            <div class="col"><div class="border rounded p-2 text-center"><div class="fw-bold">${stats.files_with_text || 0}<small>/${stats.files_total || 0}</small></div><small class="text-muted">file (testo)</small></div></div>
                            <div class="col"><div class="border rounded p-2 text-center"><div class="fw-bold">${stats.transcriptions || 0}</div><small class="text-muted">trascrizioni</small></div></div>
                            <div class="col"><div class="border rounded p-2 text-center"><div class="fw-bold">${(stats.emails_30d || 0) + (stats.sms_30d || 0)}</div><small class="text-muted">comm 30gg</small></div></div>
                            <div class="col"><div class="border rounded p-2 text-center"><div class="fw-bold">${stats.documents || 0}</div><small class="text-muted">doc AI</small></div></div>
                        </div>
                    </div>
                </div>`;

            // Cosa manca
            const missingItems = data.completeness?.missing || [];
            const suggestions = data.completeness?.suggestions || [];
            const missingHtml = (missingItems.length || suggestions.length) ? `
                <div class="alert alert-warning py-2 mb-3">
                    <div class="fw-bold mb-1"><i class="fa-solid fa-triangle-exclamation me-1"></i>Cosa manca / Suggerimenti</div>
                    ${missingItems.length ? '<ul class="mb-' + (suggestions.length ? '2' : '0') + ' small">' +
                        missingItems.map(m => `<li><strong>${escape(m.label)}</strong> <span class="text-muted">— ${escape(m.why)}</span></li>`).join('') +
                        '</ul>' : ''}
                    ${suggestions.length ? '<ul class="mb-0 small text-primary">' +
                        suggestions.map(s => `<li><i class="fa-solid fa-lightbulb me-1"></i>${escape(s)}</li>`).join('') +
                        '</ul>' : ''}
                </div>` : `<div class="alert alert-success py-2 mb-3"><i class="fa-solid fa-circle-check me-1"></i>Contesto completo, nessun campo critico mancante</div>`;

            // Sezioni collassabili
            const sectionsHtml = (data.sections || []).map((s, i) => {
                const collapsed = i > 1 ? '' : 'show';  // prime 2 aperte
                const id = `ctx-section-${i}`;
                const charCount = s.content.length;
                return `<div class="card mb-2">
                    <div class="card-header py-2 d-flex justify-content-between align-items-center" data-bs-toggle="collapse" data-bs-target="#${id}" style="cursor:pointer">
                        <div class="fw-bold small"><i class="fa-solid fa-chevron-right me-2"></i>${escape(s.title)}</div>
                        <small class="text-muted">${charCount.toLocaleString('it-IT')} char</small>
                    </div>
                    <div id="${id}" class="collapse ${collapsed}">
                        <pre class="p-3 mb-0 small bg-light" style="white-space:pre-wrap;max-height:300px;overflow:auto">${escape(s.content)}</pre>
                    </div>
                </div>`;
            }).join('');

            // Tabs Intelligence vs Document
            const tabsHtml = `
                <ul class="nav nav-pills mb-3" role="tablist">
                    <li class="nav-item">
                        <button class="nav-link ${mode === 'intelligence' ? 'active' : ''}" onclick="SyrusApp.showLeadContext('${leadId}','intelligence')">
                            <i class="fa-solid fa-brain me-1"></i>Modalità Lead Intelligence
                        </button>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link ${mode === 'document' ? 'active' : ''}" onclick="SyrusApp.showLeadContext('${leadId}','document')">
                            <i class="fa-solid fa-file-pen me-1"></i>Modalità Generazione Documenti
                        </button>
                    </li>
                </ul>`;

            const modalHtml = `<div class="modal fade" id="leadContextModal" tabindex="-1">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header bg-primary bg-opacity-10">
                            <h5 class="modal-title"><i class="fa-solid fa-eye me-2"></i>Contesto AI della Lead — cosa "vede" l'intelligenza artificiale</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            ${tabsHtml}
                            ${headerHtml}
                            ${missingHtml}
                            <h6 class="fw-bold mt-3 mb-2"><i class="fa-solid fa-list me-1"></i>Sezioni del contesto</h6>
                            ${sectionsHtml || '<div class="text-muted">Nessuna sezione</div>'}
                        </div>
                        <div class="modal-footer">
                            <small class="text-muted me-auto"><i class="fa-solid fa-circle-info me-1"></i>Anteprima gratis: nessuna chiamata AI fatta. Questo è esattamente ciò che riceve l'AI come prompt.</small>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
                        </div>
                    </div>
                </div>
            </div>`;
            // Cleanup eventuale modal precedente (es. switch tab Intelligence/Document)
            const old = document.getElementById('leadContextModal');
            if (old) {
                const inst = bootstrap.Modal.getInstance(old);
                if (inst) inst.dispose();
                old.remove();
            }
            // Rimuovi backdrop residui e classi modal-open lasciate da chiusure precedenti
            document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');

            document.body.insertAdjacentHTML('beforeend', modalHtml);
            const modalEl = document.getElementById('leadContextModal');
            const modal = new bootstrap.Modal(modalEl);
            modalEl.addEventListener('hidden.bs.modal', () => {
                modal.dispose();
                modalEl.remove();
                document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('padding-right');
            }, { once: true });
            modal.show();
        } catch (e) {
            this.toast('Errore caricamento contesto: ' + e.message, 'danger');
        }
    },

    async showEmlPreview(leadId, fileId) {
        this._showModal('Anteprima Email .eml', '<div class="text-center py-5"><span class="spinner-border text-primary"></span><p class="text-muted mt-2">Recupero file da Google Drive...</p></div>');
        try {
            const data = await this.api(`/leads/api/${leadId}/files/${fileId}/eml-preview`);
            const escape = (s) => this._escapeHtml(s || '');
            const attHtml = (data.attachments || []).length
                ? '<ul class="mb-0 small">' + data.attachments.map(a =>
                    `<li><i class="fa-solid fa-paperclip me-1"></i>${escape(a.filename)} <span class="text-muted">(${Math.round((a.size||0)/1024)} KB, ${escape(a.mime_type)})</span></li>`
                  ).join('') + '</ul>'
                : '<span class="text-muted small">Nessun allegato</span>';
            const bodyHtml = data.body
                ? `<pre class="bg-light p-3 small mb-0" style="white-space:pre-wrap;max-height:400px;overflow:auto">${escape(data.body)}</pre>`
                : '<div class="text-muted small fst-italic">Corpo email vuoto</div>';
            // Update the same modal content
            this._showModal('<i class="fa-solid fa-envelope me-2"></i>Anteprima Email .eml', `
                <div class="mb-2"><strong>Da:</strong> ${escape(data.sender_name)} &lt;${escape(data.sender_email)}&gt;</div>
                <div class="mb-2"><strong>Data:</strong> ${escape(data.date)}</div>
                <div class="mb-3"><strong>Oggetto:</strong> ${escape(data.subject)}</div>
                <hr>
                <div class="mb-3"><strong class="d-block mb-1">Corpo:</strong>${bodyHtml}</div>
                <div><strong class="d-block mb-1">Allegati:</strong>${attHtml}</div>`);
        } catch (e) {
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.toast('Errore preview .eml: ' + e.message, 'danger');
        }
    },

    async importEmlMerge(leadId) {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.eml';
        input.onchange = async () => {
            if (!input.files.length) return;
            const fd = new FormData();
            fd.append('file', input.files[0]);
            try {
                this.toast('Analisi email in corso...', 'info');
                const resp = await SyrusApp.fetchWithCsrf(`/leads/api/${leadId}/import-eml-merge`, {
                    method: 'POST',
                    body: fd,
                });
                const data = await resp.json();
                if (!resp.ok) throw new Error(data.error || 'Import fallito');
                const fields = data.fields_updated || [];
                const msg = `Email importata. ${data.attachments_saved} allegati salvati. ` +
                            (fields.length ? `Campi aggiornati: ${fields.join(', ')}.` : 'Nessun nuovo campo (solo append a note).');
                this.toast(msg, 'success');
                this.loadLeadFiles(leadId);
                if (this.loadLeadDetail) this.loadLeadDetail(leadId);
            } catch (e) {
                this.toast(e.message, 'danger');
            }
        };
        input.click();
    },

    _extractPhoneFromAudioUrl(url) {
        if (!url) return '';
        // Formato: .../20260205-123340_in_messagenet-syrus_393XXXXXXXXX.wav
        const parts = url.split('/').pop().replace('.wav','').replace('.mp3','').split('_');
        for (const p of parts) {
            if (/^3[0-9]{8,12}$/.test(p)) return '+' + p;
        }
        return '';
    },

    /** Colonna data/ora condivisa (timeline, email, telefonate):
     *  oggi → orario grande + "Oggi" sotto; ieri → "Ieri" grande + orario sotto;
     *  prima di ieri → "22 lug" grande + orario sotto. */
    _tlWhenHtml(dateIso) {
        const d = this.parseDate(dateIso);
        if (!d) return '<div class="call-log-when"></div>';
        const now = new Date();
        const time = d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
        const full = `${d.toLocaleDateString('it-IT')} ${d.toLocaleTimeString('it-IT')}`;
        const yest = new Date(now); yest.setDate(now.getDate() - 1);
        let primary, secondary, isDate = false;
        if (d.toDateString() === now.toDateString()) {
            primary = time; secondary = 'Oggi';
        } else if (d.toDateString() === yest.toDateString()) {
            primary = 'Ieri'; secondary = time; isDate = true;
        } else {
            primary = d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
            if (d.getFullYear() !== now.getFullYear()) primary += ` '${String(d.getFullYear()).slice(-2)}`;
            secondary = time; isDate = true;
        }
        return `<div class="call-log-when" title="${full}"><div class="call-log-hhmm${isDate ? ' is-date' : ''}">${primary}</div><div class="call-log-day-inline">${secondary}</div></div>`;
    },

    /** Anteprima testuale trimmata da un corpo HTML (per righe email). */
    _stripHtmlPreview(html, maxLen) {
        if (!html) return '';
        const tmp = document.createElement('div');
        tmp.innerHTML = html.replace(/<(style|script)[^>]*>[\s\S]*?<\/\1>/gi, ' ');
        const txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        return txt.length > maxLen ? txt.slice(0, maxLen) + '…' : txt;
    },

    // Righe timeline: stesso stile delle tab Email/Telefonate, con icona
    // tonda del canale (chiamata, email, whatsapp, sms, riunione)
    _renderTimelineEvent(ev) {
        const esc = (s) => this._escapeHtml(s || '');
        const when = this._tlWhenHtml(ev.date);
        const emailStatus = { sent: 'Inviata', delivered: 'Consegnata', opened: 'Aperta', clicked: 'Cliccata', failed: 'Fallita', bounced: 'Bounce', received: 'Ricevuta' };

        const row = (ico, icoClass, content, right, clickAttr = '') =>
            `<div class="call-log-item${clickAttr ? ' comm-item' : ''}" ${clickAttr}>
                ${when}
                <div class="comm-ico ${icoClass}"><i class="${ico}"></i></div>
                <div class="flex-grow-1" style="min-width:0">${content}</div>
                <div class="flex-shrink-0 text-end">${right || ''}</div>
            </div>`;

        // ── Email ───────────────────────────────────────────────────────
        if (ev.type === 'email') {
            const m = ev.metadata || {};
            if (m.email_id) {
                const isInbound = ev.direction === 'inbound';
                // Apertura "fredda": aperta, ultima apertura > 24h fa, mai risposta
                const staleBadge = !isInbound && SyrusApp._emailOpenStale(m)
                    ? ' <span class="badge badge-priority-hot ms-1"><i class="fa-solid fa-triangle-exclamation me-1"></i>Apertura +24h</span>' : '';
                const chipStatus = isInbound ? 'received' : (m.status || 'sent');
                const opens = !isInbound && (m.open_count || 0) > 0 ? `<div class="comm-to mt-1">${m.open_count}&times; aperta</div>` : '';
                const bodyPrev = this._stripHtmlPreview(m.body_html, 140);
                return row('fa-solid fa-envelope', 'email',
                    `<div class="comm-subject">${esc(m.subject || '(senza oggetto)')}${staleBadge}</div>
                     ${bodyPrev ? `<div class="comm-preview">${esc(bodyPrev)}</div>` : ''}
                     <div class="comm-to">${isInbound ? 'Da' : 'A'}: ${esc(isInbound ? (m.from || '-') : (m.to || '-'))}</div>`,
                    `<span class="comm-status ${chipStatus}">${emailStatus[chipStatus] || chipStatus}</span>${opens}`,
                    `onclick="SyrusApp.showEmailPreview('${m.email_id}')" title="Apri dettaglio email"`);
            }
            // Email importata (ContactLog da SyrusX)
            const bodyTxt = ev.body ? esc(ev.body.substring(0, 120)) + (ev.body.length > 120 ? '…' : '') : '(senza dettagli)';
            return row('fa-solid fa-envelope', 'email',
                `<div class="comm-subject">Email importata</div>
                 <div class="comm-preview">${bodyTxt}</div>`,
                '<span class="comm-status sent">Importata</span>',
                `onclick="SyrusApp.showContactLogEmailPreview('${m.contact_log_id}')" title="Apri anteprima"`);
        }

        // ── SMS ─────────────────────────────────────────────────────────
        if (ev.type === 'sms') {
            const m = ev.metadata || {};
            const chip = emailStatus[m.status] || m.status || '';
            return row('fa-solid fa-comment-sms', 'sms',
                `<div class="comm-subject">SMS</div>
                 ${ev.body ? `<div class="comm-preview">${esc(ev.body)}</div>` : ''}
                 <div class="comm-to">A: ${esc(m.to || '-')}</div>`,
                chip ? `<span class="comm-status ${m.status || 'sent'}">${esc(chip)}</span>` : '');
        }

        // ── WhatsApp ────────────────────────────────────────────────────
        if (ev.type === 'whatsapp') {
            const m = ev.metadata || {};
            const isIn = ev.direction === 'inbound';
            const ticks = ev.outcome === 'read' ? '<i class="fa-solid fa-check-double" style="color:#53bdeb" title="Letto"></i>'
                : ev.outcome === 'delivered' ? '<i class="fa-solid fa-check-double text-muted" title="Consegnato"></i>'
                : ev.outcome === 'sent' ? '<i class="fa-solid fa-check text-muted" title="Inviato"></i>' : '';
            const clickAttr = m.pnid && m.wa_id
                ? `onclick="SyrusApp._goToWaChat('${this._escapeAttr(m.pnid)}','${this._escapeAttr(m.wa_id)}')" title="Apri chat WhatsApp"`
                : '';
            return row('fa-brands fa-whatsapp', 'whatsapp',
                `<div class="comm-subject">${isIn ? 'Messaggio ricevuto' : 'Messaggio inviato'}${m.msg_type === 'template' ? ' <span class="badge bg-light text-dark ms-1">template</span>' : ''}</div>
                 ${ev.body ? `<div class="comm-preview">${esc(ev.body)}</div>` : ''}`,
                ticks, clickAttr);
        }

        // ── Trascrizione standalone (riunione/audio caricato) ───────────
        if (ev.type === 'transcription') {
            const t = ev.transcription || {};
            let actions = '';
            if (t.id && t.status === 'completed') {
                actions = `<div class="btn-group btn-group-sm mt-1">
                    <button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.dgShowTranscript('${t.id}')" title="Leggi trascrizione"><i class="fa-solid fa-file-lines"></i></button>
                    <button class="btn btn-sm ${t.has_summary ? 'btn-success' : 'btn-outline-secondary'}" onclick="SyrusApp.dgSummarize('${t.id}')" title="${t.has_summary ? 'Vedi il riepilogo AI' : 'Genera il riepilogo AI'}">${this._aiSparkleSvg(14)}</button>
                </div>`;
            }
            const sub = [t.speakers ? `${t.speakers} speaker` : '', ev.duration || ''].filter(Boolean).join(' · ');
            return row('fa-solid fa-microphone-lines', 'meeting',
                `<div class="comm-subject">${esc(ev.body || 'Trascrizione')}</div>
                 ${sub ? `<div class="comm-to">${sub}</div>` : ''}`,
                `${t.has_summary ? '<span class="badge bg-info">Analizzato</span>' : ''}${actions}`);
        }

        // ── Telefonata — stesso stile del tab Telefonate ────────────────
        const isInbound = ev.direction === 'inbound';
        const isAnswered = ev.outcome === 'reached';
        const missed = !isAnswered;
        const icoClass = missed ? 'call-missed' : (isInbound ? 'call-in' : 'call-out');
        const ico = missed ? 'fa-solid fa-phone-slash' : (isInbound ? 'fa-solid fa-phone-flip' : 'fa-solid fa-phone');
        const arrow = isInbound
            ? '<i class="fa-solid fa-arrow-down call-arrow in"></i>'
            : '<i class="fa-solid fa-arrow-up call-arrow out"></i>';

        const t = ev.transcription;
        let trBadges = '';
        let trActions = '';
        let transcriptHtml = '';
        let audioPlayerHtml = '';
        if (t && isAnswered) {
            if (t.status === 'processing') trBadges += '<span class="badge bg-warning text-dark me-1">In elaborazione</span>';
            if (t.has_summary) trBadges += '<span class="badge bg-info me-1">Analizzato</span>';
            if (t.id && t.status === 'completed') {
                transcriptHtml = `<button type="button" class="sy-voice-trbtn" data-trid="${t.id}" onclick="SyrusApp.callToggleTranscript(this)">
                        <i class="fa-solid fa-closed-captioning"></i> Mostra trascrizione
                    </button>
                    <div class="sy-voice-transcript" hidden></div>`;
                trActions = `<button type="button" class="btn-ai-sparkle${t.has_summary ? ' has-ai' : ''}" onclick="SyrusApp.dgSummarize('${t.id}', false, this)" title="Riepilogo AI" data-ai-hint-title="Riepilogo AI" data-ai-hint="${t.has_summary ? 'Riapre il riepilogo gia\u0027 generato per questa registrazione.' : 'Legge la trascrizione e ne ricava un riepilogo: punti toccati, impegni presi e prossimi passi.'}">${this._aiSparkleSvg(16)}</button>`;
            }
        }
        if (isAnswered && ev.audio_url) {
            audioPlayerHtml = `<div class="sy-voice">
                <audio preload="metadata" src="${ev.audio_url}"></audio>
                <button type="button" class="sy-voice-play" title="Riproduci"><i class="fa-solid fa-play"></i></button>
                <div class="sy-voice-track"><div class="sy-voice-fill"></div><div class="sy-voice-knob"></div></div>
                <span class="sy-voice-clock">--:-- / --:--</span>
                <button type="button" class="sy-voice-speed" title="Velocità">1×</button>
            </div>`;
        }

        return row(ico, icoClass,
            `<div class="comm-subject">${arrow} ${isInbound ? 'In entrata' : 'In uscita'}${missed ? ' · <span style="color:#d9534f">Senza risposta</span>' : ''}</div>
             ${ev.phone_number ? `<div class="comm-to fw-bold" style="color:#1B3A5C">${esc(ev.phone_number)}</div>` : ''}
             ${trBadges ? `<div class="mt-1">${trBadges}</div>` : ''}
             ${audioPlayerHtml}
             ${transcriptHtml}`,
            trActions);
    },

    // ── Duplicate detection ────────────────────────────────────────────────

    async _checkDuplicates(leadId) {
        const btn = document.getElementById('duplicate-alert-btn');
        if (!btn) return;
        try {
            const resp = await this.api(`/leads/api/${leadId}/duplicates`);
            if (resp.duplicates && resp.duplicates.length > 0) {
                this._duplicateData = resp.duplicates;
                btn.classList.remove('d-none');
                btn.onclick = () => this._showDuplicateAlert();
            } else {
                btn.classList.add('d-none');
                this._duplicateData = null;
            }
        } catch (e) {
            btn.classList.add('d-none');
        }
    },

    _showDuplicateAlert() {
        const dupes = this._duplicateData;
        if (!dupes || !dupes.length) return;

        const STATUS_LABELS = {
            new: 'Nuova', contacted: 'Contattata', qualified: 'Qualificata',
            proposal_sent: 'Proposta inviata', negotiation: 'Negoziazione',
            won: 'Vinta', lost: 'Persa', dormant: 'Dormiente', spam: 'Spam'
        };

        let rows = dupes.map(d => {
            const reasons = d.match_reasons.join(', ');
            const status = STATUS_LABELS[d.status] || d.status;
            const created = d.created_at ? this.parseDate(d.created_at).toLocaleDateString('it-IT') : '—';
            return `
                <div class="border rounded-3 p-3 mb-2 d-flex align-items-center justify-content-between">
                    <div>
                        <strong>${this._escapeHtml(d.crm_id)}</strong> — ${this._escapeHtml(d.company_name || d.contact_name || '—')}
                        <div class="small text-muted mt-1">
                            <span class="badge bg-secondary me-1">${status}</span>
                            Match: <strong>${reasons}</strong> · Creata il ${created}
                        </div>
                    </div>
                    <a href="/leads/${d.id}" class="btn btn-outline-primary btn-sm">
                        <i class="fa-solid fa-arrow-up-right-from-square me-1"></i>Apri
                    </a>
                </div>`;
        }).join('');

        const html = `
            <div class="modal fade" id="duplicateModal" tabindex="-1">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header bg-warning text-dark">
                            <h5 class="modal-title"><i class="fa-solid fa-triangle-exclamation me-2"></i>Contatto già presente</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <p class="mb-3">Questo contatto è già associato a ${dupes.length === 1 ? "un'altra lead" : 'altre lead'}:</p>
                            ${rows}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Chiudi</button>
                        </div>
                    </div>
                </div>
            </div>`;

        let existing = document.getElementById('duplicateModal');
        if (existing) existing.remove();
        document.body.insertAdjacentHTML('beforeend', html);
        new bootstrap.Modal(document.getElementById('duplicateModal')).show();
    },

    // ── Quick Fix (dirty title / contact name) ─────────────────────────────

    _quickFixData: null,

    async _checkQuickFix(leadId) {
        const btn = document.getElementById('quick-fix-btn');
        if (!btn) return;
        try {
            const resp = await this.api(`/leads/api/${leadId}/quick-fix`);
            if (resp.show) {
                this._quickFixData = resp.suggestions;
                btn.classList.remove('d-none');
            } else {
                btn.classList.add('d-none');
                this._quickFixData = null;
            }
        } catch (e) {
            btn.classList.add('d-none');
        }
    },

    showQuickFix(leadId) {
        const s = this._quickFixData;
        if (!s) return;

        let rows = '';
        if (s.company_name) {
            rows += `
                <div class="border rounded-3 p-3 mb-3">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="qf-company" checked>
                        <label class="form-check-label fw-bold" for="qf-company">Titolo Lead</label>
                    </div>
                    <div class="small text-muted mb-1">Attuale: <span class="text-danger text-decoration-line-through">${this._escapeHtml(s.company_name.current || '(vuoto)')}</span></div>
                    <input type="text" class="form-control form-control-sm" id="qf-company-val" value="${this._escapeAttr(s.company_name.suggested)}" placeholder="Es. Software gestionale, Sito web, Consulenza Ads...">
                </div>`;
        }
        if (s.project_type) {
            rows += `
                <div class="border rounded-3 p-3 mb-3">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="qf-project" checked>
                        <label class="form-check-label fw-bold" for="qf-project">Tipo Progetto</label>
                    </div>
                    <div class="small text-muted mb-1">Attuale: <span class="text-danger text-decoration-line-through">${this._escapeHtml(s.project_type.current || '(vuoto)')}</span></div>
                    <input type="text" class="form-control form-control-sm" id="qf-project-val" value="${this._escapeAttr(s.project_type.suggested)}" placeholder="Es. Sito web, Software gestionale, Consulenza Ads...">
                </div>`;
        }
        if (s.contact_name) {
            rows += `
                <div class="border rounded-3 p-3 mb-3">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="qf-contact" checked>
                        <label class="form-check-label fw-bold" for="qf-contact">Nome Contatto</label>
                    </div>
                    <div class="small text-muted mb-1">Attuale: <span class="text-danger text-decoration-line-through">${this._escapeHtml(s.contact_name.current || '(vuoto)')}</span></div>
                    <input type="text" class="form-control form-control-sm" id="qf-contact-val" value="${this._escapeAttr(s.contact_name.suggested)}" placeholder="Inserisci nome contatto">
                </div>`;
        }
        if (s.contact_email) {
            rows += `
                <div class="border rounded-3 p-3 mb-3">
                    <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" id="qf-email" checked>
                        <label class="form-check-label fw-bold" for="qf-email">Email Contatto</label>
                    </div>
                    <div class="small text-muted mb-1">Attuale: <span class="text-danger text-decoration-line-through">${this._escapeHtml(s.contact_email.current || '(vuoto)')}</span></div>
                    <input type="email" class="form-control form-control-sm" id="qf-email-val" value="${this._escapeAttr(s.contact_email.suggested)}" placeholder="email@esempio.com">
                </div>`;
        }

        this._showModal('Quick Fix — Correzione Dati Lead', `
            <div class="mb-3">
                <div class="alert alert-info py-2 small mb-3">
                    <i class="fa-solid fa-circle-info me-1"></i>
                    Suggerimenti basati sui dati già disponibili (analisi AI, trascrizioni). Puoi modificare i valori prima di applicare.
                </div>
                ${rows}
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-success flex-grow-1" onclick="SyrusApp._applyQuickFix('${leadId}')">
                    <i class="fa-solid fa-check me-1"></i>Applica Selezionati
                </button>
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Annulla</button>
            </div>`);
    },

    async _applyQuickFix(leadId) {
        const payload = {};
        if (document.getElementById('qf-company')?.checked) {
            const val = document.getElementById('qf-company-val')?.value?.trim();
            if (val) payload.company_name = val;
        }
        if (document.getElementById('qf-project')?.checked) {
            const val = document.getElementById('qf-project-val')?.value?.trim();
            if (val) payload.project_type = val;
        }
        if (document.getElementById('qf-contact')?.checked) {
            const val = document.getElementById('qf-contact-val')?.value?.trim();
            if (val) payload.contact_name = val;
        }
        if (document.getElementById('qf-email')?.checked) {
            const val = document.getElementById('qf-email-val')?.value?.trim();
            if (val) payload.contact_email = val;
        }
        if (!Object.keys(payload).length) {
            this.toast('Nessuna modifica selezionata', 'warning');
            return;
        }
        try {
            await this.api(`/leads/api/${leadId}/quick-fix`, {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.toast('Lead corretta!', 'success');
            const btn = document.getElementById('quick-fix-btn');
            if (btn) btn.classList.add('d-none');
            this._quickFixData = null;
            location.reload();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // ── Quick Status Change (negotiation → won/lost/dormant) ───────────────

    async quickStatusChange(leadId, newStatus) {
        const labels = {won: 'Won (Vinto)', lost: 'Lost (Perso)', dormant: 'Dormant (Sospeso)'};
        const label = labels[newStatus] || newStatus;
        if (newStatus === 'lost') {
            this._showModal('Motivo della perdita', `
                <form onsubmit="SyrusApp._confirmQuickStatus(event,'${leadId}','${newStatus}')">
                    <div class="mb-3"><label class="form-label">Perché hai perso questa lead?</label>
                    <textarea id="modal-lost-reason" class="form-control" rows="3" placeholder="Es. prezzo troppo alto, ha scelto un competitor, progetto annullato..."></textarea></div>
                    <button type="submit" class="btn btn-danger">Conferma Lost</button>
                </form>`);
        } else {
            if (!confirm(`Confermi di voler cambiare lo status a ${label}?`)) return;
            try {
                await this.api(`/leads/api/${leadId}/status`, {
                    method: 'PUT',
                    body: JSON.stringify({ status: newStatus })
                });
                this.toast(`Status aggiornato a ${label}`, 'success');
                location.reload();
            } catch (e) { this.toast(e.message, 'danger'); }
        }
    },

    async _confirmQuickStatus(event, leadId, newStatus) {
        event.preventDefault();
        const notes = document.getElementById('modal-lost-reason')?.value || '';
        try {
            await this.api(`/leads/api/${leadId}/status`, {
                method: 'PUT',
                body: JSON.stringify({ status: newStatus, notes })
            });
            this.toast('Status aggiornato a Lost', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            location.reload();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Status Change Modal ─────────────────────────────────────────────────

    showStatusModal(leadId, currentStatus) {
        const transitions = {
            new: ['contacted','proposal_sent','qualified','lost','spam'],
            contacted: ['qualified','proposal_sent','lost','dormant','spam'],
            qualified: ['proposal_sent','negotiation','lost','dormant'],
            proposal_sent: ['negotiation','won','lost','dormant'],
            negotiation: ['won','lost','dormant'],
            won: ['dormant'],
            lost: ['new','contacted'],
            dormant: ['new','contacted'],
            spam: [],
        };
        const allowed = transitions[currentStatus] || [];
        let options = allowed.map(s =>
            `<option value="${s}">${this._statusLabels[s] || s}</option>`).join('');

        // Override admin: consente di forzare "Vinto" anche quando la transizione
        // standard non lo prevede (es. proposta mai inviata).
        const canForceWon = window.SYRUS?.isAdmin && currentStatus !== 'won' && !allowed.includes('won');
        if (canForceWon) {
            options += `<option value="won" data-force="1">${this._statusLabels.won || 'Vinto'} (forzato)</option>`;
        }

        this._showModal('Cambia Status', `
            <form onsubmit="SyrusApp.changeStatus(event, '${leadId}')">
                <div class="mb-3"><label class="form-label">Nuovo Status</label>
                    <select id="modal-new-status" class="form-select" required onchange="SyrusApp._toggleWonWarning()">${options}</select></div>
                <div id="modal-won-warning" class="alert alert-warning d-none py-2 px-3 small">
                    <i class="fa-solid fa-triangle-exclamation me-1"></i>
                    Stai impostando <strong>Vinto</strong> senza che sia stata inviata una proposta.
                    Operazione riservata agli admin: assicurati che l'accordo sia reale.
                </div>
                <div class="mb-3"><label class="form-label">Note</label><textarea id="modal-status-notes" class="form-control" rows="3"></textarea></div>
                <button type="submit" class="btn btn-primary">Conferma</button>
            </form>`);
        this._toggleWonWarning();
    },

    _toggleWonWarning() {
        const sel = document.getElementById('modal-new-status');
        const warn = document.getElementById('modal-won-warning');
        if (!sel || !warn) return;
        const opt = sel.options[sel.selectedIndex];
        warn.classList.toggle('d-none', !(opt && opt.dataset.force === '1'));
    },

    async changeStatus(event, leadId) {
        event.preventDefault();
        try {
            await this.api(`/leads/api/${leadId}/status`, {
                method: 'PUT',
                body: JSON.stringify({
                    status: document.getElementById('modal-new-status').value,
                    notes: document.getElementById('modal-status-notes').value,
                })
            });
            const newStatus = document.getElementById('modal-new-status').value;
            this.toast('Status aggiornato');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            // Aggiorna la riga nella tabella senza ricaricare la pagina
            const row = document.querySelector(`tr[data-lead-id="${leadId}"]`);
            if (row) {
                const badge = row.querySelector('[class*="badge-status-"]');
                if (badge) {
                    badge.className = `badge badge-status-${newStatus}`;
                    badge.textContent = (this._statusLabels[newStatus] || newStatus).toUpperCase();
                }
                // Aggiorna il link "Cambia Status" con il nuovo status corrente
                const statusLink = row.querySelector('a[onclick*="showStatusModal"]');
                if (statusLink) {
                    statusLink.setAttribute('onclick', `SyrusApp.showStatusModal('${leadId}','${newStatus}');return false`);
                }
            } else {
                // Fallback: se siamo nel dettaglio lead, ricarica
                location.reload();
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Rubrica sidebar (card sotto Azioni Rapide) ──────────────────────────
    _renderRubricaSidebar(contacts) {
        const el = document.getElementById('rubrica-sidebar');
        if (!el) return;
        contacts = contacts || [];
        if (contacts.length === 0) {
            el.innerHTML = '<div class="text-muted small text-center py-2">Nessun contatto in rubrica</div>';
            return;
        }
        el.innerHTML = contacts.map((c, i) => {
            const num = c.mobile || c.phone;
            return `<div class="d-flex align-items-start gap-2 py-2 ${i < contacts.length - 1 ? 'border-bottom' : ''}">
                <div class="flex-grow-1" style="min-width:0">
                    <div class="fw-bold" style="font-size:13px">${this._escapeHtml(c.name || '')}${c.is_primary ? ' <i class="fa-solid fa-star text-warning" style="font-size:10px" title="Primario"></i>' : ''}${c.is_decision_maker ? ' <i class="fa-solid fa-key text-info" style="font-size:10px" title="Decision Maker"></i>' : ''}</div>
                    ${c.role ? `<div class="text-muted" style="font-size:11px">${this._escapeHtml(c.role)}</div>` : ''}
                    ${(num || c.email) ? `<div class="d-flex align-items-center column-gap-3 flex-wrap" style="font-size:12px">
                        ${num ? `<span class="text-nowrap"><i class="fa-solid fa-${c.mobile ? 'mobile' : 'phone'} text-muted me-1"></i>${this._escapeHtml(num)}</span>` : ''}
                        ${c.email ? `<span class="text-truncate" style="min-width:0"><i class="fa-solid fa-envelope text-muted me-1"></i><a href="mailto:${this._escapeAttr(c.email)}">${this._escapeHtml(c.email)}</a></span>` : ''}
                    </div>` : ''}
                </div>
                <div class="dropdown flex-shrink-0">
                    <button class="btn btn-sm btn-link text-muted p-0 px-1" data-bs-toggle="dropdown" title="Azioni"><i class="fa-solid fa-ellipsis-vertical"></i></button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li><a class="dropdown-item" href="#" onclick="SyrusApp.showEditContactModal('${c.id}');return false"><i class="fa-solid fa-pencil me-2 text-muted"></i>Modifica</a></li>
                        ${num ? `<li><a class="dropdown-item" href="#" onclick="SyrusApp.wpQuickCall('${this._escapeAttr(num)}');return false"><i class="fa-solid fa-phone me-2 text-muted"></i>Chiama</a></li>` : ''}
                        ${c.email ? `<li><a class="dropdown-item" href="#" data-email="${this._escapeAttr(c.email)}" onclick="SyrusApp.showSendEmailModal(SyrusApp._currentLeadId, this.dataset.email);return false"><i class="fa-solid fa-envelope me-2 text-muted"></i>Invia Email</a></li>` : ''}
                        ${num ? `<li><a class="dropdown-item" href="#" data-num="${this._escapeAttr(num)}" data-name="${this._escapeAttr(c.name || '')}" data-email="${this._escapeAttr(c.email || '')}" onclick="SyrusApp.showSendWhatsappModal(SyrusApp._currentLeadId, this.dataset.num, {name: this.dataset.name, email: this.dataset.email});return false"><i class="fa-brands fa-whatsapp me-2 text-muted"></i>Invia WhatsApp</a></li>` : ''}
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item text-danger" href="#" onclick="SyrusApp.deleteContact('${c.id}');return false"><i class="fa-solid fa-trash me-2"></i>Rimuovi</a></li>
                    </ul>
                </div>
            </div>`;
        }).join('');
    },

    async deleteContact(contactId) {
        if (!confirm('Rimuovere questo contatto dalla rubrica?')) return;
        try {
            await this.api(`/contacts/api/${contactId}/delete`, { method: 'DELETE' });
            this.toast('Contatto rimosso');
            location.reload();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    /**
     * "+" della card a tab in sidebar (Rubrica | Campagne): un pulsante solo,
     * che apre la modale del tab che stai guardando.
     */
    aggiungiDaTabLaterale(leadId) {
        if (document.querySelector('#campagne-pane.active')) {
            this.showAddToCampaignModal([leadId]);
        } else {
            this.showAddContactModal(leadId);
        }
    },

    // ── Contact Modals ──────────────────────────────────────────────────────
    showAddContactModal(leadId) {
        this._showModal('Aggiungi Contatto', `
            <form onsubmit="SyrusApp.addContact(event, '${leadId}')">
                <div class="row g-2">
                    <div class="col-6 mb-2"><label class="form-label">Nome *</label><input name="name" class="form-control" required></div>
                    <div class="col-6 mb-2"><label class="form-label">Ruolo</label><input name="role" class="form-control"></div>
                    <div class="col-6 mb-2"><label class="form-label">Email</label><input name="email" type="email" class="form-control"></div>
                    <div class="col-6 mb-2"><label class="form-label">Telefono</label><input name="phone" class="form-control"></div>
                    <div class="col-6 mb-2"><label class="form-label">Mobile</label><input name="mobile" class="form-control"></div>
                    <div class="col-6 mb-2"><label class="form-label">LinkedIn</label><input name="linkedin" class="form-control"></div>
                    <div class="col-12 mb-2"><div class="form-check"><input type="checkbox" name="is_primary" class="form-check-input"><label class="form-check-label">Primario</label></div></div>
                    <div class="col-12 mb-2"><div class="form-check"><input type="checkbox" name="is_decision_maker" class="form-check-input"><label class="form-check-label">Decision Maker</label></div></div>
                </div>
                <button type="submit" class="btn btn-primary mt-2">Salva</button>
            </form>`);
    },

    async addContact(event, leadId) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        data.lead_id = leadId;
        data.is_primary = !!data.is_primary;
        data.is_decision_maker = !!data.is_decision_maker;
        try {
            await this.api('/contacts/api/create', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Contatto aggiunto');
            location.reload();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Edit Contact Modal ─────────────────────────────────────────────────
    async showEditContactModal(contactId) {
        try {
            // Contact data is already cached from loadLeadDetail
            const c = (this._cachedContacts || []).find(x => x.id === contactId);
            if (!c) { this.toast('Contatto non trovato', 'danger'); return; }

            this._showModal('Modifica Contatto', `
                <form onsubmit="SyrusApp.updateContact(event, '${contactId}')">
                    <div class="row g-2">
                        <div class="col-6 mb-2"><label class="form-label">Nome *</label><input name="name" class="form-control" value="${this._escapeHtml(c.name || '')}" required></div>
                        <div class="col-6 mb-2"><label class="form-label">Ruolo</label><input name="role" class="form-control" value="${this._escapeHtml(c.role || '')}"></div>
                        <div class="col-6 mb-2"><label class="form-label">Email</label><input name="email" type="email" class="form-control" value="${this._escapeHtml(c.email || '')}"></div>
                        <div class="col-6 mb-2"><label class="form-label">Telefono</label><input name="phone" class="form-control" value="${this._escapeHtml(c.phone || '')}"></div>
                        <div class="col-6 mb-2"><label class="form-label">Mobile</label><input name="mobile" class="form-control" value="${this._escapeHtml(c.mobile || '')}"></div>
                        <div class="col-6 mb-2"><label class="form-label">LinkedIn</label><input name="linkedin" class="form-control" value="${this._escapeHtml(c.linkedin || '')}"></div>
                        <div class="col-12 mb-2"><div class="form-check"><input type="checkbox" name="is_primary" class="form-check-input" ${c.is_primary ? 'checked' : ''}><label class="form-check-label">Primario</label></div></div>
                        <div class="col-12 mb-2"><div class="form-check"><input type="checkbox" name="is_decision_maker" class="form-check-input" ${c.is_decision_maker ? 'checked' : ''}><label class="form-check-label">Decision Maker</label></div></div>
                    </div>
                    <button type="submit" class="btn btn-primary mt-2">Salva</button>
                </form>`);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async updateContact(event, contactId) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        data.is_primary = !!data.is_primary;
        data.is_decision_maker = !!data.is_decision_maker;
        try {
            await this.api(`/contacts/api/${contactId}/update`, { method: 'PUT', body: JSON.stringify(data) });
            this.toast('Contatto aggiornato');
            location.reload();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Log Contact Modal ───────────────────────────────────────────────────
    showLogContactModal(leadId) {
        this._showModal('Registra Attività', `
            <form onsubmit="SyrusApp.logContact(event, '${leadId}')">
                <div class="row g-2">
                    <div class="col-12 mb-2">
                        <label class="form-label fw-bold">Tipo attività</label>
                        <select name="activity_type" class="form-select" required>
                            <option value="phone:inbound">📞 Telefonata Ricevuta</option>
                            <option value="phone:outbound">📞 Telefonata Effettuata</option>
                            <option value="meeting">🤝 Meeting</option>
                            <option value="video_call">🎥 Video Call</option>
                        </select>
                    </div>
                    <div class="col-12 mb-2">
                        <label class="form-label fw-bold">Note / Appunti *</label>
                        <textarea name="notes" class="form-control" rows="6" required minlength="20" placeholder="Scrivi gli appunti dell'attività..."></textarea>
                    </div>
                    <div class="col-12 mb-2">
                        <label class="form-label">Registrazione (audio o video) <span class="text-muted small">— opzionale</span></label>
                        <input name="recording" type="file" id="log-contact-recording" class="form-control" accept="audio/*,video/*">
                        <small class="text-muted"><i class="fa-solid fa-circle-info me-1"></i>Se carichi un file, partiranno in automatico trascrizione e sintesi AI in background, e troverai tutto nelle Trascrizioni della lead.</small>
                    </div>
                    <div class="col-md-7 mb-2">
                        <label class="form-label">Prossima azione</label>
                        <input name="next_action" class="form-control" placeholder="Es. Inviare offerta">
                    </div>
                    <div class="col-md-5 mb-2">
                        <label class="form-label">Data prossima azione</label>
                        <input name="next_action_date" type="date" class="form-control">
                    </div>
                </div>
                <button type="submit" class="btn btn-primary mt-2"><i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>
            </form>`);
    },

    async logContact(event, leadId) {
        event.preventDefault();
        const form = event.target;
        const fileInput = form.querySelector('#log-contact-recording');
        const file = (fileInput && fileInput.files && fileInput.files[0]) || null;

        const fd = new FormData(form);
        const data = Object.fromEntries(fd.entries());
        delete data.recording;  // non lo inviamo come field log-contact

        // Mappa activity_type → channel + direction (back-compat con backend)
        const at = data.activity_type || 'phone:outbound';
        delete data.activity_type;
        if (at.includes(':')) {
            const [ch, dir] = at.split(':');
            data.channel = ch;
            data.direction = dir;
        } else {
            data.channel = at;
            data.direction = 'outbound';
        }

        try {
            // Se c'è una registrazione: prima upload+finalize per ottenere transcript_id,
            // poi salva contact log linkato, poi trascrivi+sintetizza in background
            if (file) {
                this.toast('Caricamento registrazione in corso...', 'info');
                const transcriptId = await this._uploadActivityRecording(file, leadId);
                if (transcriptId) {
                    data.transcript_id = transcriptId;
                }
                // Salva contact log con transcript_id
                await this.api(`/leads/api/${leadId}/log-contact`, {
                    method: 'POST', body: JSON.stringify(data),
                });
                this.toast('Attività registrata. Trascrizione e sintesi AI in corso in background.', 'success');
                // Chiudi modal e avvia transcribe+summarize SENZA reload, così il widget ops resta visibile
                bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
                if (transcriptId) {
                    this._startActivityTranscribeAndSummarize(transcriptId);
                }
                // Reload tra qualche secondo per far apparire il contact log nella timeline
                setTimeout(() => location.reload(), 1500);
            } else {
                // Nessun file: flow originale
                await this.api(`/leads/api/${leadId}/log-contact`, {
                    method: 'POST', body: JSON.stringify(data),
                });
                this.toast('Attività registrata');
                location.reload();
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    /**
     * Carica un file audio/video con upload chunked riusando gli endpoint
     * deepgram esistenti. Lo lega alla lead. Restituisce il transcript_id.
     */
    async _uploadActivityRecording(file, leadId) {
        const CHUNK_SIZE = (this.CHUNK_SIZE || 5 * 1024 * 1024);
        const sizeMB = (file.size / 1024 / 1024).toFixed(1);
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

        // Track in widget operazioni
        const opId = 'activity-upload-' + Date.now();
        if (this.trackUpload) this.trackUpload(opId, `Upload registrazione: ${file.name}`);
        if (this.updateOpProgress) this.updateOpProgress(opId, 0, `0 / ${sizeMB} MB`);

        try {
            // Step 1: init
            const init = await this.api('/deepgram/api/upload/init', {
                method: 'POST',
                body: JSON.stringify({ filename: file.name, file_size: file.size }),
            });
            if (!init.ok) throw new Error(init.error || 'Init upload fallito');
            const serverId = init.upload_id;

            // Step 2: chunks
            for (let i = 0; i < totalChunks; i++) {
                const start = i * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, file.size);
                const blob = file.slice(start, end);
                const fd = new FormData();
                fd.append('upload_id', serverId);
                fd.append('chunk_index', i);
                fd.append('chunk', blob);
                const resp = await SyrusApp.fetchWithCsrf('/deepgram/api/upload/chunk', {
                    method: 'POST', body: fd,
                });
                if (!resp.ok) throw new Error(`Chunk ${i} failed: HTTP ${resp.status}`);
                const pct = Math.round(((i + 1) / totalChunks) * 100);
                const sentMB = (end / 1024 / 1024).toFixed(1);
                if (this.updateOpProgress) this.updateOpProgress(opId, pct, `${sentMB} / ${sizeMB} MB`);
            }

            // Step 3: finalize con lead_id già linkata
            if (this.updateOpProgress) this.updateOpProgress(opId, 100, 'Assemblaggio...');
            const result = await this.api('/deepgram/api/upload/finalize', {
                method: 'POST',
                body: JSON.stringify({ upload_id: serverId, lead_id: leadId }),
            });
            if (!result.ok) throw new Error(result.error || 'Finalize fallito');

            if (this.completeOp) this.completeOp(opId, true, result.is_video ? 'Video → audio convertito' : 'Caricato');
            return result.id;
        } catch (e) {
            if (this.completeOp) this.completeOp(opId, false, e.message);
            throw e;
        }
    },

    /**
     * Avvia trascrizione Deepgram + sintesi AI in background per il
     * transcript_id appena creato. Mostra progresso nel widget ops.
     */
    async _startActivityTranscribeAndSummarize(transcriptId) {
        // Riusa la funzione esistente del modulo deepgram
        try {
            if (!this.dgTranscribe) return;
            // dgTranscribe risolve a trascrizione conclusa: il riepilogo AI
            // lavora sul testo, se parte prima il job fallisce "trascrizione vuota".
            const esito = await this.dgTranscribe(transcriptId);
            if (esito === 'completed' && this._dgStartSummarize) {
                this._dgStartSummarize(transcriptId);
            }
        } catch (e) {
            this.toast('Errore avvio trascrizione: ' + e.message, 'danger');
        }
    },

    // ── Analyze Lead AI ─────────────────────────────────────────────────────

    async analyzeLeadAI(leadId) {
        this.toast('Analisi AI in corso...', 'info');
        try {
            const result = await this.api(`/leads/api/${leadId}`, { method: 'GET' });
            this.toast('Analisi completata', 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadAiHistory(leadId) {
        // Legacy — AI history was in old "AI & Documenti" tab.
        // Now handled by loadAiIntelligence in ai-intel module.
        const el = document.getElementById('ai-history');
        const resultsEl = document.getElementById('ai-results');
        if (!el) return; // New template doesn't have this element
        if (!el) return;
        try {
            const analyses = await this.api(`/ai/api/lead/${leadId}/analyses`);
            if (!analyses.length) {
                el.innerHTML = '<p class="text-muted small">Nessuna analisi AI disponibile per questo lead.</p>';
                return;
            }

            if (resultsEl && !resultsEl.innerHTML.trim()) {
                const a = analyses[0];
                if (a.lead_score || a.recommended_action) {
                    resultsEl.innerHTML = `
                    <div class="card border-primary mb-3">
                        <div class="card-header bg-primary text-white py-2"><i class="fa-solid fa-brain me-2"></i>Lead Scoring AI ${a.model_used ? `<span class="badge bg-light text-primary ms-2">${this._escapeHtml(a.model_used)}</span>` : ''}<small class="float-end opacity-75">${this.formatDate(a.created_at)}</small></div>
                        <div class="card-body">
                            <div class="row g-3">
                                <div class="col-6 col-md-3 text-center">
                                    <div class="fs-2 fw-bold text-primary">${a.lead_score || '?'}</div>
                                    <small class="text-muted">Score /100</small>
                                </div>
                                <div class="col-6 col-md-3 text-center">
                                    <div class="fs-4">${a.sentiment_label === 'positive' ? '\u{1F60A}' : a.sentiment_label === 'negative' ? '\u{1F61F}' : '\u{1F610}'}</div>
                                    <small class="text-muted">${this._escapeHtml(a.sentiment_label || '?')}</small>
                                </div>
                                <div class="col-6 col-md-3 text-center">
                                    <div class="fw-bold">${this._escapeHtml(a.budget_estimated || '?')}</div>
                                    <small class="text-muted">Budget stimato</small>
                                </div>
                                <div class="col-6 col-md-3 text-center">
                                    <div class="fw-bold">${this._escapeHtml(a.timeline_detected || '?')}</div>
                                    <small class="text-muted">Timeline</small>
                                </div>
                            </div>
                            ${a.pain_points ? `<div class="mt-3"><strong class="small">Pain Points:</strong><p class="small mb-1">${this._escapeHtml(a.pain_points)}</p></div>` : ''}
                            ${a.objections_detected ? `<div class="mt-1"><strong class="small">Obiezioni:</strong><p class="small mb-1">${this._escapeHtml(a.objections_detected)}</p></div>` : ''}
                            ${a.recommended_action ? `<div class="mt-2 p-2 rounded" style="background:var(--color-brand-light)"><strong class="small text-primary">Azione raccomandata:</strong><p class="small mb-0">${this._escapeHtml(a.recommended_action)}</p></div>` : ''}
                        </div>
                    </div>`;
                }
            }

            if (analyses.length > 1) {
                el.innerHTML = `<p class="small fw-bold text-muted mb-2">Storico analisi (${analyses.length})</p>` + analyses.slice(1).map(a => `
                    <div class="card mb-2">
                        <div class="card-body py-2 px-3 d-flex justify-content-between align-items-center">
                            <div>
                                <span class="badge bg-secondary me-2">${this._escapeHtml(a.model_used || '')}</span>
                                <span class="small">${this._escapeHtml(a.project_type_detected || 'Analisi')}</span>
                                ${a.lead_score ? `<span class="badge bg-success ms-2">Score: ${a.lead_score}</span>` : ''}
                            </div>
                            <small class="text-muted">${this.formatDate(a.created_at)}</small>
                        </div>
                    </div>`).join('');
            } else {
                el.innerHTML = '';
            }
        } catch (e) { /* silent */ }
    },
});


// ── app-analysis.js ──
/** Syrus Sales OS – Workflow Analisi (tab Analisi nella scheda lead) */
Object.assign(SyrusApp, {

    _analysisData: null,

    async loadAnalysis(leadId, opts = {}) {
        try {
            const data = await this.api(`/leads/api/${leadId}/analysis`);
            this._analysisData = { ...data, leadId };
            this._renderAnalysisBadge(data.analysis);
            if (!opts.badgeOnly) this._renderAnalysis();
        } catch (e) {
            const box = document.getElementById('analysis-container');
            if (box && !opts.badgeOnly) box.innerHTML = `<div class="alert alert-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    // Terzo elemento: icona che sostituisce l'etichetta quando la parola
    // aggiunge poco — "documento generato" è già detto dalla spunta
    _ANALYSIS_STATUS: {
        draft: ['Bozza', 'bg-secondary'],
        extracting: ['Estrazione…', 'bg-info'],
        extracted: ['Da inviare', 'bg-primary'],
        in_review: ['In approvazione', 'bg-warning text-dark'],
        changes_requested: ['Da rivedere', 'bg-danger'],
        approved: ['Approvata', 'bg-success'],
        generated: ['Documento generato', 'bg-success', 'fa-circle-check'],
    },

    /** Badge di stato: icona sola dove prevista, testo altrimenti. */
    _analysisStatusBadge(status, extraCls = '') {
        const [label, cls, icon] = this._ANALYSIS_STATUS[status] || [status, 'bg-secondary'];
        // Badge di sola icona: compatto, non deve pesare come un'etichetta
        const inner = icon ? `<i class="fa-solid ${icon}"></i>` : this._escapeHtml(label);
        const iconCls = icon ? ' badge-icon' : '';
        return `<span class="badge ${cls}${iconCls} ${extraCls}" title="${this._escapeAttr(label)}">${inner}</span>`;
    },

    _renderAnalysisBadge(analysis) {
        const badge = document.getElementById('analysis-status-badge');
        if (!badge) return;
        if (!analysis) { badge.style.display = 'none'; return; }
        const [label, cls, icon] = this._ANALYSIS_STATUS[analysis.status] || [analysis.status, 'bg-secondary'];
        badge.className = `badge ms-1 ${cls}${icon ? ' badge-icon' : ''}`;
        badge.title = label;
        if (icon) badge.innerHTML = `<i class="fa-solid ${icon}"></i>`;
        else badge.textContent = label;
        badge.style.display = 'inline-block';
    },

    /** Documento su cui agiscono scheda, voci e note: l'analisi del tab,
     *  oppure l'offerta mentre la sua modale è aperta. Stessa forma dei dati
     *  perché l'offerta è a tutti gli effetti un LeadAnalysis con doc_kind
     *  diverso, quindi gli endpoint sono gli stessi. */
    _docCtx() {
        return (this._offerEditing && this._offerData) ? this._offerData : this._analysisData;
    },

    _docRender() {
        if (this._offerEditing && this._offerData) this._renderOfferModalBody();
        else this._renderAnalysis();
    },

    _kindMeta(kind) {
        return {
            module: ['Modulo', 'fa-cube', '#2E75B6'],
            timeline: ['Tempistica', 'fa-clock', '#7C3AED'],
            price: ['Importo', 'fa-euro-sign', '#059669'],
            excluded: ['Fuori scope', 'fa-ban', '#DC2626'],
            other: ['Info', 'fa-circle-info', '#64748B'],
        }[kind] || ['Info', 'fa-circle-info', '#64748B'];
    },

    _n(n, sing, plur) { return `${n} ${n === 1 ? sing : plur}`; },

    /** Chip di cosa l'AI ha letto: più parlanti del solo peso in caratteri. */
    _analysisSourceChips(meta) {
        if (!meta) return '';
        const chips = [];
        const add = (cond, icon, text) => { if (cond) chips.push([icon, text]); };
        add(meta.emails, 'fa-regular fa-envelope', this._n(meta.emails, 'email', 'email'));
        add(meta.whatsapp, 'fa-brands fa-whatsapp', this._n(meta.whatsapp, 'messaggio WhatsApp', 'messaggi WhatsApp'));
        add(meta.transcriptions, 'fa-solid fa-microphone-lines', this._n(meta.transcriptions, 'registrazione', 'registrazioni'));
        add(meta.files, 'fa-solid fa-paperclip', this._n(meta.files, 'file allegato', 'file allegati'));
        add(meta.approved_docs, 'fa-solid fa-file-circle-check', this._n(meta.approved_docs, 'documento approvato', 'documenti approvati'));
        add(meta.contacts, 'fa-regular fa-address-card', this._n(meta.contacts, 'contatto', 'contatti'));
        add(meta.has_ai_brief, 'fa-solid fa-brain', 'Profilo AI della lead');
        add(meta.has_pricelist, 'fa-solid fa-tags', 'Listino Syrus');
        if (!chips.length) {
            return `<span class="as-chip as-chip-empty"><i class="fa-solid fa-circle-exclamation"></i>
                Solo i dati della scheda lead</span>`;
        }
        return chips.map(([icon, text]) =>
            `<span class="as-chip"><i class="${icon}"></i>${this._escapeHtml(text)}</span>`).join('');
    },

    /** Card che spiega da dove viene l'analisi e ne raccoglie le azioni. */
    _analysisSourceCard(analysis, leadId, o) {
        const startEv = (analysis.events || []).find(
            e => e.action === (o.fromContext ? 'context_selected' : 'uploaded'));
        const who = analysis.created_by_name || (startEv && startEv.actor) || '—';
        const when = (startEv && startEv.created_at) || analysis.created_at;
        const chars = analysis.source_context_chars;

        let icon, title, sub;
        if (o.fromContext) {
            icon = 'fa-solid fa-wand-magic-sparkles';
            title = 'Analisi redatta dall\'AI';
            sub = 'Nessun documento caricato: l\'AI ha letto il materiale della lead e ha scritto la scheda.';
        } else {
            const fname = (analysis.source_file && analysis.source_file.name) || '';
            icon = /\.pdf$/i.test(fname) ? 'fa-solid fa-file-pdf'
                : /\.docx?$/i.test(fname) ? 'fa-solid fa-file-word' : 'fa-solid fa-file-lines';
            // download="" è obbligatorio: senza, il router SPA intercetta il
            // click in capture e annulla la navigazione (vedi _initSpaRouter)
            title = analysis.source_file
                ? `<a href="/leads/api/${leadId}/files/${analysis.source_file.id}/download"
                      download="${this._escapeAttr(fname)}"
                      title="Scarica il documento">${this._escapeHtml(fname)}</a>`
                : 'Documento non disponibile';
            sub = 'Documento caricato sulla lead e destrutturato dall\'AI nella scheda qui sotto.';
        }

        // I chip hanno senso solo per la stesura dal contesto: per il documento
        // la fonte è una sola ed è già il titolo. Senza conteggi (analisi
        // anteriori alla loro introduzione) si salta la riga invece di
        // mostrarne una vuota
        const chipsHtml = o.fromContext && o.hasContent && analysis.source_meta
            ? `<div class="as-chips-label">Che cosa ha letto</div>
               <div class="as-chips">${this._analysisSourceChips(analysis.source_meta)}</div>` : '';

        const instrHtml = analysis.ai_instructions
            ? `<div class="as-chips-label">Istruzioni che hai dato</div>
               <div class="small fst-italic text-secondary">“${this._escapeHtml(analysis.ai_instructions)}”</div>` : '';

        const actions = [];
        if (o.hasContent) {
            actions.push(`<button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.analysisOpenModal()">
                <i class="fa-regular fa-eye me-1"></i>Apri l'analisi</button>`);
        }
        if (o.fromContext && chars) {
            actions.push(`<button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.analysisShowContext()"
                    title="Vedi esattamente il materiale passato all'AI">
                <i class="fa-solid fa-magnifying-glass me-1"></i>Vedi il contesto</button>`);
        }
        if (o.canRemove) {
            actions.push(`<button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.analysisArchive()"
                    title="${o.fromContext ? 'Annulla questa analisi' : 'Rimuovi il documento e annulla l\'analisi'}">
                <i class="fa-solid fa-trash"></i></button>`);
        }

        return `<div class="analysis-source">
            <div class="as-icon"><i class="${icon}"></i></div>
            <div class="as-body">
                <div class="as-head">
                    <div>
                        <div class="as-title">${title}</div>
                        <div class="as-sub">${sub}</div>
                    </div>
                    ${this._analysisStatusBadge(o.status)}
                </div>
                ${chipsHtml}
                ${instrHtml}
                <div class="as-foot">
                    <span><i class="fa-regular fa-user me-1"></i>${this._escapeHtml(who)}
                        <span class="mx-1">·</span>${when ? this.formatDate(when) : '—'}
                        ${o.fromContext && chars ? `<span class="mx-1">·</span>${
                            (chars / 1000).toFixed(0)}k caratteri di contesto` : ''}</span>
                    <div class="as-actions">${actions.join('')}</div>
                </div>
            </div>
        </div>`;
    },

    _renderAnalysis() {
        const box = document.getElementById('analysis-container');
        if (!box) return;
        const { analysis, is_approver, me, leadId } = this._analysisData;

        if (this._analysisPollTimer) { clearTimeout(this._analysisPollTimer); this._analysisPollTimer = null; }
        if (!analysis) {
            this._analysisWasExtracting = false;
            const emptyFab = document.getElementById('analysis-fab');
            if (emptyFab) emptyFab.innerHTML = '';
            this._renderAnalysisEmpty(box, leadId);
            return;
        }

        // Analisi redatta dal contesto CRM invece che da un documento caricato:
        // cambiano solo la riga sorgente e il verbo dei pulsanti, non il flusso
        const fromContext = analysis.source_kind === 'context';
        // Dopo un rimando la palla è del proponente: l'approvatore resta in sola lettura
        const waitingOther = is_approver && analysis.status === 'changes_requested';
        const canEdit = ['extracted', 'changes_requested', 'in_review'].includes(analysis.status) && !waitingOther;
        const canSubmit = ['extracted', 'changes_requested'].includes(analysis.status);
        // L'approvatore può decidere anche senza submit formale; dopo un
        // rimando la palla è del proponente finché non re-invia
        const canReview = is_approver && ['in_review', 'extracted'].includes(analysis.status);
        const canGenerate = ['approved', 'generated'].includes(analysis.status);
        // Nuovo documento consentito quando l'analisi è stata "risposta"
        // (approvata/generata, o rimandata MA solo per il proponente) —
        // oppure all'approvatore in revisione; altrimenti solo rimozione manuale
        const canNewDoc = ['approved', 'generated'].includes(analysis.status)
            || (analysis.status === 'changes_requested' && !is_approver)
            || (is_approver && analysis.status === 'in_review');
        const canRemove = !['approved', 'generated', 'changes_requested'].includes(analysis.status);

        let html = `
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
                <h6 class="fw-bold mb-1"><i class="fa-solid fa-clipboard-check me-2"></i>Analisi</h6>
                <div class="d-flex gap-2 flex-wrap">
                    ${analysis.status === 'draft' ? `
                        <button class="btn btn-sm btn-primary" onclick="SyrusApp.analysisExtract()">
                            <i class="fa-solid fa-wand-magic-sparkles me-1"></i>${fromContext ? 'Redigi con AI' : 'Estrai con AI'}</button>` : ''}
                    ${canEdit && analysis.status !== 'draft' ? `
                        <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.analysisExtract(true)"
                                title="${fromContext ? 'Rilegge il contesto della lead e riscrive le voci AI (quelle aggiunte a mano restano)'
                                                     : 'Ripete l\'estrazione AI dal documento (le voci aggiunte a mano restano)'}">
                            <i class="fa-solid fa-rotate me-1"></i>${fromContext ? 'Ri-redigi' : 'Ri-estrai'}</button>` : ''}
                    ${canSubmit ? `
                        <button class="btn btn-sm btn-primary" onclick="SyrusApp.analysisSubmit()">
                            <i class="fa-solid fa-paper-plane me-1"></i>Invia in approvazione</button>` : ''}
                    ${canGenerate ? `
                        <button class="btn btn-sm btn-success" onclick="SyrusApp.analysisGenerate()">
                            <i class="fa-solid fa-file-word me-1"></i>${analysis.generated_file ? 'Rigenera documento' : 'Genera documento'}</button>` : ''}
                    ${canNewDoc ? `
                        <button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.analysisRestart()"
                                title="Riparte da zero: nuovo documento oppure stesura dal contesto della lead (questa viene archiviata alla creazione della nuova)">
                            <i class="fa-solid fa-file-circle-plus me-1"></i>Nuova analisi</button>` : ''}
                </div>
            </div>`;

        // Card "da dove viene questa analisi": una riga di tabella non diceva
        // cosa fosse successo, la card lo racconta e porta le azioni
        const hasContent = !['draft', 'extracting'].includes(analysis.status);
        html += this._analysisSourceCard(analysis, leadId, {
            hasContent, canRemove, status: analysis.status, fromContext });

        // "E adesso?": senza questa riga il passaggio successivo non si capisce,
        // soprattutto per chi è anche approvatore e vede tutti i pulsanti insieme
        if (analysis.status === 'extracted' || analysis.status === 'changes_requested') {
            const appr = analysis.approver_email || '';
            const meIsAppr = appr && appr.toLowerCase() === (this._analysisData.me_email || '').toLowerCase();
            html += `<div class="alert alert-light border d-flex align-items-start gap-2 py-2 px-3">
                <i class="fa-solid fa-circle-info text-primary mt-1"></i>
                <div class="small">
                    <b>Prossimo passo.</b> Rivedi le voci, poi
                    <b>Invia in approvazione</b>: parte un'email a
                    <b>${this._escapeHtml(appr || 'l\'approvatore')}</b> con il link alla scheda.
                    ${meIsAppr ? 'L\'approvatore sei tu, quindi puoi anche approvarla direttamente da qui, senza inviarla.' : ''}
                    Il documento Word si genera solo dopo l'approvazione.
                </div>
            </div>`;
        }

        if (analysis.status === 'in_review') {
            html += canReview ? `
                <div class="alert alert-warning d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div><i class="fa-solid fa-hourglass-half me-2"></i><b>In attesa della tua approvazione.</b>
                        Puoi modificare le voci, poi decidi.</div>
                    <div class="d-flex gap-2">
                        <button class="btn btn-sm btn-success" onclick="SyrusApp.analysisReview('approve')">
                            <i class="fa-solid fa-check me-1"></i>Approva</button>
                        <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.analysisReview('request_changes')">
                            <i class="fa-solid fa-rotate-left me-1"></i>Rimanda con note</button>
                    </div>
                </div>` : `
                <div class="alert alert-info"><i class="fa-solid fa-hourglass-half me-2"></i>
                    In attesa di approvazione da <b>${this._escapeHtml(analysis.approver_email)}</b>.</div>`;
        }
        if (analysis.status === 'changes_requested') {
            const lastCr = [...(analysis.events || [])].reverse().find(e => e.action === 'changes_requested');
            html += is_approver
                ? `<div class="alert alert-info"><i class="fa-solid fa-hourglass-half me-2"></i>
                    <b>Hai rimandato l'analisi con note</b>${lastCr && lastCr.notes ? `: <span class="fst-italic">"${this._escapeHtml(lastCr.notes)}"</span>` : ''}.
                    Ora la palla è di chi gestisce la lead: riceverai una nuova email quando re-invier&agrave; in approvazione.</div>`
                : `<div class="alert alert-danger"><i class="fa-solid fa-rotate-left me-2"></i>
                    <b>Modifiche richieste</b>${lastCr && lastCr.notes ? `: ${this._escapeHtml(lastCr.notes)}` : ''}.
                    Correggi e re-invia in approvazione.</div>`;
        }
        if (analysis.generated_file) {
            html += `<div class="alert alert-success d-flex justify-content-between align-items-center">
                <div><i class="fa-solid fa-file-word me-2"></i>Documento definitivo:
                    <b>${this._escapeHtml(analysis.generated_file.name)}</b></div>
                <a class="btn btn-sm btn-outline-success"
                   href="/leads/api/${leadId}/files/${analysis.generated_file.id}/download"
                   download="${this._escapeAttr(analysis.generated_file.name)}">
                    <i class="fa-solid fa-download me-1"></i>Scarica</a>
            </div>`;
        }

        if (analysis.status === 'extracting') {
            html += `<div class="text-center py-5 text-muted">
                <i class="fa-solid fa-spinner fa-spin fa-2x mb-3 d-block"></i>${fromContext
                    ? 'Stesura in corso&hellip;<div class="small mt-1">L\'AI sta leggendo email, call, file e profilo della lead. Pu&ograve; richiedere un paio di minuti.</div>'
                    : 'Estrazione in corso&hellip;<div class="small mt-1">La pagina si aggiorna da sola al termine.</div>'}</div>`;
        } else if (hasContent && !document.getElementById('analysis-review-inline')) {
            // Hint solo nella tab della lead: nella pagina di review il
            // contenuto è già visibile inline sotto
            const nItems = (analysis.sections || []).reduce((n, s) => n + s.items.filter(i => !i.is_removed).length, 0);
            html += `<div class="text-muted small mb-3"><i class="fa-solid fa-circle-info me-1"></i>
                ${nItems} voci ${fromContext ? 'redatte' : 'estratte'} — apri l'analisi per leggerle e modificarle.
                ${fromContext ? 'Quelle che aprono con <b>[Da confermare]</b> poggiano su assunzioni dell\'AI: rivedile prima di mandare in approvazione.' : ''}</div>`;
        }

        if ((analysis.events || []).length) {
            const actionLabels = {
                uploaded: 'ha caricato il documento',
                context_selected: 'ha avviato la stesura dal contesto della lead',
                extracted: fromContext ? 'ha redatto le voci con l\'AI' : 'ha estratto le voci con l\'AI',
                item_added: 'ha aggiunto', item_edited: 'ha modificato', item_removed: 'ha rimosso',
                submitted: 'ha inviato in approvazione', changes_requested: 'ha richiesto modifiche',
                approved: 'ha approvato', generated: 'ha generato il documento',
                archived: 'ha rimosso l\'analisi', headline_edited: 'ha aggiornato tempo/budget',
            };
            html += `<div class="border-top pt-3"><small class="text-muted d-block mb-2 fw-bold">Storico</small>`;
            for (const ev of [...analysis.events].reverse()) {
                html += `<div class="small text-muted mb-1">
                    <span class="fw-semibold text-dark">${this._escapeHtml(ev.actor || '')}</span>
                    ${actionLabels[ev.action] || ev.action}${ev.notes ? ` <span class="fst-italic">“${this._escapeHtml(ev.notes)}”</span>` : ''}
                    · ${window.SyrusApp && this.formatDate ? this.formatDate(ev.created_at) : ev.created_at}</div>`;
            }
            html += '</div>';
        }

        box.innerHTML = html;

        // Auto-refresh durante l'estrazione: la tab si aggiorna da sola
        if (analysis.status === 'extracting') {
            this._analysisPollTimer = setTimeout(() => this.loadAnalysis(leadId), 5000);
        } else if (this._analysisWasExtracting) {
            this.toast('Estrazione completata', 'success');
        }
        this._analysisWasExtracting = analysis.status === 'extracting';

        // Se la modale contenuto è aperta, sincronizza il body
        const cm = document.getElementById('analysis-content-modal');
        if (cm && cm.classList.contains('show')) {
            document.getElementById('analysis-content-modal-body').innerHTML = this._analysisContentHtml();
        }
        // Pagina di review dedicata: contenuto sempre inline
        const inlineBox = document.getElementById('analysis-review-inline');
        if (inlineBox) inlineBox.innerHTML = this._analysisContentHtml() || '<div class="text-muted text-center py-3">Nessuna analisi attiva.</div>';

        // FAB azioni (solo pagina di review): approva/rimanda, invia, genera
        const fab = document.getElementById('analysis-fab');
        if (fab) {
            let fabHtml = '';
            // Invio e revisione possono valere insieme (chi approva può anche
            // mandare in approvazione): si mostrano entrambi, non in alternativa
            if (canSubmit) {
                fabHtml += `
                    <button class="btn btn-primary shadow" onclick="SyrusApp.analysisSubmit()">
                        <i class="fa-solid fa-paper-plane me-1"></i>Invia in approvazione</button>`;
            }
            if (canReview) {
                fabHtml += `
                    <button class="btn btn-danger shadow" onclick="SyrusApp.analysisReview('request_changes')">
                        <i class="fa-solid fa-rotate-left me-1"></i>Rimanda con note</button>
                    <button class="btn btn-success shadow" onclick="SyrusApp.analysisReview('approve')">
                        <i class="fa-solid fa-check me-1"></i>Approva</button>`;
            }
            if (!fabHtml && canGenerate) {
                fabHtml = `
                    <button class="btn btn-success shadow" onclick="SyrusApp.analysisGenerate()">
                        <i class="fa-solid fa-file-word me-1"></i>${analysis.generated_file ? 'Rigenera documento' : 'Genera documento'}</button>`;
            }
            fab.innerHTML = fabHtml;
        }
    },

    // ── Modale fullscreen col contenuto estratto ─────────────────────────────
    _analysisContentHtml() {
        const analysis = this._docCtx() && this._docCtx().analysis;
        if (!analysis) return '';
        // Stessa regola della toolbar: approvatore in sola lettura dopo il rimando
        const ctx = this._docCtx();
        const waitingOther = ctx.is_approver && analysis.status === 'changes_requested';
        // L'offerta non ha gate di approvazione: è modificabile finché esiste
        const canEdit = analysis.doc_kind === 'offer'
            ? ['extracted', 'generated'].includes(analysis.status)
            : (['extracted', 'changes_requested', 'in_review'].includes(analysis.status) && !waitingOther);
        const meEmail = (ctx.me_email || '').toLowerCase();
        let html = '<div class="mx-auto analysis-content-wrap">';

        // I 3 valori chiave per chi approva: tempo, budget, sommario
        const kpiPencil = canEdit ? `<button class="btn btn-sm btn-link p-0 ms-2 align-baseline" onclick="SyrusApp.analysisEditHeadline()" title="Modifica tempo e budget">
            <i class="fa-solid fa-pencil text-muted" style="font-size:12px;opacity:.6"></i></button>` : '';
        // Headline lunga → corpo più piccolo, altrimenti sfonda il riquadro
        const kpiCls = v => 'analysis-kpi-value' + ((v || '').length > 34 ? ' is-long' : '');
        html += `<div class="row g-3 mb-4">
            <div class="col-md-3"><div class="analysis-kpi">
                <div class="stat-label"><i class="fa-solid fa-clock me-1"></i>Tempo stimato sviluppo</div>
                <div class="${kpiCls(analysis.headline_timeline)}">${this._escapeHtml(analysis.headline_timeline || '—')}${kpiPencil}</div>
            </div></div>
            <div class="col-md-3"><div class="analysis-kpi">
                <div class="stat-label"><i class="fa-solid fa-euro-sign me-1"></i>Budget di riferimento</div>
                <div class="${kpiCls(analysis.headline_budget)}">${this._escapeHtml(analysis.headline_budget || '—')}${kpiPencil}</div>
            </div></div>
            <div class="col-md-6"><div class="analysis-kpi">
                <div class="stat-label"><i class="fa-solid fa-wand-magic-sparkles me-1"></i>Sommario lead</div>
                <div class="analysis-summary">${this._escapeHtml(analysis.ai_summary || 'Nessuna sintesi disponibile.')}</div>
            </div></div>
        </div>`;

        // Note di margine raggruppate per sezione
        const notesBySection = {};
        for (const n of (analysis.notes || [])) {
            (notesBySection[n.section] = notesBySection[n.section] || []).push(n);
        }

        // Struttura canonica: "Moduli inclusi" e "Fuori scope" ci sono SEMPRE
        // (anche vuoti), in testa e in coda; le altre sezioni in mezzo.
        // Il riconoscimento è per titolo ma ripiega sul tipo delle voci: se il
        // modello battezza la sezione in un altro modo, i moduli devono finire
        // lì dentro lo stesso, non in un segnaposto vuoto
        const allSections = [...(analysis.sections || [])];
        const allOfKind = (s, k) => {
            const live = (s.items || []).filter(i => !i.is_removed);
            return live.length > 0 && live.every(i => i.kind === k);
        };
        let modSec = allSections.find(s => /moduli inclusi/i.test(s.title))
            || allSections.find(s => allOfKind(s, 'module'));
        let oosSec = allSections.find(s => /fuori scope/i.test(s.title))
            || allSections.find(s => s !== modSec && allOfKind(s, 'excluded'));
        const restSections = allSections.filter(s => s !== modSec && s !== oosSec);
        if (!modSec) modSec = { title: 'Moduli inclusi', items: [] };
        if (!oosSec) oosSec = { title: 'Fuori scope', items: [] };
        const orderedSections = [modSec, ...restSections, oosSec];

        for (const section of orderedSections) {
            const notes = notesBySection[section.title] || [];
            html += `<div class="d-flex gap-3 mb-4 flex-wrap flex-md-nowrap">
                <div class="flex-grow-1" style="min-width:280px">
                <div class="fw-bold mb-2" style="color:#1B3A5C">${this._escapeHtml(section.title)}</div>
                <div class="list-group">`;
            for (const it of section.items) {
                const [kindLabel, kindIcon, kindColor] = this._kindMeta(it.kind);
                const removedCls = it.is_removed ? 'opacity-50 text-decoration-line-through' : '';
                html += `
                    <div class="list-group-item d-flex align-items-start gap-2 ${removedCls}" data-item-id="${it.id}">
                        <span class="badge mt-1" style="background:${kindColor}1a;color:${kindColor};min-width:82px">
                            <i class="fa-solid ${kindIcon} me-1"></i>${kindLabel}</span>
                        <div class="flex-grow-1">
                            <div class="fw-semibold">${this._escapeHtml(it.label)}
                                ${it.value ? `<span class="text-muted fw-normal ms-1">— ${this._escapeHtml(it.value)}</span>` : ''}
                                ${it.amount != null ? `<span class="fw-bold ms-1" style="color:#059669">${window.eurIt ? window.eurIt(it.amount) : '€ ' + it.amount}</span>` : ''}
                                ${it.source === 'manual' ? '<span class="badge bg-light text-muted ms-1" title="Aggiunta a mano">manuale</span>' : ''}
                            </div>
                            ${it.description ? `<div class="small text-muted">${this._escapeHtml(it.description)}</div>` : ''}
                        </div>
                        ${canEdit ? `
                        <div class="d-flex gap-1">
                            <button class="btn btn-sm btn-link text-muted p-1" title="Modifica"
                                    onclick="SyrusApp.analysisEditItem('${it.id}')"><i class="fa-solid fa-pencil"></i></button>
                            <button class="btn btn-sm btn-link ${it.is_removed ? 'text-success' : 'text-danger'} p-1"
                                    title="${it.is_removed ? 'Ripristina' : 'Rimuovi'}"
                                    onclick="SyrusApp.analysisToggleRemove('${it.id}', ${!it.is_removed})">
                                <i class="fa-solid ${it.is_removed ? 'fa-rotate-left' : 'fa-trash'}"></i></button>
                        </div>` : ''}
                    </div>`;
            }
            if (!section.items.length) {
                html += `<div class="list-group-item text-muted small fst-italic">Nessuna voce in questa sezione.</div>`;
            }
            html += '</div>';
            if (canEdit) {
                html += `<div class="d-flex gap-3 mt-2 flex-wrap">
                    <button class="btn btn-sm btn-link p-0" data-section="${this._escapeAttr(section.title)}"
                            onclick="SyrusApp.analysisEditItem(null, this.dataset.section)">
                        <i class="fa-solid fa-plus me-1"></i>Aggiungi voce in questa sezione</button>
                    <button class="btn btn-sm btn-link p-0 text-warning-emphasis" data-section="${this._escapeAttr(section.title)}"
                            onclick="SyrusApp.analysisAddNote(this)"
                            title="Aggiungi una nota su questa sezione (senza modificare le voci)">
                        <i class="fa-regular fa-note-sticky me-1"></i>Aggiungi nota</button>
                </div>`;
            }
            html += '</div>';

            // Colonna note a margine: occupa spazio solo se ci sono note da
            // mostrare — il pulsante per aggiungerle sta sotto le voci
            if (notes.length) {
            html += `<div class="analysis-notes-col">`;
            for (const n of notes) {
                const mine = (n.author || '').toLowerCase() === meEmail;
                const authorName = (n.author || '').split('@')[0];
                html += `<div class="analysis-note">
                    <div class="an-meta">
                        <span class="fw-bold">${this._escapeHtml(authorName)}</span>
                        <span>${n.created_at ? this.formatDate(n.created_at) : ''}
                            ${mine ? `<button class="btn btn-link p-0 ms-1 text-danger an-del" title="Elimina nota"
                                onclick="SyrusApp.analysisDeleteNote('${n.id}')"><i class="fa-solid fa-xmark"></i></button>` : ''}</span>
                    </div>
                    <div style="white-space:pre-wrap">${this._escapeHtml(n.body)}</div>
                </div>`;
            }
            html += '</div>';
            }
            html += '</div>';
        }

        if (analysis.total_amount) {
            html += `<div class="text-end fw-bold mb-3" style="color:#1B3A5C">
                Totale importi: <span style="color:#059669">${window.eurIt ? window.eurIt(analysis.total_amount) : '€ ' + analysis.total_amount}</span>
                <small class="text-muted fw-normal">(IVA esclusa)</small></div>`;
        }

        if (canEdit) {
            html += `<button class="btn btn-sm btn-outline-primary mb-4" onclick="SyrusApp.analysisEditItem(null)">
                <i class="fa-solid fa-plus me-1"></i>Aggiungi voce</button>`;
        }

        html += '</div>';
        return html;
    },

    // ── Valori in evidenza (tempo/budget) ────────────────────────────────────
    analysisEditHeadline() {
        const a = this._analysisData.analysis;
        if (!a) return;
        this._showModal('Tempo e budget', `
            <form onsubmit="SyrusApp.analysisSaveHeadline(event)">
                <div class="mb-2"><label class="form-label">Tempo stimato di sviluppo</label>
                    <input name="headline_timeline" class="form-control" value="${this._escapeAttr(a.headline_timeline || '')}" placeholder="es. 6 settimane"></div>
                <div class="mb-3"><label class="form-label">Budget di riferimento
                        <small class="text-muted">(quello dichiarato dal cliente, non la quotazione)</small></label>
                    <input name="headline_budget" class="form-control" value="${this._escapeAttr(a.headline_budget || '')}" placeholder="es. € 12.000 – € 15.000 dichiarati"></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>
            </form>`);
    },

    async analysisSaveHeadline(event) {
        event.preventDefault();
        const data = Object.fromEntries(new FormData(event.target).entries());
        const { leadId, analysis } = this._docCtx();
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/headline`, {
                method: 'PUT', body: JSON.stringify(data) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._docCtx().analysis = r.analysis;
            this._docRender();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Note di margine per sezione ──────────────────────────────────────────
    analysisAddNote(btn) {
        const section = btn.dataset.section || '';
        this._showModal(`Nota — ${this._escapeHtml(section)}`, `
            <form onsubmit="SyrusApp.analysisSaveNote(event)">
                <input type="hidden" name="section" value="${this._escapeAttr(section)}">
                <div class="mb-3"><label class="form-label">Nota <small class="text-muted">(visibile a chi propone e a chi approva, non modifica le voci)</small></label>
                    <textarea name="body" class="form-control" rows="3" required></textarea></div>
                <button type="submit" class="btn btn-warning"><i class="fa-regular fa-note-sticky me-1"></i>Aggiungi nota</button>
            </form>`);
    },

    async analysisSaveNote(event) {
        event.preventDefault();
        const data = Object.fromEntries(new FormData(event.target).entries());
        const { leadId, analysis } = this._docCtx();
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/notes`, {
                method: 'POST', body: JSON.stringify(data) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._docCtx().analysis = r.analysis;
            this._docRender();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async analysisDeleteNote(noteId) {
        if (!confirm('Eliminare questa nota?')) return;
        const { leadId, analysis } = this._docCtx();
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/notes/${noteId}`, { method: 'DELETE' });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            this._docCtx().analysis = r.analysis;
            this._docRender();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    analysisOpenModal() {
        const analysis = this._analysisData && this._analysisData.analysis;
        if (!analysis) return;
        let modal = document.getElementById('analysis-content-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'modal fade';
            modal.id = 'analysis-content-modal';
            // z-index sotto #syrus-modal (1055): le modali di modifica voce si
            // aprono SOPRA questa; niente backdrop, il fullscreen copre tutto
            modal.style.zIndex = '1050';
            modal.setAttribute('data-bs-backdrop', 'false');
            modal.innerHTML = `<div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="fa-solid fa-clipboard-check me-2"></i>
                            Contenuto estratto <span class="text-muted fw-normal" id="analysis-content-modal-file"></span></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body" id="analysis-content-modal-body"></div>
                </div></div>`;
            document.body.appendChild(modal);
        }
        const fileEl = document.getElementById('analysis-content-modal-file');
        if (fileEl) fileEl.textContent = analysis.source_file ? `— ${analysis.source_file.name}` : '';
        document.getElementById('analysis-content-modal-body').innerHTML = this._analysisContentHtml();
        bootstrap.Modal.getOrCreateInstance(modal).show();
    },

    // ── Stato vuoto: uploader drag&drop del documento sorgente ──────────────
    async _renderAnalysisEmpty(box, leadId) {
        let existingHtml = '';
        try {
            const files = await this.api(`/leads/api/${leadId}/files`);
            const docs = (Array.isArray(files) ? files : []).filter(f =>
                /\.(pdf|docx?|txt)$/i.test(f.filename || ''));
            if (docs.length) {
                existingHtml = `<div class="mt-3 text-center">
                    <small class="text-muted d-block mb-2">…oppure usa un documento gi&agrave; presente sulla lead:</small>
                    <div class="list-group mx-auto text-start" style="max-width:620px">${docs.map(f => `
                        <button type="button" class="list-group-item list-group-item-action d-flex align-items-center gap-2"
                                onclick="SyrusApp.analysisUseExisting('${f.id}')" title="Crea l'analisi da questo documento">
                            <i class="fa-solid ${this._fileIcon(f)}"></i>
                            <span class="text-truncate">${this._escapeHtml(f.filename)}</span>
                            <i class="fa-solid fa-circle-play ms-auto text-primary"></i>
                        </button>`).join('')}</div>
                </div>`;
            }
        } catch (_) { /* lista file non disponibile */ }

        box.innerHTML = `
            <div class="text-center py-2">
                <h6 class="fw-bold">Nessuna analisi per questa lead</h6>
                <p class="text-muted small mb-3">Due strade per arrivare alla stessa scheda:
                    farla scrivere all'AI leggendo tutto quello che sappiamo della lead,
                    oppure partire da un documento gi&agrave; redatto.</p>
            </div>

            <div class="card border-primary mx-auto mb-4" style="max-width:820px">
                <div class="card-body">
                    <div class="d-flex align-items-start gap-3">
                        <i class="fa-solid fa-wand-magic-sparkles fa-2x text-primary mt-1"></i>
                        <div class="flex-grow-1">
                            <h6 class="fw-bold mb-1">Redigi dal contesto della lead</h6>
                            <p class="text-muted small mb-3">L'AI legge email, WhatsApp, trascrizioni di
                                call e videocall, file allegati e profilo AI, e scrive l'analisi
                                <b>tecnica</b>: cosa &egrave; dentro, cosa &egrave; fuori, architettura,
                                fasi e prerequisiti. Niente prezzi &mdash; quelli stanno nell'offerta.
                                Poi la rivedi voce per voce.</p>
                            <div class="mb-3">
                                <label class="form-label small fw-bold mb-1">Istruzioni per l'AI
                                    <small class="text-muted fw-normal">(opzionale)</small></label>
                                <textarea id="analysis-context-instructions" class="form-control form-control-sm" rows="2"
                                          placeholder="Es: budget massimo 15.000&euro;, escludi l'app mobile, consegna entro marzo&hellip;"></textarea>
                            </div>
                            ${this.aiDirectivesHint(leadId)}
                            <button class="btn btn-primary" onclick="SyrusApp.analysisFromContext()">
                                <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Redigi l'analisi</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center text-muted small mb-3">&mdash; oppure parti da un documento &mdash;</div>

            <div class="analysis-dropzone" id="analysis-dropzone">
                <i class="fa-solid fa-cloud-arrow-up"></i>
                <div class="fw-bold">Trascina qui il documento di analisi</div>
                <div class="text-muted small">oppure clicca per selezionarlo &mdash; PDF, DOC, DOCX o TXT</div>
                <input type="file" id="analysis-upload-input" class="d-none" accept=".pdf,.doc,.docx,.txt">
            </div>
            ${existingHtml}`;
        this._analysisBindDropzone(leadId);
    },

    /** Stesura dal contesto CRM: nessun upload, si crea subito e si redige. */
    async analysisFromContext() {
        const leadId = this._analysisData.leadId;
        const box = document.getElementById('analysis-container');
        const instrEl = document.getElementById('analysis-context-instructions');
        const instructions = instrEl ? instrEl.value.trim() : '';
        if (box) box.innerHTML = `<div class="text-center py-5 text-muted">
            <i class="fa-solid fa-spinner fa-spin fa-2x mb-3 d-block"></i>Raccolta del contesto della lead&hellip;</div>`;
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis`, {
                method: 'POST', body: JSON.stringify({ source: 'context', instructions }) });
            if (r.error) { this.toast(r.error, 'danger'); this._renderAnalysisEmpty(box, leadId); return; }
            this._analysisData.analysis = r.analysis;
            this._renderAnalysis();
            this._renderAnalysisBadge(r.analysis);
            this.analysisExtract(false, instructions);  // stesura immediata
        } catch (e) {
            this.toast(e.message, 'danger');
            this._renderAnalysisEmpty(box, leadId);
        }
    },

    /** Modale col contesto grezzo che l'AI ha letto — "su cosa si è basata?". */
    async analysisShowContext() {
        const { leadId, analysis } = this._analysisData;
        if (!analysis) return;
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/context`);
            this._showModal('Contesto letto dall\'AI', `
                <p class="text-muted small">Fotografia del materiale della lead al momento della stesura.
                    Le comunicazioni successive non sono incluse.</p>
                <pre class="border rounded p-3 bg-light" style="max-height:60vh;overflow:auto;white-space:pre-wrap;font-size:12px">${
                    this._escapeHtml(r.context || 'Nessun contesto memorizzato.')}</pre>`);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    _analysisBindDropzone(leadId) {
        const dz = document.getElementById('analysis-dropzone');
        const input = document.getElementById('analysis-upload-input');
        if (!dz || !input) return;
        dz.addEventListener('click', () => input.click());
        input.addEventListener('change', () => {
            if (input.files.length) this.analysisUploadFile(leadId, input.files[0]);
        });
        ['dragenter', 'dragover'].forEach(evName => dz.addEventListener(evName, (e) => {
            e.preventDefault(); dz.classList.add('dragover');
        }));
        dz.addEventListener('dragleave', (e) => {
            e.preventDefault();
            if (!dz.contains(e.relatedTarget)) dz.classList.remove('dragover');
        });
        dz.addEventListener('drop', (e) => {
            e.preventDefault(); dz.classList.remove('dragover');
            const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
            if (f) this.analysisUploadFile(leadId, f);
        });
    },

    async analysisUploadFile(leadId, file) {
        const box = document.getElementById('analysis-container');
        if (box) box.innerHTML = `<div class="text-center py-5 text-muted">
            <i class="fa-solid fa-spinner fa-spin fa-2x mb-3 d-block"></i>Caricamento di ${this._escapeHtml(file.name)}&hellip;</div>`;
        try {
            const fd = new FormData();
            fd.append('files', file);
            const up = await this.fetchWithCsrf(`/leads/api/${leadId}/files/upload`, { method: 'POST', body: fd });
            const upData = await up.json();
            if (!up.ok || !(upData.files || []).length || upData.files[0].error) {
                throw new Error((upData.files && upData.files[0] && upData.files[0].error) || 'Upload fallito');
            }
            if (!upData.files[0].id) throw new Error('Upload riuscito ma id file mancante');
            this.loadLeadFiles(leadId);  // aggiorna la tab Files
            await this._analysisCreate(leadId, upData.files[0].id);
            // Se la creazione è fallita (toast già mostrato) non restare sullo spinner
            if (!this._analysisData.analysis) this._renderAnalysisEmpty(box, leadId);
        } catch (e) {
            this.toast(e.message, 'danger');
            this._renderAnalysisEmpty(box, leadId);
        }
    },

    async analysisUseExisting(fileId) {
        await this._analysisCreate(this._analysisData.leadId, fileId);
    },

    async _analysisCreate(leadId, fileId) {
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis`, {
                method: 'POST', body: JSON.stringify({ lead_file_id: fileId }) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            this._analysisData.analysis = r.analysis;
            this._renderAnalysis();
            this._renderAnalysisBadge(r.analysis);
            this.analysisExtract();  // estrazione immediata dopo la creazione
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async analysisArchive() {
        if (!confirm('Rimuovere questa analisi? Il documento resta tra i file della lead, ma l\'analisi viene annullata.')) return;
        const { leadId, analysis } = this._analysisData;
        if (!analysis) return;
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/archive`, {
                method: 'POST', body: JSON.stringify({}) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            this.toast('Analisi rimossa');
            await this.loadAnalysis(leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async analysisExtract(isRerun, instructions) {
        const { leadId, analysis } = this._docCtx();
        if (!analysis) return;
        const fromContext = analysis.source_kind === 'context';
        // Ri-stesura dal contesto: si ripassano (e si possono correggere) le istruzioni
        if (isRerun && fromContext) { this._analysisRedraftModal(); return; }
        if (isRerun && !confirm('Ripetere l\'estrazione AI? Le voci estratte in precedenza dall\'AI verranno sostituite (quelle manuali restano).')) return;
        analysis.status = 'extracting';
        this._renderAnalysis();
        const body = instructions === undefined ? {} : { instructions };
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/extract`, {
                method: 'POST', body: JSON.stringify(body) });
            if (r.error) { this.toast(r.error, 'danger'); }
            // Il toast "Estrazione completata" lo emette _renderAnalysis al
            // passaggio di stato (vale anche per il polling dopo un reload)
            await this.loadAnalysis(leadId);
        } catch (e) {
            this.toast(e.message, 'danger');
            await this.loadAnalysis(leadId);
        }
    },

    analysisSubmit() {
        const a = this._analysisData.analysis || {};
        const appr = a.approver_email || '';
        const meIsAppr = appr && appr.toLowerCase() === (this._analysisData.me_email || '').toLowerCase();
        this._showModal('Invia in approvazione', `
            <form onsubmit="SyrusApp._analysisSubmitConfirm(event)">
                <div class="alert alert-light border small py-2 px-3">
                    <i class="fa-solid fa-paper-plane text-primary me-1"></i>
                    L'analisi viene inviata a <b>${this._escapeHtml(appr || '—')}</b>, che riceve
                    un'email col link alla scheda e potr&agrave; approvarla o rimandarla con note.
                    ${meIsAppr ? '<br><span class="text-muted">L\'approvatore sei tu: riceverai tu stesso l\'email.</span>' : ''}
                </div>
                <div class="mb-3"><label class="form-label">Nota per l'approvatore <small class="text-muted">(opzionale)</small></label>
                    <textarea name="notes" class="form-control" rows="3" placeholder="Eventuale contesto per chi approva..."></textarea></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-paper-plane me-1"></i>Invia in approvazione</button>
            </form>`);
    },

    async _analysisSubmitConfirm(event) {
        event.preventDefault();
        const notes = (new FormData(event.target).get('notes') || '').trim();
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        await this._analysisAction('submit', { notes });
    },

    analysisReview(decision) {
        const isReject = decision === 'request_changes';
        this._showModal(isReject ? 'Rimanda con note' : 'Approva analisi', `
            <form onsubmit="SyrusApp._analysisReviewConfirm(event, '${decision}')">
                <div class="mb-3">
                    <label class="form-label">${isReject ? 'Cosa va modificato? *' : 'Nota <small class="text-muted">(opzionale)</small>'}</label>
                    <textarea name="notes" class="form-control" rows="3" ${isReject ? 'required' : ''}
                              placeholder="${isReject ? 'Descrivi le modifiche richieste...' : 'Eventuale commento per chi ha proposto l\'analisi...'}"></textarea>
                </div>
                <button type="submit" class="btn ${isReject ? 'btn-danger' : 'btn-success'}">
                    ${isReject ? '<i class="fa-solid fa-rotate-left me-1"></i>Rimanda' : '<i class="fa-solid fa-check me-1"></i>Approva'}</button>
            </form>`);
    },

    async _analysisReviewConfirm(event, decision) {
        event.preventDefault();
        const notes = (new FormData(event.target).get('notes') || '').trim();
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        await this._analysisAction('review', { decision, notes });
    },

    async analysisGenerate() {
        const r = await this._analysisAction('generate', {});
        if (r && r.file) this.toast(`Documento generato: ${r.file.name}`, 'success');
    },

    async _analysisAction(action, payload) {
        const { leadId, analysis } = this._docCtx();
        if (!analysis) return null;
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/${action}`, {
                method: 'POST', body: JSON.stringify(payload) });
            if (r.error) { this.toast(r.error, 'danger'); return null; }
            const ctx = this._docCtx();
            ctx.analysis = r.analysis;
            this._docRender();
            if (ctx === this._analysisData) this._renderAnalysisBadge(r.analysis);
            return r;
        } catch (e) { this.toast(e.message, 'danger'); return null; }
    },

    /** Ri-stesura dal contesto: le istruzioni precedenti sono già lì, correggibili. */
    _analysisRedraftModal() {
        const analysis = this._analysisData.analysis;
        this._showModal('Ri-redigi dal contesto', `
            <form onsubmit="SyrusApp._analysisRedraftConfirm(event)">
                <p class="text-muted small">L'AI rilegge il contesto aggiornato della lead e riscrive
                    le voci che ha prodotto. Le voci aggiunte a mano restano.</p>
                ${this.aiDirectivesHint(this._analysisData.leadId)}
                <div class="mb-3"><label class="form-label">Istruzioni per l'AI <small class="text-muted">(opzionale)</small></label>
                    <textarea name="instructions" class="form-control" rows="3"
                              placeholder="Es: alza il budget a 20.000&euro;, togli il modulo firma&hellip;">${
                        this._escapeHtml(analysis && analysis.ai_instructions || '')}</textarea></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-rotate me-1"></i>Ri-redigi</button>
            </form>`);
    },

    async _analysisRedraftConfirm(event) {
        event.preventDefault();
        const instructions = (new FormData(event.target).get('instructions') || '').trim();
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        await this.analysisExtract(false, instructions);
    },

    analysisRestart() {
        if (!confirm('Ripartire da capo? L\'analisi corrente viene archiviata alla creazione della nuova.')) return;
        const box = document.getElementById('analysis-container');
        this._renderAnalysisEmpty(box, this._analysisData.leadId);
        this._analysisData.analysis = null;
    },

    // ── Editing voci ────────────────────────────────────────────────────────
    _findAnalysisItem(itemId) {
        for (const s of (this._analysisData.analysis?.sections || [])) {
            const it = s.items.find(i => i.id === itemId);
            if (it) return { ...it, section: s.title };
        }
        return null;
    },

    analysisEditItem(itemId, presetSection) {
        const presetKind = presetSection && /fuori scope/i.test(presetSection) ? 'excluded' : 'module';
        const it = itemId ? this._findAnalysisItem(itemId) : {
            id: null, kind: presetKind, label: '', description: '', value: '', amount: null, section: presetSection || '' };
        if (itemId && !it) return;
        this._showModal(itemId ? 'Modifica voce' : 'Aggiungi voce', `
            <form onsubmit="SyrusApp.analysisSaveItem(event, ${itemId ? `'${itemId}'` : 'null'})">
                <div class="row g-2 mb-2">
                    <div class="col-5"><label class="form-label">Tipo</label>
                        <select name="kind" class="form-select">
                            <option value="module" ${it.kind === 'module' ? 'selected' : ''}>Modulo da sviluppare</option>
                            <option value="timeline" ${it.kind === 'timeline' ? 'selected' : ''}>Tempistica</option>
                            <option value="price" ${it.kind === 'price' ? 'selected' : ''}>Importo</option>
                            <option value="excluded" ${it.kind === 'excluded' ? 'selected' : ''}>Fuori scope (escluso)</option>
                            <option value="other" ${it.kind === 'other' ? 'selected' : ''}>Altra informazione</option>
                        </select></div>
                    <div class="col-7"><label class="form-label">Sezione</label>
                        <input name="section" class="form-control" value="${this._escapeAttr(it.section || '')}"
                               placeholder="es. Moduli da sviluppare"></div>
                </div>
                <div class="mb-2"><label class="form-label">Titolo</label>
                    <input name="label" class="form-control" required value="${this._escapeAttr(it.label || '')}"></div>
                <div class="mb-2"><label class="form-label">Descrizione</label>
                    <textarea name="description" class="form-control" rows="2">${this._escapeHtml(it.description || '')}</textarea></div>
                <div class="row g-2 mb-3">
                    <div class="col-7"><label class="form-label">Valore sintetico</label>
                        <input name="value" class="form-control" value="${this._escapeAttr(it.value || '')}"
                               placeholder="es. 6 settimane / € 12.000 + IVA"></div>
                    <div class="col-5"><label class="form-label">Importo € (solo tipo Importo)</label>
                        <input name="amount" type="number" step="0.01" class="form-control"
                               value="${it.amount != null ? it.amount : ''}"></div>
                </div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>
            </form>`);
    },

    async analysisSaveItem(event, itemId) {
        event.preventDefault();
        const data = Object.fromEntries(new FormData(event.target).entries());
        const { leadId, analysis } = this._docCtx();
        try {
            const url = itemId
                ? `/leads/api/${leadId}/analysis/${analysis.id}/items/${itemId}`
                : `/leads/api/${leadId}/analysis/${analysis.id}/items`;
            const r = await this.api(url, {
                method: itemId ? 'PUT' : 'POST', body: JSON.stringify(data) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._docCtx().analysis = r.analysis;
            this._docRender();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async analysisToggleRemove(itemId, remove) {
        const { leadId, analysis } = this._docCtx();
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${analysis.id}/items/${itemId}`, {
                method: 'PUT', body: JSON.stringify({ is_removed: remove }) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            this._docCtx().analysis = r.analysis;
            this._docRender();
        } catch (e) { this.toast(e.message, 'danger'); }
    },
});


// ── app-offers.js ──
/** Syrus Sales OS – Offerte (tab Offerta nella scheda lead)
 *
 * Un'offerta è un LeadAnalysis con doc_kind='offer': stessa scheda, stesse voci,
 * stesso generatore DOCX dell'analisi. Cambia il regime — ne convivono più
 * varianti sulla stessa lead, ognuna con il proprio tetto di budget, e non
 * passano dall'approvazione. La scheda editabile è quella dell'analisi, aperta
 * puntando _offerData (vedi _docCtx in app-analysis.js).
 */
Object.assign(SyrusApp, {

    _offersData: null,
    _offerData: null,      // documento aperto nella modale
    _offerEditing: false,

    async loadOffers(leadId) {
        const box = document.getElementById('offers-container');
        if (!box) return;
        try {
            const data = await this.api(`/leads/api/${leadId}/offers`);
            this._offersData = { ...data, leadId };
            this._renderOffers();
            // Serve al menù "inviata da": si carica una volta sola
            if (!this._salespersonsCache) {
                this.api('/leads/api/salespersons')
                    .then(u => { this._salespersonsCache = u; })
                    .catch(() => { this._salespersonsCache = []; });
            }
        } catch (e) {
            box.innerHTML = `<div class="alert alert-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    _OFFER_STATUS: {
        draft: ['Bozza', 'bg-secondary'],
        extracting: ['Stesura…', 'bg-info'],
        extracted: ['Pronta', 'bg-primary'],
        generated: ['Documento generato', 'bg-success', 'fa-circle-check'],
        sent: ['Inviata al cliente', 'bg-dark', 'fa-paper-plane'],
    },

    _offerBadge(status) {
        const [label, cls, icon] = this._OFFER_STATUS[status] || [status, 'bg-secondary'];
        const inner = icon ? `<i class="fa-solid ${icon}"></i>` : this._escapeHtml(label);
        return `<span class="badge ${cls}${icon ? ' badge-icon' : ''}" title="${this._escapeAttr(label)}">${inner}</span>`;
    },

    /** Totale una tantum. Si guarda SOLO la sezione Investimento: altrove le
     *  voci economiche sono canoni ricorrenti e rate di pagamento, che sono
     *  quote dello stesso importo — sommarle lo conterebbe tre volte. */
    _offerTotal(offer) {
        const inv = (offer.sections || []).find(s => /investimento/i.test(s.title));
        if (!inv) return 0;
        const rows = inv.items.filter(i => i.kind === 'price' && !i.is_removed && i.amount);
        // Se l'AI ha messo la riga di totale è quella che fa fede
        const totalRow = rows.find(i => /^\s*totale\b/i.test(i.label));
        if (totalRow) return totalRow.amount;
        return rows.reduce((n, i) => n + i.amount, 0);
    },

    _renderOffers() {
        const box = document.getElementById('offers-container');
        if (!box) return;
        const { offers, analysis, leadId } = this._offersData;

        if (this._offersPollTimer) { clearTimeout(this._offersPollTimer); this._offersPollTimer = null; }

        if (!analysis) {
            box.innerHTML = `<div class="text-center py-5">
                <i class="fa-solid fa-diagram-project fa-2x text-muted mb-3 d-block"></i>
                <h6 class="fw-bold">Prima serve l'analisi tecnica</h6>
                <p class="text-muted small mb-3">L'offerta parte sempre dall'analisi: da lì prende
                    perimetro, moduli e tempi, e ci mette sopra i prezzi.</p>
                <button class="btn btn-outline-primary btn-sm"
                        onclick="document.getElementById('analysis-tab-btn').click()">
                    <i class="fa-solid fa-clipboard-check me-1"></i>Vai al tab Analisi</button>
            </div>`;
            return;
        }

        let html = `
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
                <div>
                    <h6 class="fw-bold mb-1"><i class="fa-solid fa-file-invoice-dollar me-2"></i>Offerte</h6>
                    <div class="text-muted small">Ognuna parte dall'analisi
                        (${analysis.modules} moduli) e sta dentro il tetto di budget che le dai.
                        L'AI sceglie cosa ci entra e sposta il resto nel fuori scope.</div>
                </div>
                <button class="btn btn-sm btn-primary" onclick="SyrusApp.offerNew()">
                    <i class="fa-solid fa-plus me-1"></i>Nuova offerta</button>
            </div>`;

        if (!offers.length) {
            html += `<div class="text-center py-4 text-muted">
                <i class="fa-solid fa-file-invoice-dollar fa-2x mb-3 d-block opacity-50"></i>
                Nessuna offerta. Creane una indicando il tetto di budget:
                puoi farne più d'una con tetti diversi per confrontarle.</div>`;
        } else {
            html += '<div class="row g-3">';
            for (const o of offers) {
                const total = this._offerTotal(o);
                const cap = o.budget_cap || 0;
                const over = cap && total > cap + 0.5;   // tolleranza sugli arrotondamenti
                const modules = (o.sections || []).reduce((n, s) =>
                    n + s.items.filter(i => i.kind === 'module' && !i.is_removed).length, 0);
                const cut = (o.sections || []).reduce((n, s) =>
                    n + s.items.filter(i => i.kind === 'excluded' && !i.is_removed).length, 0);
                const busy = o.status === 'extracting';
                html += `
                <div class="col-md-6">
                  <div class="card h-100 offer-card">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-start gap-2 mb-2">
                        <div class="fw-bold" style="color:#1B3A5C">
                            ${this._escapeHtml(o.title || 'Offerta senza nome')}</div>
                        ${this._offerBadge(o.status)}
                      </div>
                      <div class="offer-cap">Tetto di budget
                        <b>${window.eurIt ? window.eurIt(cap) : '€ ' + cap}</b></div>
                      ${busy ? `
                        <div class="text-muted small py-3">
                            <i class="fa-solid fa-spinner fa-spin me-1"></i>L'AI sta quotando&hellip;</div>`
                      : `
                      <div class="d-flex gap-3 flex-wrap my-3">
                        <div><div class="stat-label">Totale</div>
                          <div class="offer-total ${over ? 'text-danger' : ''}">${
                            total ? (window.eurIt ? window.eurIt(total) : '€ ' + total) : '—'}</div></div>
                        <div><div class="stat-label">Moduli</div>
                          <div class="offer-total">${modules}</div></div>
                        <div><div class="stat-label">Fuori scope</div>
                          <div class="offer-total">${cut}</div></div>
                      </div>
                      ${over ? `<div class="alert alert-warning py-1 px-2 small mb-2">
                          <i class="fa-solid fa-triangle-exclamation me-1"></i>
                          Il totale supera il tetto: rivedi le voci o alza il budget.</div>` : ''}
                      ${o.headline_timeline ? `<div class="text-muted small mb-2">
                          <i class="fa-regular fa-clock me-1"></i>${this._escapeHtml(o.headline_timeline)}</div>` : ''}
                      ${this._offerSentBanner(o, 'mb-2')}
                      <div class="d-flex gap-2 flex-wrap">
                        <button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.offerGenerate('${o.id}')">
                            <i class="fa-regular fa-eye me-1"></i>${o.is_locked ? 'Vedi il documento' : 'Documento e anteprima'}</button>
                        <a class="btn btn-sm btn-outline-danger"
                           href="/leads/api/${leadId}/offers/${o.id}/pdf" download
                           title="Scarica l'offerta in PDF">
                            <i class="fa-solid fa-file-pdf me-1"></i>PDF</a>
                        ${o.generated_file ? `
                          <a class="btn btn-sm btn-success"
                             href="/leads/api/${leadId}/files/${o.generated_file.id}/download"
                             download="${this._escapeAttr(o.generated_file.name)}"
                             title="Scarica il Word generato">
                            <i class="fa-solid fa-file-word me-1"></i>Word</a>` : ''}
                        ${o.is_locked ? '' : `
                        <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.offerRedraft('${o.id}')"
                                title="Rigenera con un tetto di budget diverso">
                            <i class="fa-solid fa-rotate me-1"></i>Budget e rigenera</button>
                        <button class="btn btn-sm btn-dark" onclick="SyrusApp.offerMarkSent('${o.id}')"
                                title="Segna come inviata al cliente">
                            <i class="fa-solid fa-paper-plane me-1"></i>Segna inviata</button>
                        <button class="btn btn-sm btn-outline-danger ms-auto" onclick="SyrusApp.offerDelete('${o.id}')"
                                title="Elimina questa offerta"><i class="fa-solid fa-trash"></i></button>`}
                      </div>`}
                    </div>
                  </div>
                </div>`;
            }
            html += '</div>';
        }
        box.innerHTML = html;

        // Le stesure in corso si aggiornano da sole
        if (offers.some(o => o.status === 'extracting')) {
            this._offersPollTimer = setTimeout(() => this.loadOffers(leadId), 5000);
        }
    },

    // ── Creazione ───────────────────────────────────────────────────────────

    offerNew() {
        const a = this._offersData.analysis || {};
        const hint = a.headline_budget
            ? `<div class="text-muted small mb-3">Budget indicato nell'analisi:
                 <b>${this._escapeHtml(a.headline_budget)}</b></div>` : '';
        this._showModal('Nuova offerta', `
            <form onsubmit="SyrusApp.offerCreate(event)">
                ${this.aiDirectivesHint(this._offersData.leadId)}
                ${hint}
                <div class="mb-3">
                    <label class="form-label">Nome della variante</label>
                    <input name="title" class="form-control" placeholder="Es. Completa, Base, Fase 1" required>
                    <div class="form-text">Serve a distinguerla dalle altre offerte della lead.</div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Tetto di budget (&euro;, IVA esclusa) *</label>
                    <input name="budget_cap" type="number" min="1" step="1" class="form-control"
                           inputmode="numeric"
                           placeholder="15000" required>
                    <div class="form-text">L'AI sceglie quali moduli dell'analisi ci stanno dentro
                        e sposta gli altri nel fuori scope, spiegando perch&eacute;.</div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Istruzioni per l'AI <small class="text-muted">(opzionale)</small></label>
                    <textarea name="instructions" class="form-control" rows="2"
                              placeholder="Es: tieni dentro la vendita online a ogni costo, pagamento in 3 tranche&hellip;"></textarea>
                </div>
                <button type="submit" class="btn btn-primary">
                    <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Genera l'offerta</button>
            </form>`);
    },

    async offerCreate(event) {
        event.preventDefault();
        const d = Object.fromEntries(new FormData(event.target).entries());
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        const leadId = this._offersData.leadId;
        try {
            const r = await this.api(`/leads/api/${leadId}/offers`, {
                method: 'POST', body: JSON.stringify(d) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            await this.loadOffers(leadId);
            this._offerExtract(r.offer.id);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    /** Lancia la stesura; la lista fa polling da sola fino al termine. */
    async _offerExtract(offerId) {
        const leadId = this._offersData.leadId;
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        if (o) { o.status = 'extracting'; this._renderOffers(); }
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${offerId}/extract`, {
                method: 'POST', body: JSON.stringify({}) });
            if (r.error) this.toast(r.error, 'danger');
            else this.toast('Offerta pronta', 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
        await this.loadOffers(leadId);
    },

    // ── Budget e ri-stesura ─────────────────────────────────────────────────

    offerRedraft(offerId) {
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        if (!o) return;
        this._showModal('Budget e rigenerazione', `
            <form onsubmit="SyrusApp.offerRedraftConfirm(event, '${offerId}')">
                <p class="text-muted small">Cambia il tetto e l'AI rifà la selezione dei moduli
                    e i prezzi. Le voci aggiunte a mano restano.</p>
                ${this.aiDirectivesHint(this._offersData.leadId)}
                <div class="mb-3">
                    <label class="form-label">Nome della variante</label>
                    <input name="title" class="form-control" value="${this._escapeAttr(o.title || '')}">
                </div>
                <div class="mb-3">
                    <label class="form-label">Tetto di budget (&euro;, IVA esclusa) *</label>
                    <input name="budget_cap" type="number" min="1" step="1" class="form-control"
                           inputmode="numeric"
                           value="${o.budget_cap || ''}" required>
                </div>
                <div class="mb-3">
                    <label class="form-label">Istruzioni per l'AI <small class="text-muted">(opzionale)</small></label>
                    <textarea name="instructions" class="form-control" rows="2">${
                        this._escapeHtml(o.ai_instructions || '')}</textarea>
                </div>
                <button type="submit" class="btn btn-primary">
                    <i class="fa-solid fa-rotate me-1"></i>Rigenera l'offerta</button>
            </form>`);
    },

    async offerRedraftConfirm(event, offerId) {
        event.preventDefault();
        const d = Object.fromEntries(new FormData(event.target).entries());
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        const leadId = this._offersData.leadId;
        try {
            const r = await this.api(`/leads/api/${leadId}/offers/${offerId}/budget`, {
                method: 'PUT', body: JSON.stringify({ budget_cap: d.budget_cap, title: d.title }) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            const e = await this.api(`/leads/api/${leadId}/analysis/${offerId}/extract`, {
                method: 'POST', body: JSON.stringify({ instructions: d.instructions || '' }) });
            if (e.error) this.toast(e.error, 'danger');
        } catch (e) { this.toast(e.message, 'danger'); }
        await this.loadOffers(leadId);
    },

    // ── Scheda dell'offerta (riusa quella dell'analisi) ─────────────────────

    offerOpen(offerId) {
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        if (!o) return;
        this._offerData = {
            analysis: o,
            leadId: this._offersData.leadId,
            is_approver: false,
            me_email: this._analysisData ? this._analysisData.me_email : '',
        };
        this._offerEditing = true;

        let modal = document.getElementById('offer-content-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'offer-content-modal';
            modal.className = 'modal fade';
            modal.tabIndex = -1;
            modal.setAttribute('data-bs-backdrop', 'false');
            modal.innerHTML = `<div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"><i class="fa-solid fa-file-invoice-dollar me-2"></i>
                            <span id="offer-content-modal-title"></span></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body" id="offer-content-modal-body"></div>
                </div></div>`;
            document.body.appendChild(modal);
            // Chiudendo la modale il contesto torna all'analisi del tab
            modal.addEventListener('hidden.bs.modal', () => {
                this._offerEditing = false;
                this.loadOffers(this._offersData.leadId);
            });
        }
        this._renderOfferModalBody();
        bootstrap.Modal.getOrCreateInstance(modal).show();
    },

    _renderOfferModalBody() {
        const o = this._offerData && this._offerData.analysis;
        if (!o) return;
        const t = document.getElementById('offer-content-modal-title');
        if (t) {
            const cap = o.budget_cap || 0;
            t.textContent = `${o.title || 'Offerta'} — tetto ${
                window.eurIt ? window.eurIt(cap) : '€ ' + cap}`;
        }
        const body = document.getElementById('offer-content-modal-body');
        if (body) body.innerHTML = this._analysisContentHtml();
    },

    // ── Word ed eliminazione ────────────────────────────────────────────────

    /** Studio dell'offerta: a sinistra i blocchi da sistemare, a destra il
     *  documento che si ridipinge a ogni tasto.
     *
     *  L'anteprima è una replica in HTML, non il Word renderizzato: in
     *  container non c'è né Word né LibreOffice. Contenuto, ordine e stile
     *  vengono dalle stesse funzioni che riempiono il template, quindi quello
     *  che si legge è quello che esce; a differire può essere solo dove cade
     *  l'interruzione di pagina. */
    async offerGenerate(offerId) {
        const leadId = this._offersData.leadId;
        let p;
        try {
            p = await this.api(`/leads/api/${leadId}/offers/${offerId}/preview`);
        } catch (e) { this.toast(e.message, 'danger'); return; }
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        this._setOfferStudio(offerId, p, o);
        this._showModal(
            `<i class="fa-solid fa-file-word me-2 text-success"></i>Offerta${
                o && o.title ? ' — ' + this._escapeHtml(o.title) : ''}`,
            `<div id="offer-studio">${this._offerStudioHtml()}</div>`, 'modal-fullscreen');
        this._offerRenderPdf();
    },

    _setOfferStudio(offerId, data, offer) {
        const compose = (label, text) => text ? `${label}: ${text}` : label;
        // Un'offerta inviata si guarda e si scarica, non si tocca
        const locked = offer ? !!offer.is_locked : (this._offerStudio || {}).locked;
        this._offerStudio = {
            offerId, data, locked, offer: offer || (this._offerStudio || {}).offer,
            mode: data.price_mode || 'detailed',
            // Copia di lavoro: si modifica qui e si salva in blocco, così un
            // ripensamento non lascia mezze modifiche a DB
            activities: (data.activities || []).map(g => ({
                title: g.title,
                items: g.items.map(i => ({id: i.id, text: compose(i.label, i.text)})),
            })),
            economics: (data.economics.rows || []).map(r => ({...r})),
            terms: (data.terms.items || []).map(t => ({...t})),
            removed: [],
            dirty: false,
        };
    },

    _PRICE_MODE_LABELS: {
        detailed: ['Dettaglio dei prezzi', 'Ogni voce con il suo importo.'],
        lump: ['Prezzo a corpo', 'Le voci restano elencate, la cifra compare solo sul totale.'],
    },

    /** Stessa regola del server: o è una cifra che so sommare, o è testo. */
    _parseCost(text) {
        const s = String(text || '').trim();
        const m = s.match(/\d[\d.  ]*(?:,\d+)?/);
        if (!m) return {amount: null, perMonth: false};
        const amount = parseFloat(m[0].replace(/[  .]/g, '').replace(',', '.'));
        const rest = s.replace(m[0], '').replace('€', '').replace('/mese', '')
            .replace(/[  .,·-]/g, '');
        if (rest || isNaN(amount)) return {amount: null, perMonth: false};
        return {amount, perMonth: /\/mese/i.test(s)};
    },

    /** "15.000 €": formato della tabella del documento, non quello dei KPI. */
    _moneyDoc(n) {
        const s = Number(n).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        return (s.endsWith(',00') ? s.slice(0, -3) : s) + ' €';
    },

    _offerCostShown(row) {
        const p = this._parseCost(row.cost);
        if (p.amount === null) return row.cost || 'da definire';
        if (this._offerStudio.mode === 'lump' && !p.perMonth) return 'incluso';
        return row.cost;
    },

    _offerTotalText() {
        const {economics, mode} = this._offerStudio;
        let once = 0, month = 0;
        economics.forEach(r => {
            const p = this._parseCost(r.cost);
            if (p.amount === null) return;
            if (p.perMonth) month += p.amount; else once += p.amount;
        });
        let total = once ? this._moneyDoc(once) : null;
        if (total && mode === 'lump') total += ' a corpo';
        if (month) total = total ? `${total} + ${this._moneyDoc(month)}/mese` : `${this._moneyDoc(month)}/mese`;
        return total || 'da definire';
    },

    // ── Colonna di sinistra: i blocchi ──────────────────────────────────────


    /** Elenco di voci che si leggono e basta. */
    _offerReadOnlyList(righe) {
        const vive = (righe || []).filter(t => (t || '').trim());
        if (!vive.length) return '';
        return `<ul class="offer-ro-list">${vive.map(t => {
            const [label, ...resto] = String(t).split(': ');
            const dettaglio = resto.join(': ');
            return `<li>${dettaglio
                ? `<b>${this._escapeHtml(label)}:</b> ${this._escapeHtml(dettaglio)}`
                : this._escapeHtml(label)}</li>`;
        }).join('')}</ul>`;
    },

    /** L'avviso che dice che l'offerta è uscita di casa. */
    _offerSentBanner(o, extraCls = '') {
        if (!o || !o.sent_at) return '';
        const quando = this.parseDate(o.sent_at).toLocaleDateString('it-IT',
            {day: '2-digit', month: 'long', year: 'numeric'});
        return `<div class="offer-sent-banner ${extraCls}">
            <i class="fa-solid fa-paper-plane"></i>
            <div><b>Offerta inviata al cliente</b> &mdash; ${this._escapeHtml(quando)}${
                o.sent_channel_label ? ' via ' + this._escapeHtml(o.sent_channel_label) : ''}${
                o.sent_by_name ? ' da ' + this._escapeHtml(o.sent_by_name) : ''}.
                <div class="small">Da qui non si modifica e non si elimina: resta agli atti
                    com'è stata mandata.</div></div>
        </div>`;
    },

    /** Segna come inviata: data, canale e mittente. */
    offerMarkSent(offerId) {
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        if (!o) return;
        const oggi = new Date().toISOString().slice(0, 10);
        const utenti = (this._salespersonsCache || []);
        const opzioni = utenti.length
            ? utenti.map(u => `<option value="${this._escapeAttr(u.id)}" ${
                u.id === this._offersData.me ? 'selected' : ''}>${
                this._escapeHtml(u.display_name || u.email)}</option>`).join('')
            : '';
        this._showModal(
            '<i class="fa-solid fa-paper-plane me-2"></i>Segna l\'offerta come inviata', `
            <form onsubmit="SyrusApp.offerMarkSentConfirm(event, '${offerId}')">
                <p class="text-muted small">Una volta segnata, l'offerta si congela: niente
                    modifiche, niente rigenerazione, niente eliminazione. Resta quello che il
                    cliente ha in mano.</p>
                <div class="row g-3">
                    <div class="col-sm-6">
                        <label class="form-label">Data di invio *</label>
                        <input type="date" name="sent_at" class="form-control"
                               max="${oggi}" value="${oggi}" required>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Canale *</label>
                        <select name="channel" class="form-select" required>
                            <option value="email">Email</option>
                            <option value="whatsapp">WhatsApp</option>
                            <option value="altro">Altro canale</option>
                        </select>
                    </div>
                    ${opzioni ? `<div class="col-12">
                        <label class="form-label">Inviata da</label>
                        <select name="sent_by" class="form-select">${opzioni}</select>
                    </div>` : ''}
                </div>
                <button type="submit" class="btn btn-dark mt-3">
                    <i class="fa-solid fa-paper-plane me-1"></i>Segna come inviata</button>
                <button type="button" class="btn btn-outline-secondary mt-3" data-bs-dismiss="modal">Annulla</button>
            </form>`);
    },

    async offerMarkSentConfirm(event, offerId) {
        event.preventDefault();
        const d = Object.fromEntries(new FormData(event.target).entries());
        const leadId = this._offersData.leadId;
        try {
            const r = await this.api(`/leads/api/${leadId}/offers/${offerId}/sent`, {
                method: 'POST', body: JSON.stringify(d) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.toast('Offerta segnata come inviata');
        } catch (e) { this.toast(e.message, 'danger'); return; }
        await this.loadOffers(leadId);
    },

    _offerStudioHtml() {
        return `<div class="offer-studio-wrap">
            <div class="offer-studio-edit">${this._offerEditHtml()}</div>
            <div class="offer-studio-preview">
                <div class="offer-pdf-state" id="offer-pdf-state"
                     onclick="SyrusApp._offerRenderPdf()">Preparo l'anteprima&hellip;</div>
                <iframe id="offer-pdf" title="Anteprima del documento"></iframe>
            </div>
        </div>`;
    },

    /** Frecce su/giù. `call` costruisce la chiamata col verso: i blocchi hanno
     *  handler diversi e le attività portano anche l'indice del gruppo. */
    _moveBtns(call, i, len) {
        return `<span class="offer-row-move">
            <button type="button" class="btn btn-sm btn-link p-0" title="Su"
                    onclick="${call(-1)}" ${i === 0 ? 'disabled' : ''}>
                <i class="fa-solid fa-chevron-up"></i></button>
            <button type="button" class="btn btn-sm btn-link p-0" title="Gi&ugrave;"
                    onclick="${call(1)}" ${i === len - 1 ? 'disabled' : ''}>
                <i class="fa-solid fa-chevron-down"></i></button></span>`;
    },

    _offerEditHtml() {
        const s = this._offerStudio;
        const scelte = Object.entries(this._PRICE_MODE_LABELS).map(([k, [label, desc]]) => `
            <label class="offer-price-mode ${k === s.mode ? 'is-on' : ''}">
                <input type="radio" name="price_mode" value="${k}" ${k === s.mode ? 'checked' : ''}
                       onchange="SyrusApp.offerStudioMode('${k}')">
                <span><b>${label}</b><br><small class="text-muted">${desc}</small></span>
            </label>`).join('');

        const attivita = s.activities.map((g, gi) => `
            <div class="offer-block-group">
                <div class="offer-block-group-title">${this._escapeHtml(g.title)}</div>
                ${s.locked ? this._offerReadOnlyList(g.items.map(i => i.text)) : g.items.map((it, i) => `
                    <div class="offer-edit-row">
                        ${this._moveBtns(d => `SyrusApp.offerActMove(${gi},${i},${d})`, i, g.items.length)}
                        <textarea class="form-control form-control-sm" rows="2"
                            oninput="SyrusApp.offerActEdit(${gi},${i},this.value)"
                            >${this._escapeHtml(it.text)}</textarea>
                        <button type="button" class="btn btn-sm btn-link text-danger p-0" title="Togli"
                            onclick="SyrusApp.offerActRemove(${gi},${i})"><i class="fa-solid fa-trash-can"></i></button>
                    </div>`).join('') || '<div class="text-muted small">Nessuna voce</div>'}
            </div>`).join('');

        const econ = s.locked
            ? s.economics.map(r => `<div class="offer-ro-row"><span>${this._escapeHtml(r.text)}</span>
                <b>${this._escapeHtml(this._offerCostShown(r))}</b></div>`).join('')
            : s.economics.map((r, i) => `
            <div class="offer-edit-row">
                ${this._moveBtns(d => `SyrusApp.offerEconMove(${i},${d})`, i, s.economics.length)}
                <textarea class="form-control form-control-sm" rows="2"
                    oninput="SyrusApp.offerEconEdit(${i},'text',this.value)"
                    >${this._escapeHtml(r.text)}</textarea>
                <input class="form-control form-control-sm offer-cost-input text-center"
                    value="${this._escapeAttr(r.cost)}"
                    oninput="SyrusApp.offerEconEdit(${i},'cost',this.value)">
                <button type="button" class="btn btn-sm btn-link text-danger p-0" title="Togli"
                    onclick="SyrusApp.offerEconRemove(${i})"><i class="fa-solid fa-trash-can"></i></button>
            </div>`).join('');

        // Termini e condizioni non si toccano da qui: sono clausole, non testo
        // commerciale. Si vedono per intero, così si sa cosa si sta mandando.
        const termini = this._offerReadOnlyList(s.terms.map(t => t.text))
            || `<div class="text-muted small">Nessuna condizione: nel documento
                finiscono quelle standard (IVA esclusa, validità 30 giorni).</div>`;

        const pdfUrl = `/leads/api/${this._offersData.leadId}/offers/${s.offerId}/pdf`;
        return `
            <div class="offer-studio-bar">
                ${s.locked ? '' : `
                <button class="btn btn-success btn-sm" onclick="SyrusApp.offerGenerateConfirm()">
                    <i class="fa-solid fa-file-word me-1"></i>Genera il Word</button>
                <button class="btn btn-outline-primary btn-sm" id="offer-studio-save"
                        onclick="SyrusApp.offerStudioSave()" ${s.dirty ? '' : 'disabled'}>
                    <i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>`}
                <a class="btn btn-outline-danger btn-sm" href="${pdfUrl}" download>
                    <i class="fa-solid fa-file-pdf me-1"></i>Scarica PDF</a>
                <span class="small text-warning-emphasis ms-auto" id="offer-studio-dirty"
                      style="${s.dirty && !s.locked ? '' : 'display:none'}">Modifiche non salvate</span>
            </div>
            ${s.locked ? this._offerSentBanner(s.offer, 'mb-3') : ''}

            <div class="offer-block">
                <h6><i class="fa-solid fa-list-check me-1"></i>Attivit&agrave;</h6>
                <p class="text-muted small mb-2">La prima voce di "Oggetto della fornitura" fa anche
                    da riga di apertura in copertina.</p>
                ${attivita || '<div class="text-muted small">Nessuna attivit&agrave;</div>'}
            </div>

            <div class="offer-block">
                <h6><i class="fa-solid fa-euro-sign me-1"></i>Proposta economica</h6>
                <div class="offer-price-modes mb-2">${scelte}</div>
                ${econ || '<div class="text-muted small">Nessuna voce economica</div>'}
                <div class="offer-edit-total">TOTALE <b id="offer-studio-total">${
                    this._escapeHtml(this._offerTotalText())}</b></div>
            </div>

            <div class="offer-block">
                <h6><i class="fa-solid fa-file-signature me-1"></i>Termini e condizioni
                    <span class="offer-ro-tag">non modificabili</span></h6>
                ${termini}
            </div>`;
    },

    // ── Modifiche ───────────────────────────────────────────────────────────

    /** Digitazione: il totale si aggiorna subito, il documento appena si
     *  smette di scrivere. Ridipingere la colonna di sinistra a ogni tasto
     *  farebbe perdere il fuoco al campo. */
    _offerStudioTouched(block, repaint = false) {
        const s = this._offerStudio;
        if (!s.dirty) {
            s.dirty = true;
            const btn = document.getElementById('offer-studio-save');
            const nota = document.getElementById('offer-studio-dirty');
            if (btn) btn.disabled = false;
            if (nota) nota.style.display = '';
        }
        const tot = document.getElementById('offer-studio-total');
        if (tot) tot.textContent = this._offerTotalText();
        if (repaint) this._offerStudioRepaint();
        this._offerRenderSoon(block);
    },

    /** Il documento vero costa un secondo di LibreOffice: si aspetta la pausa
     *  fra una parola e l'altra invece di renderizzare a ogni tasto. */
    _offerRenderSoon(block) {
        const s = this._offerStudio;
        if (!s) return;
        if (block) s.lastBlock = block;
        clearTimeout(s.renderTimer);
        s.renderTimer = setTimeout(() => this._offerRenderPdf(), 900);
    },

    _offerBlocksPayload() {
        const s = this._offerStudio;
        const rimosse = (blocco) => s.removed.filter(r => r.block === blocco)
            .map(r => ({id: r.id, is_removed: true}));
        return {
            activities: [
                ...s.activities.flatMap(g => g.items.map(i => ({id: i.id, text: i.text}))),
                ...rimosse('activities'),
            ],
            economics: [
                ...s.economics.map(r => ({id: r.id, text: r.text, cost: r.cost})),
                ...rimosse('economics'),
            ],
            terms: [
                ...s.terms.map(t => ({id: t.id, text: t.text})),
                ...rimosse('terms'),
            ],
        };
    },

    /** Anteprima = il Word vero convertito in PDF, modifiche non salvate
     *  comprese. Nessuna scrittura: il server compone, renderizza e annulla. */
    async _offerRenderPdf() {
        const s = this._offerStudio;
        if (!s) return;
        const stato = document.getElementById('offer-pdf-state');
        const frame = document.getElementById('offer-pdf');
        if (stato) {
            stato.textContent = 'Aggiorno l\'anteprima…';
            stato.className = 'offer-pdf-state';
            stato.style.display = '';
        }
        const token = (s.renderToken = (s.renderToken || 0) + 1);
        try {
            const resp = await fetch(
                `/leads/api/${this._offersData.leadId}/offers/${s.offerId}/render`, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', 'X-CSRFToken': this._csrfToken()},
                    body: JSON.stringify({price_mode: s.mode, blocks: this._offerBlocksPayload()}),
                });
            // Fra una richiesta e l'altra si continua a scrivere: vince l'ultima
            if (token !== s.renderToken) return;
            if (!resp.ok) {
                const err = await resp.json().catch(() => ({}));
                if (stato) {
                    stato.textContent = (err.error || 'Anteprima non disponibile') + ' — riprova';
                    stato.className = 'offer-pdf-state is-error';
                }
                return;
            }
            let pagine = {};
            try { pagine = JSON.parse(resp.headers.get('X-Doc-Pages') || '{}'); } catch (_) { /* niente */ }
            const url = URL.createObjectURL(await resp.blob());
            if (s.pdfUrl) URL.revokeObjectURL(s.pdfUrl);
            s.pdfUrl = url;
            s.pages = pagine;
            // Si riapre dove si stava lavorando, non in copertina
            s.page = pagine[s.lastBlock] || s.page || 1;
            if (frame) frame.src = `${url}#page=${s.page}&view=FitH&toolbar=1`;
            if (stato) stato.style.display = 'none';
        } catch (e) {
            if (token !== s.renderToken) return;
            if (stato) {
                stato.textContent = 'Anteprima non disponibile — riprova';
                stato.className = 'offer-pdf-state is-error';
            }
        }
    },

    _offerStudioRepaint() {
        const box = document.getElementById('offer-studio');
        if (!box) return;
        // Riordinare la decima voce non deve rispedire in cima a entrambe le
        // colonne: si ridipinge, ma il segno resta dov'era
        const scroll = ['.offer-studio-edit', '.offer-studio-preview']
            .map(sel => (box.querySelector(sel) || {}).scrollTop || 0);
        box.innerHTML = this._offerStudioHtml();
        ['.offer-studio-edit', '.offer-studio-preview'].forEach((sel, i) => {
            const el = box.querySelector(sel);
            if (el) el.scrollTop = scroll[i];
        });
        // La iframe ricreata è vuota: si rimette il PDF che c'era, in attesa
        // che il prossimo render lo aggiorni
        const s = this._offerStudio;
        const frame = document.getElementById('offer-pdf');
        if (frame && s && s.pdfUrl) {
            frame.src = `${s.pdfUrl}#page=${s.page || 1}&view=FitH&toolbar=1`;
            const stato = document.getElementById('offer-pdf-state');
            if (stato) stato.style.display = 'none';
        }
    },

    offerActEdit(gi, i, value) {
        this._offerStudio.activities[gi].items[i].text = value;
        this._offerStudioTouched('activities');
    },
    offerActMove(gi, i, delta) {
        const items = this._offerStudio.activities[gi].items;
        const to = i + delta;
        if (to < 0 || to >= items.length) return;
        [items[i], items[to]] = [items[to], items[i]];
        this._offerStudioTouched('activities', true);
    },
    offerActRemove(gi, i) {
        const items = this._offerStudio.activities[gi].items;
        if (!confirm(`Togliere "${(items[i].text || '').slice(0, 60)}" dall'offerta?`)) return;
        this._offerStudio.removed.push({block: 'activities', id: items[i].id});
        items.splice(i, 1);
        this._offerStudioTouched('activities', true);
    },

    offerEconEdit(i, field, value) {
        this._offerStudio.economics[i][field] = value;
        this._offerStudioTouched('economics');
    },
    offerEconMove(i, delta) {
        const rows = this._offerStudio.economics;
        const to = i + delta;
        if (to < 0 || to >= rows.length) return;
        [rows[i], rows[to]] = [rows[to], rows[i]];
        this._offerStudioTouched('economics', true);
    },
    offerEconRemove(i) {
        const rows = this._offerStudio.economics;
        if (!confirm(`Togliere "${(rows[i].text || '').slice(0, 60)}" dall'offerta?`)) return;
        this._offerStudio.removed.push({block: 'economics', id: rows[i].id});
        rows.splice(i, 1);
        this._offerStudioTouched('economics', true);
    },

    offerTermEdit(i, value) {
        this._offerStudio.terms[i].text = value;
        this._offerStudioTouched('terms');
    },
    offerTermMove(i, delta) {
        const rows = this._offerStudio.terms;
        const to = i + delta;
        if (to < 0 || to >= rows.length) return;
        [rows[i], rows[to]] = [rows[to], rows[i]];
        this._offerStudioTouched('terms', true);
    },
    offerTermRemove(i) {
        const rows = this._offerStudio.terms;
        if (!confirm('Togliere questa condizione?')) return;
        this._offerStudio.removed.push({block: 'terms', id: rows[i].id});
        rows.splice(i, 1);
        this._offerStudioTouched('terms', true);
    },

    offerStudioMode(mode) {
        this._offerStudio.mode = mode;
        this._offerStudioRepaint();
        this._offerRenderSoon('economics');
    },

    /** Salvataggio in blocco. I totali li rifà il server e lo studio si
     *  ridipinge con la sua risposta: se il browser aveva sbagliato un conto,
     *  si vede subito. */
    async offerStudioSave() {
        const s = this._offerStudio;
        if (!s) return null;
        const leadId = this._offersData.leadId;
        const payload = this._offerBlocksPayload();
        try {
            const d = await this.api(`/leads/api/${leadId}/offers/${s.offerId}/content`, {
                method: 'PUT', body: JSON.stringify(payload) });
            const mode = s.mode;
            this._setOfferStudio(s.offerId, d);
            this._offerStudio.mode = mode;
            this._offerStudioRepaint();
            this.toast('Offerta salvata');
            return d;
        } catch (e) {
            this.toast(e.message, 'danger');
            return null;
        }
    },

    async offerGenerateConfirm() {
        const s = this._offerStudio || {};
        if (!s.offerId) return;
        // Chi preme "Genera" si aspetta il Word di quello che vede a schermo
        if (s.dirty && !(await this.offerStudioSave())) return;
        const leadId = this._offersData.leadId;
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${s.offerId}/generate`, {
                method: 'POST', body: JSON.stringify({price_mode: s.mode}) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            if (r.file) this.toast(`Documento generato: ${r.file.name}`, 'success');
            this.loadLeadFiles && this.loadLeadFiles(leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
        await this.loadOffers(leadId);
    },

    async offerDelete(offerId) {
        const o = (this._offersData.offers || []).find(x => x.id === offerId);
        if (!confirm(`Eliminare l'offerta "${(o && o.title) || ''}"? Il Word già generato resta fra i file della lead.`)) return;
        const leadId = this._offersData.leadId;
        try {
            const r = await this.api(`/leads/api/${leadId}/analysis/${offerId}/archive`, {
                method: 'POST', body: JSON.stringify({}) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            this.toast('Offerta eliminata');
        } catch (e) { this.toast(e.message, 'danger'); }
        await this.loadOffers(leadId);
    },
});


// ── app-documents.js ──
/** Syrus Sales OS – Documents Module (pipeline, editor, generation, collaborators) */
Object.assign(SyrusApp, {

    // ── Document Pipeline ──────────────────────────────────────────────────

    /**
     * Banner in testa ai tab Offerta e Contratto: stato Google Drive e brief AI.
     * Lo stesso HTML va in ogni `.doc-banners` (uno per tab), perché i due tab
     * hanno gli stessi prerequisiti.
     */
    async checkDocPrerequisite(leadId) {
        const slots = Array.from(document.querySelectorAll('.doc-banners'));
        if (!slots.length) return;
        const banners = {};
        const paint = () => slots.forEach(slot => {
            slot.innerHTML = ['gdrive', 'brief'].map(k => banners[k] || '').join('');
        });

        // Google Drive: avvisa se il token e' scaduto, senza bloccare
        try {
            const gd = await this.api('/settings/api/gdrive/status');
            if (!gd.credentials_working) {
                banners.gdrive = `<div class="alert alert-warning py-2 mb-3 small d-flex align-items-center gap-2">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <div><strong>Google Drive non connesso</strong> — i documenti generati non saranno caricati su Google Docs. Puoi comunque scaricarli come DOCX.
                    <a href="/settings/" class="alert-link ms-1">Riautorizza da Impostazioni → Google Drive</a></div>
                </div>`;
                paint();
            }
        } catch (e) { /* silent — non bloccare se l'endpoint non risponde */ }

        try {
            const resp = await this.api(`/ai/api/pipeline/latest/${leadId}`);
            if (resp.has_analysis) {
                const a = resp.accepted;
                banners.brief = `<div class="alert alert-success py-2 mb-3 small">
                    <i class="fa-solid fa-brain me-1"></i><strong>Brief AI disponibile:</strong> Score ${a.lead_score || '?'} · Budget €${a.budget_ai_min ? Math.round(a.budget_ai_min).toLocaleString('it-IT') : '?'}–€${a.budget_ai_max ? Math.round(a.budget_ai_max).toLocaleString('it-IT') : '?'} · ${a.timeline_detected || 'Timeline N/D'}
                </div>`;
            } else if (resp.has_pending) {
                banners.brief = `<div class="alert alert-warning py-2 mb-3 small">
                    <i class="fa-solid fa-clock me-1"></i>Hai un'analisi AI in attesa di conferma. Confermala per migliorare la qualità dei documenti generati.
                    <button class="btn btn-warning btn-sm ms-2" onclick="document.querySelector('[data-bs-target=\\'#timeline-pane\\']')?.click();SyrusApp.loadAiIntelligence('${leadId}')">
                        <i class="fa-solid fa-brain me-1"></i>Vai al pannello AI
                    </button>
                </div>`;
            } else {
                banners.brief = `<div class="alert alert-info py-2 mb-3 small">
                    <i class="fa-solid fa-lightbulb me-1"></i><strong>Suggerimento:</strong> l'AI Lead Scoring fornisce un brief strategico che migliora la qualità dei documenti generati.
                    <button class="btn btn-outline-primary btn-sm ms-2" onclick="SyrusApp.startAiPipeline('${leadId}', 'scoring')">
                        <i class="fa-solid fa-brain me-1"></i>Avvia AI Lead Scoring
                    </button>
                </div>`;
            }
            paint();
        } catch (e) { /* silent */ }
    },

    // Un tab per tipo (Offerta, Contratto): questi sono gli unici due punti da
    // cui un documento si genera o si carica. La pipeline resta nei prerequisiti
    // (LeadDocument.PREREQUISITES: il contratto richiede un'offerta esistente).
    _DOC_TABS: [
        {key: 'offer', label: 'Offerta', plural: 'offerte', icon: 'fa-file-invoice-dollar',
         color: 'success', docType: 'offer_document',
         lockMsg: null},
        {key: 'contract', label: 'Contratto', plural: 'contratti', icon: 'fa-file-contract',
         color: 'warning', docType: 'contract_document',
         lockMsg: 'Genera o carica prima l\'Offerta: il Contratto si sblocca da lì.'},
    ],

    _DOC_STATUS: {
        draft:      ['Bozza', 'secondary'],
        review:     ['Revisione', 'warning'],
        approved:   ['Approvato', 'success'],
        sent:       ['Inviato', 'primary'],
        accepted:   ['Accettato', 'success'],
        rejected:   ['Rifiutato', 'danger'],
        generating: ['In corso...', 'info'],
    },

    _docStatusBadge(status) {
        const [label, color] = this._DOC_STATUS[status] || [status, 'secondary'];
        return `<span class="badge bg-${color}">${label}</span>`;
    },

    async loadDocumentPipeline(leadId) {
        // Attivo solo sulla lead detail, dove esistono i pannelli per tipo
        const tabs = this._DOC_TABS.filter(t => document.getElementById(`doc-panel-${t.key}`));
        if (!tabs.length) return;
        try {
            const data = await this.api(`/leads/api/${leadId}/documents`);
            const unlock = data.unlock_status || {};
            const docs = data.documents || [];
            tabs.forEach(t => {
                const own = docs.filter(d => d.doc_type === t.key);
                this._renderDocTypePanel(leadId, t, unlock[t.key] || {}, own);
                this._renderDocTypeList(leadId, t, own);
                this._renderDocTabBadge(t, own);
            });
        } catch (e) {
            console.error('loadDocumentPipeline error:', e);
        }
    },

    /** Badge di stato sul bottone del tab (come fa il tab Analisi). */
    _renderDocTabBadge(tab, docs) {
        const badge = document.getElementById(`${tab.key}-status-badge`);
        if (!badge) return;
        const latest = docs[0];
        if (!latest) { badge.style.display = 'none'; return; }
        const [label, color] = this._DOC_STATUS[latest.status] || [latest.status, 'secondary'];
        badge.className = `badge ms-1 bg-${color}`;
        badge.textContent = label;
        badge.style.display = 'inline-block';
    },

    /** Testata del tab: stato del documento corrente + azioni per generarlo/caricarlo. */
    _renderDocTypePanel(leadId, tab, state, docs) {
        const panel = document.getElementById(`doc-panel-${tab.key}`);
        if (!panel) return;
        const locked = !state.unlocked;
        const latest = docs[0];

        if (locked) {
            panel.innerHTML = `<div class="alert alert-secondary d-flex align-items-center gap-2 mb-0">
                <i class="fa-solid fa-lock"></i>
                <div><strong>${tab.label} bloccato.</strong> ${tab.lockMsg || ''}</div>
            </div>`;
            const card = document.getElementById(`doc-instructions-card-${tab.key}`);
            if (card) card.classList.add('d-none');
            return;
        }
        const card = document.getElementById(`doc-instructions-card-${tab.key}`);
        if (card) card.classList.remove('d-none');

        const genLabel = latest ? 'Nuova versione con AI' : `Genera ${tab.label} con AI`;
        const genClass = latest ? 'btn-outline-primary' : 'btn-primary';
        const actions = `<div class="d-flex flex-wrap gap-2">
            ${latest ? `<button class="btn btn-sm btn-${tab.color}" onclick="SyrusApp.openDocumentEditor('${leadId}','${latest.id}')">
                <i class="fa-solid fa-pen-to-square me-1"></i>Apri
            </button>` : ''}
            <button class="btn btn-sm ${genClass}" onclick="SyrusApp.generateDocument('${leadId}','${tab.docType}')">
                <i class="fa-solid fa-wand-magic-sparkles me-1"></i>${genLabel}
            </button>
            <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.uploadDocumentPdf('${leadId}','${tab.key}')" title="Carica un PDF preparato fuori da Syrus">
                <i class="fa-solid fa-cloud-arrow-up me-1"></i>Carica PDF
            </button>
        </div>`;

        const summary = latest
            ? `<div class="d-flex align-items-center gap-3">
                   <div class="doc-icon-round" style="background:var(--color-brand-light)">
                       <i class="fa-solid ${tab.icon} text-primary"></i>
                   </div>
                   <div>
                       <div class="fw-semibold">${this._escapeHtml(latest.title || tab.label)}</div>
                       <div class="small text-muted">
                           ${this._docStatusBadge(latest.status)}
                           <span class="ms-2">v${latest.version || 1}</span>
                           ${latest.created_at ? `<span class="ms-2">${this.formatDate(latest.created_at)}</span>` : ''}
                       </div>
                   </div>
               </div>`
            : `<div class="d-flex align-items-center gap-3 text-muted">
                   <div class="doc-icon-round" style="border:2px dashed var(--color-border-strong)">
                       <i class="fa-solid ${tab.icon}"></i>
                   </div>
                   <div>
                       <div class="fw-semibold">Nessun${tab.key === 'offer' ? "'offerta" : ' contratto'} per questa lead</div>
                       <div class="small">Generala con l'AI oppure carica un PDF esterno.</div>
                   </div>
               </div>`;

        panel.innerHTML = `<div class="card border-0 bg-light">
            <div class="card-body d-flex justify-content-between align-items-center flex-wrap gap-3">
                ${summary}
                ${actions}
            </div>
        </div>`;
    },

    /** Lista delle versioni di quel solo tipo. */
    _renderDocTypeList(leadId, tab, docs) {
        const docList = document.getElementById(`doc-list-${tab.key}`);
        if (!docList) return;
        if (!docs.length) {
            docList.innerHTML = `<p class="text-muted small mb-0">Nessun documento di tipo ${tab.label}.</p>`;
            return;
        }
        const fullTitle = (d) => this._escapeHtml(d.title || tab.label);
        docList.innerHTML = docs.map(d => `
            <div class="doc-list-item" data-open-editor="${d.id}">
                <div class="doc-icon"><i class="fa-solid ${tab.icon}"></i></div>
                <div class="doc-info">
                    <span class="doc-title" title="${fullTitle(d)}">${fullTitle(d)}</span>
                    ${this._docStatusBadge(d.status)}
                </div>
                <div class="doc-date">${d.created_at ? this.formatDate(d.created_at) : ''}</div>
                <div class="doc-actions">
                    <button class="btn btn-sm btn-outline-primary" onclick="event.stopPropagation();SyrusApp.sendDocumentEmail('${leadId}','${d.id}')" title="Invia Email"><i class="fa-solid fa-envelope"></i></button>
                    <button class="btn btn-sm btn-outline-info" onclick="event.stopPropagation();SyrusApp.shareDocument('${leadId}','${d.id}','${this._escapeAttr(d.title || d.doc_type)}','${d.google_url || ''}')" title="Condividi"><i class="fa-solid fa-share-nodes"></i></button>
                    ${d.file_url ? `<a href="${d.file_url}" class="btn btn-sm btn-outline-secondary" onclick="event.stopPropagation()" download title="Scarica"><i class="fa-solid fa-download"></i></a>` : ''}
                    ${d.google_url ? `<a href="${d.google_url}" class="btn btn-sm btn-outline-success" onclick="event.stopPropagation()" target="_blank" title="Apri in Google"><i class="fa-brands fa-google"></i></a>` : ''}
                    ${d.status === 'draft' ? `<button class="btn btn-sm btn-outline-danger doc-delete-btn" data-doc-id="${d.id}" data-doc-title="${this._escapeAttr(d.title || d.doc_type)}" title="Elimina bozza"><i class="fa-solid fa-trash-can"></i></button>` : ''}
                </div>
            </div>
        `).join('');

        docList.querySelectorAll('.doc-list-item').forEach(el => {
            el.style.cursor = 'pointer';
            el.addEventListener('click', (e) => {
                if (e.target.closest('.doc-actions')) return;
                if (el.dataset.openEditor) this.openDocumentEditor(leadId, el.dataset.openEditor);
            });
        });
        docList.querySelectorAll('.doc-delete-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                this.deleteDocument(leadId, btn.dataset.docId, btn.dataset.docTitle);
            });
        });
    },

    /**
     * Upload PDF esterno come documento (offerta, presentazione, contratto).
     */
    uploadDocumentPdf(leadId, docType) {
        const labels = {offer: 'Offerta', contract: 'Contratto'};
        const label = labels[docType] || docType;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf';
        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;
            if (!file.name.toLowerCase().endsWith('.pdf')) {
                this.toast('Solo file PDF accettati', 'warning');
                return;
            }
            const fd = new FormData();
            fd.append('file', file);
            fd.append('doc_type', docType);
            try {
                this.toast(`Caricamento ${label} in corso...`, 'info');
                const resp = await fetch(`/leads/api/${leadId}/documents/upload`, {
                    method: 'POST',
                    body: fd,
                    headers: { 'X-CSRFToken': this._csrfToken?.() || '' },
                });
                const result = await resp.json();
                if (result.ok) {
                    this.toast(result.message || `${label} caricata!`, 'success');
                    this.loadDocumentPipeline(leadId);
                    this.loadDocumentSidebar(leadId);
                } else {
                    this.toast(result.error || 'Errore caricamento', 'danger');
                }
            } catch (e) {
                this.toast('Errore: ' + e.message, 'danger');
            }
        };
        input.click();
    },

    /**
     * Stato dell'Analisi nella forma che si aspetta la pipeline in sidebar.
     * L'analisi non è un LeadDocument (ha il suo workflow: LeadAnalysis con
     * doppia approvazione), ma nella pipeline è il primo passo: senza di lei
     * offerta e contratto partono al buio.
     */
    async _analysisPipelineStep(leadId) {
        try {
            const data = await this.api(`/leads/api/${leadId}/analysis`);
            const a = data.analysis;
            if (!a) return {unlocked: true, exists: false, status: null};
            return {unlocked: true, exists: true, status: a.status};
        } catch (e) {
            return null;   // endpoint muto: si salta il passo invece di rompere la pipeline
        }
    },

    async loadDocumentSidebar(leadId) {
        const el = document.getElementById('doc-pipeline-sidebar');
        if (!el) return;
        try {
            const [data, analysisStep] = await Promise.all([
                this.api(`/leads/api/${leadId}/documents`),
                this._analysisPipelineStep(leadId),
            ]);
            const unlock = data.unlock_status || {};
            const types = [
                {key:'offer', icon:'fa-file-invoice-dollar', label:'Offerta', color:'#059669'},
                {key:'contract', icon:'fa-file-contract', label:'Contratto', color:'#D97706'},
            ];
            if (analysisStep) {
                unlock.analysis = analysisStep;
                types.unshift({key:'analysis', icon:'fa-clipboard-check', label:'Analisi',
                               color:'#2E75B6', tab:'#analysis-pane'});
            }
            const statusLabels = {draft:'Bozza',review:'In Revisione',approved:'Approvato',sent:'Inviato',accepted:'Accettato',rejected:'Rifiutato',generating:'Generazione...',
                // stati propri del workflow Analisi (LeadAnalysis)
                extracting:'Estrazione…',extracted:'Da inviare',in_review:'In approvazione',changes_requested:'Da rivedere',generated:'Documento generato'};
            const statusColors = {draft:'#64748B',review:'#D97706',approved:'#059669',sent:'#1E40AF',accepted:'#059669',rejected:'#DC2626',generating:'#0891B2',
                extracting:'#0891B2',extracted:'#1E40AF',in_review:'#D97706',changes_requested:'#DC2626',generated:'#059669'};

            let html = '';
            types.forEach((t, i) => {
                const s = unlock[t.key] || {};
                const locked = !s.unlocked;
                const exists = s.exists;
                const status = s.status;

                // Icon
                let iconHtml, statusHtml, cursor, onclick;
                if (locked) {
                    iconHtml = `<div style="width:32px;height:32px;border-radius:50%;background:#F1F5F9;display:flex;align-items:center;justify-content:center"><i class="fa-solid fa-lock" style="font-size:12px;color:#CBD5E1"></i></div>`;
                    statusHtml = `<span style="font-size:11px;color:#CBD5E1">Bloccato</span>`;
                    cursor = 'default';
                    onclick = '';
                } else if (exists) {
                    iconHtml = `<div style="width:32px;height:32px;border-radius:50%;background:${t.color}15;display:flex;align-items:center;justify-content:center"><i class="fa-solid ${t.icon}" style="font-size:14px;color:${t.color}"></i></div>`;
                    statusHtml = `<span style="font-size:11px;color:${statusColors[status] || '#64748B'};font-weight:600">${statusLabels[status] || status}</span>`;
                    cursor = 'pointer';
                    // L'analisi non ha un editor documento: si va al suo tab.
                    onclick = t.key === 'analysis'
                        ? `onclick="SyrusApp._goToAnalysisTab()"`
                        : `onclick="SyrusApp._goToDocument('${leadId}','${s.doc_id}','${t.key}')"`;
                } else {
                    iconHtml = `<div style="width:32px;height:32px;border-radius:50%;border:2px dashed ${t.color};display:flex;align-items:center;justify-content:center"><i class="fa-solid ${t.icon}" style="font-size:12px;color:${t.color}"></i></div>`;
                    const attesa = t.key === 'analysis' ? 'Da caricare' : 'Pronto per generazione';
                    statusHtml = `<span style="font-size:11px;color:${t.color};font-weight:500">${attesa}</span>`;
                    cursor = 'pointer';
                    onclick = t.key === 'analysis'
                        ? `onclick="SyrusApp._goToAnalysisTab()"`
                        : `onclick="SyrusApp._goToDocumentTab('${leadId}','${t.key}')"`;
                }

                html += `<div class="d-flex align-items-center gap-3 py-2 ${i < types.length -1 ? 'border-bottom' : ''}" style="cursor:${cursor}" ${onclick}>`;
                html += iconHtml;
                html += `<div class="flex-grow-1">`;
                html += `<div style="font-size:13px;font-weight:600;color:${locked ? '#CBD5E1' : '#0F172A'}">${t.label}</div>`;
                html += statusHtml;
                html += `</div>`;
                // Connector line
                if (i < types.length - 1) {
                    html += `</div><div style="margin-left:15px;border-left:2px solid ${exists ? t.color : '#E2E8F0'};height:8px"></div>`;
                } else {
                    html += `</div>`;
                }
            });
            el.innerHTML = html;
        } catch (e) {
            el.innerHTML = '<div class="text-muted small">Errore caricamento pipeline</div>';
        }
    },

    /** Apre il tab del tipo (offer|contract) e poi l'editor del documento. */
    _goToDocument(leadId, docId, docType) {
        this._goToDocumentTab(leadId, docType);
        setTimeout(() => this.openDocumentEditor(leadId, docId), 300);
    },

    /** Tab Analisi: click vero sul bottone, così scatta anche il suo loadAnalysis. */
    _goToAnalysisTab() {
        const tab = document.getElementById('analysis-tab-btn');
        if (tab) tab.click();
    },

    _goToDocumentTab(leadId, docType) {
        const key = (docType || 'offer').replace('_document', '');
        const tab = document.querySelector(`[data-bs-target="#${key}-pane"]`)
            || document.querySelector('[data-bs-target="#offer-pane"]');
        if (tab) new bootstrap.Tab(tab).show();
    },

    // ── Document Generation ────────────────────────────────────────────────

    async generateDocument(leadId, docType, extraInstructions) {
        // FIX 1A: Prevent double-click — disabilita il pannello del tipo in corso
        if (this._docGenerating) return;
        this._docGenerating = true;
        const cleanType = docType.replace('_document', '');
        const panel = document.getElementById(`doc-panel-${cleanType}`);
        if (panel) {
            panel.style.pointerEvents = 'none';
            panel.style.opacity = '0.6';
        }

        const instructions = extraInstructions
            || document.getElementById(`ai-instructions-${cleanType}`)?.value || '';
        const progress = document.getElementById(`ai-progress-${cleanType}`);
        const progressMsg = document.getElementById(`ai-progress-msg-${cleanType}`);

        // FIX 1B: Check for existing draft of same type
        try {
            const docsData = await this.api(`/leads/api/${leadId}/documents`);
            const existingDraft = (docsData.documents || []).find(d => d.doc_type === cleanType && d.status === 'draft');
            if (existingDraft) {
                const action = await this._showDuplicateDialog(cleanType);
                if (action === 'cancel') {
                    this._resetGenerateButtons(leadId);
                    return;
                }
                if (action === 'overwrite') {
                    // Delete existing draft before generating
                    await this.api(`/leads/api/${leadId}/documents/${existingDraft.id}`, {method: 'DELETE'});
                }
                // 'new_version' → just proceed, pipeline creates a new version
            }
        } catch (e) { /* proceed anyway */ }

        try {
            progress?.classList.remove('d-none');
            if (progressMsg) progressMsg.textContent = 'Avvio pipeline 3-AI...';

            // Use the new 3-AI document pipeline
            const payload = {lead_id: leadId, doc_type: docType, instructions};
            const resp = await this.api('/ai/api/pipeline/document', {
                method: 'POST',
                body: JSON.stringify(payload),
            });

            if (!resp.ok) {
                progress?.classList.add('d-none');
                this._resetGenerateButtons(leadId);
                if (resp.needs_scoring) {
                    this.toast('Completa prima l\'AI Lead Scoring', 'warning');
                } else if (resp.needs_confirmation) {
                    this.toast('Conferma l\'analisi AI prima di generare documenti', 'warning');
                } else {
                    this.toast(resp.error || 'Errore', 'danger');
                }
                return;
            }

            const jobId = resp.job_id;
            const docLabels = {analysis_document:'Analisi',presentation_document:'Presentazione',offer_document:'Offerta',contract_document:'Contratto',gantt_document:'GANTT',
                               analysis:'Analisi',presentation:'Presentazione',offer:'Offerta',contract:'Contratto',gantt:'GANTT'};
            this.trackOperation(jobId, 'document',
                `${docLabels[docType] || docType}`,
                `/ai/api/status/${jobId}`,
                `/leads/${leadId}`);

            // Poll with granular progress messages
            const poll = async () => {
                try {
                    const status = await this.api(`/ai/api/status/${jobId}`);
                    const op = this._operations?.find(o => o.id === jobId);

                    if (status.status === 'completed') {
                        progress?.classList.add('d-none');
                        this._resetGenerateButtons(leadId);
                        if (op) { op.status = 'completed'; this._renderOps(); }
                        this.toast('Documento generato!', 'success');
                        this.loadDocumentPipeline(leadId);
                        this.loadDocumentSidebar(leadId);
                        // Apri auto-editor solo se siamo sulla lead detail page,
                        // altrimenti l'utente lo apre cliccando l'op nel widget
                        if (status.result?.document_id && document.getElementById(`doc-panel-${cleanType}`)) {
                            const docId = status.result.document_id;
                            setTimeout(() => this.openDocumentEditor(leadId, docId), 500);
                        }
                    } else if (status.status === 'failed') {
                        progress?.classList.add('d-none');
                        this._resetGenerateButtons(leadId);
                        if (op) { op.status = 'failed'; this._renderOps(); }
                        this.toast('Errore: ' + (status.error || 'Generazione fallita'), 'danger');
                    } else {
                        // Update progress message from backend
                        if (status.result?.progress_message) {
                            if (progressMsg) progressMsg.textContent = status.result.progress_message;
                            if (op) {
                                op.label = status.result.progress_message;
                                if (status.result.progress_lines) {
                                    op.progressLines = status.result.progress_lines;
                                }
                                this._renderOps();
                            }
                        }
                        setTimeout(poll, 2500);
                    }
                } catch (e) {
                    setTimeout(poll, 3000);
                }
            };
            setTimeout(poll, 2000);
        } catch (e) {
            progress?.classList.add('d-none');
            this._resetGenerateButtons(leadId);
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async approveDocument(leadId, docId) {
        try {
            const result = await this.api(`/leads/api/${leadId}/documents/${docId}/approve`, {method: 'POST'});
            if (result.error) throw new Error(result.error);
            this.toast('Documento approvato', 'success');
            this.loadDocumentPipeline(leadId);
            this.loadDocumentSidebar(leadId);
            // Update lead status badge inline (no page reload)
            const data = await this.api(`/leads/api/${leadId}/detail`);
            if (data.status) {
                const badge = document.querySelector('.badge-status-contacted, .badge-status-new, .badge-status-qualified, .badge-status-proposal_sent, .badge-status-negotiation, .badge-status-won, .badge-status-lost, .badge-status-dormant, [class*="badge-status-"]');
                if (badge) {
                    badge.className = `badge badge-status-${data.status} fw-bold`;
                    badge.textContent = data.status.toUpperCase();
                }
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async deleteDocument(leadId, docId, title) {
        if (!confirm(`Eliminare la bozza "${title || 'documento'}"?\nQuesta azione non pu\u00f2 essere annullata.`)) return;
        try {
            await this.api(`/leads/api/${leadId}/documents/${docId}`, {method: 'DELETE'});
            this.toast('Bozza eliminata', 'success');
            this.loadDocumentPipeline(leadId);
            this.loadDocumentSidebar(leadId);
            // Close modal if open
            this._closeAllModals();
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    _resetGenerateButtons(leadId) {
        this._docGenerating = false;
        // Re-render pipeline to restore buttons
        this.loadDocumentPipeline(leadId);
    },

    _showDuplicateDialog(docType) {
        const labels = {analysis:'Analisi',offer:'Offerta',contract:'Contratto',presentation:'Presentazione',gantt:'GANTT'};
        const label = labels[docType] || docType;
        return new Promise(resolve => {
            const modal = document.createElement('div');
            modal.className = 'modal fade';
            modal.tabIndex = -1;
            modal.innerHTML = `<div class="modal-dialog modal-dialog-centered"><div class="modal-content">
                <div class="modal-header"><h6 class="modal-title">Documento esistente</h6><button type="button" class="btn-close" data-bs-dismiss="modal"></button></div>
                <div class="modal-body"><p>Esiste gi\u00e0 una bozza di <strong>${label}</strong>. Cosa vuoi fare?</p></div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-action="cancel">Annulla</button>
                    <button class="btn btn-warning" data-action="overwrite"><i class="fa-solid fa-rotate me-1"></i>Sovrascrivi</button>
                    <button class="btn btn-primary" data-action="new_version"><i class="fa-solid fa-plus me-1"></i>Nuova versione</button>
                </div>
            </div></div>`;
            document.body.appendChild(modal);
            const bsModal = new bootstrap.Modal(modal);
            modal.querySelectorAll('[data-action]').forEach(btn => {
                btn.addEventListener('click', () => {
                    resolve(btn.dataset.action);
                    bsModal.hide();
                });
            });
            modal.addEventListener('hidden.bs.modal', () => {
                resolve('cancel');
                modal.remove();
            });
            bsModal.show();
        });
    },

    // ── Document Editor ────────────────────────────────────────────────────

    async openDocumentEditor(leadId, docId) {
        try {
            const doc = await this.api(`/leads/api/${leadId}/documents/${docId}`);
            const isEditable = ['analysis', 'offer', 'contract'].includes(doc.doc_type);
            const isGantt = doc.doc_type === 'gantt';
            // Solo i tipi con un tab dedicato si rigenerano: sui documenti storici
            // (analisi, presentazione, GANTT) il bottone sparisce invece di dare 400.
            const isRegenerable = this._DOC_TABS.some(t => t.key === doc.doc_type);
            // Uploaded PDF: use proxy endpoint for preview (Drive embed doesn't work in iframe)
            const isUploadedPdf = doc.google_file_id && !doc.file_url && !doc.content_json;
            // Derive embed URL from google_url if google_embed_url is missing
            if (!doc.google_embed_url && doc.google_url) {
                doc.google_embed_url = doc.google_url
                    .replace('/preview', '/edit')
                    .replace(/\/edit(\?.*)?$/, '/edit?embedded=true');
                if (!doc.google_embed_url.includes('embedded=true')) {
                    doc.google_embed_url += (doc.google_embed_url.includes('?') ? '&' : '?') + 'embedded=true';
                }
            }
            const hasGoogle = !isUploadedPdf && !!doc.google_embed_url;

            const statusOptions = ['draft', 'review', 'approved', 'sent', 'accepted', 'rejected'].map(s => {
                const labels = {draft:'Bozza', review:'In Revisione', approved:'Approvato', sent:'Inviato', accepted:'Accettato', rejected:'Rifiutato'};
                return `<option value="${s}" ${doc.status === s ? 'selected' : ''}>${labels[s] || s}</option>`;
            }).join('');

            const typeLabels = {analysis:'Analisi', presentation:'Presentazione', offer:'Offerta', contract:'Contratto', gantt:'GANTT'};

            this._showModal(
                `<i class="fa-solid fa-file-lines me-2"></i>${this._escapeHtml(doc.title || typeLabels[doc.doc_type])}`,
                `<div class="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="d-flex gap-2 align-items-center">
                        <select class="form-select form-select-sm" style="width:auto" id="doc-status-select" onchange="SyrusApp._updateDocStatus('${leadId}','${docId}',this.value)">
                            ${statusOptions}
                        </select>
                        ${isGantt && doc.status !== 'approved' ? `<button class="btn btn-sm btn-success" onclick="SyrusApp.approveDocument('${leadId}','${docId}')"><i class="fa-solid fa-check me-1"></i>Approva GANTT</button>` : ''}
                        ${doc.doc_type === 'analysis' && doc.status === 'draft' ? `<button class="btn btn-sm btn-success doc-approve-pulse" onclick="SyrusApp.approveDocument('${leadId}','${docId}')"><i class="fa-solid fa-check me-1"></i>Approva</button>` : ''}
                    </div>
                    <div class="d-flex gap-2">
                        ${!isUploadedPdf && isRegenerable ? `<button class="btn btn-sm btn-outline-warning" onclick="SyrusApp.regenerateDocument('${leadId}','${doc.doc_type}')"><i class="fa-solid fa-rotate me-1"></i>Rigenera AI</button>` : ''}
                        ${doc.google_url ? `<a href="${doc.google_url}" class="btn btn-sm btn-success" target="_blank"><i class="fa-brands fa-google me-1"></i>Apri in Google</a>` : ''}
                        ${doc.file_url ? `<a href="${doc.file_url}" class="btn btn-sm btn-outline-primary" download><i class="fa-solid fa-download me-1"></i>Scarica</a>` : ''}
                        ${!isUploadedPdf ? `<button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.exportDocument('${leadId}','${docId}','pdf')"><i class="fa-solid fa-file-pdf me-1"></i>PDF</button>` : ''}
                        <button class="btn btn-sm btn-primary" onclick="SyrusApp.sendDocumentEmail('${leadId}','${docId}')"><i class="fa-solid fa-paper-plane me-1"></i>Invia Email</button>
                        ${isEditable && !hasGoogle && !isUploadedPdf ? `<button class="btn btn-sm btn-success" onclick="SyrusApp.saveDocumentContent('${leadId}','${docId}')"><i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>` : ''}
                        ${!isUploadedPdf ? `<button class="btn btn-sm btn-outline-info" onclick="SyrusApp.manageCollaborators('${leadId}','${docId}','${doc.google_file_id || ''}')"><i class="fa-solid fa-user-plus me-1"></i>Collaboratori</button>` : ''}
                        ${doc.status === 'draft' ? `<button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteDocument('${leadId}','${docId}','${this._escapeAttr(doc.title || '')}')"><i class="fa-solid fa-trash-can me-1"></i>Elimina</button>` : ''}
                    </div>
                </div>
                <div id="doc-editor-container" style="flex:1;min-height:0">
                    ${hasGoogle
                        ? `<iframe src="${doc.google_embed_url}" style="width:100%;height:calc(100vh - 180px);border:1px solid #dee2e6;border-radius:8px" allowfullscreen></iframe>`
                        : isUploadedPdf
                            ? `<iframe src="/leads/api/${leadId}/documents/${docId}/preview-pdf" style="width:100%;height:calc(100vh - 180px);border:1px solid #dee2e6;border-radius:8px"></iframe>`
                        : doc.file_url
                            ? `<div class="d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded p-5">
                                <i class="fa-solid fa-file-word fa-4x text-primary mb-3"></i>
                                <h5 class="fw-bold mb-2">${this._escapeHtml(doc.title || 'Documento')}</h5>
                                <p class="text-muted mb-4 text-center">Il documento è stato generato come file DOCX dal template.<br>Scaricalo per visualizzarlo o caricalo su Google Drive.</p>
                                <div class="d-flex gap-2">
                                    <a href="${doc.file_url}" class="btn btn-primary" download><i class="fa-solid fa-download me-1"></i>Scarica DOCX</a>
                                    <button class="btn btn-outline-primary" onclick="SyrusApp.exportDocument('${leadId}','${docId}','pdf')"><i class="fa-solid fa-file-pdf me-1"></i>Esporta PDF</button>
                                </div>
                              </div>`
                            : isGantt && doc.content_html
                                ? `<div class="border rounded p-3 bg-white" style="height:calc(100vh - 200px);overflow-y:auto;overflow-x:auto">${doc.content_html}</div>`
                                : `<div class="d-flex flex-column align-items-center justify-content-center h-100 bg-light rounded p-5">
                                    <i class="fa-solid fa-circle-exclamation fa-3x text-warning mb-3"></i>
                                    <h5>Documento non ancora pronto</h5>
                                    <p class="text-muted">La generazione potrebbe essere ancora in corso. Riprova tra qualche secondo.</p>
                                  </div>`
                    }
                </div>`,
                'modal-fullscreen'
            );

            // Initialize TinyMCE for editable docs
            if (isEditable && typeof tinymce !== 'undefined') {
                setTimeout(() => {
                    tinymce.remove('#doc-editor-area');
                    tinymce.init({
                        selector: '#doc-editor-area',
                        height: window.innerHeight - 160,
                        plugins: 'table lists link image code fullscreen pagebreak searchreplace',
                        toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | pagebreak | link image | searchreplace code fullscreen',
                        toolbar_mode: 'wrap',
                        menubar: 'file edit view insert format table',
                        language: 'it',
                        language_url: 'https://cdn.jsdelivr.net/npm/tinymce-i18n/langs7/it.js',
                        license_key: 'gpl',
                        promotion: false,
                        branding: false,
                        skin: 'oxide',
                        content_css: 'document',
                        font_family_formats: 'Inter=Inter,sans-serif;Arial=arial,helvetica;Georgia=georgia,palatino;Times New Roman=times new roman,times',
                        font_size_formats: '10px 11px 12px 13px 14px 16px 18px 20px 24px',
                        content_style: `
                            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
                            body {
                                font-family: 'Inter', sans-serif;
                                font-size: 13px;
                                line-height: 1.7;
                                color: #0F172A;
                                max-width: 794px;
                                margin: 20px auto;
                                padding: 60px 60px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0,0,0,0.05);
                                min-height: 1123px;
                            }
                            h1 { font-size: 22px; color: #0F172A; margin-top: 24px; }
                            h2 { font-size: 17px; color: #1E40AF; border-bottom: 2px solid #E2E8F0; padding-bottom: 6px; margin-top: 24px; }
                            h3 { font-size: 14px; color: #334155; margin-top: 18px; }
                            table { border-collapse: collapse; width: 100%; margin: 12px 0; }
                            th { background: #1E40AF; color: #fff; padding: 10px 12px; text-align: left; font-size: 13px; }
                            td { padding: 8px 12px; border-bottom: 1px solid #E2E8F0; font-size: 13px; }
                            p { margin: 6px 0; }
                            ul, ol { margin: 8px 0; }
                            li { margin-bottom: 4px; }
                        `,
                        body_class: 'syrus-doc',
                        statusbar: true,
                        resize: false,
                    });
                }, 300);
            }
        } catch (e) {
            this.toast('Errore apertura documento: ' + e.message, 'danger');
        }
    },

});


// ── app-documents-ops.js ──
/** Syrus Sales OS – Documents Module (pipeline, editor, generation, collaborators) */
Object.assign(SyrusApp, {

    // ── Document Operations ────────────────────────────────────────────────

    async saveDocumentContent(leadId, docId) {
        try {
            let html = '';
            if (typeof tinymce !== 'undefined' && tinymce.get('doc-editor-area')) {
                html = tinymce.get('doc-editor-area').getContent();
            }
            await this.api(`/leads/api/${leadId}/documents/${docId}`, {
                method: 'PUT',
                body: JSON.stringify({content_html: html}),
            });
            this.toast('Documento salvato', 'success');
            this.loadDocumentPipeline(leadId);
        } catch (e) {
            this.toast('Errore salvataggio: ' + e.message, 'danger');
        }
    },

    async exportDocument(leadId, docId, format) {
        if (format === 'pdf') {
            // Client-side PDF via browser print dialog
            try {
                const doc = await this.api(`/leads/api/${leadId}/documents/${docId}`);
                const printWin = window.open('', '_blank');
                printWin.document.write(`<!DOCTYPE html><html><head><title>${this._escapeHtml(doc.title || 'Documento')}</title>
                    <style>
                        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');
                        body { font-family: 'Inter', sans-serif; font-size: 13px; line-height: 1.7; color: #0F172A; max-width: 800px; margin: 0 auto; padding: 40px; }
                        h1 { font-size: 22px; color: #0F172A; } h2 { font-size: 17px; color: #1E40AF; border-bottom: 2px solid #E2E8F0; padding-bottom: 6px; }
                        h3 { font-size: 14px; color: #334155; } table { border-collapse: collapse; width: 100%; }
                        th { background: #1E40AF; color: #fff; padding: 10px 12px; text-align: left; }
                        td { padding: 8px 12px; border-bottom: 1px solid #E2E8F0; }
                        @media print { body { padding: 0; } @page { margin: 2cm; } }
                    </style></head><body>${doc.content_html || ''}</body></html>`);
                printWin.document.close();
                setTimeout(() => { printWin.print(); }, 500);
            } catch (e) {
                this.toast('Errore PDF: ' + e.message, 'danger');
            }
            return;
        }
        // DOCX/PPTX/XLSX download
        try {
            const resp = await this.api(`/leads/api/${leadId}/documents/${docId}/export`, {
                method: 'POST',
                body: JSON.stringify({format}),
            });
            if (resp.url) {
                window.open(resp.url, '_blank');
            } else {
                this.toast(resp.error || 'Export non disponibile', 'warning');
            }
        } catch (e) {
            this.toast('Errore export: ' + e.message, 'danger');
        }
    },

    async regenerateDocument(leadId, docType) {
        const typeLabels = {analysis:'Analisi', presentation:'Presentazione', offer:'Offerta', contract:'Contratto', gantt:'GANTT'};
        const label = typeLabels[docType] || docType;

        this._showModal(`<i class="fa-solid fa-rotate me-2"></i>Rigenera ${label}`, `
            <p class="text-muted small">Il documento verrà rigenerato dall'AI. Puoi fornire istruzioni aggiuntive per personalizzare il risultato.</p>
            <div class="mb-3">
                <label class="form-label fw-medium">Istruzioni per la rigenerazione (opzionale)</label>
                <textarea class="form-control" id="regen-instructions" rows="3" placeholder="Es: Aggiungi una sezione sul budget, cambia il tono in più formale, aggiungi dettagli tecnici..."></textarea>
            </div>
            <div class="d-flex gap-2 justify-content-end">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-warning" id="regen-btn" onclick="SyrusApp._executeRegenerate('${leadId}','${docType}')">
                    <i class="fa-solid fa-rotate me-1"></i>Rigenera con AI
                </button>
            </div>
        `);
    },

    async _executeRegenerate(leadId, docType) {
        const instructions = document.getElementById('regen-instructions')?.value || '';
        const btn = document.getElementById('regen-btn');
        if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Rigenerazione...'; }

        // Close the regen modal
        const modal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
        if (modal) modal.hide();

        // Regenerate with instructions
        const fullDocType = docType + '_document';
        this.generateDocument(leadId, fullDocType, instructions);
    },

    async approveDocument(leadId, docId) {
        try {
            await this.api(`/leads/api/${leadId}/documents/${docId}/approve`, {method: 'POST'});
            this.toast('Documento approvato', 'success');
            this.loadDocumentPipeline(leadId);
            // Close and reopen
            const modal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
            if (modal) modal.hide();
        } catch (e) {
            this.toast('Errore approvazione: ' + e.message, 'danger');
        }
    },

    async _updateDocStatus(leadId, docId, status) {
        try {
            await this.api(`/leads/api/${leadId}/documents/${docId}/status`, {
                method: 'PUT',
                body: JSON.stringify({status}),
            });
            this.toast('Stato aggiornato', 'success');
            this.loadDocumentPipeline(leadId);
        } catch (e) {
            this.toast('Errore aggiornamento stato: ' + e.message, 'danger');
        }
    },

    // ── Share Document ──────────────────────────────────────────────────────

    shareDocument(leadId, docId, docTitle, googleUrl) {
        const linkSection = googleUrl
            ? `<div class="mb-3"><label class="form-label fw-bold small">Link documento</label><div class="input-group"><input type="text" class="form-control form-control-sm" value="${googleUrl}" readonly id="share-doc-link"><button class="btn btn-outline-secondary btn-sm" onclick="navigator.clipboard.writeText(document.getElementById('share-doc-link').value);SyrusApp.toast('Link copiato','success')"><i class="fa-solid fa-copy"></i></button></div></div>`
            : '<div class="alert alert-warning py-2 small">Nessun link Google disponibile per questo documento.</div>';

        this._showModal(
            '<i class="fa-solid fa-share-nodes me-2"></i>Condividi Documento',
            `${linkSection}
            <hr>
            <p class="small text-muted">Invia il link via email a un collaboratore:</p>
            <div class="mb-3">
                <label class="form-label fw-bold small">Email destinatario</label>
                <input type="email" class="form-control" id="share-doc-email" placeholder="email@esempio.com">
            </div>
            <div class="mb-3">
                <label class="form-label fw-bold small">Messaggio (opzionale)</label>
                <textarea class="form-control" id="share-doc-message" rows="3" placeholder="Ciao, condivido con te questo documento..."></textarea>
            </div>
            <button class="btn btn-primary" onclick="SyrusApp._sendShareEmail('${leadId}','${docId}','${this._escapeAttr(docTitle)}','${googleUrl || ''}')">
                <i class="fa-solid fa-paper-plane me-1"></i>Invia Invito
            </button>`,
            'modal-md'
        );
    },

    async _sendShareEmail(leadId, docId, docTitle, googleUrl) {
        const email = document.getElementById('share-doc-email')?.value?.trim();
        const message = document.getElementById('share-doc-message')?.value?.trim() || '';
        if (!email) { this.toast('Inserisci un\'email', 'warning'); return; }
        if (!googleUrl) { this.toast('Nessun link documento disponibile', 'warning'); return; }

        try {
            await this.api('/communications/api/email/send', {
                method: 'POST',
                body: JSON.stringify({
                    lead_id: leadId,
                    to_email: email,
                    subject: `Documento condiviso: ${docTitle}`,
                    body_html: `<p>${message ? this._escapeHtml(message) + '</p><p>' : ''}Ti \u00e8 stato condiviso il seguente documento:</p><p><strong>${this._escapeHtml(docTitle)}</strong></p><p><a href="${googleUrl}">Apri documento</a></p><p>Cordiali saluti<br>Syrus Industry S.r.l.</p>`,
                }),
            });
            this.toast('Invito inviato!', 'success');
            this._closeAllModals();
        } catch (e) {
            this.toast('Errore invio: ' + e.message, 'danger');
        }
    },

    // ── Collaborators Management ───────────────────────────────────────────

    async manageCollaborators(leadId, docId, googleFileId) {
        // Salva il file corrente per la condivisione
        this._shareDocId = docId || '';
        this._shareGoogleFileId = googleFileId || '';

        try {
            const resp = await this.api(`/guest/api/collaborators/${leadId}`);
            const collabs = Array.isArray(resp) ? resp : [];

            const collabRows = collabs.length > 0
                ? collabs.map(c => `
                    <div class="d-flex align-items-center justify-content-between py-2 border-bottom">
                        <div>
                            <div class="fw-medium small">${this._escapeHtml(c.name || c.email)}</div>
                            <small class="text-muted">${this._escapeHtml(c.email)} – ${c.role === 'editor' ? 'Editor' : 'Visualizzatore'}</small>
                            ${c.last_access ? `<br><small class="text-muted"><i class="fa-solid fa-clock me-1"></i>Ultimo accesso: ${SyrusApp.parseDate(c.last_access).toLocaleString('it-IT')}</small>` : '<br><small class="text-muted fst-italic">Mai acceduto</small>'}
                        </div>
                        <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp._revokeCollaborator('${c.id}','${leadId}')">
                            <i class="fa-solid fa-user-xmark"></i>
                        </button>
                    </div>
                `).join('')
                : '<div class="text-muted text-center py-3">Nessun collaboratore</div>';

            this._showModal('<i class="fa-solid fa-share-nodes me-2"></i>Condividi Documento', `
                <div class="mb-4">
                    <h6 class="fw-bold mb-3">Condividi con un collaboratore</h6>
                    <p class="small text-muted">Il collaboratore ricevera' una notifica da Google Drive con il link diretto al documento.</p>
                    <div class="row g-2 mb-2">
                        <div class="col-md-4">
                            <input type="text" class="form-control form-control-sm" id="collab-name" placeholder="Nome">
                        </div>
                        <div class="col-md-5">
                            <input type="email" class="form-control form-control-sm" id="collab-email" placeholder="Email Google *" required>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select form-select-sm" id="collab-role">
                                <option value="viewer">Sola lettura</option>
                                <option value="editor">Può modificare</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn btn-sm btn-primary" onclick="SyrusApp._inviteCollaborator('${leadId}')">
                        <i class="fa-solid fa-paper-plane me-1"></i>Condividi
                    </button>
                </div>
                <hr>
                <h6 class="fw-bold mb-3">Collaboratori</h6>
                <div id="collab-list">${collabRows}</div>
            `);
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async _inviteCollaborator(leadId) {
        const email = document.getElementById('collab-email')?.value?.trim();
        const name = document.getElementById('collab-name')?.value?.trim();
        const role = document.getElementById('collab-role')?.value || 'viewer';

        if (!email) {
            this.toast('Inserisci un indirizzo email', 'warning');
            return;
        }

        try {
            const result = await this.api('/guest/api/invite', {
                method: 'POST',
                body: JSON.stringify({
                    lead_id: leadId, email, name, role,
                    google_file_id: this._shareGoogleFileId || '',
                }),
            });
            if (result.ok) {
                this.toast(result.message, 'success');
                this.manageCollaborators(leadId); // reload
            } else {
                this.toast(result.error || 'Errore invito', 'danger');
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async _revokeCollaborator(collabId, leadId) {
        if (!confirm('Revocare l\'accesso a questo collaboratore?')) return;
        try {
            const result = await this.api(`/guest/api/collaborators/${collabId}/revoke`, { method: 'POST' });
            if (result.ok) {
                this.toast(result.message, 'success');
                this.manageCollaborators(leadId); // reload
            } else {
                this.toast(result.error || 'Errore', 'danger');
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    // ── Send Document Email ────────────────────────────────────────────────

    async sendDocumentEmail(leadId, docId) {
        // Load lead data + all documents to build the modal
        try {
            const leadData = await this.api(`/leads/api/${leadId}`);
            const docsData = await this.api(`/leads/api/${leadId}/documents`);
            const docs = docsData.documents || [];
            const lead = leadData;

            const typeLabels = {analysis:'Analisi', presentation:'Presentazione', offer:'Offerta', contract:'Contratto', gantt:'GANTT'};

            // AI-suggested subject/body based on doc type
            const doc = docs.find(d => d.id === docId);
            const docType = doc ? doc.doc_type : 'analysis';
            const subjects = {
                analysis: `Analisi preliminare progetto – ${lead.company_name || ''}`,
                presentation: `Presentazione proposta – ${lead.company_name || ''}`,
                offer: `Offerta economica progetto ${lead.project_type || ''} – ${lead.company_name || ''}`,
                contract: `Contratto progetto – ${lead.company_name || ''}`,
                gantt: `Piano operativo progetto – ${lead.company_name || ''}`,
            };
            const bodies = {
                analysis: `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>in allegato trova il documento di analisi preliminare del progetto <strong>${lead.project_type || ''}</strong>.</p><p>Il documento descrive la nostra comprensione delle vostre esigenze e l'approccio proposto.</p><p>Resto a disposizione per approfondire qualsiasi punto.</p><p>Cordiali saluti</p>`,
                presentation: `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>in allegato la presentazione della nostra proposta per il progetto <strong>${lead.project_type || ''}</strong>.</p><p>Sarà un piacere illustrarle i dettagli in una call dedicata.</p><p>Cordiali saluti</p>`,
                offer: `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>come concordato, in allegato trova l'offerta economica per il progetto <strong>${lead.project_type || ''}</strong>.</p><p>L'offerta include il dettaglio delle fasi, i tempi di realizzazione e le condizioni economiche.</p><p>Resto a disposizione per eventuali chiarimenti.</p><p>Cordiali saluti</p>`,
                contract: `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>in allegato il contratto per il progetto <strong>${lead.project_type || ''}</strong>.</p><p>La prego di verificare i termini e di contattarmi per qualsiasi modifica.</p><p>Cordiali saluti</p>`,
                gantt: `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>in allegato il piano operativo (GANTT) del progetto <strong>${lead.project_type || ''}</strong> con le fasi, le attività e le tempistiche previste.</p><p>Cordiali saluti</p>`,
            };

            const defaultSubject = subjects[docType] || `Documento – ${lead.company_name || ''}`;
            const defaultBody = bodies[docType] || `<p>Gentile ${lead.contact_name || 'Cliente'},</p><p>in allegato il documento richiesto.</p><p>Cordiali saluti</p>`;

            // Build document checkboxes
            const docChecks = docs.map(d => {
                const checked = d.id === docId ? 'checked' : '';
                return `<div class="form-check">
                    <input class="form-check-input" type="checkbox" value="${d.id}" id="att-${d.id}" ${checked}>
                    <label class="form-check-label small" for="att-${d.id}">
                        <i class="fa-solid fa-file-pdf text-danger me-1"></i>${this._escapeHtml(d.title || typeLabels[d.doc_type] || d.doc_type)}
                        <span class="badge bg-secondary ms-1">${d.status}</span>
                    </label>
                </div>`;
            }).join('');

            this._showModal(
                '<i class="fa-solid fa-paper-plane me-2"></i>Invia Documenti via Email',
                `<div class="row g-3">
                    <div class="col-12">
                        <label class="form-label fw-bold small">Destinatario</label>
                        <input type="email" class="form-control" id="send-doc-to" value="${this._escapeHtml(lead.contact_email || '')}">
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold small">Mittente (nome)</label>
                        <input type="text" class="form-control" id="send-doc-from-name" value="Syrus Industry" placeholder="Nome mittente">
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold small">Mittente (email)</label>
                        <input type="email" class="form-control" id="send-doc-from-email" value="" placeholder="Default: email configurata Brevo">
                        <div class="form-text">Vuoto = usa mittente predefinito</div>
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-bold small">Oggetto</label>
                        <input type="text" class="form-control" id="send-doc-subject" value="${this._escapeHtml(defaultSubject)}">
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-bold small">Corpo Email</label>
                        <div class="border rounded">
                            <div class="d-flex flex-wrap gap-1 p-2 border-bottom bg-light" id="send-doc-toolbar">
                                <button type="button" class="btn btn-sm btn-outline-secondary" onclick="document.execCommand('bold')" title="Grassetto"><i class="fa-solid fa-bold"></i></button>
                                <button type="button" class="btn btn-sm btn-outline-secondary" onclick="document.execCommand('italic')" title="Corsivo"><i class="fa-solid fa-italic"></i></button>
                                <button type="button" class="btn btn-sm btn-outline-secondary" onclick="document.execCommand('underline')" title="Sottolineato"><i class="fa-solid fa-underline"></i></button>
                                <div class="vr mx-1"></div>
                                <select class="form-select form-select-sm" style="width:auto" onchange="document.execCommand('fontSize',false,this.value);this.value='';" title="Dimensione testo">
                                    <option value="">Dimensione</option>
                                    <option value="1">Piccolo</option>
                                    <option value="3">Normale</option>
                                    <option value="5">Grande</option>
                                    <option value="7">Molto grande</option>
                                </select>
                                <div class="vr mx-1"></div>
                                <button type="button" class="btn btn-sm btn-outline-secondary" onclick="document.execCommand('insertUnorderedList')" title="Elenco puntato"><i class="fa-solid fa-list-ul"></i></button>
                                <button type="button" class="btn btn-sm btn-outline-secondary" onclick="document.execCommand('removeFormat')" title="Rimuovi formattazione"><i class="fa-solid fa-eraser"></i></button>
                            </div>
                            <div contenteditable="true" id="send-doc-body" class="p-3" style="min-height:150px;max-height:300px;overflow-y:auto;outline:none">${defaultBody}</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label class="form-label fw-bold small">Documenti da allegare (PDF)</label>
                        <div class="border rounded p-2">${docChecks || '<span class="text-muted small">Nessun documento generato</span>'}</div>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-primary w-100" onclick="SyrusApp._executeSendDocEmail('${leadId}')">
                            <i class="fa-solid fa-paper-plane me-1"></i> Invia Email con Allegati
                        </button>
                    </div>
                </div>`,
                'modal-lg'
            );
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async _executeSendDocEmail(leadId) {
        const to = document.getElementById('send-doc-to')?.value?.trim();
        const subject = document.getElementById('send-doc-subject')?.value?.trim();
        const bodyEl = document.getElementById('send-doc-body');
        const bodyHtml = bodyEl ? bodyEl.innerHTML.trim() : '';
        const senderEmail = document.getElementById('send-doc-from-email')?.value?.trim() || '';
        const senderName = document.getElementById('send-doc-from-name')?.value?.trim() || '';

        const docIds = [];
        document.querySelectorAll('[id^="att-"]:checked').forEach(cb => docIds.push(cb.value));

        if (!to) { this.toast('Inserisci il destinatario', 'warning'); return; }
        if (!subject) { this.toast('Inserisci l\'oggetto', 'warning'); return; }
        if (!docIds.length) { this.toast('Seleziona almeno un documento', 'warning'); return; }

        // Show spinner on button
        const btn = document.querySelector('[onclick*="_executeSendDocEmail"]');
        const btnOriginal = btn ? btn.innerHTML : '';
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i> Preparazione allegati e invio in corso...';
        }

        try {
            const result = await this.api(`/leads/api/${leadId}/documents/send-email`, {
                method: 'POST',
                body: JSON.stringify({
                    to_email: to, subject, body_html: bodyHtml,
                    sender_email: senderEmail, sender_name: senderName,
                    doc_ids: docIds,
                }),
            });
            if (result.ok) {
                this.toast(`Email inviata a ${to} con ${docIds.length} allegat${docIds.length > 1 ? 'i' : 'o'}!`, 'success');
                this._closeAllModals();
                this.loadDocumentPipeline(leadId);
            } else {
                this.toast('Errore: ' + (result.error || 'invio fallito'), 'danger');
                if (btn) { btn.disabled = false; btn.innerHTML = btnOriginal; }
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
            if (btn) { btn.disabled = false; btn.innerHTML = btnOriginal; }
        }
    },

    // NOTE: _closeAllModals is in app-core.js

    // ── All Documents Page ──────────────────────────────────────────────────

    async loadAllDocuments(page = 1) {
        const typeFilter = document.getElementById('docs-filter-type')?.value || '';
        const statusFilter = document.getElementById('docs-filter-status')?.value || '';
        const search = document.getElementById('docs-search')?.value || '';

        const params = new URLSearchParams({page, per_page: 200, type: typeFilter, status: statusFilter, search});
        try {
            const data = await this.api(`/leads/api/all-documents?${params}`);
            const container = document.getElementById('all-docs-table');
            if (!container) return;

            const typeIcons = {analysis:'fa-file-lines', presentation:'fa-file-powerpoint', offer:'fa-file-invoice-dollar', contract:'fa-file-contract', gantt:'fa-chart-gantt'};
            const typeLabels = {analysis:'Analisi', presentation:'Presentazione', offer:'Offerta', contract:'Contratto', gantt:'GANTT'};
            const typeColors = {analysis:'primary', presentation:'info', offer:'success', contract:'warning', gantt:'danger'};
            const statusBadge = (s) => {
                const c = {draft:'secondary', review:'warning', approved:'success', sent:'primary', accepted:'success', rejected:'danger'};
                const l = {draft:'Bozza', review:'Revisione', approved:'Approvato', sent:'Inviato', accepted:'Accettato', rejected:'Rifiutato'};
                return `<span class="badge bg-${c[s]||'secondary'}">${l[s]||s}</span>`;
            };

            if (!data.items.length) {
                container.innerHTML = '<div class="text-center text-muted py-5"><i class="fa-solid fa-folder-open fa-2x mb-2 d-block" style="opacity:.3"></i>Nessun documento trovato</div>';
                document.getElementById('docs-info').textContent = '0 documenti';
                return;
            }

            // Group by lead
            const groups = {};
            const groupOrder = [];
            for (const d of data.items) {
                if (!groups[d.lead_id]) {
                    groups[d.lead_id] = {lead_id: d.lead_id, crm_id: d.lead_crm_id, company: d.lead_company, contact: d.lead_contact, status: d.lead_status, assigned: d.assigned_to, docs: []};
                    groupOrder.push(d.lead_id);
                }
                groups[d.lead_id].docs.push(d);
            }

            let html = '<div class="accordion" id="docs-accordion">';
            for (const lid of groupOrder) {
                const g = groups[lid];
                const safeId = lid.replace(/[^a-zA-Z0-9]/g, '');
                const docCount = g.docs.length;
                const typeSummary = {};
                g.docs.forEach(d => { typeSummary[d.doc_type] = (typeSummary[d.doc_type]||0)+1; });
                const badges = Object.entries(typeSummary).map(([t,n]) =>
                    `<span class="badge bg-${typeColors[t]||'secondary'} me-1"><i class="fa-solid ${typeIcons[t]||'fa-file'} me-1"></i>${typeLabels[t]||t} ${n>1?'('+n+')':''}</span>`
                ).join('');

                html += `<div class="accordion-item border mb-2" style="border-radius:8px;overflow:hidden">
                    <h2 class="accordion-header">
                        <button class="accordion-button collapsed py-2 px-3" type="button" data-bs-toggle="collapse" data-bs-target="#folder-${safeId}" style="background:#f8f9fa;font-size:.9rem">
                            <i class="fa-solid fa-folder text-warning me-2"></i>
                            <code class="me-2">${this._escapeHtml(g.crm_id||'')}</code>
                            <span class="fw-bold me-3">${this._escapeHtml(g.company||g.contact||'-')}</span>
                            ${badges}
                        </button>
                    </h2>
                    <div id="folder-${safeId}" class="accordion-collapse collapse" data-bs-parent="">
                        <div class="accordion-body p-0">
                            <table class="table table-hover align-middle mb-0">
                                <tbody>`;

                for (const d of g.docs) {
                    const icon = typeIcons[d.doc_type] || 'fa-file';
                    const color = typeColors[d.doc_type] || 'secondary';
                    html += `<tr>
                        <td style="width:140px"><span class="badge bg-${color}"><i class="fa-solid ${icon} me-1"></i>${typeLabels[d.doc_type] || d.doc_type}</span></td>
                        <td><div class="fw-medium text-truncate" style="max-width:300px" title="${this._escapeHtml(d.title || '')}">${this._escapeHtml(d.title || '-')}</div></td>
                        <td style="width:100px">${statusBadge(d.status)}</td>
                        <td style="width:120px"><small class="text-muted">${this.formatDate(d.created_at)}</small></td>
                        <td style="width:120px" class="text-end">
                            <div class="d-flex gap-1 justify-content-end">
                                ${d.google_url ? `<a href="${d.google_url}" class="btn btn-sm btn-outline-primary" target="_blank" title="Apri in Google"><i class="fa-brands fa-google"></i></a>` : ''}
                                ${d.google_embed_url ? `<button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp._previewDocEmbed('${d.google_embed_url}','${this._escapeHtml(d.title||'')}')" title="Anteprima"><i class="fa-solid fa-eye"></i></button>` : ''}
                                <a href="/leads/${d.lead_id}" class="btn btn-sm btn-outline-dark" title="Vai alla lead"><i class="fa-solid fa-arrow-right"></i></a>
                            </div>
                        </td>
                    </tr>`;
                }
                html += '</tbody></table></div></div></div>';
            }
            html += '</div>';
            container.innerHTML = html;

            document.getElementById('docs-info').textContent = `${data.total} documenti in ${groupOrder.length} lead`;
        } catch (e) {
            const c = document.getElementById('all-docs-table');
            if (c) c.innerHTML = `<div class="text-center text-danger py-5">Errore: ${e.message}</div>`;
            this.toast(e.message, 'danger');
        }
    },

    _previewDocEmbed(embedUrl, title) {
        this._showModal(
            `<i class="fa-solid fa-eye me-2"></i>${this._escapeHtml(title)}`,
            `<iframe src="${embedUrl}" style="width:100%;height:calc(100vh - 120px);border:1px solid #dee2e6;border-radius:8px" allowfullscreen></iframe>`,
            'modal-fullscreen'
        );
    },

});


// ── app-ai-hub.js ──
/** Syrus Sales OS – Documents Module (pipeline, editor, generation, collaborators) */
Object.assign(SyrusApp, {

    // ── AI Hub Dashboard ───────────────────────────────────────────────────

    async aiLoadHub() {
        this.aiLoadCliStatus();
        this.aiLoadGdriveStatus();
        this.aiLoadStats();
        this.aiLoadLog();
    },

    async aiLoadCliStatus() {
        try {
            const status = await this.api('/ai/api/cli-status');
            for (const [name, info] of Object.entries(status)) {
                const card = document.getElementById(`cli-${name}`);
                if (!card) continue;
                const badge = card.querySelector('.cli-status-badge');
                const version = card.querySelector('.cli-version');
                if (info.available) {
                    badge.innerHTML = '<span class="badge bg-success"><i class="fa-solid fa-circle-check me-1"></i>Disponibile</span>';
                    version.textContent = info.version || '';
                } else {
                    badge.innerHTML = '<span class="badge bg-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Non trovato</span>';
                    version.textContent = '';
                }
            }
        } catch (e) { /* silent */ }
    },

    async aiLoadGdriveStatus() {
        const card = document.getElementById('gdrive-status');
        if (!card) return;
        try {
            const status = await this.api('/ai/api/gdrive-status');
            const badge = card.querySelector('.gdrive-status-badge');
            const folder = card.querySelector('.gdrive-folder');
            if (status.ok) {
                badge.innerHTML = '<span class="badge bg-success"><i class="fa-solid fa-circle-check me-1"></i>Connesso</span>';
                folder.textContent = status.folder_name || '';
            } else {
                badge.innerHTML = `<span class="badge bg-danger"><i class="fa-solid fa-circle-xmark me-1"></i>Non configurato</span>`;
                folder.textContent = status.error || '';
            }
        } catch (e) {
            const badge = card.querySelector('.gdrive-status-badge');
            if (badge) badge.innerHTML = '<span class="badge bg-warning">Errore</span>';
        }
    },

    async aiTestGdrive() {
        const result = document.getElementById('gdrive-test-result');
        if (result) result.innerHTML = '<span class="spinner-border spinner-border-sm"></span> Test in corso...';
        try {
            const data = await this.api('/ai/api/gdrive-test', { method: 'POST' });
            if (data.ok) {
                result.innerHTML = `<span class="text-success"><i class="fa-solid fa-check me-1"></i>Funziona! <a href="${data.url}" target="_blank">Apri documento test</a></span>`;
                this.aiLoadGdriveStatus();
            } else {
                result.innerHTML = `<span class="text-danger"><i class="fa-solid fa-xmark me-1"></i>${this._escapeHtml(data.error)}</span>`;
            }
        } catch (e) {
            result.innerHTML = `<span class="text-danger">${this._escapeHtml(e.message)}</span>`;
        }
    },

    async aiLoadStats() {
        try {
            const stats = await this.api('/ai/api/stats');
            const el = document.getElementById('ai-stats');
            if (!el) return;
            el.innerHTML = `
                <div class="d-flex flex-column gap-3">
                    <div class="d-flex justify-content-between"><span class="text-muted">Analisi totali</span><strong>${stats.total_analyses}</strong></div>
                    <div class="d-flex justify-content-between"><span class="text-muted">Lead con analisi AI</span><strong>${stats.leads_with_ai} / ${stats.total_leads}</strong></div>
                    <div class="d-flex justify-content-between"><span class="text-muted">Copertura AI</span><strong>${stats.coverage_pct}%</strong></div>
                </div>
                <div class="progress mt-3" style="height:8px">
                    <div class="progress-bar bg-success" style="width:${stats.coverage_pct}%"></div>
                </div>`;
        } catch (e) { /* silent */ }
    },

    async aiLoadLog() {
        try {
            const logs = await this.api('/ai/api/log');
            const tbody = document.getElementById('ai-log-table');
            if (!tbody) return;
            if (!logs.length) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center py-4 text-muted">Nessuna generazione AI ancora</td></tr>';
                return;
            }
            tbody.innerHTML = logs.map(l => `
                <tr>
                    <td class="small">${this.formatDate(l.created_at)}</td>
                    <td><a href="/leads/${l.lead_id}">${l.lead_id?.substring(0,8) || '-'}</a></td>
                    <td>${l.project_type || 'Analisi'}</td>
                    <td><span class="badge bg-secondary">${l.model_used || '-'}</span></td>
                    <td>${l.lead_score ? `<span class="badge bg-success">${l.lead_score}</span>` : '-'}</td>
                </tr>`).join('');
        } catch (e) { /* silent */ }
    },

    async aiRefreshCli() {
        try {
            const status = await this.api('/ai/api/cli-refresh', { method: 'POST' });
            this.aiLoadCliStatus();
            this.toast('Stato CLI aggiornato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async aiFreeGenerate() {
        const prompt = document.getElementById('free-ai-prompt')?.value?.trim();
        const engine = document.getElementById('free-ai-engine')?.value || 'claude';
        const leadId = document.getElementById('free-ai-lead')?.value?.trim() || null;
        const progressEl = document.getElementById('free-ai-progress');
        const outputEl = document.getElementById('free-ai-output');

        if (!prompt) { this.toast('Scrivi un prompt', 'warning'); return; }
        progressEl?.classList.remove('d-none');
        if (outputEl) outputEl.innerHTML = '';

        try {
            const res = await this.api('/ai/api/free-generate', {
                method: 'POST',
                body: JSON.stringify({ prompt, engine, lead_id: leadId }),
            });

            // Track in ops widget
            this.trackOperation(res.job_id, 'document', 'AI Generazione Libera', `/ai/api/status/${res.job_id}`, null);

            const poll = async () => {
                const status = await this.api(`/ai/api/status/${res.job_id}`);
                if (status.status === 'completed') {
                    progressEl?.classList.add('d-none');
                    const op = this._operations?.find(o => o.id === res.job_id);
                    if (op) { op.status = 'completed'; this._renderOps(); }
                    if (outputEl) {
                        outputEl.innerHTML = `<div class="card"><div class="card-body"><pre class="mb-0 small" style="white-space:pre-wrap;max-height:500px;overflow:auto">${this._escapeHtml(status.result?.output || '')}</pre></div></div>`;
                    }
                } else if (status.status === 'failed') {
                    progressEl?.classList.add('d-none');
                    const op = this._operations?.find(o => o.id === res.job_id);
                    if (op) { op.status = 'failed'; this._renderOps(); }
                    if (outputEl) outputEl.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(status.error || '')}</div>`;
                } else {
                    setTimeout(poll, 3000);
                }
            };
            setTimeout(poll, 3000);
        } catch (e) {
            progressEl?.classList.add('d-none');
            if (outputEl) outputEl.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message || '')}</div>`;
        }
    },
});


// ── app-comms.js ──
/** Syrus Sales OS – Communications Module (email, SMS, WhatsApp modals, contacts, comms page) */
Object.assign(SyrusApp, {

    // ── Composer flottante (stile Gmail): la pagina resta usabile, la
    //    finestra è riducibile e trascinabile dal titolo. Una alla volta.
    _showComposer(title, bodyHtml) {
        this._closeComposer();
        const win = document.createElement('div');
        win.id = 'syrus-composer';
        win.className = 'syrus-composer';
        win.innerHTML = `
            <div class="syrus-composer-header">
                <span class="syrus-composer-title">${title}</span>
                <div class="syrus-composer-actions">
                    <button type="button" class="composer-btn-full" title="Schermo intero" onclick="SyrusApp._toggleComposerFull(event)"><i class="fa-solid fa-expand"></i></button>
                    <button type="button" class="composer-btn-min" title="Riduci/Espandi" onclick="SyrusApp._toggleComposer(event)"><i class="fa-solid fa-window-minimize"></i></button>
                    <button type="button" title="Chiudi" onclick="SyrusApp._closeComposer()"><i class="fa-solid fa-xmark"></i></button>
                </div>
            </div>
            <div class="syrus-composer-body">${bodyHtml}</div>`;
        document.body.appendChild(win);
        this._initComposerDrag(win);
        // Chi scrive a schermo intero di solito ci resta: la scelta si ricorda.
        if (localStorage.getItem('syrus_composer_full') === '1') this._setComposerFull(win, true);
    },

    _closeComposer() {
        const win = document.getElementById('syrus-composer');
        if (!win) return;
        if (typeof tinymce !== 'undefined' && win.querySelector('#email-body-html')) {
            tinymce.remove('#email-body-html');
        }
        win.remove();
    },

    _toggleComposer(event) {
        event?.stopPropagation();
        const win = document.getElementById('syrus-composer');
        if (!win) return;
        // Ridurre esce dallo schermo intero: i due stati si escludono
        if (win.classList.contains('composer-full')) this._setComposerFull(win, false);
        win.classList.toggle('composer-min');
        const icon = win.querySelector('.composer-btn-min i');
        if (icon) icon.className = win.classList.contains('composer-min')
            ? 'fa-solid fa-window-maximize' : 'fa-solid fa-window-minimize';
        // Ridotta torna sempre agganciata in basso
        if (win.classList.contains('composer-min')) {
            win.style.left = ''; win.style.top = '';
            win.style.right = ''; win.style.bottom = '';
        }
    },

    /** Schermo intero per il composer (email e SMS). */
    _toggleComposerFull(event) {
        event?.stopPropagation();
        const win = document.getElementById('syrus-composer');
        if (!win) return;
        this._setComposerFull(win, !win.classList.contains('composer-full'));
    },

    _setComposerFull(win, full) {
        win.classList.toggle('composer-full', full);
        if (full) {
            win.classList.remove('composer-min');
            const minIcon = win.querySelector('.composer-btn-min i');
            if (minIcon) minIcon.className = 'fa-solid fa-window-minimize';
        }
        // Il trascinamento scrive left/top inline: hanno la meglio sul CSS, e a
        // schermo intero la finestra resterebbe incastrata dov'era.
        win.style.left = ''; win.style.top = '';
        win.style.right = ''; win.style.bottom = '';

        const btn = win.querySelector('.composer-btn-full');
        if (btn) {
            btn.title = full ? 'Esci da schermo intero' : 'Schermo intero';
            const i = btn.querySelector('i');
            if (i) i.className = full ? 'fa-solid fa-compress' : 'fa-solid fa-expand';
        }
        localStorage.setItem('syrus_composer_full', full ? '1' : '0');
    },

    _initComposerDrag(win) {
        const header = win.querySelector('.syrus-composer-header');
        header.addEventListener('pointerdown', (e) => {
            if (e.target.closest('button')) return;
            if (win.classList.contains('composer-full')) return;  // occupa già tutto
            const rect = win.getBoundingClientRect();
            const offX = e.clientX - rect.left, offY = e.clientY - rect.top;
            win.classList.add('composer-dragging');
            const move = (ev) => {
                const w = rect.width, h = rect.height;
                let x = Math.min(Math.max(ev.clientX - offX, 0), window.innerWidth - w);
                let y = Math.min(Math.max(ev.clientY - offY, 0), window.innerHeight - 40);
                win.style.left = x + 'px'; win.style.top = y + 'px';
                win.style.right = 'auto'; win.style.bottom = 'auto';
            };
            const up = () => {
                win.classList.remove('composer-dragging');
                document.removeEventListener('pointermove', move);
                document.removeEventListener('pointerup', up);
            };
            document.addEventListener('pointermove', move);
            document.addEventListener('pointerup', up);
        });
    },

    // ── Email/SMS composer from lead detail ─────────────────────────────────
    showSendEmailModal(leadId, email) {
        this._showComposer('Invia Email', `
            <form onsubmit="SyrusApp.sendEmail(event)">
                <input type="hidden" name="lead_id" value="${leadId}">
                <div id="email-ai-box"></div>
                <div class="row g-2 mb-2">
                    <div class="col-md-6"><label class="form-label">Destinatario <small class="text-muted">(puoi cambiare)</small></label>
                        <input name="to_email" type="email" class="form-control" value="${this._escapeAttr(email || '')}" required placeholder="email@esempio.it"></div>
                    <div class="col-md-6"><label class="form-label">Oggetto</label><input name="subject" class="form-control" required></div>
                </div>
                <div class="mb-2"><label class="form-label d-flex justify-content-between align-items-center w-100">Template
                        <a href="#" class="small" onclick="SyrusApp.openEmailTemplatesManager(); return false;"><i class="fa-solid fa-pen-to-square me-1"></i>Gestisci i miei template</a></label>
                    <select name="template" id="email-template-select" class="form-select" onchange="SyrusApp._onEmailTemplateChange(this)"><option value="">Nessuno (testo libero)</option></select></div>
                <div class="mb-2"><label class="form-label">Corpo</label><textarea id="email-body-html" name="body_html" class="form-control" rows="6" required></textarea></div>
                <div id="email-signature-preview" class="mb-3"></div>
                <div id="email-transport-box" class="mb-3"></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-paper-plane"></i> Invia Email</button>
            </form>`);
        this._initEmailEditor();
        this._loadSignaturePreview();
        this._loadTransportChoice();
        this._loadEmailTemplatesIntoSelect();
        this.initEmailAi(leadId);
    },

    // Selettore "Invia con": compare solo se l'utente ha collegato Gmail
    // (menu avatar → Account Gmail); altrimenti il backend usa Brevo.
    async _loadTransportChoice() {
        const box = document.getElementById('email-transport-box');
        if (!box) return;
        try {
            const s = await this.api('/settings/api/gmail/status');
            if (!s.connected) return;
            const last = localStorage.getItem('syrus_email_transport') === 'gmail' ? 'gmail' : 'brevo';
            box.innerHTML = `
                <label class="form-label mb-1">Invia con</label>
                <select name="transport" class="form-select"
                        onchange="localStorage.setItem('syrus_email_transport', this.value)">
                    <option value="brevo" ${last === 'brevo' ? 'selected' : ''}>Metodo classico (piattaforma)</option>
                    <option value="gmail" ${last === 'gmail' ? 'selected' : ''}>La mia Gmail (${this._escapeAttr(s.email)})</option>
                </select>
                <small class="text-muted">Con Gmail l'email parte dalla tua casella e resta nei tuoi Inviati, con il tracking delle aperture attivo. La firma scelta (menu avatar → Firma email) viene aggiunta in entrambi i casi.</small>`;
        } catch (_) { /* nessuna opzione: si usa il metodo classico */ }
    },

    // ── Template email personali ────────────────────────────────────────────
    // Per-utente (ConfigKV, come la firma): alla selezione compilano oggetto e
    // corpo nel composer, sempre editabili. Le voci "classificazione" storiche
    // restano come etichette di log (non compilano nulla).
    _emailTemplates: [],

    async _loadEmailTemplatesIntoSelect() {
        const sel = document.getElementById('email-template-select');
        if (!sel) return;
        try { this._emailTemplates = await this.api('/settings/api/email-templates'); }
        catch (_) { this._emailTemplates = []; }
        const mine = (this._emailTemplates || []).map(t =>
            `<option value="mine_${t.id}" data-mine="${t.id}">${this._escapeHtml(t.name)}</option>`).join('');
        sel.innerHTML = `
            <option value="">Nessuno (testo libero)</option>
            ${mine ? `<optgroup label="I miei template">${mine}</optgroup>` : ''}
            <optgroup label="Etichette classificazione (non compilano il testo)">
                <option value="quote_sent">Invio Preventivo</option>
                <option value="follow_up_1">Follow-up 1</option>
                <option value="follow_up_2">Follow-up 2</option>
                <option value="follow_up_final">Follow-up Finale</option>
                <option value="reactivation">Riattivazione</option>
                <option value="lead_confirmation">Conferma Ricezione</option>
            </optgroup>`;
    },

    _onEmailTemplateChange(sel) {
        const opt = sel.selectedOptions[0];
        if (!opt || !opt.dataset.mine) return;
        const tpl = (this._emailTemplates || []).find(t => t.id === opt.dataset.mine);
        if (!tpl) return;
        const form = sel.closest('form');
        const subj = form.querySelector('input[name="subject"]');
        const ed = (typeof tinymce !== 'undefined') ? tinymce.get('email-body-html') : null;
        const hasContent = (subj?.value || '').trim() || (ed && ed.getContent({ format: 'text' }).trim());
        if (hasContent && !confirm('Sostituire oggetto e corpo con il template selezionato?')) {
            sel.value = '';
            return;
        }
        if (subj && tpl.subject) subj.value = tpl.subject;
        if (ed) ed.setContent(tpl.body || '');
        else { const ta = form.querySelector('#email-body-html'); if (ta) ta.value = tpl.body || ''; }
    },

    async openEmailTemplatesManager() {
        try { this._emailTemplates = await this.api('/settings/api/email-templates'); }
        catch (_) { this._emailTemplates = []; }
        this._renderEmailTemplatesList();
    },

    _renderEmailTemplatesList() {
        const rows = (this._emailTemplates || []).map(t => `
            <tr>
                <td class="fw-semibold">${this._escapeHtml(t.name)}</td>
                <td class="text-muted small">${this._escapeHtml(t.subject || '—')}</td>
                <td class="text-end text-nowrap">
                    <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp._editEmailTemplate('${t.id}')" title="Modifica"><i class="fa-solid fa-pen"></i></button>
                    <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp._deleteEmailTemplate('${t.id}')" title="Elimina"><i class="fa-solid fa-trash"></i></button>
                </td>
            </tr>`).join('');
        this._showModal('I miei template email', `
            <p class="text-muted small">Template personali di cortesia: alla selezione nel composer compilano oggetto e corpo, sempre modificabili prima dell'invio. La firma viene comunque aggiunta in fondo.</p>
            ${rows ? `<table class="table table-sm align-middle"><thead><tr><th>Nome</th><th>Oggetto</th><th></th></tr></thead><tbody>${rows}</tbody></table>`
                   : '<div class="text-muted small mb-3">Nessun template ancora. Creane uno!</div>'}
            <button class="btn btn-primary btn-sm" onclick="SyrusApp._editEmailTemplate()"><i class="fa-solid fa-plus me-1"></i>Nuovo template</button>`);
    },

    _editEmailTemplate(tid) {
        const tpl = (this._emailTemplates || []).find(t => t.id === tid) || { id: '', name: '', subject: '', body: '' };
        this._showModal(tid ? 'Modifica template' : 'Nuovo template', `
            <form onsubmit="SyrusApp._saveEmailTemplate(event)">
                <input type="hidden" name="id" value="${this._escapeAttr(tpl.id)}">
                <div class="mb-2"><label class="form-label">Nome <small class="text-muted">(come appare nel menu)</small></label>
                    <input name="name" class="form-control" required maxlength="100" value="${this._escapeAttr(tpl.name)}"></div>
                <div class="mb-2"><label class="form-label">Oggetto</label>
                    <input name="subject" class="form-control" maxlength="300" value="${this._escapeAttr(tpl.subject || '')}"></div>
                <div class="mb-3"><label class="form-label">Corpo</label>
                    <textarea id="email-tpl-body" name="body" class="form-control" rows="10">${this._escapeHtml(tpl.body || '')}</textarea></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>
                <button type="button" class="btn btn-outline-secondary ms-1" onclick="SyrusApp.openEmailTemplatesManager()">Annulla</button>
            </form>`);
        this._initEmailEditor('#email-tpl-body', 280);
    },

    async _saveEmailTemplate(event) {
        event.preventDefault();
        if (typeof tinymce !== 'undefined') tinymce.triggerSave();
        const data = Object.fromEntries(new FormData(event.target).entries());
        try {
            const r = await this.api('/settings/api/email-templates', { method: 'POST', body: JSON.stringify(data) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            if (typeof tinymce !== 'undefined') tinymce.remove('#email-tpl-body');
            this.toast('Template salvato', 'success');
            await this.openEmailTemplatesManager();
            this._loadEmailTemplatesIntoSelect();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _deleteEmailTemplate(tid) {
        if (!confirm('Eliminare questo template?')) return;
        try {
            await this.api(`/settings/api/email-templates/${tid}`, { method: 'DELETE' });
            this.toast('Template eliminato', 'success');
            await this.openEmailTemplatesManager();
            this._loadEmailTemplatesIntoSelect();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // Anteprima firma sotto il corpo: mostra cosa verrà accodato dal server
    // (send_and_log) o avvisa se la firma non è ancora stata impostata.
    async _loadSignaturePreview() {
        const box = document.getElementById('email-signature-preview');
        if (!box) return;
        try {
            const r = await this.api('/settings/api/signature');
            const sig = (r.effective || r.signature || '').trim();
            if (sig) {
                const srcLabel = r.source === 'gmail' ? 'firma Gmail' : 'firma Sales';
                box.innerHTML = `
                    <label class="form-label mb-1">Firma <small class="text-muted">(${srcLabel}, aggiunta automaticamente in fondo all'email)</small></label>
                    <div class="border rounded p-2" style="max-height:140px;overflow:auto;opacity:.75">${DOMPurify.sanitize(sig)}</div>`;
            } else {
                box.innerHTML = `
                    <div class="alert alert-warning py-2 px-3 small mb-0">
                        <i class="fa-solid fa-triangle-exclamation me-1"></i>
                        Nessuna firma impostata: l'email partirà senza firma.
                        Puoi crearla dal menu utente in alto a destra → <b>Firma email</b>.
                    </div>`;
            }
        } catch (_) { box.innerHTML = ''; }
    },

    // Rich-text (WYSIWYG) editor for the email body, mounted on #email-body-html
    // 260 (era 340): la finestra di composizione è stata allargata e abbassata,
    // l'editor è il pezzo che ne detta l'altezza.
    _initEmailEditor(selector = '#email-body-html', height = 260) {
        if (typeof tinymce === 'undefined') return;
        // Bootstrap traps focus inside the modal, which makes TinyMCE pop-up dialogs
        // (Link, color picker…) unclickable. Let TinyMCE's own UI keep focus. Patch once.
        if (!this._tinymceFocusPatched) {
            this._tinymceFocusPatched = true;
            document.addEventListener('focusin', (e) => {
                if (e.target.closest && e.target.closest('.tox-tinymce-aux, .tox-dialog, .tox-dialog__popups')) {
                    e.stopImmediatePropagation();
                }
            }, true);
        }
        setTimeout(() => {
            if (!document.getElementById(selector.slice(1))) return;
            tinymce.remove(selector);
            tinymce.init({
                selector: selector,
                height: height,
                menubar: false,
                plugins: 'lists link autolink code',
                toolbar: 'undo redo | blocks | bold italic underline | forecolor backcolor | bullist numlist | alignleft aligncenter alignright | link | removeformat | code',
                toolbar_mode: 'wrap',
                language: 'it',
                language_url: 'https://cdn.jsdelivr.net/npm/tinymce-i18n/langs7/it.js',
                license_key: 'gpl',
                promotion: false,
                branding: false,
                statusbar: false,
                skin: 'oxide',
                content_style: "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap'); body{font-family:'Inter',sans-serif;font-size:14px;line-height:1.6;color:#0F172A;} a{color:#2E75B6;}",
                // TinyMCE nasconde la textarea: col `required` nativo il browser
                // blocca il submit ("invalid form control is not focusable")
                // perché la validazione HTML5 gira PRIMA del nostro onsubmit e
                // vede il campo nascosto ancora vuoto. Il corpo vuoto viene
                // validato in sendEmail() dopo triggerSave().
                setup: (ed) => {
                    ed.on('init', () => document.getElementById(selector.slice(1))?.removeAttribute('required'));
                },
            });
        }, 250);
    },

    // ── Firma email personale ───────────────────────────────────────────────
    // Due sorgenti: editor Sales oppure una delle firme già configurate sulla
    // casella Gmail collegata (sola lettura: le firme Gmail non si toccano).
    async openSignatureEditor() {
        let cfg = { signature: '', source: 'sales', gmail: {} };
        try { cfg = await this.api('/settings/api/signature'); } catch (_) { /* nuova firma */ }
        this._signatureCfg = cfg;
        this._gmailSigsLoaded = false;
        this._showModal('Firma email', `
            <p class="text-muted small">Viene aggiunta automaticamente in fondo alle email che invii manualmente, sia col metodo classico che dalla tua Gmail.</p>
            <div class="mb-3">
                <label class="form-label mb-1">Sorgente firma</label>
                <select id="signature-source" class="form-select" onchange="SyrusApp._onSignatureSourceChange(this.value)">
                    <option value="sales" ${cfg.source !== 'gmail' ? 'selected' : ''}>Firma Sales (editor)</option>
                    <option value="gmail" ${cfg.source === 'gmail' ? 'selected' : ''}>Firma Gmail (dalla tua casella)</option>
                </select>
            </div>
            <div id="signature-pane-sales">
                <p class="text-muted small mb-1">Le immagini inserite vengono pubblicate su un URL nascosto, così da essere visibili a chi riceve la mail.</p>
                <textarea id="signature-editor" class="form-control" rows="8"></textarea>
            </div>
            <div id="signature-pane-gmail" style="display:none">
                <div id="gmail-signatures-list"><div class="text-muted small">Caricamento firme dalla tua casella…</div></div>
            </div>
            <div class="d-flex justify-content-end mt-3">
                <button class="btn btn-primary" onclick="SyrusApp.saveSignature()"><i class="fa-solid fa-check me-1"></i>Salva firma</button>
            </div>`);
        this._initSignatureEditor(cfg.signature || '');
        this._onSignatureSourceChange(cfg.source === 'gmail' ? 'gmail' : 'sales');
    },

    _onSignatureSourceChange(source) {
        const sales = document.getElementById('signature-pane-sales');
        const gmail = document.getElementById('signature-pane-gmail');
        if (!sales || !gmail) return;
        sales.style.display = source === 'sales' ? '' : 'none';
        gmail.style.display = source === 'gmail' ? '' : 'none';
        if (source === 'gmail' && !this._gmailSigsLoaded) this._loadGmailSignatures();
    },

    async _loadGmailSignatures() {
        const box = document.getElementById('gmail-signatures-list');
        if (!box) return;
        box.innerHTML = '<div class="text-muted small">Caricamento firme dalla tua casella…</div>';
        try {
            const r = await this.api('/settings/api/gmail/signatures');
            this._gmailSigsLoaded = true;
            const sigs = r.signatures || [];
            if (!sigs.length) {
                box.innerHTML = `<div class="alert alert-warning py-2 px-3 small mb-0">
                    Nessuna firma trovata sulla tua casella Gmail.
                    Creane una dalla webmail (Impostazioni → Firma) e clicca "Ricarica da Gmail".</div>
                    <button type="button" class="btn btn-outline-secondary btn-sm mt-2" onclick="SyrusApp._loadGmailSignatures()">
                        <i class="fa-solid fa-arrows-rotate me-1"></i>Ricarica da Gmail</button>`;
                return;
            }
            const selected = this._signatureCfg?.gmail?.send_as;
            box.innerHTML = sigs.map(s => `
                <label class="border rounded p-2 d-block mb-2" style="cursor:pointer">
                    <div class="d-flex align-items-center gap-2 mb-1">
                        <input type="radio" name="gmail-signature-choice" value="${this._escapeAttr(s.send_as)}"
                            ${selected === s.send_as || (!selected && s.is_default) ? 'checked' : ''}>
                        <span class="fw-semibold">${this._escapeAttr(s.send_as)}</span>
                        ${s.is_default ? '<span class="badge bg-secondary-subtle text-secondary border">predefinita</span>' : ''}
                    </div>
                    <div style="max-height:120px;overflow:auto;opacity:.8">${DOMPurify.sanitize(s.signature)}</div>
                </label>`).join('') + `
                <button type="button" class="btn btn-outline-secondary btn-sm" onclick="SyrusApp._loadGmailSignatures()">
                    <i class="fa-solid fa-arrows-rotate me-1"></i>Ricarica da Gmail</button>
                <div class="text-muted small mt-1">La firma scelta viene copiata in Sales al salvataggio: le firme sulla tua casella non vengono modificate.</div>`;
        } catch (e) {
            box.innerHTML = `<div class="alert alert-danger py-2 px-3 small mb-2">${e.message || 'Errore caricamento firme Gmail'}</div>
                <button type="button" class="btn btn-outline-secondary btn-sm" onclick="SyrusApp._loadGmailSignatures()">
                    <i class="fa-solid fa-arrows-rotate me-1"></i>Riprova</button>`;
        }
    },

    _initSignatureEditor(initial) {
        if (typeof tinymce === 'undefined') {
            const ta = document.getElementById('signature-editor');
            if (ta) ta.value = initial || '';
            return;
        }
        if (!this._tinymceFocusPatched) {
            this._tinymceFocusPatched = true;
            document.addEventListener('focusin', (e) => {
                if (e.target.closest && e.target.closest('.tox-tinymce-aux, .tox-dialog, .tox-dialog__popups')) {
                    e.stopImmediatePropagation();
                }
            }, true);
        }
        setTimeout(() => {
            if (!document.getElementById('signature-editor')) return;
            tinymce.remove('#signature-editor');
            tinymce.init({
                selector: '#signature-editor',
                height: 240,
                menubar: false,
                plugins: 'lists link autolink image code',
                toolbar: 'undo redo | bold italic underline | forecolor | link image | removeformat | code',
                toolbar_mode: 'wrap',
                language: 'it',
                language_url: 'https://cdn.jsdelivr.net/npm/tinymce-i18n/langs7/it.js',
                license_key: 'gpl',
                promotion: false,
                branding: false,
                statusbar: false,
                skin: 'oxide',
                // Le immagini (sia da toolbar che incollate) vengono caricate
                // sul server e sostituite con un URL pubblico: niente base64
                // (bloccato da Gmail/Outlook) né hosting privato (irraggiungibile
                // dal client di posta del destinatario).
                automatic_uploads: true,
                paste_data_images: true,
                images_file_types: 'png,jpg,jpeg,gif,webp',
                file_picker_types: 'image',
                images_upload_handler: (blobInfo) => new Promise((resolve, reject) => {
                    const fd = new FormData();
                    fd.append('file', blobInfo.blob(), blobInfo.filename());
                    SyrusApp.fetchWithCsrf('/settings/api/signature/upload-image', { method: 'POST', body: fd })
                        .then((resp) => resp.json().then((body) => ({ ok: resp.ok, body })))
                        .then(({ ok, body }) => {
                            if (!ok || !body.location) {
                                reject({ message: body.error || 'Upload immagine fallito', remove: true });
                                return;
                            }
                            resolve(body.location);
                        })
                        .catch(() => reject({ message: 'Errore di rete durante l\'upload', remove: true }));
                }),
                content_style: "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap'); body{font-family:'Inter',sans-serif;font-size:14px;line-height:1.6;color:#0F172A;} a{color:#2E75B6;} img{max-width:100%;height:auto;}",
                setup: (ed) => { ed.on('init', () => ed.setContent(initial || '')); },
            });
        }, 250);
    },

    async saveSignature() {
        const source = document.getElementById('signature-source')?.value || 'sales';
        const payload = { source };
        if (source === 'gmail') {
            const chosen = document.querySelector('input[name="gmail-signature-choice"]:checked');
            if (!chosen) { this.toast('Seleziona una firma Gmail prima di salvare', 'warning'); return; }
            payload.gmail_send_as = chosen.value;
        } else {
            let html = '';
            if (typeof tinymce !== 'undefined' && tinymce.get('signature-editor')) {
                html = tinymce.get('signature-editor').getContent();
            } else {
                html = document.getElementById('signature-editor')?.value || '';
            }
            payload.signature = html;
        }
        try {
            await this.api('/settings/api/signature', { method: 'POST', body: JSON.stringify(payload) });
            if (typeof tinymce !== 'undefined') tinymce.remove('#signature-editor');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.toast('Firma salvata', 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async sendEmail(event, force) {
        event.preventDefault();
        // Flush WYSIWYG editor content back into the textarea before reading the form
        if (typeof tinymce !== 'undefined') tinymce.triggerSave();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        if (!(data.body_html || '').replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()) {
            this.toast('Scrivi il corpo dell\'email prima di inviare', 'warning');
            return;
        }
        if (force) data.force = true;
        try {
            const result = await this.api('/communications/api/email/send', { method: 'POST', body: JSON.stringify(data) });
            if (result.ok === false && result.data?.status === 'needs_confirmation') {
                if (confirm(result.error)) { return this.sendEmail(event, true); }
                return;
            }
            if (result.ok === false) { this.toast(result.error || 'Errore invio email', 'danger'); return; }
            const status = result.data?.status || 'sent';
            const via = result.data?.transport === 'gmail' ? ' dalla tua Gmail' : '';
            this.toast(`Email ${status === 'sent' ? 'inviata' + via : status}`, 'success');
            this._closeComposer();
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            if (document.getElementById('comms-table')) this.loadGlobalComms('all');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    showSendSmsModal(leadId, phone) {
        this._showComposer('Invia SMS', `
            <form onsubmit="SyrusApp.sendSms(event)">
                <input type="hidden" name="lead_id" value="${leadId}">
                <div class="mb-2"><label class="form-label">Destinatario <small class="text-muted">(puoi cambiare)</small></label>
                    <input name="to_phone" class="form-control" value="${this._escapeAttr(phone || '')}" required placeholder="+393391234567"></div>
                <div class="mb-2"><label class="form-label">Messaggio (max 160 caratteri)</label>
                    <textarea name="message" class="form-control" rows="3" maxlength="160" required></textarea>
                    <small class="text-muted"><span id="sms-chars">0</span>/160</small></div>
                <button type="submit" class="btn btn-success"><i class="fa-solid fa-paper-plane"></i> Invia SMS</button>
            </form>`);
        // Character counter
        setTimeout(() => {
            const ta = document.querySelector('#syrus-composer textarea[name="message"]');
            if (ta) ta.addEventListener('input', () => document.getElementById('sms-chars').textContent = ta.value.length);
        }, 200);
    },

    async sendSms(event, force) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        if (force) data.force = true;
        try {
            const result = await this.api('/communications/api/sms/send', { method: 'POST', body: JSON.stringify(data) });
            if (result.ok === false && result.data?.status === 'needs_confirmation') {
                if (confirm(result.error)) { return this.sendSms(event, true); }
                return;
            }
            if (result.ok === false) { this.toast(result.error || 'Errore invio SMS', 'danger'); return; }
            const status = result.data?.status || 'sent';
            this.toast(`SMS ${status === 'sent' ? 'inviato' : status}`, 'success');
            this._closeComposer();
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            if (document.getElementById('comms-table')) this.loadGlobalComms('all');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── WhatsApp Template Send (from Lead detail) ───────────────────────────
    async showSendWhatsappModal(leadId, phone, leadCtx) {
        this._waSendLeadCtx = leadCtx || {};
        // Load available numbers and templates
        let numsHtml = '<option value="">Seleziona numero...</option>';
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            nums.forEach((n, i) => { numsHtml += `<option value="${n.phone_number_id}" data-waba="${n.waba_id}" data-phone="${n.phone_number || ''}"${i === 0 ? ' selected' : ''}>${n.label || n.phone_number} (${n.phone_number_id})</option>`; });
        } catch(e) { console.warn('Errore caricamento numeri WA:', e.message); }

        this._showModal('Invia WhatsApp (Template)', `
            <form onsubmit="SyrusApp.sendWhatsappTemplate(event)">
                <input type="hidden" name="lead_id" value="${leadId}">
                <div class="mb-2"><label class="form-label">Destinatario <small class="text-muted">(puoi cambiare)</small></label>
                    <input name="to" class="form-control" value="${phone || ''}" required placeholder="393391234567 (senza +)"></div>
                <div class="mb-2"><label class="form-label">Numero Mittente</label>
                    <select name="phone_number_id" id="wa-send-pnid" class="form-select" required onchange="SyrusApp._loadTemplatesForSend()">${numsHtml}</select></div>
                <div class="mb-2"><label class="form-label">Template <small class="text-muted">(solo template approvati da Meta)</small></label>
                    <select name="template_name" id="wa-send-template" class="form-select" required>
                        <option value="">Prima seleziona un numero...</option>
                    </select></div>
                <div id="wa-tpl-preview"></div>
                <div class="mb-2"><label class="form-label">Lingua</label>
                    <select name="language" class="form-select">
                        <option value="it" selected>Italiano</option>
                        <option value="en">English</option>
                    </select></div>
                <div class="alert alert-info small"><i class="fa-solid fa-circle-info"></i> WhatsApp permette solo l'invio di template approvati da Meta. Per inviare messaggi liberi, usa la chat dopo che il destinatario ha risposto (finestra 24h).</div>
                <button type="submit" class="btn btn-success"><i class="fa-brands fa-whatsapp"></i> Invia Template WhatsApp</button>
            </form>`);

        // Auto-selezione primo numero disponibile → carica subito i template
        if (document.getElementById('wa-send-pnid')?.value) this._loadTemplatesForSend();
    },

    _waTemplatesCache: [],

    // ── Prefill variabili template WA ──
    // Convenzione default: {{1}} = nome lead, {{2}} = operatore (nome e cognome).
    // Override per nome template Meta; 'manual' = campo lasciato vuoto da compilare.
    _waSendLeadCtx: {},
    _waTplVarDefaults: { '1': 'lead_first_name', '2': 'operator_name' },
    _waTplVarOverrides: {
        'notifica_invio_offerta':               { '1': 'lead_first_name', '2': 'lead_email', '3': 'operator_name' },
        'followup_chiamata_persa':              { '1': 'lead_first_name', '2': 'operator_name', '3': 'sender_national' },
        'conferma_appuntamento_personalizzato': { '1': 'lead_first_name', '2': 'operator_name', '3': 'manual', '4': 'manual' },
        'chiamata_non_risposta_cliente':        { '1': 'lead_first_name', '2': 'operator_name', '3': 'sender_national', '4': 'operator_first_name' },
    },

    _waTplVarValue(kind) {
        const ctx = this._waSendLeadCtx || {};
        switch (kind) {
            case 'lead_first_name': return (ctx.name || '').trim().split(/\s+/)[0] || '';
            case 'lead_email':      return ctx.email || '';
            case 'operator_name':   return window.SYRUS?.userName || '';
            case 'operator_first_name': return (window.SYRUS?.userName || '').trim().split(/\s+/)[0] || '';
            case 'sender_national': {
                const sel = document.getElementById('wa-send-pnid');
                const raw = sel?.options[sel.selectedIndex]?.dataset?.phone || '';
                const digits = raw.replace(/\D/g, '');
                return digits.replace(/^39(?=\d{9,10}$)/, '');
            }
            default: return '';
        }
    },

    async _loadTemplatesForSend() {
        const sel = document.getElementById('wa-send-pnid');
        const tplSel = document.getElementById('wa-send-template');
        const wabaId = sel.options[sel.selectedIndex]?.dataset?.waba;
        if (!wabaId) { tplSel.innerHTML = '<option value="">Nessun WABA configurato</option>'; return; }

        try {
            const tpls = await this.api(`/whatsapp/api/templates/${wabaId}`);
            const approved = tpls.filter(t => t.status === 'APPROVED' && (t.language === 'it' || t.language === 'it_IT'));
            this._waTemplatesCache = approved;
            if (approved.length === 0) {
                tplSel.innerHTML = '<option value="">Nessun template approvato. Sincronizza prima.</option>';
            } else {
                tplSel.innerHTML = '<option value="">Seleziona template...</option>' +
                    approved.map(t => `<option value="${this._escapeAttr(t.name)}" data-lang="${this._escapeAttr(t.language)}">${this._escapeHtml(t.name)} (${this._escapeHtml(t.language)}) – ${this._escapeHtml(t.category)}</option>`).join('');
            }
            // Bind change to show preview
            if (!tplSel._bound) {
                tplSel._bound = true;
                tplSel.addEventListener('change', () => this._onTemplateSelected());
            }
            // Clear preview area
            const preview = document.getElementById('wa-tpl-preview');
            if (preview) preview.innerHTML = '';
        } catch(e) {
            tplSel.innerHTML = '<option value="">Errore caricamento template</option>';
        }
    },

    _onTemplateSelected() {
        const tplSel = document.getElementById('wa-send-template');
        const previewEl = document.getElementById('wa-tpl-preview');
        if (!tplSel || !previewEl) return;

        const tplName = tplSel.value;
        if (!tplName) { previewEl.innerHTML = ''; return; }

        const tpl = this._waTemplatesCache.find(t => t.name === tplName);
        if (!tpl) { previewEl.innerHTML = ''; return; }

        const components = tpl.components || [];
        const header = components.find(c => c.type === 'HEADER');
        const body = components.find(c => c.type === 'BODY');
        const footer = components.find(c => c.type === 'FOOTER');
        const buttonsComp = components.find(c => c.type === 'BUTTONS');

        // WhatsApp bubble preview
        let html = '<div style="max-width:360px;margin:12px auto">';
        html += '<div style="background:#E5DDD5;border-radius:12px;padding:12px">';
        html += '<div style="background:#DCF8C6;border-radius:8px;padding:10px 12px;box-shadow:0 1px 1px rgba(0,0,0,.1)">';
        if (header) html += `<div class="fw-bold mb-1">${this._escapeHtml(header.text || '')}</div>`;
        if (body) html += `<div id="wa-tpl-preview-body" style="white-space:pre-wrap;font-size:14px">${this._escapeHtml(body.text || '')}</div>`;
        if (footer) html += `<div class="text-muted small mt-2">${this._escapeHtml(footer.text || '')}</div>`;
        html += '</div>';
        if (buttonsComp?.buttons?.length) {
            buttonsComp.buttons.forEach(b => {
                html += `<div style="background:#fff;border-radius:8px;padding:8px;margin-top:4px;text-align:center;color:#0d6efd;font-weight:500;box-shadow:0 1px 1px rgba(0,0,0,.1)">${this._escapeHtml(b.text)}</div>`;
            });
        }
        html += '</div></div>';

        // Variable fields
        const bodyText = body?.text || '';
        const varMatches = [...bodyText.matchAll(/\{\{(\d+)\}\}/g)].map(m => m[1]);
        const uniqueVars = [...new Set(varMatches)].sort((a, b) => a - b);

        if (uniqueVars.length > 0) {
            const mapping = this._waTplVarOverrides[tplName] || this._waTplVarDefaults;
            html += '<div class="mt-3"><label class="form-label fw-bold">Variabili del template</label>';
            uniqueVars.forEach(v => {
                const kind = mapping[v] || 'manual';
                const val = kind === 'manual' ? '' : this._waTplVarValue(kind);
                const manual = !val;
                html += `<div class="input-group input-group-sm mb-2">
                    <span class="input-group-text" style="min-width:60px"><code>{{${v}}}</code></span>
                    <input type="text" class="form-control wa-tpl-var${manual ? ' border-warning' : ''}" data-var="${v}" value="${this._escapeAttr(val)}" placeholder="${manual ? 'Da compilare' : `Valore per {{${v}}}`}" required>
                </div>`;
            });
            html += '</div>';
        }

        previewEl.innerHTML = html;

        this._waTplBodyRaw = bodyText;
        previewEl.querySelectorAll('.wa-tpl-var').forEach(inp =>
            inp.addEventListener('input', () => this._updateWaTplPreview()));
        this._updateWaTplPreview();
    },

    _updateWaTplPreview() {
        const el = document.getElementById('wa-tpl-preview-body');
        if (!el || this._waTplBodyRaw == null) return;
        const vals = {};
        document.querySelectorAll('.wa-tpl-var').forEach(i => { vals[i.dataset.var] = i.value.trim(); });
        el.innerHTML = this._escapeHtml(
            this._waTplBodyRaw.replace(/\{\{(\d+)\}\}/g, (m, n) => vals[n] || m));
    },

    async sendWhatsappTemplate(event, force) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        data.to = data.to.replace(/[\s\+\-]/g, '');

        // Collect variable values
        const varInputs = document.querySelectorAll('.wa-tpl-var');
        const parameters = [];
        for (const inp of varInputs) {
            if (!inp.value.trim()) { this.toast(`Inserisci il valore per {{${inp.dataset.var}}}`, 'warning'); return; }
            parameters.push({ type: 'text', text: inp.value.trim() });
        }

        const payload = {
            phone_number_id: data.phone_number_id,
            to: data.to,
            type: 'template',
            template_name: data.template_name,
            language: data.language,
        };
        if (data.lead_id) payload.lead_id = data.lead_id;
        if (parameters.length > 0) {
            payload.components = [{ type: 'body', parameters }];
        }
        if (force) payload.force = true;
        try {
            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            if (result.ok === false && result.needs_confirmation) {
                if (confirm(result.reason)) { return this.sendWhatsappTemplate(event, true); }
                return;
            }
            if (result.ok) {
                this.toast('Template WhatsApp inviato!', 'success');
                bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
                // Refresh timeline e tab WhatsApp + polling status
                const leadId = this._currentLeadId;
                if (leadId) {
                    setTimeout(() => {
                        this._loadTimeline(leadId);
                        this.loadLeadWhatsapp(leadId);
                    }, 1000);
                    this._startWaStatusPoll?.(leadId);
                }
            } else {
                this.toast(result.error || result.reason || 'Errore invio', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Free Send (no lead required) ──────────────────────────────────────
    showFreeEmailModal() {
        this._showComposer('Invia Email (libero)', `
            <form onsubmit="SyrusApp.sendEmail(event)">
                <input type="hidden" name="lead_id" value="">
                <div class="mb-2"><label class="form-label">Destinatario</label>
                    <input name="to_email" type="email" class="form-control" required placeholder="email@esempio.it"></div>
                <div class="mb-2"><label class="form-label">Oggetto</label><input name="subject" class="form-control" required></div>
                <div class="mb-2"><label class="form-label d-flex justify-content-between align-items-center w-100">Template
                        <a href="#" class="small" onclick="SyrusApp.openEmailTemplatesManager(); return false;"><i class="fa-solid fa-pen-to-square me-1"></i>Gestisci i miei template</a></label>
                    <select name="template" id="email-template-select" class="form-select" onchange="SyrusApp._onEmailTemplateChange(this)"><option value="">Nessuno (testo libero)</option></select></div>
                <div class="mb-2"><label class="form-label">Corpo</label><textarea id="email-body-html" name="body_html" class="form-control" rows="8" required></textarea></div>
                <div id="email-signature-preview" class="mb-3"></div>
                <div id="email-transport-box" class="mb-3"></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-paper-plane me-1"></i> Invia</button>
            </form>`);
        this._initEmailEditor();
        this._loadSignaturePreview();
        this._loadTransportChoice();
        this._loadEmailTemplatesIntoSelect();
    },

    showFreeSmsModal() {
        this._showComposer('Invia SMS (libero)', `
            <form onsubmit="SyrusApp.sendSms(event)">
                <input type="hidden" name="lead_id" value="">
                <div class="mb-2"><label class="form-label">Destinatario</label>
                    <input name="to_phone" class="form-control" required placeholder="+393391234567"></div>
                <div class="mb-2"><label class="form-label">Messaggio (max 160 caratteri)</label>
                    <textarea name="message" class="form-control" rows="3" maxlength="160" required></textarea>
                    <small class="text-muted"><span id="sms-chars-free">0</span>/160</small></div>
                <button type="submit" class="btn btn-success"><i class="fa-solid fa-paper-plane me-1"></i> Invia SMS</button>
            </form>`);
        setTimeout(() => {
            const ta = document.querySelector('#syrus-composer textarea[name="message"]');
            if (ta) ta.addEventListener('input', () => {
                const counter = document.getElementById('sms-chars-free') || document.getElementById('sms-chars');
                if (counter) counter.textContent = ta.value.length;
            });
        }, 200);
    },

    async showFreeWhatsappModal() {
        let numsHtml = '<option value="">Seleziona numero mittente...</option>';
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            nums.forEach(n => { numsHtml += `<option value="${n.phone_number_id}" data-waba="${n.waba_id}">${n.label || n.phone_number} (${n.phone_number_id})</option>`; });
        } catch(e) { console.warn('Errore caricamento numeri WA:', e.message); }

        this._showModal('Invia WhatsApp (Template)', `
            <form onsubmit="SyrusApp.sendWhatsappTemplate(event)">
                <input type="hidden" name="lead_id" value="">
                <div class="mb-2"><label class="form-label">Destinatario</label>
                    <input name="to" class="form-control" required placeholder="393391234567 (senza +)"></div>
                <div class="mb-2"><label class="form-label">Numero Mittente</label>
                    <select name="phone_number_id" id="wa-send-pnid" class="form-select" required onchange="SyrusApp._loadTemplatesForSend()">${numsHtml}</select></div>
                <div class="mb-2"><label class="form-label">Template <small class="text-muted">(solo approvati da Meta)</small></label>
                    <select name="template_name" id="wa-send-template" class="form-select" required>
                        <option value="">Prima seleziona un numero...</option>
                    </select></div>
                <div id="wa-tpl-preview"></div>
                <div class="mb-2"><label class="form-label">Lingua</label>
                    <select name="language" class="form-select">
                        <option value="it" selected>Italiano</option>
                        <option value="en">English</option>
                    </select></div>
                <div class="alert alert-info small"><i class="fa-solid fa-info-circle me-1"></i> Solo template approvati da Meta. Messaggi liberi possibili solo nella chat dopo risposta del destinatario (finestra 24h).</div>
                <button type="submit" class="btn btn-success"><i class="fa-brands fa-whatsapp me-1"></i> Invia Template</button>
            </form>`);
    },

    // ── Contacts Page ───────────────────────────────────────────────────────
    async loadContacts(page = 1) {
        const search = document.getElementById('contacts-search')?.value || '';
        try {
            const data = await this.api(`/contacts/api/list?page=${page}&search=${encodeURIComponent(search)}`);
            const tbody = document.getElementById('contacts-table');
            if (data.items.length === 0) {
                tbody.innerHTML = '<tr><td colspan="6" class="text-center text-muted">Nessun contatto trovato</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(c => `
                    <tr>
                        <td><a href="/contacts/${c.id}">${this._escapeHtml(c.name || '')}</a></td>
                        <td>${this._escapeHtml(c.role || '-')}</td>
                        <td>${this._escapeHtml(c.email || '-')}</td>
                        <td>${this._escapeHtml(c.phone || '-')}</td>
                        <td>${c.lead_id ? `<a href="/leads/${c.lead_id}">Vedi lead</a>` : '<span class="text-muted">-</span>'}</td>
                        <td></td>
                    </tr>`).join('');
            }
            document.getElementById('contacts-info').textContent = `${data.total} contatti – Pagina ${data.page} di ${data.pages}`;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Communications Page ─────────────────────────────────────────────────
    _statusIcon(status) {
        const map = {
            sent: '<i class="fa-solid fa-paper-plane text-primary"></i>',
            delivered: '<i class="fa-solid fa-check text-success"></i>',
            opened: '<i class="fa-solid fa-envelope-open text-warning"></i>',
            clicked: '<i class="fa-solid fa-mouse-pointer text-info"></i>',
            replied: '<i class="fa-solid fa-reply text-success"></i>',
            bounced: '<i class="fa-solid fa-triangle-exclamation text-danger"></i>',
            failed: '<i class="fa-solid fa-circle-xmark text-danger"></i>',
            draft: '<i class="fa-solid fa-file text-muted"></i>',
        };
        return map[status] || `<span class="badge bg-secondary">${status || '-'}</span>`;
    },

    async loadGlobalComms(channel) {
        try {
            // Stop PBX polling when switching away from phone tab
            if (channel !== 'phone') {
                this._stopPbxPolling();
                // Restore column header
                const th5 = document.querySelector('#comms-table')?.closest('table')?.querySelector('thead th:nth-child(5)');
                if (th5) th5.textContent = 'Anteprima';
            }
            // PBX calls: dedicated endpoint that shows ALL calls (matched + unmatched)
            if (channel === 'phone') {
                return this._loadPbxCalls();
            }
            const data = await this.api(`/communications/api/global?channel=${channel}`);
            const tbody = document.getElementById('comms-table');
            if (data.items.length === 0) {
                tbody.innerHTML = '<tr><td colspan="7" class="text-center py-5 text-muted"><i class="fa-solid fa-inbox fa-2x mb-2 d-block"></i>Nessuna comunicazione</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(c => {
                    // Click action based on channel
                    let clickAttr = '';
                    let actionBtn = '';
                    if (c.channel === 'email' && c.id) {
                        clickAttr = `onclick="SyrusApp.showEmailPreview('${c.id}')" style="cursor:pointer"`;
                        actionBtn = `<button class="btn btn-sm btn-secondary" onclick="event.stopPropagation();SyrusApp.showEmailPreview('${c.id}')"><i class="fa-solid fa-eye"></i></button>`;
                    } else if (c.channel === 'whatsapp' && c.pnid && c.wa_id) {
                        clickAttr = `onclick="SyrusApp._goToWaChat('${this._escapeAttr(c.pnid)}','${this._escapeAttr(c.wa_id)}')" style="cursor:pointer"`;
                        actionBtn = `<button class="btn btn-sm btn-success" onclick="event.stopPropagation();SyrusApp._goToWaChat('${this._escapeAttr(c.pnid)}','${this._escapeAttr(c.wa_id)}')"><i class="fa-brands fa-whatsapp"></i></button>`;
                    } else if (c.channel === 'phone') {
                        if (c.audio_url) {
                            actionBtn = `<button class="btn btn-sm btn-outline-primary" onclick="event.stopPropagation();SyrusApp.toggleCommsAudio(this, '${this._escapeAttr(c.audio_url)}')" title="Ascolta registrazione"><i class="fa-solid fa-play"></i></button>`;
                        }
                        if (c.lead_id) {
                            actionBtn += ` <a href="/leads/${c.lead_id}" class="btn btn-sm btn-outline-secondary" onclick="event.stopPropagation()"><i class="fa-solid fa-user"></i></a>`;
                        }
                    }

                    // Contact display
                    let contactDisplay = c.to || '-';
                    if (c.channel === 'email' && c.direction === 'inbound') {
                        contactDisplay = `<i class="fa-solid fa-arrow-down text-success me-1" title="Ricevuta"></i>${this._escapeHtml(c.from_email || '-')}`;
                    }
                    if (c.channel === 'whatsapp' && c.contact_name) {
                        contactDisplay = `<strong>${this._escapeHtml(c.contact_name || '')}</strong><br><small class="text-muted">${this._escapeHtml(c.to || '')}</small>`;
                    }

                    // Content preview
                    let preview = this._escapeHtml(c.subject || c.message || '-');
                    if (c.channel === 'whatsapp' && c.msg_count) {
                        preview = `${this._escapeHtml(c.message || '')} <small class="text-muted">(${c.msg_count} msg)</small>`;
                    }
                    if (c.channel === 'phone') {
                        const dirIcon = c.direction === 'inbound' ? '<i class="fa-solid fa-phone-arrow-down-left text-success me-1"></i>' : '<i class="fa-solid fa-phone-arrow-up-right text-primary me-1"></i>';
                        preview = `${dirIcon}${this._escapeHtml(c.message || '')} ${c.duration ? `<small class="text-muted">(${c.duration} min)</small>` : ''}`;
                        if (c.contact_name && c.contact_name !== '-') contactDisplay = this._escapeHtml(c.contact_name || '');
                    }

                    // Status display with colored badges
                    const emailStatusBadge = (s) => {
                        const map = {sent:'bg-secondary',delivered:'bg-info',opened:'bg-warning text-dark',clicked:'bg-success',bounced:'bg-danger',failed:'bg-danger',draft:'bg-light text-dark'};
                        return `<span class="badge ${map[s]||'bg-secondary'}">${s||'-'}</span>`;
                    };
                    let statusHtml = c.channel === 'email' ? emailStatusBadge(c.status) : this._statusIcon(c.status);
                    if (c.channel === 'email' && c.direction === 'inbound') {
                        statusHtml = '<span class="badge bg-success-subtle text-success">ricevuta</span>';
                    }
                    if (c.channel === 'email' && c.open_count) {
                        statusHtml += ` <small class="text-muted">(${c.open_count}x)</small>`;
                    }
                    if (c.channel === 'whatsapp' && c.status && c.status.includes('non letti')) {
                        statusHtml = `<span class="badge bg-success">${c.status}</span>`;
                    }

                    // Lead/Azienda column
                    const leadLink = c.lead_id
                        ? `<a href="/leads/${c.lead_id}" class="text-decoration-none small" onclick="event.stopPropagation()">${this._escapeHtml(c.lead_name || c.contact_name || 'Lead')}</a>`
                        : '<small class="text-muted">-</small>';

                    return `
                    <tr ${clickAttr}>
                        <td><span class="badge badge-channel-${c.channel}">${c.channel}</span></td>
                        <td><small>${this.formatDate(c.date)}</small></td>
                        <td>${leadLink}</td>
                        <td>${contactDisplay}</td>
                        <td class="text-truncate" style="max-width:250px">${preview}</td>
                        <td class="text-center">${statusHtml}</td>
                        <td class="text-end">${actionBtn || (c.lead_id ? `<a href="/leads/${c.lead_id}" class="btn btn-sm btn-outline-secondary" onclick="event.stopPropagation()"><i class="fa-solid fa-link"></i></a>` : '')}</td>
                    </tr>`;
                }).join('');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // Ore trascorse dall'ultima apertura; null se mai aperta
    _emailHoursSinceLastOpen(e) {
        const last = e.last_opened_at || e.opened_at;
        if (!last) return null;
        return (Date.now() - this.parseDate(last).getTime()) / 3600000;
    },

    // Apertura "fredda": il lead ha aperto ma l'ultima apertura è > 24h fa
    // e non ha mai risposto → serve un follow-up (stesso spirito delle SLA)
    _emailOpenStale(e) {
        const hours = this._emailHoursSinceLastOpen(e);
        return hours !== null && hours > 24 && !e.replied_at;
    },

    _timeAgoIt(hours) {
        if (hours < 1) return 'meno di un’ora fa';
        if (hours < 24) return `${Math.floor(hours)} ore fa`;
        const days = Math.floor(hours / 24);
        return days === 1 ? 'ieri' : `${days} giorni fa`;
    },

    async showEmailPreview(emailId) {
        try {
            const e = await this.api(`/communications/api/email/${emailId}`);

            const isInbound = e.direction === 'inbound';
            const hoursSinceOpen = this._emailHoursSinceLastOpen(e);
            const staleAlert = !isInbound && this._emailOpenStale(e) ? `
                <div class="alert alert-danger d-flex align-items-center py-2 mb-3">
                    <i class="fa-solid fa-triangle-exclamation me-2"></i>
                    <div class="small">
                        <strong>Ultima apertura ${this._timeAgoIt(hoursSinceOpen)}</strong> senza risposta:
                        il lead ha mostrato interesse, valuta un follow-up.
                    </div>
                </div>` : '';

            const trackingHtml = `
                <div class="row g-3 mb-3">
                    <div class="col-4 text-center">
                        <div class="border rounded p-2">
                            <div class="fw-bold fs-4 ${e.status === 'opened' || e.status === 'clicked' ? 'text-success' : 'text-muted'}">${e.open_count}</div>
                            <small class="text-muted">Aperture</small>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="border rounded p-2">
                            <div class="fw-bold fs-4 ${e.clicked_at ? 'text-info' : 'text-muted'}">${e.clicked_at ? '<i class="fa-solid fa-check"></i>' : '-'}</div>
                            <small class="text-muted">Click</small>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="border rounded p-2">
                            <div class="fw-bold fs-4 ${e.replied_at ? 'text-success' : 'text-muted'}">${e.replied_at ? '<i class="fa-solid fa-check"></i>' : '-'}</div>
                            <small class="text-muted">Risposta</small>
                        </div>
                    </div>
                </div>`;

            const statusBadge = {
                sent: '<span class="badge bg-primary">Inviata</span>',
                delivered: '<span class="badge bg-success">Consegnata</span>',
                opened: '<span class="badge bg-warning text-dark">Aperta</span>',
                clicked: '<span class="badge bg-info">Click</span>',
                replied: '<span class="badge bg-success">Risposta</span>',
                received: '<span class="badge bg-success-subtle text-success">Ricevuta</span>',
                bounced: '<span class="badge bg-danger">Rimbalzata</span>',
                failed: '<span class="badge bg-danger">Fallita</span>',
                draft: '<span class="badge bg-secondary">Bozza</span>',
            };

            // Tracking Brevo: solo per le email inviate (sulle ricevute non esiste)
            const trackingSection = isInbound ? '' : `
                <h6 class="fw-bold mb-2"><i class="fa-solid fa-chart-simple me-1"></i> Tracking Brevo</h6>
                ${trackingHtml}
                <div class="small text-muted mb-3">
                    ${e.opened_at ? `<div><i class="fa-solid fa-eye me-1"></i> Prima apertura: ${this.formatDate(e.opened_at)}</div>` : ''}
                    ${(e.last_opened_at || e.opened_at) ? `<div class="${this._emailOpenStale(e) ? 'text-danger fw-medium' : ''}"><i class="fa-solid fa-eye me-1"></i> Ultima apertura: ${this.formatDate(e.last_opened_at || e.opened_at)}${hoursSinceOpen !== null ? ` <span class="text-muted fw-normal">(${this._timeAgoIt(hoursSinceOpen)})</span>` : ''}</div>` : ''}
                    ${e.clicked_at ? `<div><i class="fa-solid fa-mouse-pointer me-1"></i> Primo click: ${this.formatDate(e.clicked_at)}</div>` : ''}
                    ${e.replied_at ? `<div><i class="fa-solid fa-reply me-1"></i> Risposta: ${this.formatDate(e.replied_at)}</div>` : ''}
                </div>`;

            this._showModal(`<i class="fa-solid fa-envelope me-2"></i>${this._escapeHtml(e.subject || 'Email')}`, `
                ${staleAlert}
                <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        ${statusBadge[e.status] || `<span class="badge bg-secondary">${e.status}</span>`}
                        <small class="text-muted">${this.formatDate(e.sent_at)}</small>
                    </div>
                    <table class="table table-sm table-borderless mb-0" style="font-size:13px">
                        <tr><td class="text-muted" style="width:80px">Da:</td><td class="fw-medium">${this._escapeHtml(isInbound ? (e.from_email || '-') : (e.sent_by || '-'))}</td></tr>
                        <tr><td class="text-muted">A:</td><td class="fw-medium">${this._escapeHtml(e.to_email || '')}</td></tr>
                        <tr><td class="text-muted">Oggetto:</td><td class="fw-bold">${this._escapeHtml(e.subject || '')}</td></tr>
                        ${e.template_used ? `<tr><td class="text-muted">Template:</td><td><span class="badge bg-light text-dark">${e.template_used}</span></td></tr>` : ''}
                        ${e.brevo_message_id ? `<tr><td class="text-muted">Brevo ID:</td><td><code class="small">${e.brevo_message_id}</code></td></tr>` : ''}
                    </table>
                </div>
                ${trackingSection}
                <h6 class="fw-bold mb-2"><i class="fa-solid fa-file-lines me-1"></i> Contenuto Email</h6>
                <div class="border rounded p-3 bg-white" style="max-height:400px;overflow-y:auto">
                    ${e.body_html ? DOMPurify.sanitize(e.body_html) : '<p class="text-muted">Nessun contenuto</p>'}
                </div>
            `);
        } catch (e) {
            this.toast('Errore caricamento email: ' + e.message, 'danger');
        }
    },

    async showContactLogEmailPreview(contactLogId) {
        try {
            const e = await this.api(`/communications/api/contact-log/${contactLogId}/email-preview`);
            this._showModal(`<i class="fa-solid fa-envelope me-2"></i>${this._escapeHtml(e.subject || 'Email importata')}`, `
                <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="badge bg-secondary">Importata da SyrusX</span>
                        <small class="text-muted">${this.formatDate(e.sent_at)}</small>
                    </div>
                    <table class="table table-sm table-borderless mb-0" style="font-size:13px">
                        ${e.sent_by ? `<tr><td class="text-muted" style="width:80px">Da:</td><td class="fw-medium">${this._escapeHtml(e.sent_by)}</td></tr>` : ''}
                        ${e.to_email ? `<tr><td class="text-muted">A:</td><td class="fw-medium">${this._escapeHtml(e.to_email)}</td></tr>` : ''}
                    </table>
                </div>
                <h6 class="fw-bold mb-2"><i class="fa-solid fa-file-lines me-1"></i> Contenuto</h6>
                <div class="border rounded p-3 bg-white" style="max-height:400px;overflow-y:auto">
                    ${e.body_html ? DOMPurify.sanitize(e.body_html) : '<p class="text-muted">Nessun contenuto disponibile</p>'}
                </div>
            `);
        } catch (e) {
            this.toast('Errore caricamento email: ' + e.message, 'danger');
        }
    },

    // ── PBX Calls Tab (with live polling) ──────────────────────────────────
    _pbxPollTimer: null,
    _pbxLastHash: '',

    _startPbxPolling() {
        this._stopPbxPolling();
        this._pbxPollTimer = setInterval(() => this._pollPbxCalls(), 3000);
    },

    _stopPbxPolling() {
        if (this._pbxPollTimer) {
            clearInterval(this._pbxPollTimer);
            this._pbxPollTimer = null;
        }
    },

    async _pollPbxCalls() {
        try {
            const data = await this.api('/communications/api/pbx-calls?per_page=20');
            // Simple change detection: compare IDs + statuses
            const hash = data.items.map(c => `${c.id}:${c.status}:${c.duration}`).join('|');
            if (hash !== this._pbxLastHash) {
                this._pbxLastHash = hash;
                this._renderPbxCalls(data);
            }
        } catch (e) { /* silent — polling */ }
    },

    async _loadPbxCalls() {
        try {
            const data = await this.api('/communications/api/pbx-calls');
            this._pbxLastHash = data.items.map(c => `${c.id}:${c.status}:${c.duration}`).join('|');
            this._renderPbxCalls(data);
            this._startPbxPolling();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    _renderPbxCalls(data) {
        const tbody = document.getElementById('comms-table');
        if (!tbody) return;

        // Update column header: "Anteprima" → "Durata" for phone tab
        const th5 = tbody.closest('table')?.querySelector('thead th:nth-child(5)');
        if (th5) th5.textContent = 'Durata';

        if (!data.items.length) {
            tbody.innerHTML = '<tr><td colspan="7" class="text-center py-5 text-muted"><i class="fa-solid fa-phone fa-2x mb-2 d-block" style="opacity:.3"></i>Nessuna telefonata registrata</td></tr>';
            return;
        }
        tbody.innerHTML = data.items.map(c => {
            const dirIcon = c.direction === 'in'
                ? '<i class="fa-solid fa-phone-arrow-down-left text-success"></i>'
                : '<i class="fa-solid fa-phone-arrow-up-right text-primary"></i>';

            // Status: Ricevuta/Effettuata for answered calls, specific label otherwise
            const isAnswered = c.status === 'called' || c.status === 'answered';
            const isRinging = c.status === 'ringing';
            let statusLabel, statusClass;
            if (isRinging) {
                statusLabel = 'In corso';
                statusClass = 'bg-info';
            } else if (isAnswered) {
                statusLabel = c.direction === 'in' ? 'Ricevuta' : 'Effettuata';
                statusClass = 'bg-success';
            } else {
                // no-answer, busy, failed
                const labels = {'no-answer':'Non risposta', busy:'Occupato', failed:'Fallita'};
                statusLabel = labels[c.status] || c.status || '-';
                statusClass = 'bg-danger';
            }

            const duration = c.duration ? `${Math.ceil(c.duration/60)} min` : '-';

            let leadCol;
            if (c.lead_id) {
                leadCol = `<a href="/leads/${c.lead_id}" class="text-decoration-none"><code class="me-1">${this._escapeHtml(c.lead_crm_id||'')}</code>${this._escapeHtml(c.lead_name||'')}</a>`;
            } else {
                leadCol = `<div class="btn-group btn-group-sm">` +
                    `<button class="btn btn-outline-success" onclick="SyrusApp._createLeadFromCall('${c.id}')" title="Crea nuova lead"><i class="fa-solid fa-user-plus me-1"></i>Nuova Lead</button>` +
                    `<button class="btn btn-outline-warning" onclick="SyrusApp._linkPbxCall('${c.id}')" title="Collega a lead esistente"><i class="fa-solid fa-link"></i></button>` +
                    `</div>`;
            }

            let actions = '';
            if (c.has_recording) {
                actions += `<button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.toggleCommsAudio(this, '${this._escapeAttr(c.recording_url||'')}')" title="Ascolta"><i class="fa-solid fa-play"></i></button> `;
            }
            if (c.lead_id) {
                actions += `<a href="/leads/${c.lead_id}" class="btn btn-sm btn-outline-dark" title="Vai alla lead"><i class="fa-solid fa-arrow-right"></i></a>`;
            }

            return `<tr${isRinging ? ' class="table-info"' : ''}>
                <td>${dirIcon} <span class="badge bg-dark">Telefono</span>${isRinging ? ' <span class="badge bg-info ms-1"><i class="fa-solid fa-phone-volume me-1"></i>In corso</span>' : ''}</td>
                <td><small>${this.formatDate(c.started_at)}</small></td>
                <td>${leadCol}</td>
                <td class="fw-medium">${this._escapeHtml(c.phone_number||'-')}</td>
                <td>${isRinging ? '<span class="text-info fw-bold">in corso...</span>' : duration}</td>
                <td class="text-center"><span class="badge ${statusClass}">${statusLabel}</span></td>
                <td class="text-end">${actions}</td>
            </tr>`;
        }).join('');
    },

    async _linkPbxCall(callId) {
        // Show modal with lead selector
        try {
            const leads = await this.api('/leads/api/list?per_page=100&sort=company_name');
            const options = (leads.items||[]).map(l =>
                `<option value="${l.id}">${this._escapeHtml(l.crm_id||'')} — ${this._escapeHtml(l.company_name||l.contact_name||'')}</option>`
            ).join('');

            this._showModal(
                '<i class="fa-solid fa-link me-2"></i>Collega chiamata a Lead',
                `<div class="mb-3">
                    <label class="form-label fw-bold">Seleziona la lead da collegare</label>
                    <select id="pbx-link-lead" class="form-select">${options}</select>
                </div>
                <p class="text-muted small">Il numero di telefono verrà salvato nella lead e le prossime chiamate verranno associate automaticamente.</p>
                <button class="btn btn-primary w-100" onclick="SyrusApp._executeLinkPbx('${callId}')">
                    <i class="fa-solid fa-check me-2"></i>Collega
                </button>`
            );
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async _executeLinkPbx(callId) {
        const leadId = document.getElementById('pbx-link-lead')?.value;
        if (!leadId) return;
        try {
            await this.api(`/communications/api/pbx-calls/${callId}/link`, {
                method: 'POST',
                body: JSON.stringify({lead_id: leadId}),
            });
            this._closeAllModals();
            this.toast('Chiamata collegata alla lead!', 'success');
            this._loadPbxCalls();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async _createLeadFromCall(callId) {
        if (!confirm('Creare una nuova lead da questa telefonata?\n\nSe è disponibile una registrazione, verrà trascritta e analizzata automaticamente.')) return;
        try {
            const result = await this.api(`/communications/api/pbx-calls/${callId}/create-lead`, {
                method: 'POST',
            });
            this.toast(`${result.message} — ${result.crm_id}`, 'success');
            this._loadPbxCalls();
            // Navigate to new lead
            setTimeout(() => this.spaNavigate(`/leads/${result.lead_id}`), 1000);
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // ── Comms Audio Player ──────────────────────────────────────────────────
    _commsAudio: null,
    _commsAudioBtn: null,

    toggleCommsAudio(btn, url) {
        // If same audio is playing, stop it
        if (this._commsAudio && this._commsAudioBtn === btn) {
            this._commsAudio.pause();
            this._commsAudio = null;
            this._commsAudioBtn = null;
            btn.innerHTML = '<i class="fa-solid fa-play"></i>';
            btn.classList.remove('btn-danger');
            btn.classList.add('btn-outline-primary');
            return;
        }

        // Stop previous if playing
        if (this._commsAudio) {
            this._commsAudio.pause();
            if (this._commsAudioBtn) {
                this._commsAudioBtn.innerHTML = '<i class="fa-solid fa-play"></i>';
                this._commsAudioBtn.classList.remove('btn-danger');
                this._commsAudioBtn.classList.add('btn-outline-primary');
            }
        }

        // Play new
        this._commsAudio = new Audio(url);
        this._commsAudioBtn = btn;
        btn.innerHTML = '<i class="fa-solid fa-stop"></i>';
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-danger');

        this._commsAudio.play().catch(() => {
            btn.innerHTML = '<i class="fa-solid fa-play"></i>';
            btn.classList.remove('btn-danger');
            btn.classList.add('btn-outline-primary');
        });

        this._commsAudio.onended = () => {
            btn.innerHTML = '<i class="fa-solid fa-play"></i>';
            btn.classList.remove('btn-danger');
            btn.classList.add('btn-outline-primary');
            this._commsAudio = null;
            this._commsAudioBtn = null;
        };
    },
});


// ── app-sla.js ──
/** Syrus Sales OS – Coda SLA (triage a carte delle violazioni) */
Object.assign(SyrusApp, {

    _slaQueue: [],
    _slaIdx: 0,
    _slaAiAvailable: false,

    // ── Heartbeat: promemoria periodico interruttivo (opt-out + snooze) ──────
    SLA_HEARTBEAT_MIN: 20,            // intervallo controllo
    _slaHeartbeatTimer: null,

    initSlaHeartbeat() {
        if (!document.getElementById('sla-violation-banner')) return; // solo se loggato
        if (localStorage.getItem('sla_heartbeat_off') === '1') return;
        clearInterval(this._slaHeartbeatTimer);
        this._slaHeartbeatTimer = setInterval(
            () => this._slaHeartbeatTick(), this.SLA_HEARTBEAT_MIN * 60000);
    },

    async _slaHeartbeatTick() {
        if (localStorage.getItem('sla_heartbeat_off') === '1') return;
        const snoozeUntil = parseInt(localStorage.getItem('sla_heartbeat_snooze') || '0', 10);
        if (Date.now() < snoozeUntil) return;
        // Non interrompere: modale aperta, oppure l'utente sta scrivendo
        if (document.querySelector('.modal.show')) return;
        const ae = document.activeElement;
        if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
        try {
            const d = await this.api('/leads/api/sla/banner');
            if (d && d.count > 0) this._slaHeartbeatPrompt(d);
        } catch (_) { /* silenzioso */ }
    },

    _slaHeartbeatPrompt(d) {
        this._showModal('Promemoria SLA', `
            <div class="text-center py-2">
                <i class="fa-solid fa-bell fa-2x text-warning mb-3"></i>
                <p class="mb-1">Hai <strong>${d.count}</strong> lead in violazione SLA.</p>
                <p class="text-muted small">La più urgente: ${this._escapeHtml(d.crm_id || '')} ${this._escapeHtml(d.company_name || '')}</p>
                <div class="d-flex gap-2 justify-content-center flex-wrap mt-3">
                    <button class="btn btn-primary" onclick="SyrusApp.openSlaQueue()">Smaltisci ora</button>
                    <button class="btn btn-light" onclick="SyrusApp._slaHeartbeatLater()">Più tardi</button>
                </div>
                <button class="btn btn-link btn-sm text-muted mt-2 text-decoration-none" onclick="SyrusApp._slaHeartbeatOff()">Non ricordarmelo più</button>
            </div>`, 'modal-dialog-centered');
    },

    _slaHeartbeatLater() {
        localStorage.setItem('sla_heartbeat_snooze', String(Date.now() + 3600000)); // 1h
        this._closeAllModals();
        this.toast('Ti ricordo le SLA tra un\'ora', 'info');
    },

    _slaHeartbeatOff() {
        localStorage.setItem('sla_heartbeat_off', '1');
        clearInterval(this._slaHeartbeatTimer);
        this._closeAllModals();
        this.toast('Promemoria SLA disattivati (riattivabili svuotando la cache)', 'info');
    },

    _slaStatusLabel(s) {
        return ({
            new: 'Nuovo', contacted: 'Contattata', qualified: 'Qualificata',
            proposal_sent: 'Proposta inviata', negotiation: 'Negoziazione',
            won: 'Vinta', lost: 'Persa', dormant: 'Dormant', spam: 'Spam',
        })[s] || s;
    },

    async openSlaQueue() {
        try {
            const data = await this.api('/leads/api/sla/queue');
            // Mostra il bottone AI solo se il Codex condiviso risponde davvero
            this._slaAiAvailable = !!data.ai_available;
            this._slaQueue = data.items || [];
            this._slaIdx = 0;
            if (!this._slaQueue.length) {
                this.toast('Nessuna SLA da smaltire 🎉', 'success');
                this._pollSlaBanner?.();
                return;
            }
            this._showModal('Coda SLA', '<div id="sla-card"></div>');
            this._renderSlaCard();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    _renderSlaCard() {
        const el = document.getElementById('sla-card');
        if (!el) return;

        if (this._slaIdx >= this._slaQueue.length) {
            el.innerHTML = `<div class="text-center py-5">
                <i class="fa-solid fa-circle-check fa-2x text-success mb-3"></i>
                <h6 class="mb-1">Coda completata</h6>
                <p class="text-muted small">Hai smaltito tutte le SLA in coda.</p>
                <button class="btn btn-sm btn-primary" onclick="SyrusApp._closeAllModals()">Chiudi</button></div>`;
            this._pollSlaBanner?.();
            return;
        }

        const l = this._slaQueue[this._slaIdx];
        const meta = [
            `<code>${this._escapeHtml(l.crm_id || '')}</code>`,
            this._slaStatusLabel(l.status),
            this._escapeHtml(l.assigned_name || 'Non assegnato'),
            l.deal_value ? `${Number(l.deal_value).toLocaleString('it-IT')} €` : null,
        ].filter(Boolean).join(' · ');

        const contacts = [
            l.contact_phone ? `<i class="fa-solid fa-phone fa-xs me-1"></i>${this._escapeHtml(l.contact_phone)}` : null,
            l.contact_email ? `<i class="fa-solid fa-envelope fa-xs me-1"></i>${this._escapeHtml(l.contact_email)}` : null,
        ].filter(Boolean).join('<span class="mx-2 text-muted">·</span>');

        const transOpts = (l.allowed_transitions || [])
            .map(s => `<option value="${s}">→ ${this._slaStatusLabel(s)}</option>`).join('')
            || '<option value="">(invariato)</option>';

        const aiBtn = this._slaAiAvailable
            ? `<button class="btn btn-sm btn-link text-muted text-decoration-none p-0" onclick="SyrusApp.slaAiSuggest()"><i class="fa-solid fa-robot me-1"></i>Chiedi all'AI</button>`
            : '';

        el.innerHTML = `
        <div class="d-flex justify-content-between text-muted small mb-3">
            <span>${this._slaIdx + 1} di ${this._slaQueue.length}</span>
            <span>ferma da ${Math.round(l.hours_in_status)}h lavorative</span>
        </div>

        <h6 class="mb-1">${this._escapeHtml(l.company_name || l.contact_name || '—')}</h6>
        <div class="text-muted small">${meta}</div>
        ${contacts ? `<div class="text-muted small mt-1">${contacts}</div>` : ''}

        <hr class="my-3">

        <div class="d-flex align-items-center justify-content-between mb-1">
            <span class="text-muted small text-uppercase" style="letter-spacing:.04em">Consigliato</span>
            <button class="btn btn-sm btn-primary" onclick="SyrusApp._slaApplySuggested()">Applica</button>
        </div>
        <div class="fw-semibold">${this._escapeHtml(l.suggestion.label)}</div>
        <div class="text-muted small">${this._escapeHtml(l.suggestion.reason)}</div>

        <div class="text-muted small text-uppercase mt-3 mb-2" style="letter-spacing:.04em">Oppure</div>
        <div class="input-group input-group-sm mb-2">
            <button class="btn btn-outline-secondary" onclick="SyrusApp.slaTriage('contact_advance')">Contatta + avanza</button>
            <select id="sla-to-status" class="form-select">${transOpts}</select>
        </div>
        <div class="d-flex gap-2 flex-wrap align-items-center">
            <div class="input-group input-group-sm" style="width:auto">
                <button class="btn btn-outline-secondary" onclick="SyrusApp.slaTriage('postpone')">Rimanda</button>
                <input id="sla-days" type="number" min="1" value="3" class="form-control" style="width:56px">
                <span class="input-group-text">gg</span>
            </div>
            <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.slaTriage('waiting_client')">In attesa cliente</button>
            <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.slaTriage('dormant')">Dormant</button>
            <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.slaTriage('lost')">Persa</button>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
            ${aiBtn || '<span></span>'}
            <button class="btn btn-sm btn-light" onclick="SyrusApp._slaSkip()">Salta <i class="fa-solid fa-forward fa-xs ms-1"></i></button>
        </div>
        <div id="sla-ai-out" class="small mt-2"></div>`;
    },

    _slaApplySuggested() {
        const l = this._slaQueue[this._slaIdx];
        if (l) this.slaTriage(l.suggestion.action);
    },

    _slaSkip() { this._slaIdx++; this._renderSlaCard(); },

    async slaTriage(action) {
        const l = this._slaQueue[this._slaIdx];
        if (!l) return;
        const body = { action };
        if (action === 'contact_advance') body.to_status = document.getElementById('sla-to-status')?.value || '';
        if (action === 'postpone') body.days = parseInt(document.getElementById('sla-days')?.value || '3', 10);
        try {
            const r = await this.api(`/leads/api/${l.id}/sla-triage`, { method: 'POST', body: JSON.stringify(body) });
            if (r.ok === false) { this.toast(r.error || 'Errore', 'danger'); return; }
            this.toast(r.message || 'Fatto', 'success');
            this._slaIdx++;
            this._renderSlaCard();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async slaAiSuggest() {
        const l = this._slaQueue[this._slaIdx];
        if (!l) return;
        const out = document.getElementById('sla-ai-out');
        if (out) out.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>L\'AI sta ragionando…';
        try {
            const r = await this.api(`/leads/api/${l.id}/sla-ai-suggest`, { method: 'POST', body: JSON.stringify({}) });
            if (!out) return;
            if (r.ok === false || !r.text) { out.textContent = 'AI non disponibile al momento'; return; }
            out.innerHTML = `<div class="border-start border-3 ps-2 text-muted" style="border-color:var(--color-border-strong)!important"><i class="fa-solid fa-robot me-1"></i>${this._escapeHtml(r.text)}</div>`;
        } catch (e) { if (out) out.textContent = 'AI non disponibile al momento'; }
    },
});


// ── app-whatsapp.js ──
/** Syrus Sales OS – WhatsApp Module (inbox, chat, numbers, templates, broadcast) */
Object.assign(SyrusApp, {

    // ── WhatsApp ────────────────────────────────────────────────────────────
    async loadWaInboxes() {
        const list = document.getElementById('wa-inboxes');
        if (!list) return;
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            if (nums.length === 0) {
                list.innerHTML = `<div class="list-group-item text-center py-5">
                    <i class="fa-brands fa-whatsapp fa-3x text-muted mb-3 d-block"></i>
                    <p class="mb-2">Nessun numero WhatsApp configurato</p>
                    <a href="/whatsapp/numbers" class="btn btn-primary btn-sm"><i class="fa-solid fa-plus me-1"></i> Configura il primo numero</a>
                </div>`;
            } else {
                list.innerHTML = nums.map(n => `
                    <a href="/whatsapp/inbox/${n.phone_number_id}" class="list-group-item list-group-item-action p-4">
                        <div class="d-flex align-items-center gap-3">
                            <div style="width:40px;height:40px;background:#25D366;border-radius:50%;display:flex;align-items:center;justify-content:center">
                                <i class="fa-brands fa-whatsapp text-white fs-5"></i>
                            </div>
                            <div class="flex-grow-1">
                                <div class="fw-bold">${n.label || 'Numero WA'}</div>
                                <small class="text-muted">${n.phone_number || n.phone_number_id}</small>
                            </div>
                            <i class="fa-solid fa-chevron-right text-muted"></i>
                        </div>
                    </a>`).join('');
            }
        } catch (e) {
            list.innerHTML = '<div class="list-group-item text-center text-danger py-4">Errore caricamento: ' + this._escapeHtml(e.message || '') + '</div>';
        }
    },

    async loadWaConversations(pnid) {
        const list = document.getElementById('wa-conversations');
        if (!list) return;
        try {
            const convs = await this.api(`/whatsapp/api/conversations/${pnid}`);
            if (convs.length === 0) {
                list.innerHTML = `<div class="list-group-item text-center py-5 text-muted">
                    <i class="fa-solid fa-comments fa-2x mb-2 d-block"></i>Nessuna conversazione ancora</div>`;
            } else {
                list.innerHTML = convs.map(c => `
                    <a href="/whatsapp/" onclick="sessionStorage.setItem('wa_deep_link',JSON.stringify({pnid:'${pnid}',waId:'${c.wa_id}'}))" class="list-group-item list-group-item-action p-4">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <div class="fw-bold">${c.contact_name}</div>
                                <small class="text-muted">${c.wa_id}</small>
                            </div>
                            <div class="text-end">
                                <small class="text-muted d-block">${this.formatDate(c.last_message_at)}</small>
                                ${c.unread_count ? `<span class="badge bg-success mt-1">${c.unread_count}</span>` : ''}
                            </div>
                        </div>
                    </a>`).join('');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    _chatPollTimer: null,

    initChat(pnid, waId) {
        if (this._chatPollTimer) { clearInterval(this._chatPollTimer); this._chatPollTimer = null; }
        this.loadChatMessages(pnid, waId);
        // Poll every 3 seconds
        this._chatPollTimer = setInterval(() => this.loadChatMessages(pnid, waId, true), 3000);
        // Mark read
        this.api('/whatsapp/api/messages/mark-read', { method: 'POST', body: JSON.stringify({ pnid, wa_id: waId }) });
    },

    _lastMsgTimestamp: null,

    async loadChatMessages(pnid, waId, poll = false) {
        try {
            let url = `/whatsapp/api/messages/${pnid}/${waId}`;
            if (poll && this._lastMsgTimestamp) url += `?after=${this._lastMsgTimestamp}`;

            const data = await this.api(url);

            if (!poll) {
                document.getElementById('chat-contact-name').textContent = data.contact_name;
                if (data.window_expires_at) {
                    document.getElementById('chat-window-info').textContent = `Finestra 24h: ${this.formatDate(data.window_expires_at)}`;
                }
            }

            if (!poll || data.messages.length > 0) {
                const container = document.getElementById('chat-messages');
                if (!poll) container.innerHTML = '';

                data.messages.forEach(m => {
                    const bubble = document.createElement('div');
                    bubble.className = `chat-bubble ${m.direction === 'incoming' ? 'incoming' : 'outgoing'}`;

                    let content = '';
                    if (m.type === 'text' || m.type === 'button' || m.type === 'interactive') content = m.content?.body || '';
                    else if (m.type === 'image') content = `<i class="fa-solid fa-image"></i> ${m.content?.caption || 'Immagine'}`;
                    else if (m.type === 'document') content = `<i class="fa-solid fa-file"></i> ${m.content?.caption || 'Documento'}`;
                    else if (m.type === 'audio') content = `<i class="fa-solid fa-microphone"></i> Audio`;
                    else if (m.type === 'template') {
                        content = this._renderTemplateContent(m.content);
                    }
                    else content = `<i class="fa-solid fa-comment"></i> ${m.type}`;

                    const statusIcon = m.direction === 'outgoing' ? (
                        m.status === 'read' ? '<i class="fa-solid fa-check-double text-primary"></i>' :
                        m.status === 'delivered' ? '<i class="fa-solid fa-check-double"></i>' :
                        '<i class="fa-solid fa-check"></i>'
                    ) : '';

                    bubble.innerHTML = `<div>${DOMPurify.sanitize(content)}</div><div class="chat-time">${this.formatDate(m.timestamp)} ${statusIcon}</div>`;
                    container.appendChild(bubble);

                    this._lastMsgTimestamp = m.timestamp;
                });

                container.scrollTop = container.scrollHeight;
            }
        } catch (e) { if (!poll) this.toast(e.message, 'danger'); }
    },

    _waSendForce: false,
    async sendWaMessage(event) {
        event.preventDefault();
        const pnid = document.getElementById('chat-pnid').value;
        const waId = document.getElementById('chat-waid').value;
        const input = document.getElementById('chat-input');
        const text = input.value.trim();
        if (!text) return;

        const payload = { phone_number_id: pnid, to: waId, type: 'text', text };
        if (this._waSendForce) { payload.force = true; this._waSendForce = false; }

        try {
            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            if (result.ok === false && result.needs_confirmation) {
                if (confirm(result.reason)) { this._waSendForce = true; return this.sendWaMessage(event); }
                return;
            }
            if (result.ok === false) {
                this.toast(result.error || result.reason || 'Errore invio messaggio', 'danger');
                return;
            }
            input.value = '';
            this.loadChatMessages(pnid, waId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async handleWaFileSelect(input) {
        const file = input.files[0];
        if (!file) return;

        const pnid = document.getElementById('chat-pnid').value;
        const waId = document.getElementById('chat-waid').value;

        this.toast('Invio allegato in corso...', 'info');

        try {
            // Upload file to server
            const formData = new FormData();
            formData.append('file', file);

            const resp = await SyrusApp.fetchWithCsrf('/whatsapp/api/media/upload', { method: 'POST', body: formData });
            const upload = await resp.json();
            if (!upload.ok) throw new Error(upload.error || 'Upload fallito');

            // Send via WhatsApp
            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify({
                    phone_number_id: pnid,
                    to: waId,
                    type: upload.media_type,
                    media_url: upload.url,
                    caption: file.name,
                    filename: file.name,
                })
            });

            if (result.ok) {
                this.toast('Allegato inviato!', 'success');
                this.loadChatMessages(pnid, waId);
            } else {
                this.toast(result.error || 'Errore invio', 'danger');
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        }

        input.value = ''; // reset file input
    },

    async loadWaNumbers() {
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            const tbody = document.getElementById('wa-numbers-table');
            if (nums.length === 0) {
                tbody.innerHTML = '<tr><td colspan="7" class="text-center py-5 text-muted"><i class="fa-solid fa-phone-volume fa-2x mb-2 d-block"></i>Nessun numero configurato</td></tr>';
            } else {
                tbody.innerHTML = nums.map(n => `
                    <tr>
                        <td class="fw-bold">${n.label || '-'}</td>
                        <td>${n.phone_number || '-'}</td>
                        <td><code class="small">${n.phone_number_id}</code></td>
                        <td><code class="small">${n.waba_id || '-'}</code></td>
                        <td class="text-center">${n.webhook_active ? '<i class="fa-solid fa-circle-check text-success"></i>' : '<i class="fa-solid fa-circle-xmark text-danger"></i>'}</td>
                        <td class="text-center"><i class="fa-solid fa-circle ${n.waba_id ? 'text-success' : 'text-warning'}" title="${n.waba_id ? 'Configurato' : 'Token mancante'}"></i></td>
                        <td class="text-end">
                            <button class="btn btn-sm btn-secondary me-1" onclick="SyrusApp.showWaNumberModal('${n.id}')"><i class="fa-solid fa-pencil me-1"></i>Modifica</button>
                            <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteWaNumber('${n.id}')"><i class="fa-solid fa-trash"></i></button>
                        </td>
                    </tr>`).join('');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadWaNotifyEmails() {
        const ta = document.getElementById('wa-notify-emails');
        if (!ta) return;
        try {
            const res = await this.api('/whatsapp/api/notify-emails');
            ta.value = (res.emails || []).join('\n');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async saveWaNotifyEmails(event) {
        event.preventDefault();
        const ta = document.getElementById('wa-notify-emails');
        try {
            const res = await this.api('/whatsapp/api/notify-emails', {
                method: 'POST', body: JSON.stringify({ emails: ta.value }) });
            ta.value = (res.emails || []).join('\n');
            this.toast('Destinatari notifiche salvati!', 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadWaAutoreply() {
        const enabled = document.getElementById('wa-autoreply-enabled');
        if (!enabled) return;
        try {
            const res = await this.api('/whatsapp/api/autoreply-settings');
            enabled.checked = !!res.enabled;
            document.getElementById('wa-autoreply-seconds').value = res.seconds;
            document.getElementById('wa-autoreply-text').value = res.text || '';
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async saveWaAutoreply(event) {
        event.preventDefault();
        try {
            const res = await this.api('/whatsapp/api/autoreply-settings', {
                method: 'POST',
                body: JSON.stringify({
                    enabled: document.getElementById('wa-autoreply-enabled').checked,
                    seconds: document.getElementById('wa-autoreply-seconds').value,
                    text: document.getElementById('wa-autoreply-text').value,
                }),
            });
            this.toast(`Risposta automatica ${res.enabled ? 'attiva' : 'disattivata'} (attesa ${res.seconds}s)`, 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadWaContacts() {
        try {
            const contacts = await this.api('/whatsapp/api/wa-contacts');
            const tbody = document.getElementById('wa-contacts-table');
            if (contacts.length === 0) {
                tbody.innerHTML = '<tr><td colspan="6" class="text-center text-muted">Nessun contatto</td></tr>';
            } else {
                tbody.innerHTML = contacts.map(c => `
                    <tr>
                        <td>${c.wa_id}</td><td>${c.name || '-'}</td><td>${c.company || '-'}</td>
                        <td>${c.email || '-'}</td><td>${(c.tags || []).join(', ')}</td>
                        <td><button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteWaContact('${c.wa_id}')"><i class="fa-solid fa-trash"></i></button></td>
                    </tr>`).join('');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── WA Number Modal ───────────────────────────────────────────────────
    async showWaNumberModal(numId) {
        let label = '', phoneNumber = '', phoneNumberId = '', wabaId = '', accessToken = '', notes = '';
        if (numId) {
            try {
                const nums = await this.api('/whatsapp/api/numbers');
                const num = nums.find(n => n.id === numId);
                if (num) {
                    label = num.label || '';
                    phoneNumber = num.phone_number || '';
                    phoneNumberId = num.phone_number_id || '';
                    wabaId = num.waba_id || '';
                    notes = '';
                }
            } catch(e) { console.warn('Errore caricamento numero WA:', e.message); }
        }

        this._showModal(numId ? 'Modifica Numero WhatsApp' : 'Aggiungi Numero WhatsApp', `
            <form onsubmit="SyrusApp.saveWaNumber(event, '${numId || ''}')">
                <div class="mb-2"><label class="form-label fw-bold">Label / Nome</label>
                    <input name="label" class="form-control" value="${label}" required placeholder="es. Syrus Business"></div>
                <div class="mb-2"><label class="form-label fw-bold">Numero Telefono</label>
                    <input name="phone_number" class="form-control" value="${phoneNumber}" placeholder="+39 339 1234567"></div>
                <div class="mb-2"><label class="form-label fw-bold">Phone Number ID (Meta) <span class="text-danger">*</span></label>
                    <input name="phone_number_id" class="form-control" value="${phoneNumberId}" required placeholder="es. 1060713713787658">
                    <small class="text-muted">Lo trovi su Meta Business → WhatsApp → Configurazione API</small></div>
                <div class="mb-2"><label class="form-label fw-bold">WABA ID</label>
                    <input name="waba_id" class="form-control" value="${wabaId}" placeholder="WhatsApp Business Account ID"></div>
                <div class="mb-2"><label class="form-label fw-bold">Access Token (Meta)</label>
                    <input name="access_token" type="password" class="form-control" placeholder="Token long-lived da System User">
                    <small class="text-muted">Meta Business → Impostazioni → Utenti di sistema → Token permanente</small></div>
                <div class="mb-2"><label class="form-label fw-bold">Note</label>
                    <textarea name="notes" class="form-control" rows="2">${notes}</textarea></div>
                <button type="submit" class="btn btn-primary w-100 mt-2"><i class="fa-solid fa-floppy-disk me-1"></i> Salva</button>
            </form>`);
    },

    async saveWaNumber(event, numId) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        if (numId) data.id = numId;
        try {
            await this.api('/whatsapp/api/numbers/save', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Numero salvato!', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.loadWaNumbers();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteWaNumber(numId) {
        if (!confirm('Eliminare questo numero WhatsApp?')) return;
        try {
            await this.api(`/whatsapp/api/numbers/${numId}`, { method: 'DELETE' });
            this.toast('Numero eliminato');
            this.loadWaNumbers();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteWaContact(waId) {
        if (!confirm('Eliminare questo contatto WhatsApp?')) return;
        try {
            await this.api(`/whatsapp/api/wa-contacts/${waId}`, { method: 'DELETE' });
            this.toast('Contatto eliminato');
            this.loadWaContacts();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── WA Contact Modal ────────────────────────────────────────────────────
    showWaContactModal() {
        this._showModal('Aggiungi Contatto WhatsApp', `
            <form onsubmit="SyrusApp.saveWaContact(event)">
                <div class="mb-2"><label class="form-label fw-bold">Numero WhatsApp <span class="text-danger">*</span></label>
                    <input name="wa_id" class="form-control" required placeholder="393391234567 (senza +)"></div>
                <div class="mb-2"><label class="form-label fw-bold">Nome</label>
                    <input name="name" class="form-control" placeholder="Nome completo"></div>
                <div class="mb-2"><label class="form-label fw-bold">Azienda</label>
                    <input name="company" class="form-control"></div>
                <div class="mb-2"><label class="form-label fw-bold">Email</label>
                    <input name="email" type="email" class="form-control"></div>
                <div class="mb-2"><label class="form-label fw-bold">Note</label>
                    <textarea name="notes" class="form-control" rows="2"></textarea></div>
                <button type="submit" class="btn btn-primary w-100 mt-2"><i class="fa-solid fa-floppy-disk me-1"></i> Salva</button>
            </form>`);
    },

    async saveWaContact(event) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        try {
            await this.api('/whatsapp/api/wa-contacts/save', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Contatto salvato!', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.loadWaContacts();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── WA Templates Page ─────────────────────────────────────────────────
    async loadWaTemplatesPage() {
        // Populate WABA select
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            const sel = document.getElementById('wa-tpl-waba');
            if (!sel) return;
            sel.innerHTML = '<option value="">Seleziona WABA...</option>';
            const wabas = new Set();
            nums.forEach(n => {
                if (n.waba_id && !wabas.has(n.waba_id)) {
                    wabas.add(n.waba_id);
                    sel.innerHTML += `<option value="${n.waba_id}">${n.label || n.waba_id}</option>`;
                }
            });
            sel.addEventListener('change', () => this._loadWaTemplatesList(sel.value));
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async syncWaTemplates() {
        const sel = document.getElementById('wa-tpl-waba');
        const wabaId = sel ? sel.value : '';
        if (!wabaId) { this.toast('Seleziona prima un WABA ID', 'warning'); return; }
        this.toast('Sincronizzazione template in corso...', 'info');
        try {
            const r = await this.api(`/whatsapp/api/templates/sync/${wabaId}`, { method: 'POST' });
            this.toast(`${r.synced} template sincronizzati!`, 'success');
            this._loadWaTemplatesList(wabaId);
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async _loadWaTemplatesList(wabaId) {
        const tbody = document.getElementById('wa-templates-table');
        if (!tbody) return;
        if (!wabaId) {
            tbody.innerHTML = '<tr><td colspan="5" class="text-center py-5 text-muted">Seleziona un WABA ID</td></tr>';
            return;
        }
        try {
            const tpls = await this.api(`/whatsapp/api/templates/${wabaId}`);
            if (tpls.length === 0) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center py-5 text-muted">Nessun template. Clicca Sincronizza.</td></tr>';
            } else {
                const statusBadge = (s) => {
                    if (s === 'APPROVED') return '<span class="badge bg-success">APPROVED</span>';
                    if (s === 'REJECTED') return '<span class="badge bg-danger">REJECTED</span>';
                    if (s === 'DRAFT') return '<span class="badge bg-secondary">BOZZA</span>';
                    return `<span class="badge bg-warning">${s}</span>`;
                };
                const actions = (t) => {
                    if (t.status === 'DRAFT') return `
                        <button class="btn btn-sm btn-outline-primary me-1" onclick="SyrusApp._previewDraftTemplate('${this._escapeAttr(t.id)}')"><i class="fa-solid fa-eye me-1"></i>Anteprima</button>
                        <button class="btn btn-sm btn-primary me-1" onclick="SyrusApp._submitDraftToMeta('${this._escapeAttr(t.id)}')"><i class="fa-brands fa-meta me-1"></i>Invia a Meta</button>
                        <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp._deleteDraftTemplate('${this._escapeAttr(t.id)}')"><i class="fa-solid fa-trash"></i></button>`;
                    if (t.status === 'APPROVED') return `<button class="btn btn-sm btn-secondary" onclick="SyrusApp.showFreeWhatsappModal()"><i class="fa-solid fa-paper-plane me-1"></i>Invia</button>`;
                    return '';
                };
                // Show drafts first, then by status
                const order = {'DRAFT': 0, 'PENDING': 1, 'APPROVED': 2, 'REJECTED': 3};
                tpls.sort((a, b) => (order[a.status] ?? 9) - (order[b.status] ?? 9));
                tbody.innerHTML = tpls.map(t => `
                    <tr${t.status === 'DRAFT' ? ' class="table-light"' : ''}>
                        <td class="fw-bold">${this._escapeHtml(t.name)}</td>
                        <td>${this._escapeHtml(t.language)}</td>
                        <td>${this._escapeHtml(t.category || '-')}</td>
                        <td>${statusBadge(t.status)}</td>
                        <td class="text-end">${actions(t)}</td>
                    </tr>`).join('');
            }
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    // ── Create Template ──────────────────────────────────────────────────────
    showCreateTemplateModal() {
        const wabaId = document.getElementById('wa-tpl-waba')?.value;
        if (!wabaId) { this.toast('Seleziona prima un WABA ID', 'warning'); return; }

        this._showModal('Nuovo Template WhatsApp', `
            <form id="create-tpl-form">
                <input type="hidden" id="tpl-waba-id" value="${wabaId}">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Nome template <span class="text-danger">*</span></label>
                        <input type="text" id="tpl-name" class="form-control" placeholder="es. welcome_message" pattern="[a-z0-9_]+" required>
                        <div class="form-text">Solo lettere minuscole, numeri e underscore</div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Lingua</label>
                        <select id="tpl-language" class="form-select">
                            <option value="it" selected>Italiano</option>
                            <option value="en">English</option>
                            <option value="en_US">English (US)</option>
                            <option value="es">Espa&ntilde;ol</option>
                            <option value="fr">Fran&ccedil;ais</option>
                            <option value="de">Deutsch</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label fw-bold">Categoria</label>
                        <select id="tpl-category" class="form-select">
                            <option value="MARKETING">Marketing</option>
                            <option value="UTILITY">Utility</option>
                        </select>
                    </div>
                </div>
                <hr>
                <div class="mb-3">
                    <label class="form-label fw-bold">Header <span class="text-muted fw-normal">(opzionale)</span></label>
                    <input type="text" id="tpl-header" class="form-control" placeholder="es. Ciao da Syrus!" maxlength="60">
                </div>
                <div class="mb-3">
                    <label class="form-label fw-bold">Body <span class="text-danger">*</span></label>
                    <textarea id="tpl-body" class="form-control" rows="5" required placeholder="Scrivi il testo del messaggio. Usa {{1}}, {{2}} ecc. per le variabili."></textarea>
                    <div class="form-text">Max 1024 caratteri. Variabili: <code>{{1}}</code>, <code>{{2}}</code>, ecc.</div>
                </div>
                <div class="mb-3" id="tpl-examples-wrap" style="display:none">
                    <label class="form-label fw-bold">Valori esempio per le variabili <span class="text-danger">*</span></label>
                    <div id="tpl-examples-fields"></div>
                    <div class="form-text">Meta richiede valori di esempio per approvare il template</div>
                </div>
                <div class="mb-3">
                    <label class="form-label fw-bold">Footer <span class="text-muted fw-normal">(opzionale)</span></label>
                    <input type="text" id="tpl-footer" class="form-control" placeholder="es. Syrus Digital Agency" maxlength="60">
                </div>
                <hr>
                <div class="mb-3">
                    <label class="form-label fw-bold">Pulsanti <span class="text-muted fw-normal">(opzionale, max 3)</span></label>
                    <div id="tpl-buttons-list"></div>
                    <button type="button" class="btn btn-outline-secondary btn-sm mt-2" onclick="SyrusApp._addTemplateButton()">
                        <i class="fa-solid fa-plus me-1"></i>Aggiungi pulsante
                    </button>
                </div>
                <hr>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="text-muted small"><i class="fa-solid fa-info-circle me-1"></i>Salva come bozza, poi rivedi e invia a Meta</div>
                    <button type="submit" class="btn btn-primary" id="tpl-submit-btn">
                        <i class="fa-solid fa-floppy-disk me-1"></i>Salva Bozza
                    </button>
                </div>
            </form>
        `, 'modal-lg');

        // Listen for variable changes in body
        const bodyEl = document.getElementById('tpl-body');
        bodyEl.addEventListener('input', () => this._updateTemplateExamples());

        // Form submit
        document.getElementById('create-tpl-form').addEventListener('submit', (e) => {
            e.preventDefault();
            this._submitCreateTemplate();
        });
    },

    _updateTemplateExamples() {
        const body = document.getElementById('tpl-body')?.value || '';
        const vars = [...body.matchAll(/\{\{(\d+)\}\}/g)].map(m => m[1]);
        const uniqueVars = [...new Set(vars)].sort((a, b) => a - b);
        const wrap = document.getElementById('tpl-examples-wrap');
        const fields = document.getElementById('tpl-examples-fields');
        if (!wrap || !fields) return;

        if (uniqueVars.length === 0) {
            wrap.style.display = 'none';
            fields.innerHTML = '';
            return;
        }
        wrap.style.display = 'block';
        fields.innerHTML = uniqueVars.map(v =>
            `<div class="input-group input-group-sm mb-1">
                <span class="input-group-text">{{${v}}}</span>
                <input type="text" class="form-control tpl-example-input" data-var="${v}" placeholder="Valore esempio per {{${v}}}" required>
            </div>`
        ).join('');
    },

    _addTemplateButton() {
        const list = document.getElementById('tpl-buttons-list');
        if (!list) return;
        if (list.children.length >= 3) { this.toast('Massimo 3 pulsanti', 'warning'); return; }
        const idx = list.children.length;
        const row = document.createElement('div');
        row.className = 'card card-body py-2 px-3 mb-2';
        row.innerHTML = `
            <div class="d-flex gap-2 align-items-center">
                <select class="form-select form-select-sm tpl-btn-type" style="width:140px" onchange="SyrusApp._onBtnTypeChange(this)">
                    <option value="QUICK_REPLY">Risposta rapida</option>
                    <option value="URL">Link URL</option>
                    <option value="PHONE_NUMBER">Numero telefono</option>
                </select>
                <input type="text" class="form-control form-control-sm tpl-btn-text" placeholder="Testo pulsante" required maxlength="25">
                <input type="text" class="form-control form-control-sm tpl-btn-value d-none" placeholder="URL o numero">
                <button type="button" class="btn btn-outline-danger btn-sm" onclick="this.closest('.card').remove()">
                    <i class="fa-solid fa-trash"></i>
                </button>
            </div>`;
        list.appendChild(row);
    },

    _onBtnTypeChange(sel) {
        const valueInput = sel.closest('.d-flex').querySelector('.tpl-btn-value');
        if (sel.value === 'QUICK_REPLY') {
            valueInput.classList.add('d-none');
            valueInput.required = false;
        } else {
            valueInput.classList.remove('d-none');
            valueInput.required = true;
            valueInput.placeholder = sel.value === 'URL' ? 'https://...' : '+39...';
        }
    },

    async _submitCreateTemplate() {
        const wabaId = document.getElementById('tpl-waba-id')?.value;
        const name = document.getElementById('tpl-name')?.value?.trim();
        const bodyText = document.getElementById('tpl-body')?.value?.trim();

        if (!name || !bodyText) { this.toast('Nome e body sono obbligatori', 'warning'); return; }
        if (!/^[a-z0-9_]+$/.test(name)) { this.toast('Il nome può contenere solo lettere minuscole, numeri e underscore', 'warning'); return; }

        // Collect example values
        const exampleInputs = document.querySelectorAll('.tpl-example-input');
        const bodyExamples = [];
        for (const inp of exampleInputs) {
            if (!inp.value.trim()) { this.toast(`Inserisci il valore esempio per {{${inp.dataset.var}}}`, 'warning'); return; }
            bodyExamples.push(inp.value.trim());
        }

        // Collect buttons
        const buttons = [];
        document.querySelectorAll('#tpl-buttons-list .card').forEach(card => {
            const type = card.querySelector('.tpl-btn-type')?.value;
            const text = card.querySelector('.tpl-btn-text')?.value?.trim();
            const value = card.querySelector('.tpl-btn-value')?.value?.trim();
            if (!text) return;
            const btn = { type, text };
            if (type === 'URL') btn.url = value;
            else if (type === 'PHONE_NUMBER') btn.phone_number = value;
            buttons.push(btn);
        });

        const data = {
            name,
            language: document.getElementById('tpl-language')?.value || 'it',
            category: document.getElementById('tpl-category')?.value || 'MARKETING',
            header_text: document.getElementById('tpl-header')?.value?.trim() || '',
            body_text: bodyText,
            body_examples: bodyExamples.length ? bodyExamples : null,
            footer_text: document.getElementById('tpl-footer')?.value?.trim() || '',
            buttons: buttons.length ? buttons : null,
        };

        const btn = document.getElementById('tpl-submit-btn');
        btn.disabled = true;
        btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>Salvataggio...';

        try {
            const result = await this.api(`/whatsapp/api/templates/draft/${wabaId}`, {
                method: 'POST',
                body: JSON.stringify(data),
            });
            this.toast(`Bozza "${name}" salvata!`, 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._loadWaTemplatesList(wabaId);
        } catch (e) {
            this.toast(e.message, 'danger');
            btn.disabled = false;
            btn.innerHTML = '<i class="fa-solid fa-floppy-disk me-1"></i>Salva Bozza';
        }
    },

    async _previewDraftTemplate(templateId) {
        try {
            const t = await this.api(`/whatsapp/api/templates/draft/${templateId}`);
            const components = typeof t.components === 'string' ? JSON.parse(t.components || '[]') : (t.components || []);
            const header = components.find(c => c.type === 'HEADER');
            const body = components.find(c => c.type === 'BODY');
            const footer = components.find(c => c.type === 'FOOTER');
            const buttonsComp = components.find(c => c.type === 'BUTTONS');
            const examples = body?.example?.body_text?.[0] || [];

            // Build the WhatsApp preview bubble
            let waPreview = '<div style="max-width:360px;margin:0 auto 16px">';
            waPreview += '<div style="background:#E5DDD5;border-radius:12px;padding:16px">';
            waPreview += '<div style="background:#DCF8C6;border-radius:8px;padding:10px 12px;box-shadow:0 1px 1px rgba(0,0,0,.1)">';
            if (header) waPreview += `<div class="fw-bold mb-1">${this._escapeHtml(header.text)}</div>`;
            if (body) waPreview += `<div style="white-space:pre-wrap">${this._escapeHtml(body.text)}</div>`;
            if (footer) waPreview += `<div class="text-muted small mt-2">${this._escapeHtml(footer.text)}</div>`;
            waPreview += '</div>';
            if (buttonsComp?.buttons?.length) {
                buttonsComp.buttons.forEach(b => {
                    waPreview += `<div style="background:#fff;border-radius:8px;padding:8px;margin-top:4px;text-align:center;color:#0d6efd;font-weight:500;box-shadow:0 1px 1px rgba(0,0,0,.1)">${this._escapeHtml(b.text)}</div>`;
                });
            }
            waPreview += '</div></div>';

            // Build editable form pre-filled
            let buttonsHtml = '';
            if (buttonsComp?.buttons?.length) {
                buttonsHtml = buttonsComp.buttons.map(b => {
                    const showValue = b.type !== 'QUICK_REPLY';
                    return `<div class="card card-body py-2 px-3 mb-2">
                        <div class="d-flex gap-2 align-items-center">
                            <select class="form-select form-select-sm tpl-btn-type" style="width:140px" onchange="SyrusApp._onBtnTypeChange(this)">
                                <option value="QUICK_REPLY" ${b.type==='QUICK_REPLY'?'selected':''}>Risposta rapida</option>
                                <option value="URL" ${b.type==='URL'?'selected':''}>Link URL</option>
                                <option value="PHONE_NUMBER" ${b.type==='PHONE_NUMBER'?'selected':''}>Numero telefono</option>
                            </select>
                            <input type="text" class="form-control form-control-sm tpl-btn-text" value="${this._escapeAttr(b.text)}" maxlength="25">
                            <input type="text" class="form-control form-control-sm tpl-btn-value ${showValue?'':'d-none'}" value="${this._escapeAttr(b.url||b.phone_number||'')}" placeholder="${b.type==='URL'?'https://...':'+39...'}">
                            <button type="button" class="btn btn-outline-danger btn-sm" onclick="this.closest('.card').remove()"><i class="fa-solid fa-trash"></i></button>
                        </div>
                    </div>`;
                }).join('');
            }

            this._showModal('<i class="fa-brands fa-whatsapp me-2"></i>Modifica Bozza Template', `
                ${waPreview}
                <form id="edit-tpl-form">
                    <input type="hidden" id="tpl-draft-id" value="${templateId}">
                    <input type="hidden" id="tpl-waba-id" value="${t.waba_id || document.getElementById('wa-tpl-waba')?.value || ''}">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label fw-bold">Nome template</label>
                            <input type="text" id="tpl-name" class="form-control" value="${this._escapeAttr(t.name)}" pattern="[a-z0-9_]+" required>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-bold">Lingua</label>
                            <select id="tpl-language" class="form-select">
                                <option value="it" ${t.language==='it'?'selected':''}>Italiano</option>
                                <option value="en" ${t.language==='en'?'selected':''}>English</option>
                                <option value="en_US" ${t.language==='en_US'?'selected':''}>English (US)</option>
                                <option value="es" ${t.language==='es'?'selected':''}>Espa&ntilde;ol</option>
                                <option value="fr" ${t.language==='fr'?'selected':''}>Fran&ccedil;ais</option>
                                <option value="de" ${t.language==='de'?'selected':''}>Deutsch</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label fw-bold">Categoria</label>
                            <select id="tpl-category" class="form-select">
                                <option value="MARKETING" ${t.category==='MARKETING'?'selected':''}>Marketing</option>
                                <option value="UTILITY" ${t.category==='UTILITY'?'selected':''}>Utility</option>
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Header <span class="text-muted fw-normal">(opzionale)</span></label>
                        <input type="text" id="tpl-header" class="form-control" value="${this._escapeAttr(header?.text || '')}" maxlength="60">
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Body <span class="text-danger">*</span></label>
                        <textarea id="tpl-body" class="form-control" rows="5" required>${this._escapeHtml(body?.text || '')}</textarea>
                        <div class="form-text">Max 1024 caratteri. Variabili: <code>{{1}}</code>, <code>{{2}}</code>, ecc.</div>
                    </div>
                    <div class="mb-3" id="tpl-examples-wrap" style="${examples.length ? '' : 'display:none'}">
                        <label class="form-label fw-bold">Valori esempio per le variabili <span class="text-danger">*</span></label>
                        <div id="tpl-examples-fields">
                            ${examples.map((ex, i) => `<div class="input-group input-group-sm mb-1">
                                <span class="input-group-text">{{${i+1}}}</span>
                                <input type="text" class="form-control tpl-example-input" data-var="${i+1}" value="${this._escapeAttr(ex)}" required>
                            </div>`).join('')}
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Footer <span class="text-muted fw-normal">(opzionale)</span></label>
                        <input type="text" id="tpl-footer" class="form-control" value="${this._escapeAttr(footer?.text || '')}" maxlength="60">
                    </div>
                    <hr>
                    <div class="mb-3">
                        <label class="form-label fw-bold">Pulsanti <span class="text-muted fw-normal">(opzionale, max 3)</span></label>
                        <div id="tpl-buttons-list">${buttonsHtml}</div>
                        <button type="button" class="btn btn-outline-secondary btn-sm mt-2" onclick="SyrusApp._addTemplateButton()">
                            <i class="fa-solid fa-plus me-1"></i>Aggiungi pulsante
                        </button>
                    </div>
                    <hr>
                    <div class="d-flex justify-content-between align-items-center">
                        <button type="button" class="btn btn-outline-danger" onclick="SyrusApp._deleteDraftTemplate('${templateId}')">
                            <i class="fa-solid fa-trash me-1"></i>Elimina bozza
                        </button>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-secondary" id="tpl-save-btn">
                                <i class="fa-solid fa-floppy-disk me-1"></i>Salva modifiche
                            </button>
                            <button type="button" class="btn btn-primary" onclick="SyrusApp._submitDraftToMeta('${templateId}')">
                                <i class="fa-brands fa-meta me-1"></i>Invia a Meta
                            </button>
                        </div>
                    </div>
                </form>
            `, 'modal-lg');

            // Bind body input for variable detection
            document.getElementById('tpl-body')?.addEventListener('input', () => this._updateTemplateExamples());

            // Form submit = save draft update
            document.getElementById('edit-tpl-form')?.addEventListener('submit', (e) => {
                e.preventDefault();
                this._updateDraftTemplate(templateId);
            });
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _updateDraftTemplate(templateId) {
        const name = document.getElementById('tpl-name')?.value?.trim();
        const bodyText = document.getElementById('tpl-body')?.value?.trim();
        if (!name || !bodyText) { this.toast('Nome e body sono obbligatori', 'warning'); return; }

        const exampleInputs = document.querySelectorAll('.tpl-example-input');
        const bodyExamples = [];
        for (const inp of exampleInputs) {
            if (!inp.value.trim()) { this.toast(`Inserisci il valore esempio per {{${inp.dataset.var}}}`, 'warning'); return; }
            bodyExamples.push(inp.value.trim());
        }

        const buttons = [];
        document.querySelectorAll('#tpl-buttons-list .card').forEach(card => {
            const type = card.querySelector('.tpl-btn-type')?.value;
            const text = card.querySelector('.tpl-btn-text')?.value?.trim();
            const value = card.querySelector('.tpl-btn-value')?.value?.trim();
            if (!text) return;
            const btn = { type, text };
            if (type === 'URL') btn.url = value;
            else if (type === 'PHONE_NUMBER') btn.phone_number = value;
            buttons.push(btn);
        });

        const data = {
            name,
            language: document.getElementById('tpl-language')?.value || 'it',
            category: document.getElementById('tpl-category')?.value || 'MARKETING',
            header_text: document.getElementById('tpl-header')?.value?.trim() || '',
            body_text: bodyText,
            body_examples: bodyExamples.length ? bodyExamples : null,
            footer_text: document.getElementById('tpl-footer')?.value?.trim() || '',
            buttons: buttons.length ? buttons : null,
        };

        try {
            await this.api(`/whatsapp/api/templates/draft/${templateId}`, {
                method: 'PUT',
                body: JSON.stringify(data),
            });
            this.toast('Bozza aggiornata!', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            const wabaId = document.getElementById('wa-tpl-waba')?.value;
            if (wabaId) this._loadWaTemplatesList(wabaId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _submitDraftToMeta(templateId) {
        if (!confirm('Inviare questo template a Meta per approvazione?')) return;
        try {
            const result = await this.api(`/whatsapp/api/templates/draft/${templateId}/submit`, { method: 'POST' });
            this.toast(`Template inviato a Meta! Status: ${result.status}`, 'success');
            const wabaId = document.getElementById('wa-tpl-waba')?.value;
            if (wabaId) this._loadWaTemplatesList(wabaId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _deleteDraftTemplate(templateId) {
        if (!confirm('Eliminare questa bozza?')) return;
        try {
            await this.api(`/whatsapp/api/templates/draft/${templateId}`, { method: 'DELETE' });
            this.toast('Bozza eliminata', 'success');
            const wabaId = document.getElementById('wa-tpl-waba')?.value;
            if (wabaId) this._loadWaTemplatesList(wabaId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Broadcast Page ──────────────────────────────────────────────────────
    async loadBroadcastPage() {
        try {
            const nums = await this.api('/whatsapp/api/numbers');
            const pnidSel = document.getElementById('bc-pnid');
            if (pnidSel) {
                pnidSel.innerHTML = '<option value="">Seleziona numero...</option>';
                nums.forEach(n => { pnidSel.innerHTML += `<option value="${n.phone_number_id}" data-waba="${n.waba_id}">${n.label || n.phone_number_id}</option>`; });
                pnidSel.addEventListener('change', async () => {
                    const wabaId = pnidSel.options[pnidSel.selectedIndex]?.dataset?.waba;
                    const tplSel = document.getElementById('bc-template');
                    if (!wabaId || !tplSel) return;
                    const tpls = await this.api(`/whatsapp/api/templates/${wabaId}`);
                    const approved = tpls.filter(t => t.status === 'APPROVED');
                    tplSel.innerHTML = approved.map(t => `<option value="${this._escapeAttr(t.name)}">${this._escapeHtml(t.name)} (${this._escapeHtml(t.language)})</option>`).join('') || '<option value="">Nessun template approvato</option>';
                });
            }
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async startBroadcast(event) {
        event.preventDefault();
        const pnid = document.getElementById('bc-pnid').value;
        const template = document.getElementById('bc-template').value;
        const recipientsText = document.getElementById('bc-recipients').value.trim();
        if (!pnid || !template || !recipientsText) {
            this.toast('Compila tutti i campi', 'warning');
            return;
        }
        const recipients = recipientsText.split('\n').map(r => r.trim()).filter(r => r);
        if (recipients.length === 0) { this.toast('Inserisci almeno un destinatario', 'warning'); return; }
        if (!confirm(`Inviare il template "${template}" a ${recipients.length} destinatari?`)) return;

        try {
            const r = await this.api('/whatsapp/api/broadcast/send', {
                method: 'POST',
                body: JSON.stringify({ phone_number_id: pnid, template_name: template, recipients })
            });
            this.toast('Broadcast avviato!', 'success');
            this._pollBroadcast(r.broadcast_id);
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    _pollBroadcast(broadcastId) {
        const statusEl = document.getElementById('bc-status');
        const poll = async () => {
            try {
                const s = await this.api(`/whatsapp/api/broadcast/status/${broadcastId}`);
                statusEl.innerHTML = `
                    <div class="mb-2"><strong>Stato:</strong> <span class="badge ${s.status === 'completed' ? 'bg-success' : 'bg-warning'}">${s.status}</span></div>
                    <div class="mb-1">Inviati: <strong>${s.sent || 0}</strong> / ${s.total || 0}</div>
                    <div>Errori: <strong class="text-danger">${s.failed || 0}</strong></div>`;
                if (s.status !== 'completed') setTimeout(poll, 2000);
            } catch(e) { statusEl.innerHTML = '<p class="text-danger">Errore polling status</p>'; }
        };
        poll();
    },

    // ── Chat App (UI stile WhatsApp Web) ─────────────────────────────────────
    _chatAppFilter: 'all',
    _chatAppSelectedWaId: null,
    _chatAppPnid: null,
    _goToWaChat(pnid, waId) {
        sessionStorage.setItem('wa_deep_link', JSON.stringify({ pnid: pnid, waId: waId }));
        window.location.href = '/whatsapp/';
    },

    _chatAppSearch: '',
    _chatAppListPollTimer: null,
    _chatAppMsgPollTimer: null,
    _chatAppLastMsgTs: null,

    initChatApp() {
        document.body.classList.add('wa-app-page');
        const sel = document.getElementById('wa-app-pnid-select');
        if (!sel) return;
        this._chatAppPnid = (sel.value) || (sel.options && sel.options[0] && sel.options[0].value) || null;
        if (sel.tagName === 'SELECT') {
            sel.addEventListener('change', () => {
                this._chatAppPnid = sel.value;
                this._chatAppSelectedWaId = null;
                this._renderChatAppEmpty();
                this.loadChatApp();
            });
        }
        // Filter buttons
        document.querySelectorAll('.wa-app-filters .nav-link').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                document.querySelectorAll('.wa-app-filters .nav-link').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this._chatAppFilter = btn.dataset.filter;
                this.loadChatApp();
            });
        });
        // Search box
        const search = document.getElementById('wa-app-search');
        if (search) {
            search.addEventListener('input', this.debounce(() => {
                this._chatAppSearch = search.value.trim().toLowerCase();
                this._renderChatAppList(this._chatAppConvs || []);
            }, 200));
        }
        this.loadChatApp();
        // Poll lista ogni 5 secondi
        if (this._chatAppListPollTimer) clearInterval(this._chatAppListPollTimer);
        this._chatAppListPollTimer = setInterval(() => this.loadChatApp(true), 5000);
    },

    async loadChatApp(silent = false) {
        const list = document.getElementById('wa-app-conv-list');
        if (!list) {
            // Niente lista = non siamo sull'inbox (es. chat embedded nel dettaglio
            // lead): NON toccare il poll messaggi, si auto-spegne da solo quando
            // il contenitore chat sparisce dal DOM (vedi _loadChatAppMessages).
            if (this._chatAppListPollTimer) { clearInterval(this._chatAppListPollTimer); this._chatAppListPollTimer = null; }
            return;
        }
        try {
            const params = new URLSearchParams();
            if (this._chatAppPnid) params.set('pnid', this._chatAppPnid);
            params.set('mode', this._chatAppFilter || 'all');
            const convs = await this.api(`/whatsapp/api/conversations-rich?${params}`);
            this._chatAppConvs = convs;
            this._renderChatAppList(convs);
            // Deep link from sessionStorage (set by Communications, notifications, etc.)
            const dlRaw = sessionStorage.getItem('wa_deep_link');
            if (dlRaw && convs && convs.length > 0) {
                try {
                    const dl = JSON.parse(dlRaw);
                    if (dl.pnid && dl.waId) {
                        sessionStorage.removeItem('wa_deep_link');
                        this.selectChatAppConversation(dl.pnid, dl.waId);
                    }
                } catch (_) { sessionStorage.removeItem('wa_deep_link'); }
            }
        } catch (e) {
            if (!silent) list.innerHTML = `<div class="text-center py-4 text-danger small">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    _renderChatAppList(convs) {
        const list = document.getElementById('wa-app-conv-list');
        if (!list) return;
        let filtered = convs || [];
        if (this._chatAppSearch) {
            const q = this._chatAppSearch;
            filtered = filtered.filter(c =>
                (c.contact_name || '').toLowerCase().includes(q) ||
                (c.wa_id || '').toLowerCase().includes(q) ||
                (c.preview || '').toLowerCase().includes(q) ||
                (c.lead_company || '').toLowerCase().includes(q)
            );
        }
        if (filtered.length === 0) {
            list.innerHTML = '<div class="text-center py-5 text-muted small"><i class="fa-solid fa-comments fa-2x mb-2 d-block"></i>Nessuna conversazione</div>';
            return;
        }
        const initialOf = (name) => (name || '?').trim().charAt(0).toUpperCase();
        list.innerHTML = filtered.map(c => {
            const isActive = c.wa_id === this._chatAppSelectedWaId;
            const ts = c.last_message_at ? this._formatChatAppTime(c.last_message_at) : '';
            const unread = c.unread_count > 0
                ? `<div class="wa-conv-unread">${c.unread_count}</div>` : '';
            const leadTag = c.lead_company && c.lead_id
                ? `<div class="wa-conv-lead-tag"><a href="/leads/${this._escapeAttr(c.lead_id)}" onclick="event.stopPropagation()" class="text-decoration-none" style="color:inherit"><i class="fa-solid fa-user-tag me-1"></i>${this._escapeHtml(c.lead_company)}</a></div>` : '';
            return `<div class="wa-conv-item ${isActive ? 'active' : ''}" data-waid="${this._escapeAttr(c.wa_id)}" data-pnid="${this._escapeAttr(c.phone_number_id)}">
                <div class="wa-conv-avatar">${initialOf(c.contact_name)}</div>
                <div class="wa-conv-body">
                    <div class="wa-conv-name">${this._escapeHtml(c.contact_name || c.wa_id)}</div>
                    <div class="wa-conv-preview">${this._escapeHtml(c.preview || '')}</div>
                    ${leadTag}
                </div>
                <div class="wa-conv-meta">
                    <div class="wa-conv-time">${ts}</div>
                    ${unread}
                </div>
            </div>`;
        }).join('');
        list.querySelectorAll('.wa-conv-item').forEach(el => {
            el.addEventListener('click', () => {
                this.selectChatAppConversation(el.dataset.pnid, el.dataset.waid);
            });
        });
    },

    _chatAppLastDayKey: null,
    _chatAppDayLabel(d) {
        const now = new Date();
        if (d.toDateString() === now.toDateString()) return 'Oggi';
        const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
        if (d.toDateString() === yesterday.toDateString()) return 'Ieri';
        return d.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
    },

    _formatChatAppTime(iso) {
        try {
            const d = this.parseDate(iso);
            const now = new Date();
            const sameDay = d.toDateString() === now.toDateString();
            if (sameDay) return d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
            const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
            if (d.toDateString() === yesterday.toDateString()) return 'Ieri';
            const diffDays = Math.floor((now - d) / 86400000);
            if (diffDays < 7) return d.toLocaleDateString('it-IT', { weekday: 'short' });
            return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' });
        } catch (e) { return ''; }
    },

    _renderChatAppEmpty() {
        const main = document.getElementById('wa-app-main');
        if (!main) return;
        main.innerHTML = `<div class="wa-app-main-empty">
            <i class="fa-brands fa-whatsapp"></i>
            <h5>Seleziona una conversazione</h5>
            <p class="text-muted small">Scegli una chat dalla lista per iniziare a messaggiare</p>
        </div>`;
    },

    // Buffer di sicurezza: la finestra Meta è 24h, ma blocchiamo l'input
    // 1h prima per non rischiare il rifiuto da parte di Meta vicino alla scadenza
    _CHAT_WINDOW_BUFFER_MIN: 60,

    async selectChatAppConversation(pnid, waId) {
        this._discardChatAppVoicePreview(false);  // il cambio chat azzera un eventuale vocale in attesa
        if (this._chatAppMsgPollTimer) { clearInterval(this._chatAppMsgPollTimer); this._chatAppMsgPollTimer = null; }
        if (this._chatAppWindowTimer) { clearInterval(this._chatAppWindowTimer); this._chatAppWindowTimer = null; }
        this._chatAppSelectedWaId = waId;
        this._chatAppLastMsgTs = null;

        // Highlight active item
        document.querySelectorAll('.wa-conv-item').forEach(el => {
            el.classList.toggle('active', el.dataset.waid === waId);
        });

        const main = document.getElementById('wa-app-main');
        if (!main) return;

        // Recupera info conversazione dalla cache
        const conv = (this._chatAppConvs || []).find(c => c.wa_id === waId) || {};
        this._chatAppCurrentConv = conv;
        const initial = (conv.contact_name || waId).trim().charAt(0).toUpperCase();
        const leadInfo = conv.lead_id
            ? `<small class="text-muted ms-2">· <a href="/leads/${this._escapeAttr(conv.lead_id || '')}" class="text-decoration-none text-muted">${this._escapeHtml(conv.lead_company || 'Apri lead')}</a>${conv.assigned_name ? ' · assegnata a ' + this._escapeHtml(conv.assigned_name) : ''}</small>`
            : '';
        const createLeadBtn = conv.lead_id ? '' : `
                <button class="btn btn-sm btn-outline-primary me-1" onclick="SyrusApp.waShowCreateLeadModal()" title="Crea una lead da questo numero (o collega quella esistente)">
                    <i class="fa-solid fa-user-plus me-1"></i>Crea lead
                </button>`;

        main.innerHTML = `
            <div class="wa-chat-header">
                <div class="wa-conv-avatar">${initial}</div>
                <div class="flex-grow-1">
                    <div class="fw-bold">${this._escapeHtml(conv.contact_name || waId)}</div>
                    <small class="text-muted">${this._escapeHtml(waId)}${leadInfo}</small>
                    <div id="wa-app-window-status" class="small mt-1"></div>
                </div>${createLeadBtn}
                <button class="btn btn-sm btn-outline-success" id="wa-app-tpl-btn" onclick="SyrusApp.openChatAppTemplateModal()" title="Invia un template approvato Meta">
                    <i class="fa-solid fa-file-invoice me-1"></i>Template
                </button>
            </div>
            <div class="wa-chat-messages" id="wa-app-messages">
                <div class="text-center text-muted small py-4">Caricamento messaggi...</div>
            </div>
            <form class="wa-chat-input-bar" id="wa-app-send-form">
                <input type="hidden" id="wa-app-pnid-current" value="${this._escapeAttr(pnid)}">
                <input type="hidden" id="wa-app-waid-current" value="${this._escapeAttr(waId)}">
                <button type="button" class="btn btn-link text-muted" id="wa-app-attach-btn" onclick="document.getElementById('wa-app-file-input').click()" title="Allega file">
                    <i class="fa-solid fa-paperclip fa-lg"></i>
                </button>
                <input type="file" id="wa-app-file-input" style="display:none">
                <button type="button" class="btn btn-link text-muted" id="wa-app-emoji-btn" title="Emoji">
                    <i class="fa-regular fa-face-smile fa-lg"></i>
                </button>
                <textarea id="wa-app-input" rows="1" placeholder="Scrivi un messaggio" autocomplete="off"></textarea>
                <button type="button" class="btn btn-link text-muted" id="wa-app-mic-btn" onclick="SyrusApp.toggleChatAppRecording()" title="Registra messaggio vocale">
                    <i class="fa-solid fa-microphone fa-lg"></i>
                </button>
                <button type="submit" class="btn-send" id="wa-app-send-btn" title="Invia"><i class="fa-solid fa-paper-plane"></i></button>
            </form>
            <div id="wa-app-locked-bar" class="wa-chat-locked-bar" style="display:none">
                <i class="fa-solid fa-lock me-2"></i>
                <span id="wa-app-locked-msg">Finestra chiusa — puoi solo inviare un template approvato</span>
                <button class="btn btn-sm btn-success ms-auto" onclick="SyrusApp.openChatAppTemplateModal()">
                    <i class="fa-solid fa-file-invoice me-1"></i>Invia template
                </button>
            </div>
        `;

        // Bind input form
        document.getElementById('wa-app-send-form').addEventListener('submit', (e) => this._sendChatAppMessage(e));
        document.getElementById('wa-app-file-input').addEventListener('change', (e) => this._sendChatAppFile(e.target));

        // Textarea: Invio = invia, Shift+Invio = a capo; auto-grow fino a max-height
        const inputEl = document.getElementById('wa-app-input');
        inputEl.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                document.getElementById('wa-app-send-form').requestSubmit();
            }
        });
        inputEl.addEventListener('input', () => {
            inputEl.style.height = 'auto';
            inputEl.style.height = Math.min(inputEl.scrollHeight, 140) + 'px';
        });

        // Emoji picker (portato da Connect): recenti in localStorage per utente
        const emojiBtn = document.getElementById('wa-app-emoji-btn');
        if (emojiBtn && window.SyrusEmojiPicker && window.EMOJI_DATA) {
            window.SyrusEmojiPicker.attach({
                button: emojiBtn,
                textarea: inputEl,
                container: document.getElementById('wa-app-send-form'),
                storageKey: 'syrus_emoji_recent:' + ((window.SYRUS && window.SYRUS.userName) || 'me'),
            });
        } else if (emojiBtn) {
            emojiBtn.style.display = 'none';
        }

        // Drag & drop sull'intero pannello chat
        this._setupChatAppDragDrop(pnid, waId);

        // Aggiorna stato finestra ora + ogni 30 secondi
        this._updateChatAppWindowState();
        this._chatAppWindowTimer = setInterval(() => this._updateChatAppWindowState(), 30000);

        // Carica messaggi
        await this._loadChatAppMessages(pnid, waId, false);
        // Mark as read
        this.api('/whatsapp/api/messages/mark-read', { method: 'POST', body: JSON.stringify({ pnid, wa_id: waId }) }).catch(() => {});
        // Refresh la lista (per togliere il badge unread)
        setTimeout(() => this.loadChatApp(true), 500);
        // Poll messaggi ogni 3s
        this._chatAppMsgPollTimer = setInterval(() => this._loadChatAppMessages(pnid, waId, true), 3000);
    },

    _updateChatAppWindowState() {
        const conv = this._chatAppCurrentConv;
        if (!conv) return;
        const statusEl = document.getElementById('wa-app-window-status');
        const inputEl = document.getElementById('wa-app-input');
        const sendBtn = document.getElementById('wa-app-send-btn');
        const attachBtn = document.getElementById('wa-app-attach-btn');
        const formEl = document.getElementById('wa-app-send-form');
        const lockedBar = document.getElementById('wa-app-locked-bar');
        const tplBtn = document.getElementById('wa-app-tpl-btn');
        if (!statusEl || !inputEl) return;

        const now = new Date();
        const expiresAt = conv.window_expires_at ? this.parseDate(conv.window_expires_at) : null;
        // Buffer di sicurezza: scadenza effettiva = scadenza Meta - 60 minuti
        const effectiveExpiry = expiresAt ? new Date(expiresAt.getTime() - this._CHAT_WINDOW_BUFFER_MIN * 60 * 1000) : null;

        let state, msUntilExpiry;
        if (!expiresAt) {
            state = 'never';
        } else {
            msUntilExpiry = effectiveExpiry - now;
            if (msUntilExpiry <= 0) state = 'closed';
            else if (msUntilExpiry < 60 * 60 * 1000) state = 'warning';  // < 1h al buffer
            else state = 'open';
        }

        const fmtRemaining = (ms) => {
            const totalMin = Math.max(0, Math.floor(ms / 60000));
            const h = Math.floor(totalMin / 60);
            const m = totalMin % 60;
            return h > 0 ? `${h}h ${m}m` : `${m}m`;
        };

        // Stato visuale dell'header + lock dell'input
        if (state === 'open') {
            statusEl.innerHTML = `<span class="text-success"><i class="fa-solid fa-circle-check me-1"></i>Finestra attiva — scade tra ${fmtRemaining(msUntilExpiry)}</span>`;
            formEl.style.display = '';
            lockedBar.style.display = 'none';
            inputEl.disabled = false;
            sendBtn.disabled = false;
            if (attachBtn) attachBtn.disabled = false;
            if (tplBtn) tplBtn.style.display = '';
        } else if (state === 'warning') {
            statusEl.innerHTML = `<span class="text-warning"><i class="fa-solid fa-triangle-exclamation me-1"></i>Finestra in scadenza tra ${fmtRemaining(msUntilExpiry)}</span>`;
            formEl.style.display = '';
            lockedBar.style.display = 'none';
            inputEl.disabled = false;
            sendBtn.disabled = false;
            if (attachBtn) attachBtn.disabled = false;
            if (tplBtn) tplBtn.style.display = '';
        } else if (state === 'closed') {
            statusEl.innerHTML = `<span class="text-danger"><i class="fa-solid fa-lock me-1"></i>Finestra chiusa — solo template</span>`;
            formEl.style.display = 'none';
            lockedBar.style.display = 'flex';
            // La locked-bar ha già il suo bottone template: evita il doppione in header
            if (tplBtn) tplBtn.style.display = 'none';
            document.getElementById('wa-app-locked-msg').textContent = 'Finestra di servizio scaduta — puoi solo inviare un template approvato Meta';
        } else {
            // never opened
            statusEl.innerHTML = `<span class="text-danger"><i class="fa-solid fa-lock me-1"></i>Mai contattato — primo contatto via template</span>`;
            formEl.style.display = 'none';
            lockedBar.style.display = 'flex';
            if (tplBtn) tplBtn.style.display = 'none';
            document.getElementById('wa-app-locked-msg').textContent = 'Il cliente non ha mai scritto — il primo contatto deve essere un template approvato Meta';
        }
    },

    // ── Crea lead dalla chat (numero sconosciuto) ───────────────────────────
    waShowCreateLeadModal() {
        const conv = this._chatAppCurrentConv || {};
        const waId = this._chatAppSelectedWaId || conv.wa_id || '';
        this._showModal('Crea lead da WhatsApp', `
            <form onsubmit="SyrusApp.waCreateLeadFromChat(event)">
                <p class="text-muted small mb-3">Se esiste già una lead con questo numero, la conversazione viene collegata a quella (senza crearne una nuova).</p>
                <div class="mb-2"><label class="form-label">Nome contatto</label>
                    <input name="contact_name" class="form-control" required value="${this._escapeAttr(conv.contact_name || '')}" placeholder="Nome e cognome"></div>
                <div class="mb-2"><label class="form-label">Azienda <small class="text-muted">(opzionale)</small></label>
                    <input name="company_name" class="form-control"></div>
                <div class="mb-3"><label class="form-label">Telefono</label>
                    <input class="form-control" value="+${this._escapeAttr(waId)}" disabled></div>
                <button type="submit" class="btn btn-primary"><i class="fa-solid fa-user-plus me-1"></i>Crea lead</button>
            </form>`);
    },

    async waCreateLeadFromChat(event) {
        event.preventDefault();
        const conv = this._chatAppCurrentConv || {};
        const pnid = document.getElementById('wa-app-pnid-current')?.value || conv.phone_number_id;
        const waId = document.getElementById('wa-app-waid-current')?.value || conv.wa_id;
        const data = Object.fromEntries(new FormData(event.target).entries());
        data.phone_number_id = pnid;
        data.wa_id = waId;
        try {
            const r = await this.api('/whatsapp/api/conversations/create-lead', {
                method: 'POST', body: JSON.stringify(data) });
            if (r.error) { this.toast(r.error, 'danger'); return; }
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.toast(r.linked_existing
                ? 'Conversazione collegata alla lead esistente'
                : `Lead ${r.crm_id || ''} creata e collegata`, 'success');
            // Aggiorna cache e testata chat senza ricaricare
            conv.lead_id = r.lead_id;
            conv.lead_company = r.lead_company || data.contact_name;
            this.selectChatAppConversation(pnid, waId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async openChatAppTemplateModal() {
        const conv = this._chatAppCurrentConv;
        if (!conv) return;
        const pnid = conv.phone_number_id;

        // Trova il WABA ID del numero corrente
        let wabaId = null;
        try {
            const numbers = await this.api('/whatsapp/api/numbers');
            const current = numbers.find(n => n.phone_number_id === pnid);
            wabaId = current ? current.waba_id : null;
        } catch (e) { /* ignore */ }
        if (!wabaId) {
            this.toast('WABA ID non trovato per questo numero', 'danger');
            return;
        }

        // Carica template
        let templates = [];
        try {
            templates = await this.api(`/whatsapp/api/templates/${wabaId}`);
        } catch (e) {
            this.toast('Errore caricamento template: ' + e.message, 'danger');
            return;
        }
        const approved = (templates || []).filter(t => (t.status || '').toUpperCase() === 'APPROVED');

        const escape = (s) => this._escapeHtml(s || '');
        let listHtml = '';
        if (approved.length === 0) {
            listHtml = `<div class="alert alert-warning small mb-0">
                Nessun template approvato disponibile. Vai in <a href="/settings/" class="alert-link">Impostazioni → WhatsApp Manager → Template</a> e sincronizza dal Meta Business Manager.
            </div>`;
        } else {
            listHtml = '<div class="list-group">' + approved.map(t => {
                // Estrae body preview dai components (senza parse di variabili)
                let bodyPreview = '';
                try {
                    const bodyComp = (t.components || []).find(c => (c.type || '').toUpperCase() === 'BODY');
                    bodyPreview = bodyComp && bodyComp.text ? bodyComp.text : '';
                } catch (e) { /* ignore */ }
                return `<button type="button" class="list-group-item list-group-item-action wa-tpl-pick"
                                data-name="${this._escapeAttr(t.name)}" data-lang="${this._escapeAttr(t.language)}">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold">${escape(t.name)}</div>
                            <small class="text-muted">${escape(t.language)} · ${escape(t.category || '-')}</small>
                            ${bodyPreview ? `<div class="small text-muted mt-1" style="white-space:pre-wrap">${escape(bodyPreview.slice(0, 200))}${bodyPreview.length > 200 ? '…' : ''}</div>` : ''}
                        </div>
                        <span class="badge bg-success">APPROVED</span>
                    </div>
                </button>`;
            }).join('') + '</div>';
        }

        const modalHtml = `<div class="modal fade" id="chatAppTplModal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-success bg-opacity-10">
                        <h5 class="modal-title"><i class="fa-solid fa-file-invoice me-2"></i>Invia template a ${escape(conv.contact_name || conv.wa_id)}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <p class="small text-muted">Solo i template approvati da Meta possono essere inviati. Selezionane uno per inviarlo immediatamente.</p>
                        ${listHtml}
                    </div>
                </div>
            </div>
        </div>`;
        const old = document.getElementById('chatAppTplModal');
        if (old) {
            const inst = bootstrap.Modal.getInstance(old);
            if (inst) inst.dispose();
            old.remove();
        }
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modalEl = document.getElementById('chatAppTplModal');
        const modal = new bootstrap.Modal(modalEl);
        modalEl.addEventListener('hidden.bs.modal', () => {
            modal.dispose();
            modalEl.remove();
            document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
        }, { once: true });
        this._chatAppTplCache = {};
        approved.forEach(t => { this._chatAppTplCache[t.name] = t; });
        modalEl.querySelectorAll('.wa-tpl-pick').forEach(btn => {
            btn.addEventListener('click', () => this._chatAppTemplatePick(btn.dataset.name, btn.dataset.lang, modalEl, modal));
        });
        modal.show();
    },

    // Corpo del template dai components cachati (per preview e conteggio variabili)
    _chatAppTplBody(name) {
        const t = (this._chatAppTplCache || {})[name];
        if (!t) return '';
        const bodyComp = (t.components || []).find(c => (c.type || '').toUpperCase() === 'BODY');
        return bodyComp && bodyComp.text ? bodyComp.text : '';
    },

    // Step di selezione: se il template ha variabili {{n}} chiede i valori,
    // altrimenti invia subito (comportamento precedente)
    _chatAppTemplatePick(name, lang, modalEl, modal, toOverride = null, pnidOverride = null) {
        const body = this._chatAppTplBody(name);
        const varNums = [...new Set([...body.matchAll(/\{\{(\d+)\}\}/g)].map(m => parseInt(m[1], 10)))].sort((a, b) => a - b);
        if (varNums.length === 0) {
            this._sendChatAppTemplate(name, lang, modal, [], toOverride, pnidOverride);
            return;
        }
        const escape = (s) => this._escapeHtml(s || '');
        const inputs = varNums.map(n => `
            <div class="mb-2">
                <label class="form-label small mb-1">Variabile {{${n}}}</label>
                <input type="text" class="form-control form-control-sm wa-tpl-var" data-var="${n}">
            </div>`).join('');
        modalEl.querySelector('.modal-body').innerHTML = `
            <div class="fw-bold mb-1">${escape(name)}</div>
            <div class="small text-muted mb-3 p-2 rounded" style="background:#efeae2;white-space:pre-wrap" id="wa-tpl-var-preview">${escape(body)}</div>
            ${inputs}
            <div class="d-flex gap-2 mt-3">
                <button type="button" class="btn btn-sm btn-outline-secondary" id="wa-tpl-var-back"><i class="fa-solid fa-arrow-left me-1"></i>Indietro</button>
                <button type="button" class="btn btn-sm btn-success ms-auto" id="wa-tpl-var-send"><i class="fa-solid fa-paper-plane me-1"></i>Invia</button>
            </div>`;
        // Preview live con le variabili sostituite
        const refreshPreview = () => {
            let text = body;
            modalEl.querySelectorAll('.wa-tpl-var').forEach(inp => {
                if (inp.value) text = text.replaceAll(`{{${inp.dataset.var}}}`, inp.value);
            });
            modalEl.querySelector('#wa-tpl-var-preview').textContent = text;
        };
        modalEl.querySelectorAll('.wa-tpl-var').forEach(inp => inp.addEventListener('input', refreshPreview));
        modalEl.querySelector('#wa-tpl-var-back').addEventListener('click', () => {
            modal.hide();
            if (toOverride) this.openChatAppNewChatModal(); else this.openChatAppTemplateModal();
        });
        modalEl.querySelector('#wa-tpl-var-send').addEventListener('click', () => {
            const params = varNums.map(n => modalEl.querySelector(`.wa-tpl-var[data-var="${n}"]`).value || '');
            this._sendChatAppTemplate(name, lang, modal, params, toOverride, pnidOverride);
        });
        const first = modalEl.querySelector('.wa-tpl-var');
        if (first) first.focus();
    },

    async _sendChatAppTemplate(name, lang, modal, params = [], toOverride = null, pnidOverride = null) {
        const conv = this._chatAppCurrentConv;
        const to = toOverride || (conv && conv.wa_id);
        const pnid = pnidOverride || (conv && conv.phone_number_id);
        if (!to || !pnid) return;
        const payload = {
            phone_number_id: pnid,
            to: to,
            template_name: name,
            language: lang,
        };
        if (params.length) {
            payload.components = [{ type: 'body', parameters: params.map(p => ({ type: 'text', text: p })) }];
        }
        try {
            const result = await this.api('/whatsapp/api/templates/send', {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            if (result.ok) {
                this.toast('Template inviato!', 'success');
                if (modal) modal.hide();
                if (toOverride) {
                    // Nuova chat: ricarica la lista e apri la conversazione appena creata
                    await this.loadChatApp(true);
                    this.selectChatAppConversation(pnid, to);
                } else {
                    this._loadChatAppMessages(pnid, to, false);
                    setTimeout(() => this.loadChatApp(true), 300);
                }
            } else {
                this.toast(result.error || result.reason || 'Errore invio template', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Nuova chat da template (portato da Connect) ──────────────────────────
    async openChatAppNewChatModal() {
        const sel = document.getElementById('wa-app-pnid-select');
        const pnid = this._chatAppPnid || (sel && sel.value);
        if (!pnid) { this.toast('Nessun numero WhatsApp configurato', 'danger'); return; }

        let wabaId = null;
        try {
            const numbers = await this.api('/whatsapp/api/numbers');
            const current = numbers.find(n => n.phone_number_id === pnid);
            wabaId = current ? current.waba_id : null;
        } catch (e) { /* ignore */ }
        if (!wabaId) { this.toast('WABA ID non trovato per questo numero', 'danger'); return; }

        let templates = [];
        try { templates = await this.api(`/whatsapp/api/templates/${wabaId}`); }
        catch (e) { this.toast('Errore caricamento template: ' + e.message, 'danger'); return; }
        const approved = (templates || []).filter(t => (t.status || '').toUpperCase() === 'APPROVED');
        this._chatAppTplCache = this._chatAppTplCache || {};
        approved.forEach(t => { this._chatAppTplCache[t.name] = t; });

        const escape = (s) => this._escapeHtml(s || '');
        const options = approved.map(t =>
            `<option value="${this._escapeAttr(t.name)}" data-lang="${this._escapeAttr(t.language)}">${escape(t.name)} (${escape(t.language)})</option>`
        ).join('');

        const modalHtml = `<div class="modal fade" id="chatAppNewChatModal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-success bg-opacity-10">
                        <h5 class="modal-title"><i class="fa-solid fa-pen-to-square me-2"></i>Nuova chat da template</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <p class="small text-muted">Fuori dalla finestra 24h il primo contatto deve essere un template approvato Meta. Il numero va in formato internazionale (es. 393331234567).</p>
                        <div class="mb-2">
                            <label class="form-label small mb-1">Numero destinatario</label>
                            <input type="tel" class="form-control" id="wa-newchat-phone" placeholder="39333...">
                        </div>
                        <div class="mb-2">
                            <label class="form-label small mb-1">Template</label>
                            <select class="form-select" id="wa-newchat-tpl">
                                ${options || '<option value="">Nessun template approvato</option>'}
                            </select>
                        </div>
                        <div class="small text-muted p-2 rounded" style="background:#efeae2;white-space:pre-wrap" id="wa-newchat-preview"></div>
                        <button type="button" class="btn btn-success w-100 mt-3" id="wa-newchat-next">
                            <i class="fa-solid fa-paper-plane me-1"></i>Continua
                        </button>
                    </div>
                </div>
            </div>
        </div>`;
        const old = document.getElementById('chatAppNewChatModal');
        if (old) {
            const inst = bootstrap.Modal.getInstance(old);
            if (inst) inst.dispose();
            old.remove();
        }
        document.body.insertAdjacentHTML('beforeend', modalHtml);
        const modalEl = document.getElementById('chatAppNewChatModal');
        const modal = new bootstrap.Modal(modalEl);
        modalEl.addEventListener('hidden.bs.modal', () => {
            modal.dispose();
            modalEl.remove();
            document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
        }, { once: true });

        const tplSel = modalEl.querySelector('#wa-newchat-tpl');
        const refreshPreview = () => {
            modalEl.querySelector('#wa-newchat-preview').textContent = this._chatAppTplBody(tplSel.value) || '';
        };
        tplSel.addEventListener('change', refreshPreview);
        refreshPreview();

        modalEl.querySelector('#wa-newchat-next').addEventListener('click', () => {
            const rawPhone = modalEl.querySelector('#wa-newchat-phone').value;
            const phone = this._chatAppNormalizePhone(rawPhone);
            if (!phone) { this.toast('Numero non valido', 'warning'); return; }
            const name = tplSel.value;
            if (!name) { this.toast('Seleziona un template', 'warning'); return; }
            const lang = tplSel.selectedOptions[0] ? tplSel.selectedOptions[0].dataset.lang : 'it';
            this._chatAppTemplatePick(name, lang, modalEl, modal, phone, pnid);
        });
        modal.show();
    },

    // Normalizzazione minima: solo cifre; cellulare italiano senza prefisso → 39
    _chatAppNormalizePhone(raw) {
        let p = (raw || '').replace(/\D/g, '');
        if (p.startsWith('00')) p = p.slice(2);
        if (p.length === 10 && p.startsWith('3')) p = '39' + p;
        return p.length >= 8 ? p : null;
    },

    // ── Trascrizione vocali via Whisper ──────────────────────────────────────
    async transcribeChatAppAudio(msgId, btn) {
        if (btn) { btn.disabled = true; btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Trascrizione in corso...'; }
        try {
            const result = await this.api(`/whatsapp/api/messages/${msgId}/transcribe`, { method: 'POST' });
            if (result.ok) {
                if (btn) {
                    btn.outerHTML = `<div class="wa-transcript"><span class="wa-transcript-label">Trascrizione</span>${this._escapeHtml(result.text)}</div>`;
                }
            } else {
                this.toast(result.error || 'Trascrizione fallita', 'danger');
                if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-closed-captioning me-1"></i>Trascrivi vocale'; }
            }
        } catch (e) {
            this.toast(e.message, 'danger');
            if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-closed-captioning me-1"></i>Trascrivi vocale'; }
        }
    },

    async _loadChatAppMessages(pnid, waId, poll) {
        try {
            let container = document.getElementById('wa-app-messages');
            if (!container) {
                // Chat smontata (cambio pagina): spegni il poll
                if (this._chatAppMsgPollTimer) { clearInterval(this._chatAppMsgPollTimer); this._chatAppMsgPollTimer = null; }
                return;
            }
            let url = `/whatsapp/api/messages/${pnid}/${waId}`;
            if (poll && this._chatAppLastMsgTs) url += `?after=${this._chatAppLastMsgTs}`;
            const data = await this.api(url);
            container = document.getElementById('wa-app-messages');
            if (!container) return;
            if (!poll) { container.innerHTML = ''; this._chatAppLastDayKey = null; }
            if (!data.messages || data.messages.length === 0) {
                if (!poll) container.innerHTML = '<div class="text-center text-muted small py-4">Nessun messaggio</div>';
                return;
            }
            // Tieni traccia dei messaggi media in attesa di download (per refresh)
            let hasPendingMedia = false;
            data.messages.forEach(m => {
                // Separatore giorno stile WhatsApp quando cambia la data
                const msgDate = this.parseDate(m.timestamp);
                const dayKey = msgDate.toDateString();
                if (dayKey !== this._chatAppLastDayKey) {
                    this._chatAppLastDayKey = dayKey;
                    const sep = document.createElement('div');
                    sep.className = 'wa-day-sep';
                    sep.innerHTML = `<span>${this._chatAppDayLabel(msgDate)}</span>`;
                    container.appendChild(sep);
                }
                const bubble = document.createElement('div');
                bubble.className = `wa-chat-bubble ${m.direction === 'incoming' ? 'incoming' : 'outgoing'}`;
                bubble.dataset.msgId = m.id;
                let content = this._renderChatAppBubbleContent(m);
                if (m.type !== 'text' && m.type !== 'template' && (m.content?.media_id || m.content?.local_filename) && !m.content?.local_filename && m.direction === 'incoming') {
                    hasPendingMedia = true;
                }
                const statusIcon = m.direction === 'outgoing' ? (
                    m.status === 'read' ? '<i class="fa-solid fa-check-double" style="color:#53bdeb"></i>' :
                    m.status === 'delivered' ? '<i class="fa-solid fa-check-double"></i>' :
                    '<i class="fa-solid fa-check"></i>'
                ) : '';
                const time = this.parseDate(m.timestamp).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
                bubble.innerHTML = `<div>${content}</div><div class="wa-bubble-time">${time} ${statusIcon}</div>`;
                container.appendChild(bubble);
                this._chatAppLastMsgTs = m.timestamp;
            });
            container.scrollTop = container.scrollHeight;

            // Se ci sono media in download, ricarica tra 3s per aggiornare le bolle
            if (hasPendingMedia && !this._chatAppMediaRefreshTimer) {
                this._chatAppMediaRefreshTimer = setTimeout(() => {
                    this._chatAppMediaRefreshTimer = null;
                    this._chatAppLastMsgTs = null;  // forza reload completo
                    this._loadChatAppMessages(pnid, waId, false);
                }, 3000);
            }
        } catch (e) { if (!poll) console.error(e); }
    },

    _renderTemplateContent(c) {
        const escape = (s) => this._escapeHtml(s || '');
        let parts = [];
        if (c.header) parts.push(`<div class="fw-bold mb-1">${escape(c.header)}</div>`);
        if (c.body) parts.push(`<div style="white-space:pre-wrap">${escape(c.body)}</div>`);
        else parts.push(`<div><i class="fa-solid fa-file-lines me-1"></i>${escape(c.template_name || 'Template')}</div>`);
        if (c.footer) parts.push(`<div class="text-muted small mt-2">${escape(c.footer)}</div>`);
        if (c.buttons?.length) {
            c.buttons.forEach(b => {
                parts.push(`<div style="background:rgba(0,0,0,.03);border-radius:8px;padding:6px;margin-top:4px;text-align:center;color:#0d6efd;font-weight:500">${escape(typeof b === 'string' ? b : b.text || '')}</div>`);
            });
        }
        return parts.join('');
    },

    _renderChatAppBubbleContent(m) {
        const c = m.content || {};
        const escape = (s) => this._escapeHtml(s || '');
        const captionHtml = (txt) => txt ? `<div class="wa-media-caption mt-1">${escape(txt)}</div>` : '';

        if (m.type === 'text' || m.type === 'button' || m.type === 'interactive') return escape(c.body || '');

        if (m.type === 'template') {
            return this._renderTemplateContent(c);
        }

        // Media: per i messaggi outgoing useremo c.media_url (URL pubblico al momento dell'invio).
        // Per gli incoming useremo /whatsapp/media/<msg_id> che serve il file scaricato.
        const isOutgoing = m.direction === 'outgoing';
        const downloaded = !!c.local_filename;
        const mediaSrc = isOutgoing
            ? (c.media_url || `/whatsapp/media/${m.id}`)
            : `/whatsapp/media/${m.id}`;

        if (m.type === 'audio') {
            if (!isOutgoing && !downloaded) {
                return `<div class="wa-media-pending"><span class="spinner-border spinner-border-sm me-2"></span>Download audio in corso...</div>`;
            }
            // Trascrizione via Whisper: solo vocali in ingresso già scaricati
            let transcriptHtml = '';
            if (c.transcript) {
                transcriptHtml = `<div class="wa-transcript"><span class="wa-transcript-label">Trascrizione</span>${escape(c.transcript)}</div>`;
            } else if (!isOutgoing && downloaded) {
                transcriptHtml = `<button type="button" class="wa-transcribe-btn" onclick="SyrusApp.transcribeChatAppAudio('${this._escapeAttr(m.id)}', this)">
                    <i class="fa-solid fa-closed-captioning me-1"></i>Trascrivi vocale</button>`;
            }
            return `<div class="wa-media-audio">
                <audio controls preload="none" src="${mediaSrc}" style="height:36px;max-width:280px"></audio>
                ${transcriptHtml}
            </div>`;
        }

        if (m.type === 'image' || m.type === 'sticker') {
            if (!isOutgoing && !downloaded) {
                return `<div class="wa-media-pending"><span class="spinner-border spinner-border-sm me-2"></span>Download immagine in corso...</div>`;
            }
            return `<div class="wa-media-image">
                <img src="${mediaSrc}" alt="immagine" style="max-width:240px;max-height:240px;border-radius:6px;cursor:pointer" onclick="SyrusApp.openChatAppImageFullscreen('${mediaSrc}')">
                ${captionHtml(c.caption)}
            </div>`;
        }

        if (m.type === 'video') {
            if (!isOutgoing && !downloaded) {
                return `<div class="wa-media-pending"><span class="spinner-border spinner-border-sm me-2"></span>Download video in corso...</div>`;
            }
            return `<div class="wa-media-video">
                <video controls preload="none" style="max-width:280px;border-radius:6px" src="${mediaSrc}"></video>
                ${captionHtml(c.caption)}
            </div>`;
        }

        if (m.type === 'document') {
            if (!isOutgoing && !downloaded) {
                return `<div class="wa-media-pending"><span class="spinner-border spinner-border-sm me-2"></span>Download documento in corso...</div>`;
            }
            const fname = c.caption || c.filename || c.local_filename || 'Documento';
            const fsize = c.file_size ? this._formatBytes(c.file_size) : '';
            return `<a href="${mediaSrc}" target="_blank" download="${escape(fname)}" class="wa-media-doc">
                <i class="fa-solid fa-file fa-2x me-2"></i>
                <div class="flex-grow-1 text-start">
                    <div class="fw-bold small">${escape(fname)}</div>
                    ${fsize ? `<div class="text-muted" style="font-size:11px">${fsize}</div>` : ''}
                </div>
                <i class="fa-solid fa-download ms-2"></i>
            </a>`;
        }

        if (m.type === 'location') {
            const lat = c.latitude, lng = c.longitude;
            return `<i class="fa-solid fa-location-dot me-1"></i><a href="https://maps.google.com/?q=${lat},${lng}" target="_blank">${escape(c.name || `${lat}, ${lng}`)}</a>`;
        }

        return `<i class="fa-solid fa-comment me-1"></i>${escape(m.type)}`;
    },

    _formatBytes(bytes) {
        if (!bytes || bytes < 1024) return `${bytes || 0} B`;
        if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    },

    openChatAppImageFullscreen(src) {
        const html = `<div class="modal fade" id="chatAppImgModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content bg-transparent border-0">
                    <div class="modal-header border-0">
                        <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body text-center p-0">
                        <img src="${src}" style="max-width:100%;max-height:80vh;border-radius:8px">
                    </div>
                </div>
            </div>
        </div>`;
        const old = document.getElementById('chatAppImgModal');
        if (old) {
            const inst = bootstrap.Modal.getInstance(old);
            if (inst) inst.dispose();
            old.remove();
        }
        document.body.insertAdjacentHTML('beforeend', html);
        const el = document.getElementById('chatAppImgModal');
        const m = new bootstrap.Modal(el);
        el.addEventListener('hidden.bs.modal', () => {
            m.dispose();
            el.remove();
            document.querySelectorAll('.modal-backdrop').forEach(b => b.remove());
            document.body.classList.remove('modal-open');
        }, { once: true });
        m.show();
    },

    _waAppSendForce: false,
    async _sendChatAppMessage(e) {
        e.preventDefault();
        const pnid = document.getElementById('wa-app-pnid-current').value;
        const waId = document.getElementById('wa-app-waid-current').value;
        const input = document.getElementById('wa-app-input');
        const text = input.value.trim();
        if (!text) return;
        const payload = { phone_number_id: pnid, to: waId, type: 'text', text };
        if (this._waAppSendForce) { payload.force = true; this._waAppSendForce = false; }
        try {
            const result = await this.api('/whatsapp/api/messages/send', { method: 'POST', body: JSON.stringify(payload) });
            if (result.ok === false && result.needs_confirmation) {
                if (confirm(result.reason)) { this._waAppSendForce = true; return this._sendChatAppMessage(e); }
                return;
            }
            if (result.ok === false && result.window_closed) {
                this.toast('Finestra di servizio chiusa — apri il modal template', 'warning');
                this._updateChatAppWindowState();
                this.openChatAppTemplateModal();
                return;
            }
            if (result.ok === false) { this.toast(result.error || result.reason || 'Errore invio', 'danger'); return; }
            input.value = '';
            input.style.height = 'auto';
            this._loadChatAppMessages(pnid, waId, false);
            // Refresh lista per aggiornare preview/timestamp
            setTimeout(() => this.loadChatApp(true), 300);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _sendChatAppFile(input) {
        const file = input.files[0];
        if (!file) return;
        const pnid = document.getElementById('wa-app-pnid-current')?.value;
        const waId = document.getElementById('wa-app-waid-current')?.value;
        if (!pnid || !waId) {
            this.toast('Conversazione non selezionata', 'danger');
            input.value = '';
            return;
        }
        // Riusa la stessa pipeline del drag&drop per evitare divergenze
        await this._sendChatAppDroppedFile(file, pnid, waId);
        input.value = '';
    },

    // ── Drag & Drop file ─────────────────────────────────────────────────────
    _setupChatAppDragDrop(pnid, waId) {
        const main = document.getElementById('wa-app-main');
        if (!main) return;
        // Crea overlay drag se non esiste
        let overlay = document.getElementById('wa-app-drop-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'wa-app-drop-overlay';
            overlay.className = 'wa-drop-overlay';
            overlay.innerHTML = `<div class="wa-drop-inner">
                <i class="fa-solid fa-cloud-arrow-up fa-3x mb-3"></i>
                <h5>Rilascia per inviare</h5>
                <p class="text-muted small mb-0">Il file verrà inviato come allegato WhatsApp</p>
            </div>`;
            main.appendChild(overlay);
        }
        // Counter per evitare flickering quando l'over passa sui figli
        let dragDepth = 0;
        const onDragEnter = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types || []).includes('Files')) return;
            e.preventDefault();
            dragDepth++;
            overlay.classList.add('show');
        };
        const onDragOver = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types || []).includes('Files')) return;
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        };
        const onDragLeave = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types || []).includes('Files')) return;
            dragDepth = Math.max(0, dragDepth - 1);
            if (dragDepth === 0) overlay.classList.remove('show');
        };
        const onDrop = (e) => {
            e.preventDefault();
            dragDepth = 0;
            overlay.classList.remove('show');
            const files = e.dataTransfer?.files;
            if (!files || files.length === 0) return;
            // Inviamo il primo file (un upload alla volta come WhatsApp Web)
            this._sendChatAppDroppedFile(files[0], pnid, waId);
        };
        // Rimuovi listener precedenti se esistono (cleanup tra cambi conversazione)
        if (this._chatAppDropCleanup) this._chatAppDropCleanup();
        main.addEventListener('dragenter', onDragEnter);
        main.addEventListener('dragover', onDragOver);
        main.addEventListener('dragleave', onDragLeave);
        main.addEventListener('drop', onDrop);
        this._chatAppDropCleanup = () => {
            main.removeEventListener('dragenter', onDragEnter);
            main.removeEventListener('dragover', onDragOver);
            main.removeEventListener('dragleave', onDragLeave);
            main.removeEventListener('drop', onDrop);
        };
    },

    async _sendChatAppDroppedFile(file, pnid, waId) {
        if (!file) return;
        console.log('[chat-app] uploading file:', file.name, file.type, file.size, 'bytes');
        this.toast('Invio allegato...', 'info');
        try {
            const fd = new FormData();
            fd.append('file', file);
            const resp = await SyrusApp.fetchWithCsrf('/whatsapp/api/media/upload', {
                method: 'POST', body: fd,
            });
            // Parse JSON anche su HTTP non-200, per estrarre l'error message
            let upload = null;
            try { upload = await resp.json(); } catch (_) { upload = null; }
            if (!resp.ok || !upload || !upload.ok) {
                const errMsg = (upload && upload.error) ? upload.error : `HTTP ${resp.status}`;
                console.warn('[chat-app] upload failed:', errMsg, upload);
                this.toast('Upload fallito: ' + errMsg, 'danger');
                return;
            }
            console.log('[chat-app] upload ok:', upload);
            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify({
                    phone_number_id: pnid, to: waId, type: upload.media_type,
                    media_url: upload.url, caption: file.name, filename: file.name,
                })
            });
            console.log('[chat-app] send result:', result);
            if (result.ok) {
                this.toast('Allegato inviato!', 'success');
                this._loadChatAppMessages(pnid, waId, false);
                setTimeout(() => this.loadChatApp(true), 300);
            } else if (result.window_closed) {
                this.toast('Finestra chiusa — gli allegati sono permessi solo dentro la finestra 24h', 'warning');
                this._updateChatAppWindowState();
            } else {
                this.toast(result.error || 'Errore invio', 'danger');
            }
        } catch (e) {
            console.error('[chat-app] exception:', e);
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    // ── Voice recording (MediaRecorder API) ──────────────────────────────────
    _chatAppRecorder: null,
    _chatAppRecorderStream: null,
    _chatAppRecorderChunks: [],
    _chatAppRecorderTimer: null,
    _chatAppRecorderStart: null,

    async toggleChatAppRecording() {
        if (this._chatAppRecorder && this._chatAppRecorder.state === 'recording') {
            this._stopChatAppRecording(true);
            return;
        }
        // Verifica permessi e supporto
        if (!navigator.mediaDevices || !window.MediaRecorder) {
            this.toast('Il browser non supporta la registrazione audio', 'danger');
            return;
        }
        try {
            this._chatAppRecorderStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (e) {
            this.toast('Permesso microfono negato', 'danger');
            return;
        }
        // Scegli il miglior MIME supportato — preferisci ogg/opus, fallback webm
        let mimeType = '';
        const candidates = ['audio/ogg;codecs=opus', 'audio/webm;codecs=opus', 'audio/webm', 'audio/mp4'];
        for (const c of candidates) {
            if (MediaRecorder.isTypeSupported(c)) { mimeType = c; break; }
        }
        try {
            this._chatAppRecorder = new MediaRecorder(this._chatAppRecorderStream, mimeType ? { mimeType } : undefined);
        } catch (e) {
            this.toast('Errore avvio registrazione: ' + e.message, 'danger');
            this._cleanupChatAppRecorder();
            return;
        }
        this._chatAppRecorderChunks = [];
        this._chatAppRecorderStart = Date.now();

        this._chatAppRecorder.ondataavailable = (e) => {
            if (e.data && e.data.size > 0) this._chatAppRecorderChunks.push(e.data);
        };
        this._chatAppRecorder.onstop = () => this._uploadChatAppRecording();
        this._chatAppRecorder.start();

        // UI: trasforma il bottone in "stop" rosso pulsante + mostra timer nell'input
        const micBtn = document.getElementById('wa-app-mic-btn');
        const inputEl = document.getElementById('wa-app-input');
        if (micBtn) {
            micBtn.innerHTML = '<i class="fa-solid fa-stop fa-lg text-danger"></i>';
            micBtn.title = 'Ferma registrazione';
            micBtn.classList.add('wa-mic-recording');
        }
        if (inputEl) {
            inputEl.disabled = true;
            inputEl.placeholder = '🔴 Registrazione in corso... 0:00';
        }
        this._chatAppRecorderTimer = setInterval(() => {
            const elapsed = Math.floor((Date.now() - this._chatAppRecorderStart) / 1000);
            const m = Math.floor(elapsed / 60);
            const s = String(elapsed % 60).padStart(2, '0');
            if (inputEl) inputEl.placeholder = `🔴 Registrazione in corso... ${m}:${s}`;
            // Hard cap a 5 minuti
            if (elapsed >= 300) this._stopChatAppRecording(true);
        }, 1000);
    },

    _stopChatAppRecording(send) {
        if (this._chatAppRecorder && this._chatAppRecorder.state === 'recording') {
            this._chatAppRecorder.stop();
        }
        // _uploadChatAppRecording sarà chiamata da onstop, che fa cleanup
        if (!send) {
            this._chatAppRecorderChunks = [];
        }
    },

    _cleanupChatAppRecorder() {
        if (this._chatAppRecorderTimer) { clearInterval(this._chatAppRecorderTimer); this._chatAppRecorderTimer = null; }
        if (this._chatAppRecorderStream) {
            this._chatAppRecorderStream.getTracks().forEach(t => t.stop());
            this._chatAppRecorderStream = null;
        }
        this._chatAppRecorder = null;
        this._chatAppRecorderChunks = [];
        const micBtn = document.getElementById('wa-app-mic-btn');
        const inputEl = document.getElementById('wa-app-input');
        if (micBtn) {
            micBtn.innerHTML = '<i class="fa-solid fa-microphone fa-lg"></i>';
            micBtn.title = 'Registra messaggio vocale';
            micBtn.classList.remove('wa-mic-recording');
        }
        if (inputEl) {
            inputEl.disabled = false;
            inputEl.placeholder = 'Scrivi un messaggio';
        }
    },

    // Dopo lo stop NON si invia subito: si mostra un'anteprima riascoltabile
    // con conferma esplicita (richiesta di Cristiano, 2026-07-17)
    _chatAppPendingVoice: null,

    async _uploadChatAppRecording() {
        const chunks = this._chatAppRecorderChunks.slice();
        const mimeType = this._chatAppRecorder?.mimeType || 'audio/webm';
        this._cleanupChatAppRecorder();
        if (!chunks.length) return;

        const blob = new Blob(chunks, { type: mimeType });
        // Estensione coerente col mimeType
        let ext = 'webm';
        if (mimeType.includes('ogg')) ext = 'ogg';
        else if (mimeType.includes('mp4')) ext = 'm4a';
        const filename = `voice-${Date.now()}.${ext}`;

        const pnid = document.getElementById('wa-app-pnid-current')?.value;
        const waId = document.getElementById('wa-app-waid-current')?.value;
        if (!pnid || !waId) return;

        this._showChatAppVoicePreview(blob, filename, pnid, waId);
    },

    _showChatAppVoicePreview(blob, filename, pnid, waId) {
        this._discardChatAppVoicePreview(false);
        const url = URL.createObjectURL(blob);
        this._chatAppPendingVoice = { blob, filename, pnid, waId, url };

        const form = document.getElementById('wa-app-send-form');
        if (!form) { this._discardChatAppVoicePreview(false); return; }
        const bar = document.createElement('div');
        bar.id = 'wa-app-voice-preview';
        bar.className = 'wa-voice-preview-bar';
        bar.innerHTML = `
            <i class="fa-solid fa-microphone text-success"></i>
            <span class="small">Riascolta prima di inviare:</span>
            <audio controls src="${url}" style="height:36px;flex:1;min-width:120px"></audio>
            <button type="button" class="btn btn-sm btn-outline-danger" onclick="SyrusApp._discardChatAppVoicePreview(true)" title="Annulla">
                <i class="fa-solid fa-trash"></i>
            </button>
            <button type="button" class="btn btn-sm btn-success" onclick="SyrusApp._confirmChatAppVoice()" title="Invia vocale">
                <i class="fa-solid fa-paper-plane me-1"></i>Invia
            </button>`;
        form.parentNode.insertBefore(bar, form);
    },

    _discardChatAppVoicePreview(notify) {
        const bar = document.getElementById('wa-app-voice-preview');
        if (bar) bar.remove();
        if (this._chatAppPendingVoice) {
            try { URL.revokeObjectURL(this._chatAppPendingVoice.url); } catch (_) { /* ignore */ }
            this._chatAppPendingVoice = null;
            if (notify) this.toast('Vocale scartato', 'info');
        }
    },

    async _confirmChatAppVoice() {
        const pending = this._chatAppPendingVoice;
        if (!pending) return;
        const { blob, filename, pnid, waId } = pending;
        this._discardChatAppVoicePreview(false);

        this.toast('Invio messaggio vocale...', 'info');
        try {
            const fd = new FormData();
            fd.append('file', blob, filename);
            const resp = await SyrusApp.fetchWithCsrf('/whatsapp/api/media/upload', {
                method: 'POST', body: fd,
            });
            const upload = await resp.json();
            if (!upload.ok) throw new Error(upload.error || 'Upload fallito');

            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify({
                    phone_number_id: pnid, to: waId, type: 'audio',
                    media_url: upload.url, caption: '', filename: filename,
                }),
            });
            if (result.ok) {
                this.toast('Messaggio vocale inviato!', 'success');
                this._loadChatAppMessages(pnid, waId, false);
                setTimeout(() => this.loadChatApp(true), 300);
            } else if (result.window_closed) {
                this.toast('Finestra chiusa — gli audio sono permessi solo dentro la finestra 24h', 'warning');
                this._updateChatAppWindowState();
            } else {
                this.toast(result.error || 'Errore invio audio', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

});


// ── app-deepgram.js ──
/** Syrus Sales OS – Deepgram Transcriptions */
Object.assign(SyrusApp, {

    // ── Deepgram Transcriptions ─────────────────────────────────────────────

    _formatFileSize(bytes) {
        if (!bytes) return '-';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
        return (bytes / 1073741824).toFixed(1) + ' GB';
    },

    async dgLoadList() {
        const tbody = document.getElementById('dg-table');
        if (!tbody) return;
        try {
            const data = await this.api('/deepgram/api/list');
            if (data.items.length === 0) {
                tbody.innerHTML = '<tr><td colspan="9" class="text-center py-5 text-muted"><i class="fa-solid fa-microphone-slash fa-2x mb-2 d-block"></i>Nessuna trascrizione. Carica un file audio o video.</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(t => {
                    const dur = t.audio_duration_seconds ? `${Math.floor(t.audio_duration_seconds/60)}:${String(t.audio_duration_seconds%60).padStart(2,'0')}` : '-';
                    const conf = t.confidence_score ? `${(t.confidence_score * 100).toFixed(0)}%` : '-';
                    const size = this._formatFileSize(t.file_size_bytes);
                    const statusBadge = {
                        uploaded: '<span class="badge bg-secondary">Caricato</span>',
                        processing: '<span class="badge bg-warning text-dark">Elaborazione...</span>',
                        completed: '<span class="badge bg-success">Completato</span>',
                        failed: '<span class="badge bg-danger">Errore</span>',
                    };
                    const lockIcon = t.locked
                        ? `<button class="btn btn-warning" onclick="SyrusApp.dgToggleLock('${t.id}')" title="File protetto – clicca per sbloccare"><i class="fa-solid fa-lock"></i></button>`
                        : `<button class="btn btn-outline-secondary" onclick="SyrusApp.dgToggleLock('${t.id}')" title="File non protetto – clicca per proteggere"><i class="fa-solid fa-lock-open"></i></button>`;

                    const leadCell = t.lead_id
                        ? `<a href="/leads/${t.lead_id}" onclick="event.preventDefault();SyrusApp.spaNavigate('/leads/${t.lead_id}')" class="text-decoration-none"><small class="fw-medium">${this._escapeHtml(t.lead_crm_id || '')}</small><br><small class="text-muted">${this._escapeHtml(t.lead_name || '')}</small></a>`
                        : '<small class="text-muted fst-italic">Non associato</small>';

                    return `<tr>
                        <td>
                            <div class="fw-medium">${this._escapeHtml(t.original_filename || 'File')}</div>
                            <small class="text-muted">${this.formatDate(t.created_at)} · ${size}</small>
                        </td>
                        <td>${leadCell}</td>
                        <td>${dur}</td>
                        <td>${t.speakers_detected || '-'}</td>
                        <td>${conf}</td>
                        <td class="text-center">${t.has_file
                            ? (t.storage === 'drive'
                                ? '<i class="fa-solid fa-cloud text-primary" title="Su Google Drive"></i>'
                                : '<i class="fa-solid fa-hard-drive text-warning" title="File in locale — verrà spostato su Drive quando la lead è assegnata"></i>')
                            : '<i class="fa-solid fa-circle-xmark text-muted" title="Nessun file"></i>'}</td>
                        <td class="text-center">${t.has_transcript ? '<i class="fa-solid fa-circle-check text-success"></i>' : '<i class="fa-solid fa-circle-xmark text-muted"></i>'}</td>
                        <td class="text-center">${statusBadge[t.status] || t.status}</td>
                        <td class="text-end">
                            <div class="btn-group btn-group-sm" role="group">
                                ${lockIcon}
                                ${t.has_file ? `<button class="btn btn-outline-secondary dg-play-btn" onclick="SyrusApp.dgPlay('${t.audio_url}', this)" title="Play/Stop"><i class="fa-solid fa-play"></i></button>` : ''}
                                ${t.has_file && !t.has_transcript ? `<button class="btn btn-outline-primary" onclick="SyrusApp.dgTranscribe('${t.id}')" title="Trascrivi"><i class="fa-solid fa-language"></i></button>` : ''}
                                ${t.has_transcript ? `<button class="btn btn-outline-secondary" onclick="SyrusApp.dgShowTranscript('${t.id}')" title="Leggi"><i class="fa-solid fa-file-lines"></i></button>` : ''}
                                ${t.has_transcript ? `<button class="btn ${t.has_summary ? 'btn-success' : 'btn-outline-secondary'}" onclick="SyrusApp.dgSummarize('${t.id}')" title="${t.has_summary ? 'Vedi il riepilogo AI' : 'Genera il riepilogo AI'}">${this._aiSparkleSvg(14)}</button>` : ''}
                                <button class="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown" data-bs-boundary="viewport" title="Lead"><i class="fa-solid fa-link"></i></button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#" onclick="event.preventDefault();SyrusApp.dgAssociateLead('${t.id}')"><i class="fa-solid fa-link me-2"></i>Associa a Lead esistente</a></li>
                                    <li><a class="dropdown-item" href="#" onclick="event.preventDefault();SyrusApp.dgCreateLeadFromAudio('${t.id}','${this._escapeAttr(t.original_filename || '')}')"><i class="fa-solid fa-plus me-2"></i>Crea nuova Lead</a></li>
                                    ${t.lead_id ? `<li><hr class="dropdown-divider"></li><li><a class="dropdown-item text-warning" href="#" onclick="event.preventDefault();SyrusApp.dgUnlinkLead('${t.id}')"><i class="fa-solid fa-unlink me-2"></i>Scollega Lead</a></li>` : ''}
                                </ul>
                                <button class="btn btn-outline-danger dropdown-toggle" data-bs-toggle="dropdown" data-bs-boundary="viewport" title="Elimina"><i class="fa-solid fa-trash"></i></button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    ${t.has_file ? `<li><a class="dropdown-item" href="#" onclick="event.preventDefault();SyrusApp.dgDeleteFile('${t.id}')"><i class="fa-solid fa-file-audio me-2"></i>Elimina solo file</a></li>` : ''}
                                    ${t.has_transcript ? `<li><a class="dropdown-item" href="#" onclick="event.preventDefault();SyrusApp.dgDeleteTranscript('${t.id}')"><i class="fa-solid fa-file-lines me-2"></i>Elimina solo trascrizione</a></li>` : ''}
                                    <li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item text-danger" href="#" onclick="event.preventDefault();SyrusApp.dgDeleteAll('${t.id}')"><i class="fa-solid fa-trash me-2"></i>Elimina tutto</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>`;
                }).join('');
            }
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    // NOTE: Operations Center Widget (trackOperation, trackUpload, etc.) is in app-core.js

    async dgShowUploadModal() {
        // Load leads for association
        let leadsHtml = '<option value="">-- Nessuna (audio indipendente) --</option>';
        try {
            const data = await this.api('/leads/api/list?page=1&per_page=200');
            const leads = data.leads || data.items || [];
            leads.forEach(l => {
                leadsHtml += `<option value="${l.id}">${this._escapeHtml(l.crm_id || '')} – ${this._escapeHtml(l.company_name || l.contact_name || '')}</option>`;
            });
        } catch(e) { /* silent */ }

        this._showModal('<i class="fa-solid fa-cloud-arrow-up me-2"></i>Carica Audio/Video', `
            <div class="mb-3">
                <label class="form-label fw-medium">Associa a Lead</label>
                <select id="dg-upload-lead" class="form-select">
                    ${leadsHtml}
                </select>
                <small class="text-muted">Seleziona la lead a cui associare questa registrazione, oppure lascia vuoto.</small>
            </div>
            <div class="mb-3">
                <label class="form-label fw-medium">File Audio/Video</label>
                <input type="file" id="dg-file-input" class="form-control"
                       accept=".mp3,.wav,.ogg,.flac,.m4a,.aac,.mp4,.avi,.mov,.mkv,.webm">
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-primary flex-grow-1" onclick="SyrusApp._dgStartUpload()">
                    <i class="fa-solid fa-cloud-arrow-up me-1"></i> Carica
                </button>
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
            </div>
            <p class="text-muted small mt-2 mb-0"><i class="fa-solid fa-info-circle me-1"></i>Formati: MP3, WAV, OGG, FLAC, M4A, MP4, AVI, MOV, MKV. Video convertiti automaticamente in audio.</p>
        `);
    },

    _dgStartUpload() {
        const input = document.getElementById('dg-file-input');
        const leadId = document.getElementById('dg-upload-lead')?.value || '';
        if (!input?.files?.length) { this.toast('Seleziona un file', 'warning'); return; }
        // Store lead_id for the upload flow
        this._dgUploadLeadId = leadId;
        // Close modal and start upload
        bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
        this.dgUpload(input);
    },

    _dgUploadLeadId: '',

    async dgUpload(input) {
        const file = input.files[0];
        if (!file) return;

        this._uploadCounter++;
        const opId = 'upload-' + this._uploadCounter;
        const sizeMB = (file.size / 1024 / 1024).toFixed(1);
        const totalChunks = Math.ceil(file.size / this.CHUNK_SIZE);

        // Track in unified ops widget
        this.trackUpload(opId, `Upload: ${file.name}`);
        this.updateOpProgress(opId, 0, `0 / ${sizeMB} MB`);

        try {
            // Step 1: Init upload session
            const init = await this.api('/deepgram/api/upload/init', {
                method: 'POST',
                body: JSON.stringify({ filename: file.name, file_size: file.size }),
            });
            if (!init.ok) throw new Error(init.error);

            const serverId = init.upload_id;

            // Step 2: Send chunks
            for (let i = 0; i < totalChunks; i++) {
                const start = i * this.CHUNK_SIZE;
                const end = Math.min(start + this.CHUNK_SIZE, file.size);
                const blob = file.slice(start, end);

                const fd = new FormData();
                fd.append('upload_id', serverId);
                fd.append('chunk_index', i);
                fd.append('chunk', blob);

                const resp = await SyrusApp.fetchWithCsrf('/deepgram/api/upload/chunk', { method: 'POST', body: fd });
                if (!resp.ok) throw new Error(`Chunk ${i} failed: HTTP ${resp.status}`);

                const pct = Math.round(((i + 1) / totalChunks) * 100);
                const sentMB = (end / 1024 / 1024).toFixed(1);
                this.updateOpProgress(opId, pct, `${sentMB} / ${sizeMB} MB`);
            }

            // Step 3: Finalize
            this.updateOpProgress(opId, 100, 'Assemblaggio e conversione...');

            const finalizeData = { upload_id: serverId };
            if (this._dgUploadLeadId) finalizeData.lead_id = this._dgUploadLeadId;
            const result = await this.api('/deepgram/api/upload/finalize', {
                method: 'POST',
                body: JSON.stringify(finalizeData),
            });
            this._dgUploadLeadId = '';

            if (result.ok) {
                const msg = result.is_video ? 'Video convertito in audio' : 'Caricato';
                this.completeOp(opId, true, msg);
                this.toast(`${file.name} caricato!`, 'success');
                if (document.getElementById('dg-table')) this.dgLoadList();
            } else {
                throw new Error(result.error || 'Errore finalizzazione');
            }
        } catch(e) {
            this.completeOp(opId, false, e.message);
            this.toast(e.message, 'danger');
        }
    },

    /**
     * Avvia la trascrizione Deepgram e attende l'esito.
     * Ritorna 'completed' | 'failed' — chi concatena altro lavoro sul testo
     * (es. il riepilogo AI) DEVE aspettare questa promessa: prima della fine
     * il transcript è vuoto e il job a valle fallisce.
     */
    async dgTranscribe(id) {
        // Track in unified ops widget
        const opId = `transcribe-${id}`;
        const op = this.trackUpload(opId, 'Trascrizione Deepgram');
        op.type = 'transcription';
        this.updateOpProgress(opId, 0, 'Invio a Deepgram...');
        this._renderOps();

        // Also update inline table status if visible
        const rows = document.querySelectorAll('#dg-table tr');
        rows.forEach(row => {
            if (row.innerHTML.includes(id)) {
                const statusCell = row.querySelectorAll('td')[7];
                if (statusCell) statusCell.innerHTML = '<span class="badge bg-warning text-dark"><i class="fa-solid fa-spinner fa-spin me-1"></i>In elaborazione...</span>';
            }
        });

        try {
            const result = await this.api(`/deepgram/api/${id}/transcribe`, { method: 'POST' });
            if (!result.ok) {
                this.completeOp(opId, false, result.error || 'Errore');
                this.toast(result.error || 'Errore trascrizione', 'danger');
                this.dgLoadList();
                this._refreshRecordings?.();
                return 'failed';
            }

            // La riga passa subito a "trascrizione in corso"
            this._refreshRecordings?.();

            // Polling: aspetta che la trascrizione sia completata in background
            this.updateOpProgress(opId, 50, 'Deepgram in elaborazione...');
            return await new Promise(resolve => {
                const poll = async () => {
                    try {
                        const t = await this.api(`/deepgram/api/${id}`);
                        if (t.status === 'completed') {
                            const speakers = t.speakers_detected || '?';
                            const conf = t.confidence_score ? `${(t.confidence_score * 100).toFixed(0)}%` : '?';
                            this.completeOp(opId, true, `${speakers} speaker, ${conf} confidenza`);
                            this.toast('Trascrizione completata!', 'success');
                            this.dgLoadList();
                            this._refreshRecordings?.();
                            resolve('completed');
                        } else if (t.status === 'failed') {
                            this.completeOp(opId, false, 'Trascrizione fallita');
                            this.toast('Trascrizione fallita', 'danger');
                            this.dgLoadList();
                            this._refreshRecordings?.();
                            resolve('failed');
                        } else {
                            // Ancora in elaborazione
                            setTimeout(poll, 3000);
                        }
                    } catch (e) {
                        setTimeout(poll, 5000);
                    }
                };
                setTimeout(poll, 3000);
            });

        } catch(e) {
            this.completeOp(opId, false, e.message);
            this.toast(e.message, 'danger');
            this.dgLoadList();
            this._refreshRecordings?.();
            return 'failed';
        }
    },

    async dgShowTranscript(id) {
        try {
            const t = await this.api(`/deepgram/api/${id}`);
            const dur = t.audio_duration_seconds ? `${Math.floor(t.audio_duration_seconds/60)}:${String(t.audio_duration_seconds%60).padStart(2,'0')}` : '-';

            this._showModal('<i class="fa-solid fa-file-lines me-2"></i>Trascrizione', `
                <div class="d-flex gap-3 mb-3 small">
                    <span><i class="fa-solid fa-clock me-1"></i> ${dur}</span>
                    <span><i class="fa-solid fa-users me-1"></i> ${t.speakers_detected || '?'} speaker</span>
                    <span><i class="fa-solid fa-bullseye me-1"></i> ${t.confidence_score ? (t.confidence_score * 100).toFixed(0) + '%' : '-'} confidenza</span>
                    <span><i class="fa-solid fa-globe me-1"></i> ${t.language_detected || '-'}</span>
                </div>
                ${t.audio_url ? `<div class="mb-3"><audio controls src="${this._escapeAttr(t.audio_url)}" class="w-100" style="height:40px"></audio></div>` : ''}
                <div class="border rounded p-3 bg-white" style="max-height:62vh;overflow-y:auto;white-space:pre-wrap;font-size:14px;line-height:1.8">${this._escapeHtml(t.transcript_text || 'Nessuna trascrizione disponibile')}</div>
                <div class="mt-3 d-flex gap-2">
                    <button class="btn btn-sm btn-outline-secondary" onclick="navigator.clipboard.writeText(document.querySelector('#syrus-modal .border').textContent).then(()=>SyrusApp.toast('Copiato!'))">
                        <i class="fa-solid fa-copy me-1"></i> Copia testo
                    </button>
                    ${t.has_transcript ? `<button class="btn btn-sm btn-outline-warning" onclick="if(confirm('Ri-trascrivere?')){bootstrap.Modal.getInstance(document.getElementById('syrus-modal')).hide();SyrusApp.dgDeleteTranscript('${id}').then(()=>SyrusApp.dgTranscribe('${id}'))}">
                        <i class="fa-solid fa-rotate me-1"></i> Ri-trascrivi
                    </button>` : ''}
                    <button class="btn btn-sm ${t.summary ? 'btn-success' : 'btn-outline-secondary'}" onclick="bootstrap.Modal.getInstance(document.getElementById('syrus-modal')).hide();SyrusApp.dgSummarize('${id}')">
                        ${SyrusApp._aiSparkleSvg(14)} <span class="ms-1">${t.summary ? 'Vedi riepilogo AI' : 'Genera riepilogo AI'}</span>
                    </button>
                </div>
                ${t.summary ? SyrusApp._renderCallSummary(t.summary) : ''}
            `, 'modal-xl');   // le trascrizioni lunghe arrivano qui: serve spazio
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    /** `btn` è la stellina AI cliccata: pulsa finché il riepilogo è in lavorazione. */
    async dgSummarize(id, forceRegenerate, btn) {
        try {
            if (!forceRegenerate) {
                const t = await this.api(`/deepgram/api/${id}`);
                if (t.summary) {
                    const summaryJson = JSON.stringify(t.summary, null, 2);
                    this._lastSummaryJson = summaryJson;
                    this._showModal(this._aiSparkleSvg(16) + '<span class="ms-2">Riepilogo AI</span>', `
                        ${this._renderCallSummary(t.summary)}
                        <div class="mt-3 d-flex gap-2">
                            <button class="btn btn-sm btn-outline-info" onclick="bootstrap.Modal.getInstance(document.getElementById('syrus-modal')).hide();SyrusApp.dgSummarize('${id}', true)">
                                <i class="fa-solid fa-rotate me-1"></i> Rigenera riepilogo
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" onclick="navigator.clipboard.writeText(SyrusApp._lastSummaryJson).then(()=>SyrusApp.toast('JSON copiato!'))">
                                <i class="fa-solid fa-copy me-1"></i> Copia JSON
                            </button>
                        </div>
                    `);
                    return;
                }
            }
            await this._dgStartSummarize(id, btn);
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async _dgStartSummarize(id, btn) {
        const stopPulse = () => {
            if (btn) { btn.classList.remove('is-working'); btn.disabled = false; }
        };
        if (btn) { btn.classList.add('is-working'); btn.disabled = true; }
        try {
            const res = await this.api(`/deepgram/api/${id}/summarize`, {
                method: 'POST', body: JSON.stringify({})
            });
            const jobId = res.job_id;

            // Track in unified ops widget (uses polling)
            this.trackOperation(jobId, 'summary', 'Riepilogo AI Chiamata', `/ai/api/status/${jobId}`, '/deepgram');

            // Override poll completion to show result modal
            const origPoll = this._pollOps.bind(this);
            this._dgSummaryTimer = setInterval(async () => {
                const op = this._operations.find(o => o.id === jobId);
                if (!op || op.status === 'running') return;
                clearInterval(this._dgSummaryTimer); this._dgSummaryTimer = null;
                stopPulse();
                if (op.status === 'completed') {
                    try {
                        const status = await this.api(`/ai/api/status/${jobId}`);
                        const summary = status.result?.summary;
                        this._lastSummaryJson = JSON.stringify(summary || {}, null, 2);
                        this._showModal(this._aiSparkleSvg(16) + '<span class="ms-2">Riepilogo AI</span>', `
                            ${this._renderCallSummary(summary)}
                            <div class="mt-3">
                                <button class="btn btn-sm btn-outline-secondary" onclick="navigator.clipboard.writeText(SyrusApp._lastSummaryJson).then(()=>SyrusApp.toast('JSON copiato!'))">
                                    <i class="fa-solid fa-copy me-1"></i> Copia JSON
                                </button>
                            </div>
                        `);
                        this.dgLoadList();
                        this._refreshRecordings?.();
                        if (this._currentLeadId && document.getElementById('lead-calls-list')) {
                            this.loadLeadCallsAndTranscriptions(this._currentLeadId);
                        }
                    } catch(e) { /* toast already shown by pollOps */ }
                }
            }, 1000);
        } catch(e) {
            stopPulse();
            this.toast(e.message, 'danger');
        }
    },

    _renderCallSummary(summary) {
        if (!summary) return '<div class="text-muted">Nessun riepilogo disponibile</div>';

        const sentimentColors = { positivo: 'success', neutro: 'warning', negativo: 'danger' };
        const sentimentColor = sentimentColors[summary.sentiment] || 'secondary';
        const score = summary.punteggio_interesse || '-';
        const scoreColor = score >= 7 ? 'success' : score >= 4 ? 'warning' : 'danger';

        const listHtml = (items) => {
            if (!items || !items.length) return '<span class="text-muted">-</span>';
            return '<ul class="mb-0 ps-3">' + items.map(i => '<li class="small">' + this._escapeHtml(i) + '</li>').join('') + '</ul>';
        };

        return `
            <div class="mt-3">
                ${summary.riepilogo ? `<div class="alert alert-info mb-3"><i class="fa-solid fa-quote-left me-2"></i>${this._escapeHtml(summary.riepilogo)}</div>` : ''}
                <div class="row g-3 mb-3">
                    <div class="col-md-4 text-center">
                        <div class="border rounded p-2">
                            <div class="small text-muted">Sentiment</div>
                            <span class="badge bg-${sentimentColor} fs-6">${this._escapeHtml(summary.sentiment || '-')}</span>
                        </div>
                    </div>
                    <div class="col-md-4 text-center">
                        <div class="border rounded p-2">
                            <div class="small text-muted">Interesse</div>
                            <span class="badge bg-${scoreColor} fs-6">${score}/10</span>
                        </div>
                    </div>
                    <div class="col-md-4 text-center">
                        <div class="border rounded p-2">
                            <div class="small text-muted">Budget</div>
                            <span class="fw-medium">${this._escapeHtml(summary.budget_menzionato || '-')}</span>
                        </div>
                    </div>
                </div>
                ${summary.timeline_menzionata ? `<div class="mb-2"><strong class="small">Timeline:</strong> <span class="small">${this._escapeHtml(summary.timeline_menzionata)}</span></div>` : ''}
                <div class="row g-3">
                    <div class="col-md-6">
                        <div class="card h-100"><div class="card-body py-2">
                            <h6 class="card-title mb-1"><i class="fa-solid fa-list-check me-1 text-primary"></i>Argomenti principali</h6>
                            ${listHtml(summary.argomenti_principali)}
                        </div></div>
                    </div>
                    <div class="col-md-6">
                        <div class="card h-100"><div class="card-body py-2">
                            <h6 class="card-title mb-1"><i class="fa-solid fa-clipboard-list me-1 text-success"></i>Action Items</h6>
                            ${listHtml(summary.action_items)}
                        </div></div>
                    </div>
                    <div class="col-md-6">
                        <div class="card h-100"><div class="card-body py-2">
                            <h6 class="card-title mb-1"><i class="fa-solid fa-bullseye me-1 text-info"></i>Esigenze cliente</h6>
                            ${listHtml(summary.esigenze_cliente)}
                        </div></div>
                    </div>
                    <div class="col-md-6">
                        <div class="card h-100"><div class="card-body py-2">
                            <h6 class="card-title mb-1"><i class="fa-solid fa-triangle-exclamation me-1 text-warning"></i>Obiezioni</h6>
                            ${listHtml(summary.obiezioni)}
                        </div></div>
                    </div>
                </div>
                ${summary.prossimi_passi ? `<div class="alert alert-success mt-3 mb-0"><i class="fa-solid fa-forward-step me-2"></i><strong>Prossimi passi:</strong> ${this._escapeHtml(summary.prossimi_passi)}</div>` : ''}
            </div>`;
    },

    _dgPlaying: null, // currently playing URL

    _dgResetAllPlayBtns() {
        document.querySelectorAll('.dg-play-btn').forEach(b => {
            b.innerHTML = '<i class="fa-solid fa-play"></i>';
            b.classList.remove('btn-danger');
            b.classList.add('btn-outline-secondary');
        });
    },

    dgPlay(url, btn) {
        // Ensure we have a player
        if (!this._dgPlayer) {
            this._dgPlayer = new Audio();
            this._dgPlayer.addEventListener('ended', () => {
                this._dgPlaying = null;
                this._dgResetAllPlayBtns();
            });
        }

        // If same URL is playing → STOP
        if (this._dgPlaying === url) {
            this._dgPlayer.pause();
            this._dgPlayer.currentTime = 0;
            this._dgPlaying = null;
            this._dgResetAllPlayBtns();
            return;
        }

        // Stop any other playing audio first
        this._dgPlayer.pause();
        this._dgResetAllPlayBtns();

        // Show loading spinner on the clicked button
        this._dgActiveBtn = btn || null;
        if (btn) {
            btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i>';
            btn.classList.remove('btn-outline-secondary');
            btn.classList.add('btn-warning');
        }

        // Start new playback
        this._dgPlayer.src = url;
        this._dgPlayer.play().then(() => {
            this._dgPlaying = url;
            // Highlight only the clicked button
            if (btn) {
                btn.innerHTML = '<i class="fa-solid fa-stop"></i>';
                btn.classList.remove('btn-warning');
                btn.classList.add('btn-danger');
            }
        }).catch(() => {
            this._dgResetAllPlayBtns();
            this.toast('Impossibile riprodurre', 'warning');
        });
    },

    async dgToggleLock(id) {
        try {
            const r = await this.api(`/deepgram/api/${id}/toggle-lock`, { method: 'POST' });
            this.toast(r.locked ? 'File protetto (no auto-cancellazione)' : 'File sbloccato (cancellazione automatica dopo 30gg)', r.locked ? 'success' : 'warning');
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async dgDeleteFile(id) {
        if (!confirm('Eliminare solo il file audio? La trascrizione resta.')) return;
        try {
            await this.api(`/deepgram/api/${id}/delete-file`, { method: 'DELETE' });
            this.toast('File eliminato');
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async dgDeleteTranscript(id) {
        if (!confirm('Eliminare solo la trascrizione? Il file audio resta.')) return;
        try {
            await this.api(`/deepgram/api/${id}/delete-transcript`, { method: 'DELETE' });
            this.toast('Trascrizione eliminata');
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async dgDeleteAll(id) {
        if (!confirm('Eliminare file + trascrizione + record? Azione irreversibile.')) return;
        try {
            await this.api(`/deepgram/api/${id}`, { method: 'DELETE' });
            this.toast('Tutto eliminato');
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    // ── Associate / Create Lead from transcription ──────────────────────────

    async dgAssociateLead(transcriptionId) {
        let leadsHtml = '<option value="">-- Seleziona Lead --</option>';
        try {
            const data = await this.api('/leads/api/list?page=1&per_page=200');
            const leads = data.leads || data.items || [];
            leads.forEach(l => {
                leadsHtml += `<option value="${l.id}">${this._escapeHtml(l.crm_id || '')} – ${this._escapeHtml(l.company_name || l.contact_name || '')}</option>`;
            });
        } catch(e) { /* silent */ }

        this._showModal('<i class="fa-solid fa-link me-2"></i>Associa a Lead', `
            <div class="mb-3">
                <label class="form-label fw-medium">Seleziona Lead</label>
                <select id="dg-assoc-lead" class="form-select">${leadsHtml}</select>
            </div>
            <div class="d-flex gap-2 justify-content-end">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-primary" onclick="SyrusApp._dgSaveLeadAssoc('${transcriptionId}')">
                    <i class="fa-solid fa-link me-1"></i>Associa
                </button>
            </div>
        `);
    },

    async _dgSaveLeadAssoc(transcriptionId) {
        const leadId = document.getElementById('dg-assoc-lead')?.value;
        if (!leadId) { this.toast('Seleziona una lead', 'warning'); return; }
        try {
            await this.api(`/deepgram/api/${transcriptionId}/link-lead`, {
                method: 'POST',
                body: JSON.stringify({ lead_id: leadId }),
            });
            this.toast('Trascrizione associata alla lead', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async dgCreateLeadFromAudio(transcriptionId, filename) {
        this._showModal('<i class="fa-solid fa-plus me-2"></i>Crea Lead da Registrazione', `
            <p class="text-muted small">Verrà creata una nuova lead e la registrazione <strong>${this._escapeHtml(filename)}</strong> sarà associata automaticamente.</p>
            <div class="d-flex justify-content-end mb-2">
                <button class="btn btn-sm btn-outline-info" id="dg-ai-prefill-btn" onclick="SyrusApp.dgAiPrefillLead('${transcriptionId}')" title="Analizza la trascrizione con AI e pre-compila i campi">
                    <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Analizza con AI
                </button>
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Nome Azienda *</label>
                <input type="text" id="dg-new-lead-company" class="form-control" required placeholder="Es: Azienda Rossi S.r.l.">
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Nome Contatto</label>
                <input type="text" id="dg-new-lead-name" class="form-control" placeholder="Mario Rossi">
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Email</label>
                <input type="email" id="dg-new-lead-email" class="form-control" placeholder="email@esempio.it">
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Telefono</label>
                <input type="text" id="dg-new-lead-phone" class="form-control" placeholder="+393391234567">
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Tipo Progetto</label>
                <input type="text" id="dg-new-lead-project" class="form-control" placeholder="Es: Sito web, App mobile">
            </div>
            <div class="mb-2">
                <label class="form-label fw-medium">Descrizione</label>
                <textarea id="dg-new-lead-description" class="form-control" rows="2" placeholder="Sintesi della richiesta..."></textarea>
            </div>
            <div class="mb-3">
                <label class="form-label fw-medium">Note</label>
                <textarea id="dg-new-lead-notes" class="form-control" rows="2" placeholder="Appunti sulla chiamata..."></textarea>
            </div>
            <div class="d-flex gap-2 justify-content-end">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-success" onclick="SyrusApp._dgCreateLeadAndLink('${transcriptionId}')">
                    <i class="fa-solid fa-plus me-1"></i>Crea Lead e Associa
                </button>
            </div>
        `);
    },

    async dgAiPrefillLead(transcriptionId) {
        const btn = document.getElementById('dg-ai-prefill-btn');
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>Analisi in corso...';
        }
        try {
            const r = await this.api(`/deepgram/api/${transcriptionId}/extract-lead-data`, { method: 'POST' });
            const d = r.data || {};
            const setVal = (id, val) => {
                const el = document.getElementById(id);
                if (el && val) el.value = val;
            };
            setVal('dg-new-lead-company', d.company_name);
            setVal('dg-new-lead-name', d.contact_name);
            setVal('dg-new-lead-email', d.contact_email);
            setVal('dg-new-lead-phone', d.contact_phone);
            setVal('dg-new-lead-project', d.project_type);
            setVal('dg-new-lead-description', d.description);
            setVal('dg-new-lead-notes', d.notes);
            this.toast(`Campi pre-compilati con AI (${r.engine})`, 'success');
        } catch (e) {
            this.toast(e.message || 'Errore AI', 'danger');
        } finally {
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fa-solid fa-wand-magic-sparkles me-1"></i>Analizza con AI';
            }
        }
    },

    async _dgCreateLeadAndLink(transcriptionId) {
        const company = document.getElementById('dg-new-lead-company')?.value?.trim();
        if (!company) { this.toast('Inserisci il nome azienda', 'warning'); return; }
        try {
            const leadData = {
                company_name: company,
                contact_name: document.getElementById('dg-new-lead-name')?.value?.trim() || company,
                contact_email: document.getElementById('dg-new-lead-email')?.value?.trim() || '',
                contact_phone: document.getElementById('dg-new-lead-phone')?.value?.trim() || '',
                project_type: document.getElementById('dg-new-lead-project')?.value?.trim() || '',
                description: document.getElementById('dg-new-lead-description')?.value?.trim() || '',
                notes: document.getElementById('dg-new-lead-notes')?.value?.trim() || '',
                source: 'audio_recording',
            };
            const lead = await this.api('/leads/api/create', {
                method: 'POST',
                body: JSON.stringify(leadData),
            });
            if (lead.error) throw new Error(lead.error);
            const leadId = lead.id;
            // Now link transcription to the new lead
            await this.api(`/deepgram/api/${transcriptionId}/link-lead`, {
                method: 'POST',
                body: JSON.stringify({ lead_id: leadId }),
            });
            this.toast(`Lead creata e registrazione associata`, 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },

    async dgUnlinkLead(transcriptionId) {
        if (!confirm('Scollegare questa registrazione dalla lead?')) return;
        try {
            await this.api(`/deepgram/api/${transcriptionId}/link-lead`, {
                method: 'POST',
                body: JSON.stringify({ lead_id: null }),
            });
            this.toast('Lead scollegata', 'success');
            this.dgLoadList();
        } catch(e) { this.toast(e.message, 'danger'); }
    },
});


// ── app-calendar.js ──
/** Syrus Sales OS – Calendar */
Object.assign(SyrusApp, {

    _calView: 'month',
    _calDate: new Date(),
    _calAppts: [],

    // Chiave data locale 'YYYY-MM-DD' (NON usare toISOString: converte a UTC
    // e dopo le 22:00/23:00 italiane sposta la data al giorno precedente).
    _calDateKey(d) {
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
             + '-' + String(d.getDate()).padStart(2, '0');
    },

    calInit() {
        this._calDate = new Date();
        this.setCalView('month');
        this.calLoadToday();
    },

    setCalView(view) {
        this._calView = view;
        document.getElementById('cal-month-view')?.classList.toggle('d-none', view !== 'month');
        document.getElementById('cal-week-view')?.classList.toggle('d-none', view !== 'week');
        document.getElementById('cal-view-month')?.classList.toggle('active', view === 'month');
        document.getElementById('cal-view-week')?.classList.toggle('active', view === 'week');
        this.calRender();
    },

    calNav(dir) {
        if (this._calView === 'month') {
            this._calDate.setMonth(this._calDate.getMonth() + dir);
        } else {
            this._calDate.setDate(this._calDate.getDate() + dir * 7);
        }
        this.calRender();
    },

    calToday() {
        this._calDate = new Date();
        this.calRender();
    },

    async calRender() {
        const months = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
        const d = this._calDate;
        const userId = document.getElementById('cal-user-filter')?.value || '';

        // Fetch appointments for the visible range
        let start, end;
        if (this._calView === 'month') {
            start = new Date(d.getFullYear(), d.getMonth(), 1);
            end = new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59);
            document.getElementById('cal-title').textContent = `${months[d.getMonth()]} ${d.getFullYear()}`;
        } else {
            const dayOfWeek = d.getDay() || 7;
            start = new Date(d);
            start.setDate(d.getDate() - dayOfWeek + 1);
            start.setHours(0,0,0,0);
            end = new Date(start);
            end.setDate(start.getDate() + 6);
            end.setHours(23,59,59);
            document.getElementById('cal-title').textContent = `${start.getDate()}–${end.getDate()} ${months[start.getMonth()]} ${start.getFullYear()}`;
        }

        try {
            const params = new URLSearchParams({
                start: start.toISOString(), end: end.toISOString(),
            });
            if (userId) params.set('user_id', userId);
            this._calAppts = await this.api(`/calendar/api/appointments?${params}`);
        } catch (e) {
            this._calAppts = [];
        }

        if (this._calView === 'month') this._calRenderMonth();
        else this._calRenderWeek();
    },

    _calRenderMonth() {
        const d = this._calDate;
        const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
        const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        let startDay = firstDay.getDay() || 7; // Monday = 1
        const today = new Date();
        const tbody = document.getElementById('cal-month-body');
        let html = '<tr>';

        // Empty cells before first day
        for (let i = 1; i < startDay; i++) {
            html += '<td class="other-month"></td>';
        }

        for (let day = 1; day <= lastDay.getDate(); day++) {
            const cellDate = new Date(d.getFullYear(), d.getMonth(), day);
            const isToday = cellDate.toDateString() === today.toDateString();
            const dateStr = this._calDateKey(cellDate);

            // Get appointments for this day (confronto su data locale, non su stringa UTC)
            const dayAppts = this._calAppts.filter(a => a.start_at && this._calDateKey(this.parseDate(a.start_at)) === dateStr);

            html += `<td class="${isToday ? 'today' : ''}" onclick="SyrusApp.calDayClick('${dateStr}')">`;
            html += `<div class="small fw-bold ${isToday ? 'text-primary' : 'text-muted'}">${day}</div>`;
            dayAppts.slice(0, 3).forEach(a => {
                const time = a.start_at ? this.parseDate(a.start_at).toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'}) : '';
                html += `<div class="cal-event cal-event-${a.type}" onclick="event.stopPropagation();SyrusApp.showApptDetail('${a.id}')">${time} ${this._escapeHtml(a.title || '')}</div>`;
            });
            if (dayAppts.length > 3) html += `<div class="small text-muted">+${dayAppts.length - 3} altri</div>`;
            html += '</td>';

            if (cellDate.getDay() === 0) html += '</tr><tr>';
        }

        // Fill remaining cells
        const remaining = (7 - (lastDay.getDay() || 7)) % 7;
        for (let i = 0; i < remaining; i++) html += '<td class="other-month"></td>';
        html += '</tr>';

        tbody.innerHTML = html;
    },

    _calRenderWeek() {
        const d = this._calDate;
        const dayOfWeek = d.getDay() || 7;
        const monday = new Date(d);
        monday.setDate(d.getDate() - dayOfWeek + 1);
        monday.setHours(0,0,0,0);

        const dayNames = ['Lun','Mar','Mer','Gio','Ven','Sab','Dom'];
        const today = new Date().toDateString();

        // Header
        let header = '<th style="width:50px"></th>';
        for (let i = 0; i < 7; i++) {
            const day = new Date(monday);
            day.setDate(monday.getDate() + i);
            const isToday = day.toDateString() === today;
            header += `<th class="${isToday ? 'text-primary' : ''}">${dayNames[i]} ${day.getDate()}</th>`;
        }
        document.getElementById('cal-week-header').innerHTML = header;

        // Body (hours 8-20)
        let body = '';
        for (let hour = 8; hour <= 20; hour++) {
            body += '<tr>';
            body += `<td class="week-hour-label">${String(hour).padStart(2,'0')}:00</td>`;
            for (let i = 0; i < 7; i++) {
                const day = new Date(monday);
                day.setDate(monday.getDate() + i);
                const dateStr = this._calDateKey(day);
                const hourAppts = this._calAppts.filter(a => {
                    if (!a.start_at) return false;
                    const aDate = this.parseDate(a.start_at);
                    return this._calDateKey(aDate) === dateStr && aDate.getHours() === hour;
                });
                body += '<td>';
                hourAppts.forEach(a => {
                    const time = this.parseDate(a.start_at).toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'});
                    body += `<div class="cal-event cal-event-${a.type}" onclick="SyrusApp.showApptDetail('${a.id}')">${time} ${this._escapeHtml(a.title || '')}</div>`;
                });
                body += '</td>';
            }
            body += '</tr>';
        }
        document.getElementById('cal-week-body').innerHTML = body;
    },

    calDayClick(dateStr) {
        this.showNewApptModal(dateStr);
    },

    async calLoadToday() {
        try {
            const data = await this.api('/calendar/api/appointments/today');
            const apptsEl = document.getElementById('cal-today-appts');
            const tasksEl = document.getElementById('cal-today-tasks');

            if (data.appointments.length === 0) {
                apptsEl.innerHTML = '<div class="text-center text-muted py-3 small">Nessun appuntamento oggi</div>';
            } else {
                apptsEl.innerHTML = '<div class="list-group list-group-flush">' + data.appointments.map(a => {
                    const time = a.start_at ? this.parseDate(a.start_at).toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'}) : '';
                    return `<div class="list-group-item py-2 px-3">
                        <div class="d-flex justify-content-between">
                            <strong class="small">${time}</strong>
                            <span class="badge bg-light text-dark">${a.type}</span>
                        </div>
                        <div class="small">${this._escapeHtml(a.title || '')}</div>
                        ${a.lead_name ? `<small class="text-muted">${this._escapeHtml(a.lead_name || '')}</small>` : ''}
                    </div>`;
                }).join('') + '</div>';
            }

            if (data.leads_tasks.length === 0) {
                tasksEl.innerHTML = '<div class="text-center text-muted py-3 small">Nessun task per oggi</div>';
            } else {
                tasksEl.innerHTML = '<div class="list-group list-group-flush">' + data.leads_tasks.map(l =>
                    `<a href="/leads/${l.id}" class="list-group-item list-group-item-action py-2 px-3">
                        <div class="small fw-medium">${this._escapeHtml(l.crm_id || '')} – ${this._escapeHtml(l.company_name || '')}</div>
                        <small class="text-muted">${this._escapeHtml(l.next_action || '')}</small>
                    </a>`
                ).join('') + '</div>';
            }
        } catch (e) { /* silent */ }
    },

    showNewApptModal(dateStr) {
        const today = dateStr || this._calDateKey(new Date());
        const html = `
            <div class="modal fade" id="newApptModal" tabindex="-1"><div class="modal-dialog"><div class="modal-content">
                <div class="modal-header"><h5 class="modal-title">Nuovo Appuntamento</h5><button class="btn-close" data-bs-dismiss="modal"></button></div>
                <div class="modal-body">
                    <form id="appt-form">
                        <div class="mb-3"><label class="form-label">Titolo *</label><input type="text" name="title" class="form-control" required></div>
                        <div class="row g-3 mb-3">
                            <div class="col-6"><label class="form-label">Inizio *</label><input type="datetime-local" name="start_at" class="form-control" value="${today}T09:00" required></div>
                            <div class="col-6"><label class="form-label">Fine *</label><input type="datetime-local" name="end_at" class="form-control" value="${today}T09:30" required></div>
                        </div>
                        <div class="row g-3 mb-3">
                            <div class="col-6"><label class="form-label">Tipo</label>
                                <select name="type" class="form-select"><option value="call">Telefonata</option><option value="meeting">Riunione</option><option value="demo">Demo</option><option value="follow-up">Follow-up</option></select></div>
                            <div class="col-6"><label class="form-label">Canale</label>
                                <select name="channel" class="form-select"><option value="phone">Telefono</option><option value="video">Video Call</option><option value="in-person">Di persona</option><option value="whatsapp">WhatsApp</option></select></div>
                        </div>
                        <div class="mb-3"><label class="form-label">Lead ID (opzionale)</label><input type="text" name="lead_id" class="form-control" placeholder="Lascia vuoto se non collegato"></div>
                        <div class="mb-3"><label class="form-label">Note</label><textarea name="description" class="form-control" rows="2"></textarea></div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                    <button class="btn btn-primary" onclick="SyrusApp.saveAppt()"><i class="fa-solid fa-check me-1"></i>Salva</button>
                </div>
            </div></div></div>`;
        document.getElementById('modals-container').innerHTML = html;
        const apptEl = document.getElementById('newApptModal');
        (bootstrap.Modal.getInstance(apptEl) || new bootstrap.Modal(apptEl)).show();
    },

    async saveAppt() {
        const form = document.getElementById('appt-form');
        const fd = new FormData(form);
        const data = Object.fromEntries(fd.entries());
        if (!data.lead_id) delete data.lead_id;
        // datetime-local è ora di Roma senza tz: convertito in UTC (Z) per il
        // backend, che salva tutto naive UTC come il resto della piattaforma.
        if (data.start_at) data.start_at = new Date(data.start_at).toISOString();
        if (data.end_at) data.end_at = new Date(data.end_at).toISOString();

        try {
            await this.api('/calendar/api/appointments', {method:'POST', body:JSON.stringify(data)});
            bootstrap.Modal.getInstance(document.getElementById('newApptModal'))?.hide();
            this.toast('Appuntamento creato');
            this.calRender();
            this.calLoadToday();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    showApptDetail(apptId) {
        // Simple: navigate to lead if available, otherwise show toast
        const appt = this._calAppts.find(a => a.id === apptId);
        if (appt?.lead_id) {
            location.href = `/leads/${appt.lead_id}`;
        } else if (appt) {
            this.toast(`${appt.title} – ${appt.type} (${appt.channel})`);
        }
    },
});


// ── app-funnels.js ──
/** Syrus Sales OS – Funnels & Quotes */
Object.assign(SyrusApp, {

    // ── Funnel Builder ───────────────────────────────────────────────────────

    _currentFunnelId: null,
    _funnelSteps: [],

    _actionIcons: {send_email:'step-email fa-envelope',send_sms:'step-sms fa-comment-sms',send_whatsapp:'step-whatsapp fa-brands fa-whatsapp',alert:'step-alert fa-bell',create_task:'step-task fa-list-check',change_status:'step-status fa-arrows-rotate',wait:'step-wait fa-clock'},
    _actionLabels: {send_email:'Invia Email',send_sms:'Invia SMS',send_whatsapp:'WhatsApp Template',alert:'Alert/Notifica',create_task:'Crea Task',change_status:'Cambia Status',wait:'Attesa'},

    async loadFunnels() {
        try {
            const funnels = await this.api('/funnels/api/list');
            const container = document.getElementById('funnels-list');
            document.getElementById('funnel-detail')?.classList.add('d-none');
            container?.classList.remove('d-none');

            if (!funnels.length) {
                container.innerHTML = `<div class="col-12 text-center py-5"><i class="fa-solid fa-diagram-project fa-3x text-muted mb-3 d-block" style="opacity:.3"></i><p class="text-muted">Nessun funnel configurato.</p><button class="btn btn-primary" onclick="SyrusApp.showFunnelTemplates()"><i class="fa-solid fa-wand-magic-sparkles me-1"></i>Crea da Template</button></div>`;
                return;
            }
            container.innerHTML = funnels.map(f => `
                <div class="col-md-6 col-lg-4">
                    <div class="card h-100">
                        <div class="card-body cursor-pointer" onclick="location.href='/funnels/builder/${f.id}'">
                            <div class="d-flex justify-content-between mb-2">
                                <h6 class="fw-bold mb-0">${this._escapeHtml(f.name || '')}</h6>
                                <span class="badge ${f.active ? 'bg-success' : 'bg-secondary'}">${f.active ? 'Attivo' : 'Inattivo'}</span>
                            </div>
                            <p class="small text-muted mb-2">${this._escapeHtml(f.description || '')}</p>
                            <div class="d-flex gap-3 small">
                                <span><i class="fa-solid fa-list-ol me-1"></i>${f.steps_count} step</span>
                                <span><i class="fa-solid fa-users me-1"></i>${f.active_enrollments} lead attivi</span>
                            </div>
                        </div>
                        <div class="card-footer bg-transparent border-top-0 pt-0 text-end">
                            <button class="btn btn-sm btn-outline-danger" onclick="event.stopPropagation();SyrusApp.deleteFunnelById('${f.id}')"><i class="fa-solid fa-trash me-1"></i>Elimina</button>
                        </div>
                    </div>
                </div>`).join('');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async openFunnel(funnelId) {
        try {
            const f = await this.api(`/funnels/api/${funnelId}`);
            this._currentFunnelId = funnelId;
            this._funnelSteps = f.steps || [];

            document.getElementById('funnels-list')?.classList.add('d-none');
            document.getElementById('funnel-detail')?.classList.remove('d-none');
            document.getElementById('funnel-name').value = f.name;
            document.getElementById('funnel-desc').value = f.description || '';
            document.getElementById('funnel-active').checked = f.active;

            this._renderFunnelSteps();
            this._loadFunnelLog(funnelId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    showFunnelEditor() {
        this._currentFunnelId = null;
        this._funnelSteps = [];
        document.getElementById('funnels-list')?.classList.add('d-none');
        document.getElementById('funnel-detail')?.classList.remove('d-none');
        document.getElementById('funnel-name').value = '';
        document.getElementById('funnel-desc').value = '';
        document.getElementById('funnel-active').checked = true;
        this._renderFunnelSteps();
    },

    backToFunnelList() {
        this._currentFunnelId = null;
        this.loadFunnels();
    },

    addFunnelStep() {
        this._funnelSteps.push({
            name: `Step ${this._funnelSteps.length + 1}`,
            action_type: 'send_email',
            action_config: {},
            delay_minutes: 60,
            condition_type: 'none',
            condition_config: {},
            exit_on: 'none',
        });
        this._renderFunnelSteps();
    },

    removeFunnelStep(idx) {
        this._funnelSteps.splice(idx, 1);
        this._renderFunnelSteps();
    },

    _renderFunnelSteps() {
        const container = document.getElementById('funnel-steps-container');
        if (!container) return;
        if (!this._funnelSteps.length) {
            container.innerHTML = '<div class="text-center text-muted py-3">Nessuno step. Clicca "Aggiungi Step".</div>';
            return;
        }
        const delayLabel = (m) => {
            if (m < 60) return `${m} min`;
            if (m < 1440) return `${Math.round(m/60)}h`;
            return `${Math.round(m/1440)}g`;
        };

        container.innerHTML = this._funnelSteps.map((s, i) => {
            const iconParts = (this._actionIcons[s.action_type] || 'step-wait fa-circle').split(' ');
            const iconClass = iconParts[0];
            const iconFa = iconParts.slice(1).join(' ');
            return `
                ${i > 0 ? '<div class="funnel-connector"></div><div class="funnel-connector-arrow"><i class="fa-solid fa-chevron-down"></i></div>' : ''}
                <div class="funnel-step-card">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="d-flex align-items-center gap-3">
                            <div class="step-action-icon ${iconClass}"><i class="fa-solid ${iconFa}"></i></div>
                            <div>
                                <input type="text" class="form-control form-control-sm fw-bold border-0 p-0" value="${s.name}" onchange="SyrusApp._funnelSteps[${i}].name=this.value" style="font-size:14px">
                                <div class="d-flex gap-2 mt-1">
                                    <select class="form-select form-select-sm" style="width:auto;font-size:12px" onchange="SyrusApp._funnelSteps[${i}].action_type=this.value;SyrusApp._renderFunnelSteps()">
                                        ${Object.entries(this._actionLabels).map(([k,v]) => `<option value="${k}" ${k===s.action_type?'selected':''}>${v}</option>`).join('')}
                                    </select>
                                    <div class="input-group input-group-sm" style="width:120px">
                                        <input type="number" class="form-control" value="${s.delay_minutes}" onchange="SyrusApp._funnelSteps[${i}].delay_minutes=parseInt(this.value)" style="font-size:12px">
                                        <span class="input-group-text" style="font-size:11px">min</span>
                                    </div>
                                    <select class="form-select form-select-sm" style="width:auto;font-size:12px" onchange="SyrusApp._funnelSteps[${i}].exit_on=this.value">
                                        <option value="none" ${s.exit_on==='none'?'selected':''}>Nessuna uscita</option>
                                        <option value="reply" ${s.exit_on==='reply'?'selected':''}>Esce se risponde</option>
                                        <option value="status_change" ${s.exit_on==='status_change'?'selected':''}>Esce se cambia status</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex gap-1">
                            <small class="badge bg-light text-muted">${delayLabel(s.delay_minutes)}</small>
                            <button class="btn btn-sm text-danger" onclick="SyrusApp.removeFunnelStep(${i})"><i class="fa-solid fa-xmark"></i></button>
                        </div>
                    </div>
                </div>`;
        }).join('');
    },

    async saveFunnel() {
        const data = {
            name: document.getElementById('funnel-name').value,
            description: document.getElementById('funnel-desc').value,
            active: document.getElementById('funnel-active').checked,
            steps: this._funnelSteps,
        };
        try {
            if (this._currentFunnelId) {
                await this.api(`/funnels/api/${this._currentFunnelId}/update`, {method:'PUT',body:JSON.stringify(data)});
            } else {
                const r = await this.api('/funnels/api/create', {method:'POST',body:JSON.stringify(data)});
                this._currentFunnelId = r.id;
            }
            this.toast('Funnel salvato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteFunnel() {
        if (!this._currentFunnelId || !confirm('Sei sicuro di voler eliminare questo funnel?')) return;
        try {
            await this.api(`/funnels/api/${this._currentFunnelId}`, {method:'DELETE'});
            this.toast('Funnel eliminato');
            this.backToFunnelList();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async showFunnelTemplates() {
        try {
            const templates = await this.api('/funnels/api/templates');
            const catLabels = {acquisition:'Acquisizione',nurturing:'Nurturing',recovery:'Recupero',post_sale:'Post-vendita',custom:'Personalizzato',general:'Generale'};
            this._showModal('Crea Funnel da Template', `
                <div class="row g-3">${templates.map(t => `
                    <div class="col-md-6"><div class="card h-100"><div class="card-body">
                        <div class="d-flex justify-content-between mb-1">
                            <h6 class="fw-bold mb-0">${this._escapeHtml(t.name)}</h6>
                            ${t.is_builtin ? '<span class="badge bg-primary">Builtin</span>' : '<span class="badge bg-secondary">Custom</span>'}
                        </div>
                        <span class="badge bg-light text-dark mb-2">${catLabels[t.category] || t.category}</span>
                        <p class="small text-muted mb-2">${this._escapeHtml(t.description || '')}</p>
                        <button class="btn btn-primary btn-sm w-100" onclick="SyrusApp.createFromTemplate('${t.id}')"><i class="fa-solid fa-plus me-1"></i>Usa Template</button>
                    </div></div></div>`).join('')}</div>`);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteFunnelById(funnelId) {
        if (!confirm('Sei sicuro di voler eliminare questo funnel?')) return;
        try {
            await this.api(`/funnels/api/${funnelId}`, {method: 'DELETE'});
            this.toast('Funnel eliminato', 'success');
            this.loadFunnels();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async createFromTemplate(templateId) {
        try {
            const r = await this.api(`/funnels/api/templates/${templateId}/create`, {method:'POST', body:JSON.stringify({})});
            // Close modal
            const modal = bootstrap.Modal.getInstance(document.querySelector('.modal.show'));
            if (modal) modal.hide();
            this.toast('Funnel creato da template!', 'success');
            location.href = `/funnels/builder/${r.funnel_id}`;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _loadFunnelLog(funnelId) {
        try {
            const logs = await this.api(`/funnels/api/${funnelId}/log`);
            const tbody = document.getElementById('funnel-log-table');
            if (!logs.length) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center text-muted py-3">Nessuna esecuzione</td></tr>';
                return;
            }
            tbody.innerHTML = logs.map(l => `<tr>
                <td class="small">${this.formatDate(l.executed_at)}</td>
                <td>${l.step_name||'-'}</td>
                <td>${l.action||'-'}</td>
                <td><span class="badge bg-${l.result==='success'?'success':l.result==='failed'?'danger':'secondary'}">${l.result}</span></td>
                <td class="small">${l.details||''}</td>
            </tr>`).join('');
        } catch(e){/* silent */}
    },

    // ── Funnel Builder v2 (Drawflow) ──────────────────────────────────────

    _funnelEditor: null,
    _currentFunnelBuilderId: null,
    _selectedNodeId: null,

    _nodeTemplates: {
        // Triggers (0 input, 1 output)
        trigger_new_lead:       { inputs: 0, outputs: 1, nodeType: 'trigger', actionType: 'new_lead', label: 'Nuova Lead', icon: 'fa-bolt', color: 'trigger' },
        trigger_status_change:  { inputs: 0, outputs: 1, nodeType: 'trigger', actionType: 'status_change', label: 'Cambio Status', icon: 'fa-arrows-rotate', color: 'trigger' },
        trigger_manual:         { inputs: 0, outputs: 1, nodeType: 'trigger', actionType: 'manual', label: 'Manuale', icon: 'fa-hand-pointer', color: 'trigger' },
        // Actions (1 input, 1 output)
        send_email:            { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'send_email', label: 'Invia Email', icon: 'fa-envelope', color: 'action' },
        send_sms:              { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'send_sms', label: 'Invia SMS', icon: 'fa-comment-sms', color: 'action' },
        send_whatsapp:         { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'send_whatsapp', label: 'Invia WhatsApp', icon: 'fa-brands fa-whatsapp', color: 'action' },
        create_appointment:    { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'create_appointment', label: 'Appuntamento', icon: 'fa-calendar-plus', color: 'action' },
        change_status:         { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'change_status', label: 'Cambia Status', icon: 'fa-arrows-rotate', color: 'action' },
        add_newsletter:        { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'add_newsletter', label: 'Newsletter', icon: 'fa-newspaper', color: 'action' },
        create_task:           { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'create_task', label: 'Crea Task', icon: 'fa-list-check', color: 'action' },
        alert:                 { inputs: 1, outputs: 1, nodeType: 'action', actionType: 'alert', label: 'Alerta Team', icon: 'fa-bell', color: 'action' },
        // Conditions (1 input, 2 outputs: Si/No)
        cond_email_opened:     { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'email_opened', label: 'Email Aperta?', icon: 'fa-envelope-open', color: 'condition' },
        cond_whatsapp_read:    { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'whatsapp_read', label: 'WA Letto?', icon: 'fa-brands fa-whatsapp', color: 'condition' },
        cond_whatsapp_replied: { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'whatsapp_replied', label: 'WA Risposto?', icon: 'fa-brands fa-whatsapp', color: 'condition' },
        cond_lead_status:      { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'lead_status_equals', label: 'Status Lead?', icon: 'fa-flag', color: 'condition' },
        cond_lead_score:       { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'lead_score_gt', label: 'Score Lead?', icon: 'fa-star', color: 'condition' },
        cond_no_response:      { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'no_response_after_days', label: 'Nessuna Risposta?', icon: 'fa-clock', color: 'condition' },
        cond_appointment:      { inputs: 1, outputs: 2, nodeType: 'condition', conditionType: 'appointment_confirmed', label: 'Appuntamento?', icon: 'fa-calendar-check', color: 'condition' },
        // Flow
        wait:                  { inputs: 1, outputs: 1, nodeType: 'wait', actionType: 'wait', label: 'Attendi', icon: 'fa-clock', color: 'wait' },
        exit:                  { inputs: 1, outputs: 0, nodeType: 'exit', actionType: 'exit', label: 'Esci', icon: 'fa-right-from-bracket', color: 'exit' },
    },

    initFunnelBuilder(funnelId) {
        const container = document.getElementById('drawflow');
        if (!container || typeof Drawflow === 'undefined') return;

        this._funnelEditor = new Drawflow(container);
        this._funnelEditor.reroute = true;
        this._funnelEditor.reroute_fix_curvature = true;
        this._funnelEditor.force_first_input = false;
        // Horizontal curvature (left-to-right flow)
        this._funnelEditor.curvature = 0.5;
        this._funnelEditor.reroute_curvature_start_end = 0.5;
        this._funnelEditor.reroute_curvature = 0.5;
        this._funnelEditor.start();

        // Color Si/No connections after they are created
        this._funnelEditor.on('connectionCreated', (info) => {
            this._colorConnection(info);
        });

        // Node selected
        this._funnelEditor.on('nodeSelected', (id) => {
            this._selectedNodeId = id;
            this._showNodeConfig(id);
        });
        this._funnelEditor.on('nodeUnselected', () => {
            this._selectedNodeId = null;
            document.getElementById('node-config')?.classList.add('d-none');
        });

        // Palette drag-drop
        document.querySelectorAll('.palette-node').forEach(el => {
            el.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('node-key', el.dataset.node);
            });
        });
        container.addEventListener('dragover', (e) => e.preventDefault());
        container.addEventListener('drop', (e) => {
            e.preventDefault();
            const key = e.dataTransfer.getData('node-key');
            const tpl = this._nodeTemplates[key];
            if (!tpl) return;

            const rect = container.getBoundingClientRect();
            const x = (e.clientX - rect.left) / this._funnelEditor.zoom;
            const y = (e.clientY - rect.top) / this._funnelEditor.zoom;

            const html = this._buildNodeHtml(tpl);
            const data = {
                node_type: tpl.nodeType,
                action_type: tpl.actionType || '',
                condition_type: tpl.conditionType || 'none',
                action_config: {},
                condition_config: {},
                delay_minutes: 0,
                exit_on: 'none',
                name: tpl.label,
            };

            this._funnelEditor.addNode(key, tpl.inputs, tpl.outputs, x, y, `node-${tpl.color}`, data, html);
        });

        // Load existing funnel
        this._currentFunnelBuilderId = funnelId || null;
        if (funnelId) this._loadFunnelFlow(funnelId);
    },

    _buildNodeHtml(tpl) {
        const branches = tpl.outputs === 2
            ? '<div class="df-branches"><span class="branch-yes">Si ✓</span><span class="branch-no">No ✗</span></div>'
            : '';
        return `<div class="df-node">
            <div class="df-header"><i class="fa-solid ${tpl.icon}"></i> ${tpl.label}</div>
            <div class="df-body"><div class="df-label" data-df-name>${tpl.label}</div></div>
            ${branches}
        </div>`;
    },

    // Color Si/No connections after creation
    _colorConnection(info) {
        if (!info || !info.output_class) return;
        setTimeout(() => {
            const sel = `.connection.node_out_node-${info.output_id}.node_in_node-${info.input_id}.${info.output_class}.${info.input_class}`;
            const connEl = document.querySelector(sel);
            if (!connEl) return;
            const nodeEl = document.querySelector('#node-' + info.output_id);
            if (nodeEl && nodeEl.classList.contains('node-condition')) {
                connEl.classList.add(info.output_class === 'output_2' ? 'conn-no' : 'conn-yes');
            }
        }, 100);
    },

    _recolorAllConnections() {
        if (!this._funnelEditor) return;
        const data = this._funnelEditor.export()?.drawflow?.Home?.data || {};
        for (const [nodeId, node] of Object.entries(data)) {
            const nodeEl = document.querySelector('#node-' + nodeId);
            if (!nodeEl || !nodeEl.classList.contains('node-condition')) continue;
            for (const [outKey, outData] of Object.entries(node.outputs || {})) {
                (outData.connections || []).forEach(conn => {
                    const connEl = document.querySelector(`.connection.node_out_node-${nodeId}.node_in_node-${conn.node}.${outKey}`);
                    if (connEl) connEl.classList.add(outKey === 'output_2' ? 'conn-no' : 'conn-yes');
                });
            }
        }
    },

    funnelZoom(direction) {
        if (!this._funnelEditor) return;
        if (direction > 0) this._funnelEditor.zoom_in();
        else this._funnelEditor.zoom_out();
        const el = document.getElementById('zoom-level');
        if (el) el.textContent = Math.round(this._funnelEditor.zoom * 100) + '%';
    },

    funnelFitView() {
        if (!this._funnelEditor) return;
        const data = this._funnelEditor.export()?.drawflow?.Home?.data || {};
        const nodes = Object.values(data);
        if (!nodes.length) return;

        const minX = Math.min(...nodes.map(n => n.pos_x));
        const minY = Math.min(...nodes.map(n => n.pos_y));
        const maxX = Math.max(...nodes.map(n => n.pos_x)) + 220;
        const maxY = Math.max(...nodes.map(n => n.pos_y)) + 140;

        const container = document.getElementById('drawflow');
        if (!container) return;

        const scaleX = container.clientWidth / (maxX - minX + 100);
        const scaleY = container.clientHeight / (maxY - minY + 100);
        const zoom = Math.min(Math.max(Math.min(scaleX, scaleY), 0.5), 2);

        this._funnelEditor.zoom = zoom;
        this._funnelEditor.canvas_x = -(minX - 50) * zoom;
        this._funnelEditor.canvas_y = -(minY - 50) * zoom;
        const precanvas = container.querySelector('.drawflow');
        if (precanvas) {
            precanvas.style.transform = `translate(${this._funnelEditor.canvas_x}px, ${this._funnelEditor.canvas_y}px) scale(${zoom})`;
        }
        const el = document.getElementById('zoom-level');
        if (el) el.textContent = Math.round(zoom * 100) + '%';
    },

    // ── Funnel Test (admin) ──────────────────────────────────────────────
    _funnelTestLeadId: null,

    async funnelTestCreate() {
        if (!confirm('Creare un Funnel Test completo con lead demo?')) return;
        try {
            const resp = await this.api('/funnels/api/test/create', { method: 'POST', body: '{}' });
            if (resp.error) { this.toast(resp.error, 'danger'); return; }
            this._funnelTestLeadId = resp.lead_id;
            this.toast('Funnel Test creato! Apertura builder...', 'success');
            this.spaNavigate(`/funnels/builder/${resp.funnel_id}`);
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    async funnelTestPlay() {
        if (!this._currentFunnelBuilderId) {
            this.toast('Salva prima il funnel', 'warning');
            return;
        }

        // Find test lead (from creation or ask)
        let leadId = this._funnelTestLeadId;
        if (!leadId) {
            // Try to find the test lead by source
            try {
                const leads = await this.api('/leads/api/list?search=funnel_test&per_page=1');
                if (leads.items && leads.items.length > 0) {
                    leadId = leads.items[0].id;
                }
            } catch(e) {}
        }

        const btn = document.getElementById('funnel-play-btn');
        if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>Esecuzione...'; }

        try {
            const resp = await this.api('/funnels/api/test/simulate', {
                method: 'POST',
                body: JSON.stringify({ funnel_id: this._currentFunnelBuilderId, lead_id: leadId }),
            });

            if (resp.error) { this.toast(resp.error, 'danger'); return; }

            // Clear previous simulation
            document.querySelectorAll('.drawflow-node.sim-active, .drawflow-node.sim-done').forEach(el => {
                el.classList.remove('sim-active', 'sim-done');
                el.querySelector('.sim-check')?.remove();
            });

            // Animate step by step
            await this._funnelSimAnimate(resp.steps);
        } catch (e) {
            this.toast('Errore simulazione: ' + e.message, 'danger');
        } finally {
            if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-play me-1"></i>Play Test'; }
        }
    },

    async _funnelSimAnimate(steps) {
        const STEP_DELAY = 1500; // ms between steps

        // Map step_id to drawflow node element
        const nodeMap = {};
        if (this._funnelEditor) {
            const data = this._funnelEditor.export()?.drawflow?.Home?.data || {};
            for (const [dfId, node] of Object.entries(data)) {
                if (node.data && node.data.step_id) {
                    nodeMap[node.data.step_id] = dfId;
                }
            }
        }

        for (let i = 0; i < steps.length; i++) {
            const step = steps[i];
            const dfId = nodeMap[step.step_id];

            // Highlight current node
            if (dfId) {
                const nodeEl = document.querySelector(`#node-${dfId}`);
                if (nodeEl) {
                    nodeEl.classList.add('sim-active');
                    nodeEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
                }
            }

            // Show popup
            await this._funnelSimPopup(step, i + 1, steps.length);

            // Mark as done or failed
            if (dfId) {
                const nodeEl = document.querySelector(`#node-${dfId}`);
                if (nodeEl) {
                    nodeEl.classList.remove('sim-active');
                    nodeEl.classList.add(step.result === 'failed' ? 'sim-failed' : 'sim-done');
                }
            }

            // Brief pause before next step
            if (i < steps.length - 1) {
                await new Promise(r => setTimeout(r, 300));
            }
        }

        this.toast('Simulazione completata!', 'success');
    },

    _funnelSimPopup(step, num, total) {
        return new Promise(resolve => {
            // Type icon
            const icons = {
                trigger: '🚀', action: '⚡', condition: '❓', wait: '⏳', exit: '🏁'
            };
            const typeColors = {
                trigger: '#10B981', action: '#3B82F6', condition: '#F59E0B', wait: '#6B7280', exit: '#EF4444'
            };
            const icon = icons[step.node_type] || '⚡';
            const color = typeColors[step.node_type] || '#3B82F6';

            const backdrop = document.createElement('div');
            backdrop.className = 'sim-popup-backdrop';

            const popup = document.createElement('div');
            popup.className = 'sim-popup';
            const resultBadge = step.result === 'failed'
                ? '<span class="badge bg-danger ms-2">FALLITO</span>'
                : step.result === 'skipped'
                    ? '<span class="badge bg-warning ms-2">SKIPPATO</span>'
                    : '<span class="badge bg-success ms-2">OK</span>';

            popup.innerHTML = `
                <div style="font-size:40px;margin-bottom:12px">${icon}</div>
                <div style="font-size:11px;font-weight:600;color:#64748B;margin-bottom:4px">STEP ${num} / ${total}</div>
                <div style="font-size:16px;font-weight:700;color:${color};margin-bottom:8px">${this._escapeHtml(step.step_name)} ${step.result ? resultBadge : ''}</div>
                <div style="font-size:14px;color:#334155;margin-bottom:16px;line-height:1.5">${this._escapeHtml(step.action)}</div>
                ${step.delay_minutes > 0 && step.node_type === 'wait' ? `<div style="font-size:12px;color:#6B7280;margin-bottom:12px">⏱ In produzione attenderebbe ${step.delay_minutes} minuti</div>` : ''}
                <button class="btn btn-primary btn-sm px-4" id="sim-next-btn">
                    ${num < total ? '<i class="fa-solid fa-forward me-1"></i>Prossimo Step' : '<i class="fa-solid fa-check me-1"></i>Fine'}
                </button>
            `;

            document.body.appendChild(backdrop);
            document.body.appendChild(popup);

            const close = () => {
                popup.remove();
                backdrop.remove();
                resolve();
            };

            popup.querySelector('#sim-next-btn').addEventListener('click', close);
            backdrop.addEventListener('click', close);
        });
    },

    // Compute horizontal auto-layout positions using BFS from trigger nodes
});


// ── app-funnels-builder.js ──
/** Syrus Sales OS – Funnels & Quotes */
Object.assign(SyrusApp, {

    _autoLayoutPositions(nodes, connections) {
        const GAP_X = 280;
        const GAP_Y = 170;
        const START_X = 60;
        const START_Y = 80;

        // Build adjacency: fromId -> [{toId, outputName}]
        const adj = {};
        const inDegree = {};
        nodes.forEach(nd => { adj[nd.id] = []; inDegree[nd.id] = 0; });
        connections.forEach(c => {
            if (adj[c.from_step_id]) {
                adj[c.from_step_id].push({ to: c.to_step_id, output: c.output_name || 'output_1' });
            }
            if (inDegree[c.to_step_id] !== undefined) inDegree[c.to_step_id]++;
        });

        // Find root nodes (triggers / no incoming connections)
        const roots = nodes.filter(nd => (inDegree[nd.id] || 0) === 0);
        if (roots.length === 0 && nodes.length > 0) roots.push(nodes[0]);

        const positions = {}; // nodeId -> {x, y}
        const visited = new Set();
        const colSlots = {}; // col index -> next available Y slot

        const assignPos = (nodeId, col, row) => {
            if (visited.has(nodeId)) return;
            visited.add(nodeId);

            // Get next available Y for this column to avoid overlap
            if (colSlots[col] === undefined) colSlots[col] = 0;
            const y = Math.max(row, colSlots[col]);
            colSlots[col] = y + 1;

            positions[nodeId] = {
                x: START_X + col * GAP_X,
                y: START_Y + y * GAP_Y,
            };

            // Get children sorted: output_1 (Si) first, output_2 (No) second
            const children = (adj[nodeId] || []).sort((a, b) => {
                if (a.output === 'output_1' && b.output === 'output_2') return -1;
                if (a.output === 'output_2' && b.output === 'output_1') return 1;
                return 0;
            });

            children.forEach((child, idx) => {
                if (visited.has(child.to)) return;
                if (child.output === 'output_2') {
                    // "No" branch: same column + 1, but lower Y
                    assignPos(child.to, col + 1, y + 1);
                } else {
                    // "Si" or default: next column, same Y row
                    assignPos(child.to, col + 1, y);
                }
            });
        };

        // Start BFS from each root
        let rootRow = 0;
        roots.forEach(root => {
            assignPos(root.id, 0, rootRow);
            rootRow = Math.max(rootRow, (colSlots[0] || 0));
        });

        // Place any orphan nodes (not reached by BFS)
        nodes.forEach(nd => {
            if (!positions[nd.id]) {
                const maxCol = Math.max(0, ...Object.values(positions).map(p => Math.round((p.x - START_X) / GAP_X)));
                positions[nd.id] = { x: START_X + (maxCol + 1) * GAP_X, y: START_Y };
            }
        });

        return positions;
    },

    async _loadFunnelFlow(funnelId) {
        try {
            const data = await this.api(`/funnels/api/${funnelId}/flow`);
            document.getElementById('funnel-name').value = data.name || '';
            document.getElementById('funnel-active').checked = data.active !== false;

            const nodes = data.nodes || [];
            const connections = data.connections || [];
            const idMap = {};

            // Check if nodes have saved positions (non-zero, non-default)
            const hasSavedLayout = nodes.some(nd => nd.pos_x && nd.pos_x > 0 && nd.pos_y && nd.pos_y > 0);

            // Compute auto-layout if no saved positions
            const autoPos = hasSavedLayout ? null : this._autoLayoutPositions(nodes, connections);

            nodes.forEach((nd, i) => {
                const key = this._findNodeKey(nd);
                const tpl = this._nodeTemplates[key] || this._nodeTemplates['wait'];
                const html = this._buildNodeHtml({...tpl, label: nd.name || tpl.label});
                const nodeData = {
                    node_type: nd.node_type, action_type: nd.action_type,
                    condition_type: nd.condition_type, action_config: nd.action_config || {},
                    condition_config: nd.condition_config || {}, delay_minutes: nd.delay_minutes || 0,
                    exit_on: nd.exit_on || 'none', name: nd.name || '', step_id: nd.id,
                };

                let posX, posY;
                if (autoPos && autoPos[nd.id]) {
                    posX = autoPos[nd.id].x;
                    posY = autoPos[nd.id].y;
                } else {
                    posX = nd.pos_x || (60 + i * 280);
                    posY = nd.pos_y || 80;
                }

                const newId = this._funnelEditor.addNode(
                    key, tpl.inputs, tpl.outputs,
                    posX, posY,
                    `node-${tpl.color}`, nodeData, html
                );
                idMap[nd.id] = newId;
            });

            connections.forEach(c => {
                const fromId = idMap[c.from_step_id];
                const toId = idMap[c.to_step_id];
                if (fromId && toId) {
                    this._funnelEditor.addConnection(fromId, toId, c.output_name || 'output_1', 'input_1');
                }
            });

            // Color Si/No connections after all are loaded
            setTimeout(() => this._recolorAllConnections(), 200);

            if (funnelId) this._loadBuilderLog(funnelId);
        } catch(e) {
            console.error('Load funnel flow error:', e);
        }
    },

    _findNodeKey(nd) {
        const nt = nd.node_type || 'action';
        if (nt === 'trigger') return `trigger_${nd.action_type || 'manual'}`;
        if (nt === 'condition') {
            const ct = nd.condition_type || 'email_opened';
            for (const [k, v] of Object.entries(this._nodeTemplates)) {
                if (v.conditionType === ct) return k;
            }
            return 'cond_email_opened';
        }
        if (nt === 'wait') return 'wait';
        if (nt === 'exit') return 'exit';
        return nd.action_type || 'wait';
    },

    _showNodeConfig(nodeId) {
        const panel = document.getElementById('node-config');
        const body = document.getElementById('node-config-body');
        if (!panel || !body) return;

        const nodeData = this._funnelEditor.getNodeFromId(nodeId);
        const d = nodeData.data || {};
        const nt = d.node_type || 'action';

        let html = `<div class="mb-3"><label class="form-label">Nome</label>
            <input type="text" class="form-control form-control-sm" id="cfg-name" value="${this._escapeHtml(d.name || '')}"></div>`;

        if (nt === 'action' || nt === 'trigger') {
            if (d.action_type === 'send_email') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Oggetto Email</label>
                    <input type="text" class="form-control form-control-sm" id="cfg-subject" value="${this._escapeHtml(cfg.subject || '')}"></div>`;
                html += `<div class="mb-3"><label class="form-label">Corpo Email (HTML)</label>
                    <textarea class="form-control form-control-sm" id="cfg-body" rows="4">${this._escapeHtml(cfg.body || '')}</textarea></div>`;
                html += `<div class="mb-3"><label class="form-label">Oppure Template</label>
                    <select class="form-select form-select-sm" id="cfg-template">
                        <option value="">-- Personalizzato --</option>
                        <option value="lead_confirmation" ${cfg.template==='lead_confirmation'?'selected':''}>Conferma ricezione</option>
                        <option value="follow_up_1" ${cfg.template==='follow_up_1'?'selected':''}>Follow-up 1</option>
                        <option value="follow_up_2" ${cfg.template==='follow_up_2'?'selected':''}>Follow-up 2</option>
                        <option value="follow_up_final" ${cfg.template==='follow_up_final'?'selected':''}>Follow-up finale</option>
                        <option value="reactivation" ${cfg.template==='reactivation'?'selected':''}>Riattivazione</option>
                    </select></div>`;
            } else if (d.action_type === 'send_sms') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Messaggio SMS</label>
                    <textarea class="form-control form-control-sm" id="cfg-message" rows="3" maxlength="160">${this._escapeHtml(cfg.message || '')}</textarea>
                    <small class="text-muted">Variabili: {contact_name}, {company_name}</small></div>`;
            } else if (d.action_type === 'send_whatsapp') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Numero Mittente</label>
                    <select class="form-select form-select-sm" id="cfg-wa-number">
                        <option value="">Caricamento...</option>
                    </select></div>`;
                html += `<div class="mb-3"><label class="form-label">Template</label>
                    <select class="form-select form-select-sm" id="cfg-wa-template">
                        <option value="">Seleziona numero prima</option>
                    </select></div>`;
                html += `<div class="mb-3"><label class="form-label">Numero Destinatario</label>
                    <input type="text" class="form-control form-control-sm" id="cfg-wa-phone" value="${this._escapeHtml(cfg.phone || '')}" placeholder="+39...">
                    <small class="text-muted">Vuoto = usa telefono della lead</small></div>`;
                html += `<div class="mb-3"><label class="form-label">Variabile 1 <small class="text-muted">(es. nome)</small></label>
                    <input type="text" class="form-control form-control-sm" id="cfg-wa-var1" value="${this._escapeHtml(cfg.var1 || '')}" placeholder="{contact_name}"></div>`;
                html += `<div class="mb-3"><label class="form-label">Variabile 2 <small class="text-muted">(es. data)</small></label>
                    <input type="text" class="form-control form-control-sm" id="cfg-wa-var2" value="${this._escapeHtml(cfg.var2 || '')}" placeholder="{data_appuntamento}"></div>`;
                // Load WA numbers async
                setTimeout(() => this._loadWaNodeConfig(cfg), 100);
            } else if (d.action_type === 'change_status') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Nuovo Status</label>
                    <select class="form-select form-select-sm" id="cfg-status">
                        ${['new','contacted','qualified','proposal_sent','negotiation','won','lost','dormant'].map(s =>
                            `<option value="${s}" ${cfg.new_status===s?'selected':''}>${s}</option>`).join('')}
                    </select></div>`;
            } else if (d.action_type === 'create_task') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Descrizione Task</label>
                    <input type="text" class="form-control form-control-sm" id="cfg-task" value="${this._escapeHtml(cfg.task || '')}"></div>`;
            } else if (d.action_type === 'alert') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Messaggio Alert</label>
                    <input type="text" class="form-control form-control-sm" id="cfg-alert-msg" value="${this._escapeHtml(cfg.message || '')}"></div>
                    <div class="form-check"><input type="checkbox" class="form-check-input" id="cfg-escalate" ${cfg.escalate?'checked':''}>
                    <label class="form-check-label small">Escalation (critico)</label></div>`;
            } else if (d.action_type === 'create_appointment') {
                const cfg = d.action_config || {};
                html += `<div class="mb-3"><label class="form-label">Titolo Appuntamento</label>
                    <input type="text" class="form-control form-control-sm" id="cfg-appt-title" value="${this._escapeHtml(cfg.title || '')}"></div>`;
                html += `<div class="mb-3"><label class="form-label">Giorni da oggi</label>
                    <input type="number" class="form-control form-control-sm" id="cfg-appt-days" value="${cfg.days_from_now || 1}" min="0"></div>`;
            }
        }

        if (nt === 'condition') {
            const cfg = d.condition_config || {};
            if (d.condition_type === 'lead_status_equals') {
                html += `<div class="mb-3"><label class="form-label">Status atteso</label>
                    <select class="form-select form-select-sm" id="cfg-cond-status">
                        ${['new','contacted','qualified','proposal_sent','negotiation','won','lost','dormant'].map(s =>
                            `<option value="${s}" ${cfg.status===s?'selected':''}>${s}</option>`).join('')}
                    </select></div>`;
            } else if (d.condition_type === 'lead_score_gt' || d.condition_type === 'lead_score_lt') {
                html += `<div class="mb-3"><label class="form-label">Soglia Score</label>
                    <input type="number" class="form-control form-control-sm" id="cfg-cond-threshold" value="${cfg.threshold || 50}" min="0" max="100"></div>`;
            } else if (d.condition_type === 'no_response_after_days') {
                html += `<div class="mb-3"><label class="form-label">Giorni senza risposta</label>
                    <input type="number" class="form-control form-control-sm" id="cfg-cond-days" value="${cfg.days || 7}" min="1"></div>`;
            }
        }

        if (nt === 'wait' || nt === 'action') {
            html += `<div class="mb-3"><label class="form-label">Ritardo (minuti)</label>
                <input type="number" class="form-control form-control-sm" id="cfg-delay" value="${d.delay_minutes || 0}" min="0">
                <small class="text-muted">0=immediato, 60=1h, 1440=1g</small></div>`;
        }

        if (nt === 'exit') {
            const cfg = d.action_config || {};
            html += `<div class="mb-3"><label class="form-label">Motivo uscita</label>
                <input type="text" class="form-control form-control-sm" id="cfg-exit-reason" value="${this._escapeHtml(cfg.reason || '')}"></div>`;
        }

        html += `<button class="btn btn-primary btn-sm w-100 mt-2" onclick="SyrusApp._applyNodeConfig(${nodeId})">
            <i class="fa-solid fa-check me-1"></i>Applica</button>`;

        body.innerHTML = html;
        panel.classList.remove('d-none');
    },

    _applyNodeConfig(nodeId) {
        const nodeData = this._funnelEditor.getNodeFromId(nodeId);
        const d = nodeData.data || {};

        d.name = document.getElementById('cfg-name')?.value || d.name;
        d.delay_minutes = parseInt(document.getElementById('cfg-delay')?.value) || 0;

        // Build action_config based on action_type
        if (d.action_type === 'send_email') {
            d.action_config = {
                template: document.getElementById('cfg-template')?.value || '',
                subject: document.getElementById('cfg-subject')?.value || '',
                body: document.getElementById('cfg-body')?.value || '',
            };
        } else if (d.action_type === 'send_sms') {
            d.action_config = { message: document.getElementById('cfg-message')?.value || '' };
        } else if (d.action_type === 'send_whatsapp') {
            d.action_config = {
                phone_number_id: document.getElementById('cfg-wa-number')?.value || '',
                template_name: document.getElementById('cfg-wa-template')?.value || '',
                phone: document.getElementById('cfg-wa-phone')?.value || '',
                var1: document.getElementById('cfg-wa-var1')?.value || '',
                var2: document.getElementById('cfg-wa-var2')?.value || '',
            };
        } else if (d.action_type === 'change_status') {
            d.action_config = { new_status: document.getElementById('cfg-status')?.value || 'dormant' };
        } else if (d.action_type === 'create_task') {
            d.action_config = { task: document.getElementById('cfg-task')?.value || '' };
        } else if (d.action_type === 'alert') {
            d.action_config = { message: document.getElementById('cfg-alert-msg')?.value || '', escalate: document.getElementById('cfg-escalate')?.checked || false };
        } else if (d.action_type === 'create_appointment') {
            d.action_config = { title: document.getElementById('cfg-appt-title')?.value || '', days_from_now: parseInt(document.getElementById('cfg-appt-days')?.value) || 1 };
        } else if (d.action_type === 'exit') {
            d.action_config = { reason: document.getElementById('cfg-exit-reason')?.value || '' };
        }

        // Condition config
        if (d.node_type === 'condition') {
            if (d.condition_type === 'lead_status_equals') {
                d.condition_config = { status: document.getElementById('cfg-cond-status')?.value || '' };
            } else if (d.condition_type === 'lead_score_gt' || d.condition_type === 'lead_score_lt') {
                d.condition_config = { threshold: parseInt(document.getElementById('cfg-cond-threshold')?.value) || 50 };
            } else if (d.condition_type === 'no_response_after_days') {
                d.condition_config = { days: parseInt(document.getElementById('cfg-cond-days')?.value) || 7 };
            }
        }

        this._funnelEditor.updateNodeDataFromId(nodeId, d);

        // Update visual label
        const nodeEl = document.querySelector(`#node-${nodeId} .df-label`);
        if (nodeEl) nodeEl.textContent = d.name;

        this.toast('Configurazione applicata', 'success');
    },

    async _loadWaNodeConfig(cfg) {
        // Load WA numbers for dropdown
        try {
            const numbers = await this.api('/whatsapp/api/numbers');
            const numSel = document.getElementById('cfg-wa-number');
            if (!numSel) return;
            numSel.innerHTML = '<option value="">-- Seleziona numero --</option>';
            (numbers || []).forEach(n => {
                const sel = cfg.phone_number_id === n.phone_number_id ? 'selected' : '';
                const displayName = n.phone_number ? `${n.label || ''} ${n.phone_number}`.trim() : n.phone_number_id;
                numSel.innerHTML += `<option value="${n.phone_number_id}" data-waba="${n.waba_id || ''}" ${sel}>${this._escapeHtml(displayName)}</option>`;
            });
            // When number changes, load templates for that number's WABA
            numSel.addEventListener('change', () => {
                const opt = numSel.selectedOptions[0];
                const wabaId = opt?.dataset?.waba || '';
                if (wabaId) this._loadWaTemplatesForNode(wabaId, cfg.template_name || '');
            });
            // Auto-load templates if number was pre-selected
            if (cfg.phone_number_id) {
                const opt = numSel.querySelector(`option[value="${cfg.phone_number_id}"]`);
                const wabaId = opt?.dataset?.waba || '';
                if (wabaId) this._loadWaTemplatesForNode(wabaId, cfg.template_name || '');
            }
        } catch(e) {
            const numSel = document.getElementById('cfg-wa-number');
            if (numSel) numSel.innerHTML = '<option value="">Errore caricamento numeri</option>';
        }
    },

    async _loadWaTemplatesForNode(wabaId, selectedTemplate) {
        const tplSel = document.getElementById('cfg-wa-template');
        if (!tplSel) return;
        tplSel.innerHTML = '<option value="">Caricamento...</option>';
        try {
            const data = await this.api(`/whatsapp/api/templates/${wabaId}`);
            const templates = data.templates || data || [];
            tplSel.innerHTML = '<option value="">-- Seleziona template --</option>';
            (Array.isArray(templates) ? templates : []).forEach(t => {
                const name = t.name || t.template_name || '';
                const status = t.status || '';
                const sel = name === selectedTemplate ? 'selected' : '';
                tplSel.innerHTML += `<option value="${name}" ${sel}>${this._escapeHtml(name)} ${status === 'APPROVED' ? '✓' : ''}</option>`;
            });
        } catch(e) {
            tplSel.innerHTML = '<option value="">Errore caricamento template</option>';
        }
    },

    async saveFunnelFlow() {
        if (!this._funnelEditor) return;
        const exportData = this._funnelEditor.export();
        const drawflowData = exportData.drawflow?.Home?.data || {};

        const nodes = [];
        const connections = [];

        for (const [nodeId, node] of Object.entries(drawflowData)) {
            const d = node.data || {};
            nodes.push({
                drawflow_id: nodeId,
                id: d.step_id || null,
                node_type: d.node_type || 'action',
                name: d.name || node.name || '',
                action_type: d.action_type || '',
                action_config: d.action_config || {},
                condition_type: d.condition_type || 'none',
                condition_config: d.condition_config || {},
                delay_minutes: d.delay_minutes || 0,
                exit_on: d.exit_on || 'none',
                pos_x: node.pos_x,
                pos_y: node.pos_y,
            });

            for (const [outKey, outData] of Object.entries(node.outputs || {})) {
                for (const conn of (outData.connections || [])) {
                    connections.push({
                        from_drawflow_id: nodeId,
                        to_drawflow_id: conn.node,
                        output_name: outKey,
                    });
                }
            }
        }

        try {
            const resp = await this.api('/funnels/api/save-flow', {
                method: 'POST',
                body: JSON.stringify({
                    funnel_id: this._currentFunnelBuilderId,
                    name: document.getElementById('funnel-name')?.value || 'Nuovo Funnel',
                    description: '',
                    active: document.getElementById('funnel-active')?.checked ?? true,
                    flow_json: JSON.stringify(exportData),
                    nodes, connections,
                }),
            });
            this._currentFunnelBuilderId = resp.funnel_id;
            this.toast('Funnel salvato!', 'success');
            // Update URL without reload
            if (resp.funnel_id) {
                history.replaceState(null, '', `/funnels/builder/${resp.funnel_id}`);
            }
        } catch(e) {
            this.toast('Errore salvataggio: ' + e.message, 'danger');
        }
    },

    async saveFunnelAsTemplate() {
        if (!this._currentFunnelBuilderId) {
            this.toast('Salva prima il funnel', 'warning');
            return;
        }
        const name = prompt('Nome del template:');
        if (!name) return;
        try {
            await this.api('/funnels/api/templates/save', {
                method: 'POST',
                body: JSON.stringify({
                    funnel_id: this._currentFunnelBuilderId,
                    name,
                    description: '',
                    category: 'custom',
                }),
            });
            this.toast('Template salvato!', 'success');
        } catch(e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    toggleFunnelView(view, btn) {
        document.getElementById('view-grafico')?.classList.toggle('d-none', view !== 'grafico');
        document.getElementById('view-analitico')?.classList.toggle('d-none', view !== 'analitico');
        document.querySelectorAll('.nav-pills .nav-link').forEach(b => b.classList.remove('active'));
        if (btn) btn.classList.add('active');
        if (view === 'analitico') this._renderAnalyticView();
    },

    _renderAnalyticView() {
        if (!this._funnelEditor) return;
        const tbody = document.getElementById('analytic-steps');
        if (!tbody) return;
        const exportData = this._funnelEditor.export();
        const drawflowData = exportData.drawflow?.Home?.data || {};
        const typeLabels = {trigger:'Trigger', action:'Azione', condition:'Condizione', wait:'Attesa', exit:'Uscita'};
        const typeColors = {trigger:'success', action:'primary', condition:'warning', wait:'secondary', exit:'danger'};

        let html = '';
        let i = 1;
        for (const [nodeId, node] of Object.entries(drawflowData)) {
            const d = node.data || {};
            const nt = d.node_type || 'action';
            html += `<tr>
                <td>${i++}</td>
                <td><span class="badge bg-${typeColors[nt] || 'secondary'}">${typeLabels[nt] || nt}</span></td>
                <td>${this._escapeHtml(d.name || node.name || '-')}</td>
                <td>${this._escapeHtml(d.action_type || '-')}</td>
                <td>${this._escapeHtml(d.condition_type || '-')}</td>
                <td>${d.delay_minutes ? this._formatDelay(d.delay_minutes) : '-'}</td>
                <td>${this._escapeHtml(d.exit_on || '-')}</td>
            </tr>`;
        }
        tbody.innerHTML = html || '<tr><td colspan="7" class="text-center text-muted">Nessun nodo nel funnel</td></tr>';
    },

    _formatDelay(min) {
        if (min < 60) return `${min} min`;
        if (min < 1440) return `${Math.round(min/60)} ore`;
        return `${Math.round(min/1440)} giorni`;
    },

    async _loadBuilderLog(funnelId) {
        try {
            const logs = await this.api(`/funnels/api/${funnelId}/log`);
            const el = document.getElementById('funnel-exec-log');
            if (!el) return;
            if (!logs.length) { el.innerHTML = '<p class="text-muted small">Nessun log disponibile.</p>'; return; }
            el.innerHTML = `<div class="table-responsive"><table class="table table-sm small">
                <thead><tr><th>Data</th><th>Step</th><th>Azione</th><th>Risultato</th><th>Dettagli</th></tr></thead>
                <tbody>${logs.map(l => `<tr>
                    <td>${this.formatDate(l.executed_at)}</td>
                    <td>${this._escapeHtml(l.step_name || '-')}</td>
                    <td>${this._escapeHtml(l.action || '-')}</td>
                    <td><span class="badge bg-${l.result==='success'?'success':l.result==='failed'?'danger':'secondary'}">${l.result}</span></td>
                    <td>${this._escapeHtml(l.details || '')}</td>
                </tr>`).join('')}</tbody></table></div>`;
        } catch(e) {/* silent */}
    },

});


// ── app-quotes.js ──
/** Syrus Sales OS – Funnels & Quotes */
Object.assign(SyrusApp, {

    // ── Quotes (Preventivi) ─────────────────────────────────────────────────

    _currentQuoteId: null,
    _quoteItems: [],

    async loadQuotes(page = 1) {
        try {
            const data = await this.api(`/quotes/api/list?page=${page}`);
            const tbody = document.getElementById('quotes-table');
            const editor = document.getElementById('quote-editor');
            if (editor) editor.classList.add('d-none');
            if (!data.items.length) {
                tbody.innerHTML = '<tr><td colspan="8" class="text-center text-muted py-4">Nessun preventivo</td></tr>';
            } else {
                const statusBadge = (s) => ({draft:'bg-secondary',sent:'bg-info',viewed:'bg-warning text-dark',accepted:'bg-success',rejected:'bg-danger',expired:'bg-dark'})[s] || 'bg-secondary';
                tbody.innerHTML = data.items.map(q => `<tr>
                    <td><code>${this._escapeHtml(q.quote_number||'-')}</code></td>
                    <td>${this._escapeHtml(q.lead_name||'-')}</td>
                    <td>${this._escapeHtml(q.title||'-')}</td>
                    <td class="text-end fw-bold">&euro; ${(q.amount_gross||0).toLocaleString('it-IT',{minimumFractionDigits:2})}</td>
                    <td><span class="badge ${statusBadge(q.status)}">${q.status}</span></td>
                    <td>${q.open_count ? `<span class="badge bg-warning text-dark">${q.open_count}x</span>` : '-'}</td>
                    <td><small class="text-muted">${this.formatDate(q.created_at)}</small></td>
                    <td class="text-end">
                        <div class="dropdown"><button class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown"><i class="fa-solid fa-ellipsis-vertical"></i></button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <li><a class="dropdown-item" href="#" onclick="SyrusApp.editQuote('${q.id}');return false"><i class="fa-solid fa-pencil me-2"></i>Modifica</a></li>
                            ${q.tracking_token ? `<li><a class="dropdown-item" href="/quotes/view/${q.tracking_token}" target="_blank"><i class="fa-solid fa-eye me-2"></i>Link Pubblico</a></li>` : ''}
                        </ul></div>
                    </td>
                </tr>`).join('');
            }
            document.getElementById('quotes-info').textContent = `${data.total} preventivi – Pag. ${data.page}/${data.pages}`;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    showQuoteEditor(leadId) {
        this._currentQuoteId = null;
        this._quoteItems = [{description:'',quantity:1,unit_price:0,total:0}];
        document.getElementById('quote-editor')?.classList.remove('d-none');
        document.getElementById('qt-title').value = '';
        document.getElementById('qt-lead-id').value = leadId || '';
        document.getElementById('qt-validity').value = '30';
        document.getElementById('qt-payment').value = '50% anticipo alla firma, 50% alla consegna';
        document.getElementById('qt-notes').value = '';
        this._renderQuoteItems();
    },

    async editQuote(quoteId) {
        try {
            const q = await this.api(`/quotes/api/${quoteId}`);
            this._currentQuoteId = quoteId;
            this._quoteItems = q.items || [{description:'',quantity:1,unit_price:0,total:0}];
            document.getElementById('quote-editor')?.classList.remove('d-none');
            document.getElementById('qt-title').value = q.title || '';
            document.getElementById('qt-lead-id').value = q.lead_id || '';
            document.getElementById('qt-payment').value = q.payment_terms || '';
            document.getElementById('qt-notes').value = q.notes || '';
            document.getElementById('qt-vat').value = q.vat_rate || 22;
            this._renderQuoteItems();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    backToQuotesList() {
        document.getElementById('quote-editor')?.classList.add('d-none');
        this.loadQuotes();
    },

    addQuoteItem() {
        this._quoteItems.push({description:'',quantity:1,unit_price:0,total:0});
        this._renderQuoteItems();
    },

    removeQuoteItem(idx) {
        this._quoteItems.splice(idx, 1);
        this._renderQuoteItems();
    },

    recalcQuote() {
        document.querySelectorAll('.qt-row').forEach((row, i) => {
            const qty = parseFloat(row.querySelector('.qt-qty')?.value) || 0;
            const price = parseFloat(row.querySelector('.qt-price')?.value) || 0;
            const total = qty * price;
            this._quoteItems[i] = {...this._quoteItems[i], quantity: qty, unit_price: price, total};
            row.querySelector('.qt-total').textContent = `€ ${total.toLocaleString('it-IT',{minimumFractionDigits:2})}`;
        });
        const net = this._quoteItems.reduce((s, i) => s + (i.total || 0), 0);
        const vatRate = parseFloat(document.getElementById('qt-vat')?.value) || 22;
        const vat = net * vatRate / 100;
        document.getElementById('qt-total-net').textContent = `€ ${net.toLocaleString('it-IT',{minimumFractionDigits:2})}`;
        document.getElementById('qt-total-vat').textContent = `€ ${vat.toLocaleString('it-IT',{minimumFractionDigits:2})}`;
        document.getElementById('qt-total-gross').textContent = `€ ${(net+vat).toLocaleString('it-IT',{minimumFractionDigits:2})}`;
    },

    _renderQuoteItems() {
        const tbody = document.getElementById('qt-items');
        if (!tbody) return;
        tbody.innerHTML = this._quoteItems.map((it, i) => `
            <tr class="qt-row">
                <td><input type="text" class="form-control form-control-sm" value="${it.description||''}" onchange="SyrusApp._quoteItems[${i}].description=this.value"></td>
                <td><input type="number" class="form-control form-control-sm qt-qty" value="${it.quantity||1}" min="0" step="0.5" onchange="SyrusApp.recalcQuote()"></td>
                <td><input type="number" class="form-control form-control-sm qt-price" value="${it.unit_price||0}" min="0" step="50" onchange="SyrusApp.recalcQuote()"></td>
                <td class="qt-total fw-bold">&euro; ${(it.total||0).toLocaleString('it-IT',{minimumFractionDigits:2})}</td>
                <td><button class="btn btn-sm text-danger" onclick="SyrusApp.removeQuoteItem(${i})"><i class="fa-solid fa-xmark"></i></button></td>
            </tr>`).join('');
        this.recalcQuote();
    },

    async saveQuote() {
        const data = {
            title: document.getElementById('qt-title')?.value || '',
            lead_id: document.getElementById('qt-lead-id')?.value || null,
            validity_days: parseInt(document.getElementById('qt-validity')?.value) || 30,
            vat_rate: parseFloat(document.getElementById('qt-vat')?.value) || 22,
            items: this._quoteItems,
            payment_terms: document.getElementById('qt-payment')?.value || '',
            notes: document.getElementById('qt-notes')?.value || '',
        };
        try {
            if (this._currentQuoteId) {
                await this.api(`/quotes/api/${this._currentQuoteId}/update`, {method:'PUT',body:JSON.stringify(data)});
            } else {
                const r = await this.api('/quotes/api/create', {method:'POST',body:JSON.stringify(data)});
                this._currentQuoteId = r.id;
            }
            this.toast('Preventivo salvato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async saveAndSendQuote() {
        await this.saveQuote();
        if (!this._currentQuoteId) return;
        try {
            await this.api(`/quotes/api/${this._currentQuoteId}/send`, {method:'POST'});
            this.toast('Preventivo inviato via email');
        } catch (e) { this.toast(e.message, 'danger'); }
    },
});


// ── app-newsletter.js ──
/** Syrus Sales OS – Newsletter */
Object.assign(SyrusApp, {

    async loadNewsletter() {
        this.nlLoadStats();
        this.nlLoadCampaigns();
        this.nlLoadSubscribers();
    },

    async nlLoadStats() {
        try {
            const s = await this.api('/newsletter/api/subscribers/stats');
            document.getElementById('nl-stat-subscribed').textContent = s.subscribed;
            document.getElementById('nl-stat-with-email').textContent = s.with_email;
            const campaigns = await this.api('/newsletter/api/campaigns');
            document.getElementById('nl-stat-campaigns').textContent = campaigns.filter(c => c.status === 'sent').length;
        } catch (e) { /* silent */ }
    },

    async nlLoadCampaigns() {
        try {
            const campaigns = await this.api('/newsletter/api/campaigns');
            const tbody = document.getElementById('nl-campaigns-table');
            if (!campaigns.length) {
                tbody.innerHTML = '<tr><td colspan="7" class="text-center text-muted py-4">Nessuna campagna</td></tr>';
                return;
            }
            tbody.innerHTML = campaigns.map(c => `<tr>
                <td class="fw-medium">${this._escapeHtml(c.subject || '')}</td>
                <td><span class="badge bg-light text-dark">${c.segment}</span></td>
                <td><span class="badge bg-${c.status==='sent'?'success':c.status==='sending'?'warning':c.status==='draft'?'secondary':'info'}">${c.status}</span></td>
                <td>${c.total_recipients||0}</td>
                <td>${c.total_sent||0}</td>
                <td><small class="text-muted">${this.formatDate(c.sent_at || c.created_at)}</small></td>
                <td class="text-end">
                    ${c.status==='draft' ? `<button class="btn btn-sm btn-primary" onclick="SyrusApp.nlSendCampaign('${c.id}')"><i class="fa-solid fa-paper-plane me-1"></i>Invia</button>` : ''}
                </td>
            </tr>`).join('');
        } catch (e) { /* silent */ }
    },

    async nlLoadSubscribers() {
        try {
            const data = await this.api('/newsletter/api/subscribers');
            const tbody = document.getElementById('nl-subscribers-table');
            if (!data.items.length) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center text-muted py-4">Nessun iscritto alla newsletter</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(s => `<tr>
                    <td>${this._escapeHtml(s.name || '')}</td>
                    <td>${this._escapeHtml(s.email || '')}</td>
                    <td>${(s.tags||[]).map(t => `<span class="badge bg-light text-dark me-1">${t}</span>`).join('')}</td>
                    <td><small class="text-muted">${this.formatDate(s.subscribed_at)}</small></td>
                    <td class="text-end"><button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.nlUnsubscribe('${s.id}')"><i class="fa-solid fa-xmark me-1"></i>Disiscrivi</button></td>
                </tr>`).join('');
            }
        } catch (e) { /* silent */ }
        this.nlLoadAvailable();
    },

    async nlLoadAvailable() {
        try {
            const data = await this.api('/newsletter/api/contacts-available');
            const tbody = document.getElementById('nl-available-table');
            if (!tbody) return;
            if (!data.items.length) {
                tbody.innerHTML = '<tr><td colspan="3" class="text-center text-muted py-4">Tutti i contatti con email sono gia\' iscritti</td></tr>';
                return;
            }
            tbody.innerHTML = data.items.map(c => `<tr>
                <td>${this._escapeHtml(c.name || '')}</td>
                <td>${this._escapeHtml(c.email || '')}</td>
                <td class="text-end"><button class="btn btn-sm btn-outline-success" onclick="SyrusApp.nlSubscribe('${c.id}')"><i class="fa-solid fa-plus me-1"></i>Iscrivi</button></td>
            </tr>`).join('');
        } catch (e) { /* silent */ }
    },

    async nlSubscribe(contactId) {
        try {
            await this.api(`/newsletter/api/subscribe/${contactId}`, {method:'POST', body:JSON.stringify({})});
            this.toast('Contatto iscritto alla newsletter');
            this.nlLoadSubscribers();
            this.nlLoadStats();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async nlSubscribeAll() {
        if (!confirm('Iscrivere tutti i contatti con email alla newsletter?')) return;
        try {
            const r = await this.api('/newsletter/api/subscribe-all', {method:'POST'});
            this.toast(`${r.subscribed || 0} contatti iscritti alla newsletter`);
            this.nlLoadSubscribers();
            this.nlLoadStats();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    showNlCampaignEditor() {
        const html = `<div class="modal fade" id="nlCampaignModal" tabindex="-1"><div class="modal-dialog modal-lg"><div class="modal-content">
            <div class="modal-header"><h5 class="modal-title">Nuova Campagna Newsletter</h5><button class="btn-close" data-bs-dismiss="modal"></button></div>
            <div class="modal-body">
                <div class="mb-3"><label class="form-label fw-bold">Oggetto</label><input type="text" id="nl-subject" class="form-control" placeholder="Oggetto della newsletter..."></div>
                <div class="mb-3"><label class="form-label fw-bold">Segmento</label>
                    <select id="nl-segment" class="form-select"><option value="all">Tutti gli iscritti</option></select></div>
                <div class="mb-3"><label class="form-label fw-bold">Contenuto (HTML)</label>
                    <textarea id="nl-body" class="form-control" rows="10" placeholder="<p>Gentile cliente,</p>..."></textarea></div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-primary" onclick="SyrusApp.nlCreateCampaign()"><i class="fa-solid fa-check me-1"></i>Crea Bozza</button>
            </div>
        </div></div></div>`;
        document.getElementById('modals-container').innerHTML = html;
        const nlEl = document.getElementById('nlCampaignModal');
        (bootstrap.Modal.getInstance(nlEl) || new bootstrap.Modal(nlEl)).show();
    },

    async nlCreateCampaign() {
        try {
            await this.api('/newsletter/api/campaigns', {method:'POST',body:JSON.stringify({
                subject: document.getElementById('nl-subject')?.value,
                body_html: document.getElementById('nl-body')?.value,
                segment: document.getElementById('nl-segment')?.value || 'all',
            })});
            bootstrap.Modal.getInstance(document.getElementById('nlCampaignModal'))?.hide();
            this.toast('Campagna creata come bozza');
            this.nlLoadCampaigns();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async nlSendCampaign(id) {
        if (!confirm('Inviare la newsletter a tutti gli iscritti?')) return;
        try {
            const r = await this.api(`/newsletter/api/campaigns/${id}/send`, {method:'POST'});
            this.toast(r.message || `Newsletter: invio avviato`, 'success');
            this.nlLoadCampaigns();
            this.nlLoadStats();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async nlUnsubscribe(contactId) {
        try {
            await this.api(`/newsletter/api/unsubscribe/${contactId}`, {method:'POST'});
            this.toast('Contatto disiscritto');
            this.nlLoadSubscribers();
            this.nlLoadStats();
        } catch (e) { this.toast(e.message, 'danger'); }
    },
});


// ── app-admin.js ──
/** Syrus Sales OS – Admin (Users, Reports, Settings, SyrusX) */
Object.assign(SyrusApp, {

    // ── User Modal ─────────────────────────────────────────────────────────
    async showUserModal(userId) {
        let user = null;
        if (userId) {
            try {
                const users = await this.api('/settings/api/users');
                user = (users || []).find(u => String(u.id) === String(userId));
                if (!user) { this.toast('Utente non trovato', 'danger'); return; }
            } catch (e) { this.toast(e.message, 'danger'); return; }
        }
        const v = (k, d = '') => this._escapeHtml(user && user[k] != null ? String(user[k]) : d);
        const role = user ? user.role : 'salesperson';
        const active = user ? user.active : true;
        // Utente canonico (identità Hub): niente password/attivazione, solo profilo Sales
        const hubManaged = !!(user && user.managed_by_hub);
        this._showModal(userId ? 'Modifica Utente' : 'Nuovo Utente', `
            <form onsubmit="SyrusApp.saveUser(event, '${userId || ''}')">
                <div class="mb-2"><label class="form-label fw-bold">Email <span class="text-danger">*</span></label>
                    <input name="email" type="email" class="form-control" required placeholder="email@syrus.it" value="${v('email')}" ${userId ? 'readonly' : ''}></div>
                ${hubManaged ? '<div class="alert alert-light border small py-2 mb-2"><i class="fa-solid fa-circle-info me-1"></i>Account gestito dall\'Hub: qui imposti solo ruolo e parametri Sales.</div>' : ''}
                <div class="mb-2"><label class="form-label fw-bold">Nome Completo</label>
                    <input name="display_name" class="form-control" placeholder="Nome Cognome" value="${v('display_name')}"></div>
                ${hubManaged ? '' : `<div class="mb-2"><label class="form-label fw-bold">Password ${userId ? '(lascia vuoto per non cambiare)' : '<span class="text-danger">*</span>'}</label>
                    <input name="password" type="password" class="form-control" ${userId ? '' : 'required'} minlength="8"></div>`}
                <div class="mb-2"><label class="form-label fw-bold">Ruolo</label>
                    <select name="role" class="form-select">
                        <option value="salesperson" ${role === 'salesperson' ? 'selected' : ''}>Salesperson</option>
                        <option value="sales_manager" ${role === 'sales_manager' ? 'selected' : ''}>Sales Manager</option>
                        <option value="admin" ${role === 'admin' ? 'selected' : ''}>Admin</option>
                    </select></div>
                <div class="mb-2"><label class="form-label fw-bold">Telefono</label>
                    <input name="phone" class="form-control" value="${v('phone')}"></div>
                <div class="mb-2"><label class="form-label fw-bold">SLA Primo Contatto (ore)</label>
                    <input name="sla_hours_first_contact" type="number" class="form-control" value="${v('sla_hours_first_contact', '2')}" step="0.5"></div>
                <div class="mb-2"><label class="form-label fw-bold">SLA Preventivo (ore)</label>
                    <input name="sla_hours_quote" type="number" class="form-control" value="${v('sla_hours_quote', '24')}" step="0.5"></div>
                <div class="mb-2"><label class="form-label fw-bold">Target Mensile (€)</label>
                    <input name="monthly_target" type="number" class="form-control" value="${v('monthly_target', '0')}" step="100"></div>
                <div class="form-check form-switch mb-2" ${hubManaged ? 'title="Attivazione gestita dall\'Hub"' : ''}>
                    <input class="form-check-input" type="checkbox" name="active" id="user-active-toggle" value="true" ${active ? 'checked' : ''} ${hubManaged ? 'disabled' : ''}>
                    <label class="form-check-label" for="user-active-toggle">Utente attivo ${hubManaged ? '<span class="text-muted small">(da Hub)</span>' : ''}</label>
                </div>
                <button type="submit" class="btn btn-primary w-100 mt-2"><i class="fa-solid fa-floppy-disk me-1"></i> Salva</button>
            </form>`);
    },

    async saveUser(event, userId) {
        event.preventDefault();
        const fd = new FormData(event.target);
        const data = Object.fromEntries(fd.entries());
        if (userId) data.id = userId;
        if (!data.password) delete data.password;
        // Checkbox: unchecked non finisce in FormData → forziamo false
        data.active = event.target.querySelector('input[name="active"]')?.checked === true;
        try {
            await this.api('/settings/api/users/save', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Utente salvato!', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this.loadUsers();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Reports ─────────────────────────────────────────────────────────────
    _charts: {},

    _delta(val, invert) {
        if (val === null || val === undefined) return '';
        if (val === 0) return '<span class="text-muted"><i class="fa-solid fa-minus me-1"></i>0</span>';
        const positive = invert ? val < 0 : val > 0;
        const icon = val > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
        const color = positive ? 'text-success' : 'text-danger';
        const display = typeof val === 'number' && !Number.isInteger(val) ? Math.abs(val).toFixed(1) : Math.abs(val);
        return `<span class="${color}"><i class="fa-solid ${icon} me-1"></i>${display}</span>`;
    },

    _deltaCurrency(val) {
        if (val === null || val === undefined) return '';
        if (val === 0) return '<span class="text-muted"><i class="fa-solid fa-minus me-1"></i>0</span>';
        const positive = val > 0;
        const icon = val > 0 ? 'fa-arrow-up' : 'fa-arrow-down';
        const color = positive ? 'text-success' : 'text-danger';
        return `<span class="${color}"><i class="fa-solid ${icon} me-1"></i>${this.formatCurrency(Math.abs(val))}</span>`;
    },

    async loadReport(type) {
        try {
            Object.values(this._charts || {}).forEach(c => c.destroy?.());
            this._charts = this._charts || {};

            if (type === 'overview') {
                const qs = this._periodQS ? this._periodQS() : '';
                const [kpi, trend, sources] = await Promise.all([
                    this.api('/reports/api/kpi?' + qs),
                    this.api('/reports/api/trend'),
                    this.api('/reports/api/sources?' + qs),
                ]);

                const el = id => document.getElementById(id);
                el('kpi-total').textContent = kpi.total;
                el('kpi-won').textContent = kpi.won;
                el('kpi-won-value').textContent = kpi.won_value ? this.formatCurrency(kpi.won_value) : '';
                el('kpi-lost').textContent = kpi.lost;
                el('kpi-lost-value').textContent = kpi.lost_value ? this.formatCurrency(kpi.lost_value) : '';
                el('kpi-cr').textContent = kpi.conversion_rate + '%';
                el('kpi-pipeline').textContent = this.formatCurrency(kpi.pipeline_value);
                el('kpi-weighted').textContent = this.formatCurrency(kpi.weighted_pipeline || 0);
                el('kpi-avg-deal').textContent = kpi.avg_deal_size ? this.formatCurrency(kpi.avg_deal_size) : '-';
                el('kpi-lost-total').textContent = this.formatCurrency(kpi.lost_value || 0);

                // Delta vs periodo precedente
                const d = kpi.delta;
                if (d) {
                    el('kpi-total-delta').innerHTML = this._delta(d.total);
                    el('kpi-won-delta').innerHTML = this._delta(d.won);
                    el('kpi-lost-delta').innerHTML = this._delta(d.lost, true);
                    el('kpi-cr-delta').innerHTML = d.conversion_rate !== 0
                        ? this._delta(d.conversion_rate) + ' pp' : '';
                } else {
                    ['kpi-total-delta','kpi-won-delta','kpi-lost-delta','kpi-cr-delta'].forEach(
                        id => { const e = el(id); if (e) e.innerHTML = ''; });
                }

                // Trend chart
                const trendCtx = el('chart-trend');
                if (trendCtx) {
                    this._charts.trend = new Chart(trendCtx, {
                        type: 'bar',
                        data: {
                            labels: trend.trend.map(t => t.label),
                            datasets: [
                                { label: 'Lead', data: trend.trend.map(t => t.leads), backgroundColor: '#3B82F6', borderRadius: 4 },
                                { label: 'Vinti', data: trend.trend.map(t => t.won), backgroundColor: '#10B981', borderRadius: 4 },
                                { label: 'Persi', data: trend.trend.map(t => t.lost), backgroundColor: '#EF4444', borderRadius: 4 },
                            ]
                        },
                        options: { responsive: true, plugins: { legend: { position: 'top' } }, scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } } }
                    });
                }

                // Sources doughnut
                const srcCtx = el('chart-sources');
                if (srcCtx && sources.sources.length) {
                    this._charts.sources = new Chart(srcCtx, {
                        type: 'doughnut',
                        data: {
                            labels: sources.sources.map(s => s.label),
                            datasets: [{ data: sources.sources.map(s => s.total), backgroundColor: ['#3B82F6','#10B981','#F59E0B','#EF4444','#8B5CF6','#06B6D4','#F97316','#94A3B8','#EC4899','#14B8A6'] }]
                        },
                        options: { responsive: true, plugins: { legend: { position: 'bottom' } } }
                    });
                }

                // Sources table
                const stBody = el('sources-table');
                if (stBody) {
                    stBody.innerHTML = sources.sources.map(s => `<tr>
                        <td><span class="fw-medium">${this._escapeHtml(s.label)}</span></td>
                        <td class="text-center">${s.total}</td>
                        <td class="text-center text-success fw-bold">${s.won}</td>
                        <td class="text-center text-danger">${s.lost}</td>
                        <td class="text-end">${this.formatCurrency(s.total_value || 0)}</td>
                        <td class="text-end fw-bold text-success">${this.formatCurrency(s.won_value || 0)}</td>
                        <td class="text-end"><span class="badge ${s.conversion_rate >= 20 ? 'bg-success' : s.conversion_rate >= 10 ? 'bg-warning' : 'bg-secondary'}">${s.conversion_rate}%</span></td>
                    </tr>`).join('') || '<tr><td colspan="7" class="text-center text-muted py-3">Nessun dato</td></tr>';
                }

            } else if (type === 'funnel') {
                const qs = this._periodQS ? this._periodQS() : '';
                const [funnel, velocity] = await Promise.all([
                    this.api('/reports/api/funnel?' + qs),
                    this.api('/reports/api/velocity?' + qs),
                ]);

                // Funnel visual
                const fv = document.getElementById('funnel-visual');
                if (fv) {
                    const maxCount = Math.max(...funnel.funnel.map(f => f.count), 1);
                    const colors = ['#94A3B8','#3B82F6','#8B5CF6','#F59E0B','#F97316','#10B981'];
                    let html = '';
                    funnel.funnel.forEach((f, i) => {
                        const pct = Math.max(Math.round(f.count / maxCount * 100), 8);
                        const pctOfTotal = funnel.total_cohort ? Math.round(f.count / funnel.total_cohort * 100) : 0;
                        const valStr = f.value ? this.formatCurrency(f.value) : '';
                        html += `<div class="d-flex align-items-center mb-2">
                            <div style="width:120px" class="small fw-bold">${f.label}</div>
                            <div class="flex-grow-1 position-relative" style="height:36px">
                                <div style="width:${pct}%;background:${colors[i]};height:100%;border-radius:6px;transition:width .5s" class="d-flex align-items-center px-3">
                                    <span class="fw-bold text-white">${f.count}</span>
                                </div>
                            </div>
                            <div class="ms-2 small text-muted" style="width:50px">${pctOfTotal}%</div>
                            <div class="ms-1 small text-end fw-medium" style="width:100px">${valStr}</div>
                        </div>`;
                    });
                    // Lost, dormant, mai contattati
                    html += `<div class="d-flex flex-wrap gap-2 mt-4 pt-3 border-top">
                        <span class="badge bg-danger"><i class="fa-solid fa-xmark me-1"></i>Persi: ${funnel.lost}${funnel.lost_value ? ' (' + this.formatCurrency(funnel.lost_value) + ')' : ''}</span>
                        <span class="badge bg-secondary"><i class="fa-solid fa-moon me-1"></i>Dormant: ${funnel.dormant}</span>`;
                    if (funnel.all_never_contacted > 0) {
                        html += `<span class="badge bg-warning text-dark"><i class="fa-solid fa-phone-slash me-1"></i>Mai contattati: ${funnel.all_never_contacted}</span>`;
                    }
                    if (funnel.lost_never_contacted > 0) {
                        html += `<span class="badge bg-danger bg-opacity-75"><i class="fa-solid fa-triangle-exclamation me-1"></i>Persi senza contatto: ${funnel.lost_never_contacted}</span>`;
                    }
                    html += `</div>`;
                    fv.innerHTML = html;
                }

                // Velocity stats (enhanced with median + sample size)
                const vs = document.getElementById('velocity-stats');
                if (vs) {
                    const contactLabel = velocity.avg_hours_to_contact > 48
                        ? `${Math.round(velocity.avg_hours_to_contact / 24)} giorni`
                        : `${velocity.avg_hours_to_contact}h`;
                    const medianLabel = velocity.median_hours_to_contact > 48
                        ? `${Math.round(velocity.median_hours_to_contact / 24)} giorni`
                        : `${velocity.median_hours_to_contact}h`;
                    vs.innerHTML = `
                        <div class="mb-4 pb-3 border-bottom">
                            <div class="small text-muted text-uppercase fw-bold mb-1">Tempo medio primo contatto</div>
                            <div class="fs-3 fw-bold text-primary">${contactLabel}</div>
                            <div class="small text-muted">mediana: ${medianLabel} &middot; campione: ${velocity.sample_size_contact} lead</div>
                        </div>
                        <div class="mb-4 pb-3 border-bottom">
                            <div class="small text-muted text-uppercase fw-bold mb-1">Ciclo medio di vendita</div>
                            <div class="fs-3 fw-bold text-warning">${velocity.avg_days_to_close} giorni</div>
                            <div class="small text-muted">mediana: ${velocity.median_days_to_close}gg &middot; campione: ${velocity.sample_size_cycle} lead</div>
                        </div>
                        <div class="pb-3">
                            <div class="small text-muted text-uppercase fw-bold mb-1">SLA Compliance</div>
                            <div class="fs-3 fw-bold ${velocity.sla_compliance >= 80 ? 'text-success' : velocity.sla_compliance >= 50 ? 'text-warning' : 'text-danger'}">${velocity.sla_compliance}%</div>
                            <div class="small text-muted">${velocity.sla_ok}/${velocity.total_with_sla} entro SLA</div>
                        </div>`;
                }

                // Conversion rates (new section)
                const crEl = document.getElementById('conversion-rates');
                if (crEl && funnel.conversion_rates) {
                    const crColors = ['#94A3B8','#3B82F6','#8B5CF6','#F59E0B','#F97316','#10B981'];
                    let crHtml = '<div class="row g-3">';
                    funnel.conversion_rates.forEach((cr, i) => {
                        const barWidth = Math.max(cr.pct_of_total, 3);
                        crHtml += `<div class="col-xl-2 col-md-4 col-6">
                            <div class="text-center">
                                <div class="small fw-bold mb-1">${cr.label}</div>
                                <div class="fs-4 fw-bold" style="color:${crColors[i]}">${cr.reached}</div>
                                <div class="progress my-2" style="height:8px;border-radius:999px">
                                    <div class="progress-bar" style="width:${barWidth}%;background:${crColors[i]}"></div>
                                </div>
                                <div class="small text-muted">${cr.pct_of_total}% del totale</div>
                                ${cr.step_rate !== null ? `<div class="small fw-medium">${cr.step_rate}% dallo stadio prec.</div>` : ''}
                            </div>
                        </div>`;
                    });
                    crHtml += '</div>';
                    crEl.innerHTML = crHtml;
                }

            } else if (type === 'analysis') {
                const qs = this._periodQS ? this._periodQS() : '';
                const data = await this.api('/reports/api/lost_analysis?' + qs);
                const el = id => document.getElementById(id);

                // Summary cards
                el('la-total').textContent = data.total_lost;
                el('la-value').textContent = this.formatCurrency(data.total_lost_value);
                el('la-never').textContent = data.never_contacted;
                el('la-never-pct').textContent = data.never_contacted_pct ? data.never_contacted_pct + '% dei persi' : '';
                el('la-avg').textContent = data.total_lost > 0
                    ? this.formatCurrency(Math.round(data.total_lost_value / data.total_lost)) : '-';

                // Time buckets chart
                const timeCtx = el('chart-lost-time');
                if (timeCtx && data.time_buckets.length) {
                    this._charts.lostTime = new Chart(timeCtx, {
                        type: 'bar',
                        data: {
                            labels: data.time_buckets.map(b => b.label),
                            datasets: [
                                { label: 'Lead persi', data: data.time_buckets.map(b => b.count), backgroundColor: '#EF4444', borderRadius: 4 },
                            ]
                        },
                        options: {
                            responsive: true, indexAxis: 'y',
                            plugins: {
                                legend: { display: false },
                                tooltip: { callbacks: { afterLabel: (ctx) => {
                                    const v = data.time_buckets[ctx.dataIndex].value;
                                    return v ? 'Valore: ' + this.formatCurrency(v) : '';
                                }}}
                            },
                            scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } }
                        }
                    });
                }

                // By source chart
                const srcCtx = el('chart-lost-source');
                if (srcCtx && data.by_source.length) {
                    this._charts.lostSource = new Chart(srcCtx, {
                        type: 'bar',
                        data: {
                            labels: data.by_source.map(s => s.source),
                            datasets: [
                                { label: 'Lead persi', data: data.by_source.map(s => s.count), backgroundColor: '#F97316', borderRadius: 4 },
                            ]
                        },
                        options: {
                            responsive: true, indexAxis: 'y',
                            plugins: {
                                legend: { display: false },
                                tooltip: { callbacks: { afterLabel: (ctx) => {
                                    const v = data.by_source[ctx.dataIndex].value;
                                    return v ? 'Valore: ' + this.formatCurrency(v) : '';
                                }}}
                            },
                            scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } }
                        }
                    });
                }

                // Lost reasons table
                const reasonsTb = el('lost-reasons-table');
                if (reasonsTb) {
                    reasonsTb.innerHTML = data.by_reason.map(r => {
                        const pct = data.total_lost ? Math.round(r.count / data.total_lost * 100) : 0;
                        return `<tr>
                            <td class="fw-medium">${this._escapeHtml(r.reason)}</td>
                            <td class="text-center">${r.count}</td>
                            <td class="text-end">${r.value ? this.formatCurrency(r.value) : '-'}</td>
                            <td class="text-end"><span class="badge bg-secondary">${pct}%</span></td>
                        </tr>`;
                    }).join('') || '<tr><td colspan="4" class="text-center text-muted py-3">Nessun dato</td></tr>';
                }

                // Lost trend chart
                const trendCtx = el('chart-lost-trend');
                if (trendCtx && data.lost_trend.length) {
                    this._charts.lostTrend = new Chart(trendCtx, {
                        type: 'line',
                        data: {
                            labels: data.lost_trend.map(t => t.label),
                            datasets: [{
                                label: 'Lead persi',
                                data: data.lost_trend.map(t => t.count),
                                borderColor: '#EF4444', backgroundColor: 'rgba(239,68,68,0.1)',
                                fill: true, tension: 0.3, pointRadius: 4,
                            }]
                        },
                        options: {
                            responsive: true,
                            plugins: { legend: { display: false } },
                            scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } }
                        }
                    });
                }

            } else if (type === 'activity') {
                const data = await this.api('/reports/api/activity');
                const chCtx = document.getElementById('chart-activity-channel');
                if (chCtx) {
                    const labels = {'phone':'Telefono','email':'Email','whatsapp':'WhatsApp','sms':'SMS','meeting':'Meeting','video_call':'Video Call'};
                    const channelColors = {'phone':'#3B82F6','email':'#10B981','whatsapp':'#25D366','sms':'#F59E0B','meeting':'#8B5CF6','video_call':'#06B6D4'};
                    const keys = Object.keys(data.channel_counts);
                    this._charts.channel = new Chart(chCtx, {
                        type: 'bar',
                        data: {
                            labels: keys.map(k => labels[k] || k),
                            datasets: [{
                                label: 'Interazioni',
                                data: keys.map(k => data.channel_counts[k]),
                                backgroundColor: keys.map(k => channelColors[k] || '#94A3B8'),
                                borderRadius: 4
                            }]
                        },
                        options: { responsive: true, indexAxis: 'y', plugins: { legend: { display: false } }, scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } } }
                    });
                }

                // Weekly trend chart
                const wCtx = document.getElementById('chart-weekly-trend');
                if (wCtx && data.weekly_trend) {
                    this._charts.weekly = new Chart(wCtx, {
                        type: 'bar',
                        data: {
                            labels: data.weekly_trend.map(w => w.label),
                            datasets: [{ label: 'Interazioni', data: data.weekly_trend.map(w => w.count), backgroundColor: '#3B82F6', borderRadius: 4 }]
                        },
                        options: { responsive: true, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } } }
                    });
                }

                const topEl = document.getElementById('activity-top-leads');
                if (topEl) {
                    topEl.innerHTML = data.top_leads.map(l =>
                        `<a href="/leads/${l.id}" class="d-flex justify-content-between align-items-center border-bottom py-2 text-decoration-none">
                            <div><code class="me-1">${this._escapeHtml(l.crm_id||'')}</code><span class="fw-medium">${this._escapeHtml(l.company||'')}</span></div>
                            <span class="badge bg-primary">${l.activity}</span>
                        </a>`).join('') || '<p class="text-muted text-center py-3">Nessun dato</p>';
                }

            } else if (type === 'ads') {
                const monthEl = document.getElementById('ads-month');
                if (monthEl && !monthEl.value) monthEl.value = new Date().toISOString().slice(0,7);
                const month = monthEl?.value || new Date().toISOString().slice(0,7);
                const data = await this.api(`/reports/api/ads?month=${month}`);
                const tbody = document.getElementById('ads-table');
                if (tbody) {
                    tbody.innerHTML = data.campaigns.map(c => `<tr>
                        <td class="fw-medium">${this._escapeHtml(c.name)}</td>
                        <td class="text-center">${(c.impressions||0).toLocaleString()}</td>
                        <td class="text-center">${(c.clicks||0).toLocaleString()}</td>
                        <td class="text-center">${this.formatCurrency(c.cost_eur||0)}</td>
                        <td class="text-center">${c.leads_generated||0}</td>
                        <td class="text-center">${c.leads_qualified||0}</td>
                        <td class="text-center fw-bold text-success">${c.deals_won||0}</td>
                        <td class="text-center">${this.formatCurrency(c.revenue_won||0)}</td>
                        <td class="text-end"><span class="badge ${(c.roi_percentage||0)>0?'bg-success':'bg-danger'}">${c.roi_percentage||0}%</span></td>
                    </tr>`).join('') || '<tr><td colspan="9" class="text-center text-muted py-4">Nessuna campagna per questo mese</td></tr>';
                }

            } else if (type === 'scorecard') {
                const data = await this.api('/reports/api/scorecard');
                const el = id => document.getElementById(id);
                el('sc-score').textContent = data.score;
                el('sc-sla').textContent = data.sla_rate + '%';
                el('sc-sla-bar').style.width = data.sla_rate + '%';
                el('sc-contact').textContent = data.contact_rate + '%';
                el('sc-contact-bar').style.width = data.contact_rate + '%';
                el('sc-proposal').textContent = data.proposal_rate + '%';
                el('sc-proposal-bar').style.width = data.proposal_rate + '%';
                el('sc-conversion').textContent = data.conversion_rate + '%';
                el('sc-conversion-bar').style.width = data.conversion_rate + '%';

                const sum = el('sc-summary');
                if (sum) {
                    sum.innerHTML = `<div class="small text-muted mt-2">${data.total_leads} lead &middot; ${data.won} vinti &middot; ${data.proposals} proposte</div>`;
                }

                const sel = el('sc-user-selector');
                if (sel && data.users && data.users.length > 1) {
                    sel.innerHTML = `<select class="form-select form-select-sm" onchange="SyrusApp.loadReport('scorecard','&user_id='+this.value)">
                        ${data.users.map(u => `<option value="${u.id}" ${u.id===data.user.id?'selected':''}>${this._escapeHtml(u.name)}</option>`).join('')}
                    </select>`;
                } else if (sel) {
                    sel.innerHTML = `<div class="fw-bold">${this._escapeHtml(data.user.display_name||data.user.email)}</div>`;
                }
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Settings ────────────────────────────────────────────────────────────
    async loadUsers() {
        try {
            const users = await this.api('/settings/api/users');
            const tbody = document.getElementById('users-table');
            tbody.innerHTML = users.map(u => `
                <tr>
                    <td>${this._escapeHtml(u.display_name || '-')}</td>
                    <td>${this._escapeHtml(u.email || '')}<br><span class="badge bg-secondary">${this._escapeHtml(u.role || '')}</span></td>
                    <td class="text-center">${u.active ? '<i class="fa-solid fa-circle-check text-success"></i>' : '<i class="fa-solid fa-circle-xmark text-danger"></i>'}</td>
                    <td>${u.sla_hours_first_contact}h</td>
                    <td>${this.formatDate(u.last_login)}</td>
                    <td class="text-end"><button class="btn btn-sm btn-outline-primary" onclick="SyrusApp.showUserModal('${u.id}')"><i class="fa-solid fa-pencil"></i></button></td>
                </tr>`).join('');
        } catch (e) { /* silent for non-admin */ }
    },

    async loadConfig() {
        try {
            const cfg = await this.api('/settings/api/config');

            // Merge SyrusVox defaults (from env/config.py) for empty fields
            try {
                const sip = await this.api('/settings/api/sip-config');
                if (sip.domain && !cfg.SIP_DOMAIN) cfg.SIP_DOMAIN = sip.domain;
                if (sip.wssUrl && !cfg.SIP_WSS_URL) cfg.SIP_WSS_URL = sip.wssUrl;
                if (sip.extension && !cfg.SIP_EXTENSION) cfg.SIP_EXTENSION = sip.extension;
                if (sip.password && !cfg.SIP_PASSWORD) cfg.SIP_PASSWORD = sip.password;
                if (sip.webhookToken && !cfg.PBX_WEBHOOK_TOKEN) cfg.PBX_WEBHOOK_TOKEN = sip.webhookToken;
            } catch (e) { /* sip-config may fail for non-admin */ }

            Object.entries(cfg).forEach(([k, v]) => {
                const el = document.querySelector(`[name="${k}"]`);
                if (!el) return;
                if (el.type === 'checkbox') {
                    el.checked = ['true', '1', 'yes', 'si'].includes((v || '').toLowerCase());
                    el.value = el.checked ? 'true' : 'false';
                } else {
                    el.value = v;
                }
            });
        } catch (e) { /* silent */ }
    },

    async saveConfig(event) {
        event.preventDefault();
        const form = event.target;
        const fd = new FormData(form);
        const data = Object.fromEntries(fd.entries());
        form.querySelectorAll('input[type="checkbox"][name]').forEach(el => {
            data[el.name] = el.checked ? 'true' : 'false';
        });
        try {
            await this.api('/settings/api/config/save', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Configurazione salvata');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadDemoData() {
        try {
            const r = await this.api('/settings/api/demo/load', { method: 'POST' });
            document.getElementById('demo-result').innerHTML = `<div class="alert alert-success">${r.loaded} lead demo caricati</div>`;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async clearDemoData() {
        try {
            const r = await this.api('/settings/api/demo/clear', { method: 'POST' });
            document.getElementById('demo-result').innerHTML = `<div class="alert alert-warning">${r.cleared} lead demo cancellati</div>`;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async purgeLeadsData() {
        const out = document.getElementById('purge-result');
        const confirm1 = confirm(
            'Sei sicuro di voler cancellare TUTTE le lead e i dati collegati?\n\n' +
            'Verranno preservate le trascrizioni (scollegate) e WhatsApp.\n' +
            'Verrà creato automaticamente un backup ripristinabile.'
        );
        if (!confirm1) return;
        const typed = prompt('Per confermare scrivi RESET (in maiuscolo):');
        if ((typed || '').trim() !== 'RESET') {
            this.toast('Annullato: conferma non valida', 'warning');
            return;
        }
        out.innerHTML = '<div class="text-muted"><i class="fa-solid fa-spinner fa-spin me-2"></i>Backup in corso e cancellazione dati...</div>';
        try {
            const r = await this.api('/settings/api/maintenance/purge-leads', {
                method: 'POST',
                body: JSON.stringify({ confirm: 'RESET' })
            });
            const rows = Object.entries(r.deleted || {})
                .filter(([, n]) => n > 0)
                .map(([t, n]) => `<li><code>${this._escapeHtml(t)}</code>: ${n}</li>`)
                .join('');
            out.innerHTML = `<div class="alert alert-success">
                <strong>Reset completato.</strong> Backup creato: <code>${this._escapeHtml(r.backup)}</code><br>
                Righe cancellate: <strong>${r.total_rows_deleted}</strong>
                ${rows ? `<ul class="mb-0 mt-2 small">${rows}</ul>` : ''}
            </div>`;
            this.loadBackups();
        } catch (e) {
            out.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`;
        }
    },

    async loadBackups() {
        const list = document.getElementById('backups-list');
        if (!list) return;
        list.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-2"></i>Caricamento…';
        try {
            const r = await this.api('/settings/api/maintenance/backups');
            if (!r.backups || r.backups.length === 0) {
                list.innerHTML = '<div class="text-muted">Nessun backup disponibile.</div>';
                return;
            }
            const rows = r.backups.map(b => {
                const sizeKb = (b.size_bytes / 1024).toFixed(1);
                const created = b.created_at.replace('T', ' ');
                return `<tr>
                    <td><code>${this._escapeHtml(b.filename)}</code></td>
                    <td class="text-muted small">${this._escapeHtml(created)}</td>
                    <td class="text-muted small">${sizeKb} KB</td>
                    <td class="text-end">
                        <button class="btn btn-sm btn-outline-primary"
                                onclick="SyrusApp.restoreBackup('${this._escapeHtml(b.filename)}')">
                            <i class="fa-solid fa-clock-rotate-left me-1"></i> Ripristina
                        </button>
                    </td>
                </tr>`;
            }).join('');
            list.innerHTML = `<div class="table-responsive"><table class="table table-sm align-middle mb-0">
                <thead><tr><th>File</th><th>Creato</th><th>Dimensione</th><th></th></tr></thead>
                <tbody>${rows}</tbody>
            </table></div>`;
        } catch (e) {
            list.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`;
        }
    },

    async restoreBackup(filename) {
        if (!confirm(
            `Ripristinare il backup "${filename}"?\n\n` +
            `Le tabelle lead-related verranno svuotate e ripopolate dal backup. ` +
            `Le trascrizioni esistenti verranno ricollegate. WhatsApp e config restano invariati.`
        )) return;
        try {
            const r = await this.api('/settings/api/maintenance/restore-leads', {
                method: 'POST',
                body: JSON.stringify({ filename })
            });
            this.toast(`Ripristino completato: ${r.total_rows_restored} righe ripristinate`, 'success');
            const out = document.getElementById('purge-result');
            if (out) {
                out.innerHTML = `<div class="alert alert-info">
                    Ripristinato da <code>${this._escapeHtml(r.restored_from)}</code> —
                    <strong>${r.total_rows_restored}</strong> righe ripristinate.
                </div>`;
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async createScenarioLeads() {
        if (!confirm('Creare 2 lead demo con comunicazioni e trascrizioni simulate?')) return;
        try {
            const r = await this.api('/settings/api/demo/create-scenario-leads', { method: 'POST' });
            if (r.ok) {
                const links = r.leads.map(l => `<a href="/leads/${l.id}">${this._escapeHtml(l.name)}</a> (${l.crm_id})`).join('<br>');
                document.getElementById('demo-result').innerHTML = `<div class="alert alert-success">
                    <strong>2 lead scenario create!</strong><br>${links}<br>
                    <small class="text-muted">Ogni lead ha email, telefonate e trascrizioni simulate. Vai nella lead e genera i documenti dal tab AI.</small>
                </div>`;
            } else {
                this.toast(r.error || 'Errore', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async loadSchedulerStatus() {
        try {
            const data = await this.api('/settings/api/scheduler/status');
            const el = document.getElementById('scheduler-status');
            if (!el) return;
            if (!data.running) {
                const mode = data.enabled
                    ? 'Configurato ma non avviato nel processo corrente'
                    : 'Disabilitato';
                el.innerHTML = `<div class="alert alert-warning"><i class="fa-solid fa-pause me-2"></i>Scheduler non attivo<br><small>${mode}${data.role ? ` · ruolo: ${this._escapeHtml(data.role)}` : ''}</small></div>`;
                return;
            }
            el.innerHTML = `
                <div class="alert alert-success mb-3"><i class="fa-solid fa-circle-play me-2"></i>Scheduler attivo — ${data.jobs.length} job configurati<br><small>Ruolo processo: ${this._escapeHtml(data.role || 'N/D')}</small></div>
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr><th>Job</th><th>Trigger</th><th>Prossima esecuzione</th></tr>
                        </thead>
                        <tbody>
                            ${data.jobs.map(j => `<tr>
                                <td><strong>${j.id}</strong></td>
                                <td><code>${j.trigger}</code></td>
                                <td>${j.next_run ? this.formatDate(j.next_run) : 'N/D'}</td>
                            </tr>`).join('')}
                        </tbody>
                    </table>
                </div>`;
        } catch (e) {
            const el = document.getElementById('scheduler-status');
            if (el) el.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message || '')}</div>`;
        }
    },

    async loadAiSettings() {
        // Load CLI status in settings page
        try {
            const status = await this.api('/ai/api/cli-status');
            const el = document.getElementById('settings-cli-status');
            if (!el) return;
            el.innerHTML = Object.entries(status).map(([name, info]) =>
                `<div class="d-inline-flex align-items-center gap-2 me-4 mb-2">
                    <span class="badge ${info.available ? 'bg-success' : 'bg-danger'}">${name}</span>
                    <small class="text-muted">${info.version || 'Non trovato'}</small>
                </div>`
            ).join('');
        } catch (e) { /* silent */ }

        // Load prompt templates
        try {
            const prompts = await this.api('/ai/api/prompts');
            for (const [type, text] of Object.entries(prompts)) {
                const el = document.getElementById(`prompt-tpl-${type}`);
                if (el && text) el.value = text;
            }
        } catch (e) { /* silent */ }
    },

    async saveAiPrompts() {
        const data = {};
        for (const type of ['analysis', 'presentation', 'quote']) {
            const el = document.getElementById(`prompt-tpl-${type}`);
            if (el && el.value.trim()) data[type] = el.value;
        }
        try {
            await this.api('/ai/api/prompts/save', { method: 'POST', body: JSON.stringify(data) });
            this.toast('Prompt template salvati');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── SyrusX Import ──────────────────────────────────────────────────────
    async loadSyrusxAutoSync() {
        try {
            const data = await this.api('/settings/api/syrusx/auto-sync');
            const toggle = document.getElementById('syrusx-auto-sync-toggle');
            const status = document.getElementById('syrusx-auto-sync-status');
            if (toggle) toggle.checked = data.enabled;
            if (status) status.textContent = data.enabled
                ? 'Attiva — le nuove lead vengono importate ogni ora'
                : 'Disattivata';
        } catch (e) { /* silent */ }
    },

    async toggleSyrusxAutoSync(enabled) {
        try {
            await this.api('/settings/api/syrusx/auto-sync', {
                method: 'POST',
                body: JSON.stringify({ enabled }),
            });
            const status = document.getElementById('syrusx-auto-sync-status');
            if (status) status.textContent = enabled
                ? 'Attiva — le nuove lead vengono importate ogni ora'
                : 'Disattivata';
            this.toast(enabled ? 'Sync automatico attivato' : 'Sync automatico disattivato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async syrusxImport() {
        if (!confirm('Importare TUTTE le lead da SyrusX? Le lead già presenti verranno saltate.')) return;
        await this._syrusxRun('/settings/api/syrusx/import');
    },

    async syrusxSync() {
        await this._syrusxRun('/settings/api/syrusx/sync');
    },

    async _syrusxRun(url) {
        const prog = document.getElementById('syrusx-progress');
        const result = document.getElementById('syrusx-result');
        const btnImport = document.getElementById('btn-syrusx-import');
        const btnSync = document.getElementById('btn-syrusx-sync');

        prog.classList.remove('d-none');
        result.innerHTML = '';
        if (btnImport) btnImport.disabled = true;
        if (btnSync) btnSync.disabled = true;

        try {
            const resp = await SyrusApp.fetchWithCsrf(url, { method: 'POST' });
            const data = await resp.json();

            prog.classList.add('d-none');
            if (btnImport) btnImport.disabled = false;
            if (btnSync) btnSync.disabled = false;

            if (data.error) {
                result.innerHTML = `<div class="alert alert-danger"><i class="fa-solid fa-circle-xmark me-2"></i>${this._escapeHtml(data.error || '')}</div>`;
                return;
            }

            document.getElementById('syrusx-stat-total').textContent = data.total || 0;
            document.getElementById('syrusx-stat-imported').textContent = data.imported || 0;
            document.getElementById('syrusx-stat-calls').textContent = data.calls || 0;
            document.getElementById('syrusx-stat-emails').textContent = data.emails || 0;
            document.getElementById('syrusx-stat-skipped').textContent = data.skipped || 0;

            const errHtml = data.errors > 0
                ? `<br><span class="text-danger">${data.errors} errori durante l'importazione</span>`
                : '';

            result.innerHTML = `<div class="alert alert-success">
                <i class="fa-solid fa-circle-check me-2"></i>
                <strong>${data.imported}</strong> lead importate,
                <strong>${data.calls || 0}</strong> telefonate,
                <strong>${data.emails || 0}</strong> email,
                <strong>${data.activities || 0}</strong> attività,
                <strong>${data.contacts || 0}</strong> contatti,
                <strong>${data.skipped}</strong> già presenti (su ${data.total} totali).
                ${errHtml}
            </div>`;
        } catch (e) {
            prog.classList.add('d-none');
            if (btnImport) btnImport.disabled = false;
            if (btnSync) btnSync.disabled = false;
            result.innerHTML = `<div class="alert alert-danger"><i class="fa-solid fa-circle-xmark me-2"></i>Errore di rete: ${this._escapeHtml(e.message || '')}</div>`;
        }
    },

    // ── SyrusVox Connection Test ──────────────────────────────────────────
    async testSyrusVoxConnection() {
        const sipEl = document.getElementById('svox-sip-status');
        const whEl = document.getElementById('svox-webhook-status');
        sipEl.className = 'badge bg-warning text-dark';
        sipEl.textContent = 'SIP: testing...';
        whEl.className = 'badge bg-warning text-dark';
        whEl.textContent = 'Webhook: testing...';

        // Test SIP config
        try {
            const cfg = await this.api('/settings/api/sip-config');
            if (cfg.wssUrl && cfg.domain && cfg.extension && cfg.password) {
                sipEl.className = 'badge bg-success';
                sipEl.textContent = `SIP: ${cfg.extension}@${cfg.domain}`;
            } else {
                sipEl.className = 'badge bg-danger';
                sipEl.textContent = 'SIP: config incompleta';
            }
        } catch (e) {
            sipEl.className = 'badge bg-danger';
            sipEl.textContent = 'SIP: errore';
        }

        // Test webphone connection status
        if (this._wpConnected) {
            sipEl.className = 'badge bg-success';
            sipEl.textContent += ' (connesso)';
        }

        // Webhook status (check if calls exist)
        try {
            const data = await this.api('/communications/api/pbx-calls?per_page=1');
            if (data.total > 0) {
                whEl.className = 'badge bg-success';
                whEl.textContent = `Webhook: attivo (${data.total} chiamate)`;
            } else {
                whEl.className = 'badge bg-secondary';
                whEl.textContent = 'Webhook: nessuna chiamata';
            }
        } catch (e) {
            whEl.className = 'badge bg-danger';
            whEl.textContent = 'Webhook: errore';
        }
    },

    // ── Drive (multi-provider) ──────────────────────────────────────────────
    selectDriveProvider(provider) {
        // Highlight selected card
        document.querySelectorAll('.provider-card').forEach(c => {
            c.classList.remove('border-primary');
            c.style.opacity = '0.6';
        });
        const selected = document.getElementById('provider-' + provider.replace('_', '-'));
        if (selected) {
            selected.classList.add('border-primary');
            selected.style.opacity = '1';
        }
        // Show matching config panel
        document.querySelectorAll('.drive-config-panel').forEach(p => p.classList.add('d-none'));
        const configId = 'config-' + provider.replace('_', '-');
        const panel = document.getElementById(configId);
        if (panel) panel.classList.remove('d-none');
        // Save selection
        this._currentDriveProvider = provider;

        // Wire up SA file upload listener
        if (provider === 'google_workspace') {
            const fileInput = document.getElementById('workspace-sa-file');
            if (fileInput && !fileInput._wired) {
                fileInput._wired = true;
                fileInput.addEventListener('change', (e) => {
                    const file = e.target.files[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = (ev) => {
                        try {
                            const json = JSON.parse(ev.target.result);
                            this._workspaceSaJson = ev.target.result;
                            const email = json.client_email || '?';
                            // Show detected SA email + instructions
                            document.getElementById('workspace-sa-detected')?.classList.remove('d-none');
                            const emailDisplay = document.getElementById('workspace-sa-email-display');
                            const emailCopy = document.getElementById('workspace-sa-email-copy');
                            if (emailDisplay) emailDisplay.textContent = email;
                            if (emailCopy) emailCopy.textContent = email;
                            this.toast('Service Account rilevato: ' + email, 'success');
                        } catch (err) {
                            this.toast('File JSON non valido', 'danger');
                        }
                    };
                    reader.readAsText(file);
                });
            }
        }
    },

    _workspaceSaJson: null,

    async saveDriveWorkspace() {
        const saJson = this._workspaceSaJson;
        let sharedDriveId = document.getElementById('workspace-shared-drive-id')?.value?.trim() || '';
        const domain = document.getElementById('workspace-domain')?.value?.trim();
        if (!saJson) { this.toast('Carica prima il file JSON del Service Account', 'danger'); return; }
        // Estrai ID dall'URL se necessario
        if (sharedDriveId.includes('drive.google.com')) {
            sharedDriveId = sharedDriveId.replace(/\/$/, '').split('/').pop();
        }
        try {
            const result = await this.api('/settings/api/gdrive/workspace-setup', {
                method: 'POST',
                body: JSON.stringify({sa_json: saJson, shared_drive_id: sharedDriveId, domain}),
            });
            const el = document.getElementById('workspace-test-result');
            if (result.ok) {
                if (el) el.innerHTML = `<div class="alert alert-success small"><i class="fa-solid fa-check-circle me-2"></i>${this._escapeHtml(result.message)}${result.sa_email ? '<br>Service Account: <code>' + this._escapeHtml(result.sa_email) + '</code>' : ''}</div>`;
                this.toast('Workspace configurato!', 'success');
                this.loadGDriveStatus();
            } else {
                if (el) el.innerHTML = `<div class="alert alert-danger small"><i class="fa-solid fa-circle-xmark me-2"></i>${this._escapeHtml(result.message || result.error || 'Errore')}</div>`;
                this.toast(result.error || result.message || 'Errore', 'danger');
            }
        } catch (e) {
            const el = document.getElementById('workspace-test-result');
            if (el) el.innerHTML = `<div class="alert alert-danger small">${this._escapeHtml(e.message)}</div>`;
            this.toast(e.message, 'danger');
        }
    },

    async loadGDriveStatus() {
        const el = document.getElementById('gdrive-status');
        if (!el) return;
        try {
            const s = await this.api('/settings/api/gdrive/status');
            const ok = s.credentials_working;
            const statusClass = ok ? 'alert-success' : 'alert-danger';
            const statusIcon = ok ? 'fa-circle-check' : 'fa-circle-exclamation';
            const providerLabel = s.provider_display || s.provider || '?';
            let statusText;
            if (ok) {
                statusText = `${providerLabel} connesso e funzionante`;
            } else if (s.credentials_error) {
                statusText = `Errore: ${this._escapeHtml(s.credentials_error).slice(0, 200)}`;
            } else {
                statusText = 'Non configurato';
            }

            el.innerHTML = `
                <div class="alert ${statusClass} d-flex align-items-start gap-2">
                    <i class="fa-solid ${statusIcon} mt-1 fs-5"></i>
                    <div>
                        <div class="fw-bold">${statusText}</div>
                        <small class="text-muted">Provider: ${this._escapeHtml(providerLabel)}</small>
                        ${s.details ? `<br><small class="text-muted">${this._escapeHtml(s.details)}</small>` : ''}
                    </div>
                </div>`;

            // Auto-select the active provider in the UI
            if (s.provider) this.selectDriveProvider(s.provider);
        } catch (e) {
            el.innerHTML = `<div class="alert alert-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    // ── Cron / Scheduler ─────────────────────────────────────────────────────
    async loadCronJobs() {
        const el = document.getElementById('cron-jobs-list');
        if (!el) return;
        try {
            const data = await this.api('/settings/api/scheduler/jobs');
            const jobs = data.jobs || [];

            let html = '';
            if (!data.scheduler_active) {
                html += `<div class="alert alert-warning py-2 mb-3 small d-flex align-items-center gap-2">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <div><strong>Scheduler non attivo.</strong> Imposta <code>ENABLE_SCHEDULER=true</code> e <code>SCHEDULER_ROLE=scheduler</code> nel .env e riavvia il servizio. I job sotto sono configurati ma non in esecuzione.</div>
                </div>`;
            }

            if (!jobs.length) {
                el.innerHTML = html + '<div class="text-center py-4 text-muted">Nessun job configurato</div>';
                return;
            }
            html += jobs.map(j => {
                const toggleChecked = j.enabled ? 'checked' : '';
                const toggleLabel = j.enabled ? '<span class="text-success small">ON</span>' : '<span class="text-muted small">OFF</span>';
                const nextRun = j.next_run ? this.formatDate(j.next_run) : '';
                const lastRun = j.last_run ? this.formatDate(j.last_run) : '';
                const nextRunHtml = nextRun
                    ? `<span class="text-muted"><i class="fa-solid fa-clock me-1"></i>Prossima: ${nextRun}</span>`
                    : '';
                const lastRunHtml = lastRun
                    ? `<span class="text-muted"><i class="fa-solid fa-circle-check me-1"></i>Ultima: ${lastRun}</span>`
                    : '<span class="text-muted fst-italic"><i class="fa-solid fa-circle-minus me-1"></i>Mai eseguito</span>';
                return `<div class="d-flex align-items-start gap-3 p-3 border-bottom">
                    <div class="d-flex align-items-center justify-content-center rounded-circle bg-${j.color} bg-opacity-10" style="width:40px;height:40px;flex-shrink:0">
                        <i class="fa-solid ${j.icon} text-${j.color}"></i>
                    </div>
                    <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-bold">${this._escapeHtml(j.name)}</span>
                            <div class="form-check form-switch mb-0">
                                <input class="form-check-input" type="checkbox" ${toggleChecked}
                                       onchange="SyrusApp.toggleCronJob('${j.id}', this.checked)"
                                       style="cursor:pointer;width:2.5em;height:1.3em">
                            </div>
                        </div>
                        <p class="small text-muted mb-1">${this._escapeHtml(j.description)}</p>
                        <div class="d-flex flex-wrap gap-3 small">
                            <span class="text-muted"><i class="fa-solid fa-repeat me-1"></i>${this._escapeHtml(j.schedule || j.trigger)}</span>
                            ${lastRunHtml}
                            ${nextRunHtml}
                        </div>
                    </div>
                </div>`;
            }).join('');
            el.innerHTML = html;
        } catch (e) {
            el.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`;
        }
    },

    async toggleCronJob(jobId, enabled) {
        try {
            await this.api('/settings/api/scheduler/toggle-job', {
                method: 'POST',
                body: JSON.stringify({ job_id: jobId, enabled }),
            });
            this.toast(enabled ? 'Job attivato' : 'Job disattivato');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Backup ────────────────────────────────────────────────────────────────
    async loadBackupList() {
        const el = document.getElementById('backup-list');
        if (!el) return;
        try {
            const data = await this.api('/settings/api/backup/list');
            const backups = data.backups || [];
            if (!backups.length) {
                el.innerHTML = '<div class="text-center py-4 text-muted"><i class="fa-solid fa-box-open fa-2x mb-2 d-block"></i>Nessun backup presente</div>';
                return;
            }
            const typeLabels = { auto: 'Automatico', manual: 'Manuale', pre_purge: 'Pre-Purge' };
            const typeColors = { auto: 'info', manual: 'success', pre_purge: 'warning' };
            el.innerHTML = '<div class="table-responsive"><table class="table table-hover table-sm align-middle mb-0"><thead><tr><th>File</th><th>Tipo</th><th>Dimensione</th><th>Data</th><th class="text-end">Azioni</th></tr></thead><tbody>' +
                backups.map(b => `<tr>
                    <td class="small fw-medium">${this._escapeHtml(b.filename)}</td>
                    <td><span class="badge bg-${typeColors[b.type] || 'secondary'}">${typeLabels[b.type] || b.type}</span></td>
                    <td class="small">${b.size_mb} MB</td>
                    <td class="small text-muted">${this.formatDate(b.created_at)}</td>
                    <td class="text-end">
                        <a href="/settings/api/backup/download/${encodeURIComponent(b.filename)}" class="btn btn-sm btn-outline-primary" title="Scarica"><i class="fa-solid fa-download"></i></a>
                        <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteBackup('${this._escapeAttr(b.filename)}')" title="Elimina"><i class="fa-solid fa-trash"></i></button>
                    </td>
                </tr>`).join('') + '</tbody></table></div>';
        } catch (e) { el.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`; }
    },

    async createManualBackup() {
        if (!confirm('Creare un backup manuale del database?')) return;
        this.toast('Backup in corso...', 'info');
        try {
            const res = await this.api('/settings/api/backup/create-manual', { method: 'POST' });
            if (res.ok) {
                this.toast(`Backup creato: ${res.filename}`, 'success');
                this.loadBackupList();
            } else {
                this.toast(res.error || 'Errore', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteBackup(filename) {
        if (!confirm(`Eliminare il backup ${filename}?`)) return;
        try {
            await this.api('/settings/api/backup/delete', { method: 'POST', body: JSON.stringify({ filename }) });
            this.toast('Backup eliminato');
            this.loadBackupList();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async gdriveStartAuth() {
        try {
            const res = await this.api('/settings/api/gdrive/auth-url');
            if (!res.ok) throw new Error(res.error);
            const url = res.url;
            document.getElementById('gdrive-auth-url').value = url;
            document.getElementById('gdrive-auth-open').href = url;
            document.getElementById('gdrive-auth-link').classList.remove('d-none');
            // Apri direttamente in una nuova tab
            window.open(url, '_blank');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async gdriveExchangeCode() {
        const input = document.getElementById('gdrive-auth-code');
        const code = (input?.value || '').trim();
        if (!code) { this.toast('Incolla il codice di autorizzazione', 'warning'); return; }
        try {
            const res = await this.api('/settings/api/gdrive/exchange-code', {
                method: 'POST', body: JSON.stringify({ code }),
            });
            if (res.ok) {
                this.toast(res.message, 'success');
                input.value = '';
                document.getElementById('gdrive-auth-link')?.classList.add('d-none');
                this.loadGDriveStatus();
            } else {
                this.toast(res.error || 'Errore', 'danger');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async uploadGDriveSA() {
        const input = document.getElementById('gdrive-sa-file');
        if (!input || !input.files.length) {
            this.toast('Seleziona un file JSON', 'warning');
            return;
        }
        const fd = new FormData();
        fd.append('file', input.files[0]);
        try {
            const resp = await SyrusApp.fetchWithCsrf('/settings/api/gdrive/upload-sa', {
                method: 'POST', body: fd,
            });
            let data;
            try { data = await resp.json(); } catch (_) { data = null; }
            if (!resp.ok || !data || !data.ok) {
                throw new Error((data && data.error) ? data.error : `HTTP ${resp.status}`);
            }
            this.toast(data.message, 'success');
            input.value = '';
            this.loadGDriveStatus();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── SLA Configuration ──────────────────────────────────────────────────

    async loadSlaConfig() {
        try {
            const data = await this.api('/settings/api/sla-config');
            const container = document.getElementById('sla-rules-container');
            if (!container) return;

            container.innerHTML = data.rules.map(r => `
                <div class="d-flex align-items-center gap-3 mb-3 p-3 bg-light rounded">
                    <div class="flex-grow-1">
                        <strong>${r.label}</strong>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <input type="number" class="form-control form-control-sm sla-hours-input"
                               data-key="${r.key}" value="${r.hours}" style="width:80px" min="1">
                        <span class="text-muted small">ore</span>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input sla-enabled-input" type="checkbox"
                               data-key="${r.key}" ${r.enabled ? 'checked' : ''}>
                    </div>
                </div>
            `).join('');

            document.getElementById('sla-immediate-email').checked = data.immediate_email_new;
            document.getElementById('sla-daily-recap').checked = data.daily_recap_enabled;
        } catch (e) {
            this.toast('Errore caricamento SLA: ' + e.message, 'danger');
        }
    },

    async saveSlaConfig() {
        const rules = [];
        document.querySelectorAll('.sla-hours-input').forEach(input => {
            rules.push({
                key: input.dataset.key,
                hours: parseFloat(input.value) || 2,
                enabled: document.querySelector(`.sla-enabled-input[data-key="${input.dataset.key}"]`)?.checked ?? true,
            });
        });

        const payload = {
            rules,
            immediate_email_new: document.getElementById('sla-immediate-email')?.checked ?? true,
            daily_recap_enabled: document.getElementById('sla-daily-recap')?.checked ?? true,
        };

        try {
            await this.api('/settings/api/sla-config/save', {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            this.toast('Configurazione SLA salvata', 'success');
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    // ── Log di Sistema ────────────────────────────────────────────────────
    _logRawLines: [],

    async loadLogs() {
        const fileSelect = document.getElementById('log-file-select');
        const linesSelect = document.getElementById('log-lines');
        const output = document.getElementById('log-output');
        if (!output) return;

        const file = fileSelect?.value || 'syrus.log';
        const lines = linesSelect?.value || '1000';

        output.textContent = 'Caricamento...';
        try {
            const data = await this.api(`/settings/api/logs?file=${encodeURIComponent(file)}&lines=${lines}`);
            this._logRawLines = data.lines || [];
            // Stats
            const stats = document.getElementById('log-stats');
            if (stats) {
                const errors = this._logRawLines.filter(l => l.includes(' ERROR ')).length;
                const warnings = this._logRawLines.filter(l => l.includes(' WARNING ')).length;
                stats.innerHTML = `<span>Totale nel file: <strong>${data.total}</strong></span>` +
                    `<span>Mostrate: <strong>${data.showing}</strong></span>` +
                    `<span class="text-danger">Errori: <strong>${errors}</strong></span>` +
                    `<span class="text-warning">Warning: <strong>${warnings}</strong></span>`;
            }
            this.filterLogs();
        } catch (e) {
            output.textContent = 'Errore: ' + e.message;
        }
    },

    filterLogs() {
        const output = document.getElementById('log-output');
        if (!output) return;
        const level = (document.getElementById('log-level-filter')?.value || '').toUpperCase();
        const search = (document.getElementById('log-search')?.value || '').toLowerCase();

        let filtered = this._logRawLines;
        if (level) {
            filtered = filtered.filter(l => l.includes(` ${level} `));
        }
        if (search) {
            filtered = filtered.filter(l => l.toLowerCase().includes(search));
        }

        if (filtered.length === 0) {
            output.innerHTML = '<span class="text-muted">Nessuna riga corrispondente ai filtri.</span>';
            return;
        }

        // Color-code lines
        output.innerHTML = filtered.map(line => {
            let cls = '';
            if (line.includes(' ERROR ')) cls = 'color:#f87171';
            else if (line.includes(' WARNING ')) cls = 'color:#fbbf24';
            else if (line.includes(' DEBUG ')) cls = 'color:#94a3b8';
            const escaped = line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            return cls ? `<span style="${cls}">${escaped}</span>` : escaped;
        }).join('\n');

        // Auto-scroll to bottom
        output.scrollTop = output.scrollHeight;
    },

    downloadLog() {
        const file = document.getElementById('log-file-select')?.value || 'syrus.log';
        window.location.href = `/settings/api/logs/download?file=${encodeURIComponent(file)}`;
    },

    async testGDriveConnection() {
        this.toast('Test connessione in corso...', 'info');
        try {
            const result = await this.api('/settings/api/gdrive/test', { method: 'POST' });
            if (result.ok) {
                let msg = 'Connessione Google Drive OK!';
                if (result.folder_accessible) msg += ` Cartella "${result.folder_name}" accessibile.`;
                else if (result.folder_configured) msg += ' ⚠ Cartella configurata ma non accessibile. Verifica che il Service Account abbia i permessi.';
                else msg += ' ⚠ Nessuna cartella configurata (imposta GOOGLE_DRIVE_FOLDER_ID).';
                this.toast(msg, 'success');
            } else {
                this.toast(result.error || 'Test fallito', 'danger');
            }
            this.loadGDriveStatus();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Escalation Config ─────────────────────────────────────────────────

    async loadEscalationConfig() {
        const body = document.getElementById('escalation-config-body');
        if (!body) return;
        try {
            const c = await this.api('/settings/api/escalation-config');
            body.innerHTML = `
                <div class="mb-4">
                    <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" id="esc-enabled" ${c.escalation_enabled ? 'checked' : ''} style="width:2.5em;height:1.3em">
                        <label class="form-check-label fw-bold" for="esc-enabled">Escalation attiva</label>
                    </div>
                    <p class="text-muted small">Ore in orario lavorativo (Lun-Ven 9-18) dopo la creazione della lead senza primo contatto:</p>
                    <div class="row g-3 mb-3">
                        <div class="col-md-3">
                            <label class="form-label small fw-bold"><span class="badge bg-warning text-dark me-1">1</span> Reminder</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-step1" value="${c.step1_hours}" min="1" step="1">
                                <span class="input-group-text">ore</span>
                            </div>
                            <div class="text-muted" style="font-size:11px">Email al venditore</div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold"><span class="badge bg-orange text-white me-1" style="background:#F97316">2</span> Urgente</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-step2" value="${c.step2_hours}" min="1" step="1">
                                <span class="input-group-text">ore</span>
                            </div>
                            <div class="text-muted" style="font-size:11px">Email urgente al venditore</div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold"><span class="badge bg-danger me-1">3</span> Escalation</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-step3" value="${c.step3_hours}" min="1" step="1">
                                <span class="input-group-text">ore</span>
                            </div>
                            <div class="text-muted" style="font-size:11px">Venditore + Admin</div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small fw-bold"><span class="badge me-1" style="background:#991B1B;color:#fff">4</span> Abbandonata</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-step4" value="${c.step4_hours}" min="1" step="1">
                                <span class="input-group-text">ore</span>
                            </div>
                            <div class="text-muted" style="font-size:11px">Solo Admin</div>
                        </div>
                    </div>
                    <div class="alert alert-info small py-2">
                        <i class="fa-solid fa-circle-info me-1"></i>
                        Le ore sono <strong>lavorative</strong> (Lun-Ven 9:00-18:00). Per lead di alto valore (>€10K) i tempi sono dimezzati automaticamente.
                    </div>
                </div>
                <hr>
                <div class="mb-4">
                    <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" id="esc-dormant-enabled" ${c.auto_dormant_enabled ? 'checked' : ''} style="width:2.5em;height:1.3em">
                        <label class="form-check-label fw-bold" for="esc-dormant-enabled">Auto-Dormant per inattività</label>
                    </div>
                    <p class="text-muted small">Le lead senza attività vengono automaticamente messe in Dormiente. Soglie per status:</p>
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label class="form-label small text-muted">New</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-dormant-new" value="${c.auto_dormant_days_new}" min="7" max="180" step="1">
                                <span class="input-group-text">gg</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">Contacted</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-dormant-contacted" value="${c.auto_dormant_days_contacted}" min="7" max="180" step="1">
                                <span class="input-group-text">gg</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">Proposta Inviata</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-dormant-proposal" value="${c.auto_dormant_days_proposal_sent}" min="7" max="180" step="1">
                                <span class="input-group-text">gg</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">Negoziazione</label>
                            <div class="input-group input-group-sm">
                                <input type="number" class="form-control" id="esc-dormant-negotiation" value="${c.auto_dormant_days_negotiation}" min="7" max="180" step="1">
                                <span class="input-group-text">gg</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <button class="btn btn-primary" onclick="SyrusApp.saveEscalationConfig()">
                    <i class="fa-solid fa-check me-2"></i>Salva Configurazione
                </button>`;
        } catch (e) {
            body.innerHTML = `<div class="alert alert-danger">${this._escapeHtml(e.message)}</div>`;
        }
    },

    async saveEscalationConfig() {
        try {
            await this.api('/settings/api/escalation-config/save', {
                method: 'POST',
                body: JSON.stringify({
                    escalation_enabled: document.getElementById('esc-enabled')?.checked || false,
                    step1_hours: parseFloat(document.getElementById('esc-step1')?.value) || 2,
                    step2_hours: parseFloat(document.getElementById('esc-step2')?.value) || 8,
                    step3_hours: parseFloat(document.getElementById('esc-step3')?.value) || 24,
                    step4_hours: parseFloat(document.getElementById('esc-step4')?.value) || 48,
                    auto_dormant_enabled: document.getElementById('esc-dormant-enabled')?.checked || false,
                    auto_dormant_days_new: parseInt(document.getElementById('esc-dormant-new')?.value) || 30,
                    auto_dormant_days_contacted: parseInt(document.getElementById('esc-dormant-contacted')?.value) || 30,
                    auto_dormant_days_proposal_sent: parseInt(document.getElementById('esc-dormant-proposal')?.value) || 30,
                    auto_dormant_days_negotiation: parseInt(document.getElementById('esc-dormant-negotiation')?.value) || 45,
                }),
            });
            this.toast('Configurazione escalation salvata');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Lead API keys (import via endpoint) ──────────────────────────────
    async loadLeadApiKeys() {
        const tbody = document.getElementById('lead-api-keys-table');
        if (!tbody) return;
        try {
            const res = await this.api('/settings/api/lead-api-keys');
            const keys = res.keys || [];
            if (!keys.length) {
                tbody.innerHTML = '<tr><td colspan="6" class="text-center text-muted py-4">Nessuna API key. Generane una per iniziare.</td></tr>';
                return;
            }
            const fmt = (d) => d ? this.formatDate(d) : '—';
            tbody.innerHTML = keys.map(k => `
                <tr>
                    <td class="fw-bold">${this._escapeHtml(k.name || '-')}${k.scope === 'proposals' ? ' <span class="badge bg-primary">Feed proposte</span>' : (k.read_only ? ' <span class="badge bg-info">Sola lettura</span>' : '')}</td>
                    <td><code class="small">${k.key_prefix || ''}…</code></td>
                    <td class="text-center">${k.active
                        ? '<span class="badge bg-success">Attiva</span>'
                        : '<span class="badge bg-secondary">Disattivata</span>'}</td>
                    <td class="small text-muted">${fmt(k.created_at)}</td>
                    <td class="small text-muted">${fmt(k.last_used_at)}</td>
                    <td class="text-end">
                        <button class="btn btn-sm btn-outline-secondary me-1" onclick="SyrusApp.toggleLeadApiKey('${k.id}', ${k.active ? 'false' : 'true'})">
                            ${k.active ? 'Disattiva' : 'Attiva'}
                        </button>
                        <button class="btn btn-sm btn-outline-danger" onclick="SyrusApp.deleteLeadApiKey('${k.id}')"><i class="fa-solid fa-trash"></i></button>
                    </td>
                </tr>`).join('');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async generateLeadApiKey() {
        const name = prompt('Nome della chiave (es. "Sito web", "Gestionale"):', '');
        if (name === null) return;
        const readOnly = confirm('Chiave a SOLA LETTURA?\n\nOK = solo endpoint GET (consultazione)\nAnnulla = accesso completo (crea/aggiorna lead)');
        try {
            const res = await this.api('/settings/api/lead-api-keys', {
                method: 'POST', body: JSON.stringify({ name, read_only: readOnly }) });
            const box = document.getElementById('lead-api-key-new');
            const code = document.getElementById('lead-api-key-plain');
            if (box && code) {
                code.textContent = res.plaintext;
                box.classList.remove('d-none');
            }
            this.toast('API key generata — copiala ora!', 'success');
            this.loadLeadApiKeys();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async generateProposalsApiKey() {
        const name = prompt('Nome della chiave per il feed proposte (es. "Conversioni offline"):', 'Feed proposte');
        if (name === null) return;
        try {
            const res = await this.api('/settings/api/lead-api-keys', {
                method: 'POST', body: JSON.stringify({ name, scope: 'proposals' }) });
            const box = document.getElementById('lead-api-key-new');
            const code = document.getElementById('lead-api-key-plain');
            if (box && code) {
                code.textContent = res.plaintext;
                box.classList.remove('d-none');
            }
            this.toast('Chiave feed proposte generata — copiala ora!', 'success');
            this.loadLeadApiKeys();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    copyLeadApiKey() {
        const code = document.getElementById('lead-api-key-plain');
        if (code && code.textContent) {
            navigator.clipboard.writeText(code.textContent)
                .then(() => this.toast('Chiave copiata negli appunti', 'success'))
                .catch(() => this.toast('Copia non riuscita', 'danger'));
        }
    },

    // ── Centralino: push webhook conversazioni WhatsApp ──────────────────
    async loadCentralino() {
        try {
            const cfg = await this.api('/settings/api/centralino/config');
            const url = document.getElementById('centralino-url');
            const enabled = document.getElementById('centralino-enabled');
            const regen = document.getElementById('centralino-regen-btn');
            if (url) url.value = cfg.url || '';
            if (enabled) enabled.checked = !!cfg.enabled;
            if (regen) regen.disabled = !cfg.has_secret;
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    _showCentralinoSecret(plaintext) {
        const box = document.getElementById('centralino-secret-new');
        const code = document.getElementById('centralino-secret-plain');
        if (box && code && plaintext) {
            code.textContent = plaintext;
            box.classList.remove('d-none');
        }
    },

    async saveCentralino() {
        const url = document.getElementById('centralino-url')?.value.trim() || '';
        const enabled = document.getElementById('centralino-enabled')?.checked || false;
        try {
            const res = await this.api('/settings/api/centralino/config/save', {
                method: 'POST', body: JSON.stringify({ url, enabled }) });
            this._showCentralinoSecret(res.plaintext_secret);
            this.toast(res.plaintext_secret
                ? 'Configurazione salvata — copia il secret ora!'
                : 'Configurazione salvata', 'success');
            this.loadCentralino();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async regenCentralinoSecret() {
        if (!confirm('Rigenerare il secret? Il centralino dovrà aggiornarlo: il vecchio smette subito di funzionare.')) return;
        try {
            const res = await this.api('/settings/api/centralino/secret/regen', { method: 'POST' });
            this._showCentralinoSecret(res.plaintext_secret);
            this.toast('Secret rigenerato — copialo ora!', 'warning');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    copyCentralinoSecret() {
        const code = document.getElementById('centralino-secret-plain');
        if (code && code.textContent) {
            navigator.clipboard.writeText(code.textContent)
                .then(() => this.toast('Secret copiato negli appunti', 'success'))
                .catch(() => this.toast('Copia non riuscita', 'danger'));
        }
    },

    async toggleLeadApiKey(keyId, active) {
        try {
            await this.api(`/settings/api/lead-api-keys/${keyId}/toggle`, {
                method: 'POST', body: JSON.stringify({ active }) });
            this.loadLeadApiKeys();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async deleteLeadApiKey(keyId) {
        if (!confirm('Eliminare questa API key? Le integrazioni che la usano smetteranno di funzionare.')) return;
        try {
            await this.api(`/settings/api/lead-api-keys/${keyId}`, { method: 'DELETE' });
            this.toast('API key eliminata');
            this.loadLeadApiKeys();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Tracking WhatsApp (eventi click → attribuzione) ──────────────────
    async loadWaTracking() {
        await this._loadWaTrackingConfig();
        await this._loadWaTrackingEvents();
    },

    async _loadWaTrackingConfig() {
        try {
            const c = await this.api('/settings/api/wa-tracking/config');
            const set = (id, v) => { const el = document.getElementById(id); if (el) el.value = v; };
            set('wa-track-base-urls', (c.base_urls || []).join('\n'));
            set('wa-track-window', c.match_window_min || 10);
            const en = document.getElementById('wa-track-enabled'); if (en) en.checked = !!c.enabled;
            const hint = document.getElementById('wa-track-key-hint');
            if (hint) hint.textContent = c.has_key
                ? 'Una chiave è già salvata (cifrata). Compila il campo solo per sostituirla.'
                : 'Nessuna chiave salvata: incollala qui sopra.';
            const badge = document.getElementById('wa-track-status-badge');
            if (badge) { badge.className = 'badge ' + (c.enabled ? 'bg-success' : 'bg-secondary'); badge.textContent = c.enabled ? 'Attiva' : 'Disattiva'; }
            const tot = document.getElementById('wa-track-count-total'); if (tot) tot.textContent = c.events_total || 0;
            const mat = document.getElementById('wa-track-count-matched'); if (mat) mat.textContent = c.events_matched || 0;
            const siteCfg = document.getElementById('wa-track-site-config');
            if (siteCfg && (c.sites || []).length) siteCfg.innerHTML = c.sites.map(s => `
                <div class="d-flex flex-wrap align-items-center gap-2 wa-track-site-row" data-site="${this._escapeHtml(s.site)}">
                    <span class="fw-semibold text-body" style="min-width:170px"><i class="fa-solid fa-globe me-1"></i>${this._escapeHtml(s.site)}</span>
                    <input type="password" class="form-control form-control-sm wa-site-key" style="max-width:260px" autocomplete="new-password"
                           placeholder="${s.own_key ? 'Chiave propria salvata — vuoto = invariata' : 'Chiave propria (vuoto = chiave comune)'}">
                    <input type="text" class="form-control form-control-sm wa-site-prefix text-uppercase" style="max-width:110px"
                           placeholder="Prefisso" value="${this._escapeHtml(s.ref_prefix || '')}">
                    <span class="badge ${s.match_mode === 'ref' ? 'bg-primary' : 'bg-light text-dark'}">${s.match_mode === 'ref' ? 'Solo codice' : 'Per orario'}</span>
                    ${s.own_key ? '<span class="badge bg-success">Chiave propria</span>' : ''}
                </div>`).join('');
            const sites = document.getElementById('wa-track-sites');
            if (sites) sites.innerHTML = (c.sites || []).map(s =>
                `<span class="me-3"><i class="fa-solid fa-globe me-1"></i>${this._escapeHtml(s.site)} — ultimo sync: ${s.last_sync ? new Date(s.last_sync * 1000).toLocaleString('it-IT') : 'mai'}</span>`).join('');
            const alertBox = document.getElementById('wa-track-import-alert');
            if (alertBox) alertBox.innerHTML = c.imports_allowed
                ? '<div class="alert alert-success d-flex align-items-center gap-2 mb-0"><i class="fa-solid fa-circle-check"></i><div>Import esterni <strong>attivi</strong>: polling e backfill operativi.</div></div>'
                : '<div class="alert alert-warning d-flex align-items-start gap-2 mb-0"><i class="fa-solid fa-triangle-exclamation mt-1"></i><div><strong>Import esterni disabilitati.</strong> Polling e backfill restano inattivi finché <code>ALLOW_EXTERNAL_IMPORTS</code> non è <code>true</code> nel <code>.env</code>.</div></div>';
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _loadWaTrackingEvents() {
        const tb = document.getElementById('wa-track-events-table');
        if (!tb) return;
        try {
            const d = await this.api('/settings/api/wa-tracking/events');
            if (!d.events.length) {
                tb.innerHTML = '<tr><td colspan="8" class="text-center text-muted py-4">Nessun evento importato</td></tr>';
                return;
            }
            const when = (ev) => ev.ts ? this._escapeHtml(ev.ts) : (ev.ts_epoch ? new Date(ev.ts_epoch * 1000).toLocaleString('it-IT') : '—');
            tb.innerHTML = d.events.map(ev => `<tr>
                <td class="small">${when(ev)}</td>
                <td class="small">${this._escapeHtml(ev.site)}${ev.ref ? `<div class="text-muted">${this._escapeHtml(ev.ref)}</div>` : ''}</td>
                <td class="small text-truncate" style="max-width:200px" title="${this._escapeHtml(ev.page || '')}">${this._escapeHtml(ev.page || '—')}</td>
                <td><span class="badge bg-light text-dark">${this._escapeHtml(ev.source || '—')}</span></td>
                <td class="small text-truncate" style="max-width:160px">${this._escapeHtml(ev.gclid || '—')}</td>
                <td class="small">${this._escapeHtml(ev.utm_campaign || '—')}</td>
                <td class="small">${this._escapeHtml(ev.ip || '—')}</td>
                <td class="text-center">${ev.matched
                    ? '<i class="fa-solid fa-circle-check text-success" title="Abbinato a una lead"></i>'
                    : '<i class="fa-regular fa-circle text-muted" title="Non abbinato"></i>'}</td>
            </tr>`).join('');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async saveWaTracking() {
        const val = (id) => { const el = document.getElementById(id); return el ? el.value : ''; };
        const payload = {
            base_urls: val('wa-track-base-urls'),
            api_key: val('wa-track-api-key'),
            enabled: document.getElementById('wa-track-enabled')?.checked || false,
            match_window_min: parseInt(val('wa-track-window'), 10) || 10,
            sites: {},
        };
        document.querySelectorAll('.wa-track-site-row').forEach(row => {
            payload.sites[row.dataset.site] = {
                api_key: row.querySelector('.wa-site-key')?.value || '',
                ref_prefix: row.querySelector('.wa-site-prefix')?.value || '',
            };
        });
        try {
            await this.api('/settings/api/wa-tracking/config/save', {
                method: 'POST', body: JSON.stringify(payload) });
            const key = document.getElementById('wa-track-api-key'); if (key) key.value = '';
            this.toast('Configurazione salvata', 'success');
            this._loadWaTrackingConfig();
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async testWaTracking() {
        const box = document.getElementById('wa-track-test-result');
        if (box) box.innerHTML = '<span class="text-muted small">Test in corso…</span>';
        try {
            const d = await this.api('/settings/api/wa-tracking/test', { method: 'POST' });
            if (box) box.innerHTML = d.results.map(r => {
                const cls = r.ok ? 'success' : 'danger';
                const icon = r.ok ? 'circle-check' : 'circle-xmark';
                return `<div class="d-flex align-items-center gap-2 small text-${cls}"><i class="fa-solid fa-${icon}"></i><code>${this._escapeHtml(r.base_url)}</code> — ${this._escapeHtml(r.message)}</div>`;
            }).join('');
        } catch (e) { if (box) box.innerHTML = `<span class="text-danger small">${this._escapeHtml(e.message)}</span>`; }
    },

    async backfillWaTracking() {
        if (!confirm('Avviare il backfill dello storico (fino a 90 giorni) per i siti configurati?')) return;
        const btn = document.getElementById('wa-track-backfill-btn');
        if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i> Backfill…'; }
        try {
            const d = await this.api('/settings/api/wa-tracking/backfill', { method: 'POST' });
            this.toast(`Backfill: ${d.imported} eventi importati, ${d.matched} abbinati`, 'success');
            if (d.errors && d.errors.length) this.toast(`Avvisi: ${d.errors.map(e => e.error).join(', ')}`, 'warning');
            this.loadWaTracking();
        } catch (e) { this.toast(e.message, 'danger'); }
        finally { if (btn) { btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-cloud-arrow-down me-1"></i> Backfill (storico)'; } }
    },

    // ── Ricerca rapida nella nav Impostazioni ───────────────────────────
    _initSettingsSearch() {
        const input = document.getElementById('settings-search-input');
        if (!input || input._wired) return;
        input._wired = true;
        const nav = document.getElementById('settingsTabs');
        if (!nav) return;
        const toggleFor = (grp) => nav.querySelector(`[data-bs-target="#${grp.id}"]`);
        input.addEventListener('input', () => {
            const q = input.value.trim().toLowerCase();
            nav.querySelectorAll('.settings-group').forEach(grp => {
                const tg = toggleFor(grp);
                if (!q) {
                    // ripristino: collassa tutto tranne il gruppo con la voce attiva
                    grp.querySelectorAll('.settings-link').forEach(l => { l.style.display = ''; });
                    const hasActive = !!grp.querySelector('.settings-link.active');
                    grp.classList.toggle('show', hasActive);
                    if (tg) { tg.style.display = ''; tg.classList.toggle('collapsed', !hasActive); tg.setAttribute('aria-expanded', hasActive); }
                    return;
                }
                let any = false;
                grp.querySelectorAll('.settings-link').forEach(l => {
                    const match = l.textContent.toLowerCase().includes(q);
                    l.style.display = match ? '' : 'none';
                    if (match) any = true;
                });
                grp.classList.toggle('show', any);
                if (tg) { tg.style.display = any ? '' : 'none'; tg.classList.toggle('collapsed', !any); tg.setAttribute('aria-expanded', any); }
            });
        });
    },

    // ── Settings tabs initialization (works for both full load and SPA) ──
    _initSettingsTabs() {
        this._initSettingsSearch();
        const waMgrTabHandlers = {
            '#wa-mgr-numbers':   () => this.loadWaNumbers(),
            '#wa-mgr-templates': () => this.loadWaTemplatesPage && this.loadWaTemplatesPage(),
            '#wa-mgr-broadcast': () => this.loadBroadcastPage && this.loadBroadcastPage(),
            '#wa-mgr-contacts':  () => this.loadWaContacts && this.loadWaContacts(),
        };

        const tabConfigs = {
            '#tab-whatsapp-mgr': () => {
                const activeSubTab = document.querySelector('#waMgrTabs .nav-link.active');
                const target = activeSubTab?.getAttribute('data-bs-target');
                if (target && waMgrTabHandlers[target]) waMgrTabHandlers[target]();
            },
            '#tab-gdrive': () => this.loadGDriveStatus(),
            '#tab-lead-api': () => this.loadLeadApiKeys(),
            '#tab-wa-tracking': () => this.loadWaTracking(),
            '#tab-centralino': () => this.loadCentralino(),
            '#tab-demo': () => this.loadBackups(),
            '#tab-cron': () => this.loadCronJobs(),
            '#tab-backup': () => this.loadBackupList(),
            '#tab-sla': () => this.loadSlaConfig(),
            '#tab-escalation': () => this.loadEscalationConfig(),
            '#tab-logs': () => this.loadLogs(),
        };

        // Bind main tab lazy-loaders
        Object.entries(tabConfigs).forEach(([target, handler]) => {
            const btn = document.querySelector(`[data-bs-target="${target}"]`);
            if (btn && !btn._settingsWired) {
                btn._settingsWired = true;
                btn.addEventListener('shown.bs.tab', handler);
            }
        });

        // Bind WA sub-tab lazy-loaders
        Object.entries(waMgrTabHandlers).forEach(([target, handler]) => {
            const btn = document.querySelector(`[data-bs-target="${target}"]`);
            if (btn && !btn._settingsWired) {
                btn._settingsWired = true;
                btn.addEventListener('shown.bs.tab', handler);
            }
        });
    },
});


// ── app-webphone.js ──
/** Syrus Sales OS – Webphone (SIP.js 0.15.x) */
console.log('[Webphone] Modulo caricato v20260404b — con notifica backend');
Object.assign(SyrusApp, {

    _wpUA: null,           // SIP.UA instance
    _wpSession: null,      // Active SIP session
    _wpTimer: null,        // Call timer interval
    _wpSeconds: 0,         // Call duration counter
    _wpConnected: false,   // UA connected state
    _wpConnecting: false,  // Connection in progress
    _wpConfig: null,       // SIP config (fetched from API)
    _wpCurrentCallId: null, // Backend PbxCall ID for current call
    _wpCurrentNumber: null, // Phone number of current call
    _wpCallDirection: null, // 'out' or 'in'

    initWebphone() {
        // Rende il widget trascinabile e ripristina posizione/stato salvati
        this.initWebphoneDrag();
        // Auto-connect SIP on page load so incoming calls always ring
        if (!this._wpConnected && !this._wpConnecting) {
            console.log('[Webphone] Auto-connect on page load');
            this.wpConnect();
        }
    },

    toggleWebphone() {
        const body = document.getElementById('wp-body');
        const chevron = document.getElementById('wp-chevron');
        const widget = document.getElementById('webphone-widget');
        if (body.style.display === 'none') {
            body.style.display = 'block';
            chevron.className = 'fa-solid fa-chevron-down';
            widget.classList.add('wp-open');   // tiene il widget al 100% mentre è aperto
            if (!this._wpConnected && !this._wpConnecting) this.wpConnect();
        } else {
            body.style.display = 'none';
            chevron.className = 'fa-solid fa-chevron-up';
            widget.classList.remove('wp-open');
        }
    },

    // ── Drag & drop del widget lungo i bordi + posizione persistita ──────────
    initWebphoneDrag() {
        const widget = document.getElementById('webphone-widget');
        if (!widget || widget._wpDragBound) return;
        const header = widget.querySelector('.webphone-header');
        if (!header) return;
        widget._wpDragBound = true;

        this._wpApplySavedPosition();

        let startX, startY, originLeft, originTop, dragging = false, pointerId = null;
        const THRESH = 4;  // px oltre i quali è drag e non click

        const onMove = (e) => {
            const dx = e.clientX - startX, dy = e.clientY - startY;
            if (!dragging) {
                if (Math.abs(dx) < THRESH && Math.abs(dy) < THRESH) return;
                dragging = true;
                widget.classList.add('wp-dragging', 'wp-floating');
                widget.style.right = 'auto';
                widget.style.bottom = 'auto';
            }
            const w = widget.offsetWidth, h = widget.offsetHeight;
            const nl = Math.max(0, Math.min(originLeft + dx, window.innerWidth - w));
            const nt = Math.max(0, Math.min(originTop + dy, window.innerHeight - h));
            widget.style.left = nl + 'px';
            widget.style.top = nt + 'px';
        };
        const onUp = () => {
            document.removeEventListener('pointermove', onMove);
            document.removeEventListener('pointerup', onUp);
            try { header.releasePointerCapture(pointerId); } catch (e) { /* noop */ }
            if (dragging) {
                widget.classList.remove('wp-dragging');
                this._wpSnapToEdge();
                widget._wpJustDragged = true;          // sopprime il click di toggle
                setTimeout(() => { widget._wpJustDragged = false; }, 0);
            }
        };
        header.addEventListener('pointerdown', (e) => {
            if (e.button != null && e.button !== 0) return;  // solo tasto sinistro
            const r = widget.getBoundingClientRect();
            startX = e.clientX; startY = e.clientY;
            originLeft = r.left; originTop = r.top;
            dragging = false; pointerId = e.pointerId;
            try { header.setPointerCapture(pointerId); } catch (e2) { /* noop */ }
            document.addEventListener('pointermove', onMove);
            document.addEventListener('pointerup', onUp);
        });
        // Click sull'header = apri/chiudi, ma non se abbiamo appena trascinato
        header.addEventListener('click', () => {
            if (widget._wpJustDragged) return;
            this.toggleWebphone();
        });
        // Su resize tieni il widget agganciato e dentro lo schermo
        window.addEventListener('resize', () => this._wpApplySavedPosition());
    },

    _wpSnapToEdge() {
        const widget = document.getElementById('webphone-widget');
        const w = widget.offsetWidth, h = widget.offsetHeight, margin = 12;
        const r = widget.getBoundingClientRect();
        const side = (r.left + w / 2) < window.innerWidth / 2 ? 'left' : 'right';
        const top = Math.max(margin, Math.min(r.top, window.innerHeight - h - margin));
        this._wpApplyPosition(side, top / window.innerHeight);
        try { localStorage.setItem('wp_pos', JSON.stringify({ side, topRatio: top / window.innerHeight })); } catch (e) { /* noop */ }
    },

    _wpApplyPosition(side, topRatio) {
        const widget = document.getElementById('webphone-widget');
        widget.classList.add('wp-floating');
        const h = widget.offsetHeight, margin = 12;
        let top = (topRatio || 0) * window.innerHeight;
        top = Math.max(margin, Math.min(top, window.innerHeight - h - margin));
        widget.style.top = top + 'px';
        widget.style.bottom = 'auto';
        if (side === 'left') { widget.style.left = margin + 'px'; widget.style.right = 'auto'; }
        else { widget.style.left = 'auto'; widget.style.right = margin + 'px'; }
    },

    _wpApplySavedPosition() {
        let pos = null;
        try { pos = JSON.parse(localStorage.getItem('wp_pos')); } catch (e) { /* noop */ }
        if (pos && pos.side) this._wpApplyPosition(pos.side, pos.topRatio);
    },

    wpDial(digit) {
        const input = document.getElementById('wp-number');
        input.value += digit;
        // Send DTMF if in active call
        if (this._wpSession && this._wpSession.sessionDescriptionHandler) {
            try {
                const pc = this._wpSession.sessionDescriptionHandler.peerConnection;
                const sender = pc.getSenders().find(s => s.track && s.track.kind === 'audio');
                if (sender) sender.dtmf?.insertDTMF(digit);
            } catch(e) { console.warn('[Webphone] DTMF error:', e); }
        }
    },

    async wpConnect() {
        if (this._wpConnecting || this._wpConnected) return;

        if (typeof SIP === 'undefined' || !SIP.UA) {
            this.toast('Libreria SIP non disponibile', 'danger');
            this._wpSetState('idle', 'Errore');
            return;
        }

        this._wpConnecting = true;
        this._wpSetState('idle', 'Connessione...');

        // Fetch SIP config from secure API endpoint
        let cfg;
        try {
            cfg = await this.api('/settings/api/sip-config');
        } catch (e) {
            this._wpConnecting = false;
            this._wpSetState('idle', 'Errore config');
            return;
        }
        if (!cfg || !cfg.wssUrl || !cfg.extension) {
            this._wpConnecting = false;
            this._wpSetState('idle', 'Non configurato');
            return;
        }
        this._wpConfig = cfg;
        console.log('[Webphone] Config:', { wss: cfg.wssUrl, domain: cfg.domain, ext: cfg.extension, hasPwd: !!cfg.password });

        try {
            // SIP.js 0.15.x API — same as technician's test code
            this._wpUA = new SIP.UA({
                uri: 'sip:' + cfg.extension + '@' + cfg.domain,
                transportOptions: {
                    wsServers: [cfg.wssUrl],
                    traceSip: true
                },
                authorizationUser: cfg.extension,
                password: cfg.password,
                sessionDescriptionHandlerFactoryOptions: {
                    constraints: { audio: true, video: false }
                },
                log: { level: 'warn' }
            });

            this._wpUA.on('connected', () => {
                console.log('[Webphone] Trasporto WSS connesso');
            });

            this._wpUA.on('transportError', () => {
                this._wpConnecting = false;
                this._wpSetState('idle', 'Errore WSS');
                this.toast('Webphone: connessione WSS fallita verso ' + cfg.wssUrl, 'danger');
                console.error('[Webphone] Trasporto WSS fallito:', cfg.wssUrl);
            });

            this._wpUA.on('registered', () => {
                this._wpConnected = true;
                this._wpConnecting = false;
                this._wpSetState('idle', 'Connesso');
                this.toast('Webphone connesso', 'success');
                console.log('[Webphone] Registrato su', cfg.domain, 'come', cfg.extension);
            });

            this._wpUA.on('registrationFailed', (cause) => {
                this._wpConnecting = false;
                this._wpSetState('idle', 'Reg. fallita');
                const reason = cause?.cause || cause?.status_code || cause || 'sconosciuto';
                this.toast('Registrazione SIP fallita: ' + reason, 'danger');
                console.error('[Webphone] Registrazione fallita:', JSON.stringify(cause));
            });

            this._wpUA.on('unregistered', (cause) => {
                this._wpConnected = false;
                console.warn('[Webphone] Deregistrato:', cause);
            });

            this._wpUA.on('disconnected', () => {
                this._wpConnected = false;
                this._wpConnecting = false;
                this._wpSetState('idle', 'Disconnesso');
                console.log('[Webphone] Disconnesso');
            });

            this._wpUA.on('invite', (session) => {
                console.log('[Webphone] Chiamata in arrivo da:', session.remoteIdentity?.uri?.toString());
                this._wpHandleIncoming(session);
            });

        } catch (e) {
            this._wpConnecting = false;
            this._wpSetState('idle', 'Errore');
            this.toast('Errore SIP: ' + e.message, 'danger');
            console.error('[Webphone] Errore init:', e);
        }
    },

    // ── Incoming call handling ────────────────────────────────────────────
    _wpHandleIncoming(session) {
        if (this._wpSession) {
            session.reject();
            return;
        }

        this._wpSession = session;
        const caller = session.remoteIdentity.displayName || session.remoteIdentity.uri.user || 'Sconosciuto';
        const callerNum = session.remoteIdentity.uri.user || '';

        document.getElementById('wp-incoming-caller').textContent = caller;
        document.getElementById('wp-incoming-number').textContent = callerNum;
        document.getElementById('wp-incoming').classList.remove('d-none');

        const body = document.getElementById('wp-body');
        if (body.style.display === 'none') this.toggleWebphone();

        this._wpSetState('ringing', 'Chiamata in arrivo');
        this._wpCurrentNumber = callerNum;
        this._wpCallDirection = 'in';
        try { document.getElementById('wp-ringtone').play(); } catch(e) {}

        // Notify backend (inbound seen from webphone)
        this.api('/communications/api/pbx-calls/webphone', {
            method: 'POST', body: JSON.stringify({ event: 'call_start', phone_number: callerNum, direction: 'in' }),
            headers: { 'Content-Type': 'application/json' }
        }).then(r => {
            this._wpCurrentCallId = r.pbx_call_id || null;
            console.log('[Webphone] Backend inbound call_start OK, pbx_call_id:', this._wpCurrentCallId);
        }).catch(e => console.warn('[Webphone] Backend inbound call_start failed:', e));

        session.on('terminated', () => {
            if (!this._wpSession || this._wpSession === session) {
                this._wpClearIncoming();
                this._wpEndCall();
            }
        });
    },

    _wpClearIncoming() {
        document.getElementById('wp-incoming').classList.add('d-none');
        try {
            document.getElementById('wp-ringtone').pause();
            document.getElementById('wp-ringtone').currentTime = 0;
        } catch(e) {}
    },

    wpAnswer() {
        if (!this._wpSession) return;

        this._wpClearIncoming();

        this._wpSession.accept({
            sessionDescriptionHandlerOptions: {
                constraints: { audio: true, video: false }
            }
        });

        this._wpBindSession(this._wpSession);
    },

    wpReject() {
        if (!this._wpSession) return;
        this._wpSession.reject();
        this._wpClearIncoming();
        this._wpEndCall();
    },

    // ── Outbound calls ───────────────────────────────────────────────────
    async wpCall() {
        const number = document.getElementById('wp-number').value.replace(/[\s\-()]/g, '').replace('+39', '');
        if (!number) { this.toast('Inserisci un numero', 'warning'); return; }

        if (!this._wpUA || !this._wpConnected) {
            this.toast('Webphone non connesso. Attendi la connessione.', 'warning');
            return;
        }

        if (this._wpSession) {
            this.toast('Chiamata già in corso', 'warning');
            return;
        }

        const cfg = this._wpConfig;
        const target = 'sip:' + number + '@' + cfg.domain;

        try {
            console.log('[Webphone] Chiamata verso', number, '(target:', target, ')');

            // Pre-check microphone access (forces browser permission prompt)
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(t => t.stop()); // release immediately
                console.log('[Webphone] Microfono: accesso concesso');
            } catch (micErr) {
                console.error('[Webphone] Microfono: accesso negato o non disponibile:', micErr);
                this.toast('Microfono non disponibile: controlla i permessi del browser', 'danger');
                this._wpSetState('idle', 'Microfono negato');
                return;
            }

            this.toast('Chiamata in uscita: ' + number, 'info');
            this._wpCurrentNumber = number;
            this._wpCallDirection = 'out';

            // Notify backend — create PbxCall record
            this.api('/communications/api/pbx-calls/webphone', {
                method: 'POST', body: JSON.stringify({ event: 'call_start', phone_number: number, direction: 'out' }),
            }).then(r => {
                this._wpCurrentCallId = r.pbx_call_id || null;
                console.log('[Webphone] Backend call_start OK, pbx_call_id:', this._wpCurrentCallId);
            }).catch(e => console.warn('[Webphone] Backend call_start failed:', e));

            const session = this._wpUA.invite(target, {
                sessionDescriptionHandlerOptions: {
                    constraints: { audio: true, video: false }
                }
            });

            this._wpBindSession(session);

        } catch (e) {
            this.toast('Errore chiamata: ' + e.message, 'danger');
            console.error('[Webphone] Errore chiamata:', e);
        }
    },

    // ── Bind session events (shared by inbound/outbound) ─────────────────
    _wpBindSession(session) {
        this._wpSession = session;

        document.getElementById('wp-call-btn').classList.add('d-none');
        document.getElementById('wp-hangup-btn').classList.remove('d-none');

        // Bind remote audio il prima possibile (prima di accepted/progress)
        const audio = document.getElementById('wp-remote-audio');
        const _bindAudio = () => {
            const sdh = session.sessionDescriptionHandler;
            if (!sdh || !sdh.peerConnection) return;
            const pc = sdh.peerConnection;

            // Registra ontrack subito per catturare early media (ringback/squillo)
            pc.ontrack = (event) => {
                console.log('[Webphone] ontrack ricevuto', event.track?.kind);
                if (event.streams && event.streams[0]) {
                    audio.srcObject = event.streams[0];
                } else {
                    const stream = audio.srcObject instanceof MediaStream ? audio.srcObject : new MediaStream();
                    stream.addTrack(event.track);
                    audio.srcObject = stream;
                }
                audio.play().catch(() => {});
            };

            // Cattura track già presenti
            const receivers = pc.getReceivers().filter(r => r.track);
            if (receivers.length) {
                const stream = new MediaStream(receivers.map(r => r.track));
                audio.srcObject = stream;
                audio.play().catch(() => {});
            }
        };

        // SDH potrebbe non essere ancora pronto, ritenta
        if (session.sessionDescriptionHandler) {
            _bindAudio();
        }
        session.on('SessionDescriptionHandler-created', () => _bindAudio());

        session.on('rejected', (response) => {
            console.error('[Webphone] Chiamata rifiutata:', response?.status_code, response?.reason_phrase);
            this.toast('Chiamata rifiutata: ' + (response?.reason_phrase || response?.status_code || 'sconosciuto'), 'danger');
        });

        session.on('failed', (response, cause) => {
            console.error('[Webphone] Chiamata fallita:', cause, response?.status_code);
            this.toast('Chiamata fallita: ' + (cause || 'errore sconosciuto'), 'danger');
        });

        session.on('accepted', () => {
            this._wpSetState('calling', 'In chiamata');
            this._wpStartTimer();
            console.log('[Webphone] Chiamata accettata — audio attivo');
            document.getElementById('wp-call-info').classList.remove('d-none');

            // Riprova bind audio in caso SDH non fosse pronto prima
            _bindAudio();
        });

        session.on('progress', () => {
            this._wpSetState('ringing', 'Squilla...');
            // Bind audio anche su progress (early media)
            _bindAudio();
        });

        session.on('terminated', () => {
            console.log('[Webphone] Chiamata terminata');
            this._wpEndCall();
        });
    },

    _wpEndCall() {
        // Notify backend of call end
        if (this._wpCurrentCallId) {
            const duration = this._wpSeconds;
            const status = duration > 0 ? 'called' : 'no-answer';
            this.api('/communications/api/pbx-calls/webphone', {
                method: 'POST', body: JSON.stringify({
                    event: 'call_end',
                    pbx_call_id: this._wpCurrentCallId,
                    phone_number: this._wpCurrentNumber || '',
                    duration: duration,
                    status: status
                }),
                headers: { 'Content-Type': 'application/json' }
            }).then(() => {
                console.log('[Webphone] Backend call_end OK, duration:', duration, 'status:', status);
            }).catch(e => console.warn('[Webphone] Backend call_end failed:', e));
        }
        this._wpCurrentCallId = null;
        this._wpCurrentNumber = null;
        this._wpCallDirection = null;
        this._wpSession = null;
        this._wpStopTimer();
        this._wpSetState('idle', this._wpConnected ? 'Connesso' : 'Telefono');
        document.getElementById('wp-call-btn').classList.remove('d-none');
        document.getElementById('wp-hangup-btn').classList.add('d-none');
        document.getElementById('wp-call-info').classList.add('d-none');
    },

    wpHangup() {
        if (this._wpSession) {
            try { this._wpSession.terminate(); } catch(e) {
                try { this._wpSession.bye(); } catch(e2) {}
            }
        }
        this._wpEndCall();
    },

    _wpSetState(state, label) {
        const widget = document.getElementById('webphone-widget');
        // Preserva i modificatori di posizione/apertura che non dipendono dallo stato chiamata
        const keep = ['wp-open', 'wp-floating'].filter(c => widget.classList.contains(c));
        widget.className = 'webphone-widget shadow-lg'
            + (state !== 'idle' ? ' ' + state : '')
            + (keep.length ? ' ' + keep.join(' ') : '');
        document.getElementById('wp-status').textContent = label;
    },

    _wpStartTimer() {
        this._wpSeconds = 0;
        this._wpTimer = setInterval(() => {
            this._wpSeconds++;
            const m = String(Math.floor(this._wpSeconds / 60)).padStart(2, '0');
            const s = String(this._wpSeconds % 60).padStart(2, '0');
            document.getElementById('wp-call-timer').textContent = `${m}:${s}`;
        }, 1000);
    },

    _wpStopTimer() {
        if (this._wpTimer) { clearInterval(this._wpTimer); this._wpTimer = null; }
    },

    wpQuickCall(phone) {
        document.getElementById('wp-number').value = phone;
        const body = document.getElementById('wp-body');
        if (body.style.display === 'none') this.toggleWebphone();
        // Non auto-chiamare: l'utente preme "Chiama" manualmente
    },
});


// ── app-ai-intel.js ──
/** Syrus Sales OS – AI Lead Intelligence Module */
Object.assign(SyrusApp, {

    // ── AI Pipeline (3-AI Lead Scoring & Transcription Analysis) ────────────

    async startAiPipeline(leadId, analysisType, transcriptId) {
        const payload = { lead_id: leadId, analysis_type: analysisType };
        if (transcriptId) payload.transcript_id = transcriptId;

        try {
            const res = await this.api('/ai/api/pipeline/start', {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            if (!res.ok) { this.toast(res.error || 'Errore avvio pipeline', 'danger'); return; }

            const jobId = res.job_id;
            const label = analysisType === 'transcription' ? 'Analisi Trascrizione AI' : 'Lead Scoring AI';

            // Track in ops widget with custom handling (don't auto-dismiss)
            this.trackOperation(jobId, 'scoring', label, `/ai/api/status/${jobId}`, null);

            // Start granular progress polling
            this._pollAiPipeline(jobId, leadId, analysisType);

        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _pollAiPipeline(jobId, leadId, analysisType) {
        const poll = async () => {
            try {
                const status = await this.api(`/ai/api/status/${jobId}`);
                const op = this._operations?.find(o => o.id === jobId);

                if (status.status === 'awaiting_confirmation') {
                    // Pipeline completed — show confirmation UI
                    if (op) { op.status = 'completed'; op.label = 'AI: in attesa di conferma'; this._renderOps(); }
                    this._showAiConfirmation(status.result, leadId, analysisType);
                } else if (status.status === 'failed') {
                    if (op) { op.status = 'failed'; this._renderOps(); }
                    this.toast('Pipeline AI fallita: ' + (status.error || 'errore sconosciuto'), 'danger');
                } else {
                    // Update progress message in widget
                    if (op && status.result?.progress_message) {
                        op.label = status.result.progress_message;
                        if (status.result.progress_lines) {
                            op.progressLines = status.result.progress_lines;
                        }
                        this._renderOps();
                    }
                    setTimeout(poll, 2000);
                }
            } catch (e) { setTimeout(poll, 3000); }
        };
        setTimeout(poll, 2000);
    },

    _showAiConfirmation(result, leadId, analysisType) {
        const data = result;
        const finalResult = data.final_result || {};
        const individual = data.individual_results || {};
        const synthesis = data.synthesis || {};
        const previousValues = data.previous_values;
        const analysisId = data.analysis_id;

        // Build individual results as structured cards
        const engines = Object.keys(individual).filter(k => !individual[k]._error && !individual[k]._parse_error);
        const failedEngines = Object.keys(individual).filter(k => individual[k]._error || individual[k]._parse_error);

        const renderAiResult = (r, name) => {
            const sentColors = { positivo: 'success', neutro: 'warning', negativo: 'danger' };
            const score = r.score ?? r.interesse ?? '-';
            const sentiment = r.sentiment || '-';
            const listRender = (items) => {
                if (!items || !items.length) return '<span class="text-muted">-</span>';
                return '<ul class="mb-0 ps-3 small">' + (Array.isArray(items) ? items : [items]).map(i => `<li>${this._escapeHtml(String(i))}</li>`).join('') + '</ul>';
            };
            let budgetStr = '-';
            if (r.budget_ai_min || r.budget_ai_max) budgetStr = `€${r.budget_ai_min || '?'} – €${r.budget_ai_max || '?'}`;
            else if (r.budget_menzionato) budgetStr = r.budget_menzionato;

            return `<div class="border rounded p-3 mb-2">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold">${name}</span>
                    <span class="badge bg-${sentColors[sentiment] || 'secondary'}">${this._escapeHtml(sentiment)}</span>
                </div>
                <div class="row g-2 mb-2">
                    <div class="col-4 text-center"><div class="fs-5 fw-bold">${score}</div><small class="text-muted">${r.score !== undefined ? 'Score /100' : 'Interesse /10'}</small></div>
                    <div class="col-4"><small class="text-muted">Budget</small><div class="small fw-medium">${this._escapeHtml(budgetStr)}</div></div>
                    <div class="col-4"><small class="text-muted">Timeline</small><div class="small">${this._escapeHtml(r.timeline_ai || r.timeline || '-')}</div></div>
                </div>
                ${r.pain_points ? `<div class="mb-1"><small class="text-muted fw-bold">Pain Points</small>${listRender(r.pain_points)}</div>` : ''}
                ${r.obiezioni ? `<div class="mb-1"><small class="text-muted fw-bold">Obiezioni</small>${listRender(r.obiezioni)}</div>` : ''}
                ${r.azioni_raccomandate ? `<div class="mb-1"><small class="text-muted fw-bold">Azioni</small>${listRender(r.azioni_raccomandate)}</div>` : ''}
                ${r.riepilogo_esecutivo ? `<div class="mb-1"><small class="text-muted fw-bold">Riepilogo</small><div class="small">${this._escapeHtml(r.riepilogo_esecutivo)}</div></div>` : ''}
                ${r.action_items ? `<div class="mb-1"><small class="text-muted fw-bold">Action Items</small>${listRender(r.action_items)}</div>` : ''}
            </div>`;
        };

        const engineCards = engines.map(eng => {
            const safeName = this._escapeHtml(eng.charAt(0).toUpperCase() + eng.slice(1));
            return renderAiResult(individual[eng], `${safeName} <i class="fa-solid fa-circle-check text-success ms-1"></i>`);
        }).join('');
        const failedCards = failedEngines.map(eng =>
            `<div class="border rounded p-3 mb-2 bg-light"><span class="fw-bold text-muted">${eng.charAt(0).toUpperCase() + eng.slice(1)}</span> <span class="badge bg-danger">Non ha risposto</span><div class="small text-muted mt-1">${this._escapeHtml(individual[eng]._error || 'Parse error')}</div></div>`
        ).join('');

        // Build diff table if this is an update
        let diffHtml = '';
        if (previousValues) {
            const diffRows = [];
            const fieldLabels = {
                score: 'Score', sentiment: 'Sentiment', budget_ai_min: 'Budget Min',
                budget_ai_max: 'Budget Max', timeline_ai: 'Timeline',
                pain_points: 'Pain Points', obiezioni: 'Obiezioni',
                azioni_raccomandate: 'Azioni Raccomandate'
            };
            for (const [key, label] of Object.entries(fieldLabels)) {
                const prev = previousValues[key];
                const curr = finalResult[key];
                const prevStr = Array.isArray(prev) ? prev.join(', ') : String(prev ?? '-');
                const currStr = Array.isArray(curr) ? curr.join(', ') : String(curr ?? '-');
                if (prevStr !== currStr) {
                    diffRows.push(`<tr>
                        <td class="fw-medium small">${label}</td>
                        <td class="small text-muted">${this._escapeHtml(prevStr)}</td>
                        <td class="small text-primary fw-medium">${this._escapeHtml(currStr)}</td>
                        <td class="small">${prevStr === '-' ? '<span class="badge bg-success">Nuovo</span>' : '<span class="badge bg-warning text-dark">Cambiato</span>'}</td>
                    </tr>`);
                }
            }
            if (diffRows.length > 0) {
                diffHtml = `
                    <div class="alert alert-info mb-3">
                        <i class="fa-solid fa-code-compare me-2"></i><strong>Aggiornamento v${data.version}</strong> — ${diffRows.length} campi modificati rispetto alla v${previousValues.version || 1}
                    </div>
                    <div class="table-responsive mb-3">
                        <table class="table table-sm table-bordered">
                            <thead class="table-light"><tr><th>Campo</th><th>Valore Attuale</th><th>Proposta AI</th><th>Diff</th></tr></thead>
                            <tbody>${diffRows.join('')}</tbody>
                        </table>
                    </div>`;
            }
        }

        // Synthesis reasoning
        const confronto = synthesis.confronto || {};
        const reasoningHtml = confronto.ragionamento_sintesi
            ? `<div class="card bg-light border-0 mb-3">
                <div class="card-body small">
                    <strong><i class="fa-solid fa-brain me-1"></i>Ragionamento Claude:</strong>
                    <p class="mb-0 mt-1">${this._escapeHtml(confronto.ragionamento_sintesi)}</p>
                </div>
              </div>` : '';

        this._showModal(
            `<i class="fa-solid fa-brain me-2"></i>Conferma Analisi AI (${analysisType === 'transcription' ? 'Trascrizione' : 'Lead Scoring'})`,
            `${diffHtml}
            ${reasoningHtml}

            <h6 class="fw-bold mb-2"><i class="fa-solid fa-star me-1 text-primary"></i>Risultato Finale Claude</h6>
            ${renderAiResult(finalResult, 'Sintesi Finale')}

            <details class="mb-3">
                <summary class="fw-medium small text-muted" style="cursor:pointer"><i class="fa-solid fa-eye me-1"></i>Mostra risultati individuali (${engines.length} AI risposte, ${failedEngines.length} fallite)</summary>
                <div class="mt-2">${engineCards}${failedCards}</div>
            </details>

            <details class="mb-3">
                <summary class="fw-medium small text-muted" style="cursor:pointer"><i class="fa-solid fa-code me-1"></i>Mostra JSON raw (debug)</summary>
                <pre class="small bg-light p-3 rounded mt-2" style="max-height:200px;overflow:auto">${this._escapeHtml(JSON.stringify(finalResult, null, 2))}</pre>
            </details>

            <div class="d-flex gap-2 justify-content-end">
                <button class="btn btn-secondary" onclick="SyrusApp._rejectAiAnalysis('${analysisId}')">
                    <i class="fa-solid fa-xmark me-1"></i>Annulla
                </button>
                <button class="btn btn-success" onclick="SyrusApp._acceptAiAnalysis('${analysisId}', '${leadId}')">
                    <i class="fa-solid fa-check me-1"></i>Accetta e Salva
                </button>
            </div>`,
            'modal-lg'
        );
    },

    async _acceptAiAnalysis(analysisId, leadId) {
        try {
            const result = await this.api('/ai/api/pipeline/accept', {
                method: 'POST',
                body: JSON.stringify({ analysis_id: analysisId }),
            });
            if (!result.ok) {
                this.toast(result.error || 'Errore', 'danger');
                return;
            }
            this.toast('Analisi AI accettata e salvata', 'success');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            // Refresh DOM solo se siamo sulla lead detail page (gli elementi esistono)
            const onLeadDetail = !!document.getElementById('rubrica-sidebar');
            if (onLeadDetail) {
                try { this.loadAiIntelligence(leadId); } catch (e) { console.warn('loadAiIntelligence:', e); }
                try { this.loadLeadDetail(leadId); } catch (e) { console.warn('loadLeadDetail:', e); }
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _rejectAiAnalysis(analysisId, isAccepted, leadId) {
        if (isAccepted) {
            // Case B: confirmed analysis — require explicit confirmation
            if (!confirm('Vuoi eliminare l\'analisi AI di questa lead?\n\nPerderai score, pain points e tutte le informazioni generate. Questa azione è irreversibile.')) return;
        }
        try {
            await this.api('/ai/api/pipeline/reject', {
                method: 'POST',
                body: JSON.stringify({ analysis_id: analysisId }),
            });
            this.toast(isAccepted ? 'Analisi eliminata' : 'Analisi annullata', 'warning');
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            const onLeadDetail = !!document.getElementById('rubrica-sidebar');
            if (leadId && onLeadDetail) {
                try { this.loadAiIntelligence(leadId); } catch (e) { console.warn('loadAiIntelligence:', e); }
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── AI Lead Intelligence Panel (permanent sidebar) ──────────────────────

    _renderCallInterest(ci) {
        if (!ci || ci.score == null) return '';
        const color = ci.score >= 7 ? 'success' : ci.score >= 4 ? 'warning' : 'danger';
        const sentColors = { positivo: 'success', neutro: 'warning', negativo: 'danger' };
        const sentColor = sentColors[ci.sentiment] || 'secondary';
        return `
            <div class="alert alert-light border py-2 px-3 mb-3" style="font-size:13px">
                <div class="d-flex align-items-center justify-content-between">
                    <div><i class="fa-solid fa-phone-volume me-1 text-primary"></i><strong>Interesse da telefonata</strong></div>
                    <div><span class="badge bg-${color} fs-6">${ci.score}/10</span></div>
                </div>
                <div class="mt-1 small text-muted">
                    Sentiment: <span class="badge bg-${sentColor}">${this._escapeHtml(ci.sentiment || '-')}</span>
                    ${ci.date ? ` · ${this.formatDate(ci.date)}` : ''}
                </div>
            </div>`;
    },

    _renderAnalysisData(a, leadId) {
        const sentimentColors = { positivo: 'success', neutro: 'warning', negativo: 'danger' };
        const sentimentColor = sentimentColors[a.sentiment_label] || 'secondary';
        const score = a.lead_score ?? '-';
        const scoreColor = score >= 70 ? 'success' : score >= 40 ? 'warning' : score > 0 ? 'danger' : 'secondary';
        const listHtml = (items) => {
            if (!items || !items.length) return '<span class="text-muted small">-</span>';
            if (typeof items === 'string') return `<span class="small">${this._escapeHtml(items)}</span>`;
            return '<ul class="mb-0 ps-3 small">' + items.slice(0, 5).map(i => '<li>' + this._escapeHtml(String(i)) + '</li>').join('') + '</ul>';
        };
        let budgetStr = '-';
        if (a.budget_ai_min || a.budget_ai_max) {
            budgetStr = `€${a.budget_ai_min || '?'} – €${a.budget_ai_max || '?'}`;
        }
        return `
            <div class="row g-2 mb-3">
                <div class="col-6 text-center"><div class="fs-2 fw-bold text-${scoreColor}">${score}</div><small class="text-muted">Score /100</small></div>
                <div class="col-6 text-center"><span class="badge bg-${sentimentColor} fs-6">${this._escapeHtml(a.sentiment_label || '-')}</span><br><small class="text-muted">Sentiment</small></div>
            </div>
            <div class="mb-2"><small class="text-muted fw-bold">Budget AI</small><div class="small fw-medium">${this._escapeHtml(budgetStr)}</div></div>
            ${a.timeline_detected ? `<div class="mb-2"><small class="text-muted fw-bold">Timeline</small><div class="small">${this._escapeHtml(a.timeline_detected)}</div></div>` : ''}
            <div class="mb-2"><small class="text-muted fw-bold">Pain Points <span class="badge bg-info text-white" style="font-size:9px">AI</span></small>${listHtml(a.pain_points)}</div>
            <div class="mb-2"><small class="text-muted fw-bold">Obiezioni <span class="badge bg-info text-white" style="font-size:9px">AI</span></small>${listHtml(a.objections)}</div>
            <div class="mb-3"><small class="text-muted fw-bold">Azioni <span class="badge bg-info text-white" style="font-size:9px">AI</span></small>${listHtml(a.recommended_actions)}</div>
            <div class="text-muted" style="font-size:11px"><i class="fa-solid fa-robot me-1"></i>
                ${this.formatDate(a.created_at)} · ${this._escapeHtml(a.engines_used || '?')} · v${a.version || 1}
            </div>
            ${a.context_summary ? this._renderContextSummary(a.context_summary, a.created_at) : ''}`;
    },

    _renderContextSummary(ctx, date) {
        if (!ctx || typeof ctx !== 'object') return '';
        const ts = ctx.transcriptions || [];
        const comms = ctx.communications || {};
        const er = ctx.engine_results || {};
        const engines = Object.entries(er);
        const totalComms = (comms.emails || 0) + (comms.sms || 0) + (comms.whatsapp || 0);

        let transLines = ts.length ? ts.map(t =>
            `<div class="small ps-3">• ${this._escapeHtml(t.filename)} — ${t.duration} — ${t.has_summary ? 'analizzata con AI ✓' : 'testo grezzo ⚠'}</div>`
        ).join('') : '<div class="small text-muted ps-3">Nessuna trascrizione</div>';

        let engineLines = engines.map(([eng, status]) => {
            const icon = status === 'successo' ? '✓' : '✗';
            const color = status === 'successo' ? 'text-success' : 'text-danger';
            return `<span class="${color} fw-medium">${eng.charAt(0).toUpperCase() + eng.slice(1)} ${icon}</span>`;
        }).join('  ');
        const successCount = engines.filter(([, s]) => s === 'successo').length;

        return `
            <details class="mt-2 mb-2" style="font-size:12px">
                <summary class="text-muted fw-medium" style="cursor:pointer">
                    <i class="fa-solid fa-clipboard-list me-1"></i>Basata su (${date ? this.formatDate(date) : '?'})
                </summary>
                <div class="mt-2 ps-2 border-start border-2">
                    <div class="mb-1"><i class="fa-solid fa-microphone me-1"></i>${ts.length} trascrizioni</div>
                    ${transLines}
                    <div class="mb-1 mt-2"><i class="fa-solid fa-envelope me-1"></i>Comunicazioni: ${totalComms > 0 ? `${totalComms} (${comms.period || '30gg'})` : 'nessuna nel periodo'}</div>
                    <div class="mb-1"><i class="fa-solid fa-file me-1"></i>Documenti: ${ctx.documents || 0}</div>
                    <div class="mt-2"><i class="fa-solid fa-robot me-1"></i>AI: ${engineLines} — Sintesi su ${successCount}/${engines.length}</div>
                </div>
            </details>`;
    },

    async loadAiIntelligence(leadId) {
        const emptyEl = document.getElementById('ai-intel-empty');
        const dataEl = document.getElementById('ai-intel-data');
        const versionBadge = document.getElementById('ai-version-badge');
        if (!dataEl) return;

        try {
            const resp = await this.api(`/ai/api/pipeline/latest/${leadId}`);

            // ── Missing summaries warning ────────────────────────────────
            let missingWarning = '';
            if (resp.missing_summaries > 0) {
                missingWarning = `
                    <div class="alert alert-warning py-2 mb-2 small">
                        <i class="fa-solid fa-triangle-exclamation me-1"></i>
                        <strong>${resp.missing_summaries} trascrizioni</strong> senza riepilogo AI.
                        Per un'analisi completa, genera prima i riepiloghi.
                        <div class="mt-2 d-flex gap-2">
                            <button class="btn btn-warning btn-sm" onclick="SyrusApp._generateMissingSummaries('${leadId}')">
                                <i class="fa-solid fa-robot me-1"></i>Genera riepiloghi mancanti
                            </button>
                            <button class="btn btn-outline-secondary btn-sm" onclick="SyrusApp.startAiPipeline('${leadId}', 'scoring')">
                                Procedi comunque
                            </button>
                        </div>
                    </div>`;
            }

            // ── State 2: Pending confirmation ────────────────────────────
            if (resp.has_pending) {
                if (emptyEl) emptyEl.style.display = 'none';
                dataEl.style.display = 'block';
                if (versionBadge) { versionBadge.textContent = 'pending'; versionBadge.style.display = 'inline'; versionBadge.className = 'badge bg-warning text-dark'; }

                const p = resp.pending;
                dataEl.innerHTML = `
                    ${missingWarning}
                    <div class="alert alert-warning py-2 mb-3">
                        <i class="fa-solid fa-clock me-1"></i>
                        <strong>Analisi in attesa di conferma</strong>
                        <div class="small text-muted">${this.formatDate(p.created_at)} · ${this._escapeHtml(p.engines_used || '?')}</div>
                    </div>
                    ${this._renderAnalysisData(p, leadId)}
                    <div class="d-flex gap-2 mt-2">
                        <button class="btn btn-success btn-sm flex-grow-1" onclick="SyrusApp._acceptAiAnalysis('${p.id}', '${leadId}')">
                            <i class="fa-solid fa-check me-1"></i>Accetta e Salva
                        </button>
                        <button class="btn btn-outline-primary btn-sm" onclick="SyrusApp._reopenConfirmation('${leadId}', '${p.id}')">
                            <i class="fa-solid fa-eye me-1"></i>Rivedi
                        </button>
                        <button class="btn btn-outline-danger btn-sm" onclick="SyrusApp._rejectAiAnalysis('${p.id}', false, '${leadId}')">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>`;
                return;
            }

            // ── State 3: Accepted analysis ───────────────────────────────
            if (resp.has_analysis) {
                if (emptyEl) emptyEl.style.display = 'none';
                dataEl.style.display = 'block';
                const a = resp.accepted;
                if (versionBadge) { versionBadge.textContent = `v${a.version || 1}`; versionBadge.style.display = 'inline'; versionBadge.className = 'badge bg-white text-primary'; }
                dataEl.innerHTML = missingWarning + this._renderCallInterest(resp.call_interest) + this._renderAnalysisData(a, leadId) + `
                    <button class="btn btn-outline-primary btn-sm w-100 mt-2" onclick="SyrusApp._confirmUpdateAnalysis('${leadId}')">
                        <i class="fa-solid fa-rotate me-1"></i>Aggiorna Analisi
                    </button>
                    <button class="btn btn-outline-danger btn-sm w-100 mt-1" onclick="SyrusApp._rejectAiAnalysis('${a.id}', true, '${leadId}')" style="font-size:11px">
                        <i class="fa-solid fa-trash me-1"></i>Elimina Analisi
                    </button>`;
                const scoreHeader = document.getElementById('lead-score-header');
                if (scoreHeader) scoreHeader.textContent = `${a.lead_score ?? '-'}/100`;
                // Aggiorna budget header SOLO se non c'è override manuale.
                // Se l'utente ha modificato manualmente il budget (es. cliente
                // consolidato con prezzi storici), il valore deve restare.
                const budgetHeader = document.getElementById('lead-budget-header');
                if (budgetHeader && budgetHeader.dataset.manualOverride !== '1') {
                    let budgetStr = '';
                    if (a.budget_ai_min && a.budget_ai_max) {
                        budgetStr = `€${Math.round(a.budget_ai_min).toLocaleString('it-IT')} – €${Math.round(a.budget_ai_max).toLocaleString('it-IT')}`;
                    } else if (a.budget_ai_min) {
                        budgetStr = `€${Math.round(a.budget_ai_min).toLocaleString('it-IT')}`;
                    }
                    if (budgetStr) {
                        budgetHeader.innerHTML = `${budgetStr} <span class="badge bg-info text-white ms-1" style="font-size:9px;vertical-align:middle">AI</span> <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>`;
                    }
                }
                return;
            }

            // ── State 1: No analysis ─────────────────────────────────────
            if (emptyEl) {
                emptyEl.style.display = 'block';
                emptyEl.innerHTML = `
                    ${this._renderCallInterest(resp.call_interest)}
                    <i class="fa-solid fa-brain fa-3x text-primary mb-3 d-block opacity-50"></i>
                    <p class="fw-medium mb-2">Nessuna analisi AI disponibile</p>
                    <p class="text-muted small mb-3">Avvia il Lead Scoring AI per ottenere score, sentiment, pain points e azioni raccomandate.</p>
                    ${missingWarning}
                    ${!missingWarning ? `<button class="btn btn-primary" onclick="SyrusApp.startAiPipeline('${leadId}', 'scoring')"><i class="fa-solid fa-brain me-1"></i> Avvia AI Lead Scoring</button>` : ''}`;
            }
            dataEl.style.display = 'none';
            if (versionBadge) versionBadge.style.display = 'none';

        } catch (e) { /* silent */ }
    },

    async _reopenConfirmation(leadId, analysisId) {
        try {
            const resp = await this.api(`/ai/api/pipeline/latest/${leadId}`);
            if (resp.pending) {
                const p = resp.pending;
                this._showAiConfirmation({
                    analysis_id: p.id,
                    version: p.version,
                    final_result: p.full_result || {},
                    individual_results: p.individual_results || {},
                    synthesis: p.synthesis || {},
                    previous_values: resp.accepted || null,
                }, leadId, p.analysis_type || 'scoring');
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _generateMissingSummaries(leadId) {
        this.toast('Generazione riepiloghi mancanti avviata...', 'info');
        try {
            const data = await this.api(`/leads/api/${leadId}/calls-and-transcriptions`);
            const items = (data.items || []).filter(i => i.transcription_id && i.transcription_status === 'completed' && !i.has_summary);
            if (!items.length) { this.toast('Nessun riepilogo mancante', 'info'); return; }
            for (const item of items) {
                this.trackOperation(`summary-${item.transcription_id}`, 'summary',
                    `Riepilogo: ${this._escapeHtml((item.label || 'Audio').substring(0, 30))}`,
                    `/ai/api/status/placeholder`, null);
                try {
                    await this.api(`/deepgram/api/${item.transcription_id}/summarize`, { method: 'POST', body: JSON.stringify({}) });
                } catch (e) { /* continue with others */ }
            }
            this.toast(`${items.length} riepiloghi avviati. Al termine, avvia il Lead Scoring.`, 'success');
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    async _confirmUpdateAnalysis(leadId) {
        // Compare current context with last analysis context to show what's new
        try {
            const resp = await this.api(`/ai/api/pipeline/latest/${leadId}`);
            const lastCtx = resp.accepted?.context_summary;
            const currentCtx = await this.api(`/leads/api/${leadId}/calls-and-transcriptions`);
            const currentComms = await this.api(`/leads/api/${leadId}/communications`);

            const lastTransCount = lastCtx?.transcriptions?.length || 0;
            const lastCommsCount = (lastCtx?.communications?.emails || 0) + (lastCtx?.communications?.sms || 0) + (lastCtx?.communications?.whatsapp || 0);
            const currentTransCount = (currentCtx.items || []).filter(i => i.transcription_status === 'completed').length;
            const currentCommsCount = (currentComms.items || []).length;

            const newTrans = currentTransCount - lastTransCount;
            const newComms = currentCommsCount - lastCommsCount;

            let message = '';
            if (newTrans > 0 || newComms > 0) {
                let parts = [];
                if (newTrans > 0) parts.push(`+${newTrans} trascrizioni`);
                if (newComms > 0) parts.push(`+${newComms} comunicazioni`);
                message = `Nuovi elementi disponibili:\n• ${parts.join('\n• ')}\n\nAvviare l'aggiornamento?`;
            } else {
                message = `Nessun nuovo elemento dall'ultima analisi.\nVuoi comunque rieseguire?`;
            }

            if (confirm(message)) {
                this.startAiPipeline(leadId, 'scoring');
            }
        } catch (e) {
            // Fallback: just start without comparison
            if (confirm('Avviare aggiornamento analisi AI?')) {
                this.startAiPipeline(leadId, 'scoring');
            }
        }
    },

    // ── Lead WhatsApp Chat Tab ──────────────────────────────────────────────
    // Monta il pannello chat completo del chat-app (stesse funzioni dell'inbox,
    // portate da Connect: emoji, allegati, vocali, template, finestra 24h)
    // dentro #wa-app-main nel dettaglio lead.

    async loadLeadWhatsapp(leadId) {
        const main = document.getElementById('wa-app-main');
        if (!main) return;

        try {
            // L'endpoint lead individua (e auto-collega) la conversazione più recente
            const data = await this.api(`/leads/api/${leadId}/whatsapp-messages`);
            if (!data.phone_number_id || !data.wa_id) {
                main.innerHTML = `<div class="wa-lead-chat-empty">
                    <i class="fa-brands fa-whatsapp"></i>
                    <h6 class="fw-bold">Nessuna conversazione WhatsApp</h6>
                    <p class="text-muted small mb-3">Il primo contatto deve partire da un template approvato Meta.</p>
                    <button class="btn btn-success btn-sm" data-phone="${this._escapeAttr(data.lead_phone || '')}" onclick="SyrusApp.showSendWhatsappModal('${leadId}', this.dataset.phone)">
                        <i class="fa-brands fa-whatsapp me-1"></i>Invia Template
                    </button>
                </div>`;
                return;
            }

            // Metadati conversazione (nome contatto, finestra 24h, assegnatario)
            // necessari a selectChatAppConversation per header e lock dell'input
            try {
                const convs = await this.api(`/whatsapp/api/conversations-rich?mode=all&pnid=${encodeURIComponent(data.phone_number_id)}`);
                this._chatAppConvs = convs || [];
            } catch (e) { this._chatAppConvs = []; }

            await this.selectChatAppConversation(data.phone_number_id, data.wa_id);
        } catch (e) {
            main.innerHTML = `<div class="text-center py-5 text-muted">Errore caricamento: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    /**
     * Render contenuto messaggio WhatsApp (testo, audio, immagine, video, doc, template).
     */
    _renderWaMessageContent(m) {
        if (m.type === 'template' && typeof m.content === 'object') {
            return this._renderTemplateContent(m.content);
        }
        if (m.type === 'audio' && m.media_url) {
            return `<audio controls preload="none" style="max-width:100%;height:36px"><source src="${m.media_url}" type="${m.content?.mime_type || 'audio/ogg'}"></audio>`;
        }
        if (m.type === 'image' && m.media_url) {
            const caption = m.content?.caption ? `<div class="mt-1">${this._escapeHtml(m.content.caption)}</div>` : '';
            return `<img src="${m.media_url}" style="max-width:100%;border-radius:6px;cursor:pointer" onclick="window.open('${m.media_url}','_blank')">${caption}`;
        }
        if (m.type === 'video' && m.media_url) {
            return `<video controls preload="none" style="max-width:100%;border-radius:6px"><source src="${m.media_url}" type="${m.content?.mime_type || 'video/mp4'}"></video>`;
        }
        if (m.type === 'document' && m.media_url) {
            const fname = m.content?.filename || m.content?.local_filename || 'documento';
            return `<a href="${m.media_url}" target="_blank" class="d-flex align-items-center gap-2 text-decoration-none"><i class="fa-solid fa-file-arrow-down"></i> ${this._escapeHtml(fname)}</a>`;
        }
        return this._escapeHtml(m.text || m.content || '');
    },

    async _sendLeadWaMessage(leadId, pnid, waId) {
        const input = document.getElementById('lead-wa-input');
        const text = input?.value?.trim();
        if (!text) return;
        try {
            const result = await this.api('/whatsapp/api/messages/send', {
                method: 'POST',
                body: JSON.stringify({ phone_number_id: pnid, to: waId, type: 'text', text, lead_id: leadId })
            });
            if (result.ok === false) {
                if (result.needs_confirmation && confirm(result.reason)) {
                    await this.api('/whatsapp/api/messages/send', {
                        method: 'POST',
                        body: JSON.stringify({ phone_number_id: pnid, to: waId, type: 'text', text, force: true, lead_id: leadId })
                    });
                } else if (result.ok === false) {
                    this.toast(result.error || result.reason || 'Errore invio', 'danger');
                    return;
                }
            }
            input.value = '';
            this.loadLeadWhatsapp(leadId);
            // Refresh timeline + polling status delivery/read
            setTimeout(() => this._loadTimeline(leadId), 1500);
            this._startWaStatusPoll(leadId);
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    /**
     * Polling breve per status WhatsApp (sent → delivered → read).
     * Ricarica tab WA ogni 5s per 2 minuti dopo invio.
     */
    _startWaStatusPoll(leadId) {
        if (this._waStatusPollTimer) clearInterval(this._waStatusPollTimer);
        let attempts = 0;
        this._waStatusPollTimer = setInterval(() => {
            attempts++;
            if (attempts > 24) { // 2 minuti
                clearInterval(this._waStatusPollTimer);
                this._waStatusPollTimer = null;
                return;
            }
            this.loadLeadWhatsapp(leadId);
        }, 5000);
    },

    // ── Lead Comunicazioni Tab (email + SMS unified) ────────────────────────

    async loadLeadComms(leadId) {
        const el = document.getElementById('lead-comms-list');
        const countBadge = document.getElementById('comms-count');
        if (!el) return;

        try {
            const data = await this.api(`/leads/api/${leadId}/communications`);
            const items = data.items || [];
            if (countBadge) countBadge.textContent = items.length;

            if (!items.length) {
                el.innerHTML = '<div class="text-center py-5 text-muted"><i class="fa-solid fa-envelope fa-2x mb-2 d-block opacity-25"></i>Nessuna comunicazione email o SMS</div>';
                return;
            }

            // Layout coerente col registro chiamate: orario a sinistra,
            // icona canale, oggetto/destinatario, chip di stato a destra
            const statusLabels = { sent: 'Inviata', delivered: 'Consegnata', opened: 'Aperta', clicked: 'Cliccata', failed: 'Fallita', bounced: 'Bounce', received: 'Ricevuta', queued: 'In coda', error: 'Errore' };

            el.innerHTML = items.map(item => {
                const isEmail = item.channel === 'email';
                const inbound = item.direction === 'inbound';
                const statusLabel = statusLabels[item.status] || item.status || '';
                const preview = isEmail ? (item.preview || '') : (item.text || '');
                const clickAttr = isEmail && item.id
                    ? `onclick="SyrusApp.showEmailPreview('${item.id}')" title="Apri dettaglio email"`
                    : '';
                const arrow = inbound
                    ? '<i class="fa-solid fa-arrow-down call-arrow in"></i>'
                    : '<i class="fa-solid fa-arrow-up call-arrow out"></i>';
                return `<div class="call-log-item comm-item${clickAttr ? '' : ' no-preview'}" ${clickAttr}>
                    ${this._tlWhenHtml(item.date)}
                    <div class="call-log-dir ${inbound ? 'in' : 'out'}">
                        <div class="call-log-dir-label">${arrow}${inbound ? 'In entrata' : 'In uscita'}</div>
                        <div class="call-log-sub"><span>${isEmail ? 'Email' : 'SMS'}</span></div>
                    </div>
                    <div class="flex-grow-1" style="min-width:0">
                        <div class="comm-subject">${this._escapeHtml(isEmail ? (item.subject || 'Senza oggetto') : 'SMS')}</div>
                        ${preview ? `<div class="comm-preview">${this._escapeHtml(preview)}</div>` : ''}
                        <div class="comm-to">${inbound ? 'Da' : 'A'}: ${this._escapeHtml(item.to || '')}</div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="comm-status ${item.status || 'sent'}">${this._escapeHtml(statusLabel)}</span>
                    </div>
                </div>`;
            }).join('');

        } catch (e) {
            el.innerHTML = `<div class="p-3 text-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    // ── Lead Telefonate & Trascrizioni Tab ──────────────────────────────────

    /** Oltre questa lunghezza la trascrizione non si srotola dentro la riga:
     *  diventa un muro di testo che sposta tutto il resto. Si apre la modale. */
    _TRANSCRIPT_INLINE_MAX: 1200,

    /** Riga "trascrizione" di una chiamata o di una registrazione: inline se
     *  corta, modale se lunga. Unico punto per entrambe le liste. */
    _transcriptRowHtml(transcriptionId, chars) {
        if ((chars || 0) > this._TRANSCRIPT_INLINE_MAX) {
            return `<button type="button" class="sy-voice-trbtn" onclick="SyrusApp.dgShowTranscript('${transcriptionId}')" title="Trascrizione lunga: si apre in una finestra">
                    <i class="fa-solid fa-closed-captioning"></i> Apri trascrizione
                </button>`;
        }
        return `<button type="button" class="sy-voice-trbtn" data-trid="${transcriptionId}" onclick="SyrusApp.callToggleTranscript(this)">
                <i class="fa-solid fa-closed-captioning"></i> Mostra trascrizione
            </button>
            <div class="sy-voice-transcript" hidden></div>`;
    },

    async loadLeadCallsAndTranscriptions(leadId) {
        const el = document.getElementById('lead-calls-list');
        const countBadge = document.getElementById('calls-count');
        if (!el) return;

        try {
            const data = await this.api(`/leads/api/${leadId}/calls-and-transcriptions`);
            const items = data.items || [];
            if (countBadge) countBadge.textContent = items.length;

            if (!items.length) {
                el.innerHTML = '<div class="text-center py-5 text-muted"><i class="fa-solid fa-phone fa-2x mb-2 d-block opacity-25"></i>Nessuna telefonata o trascrizione</div>';
                return;
            }

            // Registro stile smartphone: colonne orario / direzione / audio / azioni
            let html = '';
            items.forEach(item => {

                // Durata trascrizione (può differire dalla chiamata)
                const trDur = item.transcription_duration ? `${Math.floor(item.transcription_duration / 60)}:${(item.transcription_duration % 60).toString().padStart(2, '0')}` : '';

                // Status leggibile
                const statusLabels = { 'answered': 'Risposta', 'called': 'Risposta', 'no-answer': 'Senza risposta', 'busy': 'Occupato', 'failed': 'Fallita', 'reached': 'Risposta' };
                const statusLabel = statusLabels[item.call_status] || item.call_status || '';
                // Se dura più di 20 secondi è stata sicuramente risposta,
                // qualunque cosa dica lo status del PBX
                const isAnswered = ['answered', 'called', 'reached'].includes(item.call_status) || (item.duration || 0) > 20;
                const missed = !isAnswered;

                const dirIn = item.direction === 'inbound';
                const dirClass = missed ? 'missed' : (dirIn ? 'in' : 'out');
                const dirLabel = dirIn ? 'In entrata' : 'In uscita';
                const arrow = dirIn
                    ? '<i class="fa-solid fa-arrow-down call-arrow in"></i>'
                    : '<i class="fa-solid fa-arrow-up call-arrow out"></i>';

                let badges = '';
                if (item.transcription_status === 'completed') {
                    badges += `<span class="badge bg-success me-1">Trascritto${trDur ? ' · ' + trDur : ''}</span>`;
                } else if (item.transcription_status === 'processing') {
                    badges += '<span class="badge bg-warning text-dark me-1">In elaborazione</span>';
                }
                if (item.has_summary) {
                    badges += '<span class="badge bg-info me-1">Analizzato</span>';
                }

                // Player vocale stile WhatsApp (Connect) + trascrizione inline
                let actions = '';
                let audioPlayerHtml = '';
                let transcriptHtml = '';
                if (isAnswered) {
                    if (item.has_audio && item.audio_url) {
                        audioPlayerHtml = `<div class="sy-voice">
                            <audio preload="metadata" src="${item.audio_url}"></audio>
                            <button type="button" class="sy-voice-play" title="Riproduci"><i class="fa-solid fa-play"></i></button>
                            <div class="sy-voice-track"><div class="sy-voice-fill"></div><div class="sy-voice-knob"></div></div>
                            <span class="sy-voice-clock">--:-- / --:--</span>
                            <button type="button" class="sy-voice-speed" title="Velocità">1×</button>
                        </div>`;
                    }
                    if (item.transcription_id && item.transcription_status === 'completed') {
                        transcriptHtml = this._transcriptRowHtml(item.transcription_id, item.transcript_chars);
                        actions += `<button type="button" class="btn-ai-sparkle${item.has_summary ? ' has-ai' : ''}" onclick="SyrusApp.dgSummarize('${item.transcription_id}', false, this)" title="Riepilogo AI" data-ai-hint-title="Riepilogo AI" data-ai-hint="${item.has_summary ? 'Riapre il riepilogo gia\u0027 generato per questa registrazione.' : 'Legge la trascrizione e ne ricava un riepilogo: punti toccati, impegni presi e prossimi passi.'}">${this._aiSparkleSvg(16)}</button>`;
                    } else if (item.transcription_id && item.transcription_status === 'processing') {
                        transcriptHtml = `<span class="sy-voice-trbtn" style="cursor:default"><i class="fa-solid fa-spinner fa-spin"></i> Trascrizione in corso…</span>`;
                    } else if (item.has_audio && !item.transcription_id && item.contact_log_id) {
                        transcriptHtml = `<button type="button" class="sy-voice-trbtn" onclick="SyrusApp.clTranscribe('${item.contact_log_id}')">
                                <i class="fa-solid fa-closed-captioning"></i> Trascrivi
                            </button>`;
                    }
                }

                html += `<div class="call-log-item">
                    ${this._tlWhenHtml(item.date)}
                    <div class="call-log-dir ${dirClass}">
                        <div class="call-log-dir-label">${arrow}${dirLabel}</div>
                        ${missed && statusLabel ? `<div class="call-log-sub"><span>${statusLabel}</span></div>` : ''}
                        ${item.speakers ? `<div class="call-log-sub"><span>${item.speakers} speaker</span></div>` : ''}
                        ${item.phone_number ? `<div class="call-log-sub fw-bold" style="color:#1B3A5C">${this._escapeHtml(item.phone_number)}</div>` : ''}
                        ${badges ? `<div class="mt-1">${badges}</div>` : ''}
                    </div>
                    <div class="call-log-media">
                        ${audioPlayerHtml || '<span class="text-muted" style="font-size:12px">Nessuna registrazione</span>'}
                        ${transcriptHtml}
                    </div>
                    <div class="call-log-actions">${actions}</div>
                </div>`;
            });
            el.innerHTML = html;
            this._initVoicePlayers(el);

        } catch (e) {
            el.innerHTML = `<div class="p-3 text-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    /**
     * Player registrazioni chiamate: pillola in stile piattaforma (accento blu),
     * play/pausa, seek sulla barra di avanzamento, contatore corrente/totale,
     * velocità 1×/1.5×/2×, un solo audio in riproduzione alla volta.
     */
    _initVoicePlayers(root) {
        const fmt = (s) => {
            if (!isFinite(s)) return '--:--';
            s = Math.max(0, Math.round(s));
            return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
        };
        root.querySelectorAll('.sy-voice').forEach(v => {
            if (v.dataset.init) return;
            v.dataset.init = '1';
            const audio = v.querySelector('audio');
            const playBtn = v.querySelector('.sy-voice-play');
            const track = v.querySelector('.sy-voice-track');
            const fill = v.querySelector('.sy-voice-fill');
            const knob = v.querySelector('.sy-voice-knob');
            const clock = v.querySelector('.sy-voice-clock');
            const speedBtn = v.querySelector('.sy-voice-speed');
            let raf = null;
            const paint = () => {
                const durOK = isFinite(audio.duration) && audio.duration > 0;
                const ratio = durOK ? audio.currentTime / audio.duration : 0;
                fill.style.width = (ratio * 100) + '%';
                knob.style.left = (ratio * 100) + '%';
                clock.textContent = `${fmt(audio.currentTime)} / ${durOK ? fmt(audio.duration) : '--:--'}`;
            };
            const loop = () => { paint(); raf = requestAnimationFrame(loop); };
            audio.addEventListener('loadedmetadata', paint);
            if (isFinite(audio.duration) && audio.duration > 0) paint();
            audio.addEventListener('play', () => { playBtn.innerHTML = '<i class="fa-solid fa-pause"></i>'; v.classList.add('playing'); if (!raf) loop(); });
            audio.addEventListener('pause', () => { playBtn.innerHTML = '<i class="fa-solid fa-play"></i>'; v.classList.remove('playing'); if (raf) { cancelAnimationFrame(raf); raf = null; } paint(); });
            audio.addEventListener('ended', () => { audio.currentTime = 0; paint(); });
            playBtn.addEventListener('click', () => {
                if (audio.paused) {
                    // Un solo audio in riproduzione alla volta
                    document.querySelectorAll('.sy-voice audio, .wa-voice audio').forEach(a => { if (a !== audio) a.pause(); });
                    audio.play();
                } else audio.pause();
            });
            track.addEventListener('click', (e) => {
                if (!isFinite(audio.duration) || audio.duration <= 0) return;
                const rect = track.getBoundingClientRect();
                const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
                audio.currentTime = ratio * audio.duration;
                paint();
            });
            const speeds = [1, 1.5, 2];
            speedBtn.addEventListener('click', () => {
                const idx = (speeds.indexOf(audio.playbackRate) + 1) % speeds.length;
                audio.playbackRate = speeds[idx];
                speedBtn.textContent = speeds[idx] + '×';
            });
        });
    },

    /**
     * Trascrizione inline sotto il player (stile Connect): primo click carica
     * il testo da /deepgram/api/<id>, i successivi fanno toggle.
     */
    async callToggleTranscript(btn) {
        const box = btn.nextElementSibling;
        if (!box) return;
        if (box.dataset.done) { box.hidden = !box.hidden; return; }
        if (btn.disabled) return;
        btn.disabled = true;
        box.hidden = false;
        box.innerHTML = '<span class="tr-head">Trascrizione</span><i class="fa-solid fa-spinner fa-spin"></i> Caricamento…';
        try {
            const t = await this.api(`/deepgram/api/${btn.dataset.trid}`);
            // Rete di sicurezza: se il conteggio caratteri della lista era vecchio
            // (o assente) e il testo è lungo, si apre lo stesso nella modale.
            if ((t.transcript_text || '').length > this._TRANSCRIPT_INLINE_MAX) {
                box.hidden = true;
                box.innerHTML = '';
                btn.disabled = false;
                this.dgShowTranscript(btn.dataset.trid);
                return;
            }
            box.dataset.done = '1';
            box.textContent = t.transcript_text || '(nessun testo disponibile)';
            const head = document.createElement('span');
            head.className = 'tr-head';
            head.textContent = 'Trascrizione';
            box.prepend(head);
        } catch (e) {
            box.innerHTML = `<span class="tr-head">Trascrizione</span>Errore: ${this._escapeHtml(e.message)}`;
        }
        btn.disabled = false;
    },

    /**
     * Registrazioni caricate a mano (riunioni, audio/video) — NON le telefonate
     * del centralino, che stanno nel tab Telefonate. Stessa grafica del registro
     * chiamate: colonna orario, titolo, player a pillola, trascrizione inline.
     */
    async loadLeadTranscriptions(leadId) {
        const el = document.getElementById('lead-transcriptions-list');
        const countBadge = document.getElementById('transcriptions-count');
        if (this._recPollTimer) { clearTimeout(this._recPollTimer); this._recPollTimer = null; }
        if (!el) return;

        try {
            const data = await this.api(`/leads/api/${leadId}/transcriptions`);
            const items = data.items || [];
            if (countBadge) countBadge.textContent = items.length;

            if (!items.length) {
                el.innerHTML = '<div class="text-center py-5 text-muted"><i class="fa-solid fa-microphone-lines fa-2x mb-2 d-block opacity-25"></i>Nessuna registrazione caricata</div>';
                return;
            }

            const fmtDur = (s) => s ? `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}` : '';

            el.innerHTML = items.map(item => {
                const dur = fmtDur(item.duration);
                // Nessuno stato = file caricato ma mai inviato a Deepgram
                const status = item.status || 'uploaded';

                let badges = '';
                if (status === 'completed') {
                    badges += '<span class="badge bg-success me-1">Trascritta</span>';
                } else if (status === 'processing') {
                    badges += '<span class="badge bg-warning text-dark me-1">Trascrizione in corso</span>';
                } else if (status === 'failed') {
                    badges += '<span class="badge bg-danger me-1">Trascrizione fallita</span>';
                } else {
                    badges += '<span class="badge bg-secondary me-1">Da trascrivere</span>';
                }
                if (item.has_summary) {
                    badges += '<span class="badge bg-info me-1">Riepilogo AI</span>';
                }

                // Player a pillola, identico a quello delle telefonate
                const audioPlayerHtml = (item.has_audio && item.audio_url)
                    ? `<div class="sy-voice">
                            <audio preload="metadata" src="${this._escapeAttr(item.audio_url)}"></audio>
                            <button type="button" class="sy-voice-play" title="Riproduci"><i class="fa-solid fa-play"></i></button>
                            <div class="sy-voice-track"><div class="sy-voice-fill"></div><div class="sy-voice-knob"></div></div>
                            <span class="sy-voice-clock">--:-- / --:--</span>
                            <button type="button" class="sy-voice-speed" title="Velocità">1×</button>
                        </div>`
                    : '<span class="text-muted" style="font-size:12px">Audio non più disponibile</span>';

                // Trascrizione inline + azione di (ri)trascrizione
                let transcriptHtml = '';
                if (status === 'completed') {
                    transcriptHtml = this._transcriptRowHtml(item.id, item.transcript_chars);
                } else if (status === 'processing') {
                    transcriptHtml = '<span class="sy-voice-trbtn" style="cursor:default"><i class="fa-solid fa-spinner fa-spin"></i> Trascrizione in corso…</span>';
                } else if (item.has_audio) {
                    transcriptHtml = `<button type="button" class="sy-voice-trbtn" onclick="SyrusApp.dgTranscribe('${item.id}')">
                            <i class="fa-solid fa-closed-captioning"></i> ${status === 'failed' ? 'Riprova la trascrizione' : 'Trascrivi'}
                        </button>`;
                }

                // Riepilogo AI: stellina Gemini, come accanto al referente
                const actions = status === 'completed'
                    ? `<button type="button" class="btn-ai-sparkle${item.has_summary ? ' has-ai' : ''}"
                               onclick="SyrusApp.dgSummarize('${item.id}', false, this)"
                               title="Riepilogo AI" data-ai-hint-title="Riepilogo AI" data-ai-hint="${item.has_summary ? 'Riapre il riepilogo gia\u0027 generato per questa registrazione.' : 'Legge la trascrizione e ne ricava un riepilogo: punti toccati, impegni presi e prossimi passi.'}">${this._aiSparkleSvg(16)}</button>`
                    : '';

                const meta = [dur, item.speakers ? `${item.speakers} speaker` : ''].filter(Boolean).join(' · ');

                return `<div class="call-log-item">
                    ${this._tlWhenHtml(item.date)}
                    <div class="call-log-dir rec">
                        <div class="call-log-dir-label">
                            <i class="fa-solid fa-microphone-lines"></i>
                            <span class="call-log-title" title="${this._escapeAttr(item.label || 'Registrazione')}">${this._escapeHtml(item.label || 'Registrazione')}</span>
                        </div>
                        ${meta ? `<div class="call-log-sub"><span>${this._escapeHtml(meta)}</span></div>` : ''}
                        ${badges ? `<div class="mt-1">${badges}</div>` : ''}
                    </div>
                    <div class="call-log-media">
                        ${audioPlayerHtml}
                        ${transcriptHtml}
                    </div>
                    <div class="call-log-actions">${actions}</div>
                </div>`;
            }).join('');

            this._initVoicePlayers(el);

            // Una trascrizione in corso si chiude da sola: ricontrolla fra poco
            // invece di lasciare la riga ferma su "in corso" fino al refresh.
            if (items.some(i => i.status === 'processing')) {
                this._recPollTimer = setTimeout(() => this.loadLeadTranscriptions(leadId), 8000);
            }

        } catch (e) {
            el.innerHTML = `<div class="p-3 text-danger">Errore: ${this._escapeHtml(e.message)}</div>`;
        }
    },

    /** Ricarica le registrazioni se siamo sulla scheda lead (usata dai job async). */
    _refreshRecordings() {
        const leadId = this._currentLeadId;
        if (leadId && document.getElementById('lead-transcriptions-list')) {
            this.loadLeadTranscriptions(leadId);
        }
    },

    /**
     * Upload audio/video per trascrizione da tab Trascrizioni.
     */
    uploadTranscription(leadId) {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'audio/*,video/*,.m4a,.mp3,.wav,.ogg,.webm,.mp4,.mkv,.avi';
        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;
            try {
                this.toast('Caricamento registrazione in corso...', 'info');
                const transcriptId = await this._uploadActivityRecording(file, leadId);
                if (!transcriptId) throw new Error('Upload fallito');
                this.toast('Trascrizione in corso in background...', 'success');
                // Il riepilogo AI parte solo a trascrizione conclusa (vedi
                // _startActivityTranscribeAndSummarize): prima il testo non c'è.
                this._startActivityTranscribeAndSummarize(transcriptId);
                this.loadLeadTranscriptions(leadId);
            } catch (e) {
                this.toast('Errore: ' + e.message, 'danger');
            }
        };
        input.click();
    },

    /**
     * Avvia trascrizione + analisi AI per una chiamata PBX con registrazione.
     */
    async pbxTranscribe(pbxCallId) {
        try {
            this.toast('Trascrizione in corso...', 'info');
            const result = await this.api(`/communications/api/pbx-calls/${pbxCallId}/transcribe`, { method: 'POST' });
            if (result.error) throw new Error(result.error);

            if (result.already) {
                this.toast('Trascrizione già completata', 'success');
                const leadId = this._currentLeadId;
                if (leadId) this.loadLeadCallsAndTranscriptions(leadId);
                return;
            }

            this.toast('Trascrizione avviata — aggiornamento automatico...', 'success');
            const leadId = this._currentLeadId;
            if (leadId) {
                let attempts = 0;
                const maxAttempts = 20;
                const poll = async () => {
                    attempts++;
                    if (attempts > maxAttempts) return;
                    await this.loadLeadCallsAndTranscriptions(leadId);
                    const resp = await this.api(`/communications/api/pbx-calls/${pbxCallId}/transcribe`, { method: 'POST' });
                    if (resp.already) {
                        this.toast('Trascrizione completata!', 'success');
                        this._loadTimeline(leadId);
                        this.loadLeadTranscriptions(leadId);
                        return;
                    }
                    setTimeout(poll, 5000);
                };
                setTimeout(poll, 5000);
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },

    /**
     * Trascrivi audio da un ContactLog (audio remoto, es. import SyrusX).
     */
    async clTranscribe(contactLogId) {
        try {
            this.toast('Trascrizione in corso...', 'info');
            const result = await this.api(`/communications/api/contact-log/${contactLogId}/transcribe`, { method: 'POST' });
            if (result.error) throw new Error(result.error);

            if (result.already) {
                this.toast('Trascrizione già completata', 'success');
                const leadId = this._currentLeadId;
                if (leadId) this.loadLeadCallsAndTranscriptions(leadId);
                return;
            }

            this.toast('Trascrizione avviata — aggiornamento automatico...', 'success');
            const leadId = this._currentLeadId;
            if (leadId) {
                let attempts = 0;
                const maxAttempts = 20;
                const poll = async () => {
                    attempts++;
                    if (attempts > maxAttempts) return;
                    await this.loadLeadCallsAndTranscriptions(leadId);
                    const resp = await this.api(`/communications/api/contact-log/${contactLogId}/transcribe`, { method: 'POST' });
                    if (resp.already && resp.status === 'completed') {
                        this.toast('Trascrizione completata!', 'success');
                        this._loadTimeline(leadId);
                        this.loadLeadTranscriptions(leadId);
                        return;
                    }
                    setTimeout(poll, 5000);
                };
                setTimeout(poll, 5000);
            }
        } catch (e) {
            this.toast('Errore: ' + e.message, 'danger');
        }
    },
});


// ── app-notifications.js ──
/** Syrus Sales OS – Centro notifiche (campanella topbar + pannello) */
Object.assign(SyrusApp, {

    _notifCenterTimer: null,

    notifCenterInit() {
        const bell = document.getElementById('notif-bell');
        if (!bell) return;
        this.notifRefreshCount();
        this._notifCenterTimer = setInterval(() => this.notifRefreshCount(), 60000);
        // Bootstrap 5 emette l'evento sul parent .dropdown
        bell.closest('.dropdown')?.addEventListener('show.bs.dropdown', () => this.notifLoadPanel());
    },

    async notifRefreshCount() {
        try {
            const data = await this.api('/notifiche/api/unread-count');
            this._updateNotifBadge(data.count || 0);
        } catch (e) { /* silent */ }
    },

    _notifIcon(type) {
        return {
            email_opened: 'fa-envelope-open text-success',
            email_stale: 'fa-triangle-exclamation text-danger',
            email_inbound: 'fa-envelope text-primary',
            whatsapp_inbound: 'fa-brands fa-whatsapp text-success',
            whatsapp_auto_reply: 'fa-robot text-primary',
        }[type] || 'fa-bell text-secondary';
    },

    _notifItemHtml(n) {
        const time = n.created_at ? this.parseDate(n.created_at).toLocaleString('it-IT', {day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit'}) : '';
        return `
        <div class="d-flex gap-2 px-3 py-2 border-bottom notif-item ${n.read ? '' : 'bg-light'}" style="cursor:pointer" onclick="SyrusApp.notifOpen('${n.id}', '${n.link || ''}')">
            <div class="pt-1"><i class="fa-solid ${this._notifIcon(n.type)}"></i></div>
            <div class="flex-grow-1" style="min-width:0">
                <div class="small ${n.read ? '' : 'fw-bold'}">${this._escapeHtml(n.title || '')}</div>
                ${n.body ? `<div class="small text-muted text-truncate">${this._escapeHtml(n.body)}</div>` : ''}
                <div class="text-muted" style="font-size:11px">${time}</div>
            </div>
            ${n.read ? '' : '<div class="pt-2"><span style="display:block;width:8px;height:8px;border-radius:4px;background:#2E75B6"></span></div>'}
        </div>`;
    },

    async notifLoadPanel() {
        const list = document.getElementById('notif-panel-list');
        if (!list) return;
        try {
            const data = await this.api('/notifiche/api/list?per_page=15');
            this._updateNotifBadge(data.unread || 0);
            list.innerHTML = data.items.length
                ? data.items.map(n => this._notifItemHtml(n)).join('')
                : '<div class="text-center text-muted py-4 small"><i class="fa-regular fa-bell-slash me-1"></i> Nessuna notifica</div>';
        } catch (e) {
            list.innerHTML = '<div class="text-center text-muted py-4 small">Errore di caricamento</div>';
        }
    },

    async notifOpen(id, link) {
        try {
            const r = await this.api(`/notifiche/api/${id}/read`, {method: 'POST', body: '{}'});
            this._updateNotifBadge(r.unread || 0);
        } catch (e) { /* la navigazione vale comunque */ }
        if (link) location.href = link;
    },

    async notifMarkAllRead(event) {
        if (event) { event.preventDefault(); event.stopPropagation(); }
        try {
            await this.api('/notifiche/api/read-all', {method: 'POST', body: '{}'});
            this._updateNotifBadge(0);
            this.notifLoadPanel();
            // Aggiorna anche la pagina Notifiche se aperta
            if (typeof this.notifPageReload === 'function' && document.getElementById('notif-page-list')) {
                this.notifPageReload();
            }
        } catch (e) { this.toast(e.message, 'danger'); }
    },

    // ── Pagina /notifiche ───────────────────────────────────────────────
    _notifPageState: {page: 1, unread: false, type: ''},

    notifPageInit() {
        if (!document.getElementById('notif-page-list')) return;
        // Reset: il DOM riparte dai default (Tutte/tutti i tipi), lo stato
        // JS deve seguirlo anche rientrando via navigazione SPA
        this._notifPageState = {page: 1, unread: false, type: ''};
        this.notifPageReload();
    },

    notifPageFilter(opts) {
        Object.assign(this._notifPageState, opts, {page: 1});
        const state = this._notifPageState.unread ? 'unread' : 'all';
        document.querySelectorAll('[data-notif-filter]').forEach(b => {
            b.classList.toggle('active', b.getAttribute('data-notif-filter') === state);
        });
        this.notifPageReload();
    },

    async notifPageReload(append) {
        const list = document.getElementById('notif-page-list');
        if (!list) return;
        const s = this._notifPageState;
        try {
            const params = new URLSearchParams({page: s.page, per_page: 25});
            if (s.unread) params.set('unread', '1');
            if (s.type) params.set('type', s.type);
            const data = await this.api(`/notifiche/api/list?${params}`);
            const html = data.items.length
                ? data.items.map(n => this._notifItemHtml(n)).join('')
                : '<div class="text-center text-muted py-5"><i class="fa-regular fa-bell-slash fa-2x mb-2 d-block"></i>Nessuna notifica</div>';
            if (append) list.insertAdjacentHTML('beforeend', html);
            else list.innerHTML = html;
            const moreBtn = document.getElementById('notif-load-more');
            if (moreBtn) moreBtn.style.display = data.has_more ? '' : 'none';
            this._updateNotifBadge(data.unread || 0);
        } catch (e) {
            list.innerHTML = '<div class="text-center text-muted py-4">Errore di caricamento</div>';
        }
    },

    notifPageMore() {
        this._notifPageState.page += 1;
        this.notifPageReload(true);
    },
});

document.addEventListener('DOMContentLoaded', () => {
    SyrusApp.notifCenterInit();
    SyrusApp.notifPageInit();
});


// ── app-campaigns.js ──
/**
 * Syrus Sales OS – Campagne outreach
 *
 * Fase 1: entità campagna + popolamento lead.
 *  - lista campagne          → /campagne
 *  - dettaglio + membri      → /campagne/<id>
 *  - picker lead             → modale su /campagne/<id>/candidates
 *  - selezione multipla lead → /leads (barra bulk "Aggiungi a campagna")
 */
Object.assign(SyrusApp, {

    _campaignStatusLabels: {
        draft: 'Bozza', active: 'Attiva', paused: 'In pausa',
        completed: 'Conclusa', archived: 'Archiviata',
    },
    _campaignStatusColors: {
        draft:     {bg: '#EEF2F6', fg: '#475569'},
        active:    {bg: '#DFF7E7', fg: '#15803D'},
        paused:    {bg: '#FEF3C7', fg: '#B45309'},
        completed: {bg: '#EBF3FB', fg: '#2E75B6'},
        archived:  {bg: '#F1F5F9', fg: '#94A3B8'},
    },
    _campaignChannelLabels: {email: 'Email', whatsapp: 'WhatsApp', mixed: 'Email + WhatsApp'},
    _campaignChannelIcons: {
        email: 'fa-solid fa-envelope', whatsapp: 'fa-brands fa-whatsapp',
        mixed: 'fa-solid fa-tower-broadcast',
    },
    _campaignQuickViewStatuses: {
        active: 'active', all: '', draft: 'draft',
        paused: 'paused', closed: 'completed,archived',
    },

    campaignStatusBadge(status) {
        const c = this._campaignStatusColors[status] || this._campaignStatusColors.draft;
        const label = this._campaignStatusLabels[status] || status || '-';
        return `<span class="badge" style="background:${c.bg};color:${c.fg};font-weight:600">${this._escapeHtml(label)}</span>`;
    },

    campaignChannelBadge(channel) {
        const icon = this._campaignChannelIcons[channel] || 'fa-solid fa-tower-broadcast';
        const label = this._campaignChannelLabels[channel] || channel || '-';
        return `<span class="text-muted small"><i class="${icon} me-1"></i>${this._escapeHtml(label)}</span>`;
    },

    // ── Lista campagne ──────────────────────────────────────────────────
    initCampaignsPage() {
        this._campaignsQuickView = this._campaignsQuickView || 'active';
        const search = document.getElementById('camp-search');
        if (search && !search.dataset.bound) {
            search.dataset.bound = '1';
            search.addEventListener('input', this.debounce(() => this.loadCampaigns(1), 300));
        }
        this.loadCampaigns(1);
    },

    setCampaignQuickView(view) {
        this._campaignsQuickView = view;
        document.querySelectorAll('#camp-view-chips .lead-view-chip')
            .forEach(btn => btn.classList.toggle('active', btn.dataset.view === view));
        this.loadCampaigns(1);
    },

    async loadCampaigns(page = 1) {
        const tbody = document.getElementById('campaigns-table');
        if (!tbody) return;
        const search = (document.getElementById('camp-search') || {}).value || '';
        const status = this._campaignQuickViewStatuses[this._campaignsQuickView || 'active'] || '';
        const params = new URLSearchParams({page, search, status});

        try {
            const data = await this.api(`/campagne/api/list?${params}`);
            if (!data.items.length) {
                tbody.innerHTML = `<tr><td colspan="7" class="text-center text-muted py-4">
                    Nessuna campagna. <a href="#" onclick="SyrusApp.showCampaignFormModal();return false">Creane una</a>.</td></tr>`;
            } else {
                tbody.innerHTML = data.items.map(c => `
                    <tr data-campaign-id="${c.id}">
                        <td>
                            <a href="/campagne/${c.id}" class="text-decoration-none">
                                <div class="fw-medium">${this._escapeHtml(c.name)}</div>
                                ${c.description ? `<small class="text-muted">${this._escapeHtml(c.description.slice(0, 90))}</small>` : ''}
                            </a>
                        </td>
                        <td>${this.campaignStatusBadge(c.status)}</td>
                        <td>${this.campaignChannelBadge(c.channel)}</td>
                        <td class="text-center"><span class="badge bg-light text-dark">${c.member_count}</span></td>
                        <td><small class="text-muted">${c.created_at ? this.parseDate(c.created_at).toLocaleDateString('it-IT', {day: '2-digit', month: 'short', year: '2-digit'}) : '-'}</small></td>
                        <td><small>${this._escapeHtml(c.created_by_name || '-')}</small></td>
                        <td class="text-end">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" onclick="event.stopPropagation()">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="/campagne/${c.id}"><i class="fa-solid fa-eye me-2"></i>Apri</a></li>
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.showCampaignFormModal('${c.id}');return false"><i class="fa-solid fa-pen me-2"></i>Modifica</a></li>
                                    <li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item text-danger" href="#" onclick="SyrusApp.confirmDeleteCampaign('${c.id}','${this._escapeAttr(c.name)}');return false"><i class="fa-solid fa-trash me-2"></i>Elimina</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>`).join('');

                if (!tbody.dataset.rowNav) {
                    tbody.dataset.rowNav = '1';
                    tbody.addEventListener('click', (e) => {
                        if (e.target.closest('a, button, input, .dropdown, .dropdown-menu, [data-bs-toggle]')) return;
                        const row = e.target.closest('tr[data-campaign-id]');
                        if (row) window.location.href = `/campagne/${row.dataset.campaignId}`;
                    });
                }
            }

            const info = document.getElementById('campaigns-info');
            if (info) info.textContent = `${data.total} campagne – Pagina ${data.page} di ${data.pages || 1}`;
            this._renderPagination('campaigns-pagination', data, 'SyrusApp.loadCampaigns');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    _renderPagination(elementId, data, fnName) {
        const pag = document.getElementById(elementId);
        if (!pag) return;
        pag.innerHTML = '';
        for (let i = 1; i <= (data.pages || 0); i++) {
            pag.innerHTML += `<li class="page-item ${i === data.page ? 'active' : ''}"><a class="page-link" href="#" onclick="${fnName}(${i});return false">${i}</a></li>`;
        }
    },

    // ── Crea / modifica campagna ────────────────────────────────────────
    async showCampaignFormModal(campaignId) {
        let c = {name: '', description: '', status: 'draft', channel: 'email'};
        if (campaignId) {
            try {
                c = (await this.api(`/campagne/api/${campaignId}/stats`)).campaign;
            } catch (e) { this.toast(e.message, 'danger'); return; }
        }
        const opt = (val, label, cur) => `<option value="${val}" ${cur === val ? 'selected' : ''}>${label}</option>`;
        let prompts = [];
        try { prompts = (await this.api('/prompts/api/list')).items || []; } catch (_) {}
        this._showModal(campaignId ? 'Modifica campagna' : 'Nuova campagna', `
            <div class="mb-3">
                <label class="form-label">Nome *</label>
                <input type="text" class="form-control" id="camp-form-name" value="${this._escapeAttr(c.name || '')}" placeholder="Es. Riattivazione clienti Q3">
            </div>
            <div class="mb-3">
                <label class="form-label">Descrizione</label>
                <textarea class="form-control" id="camp-form-desc" rows="2" placeholder="A cosa serve questa campagna">${this._escapeHtml(c.description || '')}</textarea>
            </div>
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">Stato</label>
                    <select class="form-select" id="camp-form-status">
                        ${opt('draft', 'Bozza', c.status)}${opt('active', 'Attiva', c.status)}${opt('paused', 'In pausa', c.status)}${opt('completed', 'Conclusa', c.status)}${opt('archived', 'Archiviata', c.status)}
                    </select>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Canale previsto</label>
                    <select class="form-select" id="camp-form-channel">
                        ${opt('email', 'Email', c.channel)}${opt('whatsapp', 'WhatsApp', c.channel)}${opt('mixed', 'Email + WhatsApp', c.channel)}
                    </select>
                    <div class="form-text">Indicativo: gli invii arrivano in una fase successiva.</div>
                </div>
                <div class="col-12">
                    <label class="form-label">Prompt della campagna</label>
                    <select class="form-select" id="camp-form-prompt">
                        <option value="">Nessuno</option>
                        ${prompts.map(p => `<option value="${p.id}" ${c.prompt_id === p.id ? 'selected' : ''}>${this._escapeHtml(p.title)} (${p.used_count}×)</option>`).join('')}
                    </select>
                    <div class="form-text">
                        Chi scrive a queste lead parte da qui.
                        <a href="/prompts/">Gestisci la libreria</a>
                    </div>
                </div>
            </div>
            <div class="text-end mt-4">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-primary" onclick="SyrusApp.submitCampaignForm(${campaignId ? `'${campaignId}'` : 'null'})">
                    ${campaignId ? 'Salva' : 'Crea campagna'}
                </button>
            </div>`, 'modal-lg');
        setTimeout(() => { const el = document.getElementById('camp-form-name'); if (el) el.focus(); }, 300);
    },

    async submitCampaignForm(campaignId) {
        const payload = {
            name: (document.getElementById('camp-form-name').value || '').trim(),
            description: document.getElementById('camp-form-desc').value,
            status: document.getElementById('camp-form-status').value,
            channel: document.getElementById('camp-form-channel').value,
            prompt_id: document.getElementById('camp-form-prompt').value,
        };
        if (!payload.name) { this.toast('Il nome è obbligatorio', 'danger'); return; }
        try {
            if (campaignId) {
                await this.api(`/campagne/api/${campaignId}`, {method: 'PUT', body: JSON.stringify(payload)});
                this._closeAllModals();
                this.toast('Campagna aggiornata');
                if (this._campaignId === campaignId) this.loadCampaignStats();
                else this.loadCampaigns(1);
            } else {
                const created = await this.api('/campagne/api/create', {method: 'POST', body: JSON.stringify(payload)});
                this._closeAllModals();
                this.toast('Campagna creata');
                window.location.href = `/campagne/${created.id}`;
            }
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    confirmDeleteCampaign(campaignId, name) {
        this._showModal('Elimina campagna', `
            <p>Vuoi eliminare la campagna <strong>${this._escapeHtml(name)}</strong>?</p>
            <p class="text-muted small mb-4">Le lead <strong>non</strong> vengono toccate: si elimina solo la campagna e l'elenco dei suoi membri.</p>
            <div class="text-end">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-danger" onclick="SyrusApp.deleteCampaign('${campaignId}')">Elimina</button>
            </div>`, 'modal-md');
    },

    async deleteCampaign(campaignId) {
        try {
            await this.api(`/campagne/api/${campaignId}`, {method: 'DELETE'});
            this._closeAllModals();
            this.toast('Campagna eliminata');
            if (this._campaignId === campaignId) window.location.href = '/campagne';
            else this.loadCampaigns(1);
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // ── Dettaglio campagna ──────────────────────────────────────────────
    loadCampaignDetail(campaignId) {
        this._campaignId = campaignId;
        this._selectedMembers = new Set();
        this._memberView = '';
        const search = document.getElementById('members-search');
        if (search && !search.dataset.bound) {
            search.dataset.bound = '1';
            search.addEventListener('input', this.debounce(() => this.loadMembers(1), 300));
        }
        this.loadCampaignStats();
        this.loadMembers(1);
    },

    async loadCampaignStats() {
        if (!this._campaignId) return;
        try {
            const data = await this.api(`/campagne/api/${this._campaignId}/stats`);
            const badge = document.getElementById('campaign-status-badge');
            if (badge) badge.innerHTML = this.campaignStatusBadge(data.campaign.status);
            const chan = document.getElementById('campaign-channel-badge');
            if (chan) chan.innerHTML = this.campaignChannelBadge(data.campaign.channel);

            const box = document.getElementById('campaign-prompt-box');
            if (box) {
                box.innerHTML = data.campaign.prompt_id
                    ? `<i class="fa-solid fa-wand-magic-sparkles me-1 text-primary"></i>
                       Prompt: <a href="/prompts/">${this._escapeHtml(data.campaign.prompt_title || 'senza titolo')}</a>`
                    : `<i class="fa-regular fa-lightbulb me-1"></i>
                       Nessun prompt associato —
                       <a href="#" onclick="SyrusApp.showCampaignFormModal('${this._campaignId}');return false">scegline uno</a>`;
            }
            this._campaignPromptId = data.campaign.prompt_id || null;

            const f = data.funnel || {};
            const put = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
            put('fn-membri', f.membri ?? 0);
            put('fn-da-inviare', f.da_inviare ?? 0);
            put('fn-inviate', f.inviate ?? 0);
            put('fn-aperte', f.aperte ?? 0);
            put('fn-risposte', f.risposte ?? 0);
            // Le percentuali si leggono sugli invii, non sui membri: aprire una
            // email che non e' partita non vuol dire niente.
            const perc = (n, base) => base ? `${Math.round(100 * n / base)}% degli invii` : '';
            put('fn-aperte-perc', perc(f.aperte || 0, f.inviate || 0));
            put('fn-risposte-perc', perc(f.risposte || 0, f.inviate || 0));
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    setMemberView(view) {
        this._memberView = view;
        document.querySelectorAll('#members-view-chips .lead-view-chip')
            .forEach(btn => btn.classList.toggle('active', (btn.dataset.view || '') === view));
        this.loadMembers(1);
    },

    // ── Celle di avanzamento invio ──────────────────────────────────────
    _dataBreve(iso) {
        return iso ? this.parseDate(iso).toLocaleDateString('it-IT',
            {day: '2-digit', month: 'short', year: '2-digit'}) : '';
    },

    _pill(bg, fg, icon, testo, titolo) {
        return `<span class="badge d-inline-flex align-items-center gap-1"
            style="background:${bg};color:${fg};font-weight:600"
            ${titolo ? `title="${this._escapeAttr(titolo)}"` : ''}>
            <i class="${icon}"></i>${this._escapeHtml(testo)}</span>`;
    },

    _cellaInvio(em) {
        if (!em.invii) return this._pill('#F1F5F9', '#94A3B8', 'fa-solid fa-clock', 'da inviare');
        const q = em.invii > 1 ? ` ${em.invii}×` : '';
        return this._pill('#EBF3FB', '#2E75B6', 'fa-solid fa-paper-plane',
            `inviata${q}`, `Primo invio: ${this._dataBreve(em.prima_inviata)}`) +
            `<div class="small text-muted">${this._dataBreve(em.ultima_inviata)}</div>`;
    },

    _cellaApertura(em) {
        if (!em.invii) return '<span class="text-muted small">–</span>';
        if (!em.aperte) return this._pill('#F8FAFC', '#94A3B8', 'fa-regular fa-eye-slash', 'non aperta');
        const volte = em.aperture > 1 ? ` ${em.aperture}×` : '';
        return this._pill('#FEF3C7', '#B45309', 'fa-solid fa-eye', `aperta${volte}`,
            `Prima apertura: ${this._dataBreve(em.prima_apertura)}`) +
            `<div class="small text-muted">${this._dataBreve(em.ultima_apertura)}</div>`;
    },

    _cellaRisposta(em) {
        if (!em.risposte) return '<span class="text-muted small">–</span>';
        const q = em.risposte > 1 ? ` ${em.risposte}×` : '';
        return this._pill('#DFF7E7', '#15803D', 'fa-solid fa-reply', `risposta${q}`) +
            `<div class="small text-muted">${this._dataBreve(em.ultima_risposta)}</div>`;
    },

    async loadMembers(page = 1) {
        const tbody = document.getElementById('members-table');
        if (!tbody || !this._campaignId) return;
        this._membersPage = page;
        const search = (document.getElementById('members-search') || {}).value || '';
        const params = new URLSearchParams({page, search, vista: this._memberView || ''});

        try {
            const data = await this.api(`/campagne/api/${this._campaignId}/members?${params}`);
            if (!data.items.length) {
                tbody.innerHTML = `<tr><td colspan="8" class="text-center text-muted py-4">
                    ${this._memberView ? 'Nessuna lead in questa vista.'
                      : `Nessuna lead in questa campagna. <a href="#" onclick="SyrusApp.showCampaignPickerModal();return false">Aggiungine</a>.`}</td></tr>`;
            } else {
                tbody.innerHTML = data.items.map(m => {
                    const l = m.lead, em = m.email || {};
                    return `
                    <tr data-lead-id="${l.id}" style="cursor:pointer">
                        <td class="text-center">
                            <input type="checkbox" class="form-check-input member-select" value="${l.id}"
                                   ${this._selectedMembers.has(l.id) ? 'checked' : ''}
                                   onchange="SyrusApp.onMemberCheckbox(this)">
                        </td>
                        <td>
                            <div class="fw-medium">${this._escapeHtml(l.company_name || '-')}</div>
                            <small class="text-muted">${this._escapeHtml(l.crm_id || '')}</small>
                        </td>
                        <td>
                            <div>${this._escapeHtml(l.contact_name || '-')}</div>
                            <small class="text-muted">${this._escapeHtml(l.contact_email || '(nessuna email)')}</small>
                        </td>
                        <td>${this._cellaInvio(em)}</td>
                        <td>${this._cellaApertura(em)}</td>
                        <td>${this._cellaRisposta(em)}</td>
                        <td><small>${this._escapeHtml(l.assigned_name || '-')}</small></td>
                        <td class="text-end">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" onclick="event.stopPropagation()">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.showMemberEmail('${l.id}');return false"><i class="fa-solid fa-envelope-open-text me-2"></i>Leggi l'email</a></li>
                                    ${l.contact_email ? `<li><a class="dropdown-item" href="#" data-email="${this._escapeAttr(l.contact_email)}" onclick="SyrusApp.scriviAMembro('${l.id}', this.dataset.email);return false"><i class="fa-solid fa-wand-magic-sparkles me-2"></i>Scrivi con l'AI</a></li>` : ''}
                                    <li><a class="dropdown-item" href="/leads/${l.id}"><i class="fa-solid fa-eye me-2"></i>Apri lead</a></li>
                                    <li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item text-danger" href="#" onclick="SyrusApp.removeMembers(['${l.id}']);return false"><i class="fa-solid fa-user-minus me-2"></i>Rimuovi dalla campagna</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>`;
                }).join('');

                // Riga cliccabile -> lettura dell'email della campagna.
                if (!tbody.dataset.rowNav) {
                    tbody.dataset.rowNav = '1';
                    tbody.addEventListener('click', (e) => {
                        if (e.target.closest('a, button, input, .dropdown, .dropdown-menu, [data-bs-toggle]')) return;
                        const row = e.target.closest('tr[data-lead-id]');
                        if (row) this.showMemberEmail(row.dataset.leadId);
                    });
                }
            }

            const info = document.getElementById('members-info');
            if (info) info.textContent = `${data.total} lead – Pagina ${data.page} di ${data.pages || 1}`;
            this._renderPagination('members-pagination', data, 'SyrusApp.loadMembers');
            this._syncMembersSelectAll();
            this._updateMemberBulkBar();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    onMemberCheckbox(cb) {
        if (cb.checked) this._selectedMembers.add(cb.value);
        else this._selectedMembers.delete(cb.value);
        this._syncMembersSelectAll();
        this._updateMemberBulkBar();
    },

    toggleAllMembers(cb) {
        document.querySelectorAll('#members-table .member-select').forEach(el => {
            el.checked = cb.checked;
            if (cb.checked) this._selectedMembers.add(el.value);
            else this._selectedMembers.delete(el.value);
        });
        this._updateMemberBulkBar();
    },

    _syncMembersSelectAll() {
        const all = document.getElementById('members-select-all');
        if (!all) return;
        const boxes = [...document.querySelectorAll('#members-table .member-select')];
        all.checked = boxes.length > 0 && boxes.every(b => b.checked);
        all.indeterminate = boxes.some(b => b.checked) && !all.checked;
    },

    _updateMemberBulkBar() {
        const bar = document.getElementById('members-bulk-bar');
        if (!bar) return;
        const n = this._selectedMembers.size;
        bar.classList.toggle('d-none', n === 0);
        const count = document.getElementById('members-bulk-count');
        if (count) count.textContent = n;
    },

    clearMemberSelection() {
        this._selectedMembers.clear();
        document.querySelectorAll('#members-table .member-select').forEach(el => { el.checked = false; });
        this._syncMembersSelectAll();
        this._updateMemberBulkBar();
    },

    removeSelectedMembers() {
        const ids = [...this._selectedMembers];
        if (!ids.length) return;
        // Gli id restano in una property: mai JSON dentro un attributo onclick.
        this._pendingRemoveIds = ids;
        this._showModal('Rimuovi dalla campagna', `
            <p>Vuoi rimuovere <strong>${ids.length}</strong> lead da questa campagna?</p>
            <p class="text-muted small mb-4">Le lead restano nel CRM: si elimina solo l'appartenenza alla campagna.</p>
            <div class="text-end">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-danger" onclick="SyrusApp.confirmRemoveMembers()">Rimuovi</button>
            </div>`, 'modal-md');
    },

    confirmRemoveMembers() {
        this.removeMembers(this._pendingRemoveIds || [], true);
    },

    async removeMembers(leadIds, fromModal) {
        try {
            const res = await this.api(`/campagne/api/${this._campaignId}/members/remove`, {
                method: 'POST', body: JSON.stringify({lead_ids: leadIds}),
            });
            if (fromModal) this._closeAllModals();
            leadIds.forEach(id => this._selectedMembers.delete(id));
            this.toast(`${res.removed} lead rimosse dalla campagna`);
            this.loadCampaignStats();
            this.loadMembers(this._membersPage || 1);
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    /** Apre il compositore sulla lead col prompt della campagna già dentro. */
    async scriviAMembro(leadId, email) {
        this.showSendEmailModal(leadId, email);
        if (!this._campaignPromptId) return;
        // initEmailAi è asincrono: si aspetta che la libreria sia caricata.
        for (let i = 0; i < 20 && !document.getElementById('ai-prompt'); i++) {
            await new Promise(r => setTimeout(r, 100));
        }
        if (this._prompts && this._prompts.length) {
            this.usaPrompt(this._campaignPromptId);
        }
    },

    // ── Lettura dell'email della campagna ───────────────────────────────
    async showMemberEmail(leadId) {
        this._showModal('Email della campagna',
            '<div class="text-center py-5 text-muted">Caricamento...</div>', 'modal-xl');
        let data;
        try {
            data = await this.api(`/campagne/api/${this._campaignId}/members/${leadId}/email`);
        } catch (e) {
            this._showModal('Email della campagna',
                `<div class="alert alert-danger mb-0">${this._escapeHtml(e.message)}</div>`, 'modal-lg');
            return;
        }

        const l = data.lead || {};
        const titolo = `${this._escapeHtml(l.company_name || l.contact_name || 'Lead')}
            <small class="text-muted ms-2">${this._escapeHtml(l.crm_id || '')}</small>`;

        if (!data.items.length) {
            this._showModal(titolo, `
                <div class="text-center py-5">
                    <i class="fa-regular fa-envelope fa-2x text-muted mb-3 d-block"></i>
                    <p class="text-muted mb-1">Nessuna email di questa campagna per questa lead.</p>
                    <p class="text-muted small">Il primo invio non è ancora stato fatto.</p>
                    <a href="/leads/${leadId}" class="btn btn-outline-primary btn-sm mt-2">Apri la lead</a>
                </div>`, 'modal-lg');
            return;
        }

        const corpo = data.items.map(e => this._renderEmailCampagna(e)).join('');
        this._showModal(titolo, `
            <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-muted small">${data.items.length} messaggi in questa campagna</span>
                <a href="/leads/${leadId}" class="btn btn-sm btn-outline-primary">
                    <i class="fa-solid fa-eye me-1"></i>Apri la lead
                </a>
            </div>
            ${corpo}`, 'modal-xl');
    },

    _renderEmailCampagna(e) {
        const inbound = e.direction === 'inbound';
        const quando = e.sent_at ? this.formatDate(e.sent_at) : '';
        // Il corpo e' HTML scritto da terzi (o dall'AI): sempre sanificato.
        const body = window.DOMPurify
            ? DOMPurify.sanitize(e.body_html || '', {FORBID_TAGS: ['style', 'script'], FORBID_ATTR: ['onerror', 'onload']})
            : this._escapeHtml((e.body_html || '').replace(/<[^>]+>/g, ' '));

        let stato = '';
        if (inbound) {
            stato = this._pill('#DFF7E7', '#15803D', 'fa-solid fa-reply', 'risposta ricevuta');
        } else if (e.opened_at) {
            const volte = (e.open_count || 0) > 1 ? ` ${e.open_count}×` : '';
            stato = this._pill('#FEF3C7', '#B45309', 'fa-solid fa-eye', `aperta${volte}`,
                `Prima: ${this.formatDate(e.opened_at)} · Ultima: ${this.formatDate(e.last_opened_at || e.opened_at)}`);
        } else {
            stato = this._pill('#F8FAFC', '#94A3B8', 'fa-regular fa-eye-slash', 'nessuna apertura registrata');
        }

        return `
        <div class="card mb-3 ${inbound ? 'border-success' : ''}">
            <div class="card-header bg-white py-2">
                <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <div class="fw-bold">
                        <i class="fa-solid ${inbound ? 'fa-inbox text-success' : 'fa-paper-plane text-primary'} me-2"></i>
                        ${this._escapeHtml(e.subject || '(senza oggetto)')}
                    </div>
                    ${stato}
                </div>
                <div class="small text-muted mt-1">
                    ${inbound
                        ? `da <strong>${this._escapeHtml(e.from_email || '')}</strong>`
                        : `a <strong>${this._escapeHtml(e.to_email || '')}</strong>${e.sent_by ? ' · da ' + this._escapeHtml(e.sent_by) : ''}`}
                    · ${quando}
                </div>
            </div>
            <div class="card-body">
                <div class="email-body-render">${body}</div>
            </div>
        </div>`;
    },

    // ── Picker lead (dal dettaglio campagna) ────────────────────────────
    showCampaignPickerModal() {
        this._pickerSelected = new Set();
        this._showModal('Aggiungi lead alla campagna', `
            <div class="row g-2 align-items-end mb-3">
                <div class="col-md-5">
                    <label class="form-label small text-muted mb-1">Cerca</label>
                    <input type="text" class="form-control form-control-sm" id="picker-search" placeholder="Azienda, contatto, email...">
                </div>
                <div class="col-md-4">
                    <label class="form-label small text-muted mb-1">Stato</label>
                    <select class="form-select form-select-sm" id="picker-status">
                        <option value="">Tutti (esclusi spam)</option>
                        <option value="new">Nuovo</option>
                        <option value="contacted">Contattato</option>
                        <option value="qualified">Qualificato</option>
                        <option value="proposal_sent">Preventivo Inviato</option>
                        <option value="negotiation">In Trattativa</option>
                        <option value="won">Vinto</option>
                        <option value="lost">Perso</option>
                        <option value="dormant">Dormiente</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label small text-muted mb-1">Priorit&agrave;</label>
                    <select class="form-select form-select-sm" id="picker-priority">
                        <option value="">Tutte</option>
                        <option value="hot">Hot</option>
                        <option value="warm">Warm</option>
                        <option value="cold">Cold</option>
                    </select>
                </div>
            </div>
            <div class="table-responsive" style="max-height:46vh;overflow-y:auto">
                <table class="table table-sm table-hover align-middle mb-0">
                    <thead class="sticky-top bg-white">
                        <tr>
                            <th style="width:34px" class="text-center">
                                <input type="checkbox" class="form-check-input" id="picker-select-all" onclick="SyrusApp.togglePickerPage(this)">
                            </th>
                            <th>Azienda</th>
                            <th>Contatto</th>
                            <th>Stato</th>
                            <th>Priorit&agrave;</th>
                        </tr>
                    </thead>
                    <tbody id="picker-table">
                        <tr><td colspan="5" class="text-center text-muted py-4">Caricamento...</td></tr>
                    </tbody>
                </table>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-2">
                <div class="text-muted small" id="picker-info"></div>
                <nav><ul class="pagination pagination-sm mb-0" id="picker-pagination"></ul></nav>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                <span class="text-muted small"><span id="picker-count">0</span> lead selezionate</span>
                <div>
                    <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                    <button class="btn btn-primary" id="picker-submit" onclick="SyrusApp.addPickedLeads()" disabled>Aggiungi</button>
                </div>
            </div>`, 'modal-xl');

        ['picker-search', 'picker-status', 'picker-priority'].forEach(id => {
            const el = document.getElementById(id);
            if (!el) return;
            const handler = () => this.loadPickerCandidates(1);
            el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input',
                el.tagName === 'SELECT' ? handler : this.debounce(handler, 300));
        });
        this.loadPickerCandidates(1);
    },

    async loadPickerCandidates(page = 1) {
        const tbody = document.getElementById('picker-table');
        if (!tbody || !this._campaignId) return;
        const params = new URLSearchParams({
            page, per_page: 25,
            search: (document.getElementById('picker-search') || {}).value || '',
            status: (document.getElementById('picker-status') || {}).value || '',
            priority: (document.getElementById('picker-priority') || {}).value || '',
        });

        try {
            const data = await this.api(`/campagne/api/${this._campaignId}/candidates?${params}`);
            if (!data.items.length) {
                tbody.innerHTML = '<tr><td colspan="5" class="text-center text-muted py-4">Nessuna lead disponibile con questi filtri.</td></tr>';
            } else {
                tbody.innerHTML = data.items.map(l => `
                    <tr>
                        <td class="text-center">
                            <input type="checkbox" class="form-check-input picker-select" value="${l.id}"
                                   ${this._pickerSelected.has(l.id) ? 'checked' : ''}
                                   onchange="SyrusApp.onPickerCheckbox(this)">
                        </td>
                        <td>
                            <div class="fw-medium">${this._escapeHtml(l.company_name || '-')}</div>
                            <small class="text-muted">${this._escapeHtml(l.crm_id || '')}</small>
                        </td>
                        <td>
                            <div>${this._escapeHtml(l.contact_name || '-')}</div>
                            <small class="text-muted">${this._escapeHtml(l.contact_email || l.contact_phone || '')}</small>
                        </td>
                        <td>${this.statusBadge(l.status)}</td>
                        <td>${this.priorityBadge(l.priority)}</td>
                    </tr>`).join('');
            }
            const info = document.getElementById('picker-info');
            if (info) info.textContent = `${data.total} lead disponibili`;
            this._renderPagination('picker-pagination', data, 'SyrusApp.loadPickerCandidates');
            this._syncPickerSelectAll();
            this._updatePickerCount();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    onPickerCheckbox(cb) {
        if (cb.checked) this._pickerSelected.add(cb.value);
        else this._pickerSelected.delete(cb.value);
        this._syncPickerSelectAll();
        this._updatePickerCount();
    },

    togglePickerPage(cb) {
        document.querySelectorAll('#picker-table .picker-select').forEach(el => {
            el.checked = cb.checked;
            if (cb.checked) this._pickerSelected.add(el.value);
            else this._pickerSelected.delete(el.value);
        });
        this._updatePickerCount();
    },

    _syncPickerSelectAll() {
        const all = document.getElementById('picker-select-all');
        if (!all) return;
        const boxes = [...document.querySelectorAll('#picker-table .picker-select')];
        all.checked = boxes.length > 0 && boxes.every(b => b.checked);
        all.indeterminate = boxes.some(b => b.checked) && !all.checked;
    },

    _updatePickerCount() {
        const count = document.getElementById('picker-count');
        if (count) count.textContent = this._pickerSelected.size;
        const btn = document.getElementById('picker-submit');
        if (btn) {
            btn.disabled = this._pickerSelected.size === 0;
            btn.textContent = this._pickerSelected.size ? `Aggiungi ${this._pickerSelected.size} lead` : 'Aggiungi';
        }
    },

    async addPickedLeads() {
        const ids = [...this._pickerSelected];
        if (!ids.length) return;
        const btn = document.getElementById('picker-submit');
        if (btn) { btn.disabled = true; btn.textContent = 'Aggiunta...'; }
        try {
            const res = await this.api(`/campagne/api/${this._campaignId}/members`, {
                method: 'POST', body: JSON.stringify({lead_ids: ids}),
            });
            this._closeAllModals();
            this.toast(res.skipped ? `${res.added} lead aggiunte (${res.skipped} già presenti)`
                                   : `${res.added} lead aggiunte alla campagna`);
            this.loadCampaignStats();
            this.loadMembers(1);
        } catch (e) {
            this.toast(e.message, 'danger');
            if (btn) { btn.disabled = false; btn.textContent = 'Aggiungi'; }
        }
    },

    // ── Selezione multipla nella lista lead ─────────────────────────────
    _selectedLeads: new Set(),

    onLeadCheckbox(cb) {
        if (cb.checked) this._selectedLeads.add(cb.value);
        else this._selectedLeads.delete(cb.value);
        this._syncLeadsSelectAll();
        this.updateLeadsBulkBar();
    },

    toggleAllLeads(cb) {
        document.querySelectorAll('#leads-table .lead-select').forEach(el => {
            el.checked = cb.checked;
            if (cb.checked) this._selectedLeads.add(el.value);
            else this._selectedLeads.delete(el.value);
        });
        this.updateLeadsBulkBar();
    },

    _syncLeadsSelectAll() {
        const all = document.getElementById('leads-select-all');
        if (!all) return;
        const boxes = [...document.querySelectorAll('#leads-table .lead-select')];
        all.checked = boxes.length > 0 && boxes.every(b => b.checked);
        all.indeterminate = boxes.some(b => b.checked) && !all.checked;
    },

    /** Ri-applica la selezione dopo il re-render del tbody (cambio pagina/filtri). */
    restoreLeadSelection() {
        document.querySelectorAll('#leads-table .lead-select').forEach(el => {
            el.checked = this._selectedLeads.has(el.value);
        });
        this._syncLeadsSelectAll();
        this.updateLeadsBulkBar();
    },

    updateLeadsBulkBar() {
        const bar = document.getElementById('leads-bulk-bar');
        if (!bar) return;
        const n = this._selectedLeads.size;
        bar.classList.toggle('d-none', n === 0);
        const count = document.getElementById('leads-bulk-count');
        if (count) count.textContent = n;
    },

    clearLeadSelection() {
        this._selectedLeads.clear();
        document.querySelectorAll('#leads-table .lead-select').forEach(el => { el.checked = false; });
        this._syncLeadsSelectAll();
        this.updateLeadsBulkBar();
    },

    // ── Modale "Aggiungi a campagna" (da lista lead o dettaglio lead) ───
    async showAddToCampaignModal(leadIds) {
        const ids = leadIds || [...this._selectedLeads];
        if (!ids.length) { this.toast('Nessuna lead selezionata', 'danger'); return; }
        this._pendingCampaignLeadIds = ids;

        let items = [];
        try {
            items = (await this.api('/campagne/api/options')).items;
        } catch (e) { this.toast(e.message, 'danger'); return; }

        const options = items.length
            ? items.map(c => `<option value="${c.id}">${this._escapeHtml(c.name)} (${c.member_count})</option>`).join('')
            : '';

        this._showModal('Aggiungi a campagna', `
            <p class="text-muted small">${ids.length} lead selezionate.</p>
            ${items.length ? `
            <div class="mb-3">
                <label class="form-label">Campagna</label>
                <select class="form-select" id="atc-campaign">${options}</select>
            </div>
            <div class="mb-3 text-center text-muted small">oppure</div>` : ''}
            <div class="mb-3">
                <label class="form-label">${items.length ? 'Crea una nuova campagna' : 'Nome della nuova campagna'}</label>
                <input type="text" class="form-control" id="atc-new-name" placeholder="Lascia vuoto per usare quella sopra">
            </div>
            <div class="text-end mt-4">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-primary" onclick="SyrusApp.submitAddToCampaign()">Aggiungi</button>
            </div>`, 'modal-md');
    },

    async submitAddToCampaign() {
        const ids = this._pendingCampaignLeadIds || [];
        const newName = ((document.getElementById('atc-new-name') || {}).value || '').trim();
        const select = document.getElementById('atc-campaign');
        if (!newName && !select) { this.toast('Indica un nome per la nuova campagna', 'danger'); return; }

        try {
            let campaignId;
            if (newName) {
                const created = await this.api('/campagne/api/create', {
                    method: 'POST', body: JSON.stringify({name: newName}),
                });
                campaignId = created.id;
            } else {
                campaignId = select.value;
            }
            const res = await this.api(`/campagne/api/${campaignId}/members`, {
                method: 'POST', body: JSON.stringify({lead_ids: ids}),
            });
            this._closeAllModals();
            this.toast(res.skipped ? `${res.added} lead aggiunte (${res.skipped} già presenti)`
                                   : `${res.added} lead aggiunte alla campagna`);
            this.clearLeadSelection();
            if (this._leadCampaignsLeadId) this.loadLeadCampaigns(this._leadCampaignsLeadId);
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    // ── Card "Campagne" nel dettaglio lead ──────────────────────────────
    async loadLeadCampaigns(leadId) {
        const box = document.getElementById('lead-campaigns');
        if (!box) return;
        this._leadCampaignsLeadId = leadId;
        try {
            const data = await this.api(`/campagne/api/by-lead/${leadId}`);
            box.innerHTML = data.items.length
                ? data.items.map(c => `
                    <a href="/campagne/${c.id}" class="d-flex align-items-center justify-content-between text-decoration-none py-1">
                        <span class="text-truncate me-2">${this._escapeHtml(c.name)}</span>
                        ${this.campaignStatusBadge(c.status)}
                    </a>`).join('')
                : '<div class="text-muted small">Non è in nessuna campagna.</div>';
        } catch (e) {
            box.innerHTML = '<div class="text-muted small">Errore nel caricamento.</div>';
        }
    },
});


// ── app-ai-context.js ──
/**
 * Syrus Sales OS – Contesto progetto della lead generato dall'AI
 *
 * Documento narrativo in Markdown (cosa vuole il cliente, funzionalità, stack,
 * budget/tempi, rischi, prossimi passi). Diverso dallo scoring di `ai_analysis`.
 */
Object.assign(SyrusApp, {

    /**
     * Renderer Markdown minimale, sul sottoinsieme che questi documenti usano
     * davvero: titoli ##/###, **grassetto**, *corsivo*, `codice`, elenchi
     * puntati e numerati, righe orizzontali, paragrafi.
     *
     * Scritto a mano invece di aggiungere una libreria: il testo è generato da
     * un modello con struttura costante, e l'output passa comunque da DOMPurify.
     */
    _renderMarkdown(md) {
        if (!md) return '';
        const esc = (s) => this._escapeHtml(s);

        // Inline: codice prima di tutto, così il resto non tocca il suo contenuto.
        const inline = (s) => {
            let out = esc(s);
            out = out.replace(/`([^`]+)`/g, '<code>$1</code>');
            out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
            out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>');
            return out;
        };

        const righe = String(md).replace(/\r\n/g, '\n').split('\n');
        const out = [];
        let lista = null;      // 'ul' | 'ol' | null
        let paragrafo = [];
        let citazione = [];

        const chiudiParagrafo = () => {
            if (paragrafo.length) {
                out.push('<p>' + paragrafo.map(inline).join('<br>') + '</p>');
                paragrafo = [];
            }
        };
        const chiudiLista = () => {
            if (lista) { out.push(`</${lista}>`); lista = null; }
        };
        const chiudiCitazione = () => {
            if (citazione.length) {
                out.push('<blockquote>' + citazione.map(inline).join('<br>') + '</blockquote>');
                citazione = [];
            }
        };
        const chiudiTutto = () => { chiudiParagrafo(); chiudiLista(); chiudiCitazione(); };

        for (const riga of righe) {
            const t = riga.trim();

            if (!t) { chiudiTutto(); continue; }

            const cit = t.match(/^>\s?(.*)$/);
            if (cit) {
                chiudiParagrafo(); chiudiLista();
                citazione.push(cit[1]);
                continue;
            }
            chiudiCitazione();

            const titolo = t.match(/^(#{1,6})\s+(.*)$/);
            if (titolo) {
                chiudiParagrafo(); chiudiLista();
                // ## nel documento = intestazione di sezione: resa come h5 per
                // non competere col titolo della scheda lead.
                const liv = Math.min(6, titolo[1].length + 3);
                out.push(`<h${liv} class="ai-ctx-h">${inline(titolo[2])}</h${liv}>`);
                continue;
            }

            if (/^([-*_])\1{2,}$/.test(t)) {
                chiudiParagrafo(); chiudiLista();
                out.push('<hr>');
                continue;
            }

            const punto = t.match(/^[-*+]\s+(.*)$/);
            if (punto) {
                chiudiParagrafo();
                if (lista !== 'ul') { chiudiLista(); out.push('<ul>'); lista = 'ul'; }
                out.push('<li>' + inline(punto[1]) + '</li>');
                continue;
            }

            const numero = t.match(/^\d+[.)]\s+(.*)$/);
            if (numero) {
                chiudiParagrafo();
                if (lista !== 'ol') { chiudiLista(); out.push('<ol>'); lista = 'ol'; }
                out.push('<li>' + inline(numero[1]) + '</li>');
                continue;
            }

            chiudiLista();
            paragrafo.push(t);
        }
        chiudiTutto();

        const html = out.join('\n');
        return window.DOMPurify
            ? DOMPurify.sanitize(html, {FORBID_TAGS: ['style', 'script'], FORBID_ATTR: ['onerror', 'onload']})
            : html;
    },

    /**
     * Markdown ridotto a testo scorrevole, per l'anteprima da 5 righe nella
     * card Valutazione: i marcatori (##, **, elenchi) su cinque righe fanno
     * solo rumore, mentre in modale il documento si vede formattato per intero.
     */
    _markdownToText(md) {
        return String(md || '')
            .replace(/```[\s\S]*?```/g, ' ')
            .replace(/^\s*([-*_])\1{2,}\s*$/gm, ' ')     // righe orizzontali
            .replace(/^\s*#{1,6}\s+/gm, '')              // titoli
            .replace(/^\s*[-*+]\s+/gm, '')               // elenchi puntati
            .replace(/^\s*\d+[.)]\s+/gm, '')             // elenchi numerati
            .replace(/^\s*>\s?/gm, '')                   // citazioni
            .replace(/[*_`]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    },

    /**
     * Carica il contesto e dipinge l'anteprima nella card Valutazione.
     * Se la modale col documento intero è aperta, la riscrive: serve dopo una
     * rigenerazione lanciata da dentro la modale stessa.
     */
    async loadAiContext(leadId) {
        const box = document.getElementById('lead-ai-ctx-preview');
        if (!box) return;
        this._aiContextLeadId = leadId;

        let data;
        try {
            data = await this.api(`/leads/api/${leadId}/ai-context`);
        } catch (e) {
            box.innerHTML = `<div class="small text-danger">${this._escapeHtml(e.message)}</div>`;
            return;
        }

        this._aiContextData = data;
        this._aiContextRaw = data.context ? data.context.content : null;
        this._paintAiContextPreview();
        if (document.querySelector('#syrus-modal.show #ai-ctx-body')) this.showAiContextModal();
    },

    _paintAiContextPreview() {
        const box = document.getElementById('lead-ai-ctx-preview');
        const piu = document.getElementById('ai-ctx-more');
        if (!box) return;
        const data = this._aiContextData || {};
        const c = data.context;

        if (!c) {
            if (piu) piu.style.display = 'none';
            box.innerHTML = `
                <div class="small text-muted mb-2">Nessun contesto per questa lead: viene generato entro un'ora dalla prima attivit&agrave;.</div>
                <button class="btn btn-sm btn-outline-primary" id="ai-ctx-regen" onclick="SyrusApp.regenerateAiContext()">
                    <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Genera ora
                </button>`;
            return;
        }

        if (piu) piu.style.display = '';
        const avviso = data.stale
            ? '<div class="small text-warning-emphasis mb-1"><i class="fa-solid fa-triangle-exclamation me-1"></i>La lead si &egrave; mossa dopo l\'ultima generazione.</div>'
            : '';
        box.innerHTML = avviso
            + `<div class="ai-ctx-clamp">${this._escapeHtml(this._markdownToText(c.content))}</div>`;
    },

    /** Documento intero, formattato, con le azioni copia e rigenera. */
    showAiContextModal() {
        const data = this._aiContextData || {};
        const c = data.context;
        if (!c) return;

        const origine = c.source === 'lead_manager'
            ? '<span class="badge bg-light text-dark" title="Importato dal Lead Manager">importato</span>'
            : '';
        const costo = c.cost_usd ? `$${Number(c.cost_usd).toFixed(3)}` : '';
        const durata = c.duration_ms ? `${Math.round(c.duration_ms / 1000)}s` : '';
        const meta = [c.model, costo, durata,
                      c.generated_by ? `lanciata da ${c.generated_by}` : '']
            .filter(Boolean).map(x => this._escapeHtml(x)).join(' · ');

        // Lo score nasce dalla stessa passata del contesto: mostrarlo qui
        // evita di dover cercare altrove perché la lead vale quel punteggio.
        const punteggio = data.score;
        const scoreHtml = (punteggio === null || punteggio === undefined) ? '' : `
            <div class="mt-2 d-flex align-items-center gap-2">
                <span class="badge ${punteggio >= 70 ? 'bg-success' : punteggio >= 40 ? 'bg-warning text-dark' : 'bg-secondary'}">Score ${punteggio}/100</span>
                ${data.score_reason ? `<span class="small text-muted">${this._escapeHtml(data.score_reason)}</span>` : ''}
            </div>`;

        const body = `
            <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3 pb-3 border-bottom">
                <div>
                    <div class="small text-muted">${meta} ${origine}</div>
                    ${c.generated_at ? `<div class="small text-muted">generato il ${this.formatDate(c.generated_at)}</div>` : ''}
                    ${scoreHtml}
                </div>
                <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.copyAiContext()">
                        <i class="fa-regular fa-copy me-1"></i>Copia
                    </button>
                    <button class="btn btn-sm ${data.stale ? 'btn-primary' : 'btn-outline-primary'}" id="ai-ctx-regen"
                            onclick="SyrusApp.regenerateAiContext()"
                            title="${data.stale ? 'La lead si è mossa dopo l\'ultima generazione' : 'Rigenera comunque'}">
                        <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Rigenera
                    </button>
                </div>
            </div>
            ${data.stale ? '<div class="alert alert-warning py-2 px-3 small mb-3"><i class="fa-solid fa-triangle-exclamation me-1"></i>La lead si è mossa dopo l\'ultima generazione: il contesto qui sotto non è aggiornato.</div>' : ''}
            <div class="ai-ctx-body" id="ai-ctx-body">${this._renderMarkdown(c.content)}</div>`;

        this._showModal('<i class="fa-solid fa-lightbulb me-2 text-primary"></i>Contesto di progetto', body, 'modal-xl');
    },

    async regenerateAiContext() {
        const leadId = this._aiContextLeadId;
        if (!leadId) return;
        const btn = document.getElementById('ai-ctx-regen');
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Genero...';
        }
        try {
            // Rilettura completa del contesto: può richiedere una ventina di secondi
            // genera_titolo: la rigenerazione chiesta a mano riscrive anche il
            // titolo, anche se qualcuno l'aveva messo a mano. Il job orario no.
            const res = await this.api(`/leads/api/${leadId}/ai-context/regenerate`, {
                method: 'POST',
                body: JSON.stringify({genera_titolo: true}),
            });
            this.toast(res.titolo ? `Contesto aggiornato — titolo: ${res.titolo}` : 'Contesto aggiornato');
            await this.loadAiContext(leadId);
            // Il titolo e lo score sono cambiati anche fuori da questa scheda
            if (res.titolo) setTimeout(() => window.location.reload(), 800);
        } catch (e) {
            this.toast(e.message || 'Generazione non riuscita', 'danger');
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fa-solid fa-wand-magic-sparkles me-1"></i>Rigenera';
            }
        }
    },

    /**
     * Chiede all'AI un singolo campo (referente o titolo) e lo applica.
     * Chiamata corta: legge il materiale della lead e risponde col solo nome,
     * senza rifare tutto il profilo.
     */
    async suggerisciCampo(leadId, campo) {
        const bottoni = {
            contact_name: 'ai-referente-btn',
            company_name: 'ai-titolo-btn',
            contact_email: 'ai-email-btn',
            lead_score: 'ai-score-btn',
            budget_range: 'ai-budget-btn',
        };
        const campi = {
            contact_name: 'lead-referente',
            company_name: 'lead-titolo',
            contact_email: 'lead-email',
        };
        const btn = document.getElementById(bottoni[campo]);
        if (btn) { btn.disabled = true; btn.classList.add('is-working'); }

        try {
            const r = await this.api(`/leads/api/${leadId}/ai-suggerisci/${campo}`, {method: 'POST'});
            if (campo === 'lead_score') {
                this.paintLeadGauge(r.valore, r.motivazione);
            } else if (campo === 'budget_range') {
                this.paintLeadBudget(r.valore);
            } else {
                const el = document.getElementById(campi[campo]);
                if (el) {
                    const matita = campo === 'company_name'
                        ? '<i class="fa-solid fa-pencil text-muted ms-2" style="font-size:12px;opacity:.4"></i>'
                        : '<i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>';
                    el.innerHTML = `${this._escapeHtml(r.valore)} ${matita}`;
                }
            }
            // Si mostra anche cosa c'era prima: se l'AI ha preso un abbaglio
            // la si corregge subito cliccando sul campo.
            this.toast(r.precedente && String(r.precedente) !== String(r.valore)
                ? `Impostato "${r.valore}" (prima: "${r.precedente}")`
                : `Impostato "${r.valore}"`);
        } catch (e) {
            this.toast(e.message || 'Non sono riuscito a ricavarlo', 'warning');
        } finally {
            if (btn) { btn.disabled = false; btn.classList.remove('is-working'); }
        }
    },

    /**
     * Gauge del punteggio nella card "Valutazione" (sidebar lead).
     * L'arco è mezzo cerchio r=48: lunghezza pi*48, l'offset è la quota mancante.
     * Chiamata senza argomenti legge il punteggio dal data-attribute del server.
     */
    paintLeadGauge(score, motivazione) {
        const box = document.getElementById('lead-score-gauge');
        if (!box) return;
        if (score === undefined) score = box.dataset.score;
        const n = (score === '' || score === null || score === undefined) ? null : Number(score);
        const valido = n !== null && !Number.isNaN(n);
        const arco = Math.PI * 48;

        const path = box.querySelector('.gauge-value');
        if (path) path.style.strokeDashoffset = arco * (1 - (valido ? Math.max(0, Math.min(100, n)) : 0) / 100);

        box.classList.remove('is-low', 'is-mid', 'is-high');
        if (valido) box.classList.add(n < 40 ? 'is-low' : (n < 70 ? 'is-mid' : 'is-high'));
        box.dataset.score = valido ? n : '';

        const num = document.getElementById('lead-score-header');
        if (num) num.textContent = valido ? n : '–';

        if (motivazione !== undefined) {
            let riga = box.parentElement.querySelector('.lead-score-reason');
            if (!riga && motivazione) {
                riga = document.createElement('div');
                riga.className = 'lead-score-reason text-muted mt-1';
                riga.style.cssText = 'font-size:11px;line-height:1.3';
                box.parentElement.appendChild(riga);
            }
            if (riga) riga.textContent = motivazione || '';
        }
    },

    /** Valore stimato nella card "Valutazione", ridipinto dopo la stima AI. */
    paintLeadBudget(valore) {
        const el = document.getElementById('lead-budget-header');
        if (!el) return;
        // La stima chiesta a mano azzera l'override: da qui in poi vale l'AI.
        el.dataset.manualOverride = '0';
        el.innerHTML = `${this._escapeHtml(valore || '–')}`
            + ' <span class="badge bg-info text-white ms-1" style="font-size:9px;vertical-align:middle">AI</span>'
            + ' <i class="fa-solid fa-pencil text-muted ms-1" style="font-size:10px;opacity:.5"></i>';
    },

    async copyAiContext() {
        if (!this._aiContextRaw) return;
        try {
            await navigator.clipboard.writeText(this._aiContextRaw);
            this.toast('Contesto copiato');
        } catch (e) {
            this.toast('Copia non riuscita', 'danger');
        }
    },

    // ── Direttive per l'AI ───────────────────────────────────────────────
    // Contesto umano permanente sulla lead: l'AI lo rispetta a ogni passata,
    // a differenza delle istruzioni scritte per la singola stesura. Si scrive
    // da un posto solo (card Valutazione) e si ricorda dove l'AI viene lanciata.

    /** Testo corrente, letto dalla card: null se la pagina non ce l'ha. */
    _aiDirectivesText() {
        const box = document.getElementById('lead-ai-directives');
        return box ? (box.dataset.text || '') : null;
    },

    /** Riga da mettere nei modali che lanciano l'AI, per non farle dimenticare. */
    aiDirectivesHint(leadId) {
        const txt = this._aiDirectivesText();
        const link = `<a href="#" class="text-decoration-none"
             onclick="SyrusApp.showAiDirectivesModal('${this._escapeAttr(leadId)}');return false">`;
        if (txt) {
            const short = txt.length > 220 ? txt.slice(0, 220) + '…' : txt;
            return `<div class="alert alert-light border py-2 px-3 small mb-3">
                <i class="fa-solid fa-bullhorn text-primary me-1"></i>
                <b>L'AI seguir&agrave; anche le direttive della lead:</b>
                <div class="fst-italic text-secondary mt-1">${this._escapeHtml(short)}</div>
                <div class="mt-1">${link}Modifica le direttive</a></div></div>`;
        }
        const testo = txt === ''
            ? 'Nessuna direttiva sulla lead: l\'AI usa solo il CRM.'
            : 'Direttive per l\'AI su questa lead.';
        return `<div class="small text-muted mb-3">
            <i class="fa-solid fa-bullhorn me-1"></i>${testo}
            ${link}Scrivile</a></div>`;
    },

    async showAiDirectivesModal(leadId) {
        this._aiDirectivesLeadId = leadId;
        this._showModal(
            '<i class="fa-solid fa-bullhorn me-2 text-primary"></i>Direttive per l\'AI',
            '<div class="text-center py-4 text-muted">Caricamento&hellip;</div>');
        let d;
        try {
            d = await this.api(`/leads/api/${leadId}/ai-directives`);
        } catch (e) {
            this.toast(e.message, 'danger');
            return;
        }
        const firma = d.updated_at
            ? `<div class="form-text">Aggiornate il ${this.formatDate(d.updated_at)}${
                d.by ? ' da ' + this._escapeHtml(d.by) : ''}.</div>` : '';
        this._showModal(
            '<i class="fa-solid fa-bullhorn me-2 text-primary"></i>Direttive per l\'AI', `
            <form onsubmit="SyrusApp.saveAiDirectives(event)">
                <p class="text-muted small">Quello che sai tu e l'AI no: vincoli detti a voce,
                    preferenze del cliente, prezzi da tenere, argomenti da non toccare.
                    Valgono <b>sempre</b> — analisi, offerta e contratto — finch&eacute; non le cambi.
                    Per una singola stesura usa invece le istruzioni del modale di generazione.</p>
                <div class="mb-3">
                    <textarea name="directives" class="form-control" rows="9"
                              maxlength="${d.max_chars || 4000}"
                              placeholder="Es: il cliente ha gi&agrave; un gestionale e non vuole sostituirlo.&#10;Non proporre l'app mobile: bocciata in call.&#10;Tenere il canone sotto i 200 &euro;/mese."
                    >${this._escapeHtml(d.directives || '')}</textarea>
                    ${firma}
                </div>
                <div class="d-flex gap-2">
                    <button type="submit" class="btn btn-primary">
                        <i class="fa-solid fa-floppy-disk me-1"></i>Salva</button>
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Annulla</button>
                </div>
            </form>`);
    },

    async saveAiDirectives(event) {
        event.preventDefault();
        const leadId = this._aiDirectivesLeadId;
        const testo = (new FormData(event.target).get('directives') || '').trim();
        try {
            const d = await this.api(`/leads/api/${leadId}/ai-directives`, {
                method: 'PUT', body: JSON.stringify({directives: testo}) });
            bootstrap.Modal.getInstance(document.getElementById('syrus-modal'))?.hide();
            this._paintAiDirectives(d);
            this.toast(testo ? 'Direttive salvate: l\'AI le seguirà da ora' : 'Direttive rimosse');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    _paintAiDirectives(d) {
        const box = document.getElementById('lead-ai-directives');
        if (!box) return;
        box.dataset.text = d.directives || '';
        box.innerHTML = d.directives
            ? `<div class="ai-directives-text">${this._escapeHtml(d.directives)}</div>
               <div class="small text-muted mt-1" style="font-size:11px">
                   L'AI le segue in analisi, offerta e contratto</div>`
            : `<div class="small text-muted">Nessuna direttiva: l'AI lavora solo su quello
                   che trova nel CRM. Scrivi qui quello che sai tu e lei no.</div>`;
        // Il pulsante accanto al titolo cambia parola col contenuto
        const btn = box.previousElementSibling?.querySelector('button');
        if (btn) btn.textContent = d.directives ? 'Modifica' : 'Aggiungi';
    },
});


// ── app-videocall.js ──
/**
 * Syrus Sales OS – Registrazioni videocall della lead
 *
 * Il file non passa dal server: viene tagliato a pezzi e ogni pezzo va
 * direttamente sullo Space con un URL firmato. Il server sa solo quali pezzi
 * sono arrivati, ed è quello che rende il caricamento ripartibile — una
 * connessione che cade a metà di un file da 3 GB non butta via il lavoro fatto.
 */
Object.assign(SyrusApp, {

    // Un pezzo alla volta: su ADSL tre richieste in parallelo si rubano banda
    // a vicenda e allungano il tempo totale invece di accorciarlo.
    _vcMaxRetries: 4,

    // ── Impostazioni → Videocall (storage) ──────────────────────────────────

    async loadVideocallStorage() {
        const box = document.getElementById('vcs-status');
        if (!box) return;
        let c;
        try {
            c = await this.api('/settings/api/videocall-storage/config');
        } catch (e) {
            box.innerHTML = `<div class="alert alert-danger mb-0">${this._escapeHtml(e.message)}</div>`;
            return;
        }

        const provenienza = {
            workspace: 'credenziali di questo workspace',
            env: 'credenziali globali dal file .env del server',
            none: '',
        }[c.source] || '';

        box.innerHTML = c.configured
            ? `<div class="alert alert-success mb-0 py-2">
                 <i class="fa-solid fa-circle-check me-1"></i>Storage configurato
                 <span class="text-muted small">— ${this._escapeHtml(provenienza)}, pezzi da ${c.part_size_mb} MB</span>
               </div>`
            : `<div class="alert alert-warning mb-0 py-2">
                 <i class="fa-solid fa-triangle-exclamation me-1"></i>Storage non configurato: il tab Videocall delle lead resta disabilitato.
               </div>`;

        document.getElementById('vcs-key').value = c.key || '';
        document.getElementById('vcs-bucket').value = c.bucket || '';
        document.getElementById('vcs-region').value = c.region || '';
        document.getElementById('vcs-endpoint').value = c.endpoint || '';
        document.getElementById('vcs-prefix').value = c.prefix || '';
        document.getElementById('vcs-esempio').textContent = c.esempio_percorso || '';
        // Il secret non torna mai dal server: campo vuoto = "non toccarlo"
        document.getElementById('vcs-secret').value = '';
        document.getElementById('vcs-secret').placeholder =
            c.has_secret ? 'già impostato — lascia vuoto per non modificarlo' : 'da inserire';
    },

    async saveVideocallStorage() {
        const payload = {
            key: document.getElementById('vcs-key').value.trim(),
            secret: document.getElementById('vcs-secret').value.trim(),
            bucket: document.getElementById('vcs-bucket').value.trim(),
            region: document.getElementById('vcs-region').value.trim(),
            endpoint: document.getElementById('vcs-endpoint').value.trim(),
            prefix: document.getElementById('vcs-prefix').value.trim(),
        };
        try {
            await this.api('/settings/api/videocall-storage/config/save',
                           {method: 'POST', body: JSON.stringify(payload)});
            this.toast('Configurazione salvata');
            this.loadVideocallStorage();
        } catch (e) {
            this.toast(e.message || 'Salvataggio non riuscito', 'danger');
        }
    },

    async testVideocallStorage() {
        const box = document.getElementById('vcs-test-result');
        box.innerHTML = '<span class="text-muted small"><span class="spinner-border spinner-border-sm me-1"></span>Provo a scrivere e rileggere un file di prova...</span>';
        let r;
        try {
            // L'origin lo sa solo il browser: dedurlo lato server dietro il
            // proxy darebbe http:// invece di https:// e un falso allarme.
            r = await this.api('/settings/api/videocall-storage/test', {
                method: 'POST',
                body: JSON.stringify({origin: window.location.origin}),
            });
        } catch (e) {
            box.innerHTML = `<div class="alert alert-danger mb-0 py-2"><i class="fa-solid fa-xmark me-1"></i>${this._escapeHtml(e.message)}</div>`;
            return;
        }

        // Il probe fa lo stesso preflight del browser: risponde alla domanda
        // che conta davvero, cioè se il caricamento andrà a buon fine.
        const cors = r.cors_ok
            ? '<div class="small mt-1"><i class="fa-solid fa-circle-check text-success me-1"></i>CORS attiva: il caricamento dal browser funziona.</div>'
            : `<div class="small mt-1"><i class="fa-solid fa-triangle-exclamation text-warning me-1"></i>
                 <strong>CORS non configurata</strong> per <code>${this._escapeHtml(r.origin || '')}</code>:
                 le credenziali sono giuste, ma il browser non può caricare finché non la imposti
                 nel pannello DigitalOcean (valori qui sotto).</div>`;

        box.innerHTML = `<div class="alert alert-${r.cors_ok ? 'success' : 'warning'} mb-0 py-2">
            <i class="fa-solid fa-circle-check me-1"></i>Lettura e scrittura sullo Space <code>${this._escapeHtml(r.bucket)}</code> funzionano.
            ${cors}
        </div>`;
    },

    _vcFormatSize(bytes) {
        if (!bytes) return '';
        const u = ['B', 'KB', 'MB', 'GB', 'TB'];
        let i = 0, n = Number(bytes);
        while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
        return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
    },

    async loadVideocalls(leadId) {
        const box = document.getElementById('videocall-list');
        if (!box) return;
        this._vcLeadId = leadId;

        let data;
        try {
            data = await this.api(`/leads/api/${leadId}/videocalls`);
        } catch (e) {
            box.innerHTML = `<div class="alert alert-danger mb-0">${this._escapeHtml(e.message)}</div>`;
            return;
        }

        if (!data.storage_configured) {
            box.innerHTML = `<div class="alert alert-warning mb-0">
                <i class="fa-solid fa-triangle-exclamation me-1"></i>
                Storage delle registrazioni non ancora configurato.
                Servono <code>SPACES_KEY</code>, <code>SPACES_SECRET</code> e
                <code>SPACES_BUCKET</code> nel <code>.env</code> di syrus-sales.
            </div>`;
            const btn = document.getElementById('videocall-upload-btn');
            if (btn) btn.disabled = true;
            return;
        }

        if (!data.items.length) {
            box.innerHTML = `<div class="text-center py-5 text-muted">
                <i class="fa-solid fa-video fa-2x mb-3 d-block opacity-50"></i>
                Nessuna registrazione caricata per questa lead.
            </div>`;
            return;
        }

        box.innerHTML = `<div class="row g-3">${data.items.map(v => this._vcCard(v)).join('')}</div>`;
        data.items.forEach(v => this._vcLoadMedia(v));

        // Finché qualcosa è in lavorazione la lista si aggiorna da sola:
        // l'utente non deve ricaricare per vedere comparire il verbale.
        const inCorso = data.items.some(v => ['pending', 'running'].includes(v.preview_state)
            || ['pending', 'running'].includes(v.transcription_state)
            || ['pending', 'running'].includes(v.summary_state));
        clearTimeout(this._vcPollTimer);
        if (inCorso) {
            this._vcPollTimer = setTimeout(() => this.loadVideocalls(leadId), 10000);
        }
    },

    _vcBadge(stato, etichetta) {
        const m = {
            completed: ['success', 'fa-check'],
            running: ['info', 'fa-spinner fa-spin'],
            pending: ['secondary', 'fa-clock'],
            failed: ['danger', 'fa-xmark'],
        }[stato] || ['secondary', 'fa-clock'];
        const testo = {completed: '', running: 'in corso', pending: 'in attesa', failed: 'non riuscita'}[stato] || '';
        return `<span class="badge bg-${m[0]}-subtle text-${m[0]}-emphasis border border-${m[0]}-subtle">
            <i class="fa-solid ${m[1]} me-1"></i>${this._escapeHtml(etichetta)}${testo ? ' ' + testo : ''}</span>`;
    },

    _vcCard(v) {
        const durata = v.duration_seconds
            ? `${Math.floor(v.duration_seconds / 60)}:${String(v.duration_seconds % 60).padStart(2, '0')}`
            : '';
        const sotto = [
            v.meeting_date ? this._fmtDateIt(v.meeting_date) : this._fmtDateIt(v.created_at),
            this._vcFormatSize(v.size_bytes),
        ].filter(Boolean).join(' · ');

        const incompleto = v.upload_state !== 'completed';

        return `<div class="col-md-6 col-xl-4">
            <div class="card h-100 vc-card" id="vc-card-${v.id}">
                <div class="vc-thumb" onmouseenter="SyrusApp.vcHover('${v.id}', true)"
                     onmouseleave="SyrusApp.vcHover('${v.id}', false)"
                     onclick="SyrusApp.openVideocall('${v.id}')">
                    <img id="vc-img-${v.id}" alt="">
                    <div class="vc-thumb-fallback" id="vc-fallback-${v.id}">
                        <i class="fa-solid fa-video"></i>
                    </div>
                    <span class="vc-play"><i class="fa-solid fa-play"></i></span>
                    ${durata ? `<span class="vc-durata">${durata}</span>` : ''}
                </div>
                <div class="card-body p-3">
                    <div class="fw-semibold text-truncate" title="${this._escapeAttr(v.title || v.filename)}">
                        ${this._escapeHtml(v.title || v.filename)}
                    </div>
                    <div class="small text-muted mb-2">${this._escapeHtml(sotto)}</div>
                    <div class="d-flex flex-wrap gap-1">
                        ${incompleto
                            ? '<span class="badge bg-warning text-dark"><i class="fa-solid fa-triangle-exclamation me-1"></i>Caricamento incompleto</span>'
                            : this._vcBadge(v.transcription_state, 'Trascrizione') + this._vcBadge(v.summary_state, 'Verbale')}
                    </div>
                </div>
                <div class="card-footer bg-white border-0 pt-0 pb-3 px-3 d-flex gap-2">
                    <button class="btn btn-sm btn-outline-primary flex-grow-1" onclick="SyrusApp.openVideocall('${v.id}')">
                        <i class="fa-solid fa-file-lines me-1"></i>Apri
                    </button>
                    ${v.preview_state === 'failed'
                        ? `<button class="btn btn-sm btn-outline-secondary" title="Rifai l'anteprima"
                                   onclick="SyrusApp.regenPreview('${v.id}')"><i class="fa-solid fa-image"></i></button>`
                        : ''}
                    <button class="btn btn-sm btn-outline-danger" title="Elimina"
                            data-vc-id="${v.id}" data-vc-file="${this._escapeAttr(v.filename)}"
                            onclick="SyrusApp.deleteVideocall(this.dataset.vcId, this.dataset.vcFile)">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                </div>
            </div>
        </div>`;
    },

    /** Carica poster e GIF; la GIF si scarica solo al primo passaggio del mouse. */
    async _vcLoadMedia(v) {
        if (!v.has_preview) return;
        try {
            const m = await this.api(`/leads/api/${this._vcLeadId}/videocalls/${v.id}/media`);
            const img = document.getElementById(`vc-img-${v.id}`);
            const fb = document.getElementById(`vc-fallback-${v.id}`);
            if (!img) return;
            this._vcMedia = this._vcMedia || {};
            this._vcMedia[v.id] = m;
            if (m.poster) {
                img.src = m.poster;
                img.style.display = 'block';
                if (fb) fb.style.display = 'none';
            }
        } catch (e) { /* l'anteprima è un di più: se manca resta l'icona */ }
    },

    vcHover(id, dentro) {
        const img = document.getElementById(`vc-img-${id}`);
        const m = (this._vcMedia || {})[id];
        if (!img || !m || !m.gif) return;
        // La GIF parte solo al passaggio del mouse: caricarle tutte insieme
        // significherebbe scaricare qualche MB per ogni riunione in lista.
        img.src = dentro ? m.gif : (m.poster || m.gif);
    },

    async regenPreview(id) {
        try {
            await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/rigenera-anteprima`, {method: 'POST'});
            this.toast('Anteprima in rigenerazione');
            setTimeout(() => this.loadVideocalls(this._vcLeadId), 3000);
        } catch (e) {
            this.toast(e.message || 'Rigenerazione non riuscita', 'danger');
        }
    },

    /** Avvia trascrizione + verbale dal dettaglio della riunione. */
    async transcribeVideocall(id) {
        const btn = document.getElementById('vc-trascrivi-btn');
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<span class="spinner-border spinner-border-sm me-1"></span>Avviata...';
        }
        try {
            await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/trascrivi`, {method: 'POST'});
            this.toast('Trascrizione avviata: il verbale arriva subito dopo');
            this._vcWatchDetail(id);
        } catch (e) {
            this.toast(e.message || 'Avvio non riuscito', 'danger');
            if (btn) {
                btn.disabled = false;
                btn.innerHTML = '<i class="fa-solid fa-wand-magic-sparkles me-1"></i>Trascrivi e genera verbale';
            }
        }
    },

    /** Ricarica il dettaglio finché trascrizione e verbale non sono conclusi. */
    _vcWatchDetail(id) {
        clearTimeout(this._vcDetailTimer);
        this._vcDetailTimer = setTimeout(async () => {
            const el = document.getElementById('vc-detail-modal');
            if (!el || !el.classList.contains('show')) return;
            await this.openVideocall(id, true);
        }, 8000);
    },

    async openVideocall(id, soloAggiorna = false) {
        const modalId = 'vc-detail-modal';
        let el = document.getElementById(modalId);
        if (!el) {
            el = document.createElement('div');
            el.id = modalId;
            el.className = 'modal fade';
            el.innerHTML = `<div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content"><div class="modal-body" id="vc-detail-body"></div></div></div>`;
            document.body.appendChild(el);
        }
        const body = document.getElementById('vc-detail-body');
        // In aggiornamento automatico si riscrive il contenuto senza far
        // lampeggiare la modale né riaprirla.
        if (!soloAggiorna) {
            body.innerHTML = '<div class="text-center py-5 text-muted">Caricamento...</div>';
            bootstrap.Modal.getOrCreateInstance(el).show();
        }

        let d;
        try {
            d = await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/detail`);
        } catch (e) {
            body.innerHTML = `<div class="alert alert-danger mb-0">${this._escapeHtml(e.message)}</div>`;
            return;
        }
        const v = d.videocall;

        const verbale = d.summary
            ? this._renderMarkdown(d.summary)
            : `<div class="text-muted small">${v.summary_state === 'running' ? 'Verbale in corso di scrittura...'
                : v.summary_state === 'failed' ? 'Verbale non disponibile' + (v.last_error ? `: ${this._escapeHtml(v.last_error)}` : '')
                : 'Verbale non ancora generato'}</div>`;

        const trascrizione = d.trascrizione && d.trascrizione.testo
            ? `<pre class="small bg-light p-3 rounded" style="white-space:pre-wrap;max-height:340px;overflow:auto">${this._escapeHtml(d.trascrizione.testo)}</pre>`
            : `<div class="text-muted small">${v.transcription_state === 'running' ? 'Trascrizione in corso...' : 'Trascrizione non disponibile'}</div>`;

        // Trascrizione e verbale partono da soli all'apertura della lead: il
        // pulsante serve a rifarli, o ad anticiparli se sono ancora in coda.
        const inCorso = v.transcription_state === 'running' || v.summary_state === 'running';
        const fatta = v.transcription_state === 'completed';
        const lavorazione = inCorso
            ? `<button class="btn btn-sm btn-primary" disabled>
                   <span class="spinner-border spinner-border-sm me-1"></span>
                   ${v.transcription_state === 'running' ? 'Trascrizione in corso...' : 'Scrittura verbale...'}
               </button>`
            : `<button class="btn btn-sm ${fatta ? 'btn-outline-secondary' : 'btn-primary'}" id="vc-trascrivi-btn"
                       onclick="SyrusApp.transcribeVideocall('${id}')">
                   <i class="fa-solid fa-wand-magic-sparkles me-1"></i>${fatta ? 'Rifai trascrizione e verbale' : 'Trascrivi ora'}
               </button>`;

        const avviso = (!inCorso && v.last_error)
            ? `<div class="alert alert-warning py-2 px-3 small">${this._escapeHtml(v.last_error)}</div>`
            : '';

        if (inCorso) this._vcWatchDetail(id);

        body.innerHTML = `
            <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                    <h5 class="fw-bold mb-1">${this._escapeHtml(v.title || v.filename)}</h5>
                    <div class="small text-muted">${this._escapeHtml([
                        v.meeting_date ? 'Riunione del ' + this._fmtDateIt(v.meeting_date) : '',
                        this._vcFormatSize(v.size_bytes),
                        d.trascrizione && d.trascrizione.parlanti ? d.trascrizione.parlanti + ' parlanti' : '',
                    ].filter(Boolean).join(' · '))}</div>
                </div>
                <button class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div id="vc-modal-player" class="mb-3">
                <div class="text-center py-4 text-muted small">Carico il video...</div>
            </div>
            <div class="d-flex flex-wrap gap-2 mb-3">
                ${lavorazione}
                <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.downloadVideocall('${id}')">
                    <i class="fa-solid fa-download me-1"></i>Scarica
                </button>
                <button class="btn btn-sm btn-outline-secondary" onclick="SyrusApp.regenPreview('${id}')" title="Rifai l'anteprima animata">
                    <i class="fa-solid fa-image me-1"></i>Rifai anteprima
                </button>
            </div>
            ${avviso}
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item"><button class="nav-link active" data-bs-toggle="tab" data-bs-target="#vc-tab-verbale">Verbale</button></li>
                <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#vc-tab-trascr">Trascrizione</button></li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane fade show active" id="vc-tab-verbale">${verbale}</div>
                <div class="tab-pane fade" id="vc-tab-trascr">${trascrizione}</div>
            </div>`;

        // Il video si carica da solo all'apertura: si preleva solo
        // l'intestazione, quindi non pesa finché non si preme play.
        this.playVideocallInModal(id);
    },

    /** Carica il player nella modale. Chiamata all'apertura, non da un pulsante. */
    async playVideocallInModal(id) {
        const slot = document.getElementById('vc-modal-player');
        if (!slot) return;
        try {
            const res = await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/url`);
            // preload="metadata": scarica solo l'intestazione, il resto arriva
            // quando si preme play. Su un file da 250 MB fa la differenza.
            slot.innerHTML = `<video class="w-100 rounded" controls preload="metadata"
                                     style="max-height:420px;background:#000"
                                     src="${this._escapeAttr(res.url)}"></video>`;
        } catch (e) {
            slot.innerHTML = `<div class="alert alert-warning py-2 px-3 small mb-0">
                Video non disponibile: ${this._escapeHtml(e.message || '')}</div>`;
        }
    },

    async downloadVideocall(id) {
        try {
            const res = await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/url`);
            window.open(res.url, '_blank');
        } catch (e) {
            this.toast(e.message || 'Download non disponibile', 'danger');
        }
    },

    async playVideocall(id) {
        const slot = document.getElementById(`vc-player-${id}`);
        if (!slot) return;
        if (slot.innerHTML) { slot.innerHTML = ''; return; }
        try {
            const res = await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}/url`);
            // L'URL è firmato e scade: si chiede al momento della riproduzione
            slot.innerHTML = `<video class="w-100 mb-3 rounded" controls preload="metadata" src="${this._escapeAttr(res.url)}"></video>`;
        } catch (e) {
            this.toast(e.message || 'Riproduzione non disponibile', 'danger');
        }
    },

    async deleteVideocall(id, filename) {
        // Doppia conferma col nome del file: la registrazione di una riunione
        // non si recupera, lo Space non tiene versioni precedenti.
        const scritto = prompt(
            `Questa registrazione verrà eliminata DEFINITIVAMENTE e non è recuperabile.\n\n` +
            `Per confermare, scrivi il nome del file:\n${filename}`);
        if (scritto === null) return;
        if (scritto.trim() !== filename) {
            this.toast('Nome file non corrispondente: eliminazione annullata', 'warning');
            return;
        }
        try {
            await this.api(`/leads/api/${this._vcLeadId}/videocalls/${id}`,
                           {method: 'DELETE', body: JSON.stringify({conferma: filename})});
            this.toast('Registrazione eliminata');
            this.loadVideocalls(this._vcLeadId);
        } catch (e) {
            this.toast(e.message || 'Eliminazione non riuscita', 'danger');
        }
    },

    _vcRenderProgress(nome, fatti, totali, percentuale) {
        const box = document.getElementById('videocall-progress');
        if (!box) return;
        box.innerHTML = `<div class="border rounded p-3 mb-3 bg-light">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div class="fw-semibold text-truncate">${this._escapeHtml(nome)}</div>
                <small class="text-muted">${fatti}/${totali} pezzi</small>
            </div>
            <div class="progress" style="height:6px">
                <div class="progress-bar" style="width:${percentuale}%"></div>
            </div>
        </div>`;
    },

    /**
     * Carica un file a pezzi. Ogni pezzo viene ritentato da solo: un errore di
     * rete non fa ricominciare tutto.
     */
    async uploadVideocall(leadId, file) {
        if (!file) return;
        this._vcLeadId = leadId;
        const btn = document.getElementById('videocall-upload-btn');
        if (btn) btn.disabled = true;

        let init;
        try {
            init = await this.api(`/leads/api/${leadId}/videocalls/init`, {
                method: 'POST',
                body: JSON.stringify({
                    filename: file.name,
                    size_bytes: file.size,
                    content_type: file.type || 'application/octet-stream',
                }),
            });
        } catch (e) {
            this.toast(e.message || 'Avvio caricamento non riuscito', 'danger');
            if (btn) btn.disabled = false;
            return;
        }

        const {videocall_id: vcId, part_size: partSize} = init;
        const totali = Math.max(1, Math.ceil(file.size / partSize));
        const parts = [];

        // Avvisa se si chiude la scheda a metà: i pezzi restano, ma il file
        // non è leggibile finché il caricamento non viene completato.
        const avviso = (ev) => { ev.preventDefault(); ev.returnValue = ''; };
        window.addEventListener('beforeunload', avviso);

        try {
            for (let n = 1; n <= totali; n++) {
                this._vcRenderProgress(file.name, n - 1, totali,
                                       Math.round(((n - 1) / totali) * 100));
                const blob = file.slice((n - 1) * partSize, n * partSize);
                const etag = await this._vcUploadPart(leadId, vcId, n, blob);
                if (etag) parts.push({PartNumber: n, ETag: etag});
                await this.api(`/leads/api/${leadId}/videocalls/${vcId}/part-done`, {
                    method: 'POST',
                    body: JSON.stringify({part_number: n, etag, size: blob.size}),
                });
            }

            this._vcRenderProgress(file.name, totali, totali, 100);
            await this.api(`/leads/api/${leadId}/videocalls/${vcId}/complete`, {
                method: 'POST',
                body: JSON.stringify({parts}),
            });

            document.getElementById('videocall-progress').innerHTML = '';
            this.toast('Registrazione caricata');
            this.loadVideocalls(leadId);
        } catch (e) {
            document.getElementById('videocall-progress').innerHTML =
                `<div class="alert alert-danger">Caricamento interrotto: ${this._escapeHtml(e.message || 'errore di rete')}.
                 I pezzi già caricati restano salvati.</div>`;
            this.toast('Caricamento interrotto', 'danger');
        } finally {
            window.removeEventListener('beforeunload', avviso);
            if (btn) btn.disabled = false;
        }
    },

    /** Carica un pezzo con ritentativi ed ETag di ritorno. */
    async _vcUploadPart(leadId, vcId, partNumber, blob) {
        let ultimoErrore;
        for (let tentativo = 1; tentativo <= this._vcMaxRetries; tentativo++) {
            try {
                const {url} = await this.api(
                    `/leads/api/${leadId}/videocalls/${vcId}/part-url`,
                    {method: 'POST', body: JSON.stringify({part_number: partNumber})});

                // fetch diretta allo Space: NON passa da this.api (che aggiunge
                // header e credenziali della sessione Syrus, che S3 rifiuta).
                let resp;
                try {
                    resp = await fetch(url, {method: 'PUT', body: blob});
                } catch (netErr) {
                    // Una PUT cross-origin richiede il preflight: se lo Space non
                    // ha la CORS, il browser blocca prima ancora di partire e
                    // qui arriva un TypeError generico, non uno status HTTP.
                    throw new Error('lo storage ha rifiutato la connessione — '
                        + 'è la CORS dello Space non configurata. Vai in '
                        + 'Impostazioni → Videocall (storage): trovi i valori esatti da inserire '
                        + 'nel pannello DigitalOcean (origin ' + window.location.origin + ', metodi GET/PUT/HEAD)');
                }
                if (!resp.ok) throw new Error(`storage ha risposto ${resp.status}`);

                // L'ETag può non essere leggibile se la CORS non lo espone:
                // non è un problema, al momento di chiudere il caricamento
                // il server rilegge gli ETag direttamente dallo Space.
                return resp.headers.get('ETag') || resp.headers.get('etag') || '';
            } catch (e) {
                ultimoErrore = e;
                if (tentativo < this._vcMaxRetries) {
                    // Attesa crescente: 1s, 2s, 4s
                    await new Promise(r => setTimeout(r, 1000 * Math.pow(2, tentativo - 1)));
                }
            }
        }
        throw ultimoErrore;
    },
});


// ── app-email-ai.js ──
/**
 * Syrus Sales OS – Generazione email con l'AI + libreria di prompt condivisa
 *
 * Porting dal Lead Manager. Il pulsante di salvataggio dice sempre cosa farà:
 *   - "Salva prompt"        il testo è nuovo
 *   - "Aggiorna «nome»"     arriva dalla libreria ed è stato ritoccato
 *   - "Già in libreria"      identico a uno esistente (disattivato)
 * Senza questa distinzione ogni ritocco risalvato creava una copia, e la
 * libreria si riempiva di varianti quasi identiche.
 */
Object.assign(SyrusApp, {

    _prompts: [],
    _promptSelezionato: null,   // {id, title, text} se il testo viene dalla libreria

    /** Stessa normalizzazione del server: spazi compressi, maiuscole ignorate. */
    _normPrompt(t) {
        return (t || '').replace(/\s+/g, ' ').trim().toLowerCase();
    },

    _emailAiBoxHtml() {
        return `
        <div class="card mb-3 border-brand" id="email-ai-card">
            <div class="card-header bg-brand-light py-2 d-flex justify-content-between align-items-center">
                <span class="fw-bold"><i class="fa-solid fa-wand-magic-sparkles me-2 text-primary"></i>Scrivila con l'AI</span>
                <a href="#" class="small" onclick="SyrusApp.togglePromptLibrary();return false">
                    <i class="fa-solid fa-book me-1"></i>Libreria prompt
                </a>
            </div>
            <div class="card-body py-3">
                <div id="prompt-library" class="mb-3 d-none"></div>
                <label class="form-label mb-1">Istruzione per l'AI</label>
                <textarea id="ai-prompt" class="form-control" rows="3"
                          placeholder="Es. sollecita il preventivo con tono cordiale, oggetto tipo «[Azienda] - Bando CCIAA - 10K a fondo perduto»"
                          oninput="SyrusApp._onPromptInput()"></textarea>
                <div class="d-flex flex-wrap gap-2 align-items-center mt-2">
                    <button type="button" class="btn btn-primary btn-sm" id="ai-generate-btn"
                            onclick="SyrusApp.generaEmailAi()">
                        <i class="fa-solid fa-wand-magic-sparkles me-1"></i>Genera mail
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" id="ai-save-prompt-btn"
                            onclick="SyrusApp.salvaPrompt()" disabled>Salva prompt</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm d-none" id="ai-save-new-btn"
                            onclick="SyrusApp.salvaPrompt(true)">Salva come nuovo</button>
                    <button type="button" class="btn btn-link btn-sm text-muted p-0 ms-auto"
                            onclick="SyrusApp.anteprimaContestoAi()">
                        Mostra cosa verrà mandato all'AI
                    </button>
                </div>
                <div id="ai-status" class="small text-muted mt-2"></div>
            </div>
        </div>`;
    },

    async initEmailAi(leadId) {
        this._aiLeadId = leadId;
        this._promptSelezionato = null;
        const box = document.getElementById('email-ai-box');
        if (!box || !leadId) return;
        box.innerHTML = this._emailAiBoxHtml();
        await this.caricaPrompts();
        this._onPromptInput();
    },

    async caricaPrompts() {
        try {
            this._prompts = (await this.api('/prompts/api/list')).items || [];
        } catch (_) {
            this._prompts = [];
        }
        this._renderPromptLibrary();
    },

    togglePromptLibrary() {
        const el = document.getElementById('prompt-library');
        if (el) el.classList.toggle('d-none');
    },

    _renderPromptLibrary() {
        const el = document.getElementById('prompt-library');
        if (!el) return;
        if (!this._prompts.length) {
            el.innerHTML = '<div class="text-muted small">Nessun prompt salvato. Scrivine uno e premi «Salva prompt».</div>';
            return;
        }
        el.innerHTML = `
            <div class="list-group list-group-flush border rounded">
                ${this._prompts.map(p => `
                <div class="list-group-item d-flex justify-content-between align-items-center py-2">
                    <a href="#" class="text-decoration-none flex-grow-1 me-2"
                       onclick="SyrusApp.usaPrompt('${p.id}');return false">
                        <div class="fw-medium">${this._escapeHtml(p.title)}</div>
                        <small class="text-muted">${this._escapeHtml((p.text || '').slice(0, 90))}…</small>
                    </a>
                    <span class="badge bg-light text-dark me-2" title="Quante volte è stato usato">${p.used_count}×</span>
                    <button type="button" class="btn btn-sm btn-link text-danger p-0"
                            onclick="SyrusApp.eliminaPrompt('${p.id}')" title="Elimina">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                </div>`).join('')}
            </div>`;
    },

    usaPrompt(id) {
        const p = this._prompts.find(x => x.id === id);
        if (!p) return;
        const ta = document.getElementById('ai-prompt');
        if (ta) ta.value = p.text;
        this._promptSelezionato = {id: p.id, title: p.title, text: p.text};
        this.togglePromptLibrary();
        this._onPromptInput();
    },

    /** Il pulsante deve sempre dire cosa farà: qui si decide quale stato mostrare. */
    _onPromptInput() {
        const ta = document.getElementById('ai-prompt');
        const btn = document.getElementById('ai-save-prompt-btn');
        const btnNuovo = document.getElementById('ai-save-new-btn');
        if (!ta || !btn) return;

        const testo = ta.value || '';
        const norm = this._normPrompt(testo);
        btnNuovo.classList.add('d-none');

        if (!norm) {
            btn.disabled = true;
            btn.textContent = 'Salva prompt';
            return;
        }
        const gemello = this._prompts.find(p => this._normPrompt(p.text) === norm);
        if (gemello) {
            btn.disabled = true;
            btn.textContent = 'Già in libreria';
            return;
        }
        const sel = this._promptSelezionato;
        if (sel && this._normPrompt(sel.text) !== norm) {
            btn.disabled = false;
            btn.textContent = `Aggiorna «${sel.title}»`;
            btnNuovo.classList.remove('d-none');
            return;
        }
        btn.disabled = false;
        btn.textContent = 'Salva prompt';
    },

    async salvaPrompt(comeNuovo) {
        const ta = document.getElementById('ai-prompt');
        const testo = (ta && ta.value || '').trim();
        if (!testo) return;
        const sel = this._promptSelezionato;

        try {
            if (sel && !comeNuovo) {
                await this.api(`/prompts/api/${sel.id}`, {
                    method: 'PUT', body: JSON.stringify({text: testo}),
                });
                this._promptSelezionato = {...sel, text: testo};
                this.toast(`Prompt «${sel.title}» aggiornato`);
            } else {
                const titolo = prompt('Nome del prompt:',
                    testo.split('\n')[0].slice(0, 60)) || '';
                if (!titolo.trim()) return;
                const creato = await this.api('/prompts/api/create', {
                    method: 'POST', body: JSON.stringify({title: titolo, text: testo}),
                });
                this._promptSelezionato = {id: creato.id, title: creato.title, text: creato.text};
                this.toast(creato.duplicato ? 'Questo prompt era già in libreria' : 'Prompt salvato');
            }
            await this.caricaPrompts();
            this._onPromptInput();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async eliminaPrompt(id) {
        const p = this._prompts.find(x => x.id === id);
        if (!p || !confirm(`Eliminare il prompt «${p.title}»?`)) return;
        try {
            await this.api(`/prompts/api/${id}`, {method: 'DELETE'});
            if (this._promptSelezionato && this._promptSelezionato.id === id) {
                this._promptSelezionato = null;
            }
            // Stessa funzione da due schermi: si aggiorna quello in cui siamo.
            if (document.getElementById('prompts-table')) {
                await this.loadPromptsPage();
            } else {
                await this.caricaPrompts();
                this._onPromptInput();
            }
            this.toast('Prompt eliminato');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    async generaEmailAi() {
        const ta = document.getElementById('ai-prompt');
        const testo = (ta && ta.value || '').trim();
        if (!testo) { this.toast("Scrivi un'istruzione per l'AI", 'danger'); return; }

        const btn = document.getElementById('ai-generate-btn');
        const stato = document.getElementById('ai-status');
        const originale = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin me-1"></i>Sto scrivendo...';
        if (stato) stato.textContent = "L'AI ha in pancia scheda lead, contesto di progetto e storico email.";

        try {
            const res = await this.api(`/leads/api/${this._aiLeadId}/email-ai`, {
                method: 'POST', body: JSON.stringify({prompt: testo}),
            });
            const form = document.querySelector('#syrus-composer form');
            if (res.subject && form && form.subject) form.subject.value = res.subject;
            // Il corpo va scritto in TinyMCE, non nella textarea sottostante.
            const ed = window.tinymce && tinymce.get('email-body-html');
            if (ed) ed.setContent(res.body_html || '');
            else {
                const t = document.getElementById('email-body-html');
                if (t) t.value = res.body_html || '';
            }
            if (stato) stato.textContent = res.warning || 'Fatto: rileggi e correggi prima di inviare.';
            if (res.warning) this.toast(res.warning, 'danger');

            // Conta l'uso solo quando il prompt ha davvero prodotto qualcosa.
            if (this._promptSelezionato) {
                this.api(`/prompts/api/${this._promptSelezionato.id}/used`, {method: 'POST'})
                    .then(() => this.caricaPrompts()).catch(() => {});
            }
        } catch (e) {
            if (stato) stato.textContent = '';
            this.toast(e.message, 'danger');
        } finally {
            btn.disabled = false;
            btn.innerHTML = originale;
        }
    },

    async anteprimaContestoAi() {
        const ta = document.getElementById('ai-prompt');
        const testo = (ta && ta.value || '');
        try {
            const res = await this.api(`/leads/api/${this._aiLeadId}/email-ai/contesto`, {
                method: 'POST', body: JSON.stringify({prompt: testo}),
            });
            const blocchi = (res.blocks || []).map(b => `
                <div class="mb-3">
                    <div class="fw-bold small text-uppercase text-muted mb-1">${this._escapeHtml(b.ruolo)}</div>
                    <pre class="bg-light border rounded p-2 mb-0" style="max-height:34vh;overflow:auto;white-space:pre-wrap;font-size:.8rem">${this._escapeHtml(b.testo || '(vuoto)')}</pre>
                </div>`).join('');
            this._showModal(
                `Cosa verrà mandato all'AI <small class="text-muted ms-2">${res.chars} caratteri</small>`,
                blocchi + '<p class="text-muted small mb-0">La richiesta dell\'operatore viaggia separata e ha la precedenza sulle regole generali: i fatti che porti tu (bandi, importi, esempi di oggetto) vengono usati così come li scrivi.</p>',
                'modal-xl');
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },
});


// ── app-prompts.js ──
/**
 * Syrus Sales OS – Libreria prompt per le comunicazioni
 *
 * Pagina di gestione (/prompts). Il richiamo dal compositore email vive in
 * app-email-ai.js: qui si creano, si correggono e si cancellano.
 */
Object.assign(SyrusApp, {

    _promptChannelLabels: {email: 'Email', whatsapp: 'WhatsApp', generico: 'Generico'},
    _promptChannelColors: {
        email:    {bg: '#EBF3FB', fg: '#2E75B6', icon: 'fa-solid fa-envelope'},
        whatsapp: {bg: '#DCFCE7', fg: '#15803D', icon: 'fa-brands fa-whatsapp'},
        generico: {bg: '#EEF2F6', fg: '#475569', icon: 'fa-solid fa-asterisk'},
    },

    promptChannelBadge(ch) {
        const c = this._promptChannelColors[ch] || this._promptChannelColors.email;
        const label = this._promptChannelLabels[ch] || ch || 'Email';
        return `<span class="badge d-inline-flex align-items-center gap-1"
            style="background:${c.bg};color:${c.fg};font-weight:600">
            <i class="${c.icon}"></i>${this._escapeHtml(label)}</span>`;
    },

    initPromptsPage() {
        this._promptChannel = '';
        const s = document.getElementById('prompt-search');
        if (s && !s.dataset.bound) {
            s.dataset.bound = '1';
            s.addEventListener('input', this.debounce(() => this.loadPromptsPage(), 300));
        }
        this.loadPromptsPage();
    },

    setPromptChannel(ch) {
        this._promptChannel = ch;
        document.querySelectorAll('#prompt-view-chips .lead-view-chip')
            .forEach(b => b.classList.toggle('active', (b.dataset.view || '') === ch));
        this.loadPromptsPage();
    },

    async loadPromptsPage() {
        const tbody = document.getElementById('prompts-table');
        if (!tbody) return;
        const params = new URLSearchParams({
            channel: this._promptChannel || '',
            search: (document.getElementById('prompt-search') || {}).value || '',
        });
        try {
            const data = await this.api(`/prompts/api/list?${params}`);
            this._prompts = data.items || [];
            if (!this._prompts.length) {
                tbody.innerHTML = `<tr><td colspan="6" class="text-center text-muted py-4">
                    Nessun prompt. <a href="#" onclick="SyrusApp.showPromptFormModal();return false">Creane uno</a>.</td></tr>`;
            } else {
                tbody.innerHTML = this._prompts.map(p => `
                    <tr data-prompt-id="${p.id}" style="cursor:pointer">
                        <td>
                            <div class="fw-medium">${this._escapeHtml(p.title)}</div>
                            <small class="text-muted">${this._escapeHtml((p.text || '').slice(0, 110))}…</small>
                        </td>
                        <td>${this.promptChannelBadge(p.channel)}</td>
                        <td class="text-center"><span class="badge bg-light text-dark">${p.used_count}×</span></td>
                        <td><small>${this._escapeHtml(p.created_by || '-')}</small></td>
                        <td><small class="text-muted">${p.last_used_at ? this.parseDate(p.last_used_at).toLocaleDateString('it-IT', {day: '2-digit', month: 'short', year: '2-digit'}) : 'mai'}</small></td>
                        <td class="text-end">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-outline-secondary" data-bs-toggle="dropdown" onclick="event.stopPropagation()">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.showPromptFormModal('${p.id}');return false"><i class="fa-solid fa-pen me-2"></i>Modifica</a></li>
                                    <li><a class="dropdown-item" href="#" onclick="SyrusApp.copyPromptText('${p.id}');return false"><i class="fa-regular fa-copy me-2"></i>Copia testo</a></li>
                                    <li><hr class="dropdown-divider"></li>
                                    <li><a class="dropdown-item text-danger" href="#" onclick="SyrusApp.eliminaPrompt('${p.id}');return false"><i class="fa-solid fa-trash me-2"></i>Elimina</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>`).join('');

                if (!tbody.dataset.rowNav) {
                    tbody.dataset.rowNav = '1';
                    tbody.addEventListener('click', (e) => {
                        if (e.target.closest('a, button, .dropdown, .dropdown-menu, [data-bs-toggle]')) return;
                        const row = e.target.closest('tr[data-prompt-id]');
                        if (row) this.showPromptFormModal(row.dataset.promptId);
                    });
                }
            }
            const info = document.getElementById('prompts-info');
            if (info) info.textContent = `${this._prompts.length} prompt`;
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },

    copyPromptText(id) {
        const p = (this._prompts || []).find(x => x.id === id);
        if (!p) return;
        navigator.clipboard.writeText(p.text)
            .then(() => this.toast('Testo copiato'))
            .catch(() => this.toast('Copia non riuscita', 'danger'));
    },

    showPromptFormModal(id) {
        const p = id ? (this._prompts || []).find(x => x.id === id) : null;
        const opt = (v, l) => `<option value="${v}" ${(p && p.channel) === v || (!p && v === 'email') ? 'selected' : ''}>${l}</option>`;
        this._showModal(p ? 'Modifica prompt' : 'Nuovo prompt', `
            <div class="row g-3">
                <div class="col-md-8">
                    <label class="form-label">Titolo *</label>
                    <input type="text" class="form-control" id="pf-title" value="${this._escapeAttr(p ? p.title : '')}" placeholder="Es. Riattivazione con bando CCIAA">
                </div>
                <div class="col-md-4">
                    <label class="form-label">Canale</label>
                    <select class="form-select" id="pf-channel">
                        ${opt('email', 'Email')}${opt('whatsapp', 'WhatsApp')}${opt('generico', 'Generico')}
                    </select>
                </div>
            </div>
            <div class="mt-3">
                <label class="form-label">Istruzione per l'AI *</label>
                <textarea class="form-control" id="pf-text" rows="14" style="font-size:.86rem"
                          placeholder="Descrivi cosa deve scrivere l'AI: obiettivo, tono, fatti da usare, formato dell'oggetto...">${this._escapeHtml(p ? p.text : '')}</textarea>
                <div class="form-text">I fatti che scrivi qui (bandi, importi, scadenze) l'AI li userà così come sono: hanno la precedenza sui dati della lead.</div>
            </div>
            <div class="text-end mt-4">
                <button class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                <button class="btn btn-primary" onclick="SyrusApp.submitPromptForm(${id ? `'${id}'` : 'null'})">
                    ${p ? 'Salva' : 'Crea prompt'}
                </button>
            </div>`, 'modal-xl');
    },

    async submitPromptForm(id) {
        const payload = {
            title: (document.getElementById('pf-title').value || '').trim(),
            text: (document.getElementById('pf-text').value || '').trim(),
            channel: document.getElementById('pf-channel').value,
        };
        if (!payload.title) { this.toast('Il titolo è obbligatorio', 'danger'); return; }
        if (!payload.text) { this.toast("L'istruzione è obbligatoria", 'danger'); return; }
        try {
            if (id) {
                await this.api(`/prompts/api/${id}`, {method: 'PUT', body: JSON.stringify(payload)});
                this.toast('Prompt aggiornato');
            } else {
                const r = await this.api('/prompts/api/create', {method: 'POST', body: JSON.stringify(payload)});
                this.toast(r.duplicato ? 'Questo testo era già in libreria' : 'Prompt creato');
            }
            this._closeAllModals();
            this.loadPromptsPage();
        } catch (e) {
            this.toast(e.message, 'danger');
        }
    },
});


// ── app-spa.js ──
/** Syrus Sales OS – SPA Router & Initialization (must be loaded last) */
Object.assign(SyrusApp, {

    // ── SPA Router (navigate without full page reload) ──────────────────────
    _spaEnabled: true,

    spaNavigate(url, pushState = true) {
        // Il tab Note della lead salva col debounce: se si naviga via prima che
        // scatti, il DOM sparisce con dentro l'ultimo appunto.
        this._flushLeadNotes && this._flushLeadNotes();
        if (!this._spaEnabled) { location.href = url; return; }

        // Skip external URLs, auth pages, API calls, hash links
        if (url.startsWith('http') && !url.startsWith(location.origin)) { location.href = url; return; }
        if (url.includes('/auth/')) { location.href = url; return; }
        if (url.includes('/funnels/builder')) { location.href = url; return; }
        if (url.includes('/api/')) return;
        if (url.startsWith('#')) return;

        const container = document.getElementById('spa-content');
        if (!container) { location.href = url; return; }

        // Show loading state
        container.style.opacity = '0.5';
        container.style.pointerEvents = 'none';

        fetch(url, { headers: { 'X-Requested-With': 'SPA' } })
            .then(resp => {
                if (!resp.ok) throw new Error(resp.status);
                // If redirected to login, do full navigation
                if (resp.redirected && resp.url.includes('/auth/')) {
                    location.href = resp.url;
                    throw new Error('redirect');
                }
                return resp.text();
            })
            .then(html => {
                // Parse the full HTML and extract #spa-content
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newContent = doc.getElementById('spa-content');
                if (!newContent) {
                    // Page doesn't have spa-content (maybe auth page), do full nav
                    location.href = url;
                    return;
                }

                // Replace content
                container.innerHTML = newContent.innerHTML;
                container.style.opacity = '1';
                container.style.pointerEvents = '';

                // Update page title
                const newTitle = doc.querySelector('title');
                if (newTitle) document.title = newTitle.textContent;

                // Update top header page title
                const newPageTitle = doc.querySelector('.page-title');
                const currentPageTitle = document.querySelector('.page-title');
                if (newPageTitle && currentPageTitle) {
                    currentPageTitle.innerHTML = newPageTitle.innerHTML;
                }

                // Update active sidebar link
                document.querySelectorAll('.sidebar .nav-link').forEach(link => {
                    link.classList.remove('active');
                    const href = link.getAttribute('href');
                    if (href && (url === href || (url.startsWith(href) && href !== '/'))) {
                        link.classList.add('active');
                    }
                });
                if (url === '/') {
                    const dashLink = document.querySelector('.sidebar .nav-link[href="/"]');
                    if (dashLink) dashLink.classList.add('active');
                }

                // Update mobile nav
                document.querySelectorAll('.mobile-nav-item').forEach(item => {
                    item.classList.remove('active');
                    const href = item.getAttribute('href');
                    if (href && (url === href || (url.startsWith(href) && href !== '/'))) {
                        item.classList.add('active');
                    }
                });

                // Route-based initialization (reliable, no eval needed)
                this._spaInitPage(url);

                // Push URL to history
                if (pushState) {
                    history.pushState({ spaUrl: url }, '', url);
                }

                // Scroll to top
                window.scrollTo(0, 0);

                // Re-bind SPA links in new content
                this._bindSpaLinks(container);
            })
            .catch(err => {
                if (err.message === 'redirect') return;
                console.warn('SPA nav failed, falling back:', err);
                container.style.opacity = '1';
                container.style.pointerEvents = '';
                location.href = url;
            });
    },

    _spaCleanup() {
        // Clear all polling intervals to prevent memory leaks
        if (this._notifPollTimer) { clearInterval(this._notifPollTimer); this._notifPollTimer = null; }
        if (this._chatPollTimer) { clearInterval(this._chatPollTimer); this._chatPollTimer = null; }
        if (this._dashPollTimer) { clearInterval(this._dashPollTimer); this._dashPollTimer = null; }
        if (this._opsPollingInterval) { clearInterval(this._opsPollingInterval); this._opsPollingInterval = null; }
        // NOTA: _wpTimer (contatore durata chiamata) NON va fermato — il webphone è persistente
        if (this._dgSummaryTimer) { clearInterval(this._dgSummaryTimer); this._dgSummaryTimer = null; }
        if (this._pbxPollTimer) { clearInterval(this._pbxPollTimer); this._pbxPollTimer = null; }
        if (this._chatAppListPollTimer) { clearInterval(this._chatAppListPollTimer); this._chatAppListPollTimer = null; }
        if (this._chatAppMsgPollTimer) { clearInterval(this._chatAppMsgPollTimer); this._chatAppMsgPollTimer = null; }
        document.body.classList.remove('wa-app-page');
    },

    _spaInitPage(url) {
        this._spaCleanup();
        // Map URL patterns to initialization functions
        const path = url.split('?')[0].replace(/\/+$/, '') || '/';

        // Exact matches
        if (path === '' || path === '/') { this.loadDashboard(); return; }
        if (path === '/leads') { this._leadView = 'table'; this.initLeadsPage(); return; }
        if (path === '/leads/new' || path === '/leads/create') return; // form, no init needed
        if (path === '/contacts') { this.loadContacts(); return; }
        if (path === '/communications') { this.loadGlobalComms('all'); return; }
        if (path === '/whatsapp') { if (typeof this.initChatApp === 'function') this.initChatApp(); return; }
        if (path === '/whatsapp/numbers') { this.loadWaNumbers(); return; }
        if (path === '/whatsapp/templates') { this.loadWaTemplatesPage(); return; }
        if (path === '/whatsapp/broadcast') { this.loadBroadcastPage(); return; }
        if (path === '/whatsapp/wa-contacts') { this.loadWaContacts(); return; }
        if (path === '/deepgram') { this.dgLoadList(); return; }
        if (path === '/ai') { this.aiLoadHub(); return; }
        if (path === '/calendar') { this.calInit(); return; }
        if (path === '/funnels') { this.loadFunnels(); return; }
        if (path === '/funnels/builder') { this.initFunnelBuilder(''); return; }
        if (path.match(/^\/funnels\/builder\/[^/]+$/)) {
            const fid = path.split('/')[3];
            this.initFunnelBuilder(fid);
            return;
        }
        if (path === '/quotes') { this.loadQuotes(); return; }
        if (path === '/leads/documents') { this.loadAllDocuments(); return; }
        if (path === '/newsletter') { this.loadNewsletter(); return; }
        if (path === '/reports') { this.loadReport('overview'); return; }
        if (path === '/settings') { this.loadUsers(); this.loadConfig(); this.loadSchedulerStatus(); this.loadAiSettings(); this._initSettingsTabs(); return; }
        if (path === '/notifiche') { this.notifPageInit(); return; }
        if (path === '/campagne') { this.initCampaignsPage(); return; }
        if (path === '/prompts') { this.initPromptsPage(); return; }

        // Pattern matches
        if (path.match(/^\/leads\/[^/]+\/edit$/)) return; // edit form
        if (path.match(/^\/leads\/[^/]+$/)) {
            const leadId = path.split('/')[2];
            this.loadLeadDetail(leadId);
            this.loadLeadCampaigns(leadId);
            return;
        }
        if (path.match(/^\/campagne\/[^/]+$/)) {
            this.loadCampaignDetail(path.split('/')[2]);
            return;
        }
        if (path.match(/^\/whatsapp\/inbox\/[^/]+$/)) {
            const pnid = path.split('/')[3];
            this.loadWaConversations(pnid);
            return;
        }
        if (path.match(/^\/whatsapp\/chat\/[^/]+\/[^/]+$/)) {
            const parts = path.split('/');
            this.initChat(parts[3], parts[4]);
            return;
        }

        console.log('SPA: no init handler for', path);
    },

    _bindSpaLinks(root = document) {
        // Skip if not in SPA mode
        if (!this._spaEnabled) return;

        root.querySelectorAll('a[href]').forEach(link => {
            if (link.dataset.spabound) return;
            link.dataset.spabound = '1';

            const href = link.getAttribute('href');
            if (!href || href === '#' || href.startsWith('javascript:') || href.startsWith('http') ||
                href.includes('/auth/') || href.startsWith('/api/') || link.target === '_blank' ||
                link.hasAttribute('download')) return;

            link.addEventListener('click', (e) => {
                if (e.ctrlKey || e.metaKey || e.shiftKey) return;
                e.preventDefault();
                e.stopPropagation();
                this.spaNavigate(href);
            });
        });
    },

    _initSpaRouter() {
        // Use event delegation on the entire document for maximum reliability
        document.addEventListener('click', (e) => {
            if (!this._spaEnabled) return;
            if (e.ctrlKey || e.metaKey || e.shiftKey) return;

            // Find closest <a> tag
            const link = e.target.closest('a[href]');
            if (link) {
                const href = link.getAttribute('href');
                // '/api/' va cercato ovunque nell'href, non solo in testa: in
                // Sales gli endpoint stanno sotto /leads/api/..., /settings/api/...
                // e intercettarli significa annullare download e export
                if (href && href !== '#' && !href.startsWith('javascript:') &&
                    !href.startsWith('http') && !href.includes('/auth/') &&
                    !href.includes('/api/') && link.target !== '_blank' &&
                    !link.hasAttribute('download')) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.spaNavigate(href);
                    return;
                }
            }

            // Also catch onclick="location.href='...'" buttons
            const btn = e.target.closest('[onclick]');
            if (btn) {
                const onclick = btn.getAttribute('onclick');
                if (onclick) {
                    const match = onclick.match(/location\.href\s*=\s*['"]([^'"]+)['"]/);
                    if (match && match[1] && !match[1].includes('/auth/') && !match[1].startsWith('http')) {
                        e.preventDefault();
                        e.stopPropagation();
                        this.spaNavigate(match[1]);
                    }
                }
            }
        }, true);  // capture phase = fires before any other handler

        // Handle browser back/forward
        window.addEventListener('popstate', (e) => {
            if (e.state && e.state.spaUrl) {
                this.spaNavigate(e.state.spaUrl, false);
            }
        });

        // Set initial state
        history.replaceState({ spaUrl: location.pathname }, '', location.pathname);
    },
});

// ── Initialization ──
document.addEventListener('DOMContentLoaded', () => {
    SyrusApp.initSidebar();
    SyrusApp._initSpaRouter();
    SyrusApp.initNotifications();
    SyrusApp.initSlaBanner();
    SyrusApp.initSlaHeartbeat();

    // Unlock AudioContext on first user interaction (browser autoplay policy)
    SyrusApp._unlockAudioHandler = () => SyrusApp._unlockAudio();
    document.addEventListener('click', SyrusApp._unlockAudioHandler);
    document.addEventListener('keydown', SyrusApp._unlockAudioHandler);
    document.addEventListener('touchstart', SyrusApp._unlockAudioHandler);

    // Webphone: auto-connect so incoming calls always ring
    SyrusApp.initWebphone();

});
